webpackJsonp([4],Array(21).concat([
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isDev = window.location.hostname === 'localhost' || /(^127\.)|(^10\.)|(^172\.1[6-9]\.)|(^172\.2[0-9]\.)|(^172\.3[0-1]\.)|(^192\.168\.)/.test(window.location.hostname);
var isPre = window.location.hostname === 'localhost';
var isTst = window.location.hostname === 'wwwtest.beathey.com';
var isStg = window.location.hostname === 'wwwdev.beathey.com';
var isProd = window.location.hostname === 'wwwprod.beathey.com';

var baseHost = 'https://beathey.com';

var ppClientId = 'Abs7V6JtNPhBdHyXRPDH6aRuESQj4MhTSfi4MwH0mI0Nef5eyP07UtXUTZFXgZa5ztZp0XDu5Tu1oUCE';

if (isDev || isPre) {
  baseHost = 'http://localhost';
  // Credenciales Sandbox para Paypal
  ppClientId = 'AVs9tKtUaY4iP7GSjBXbhWgSo13ewHgjEoy1ziR68bskWevz2B4G9byEwls-hXLfWci0_B3Lk4zHNklL';
} else if (isTst) {
  baseHost = 'https://wwwtest.beathey.com';
  // Credenciales Sandbox para Paypal
  ppClientId = 'AVs9tKtUaY4iP7GSjBXbhWgSo13ewHgjEoy1ziR68bskWevz2B4G9byEwls-hXLfWci0_B3Lk4zHNklL';
} else if (isStg) {
  baseHost = 'https://wwwdev.beathey.com';
} else if (isProd) {
  baseHost = 'https://wwwprod.beathey.com';
}
var apiUrl = baseHost + '/services';

var ppSubscriptionPaymentURL = 'https://www.paypal.com/sdk/js?client-id=' + ppClientId + '&disable-funding=card&vault=true&intent=subscription';
var ppTrackPaymentURL = 'https://www.paypal.com/sdk/js?client-id=' + ppClientId + '&disable-funding=card';

/* harmony default export */ __webpack_exports__["a"] = ({
  API_BASE_URL: apiUrl,
  BASE_HOST: baseHost,
  MEDIA_BASE_URL: baseHost,
  MUSIC_FAN_TYPE: 0,
  PRODUCER_TYPE: 1,
  ACCEPTED_LOCALES: ['es', 'en', 'pt'],
  DEFAULT_LOCALE: 'en',
  PP_SUBSCRIPTION_PAYMENT_URL: ppSubscriptionPaymentURL,
  PP_TRACK_PAYMENT_URL: ppTrackPaymentURL
});

/***/ }),
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_ClipLoader_vue__ = __webpack_require__(350);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7edc50d8_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_ClipLoader_vue__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(764)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_ClipLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7edc50d8_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_ClipLoader_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7edc50d8_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_ClipLoader_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__(1182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__es_js__ = __webpack_require__(1183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__en_js__ = __webpack_require__(1184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pt_js__ = __webpack_require__(1185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__localeHelper_js__ = __webpack_require__(1186);







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);

var messages = {
  es: __WEBPACK_IMPORTED_MODULE_2__es_js__["a" /* default */],
  en: __WEBPACK_IMPORTED_MODULE_3__en_js__["a" /* default */],
  pt: __WEBPACK_IMPORTED_MODULE_4__pt_js__["a" /* default */]
};

var locale = Object(__WEBPACK_IMPORTED_MODULE_5__localeHelper_js__["a" /* default */])();

var i18n = new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
  locale: locale,
  messages: messages
});

/* harmony default export */ __webpack_exports__["a"] = (i18n);

/***/ }),
/* 70 */,
/* 71 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__authGuard__ = __webpack_require__(890);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__authWrapper__ = __webpack_require__(404);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__authWrapper__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__authWrapper__["b"]; });
/* harmony default export */ __webpack_exports__["b"] = ({
  getToken: function getToken() {
    return localStorage.getItem('token');
  },
  setToken: function setToken(token) {
    localStorage.setItem('token', token);
  },
  setMsisdn: function setMsisdn(msisdn) {
    localStorage.setItem('msisdn', msisdn);
  },
  getMsisdn: function getMsisdn() {
    return localStorage.getItem('msisdn');
  },
  setProvider: function setProvider(provider) {
    localStorage.setItem('provider', provider);
  },
  getProvider: function getProvider() {
    return localStorage.getItem('provider');
  },
  removeToken: function removeToken() {
    localStorage.removeItem('token');
  },
  removeProvider: function removeProvider() {
    localStorage.removeItem('provider');
    localStorage.removeItem('providerCountry');
    localStorage.removeItem('provider_msj');
    localStorage.removeItem('provider_n');
    localStorage.removeItem('provider_email');
  },
  removeMsisdn: function removeMsisdn() {
    localStorage.removeItem('msisdn');
  },
  getHeader: function getHeader() {
    return { 'access-token': this.getToken() };
  }
});




/***/ }),
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrackOptionsButton_vue__ = __webpack_require__(353);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bba6a3d_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrackOptionsButton_vue__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(771)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0bba6a3d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrackOptionsButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bba6a3d_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrackOptionsButton_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bba6a3d_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrackOptionsButton_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrackData_vue__ = __webpack_require__(390);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_abfc90c2_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrackData_vue__ = __webpack_require__(869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(868)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-abfc90c2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrackData_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_abfc90c2_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrackData_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_abfc90c2_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrackData_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DirectLinkModal_vue__ = __webpack_require__(405);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_871c311a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DirectLinkModal_vue__ = __webpack_require__(899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(898)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-871c311a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DirectLinkModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_871c311a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DirectLinkModal_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_871c311a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DirectLinkModal_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProviderLink_vue__ = __webpack_require__(406);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3da1bd8b_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProviderLink_vue__ = __webpack_require__(901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(900)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3da1bd8b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProviderLink_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3da1bd8b_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProviderLink_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3da1bd8b_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProviderLink_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeFooter_vue__ = __webpack_require__(438);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e44234c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomeFooter_vue__ = __webpack_require__(975);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(974)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3e44234c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e44234c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomeFooter_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e44234c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomeFooter_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CircleProgress_vue__ = __webpack_require__(429);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b43667a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CircleProgress_vue__ = __webpack_require__(951);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CircleProgress_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b43667a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CircleProgress_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b43667a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CircleProgress_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LandingNavBar_vue__ = __webpack_require__(448);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_780cdb3c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LandingNavBar_vue__ = __webpack_require__(1003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1002)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-780cdb3c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LandingNavBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_780cdb3c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LandingNavBar_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_780cdb3c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LandingNavBar_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIxLjAuMiwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAzNDcgMzQ3IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAzNDcgMzQ3OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+Cgkuc3Qwe2ZpbGw6I0ZGRkZGRjt9Cjwvc3R5bGU+CjxnPgoJPGNpcmNsZSBjbGFzcz0ic3QwIiBjeD0iMTczLjUiIGN5PSIxNzMuNSIgcj0iMTczLjUiLz4KPC9nPgo8cGF0aCBkPSJNMTE1LjcsODguNHYzNS4xaDM1LjFWODguNGgyNmMxOS4zLDAsMzUuMSwxNS43LDM1LjEsMzUuMWMwLDEzLjktOC4xLDI1LjktMTkuOSwzMS42Yy00LjYsMi4zLTkuNywzLjUtMTUuMSwzLjV2MjkuOQoJYzUuNCwwLDEwLjYsMS4zLDE1LjEsMy41YzExLjgsNS43LDE5LjksMTcuNywxOS45LDMxLjZjMCwxOS4zLTE1LjcsMzUuMS0zNS4xLDM1LjFoLTYwLjl2MzUuMWg2MC45YzM4LjcsMCw3MC4xLTMxLjMsNzAuMS03MC4xCgljMC0xOS42LTgtMzcuMi0yMS01MGMxMi45LTEyLjcsMjEtMzAuNSwyMS01MGMwLTM4LjctMzEuNC03MC4xLTcwLjEtNzAuMWgtNjAuOUwxMTUuNyw4OC40TDExNS43LDg4LjR6Ii8+Cjwvc3ZnPgo="

/***/ }),
/* 171 */,
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_PulseLoader_vue__ = __webpack_require__(385);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7dc0198c_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_PulseLoader_vue__ = __webpack_require__(863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(862)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_PulseLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7dc0198c_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_PulseLoader_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7dc0198c_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_PulseLoader_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrackImage_vue__ = __webpack_require__(391);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8cb494d4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrackImage_vue__ = __webpack_require__(871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(870)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8cb494d4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrackImage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8cb494d4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrackImage_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8cb494d4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrackImage_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UploadImage_vue__ = __webpack_require__(403);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ccdd13b6_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UploadImage_vue__ = __webpack_require__(896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(889)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UploadImage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ccdd13b6_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UploadImage_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ccdd13b6_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UploadImage_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditorCK_vue__ = __webpack_require__(417);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b5a7e4c_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditorCK_vue__ = __webpack_require__(926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(924)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditorCK_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b5a7e4c_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditorCK_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b5a7e4c_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditorCK_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserInfo_vue__ = __webpack_require__(348);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3eee72f3_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserInfo_vue__ = __webpack_require__(763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(762)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3eee72f3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3eee72f3_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserInfo_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3eee72f3_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserInfo_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrackInfo_vue__ = __webpack_require__(352);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a7e3941_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrackInfo_vue__ = __webpack_require__(776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(770)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5a7e3941"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrackInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a7e3941_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrackInfo_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a7e3941_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrackInfo_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentModal_vue__ = __webpack_require__(366);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c565466_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentModal_vue__ = __webpack_require__(842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(825)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5c565466"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c565466_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentModal_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c565466_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentModal_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 234 */,
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TracksList_vue__ = __webpack_require__(459);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_436ba532_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TracksList_vue__ = __webpack_require__(1038);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1035)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-436ba532"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TracksList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_436ba532_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TracksList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_436ba532_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TracksList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrackEdit_vue__ = __webpack_require__(464);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d623022_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrackEdit_vue__ = __webpack_require__(1046);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1045)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7d623022"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrackEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d623022_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrackEdit_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d623022_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrackEdit_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalPlaylistCard_vue__ = __webpack_require__(546);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78ea0d21_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalPlaylistCard_vue__ = __webpack_require__(1121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1120)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-78ea0d21"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalPlaylistCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78ea0d21_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalPlaylistCard_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78ea0d21_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalPlaylistCard_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArtistCard_vue__ = __webpack_require__(548);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f4cd185_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArtistCard_vue__ = __webpack_require__(1127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1126)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2f4cd185"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArtistCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f4cd185_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArtistCard_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f4cd185_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArtistCard_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(335);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45620236_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(733)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45620236_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45620236_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),
/* 336 */,
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__consts__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Navigation_vue__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_player_Player_vue__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_modals_login_LoginModal_vue__ = __webpack_require__(782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_modals_signup_SignupModal_vue__ = __webpack_require__(813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_modals_subscription_SubscriptionModal_vue__ = __webpack_require__(816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_modals_PaymentModal_vue__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modals_ShareModal_vue__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_modals_tracks_BuyTrackModal_vue__ = __webpack_require__(850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_modals_tracks_CreditsModal_vue__ = __webpack_require__(857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_artistProfile_ArtistProfile_vue__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_modals_playlist_AddToPlaylist_vue__ = __webpack_require__(881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_modals_playlist_NewPlaylist_vue__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_modals_provider_DirectLinkModal_vue__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_providerLink_ProviderLink_vue__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_modals_newFeaturesNotice_NewFeaturesModal_vue__ = __webpack_require__(902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__modals_LocalRadioModal_vue__ = __webpack_require__(905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_PlaylistProfile_PlaylistProfile_vue__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_modals_SetEmailModal_vue__ = __webpack_require__(912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_modals_SetUserTypeModal_vue__ = __webpack_require__(915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_modals_SetNameArtistModal_vue__ = __webpack_require__(918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_modals_login_LoginUnauthorizedUser_vue__ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_textEditor_EditorCK_vue__ = __webpack_require__(175);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


























/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app-wrapper',
  components: {
    Navigation: __WEBPACK_IMPORTED_MODULE_3__components_Navigation_vue__["a" /* default */],
    Player: __WEBPACK_IMPORTED_MODULE_4__components_player_Player_vue__["a" /* default */],
    LoginModal: __WEBPACK_IMPORTED_MODULE_5__components_modals_login_LoginModal_vue__["a" /* default */],
    SignupModal: __WEBPACK_IMPORTED_MODULE_6__components_modals_signup_SignupModal_vue__["a" /* default */],
    SubscriptionModal: __WEBPACK_IMPORTED_MODULE_7__components_modals_subscription_SubscriptionModal_vue__["a" /* default */],
    PaymentModal: __WEBPACK_IMPORTED_MODULE_8__components_modals_PaymentModal_vue__["a" /* default */],
    BuyTrackModal: __WEBPACK_IMPORTED_MODULE_10__components_modals_tracks_BuyTrackModal_vue__["a" /* default */],
    ShareModal: __WEBPACK_IMPORTED_MODULE_9__components_modals_ShareModal_vue__["a" /* default */],
    ArtistProfile: __WEBPACK_IMPORTED_MODULE_12__components_artistProfile_ArtistProfile_vue__["a" /* default */],
    AddToPlaylist: __WEBPACK_IMPORTED_MODULE_13__components_modals_playlist_AddToPlaylist_vue__["a" /* default */],
    NewPlaylist: __WEBPACK_IMPORTED_MODULE_14__components_modals_playlist_NewPlaylist_vue__["a" /* default */],
    ProviderLink: __WEBPACK_IMPORTED_MODULE_16__components_providerLink_ProviderLink_vue__["a" /* default */],
    DirectLinkModal: __WEBPACK_IMPORTED_MODULE_15__components_modals_provider_DirectLinkModal_vue__["a" /* default */],
    NewFeaturesModal: __WEBPACK_IMPORTED_MODULE_18__components_modals_newFeaturesNotice_NewFeaturesModal_vue__["a" /* default */],
    LocalRadioModal: __WEBPACK_IMPORTED_MODULE_19__modals_LocalRadioModal_vue__["a" /* default */],
    PlaylistProfile: __WEBPACK_IMPORTED_MODULE_20__components_PlaylistProfile_PlaylistProfile_vue__["a" /* default */],
    SetEmailModal: __WEBPACK_IMPORTED_MODULE_21__components_modals_SetEmailModal_vue__["a" /* default */],
    SetUserTypeModal: __WEBPACK_IMPORTED_MODULE_22__components_modals_SetUserTypeModal_vue__["a" /* default */],
    SetNameArtistModal: __WEBPACK_IMPORTED_MODULE_23__components_modals_SetNameArtistModal_vue__["a" /* default */],
    LoginUnauthorizedUser: __WEBPACK_IMPORTED_MODULE_24__components_modals_login_LoginUnauthorizedUser_vue__["a" /* default */],
    CreditsModal: __WEBPACK_IMPORTED_MODULE_11__components_modals_tracks_CreditsModal_vue__["a" /* default */],
    EditorCK: __WEBPACK_IMPORTED_MODULE_25__components_textEditor_EditorCK_vue__["a" /* default */]
  },
  data: function data() {
    return {
      checkedSeen: null,
      mk: false,
      fPixel: null,
      providerData: {
        provider: null,
        providerCountry: null
      }
    };
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    var _this = this;

    var matched = false;
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(to.matched), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var matchedRoute = _step.value;

        if (matchedRoute.name === 'artist') {
          next(false);
          this.getArtist(to.params.id).catch(function (e) {
            _this.$toasted.show(_this.error.message, { type: 'error' });
          });
          this.getArtistTracks(to.params.id).catch(function (e) {
            _this.$toasted.show(_this.error.message, { type: 'error' });
          });
          this.getArtistPlaylists(to.params.id).catch(function (e) {
            _this.$toasted.show(_this.error.message, { type: 'error' });
          });
          this.openProfile();
          history.pushState({}, null, to.path);
          matched = true;
        }

        if (matchedRoute.name === 'playlist') {
          next(false);
          this.getPlaylist(to.params.id).catch(function (e) {
            _this.$toasted.show(_this.error.message, { type: 'error' });
          });
          this.openPlaylist();
          history.pushState({}, null, to.path);
          matched = true;
        }
      }
      // close sidebar if route change
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    if (!matched) {
      this.closeProfile();
      this.closePlaylist();
      next();
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    // Open sidebar if artist route is requested
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(to.matched), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var matchedRoute = _step2.value;

        if (matchedRoute.name === 'artist') {
          next(function (vm) {
            vm.$store.dispatch('artist/getArtist', to.params.id).catch(function (e) {
              vm.$toasted.show(vm.getters['artist/error'].message, { type: 'error' });
            });
            vm.$store.dispatch('artist/getArtistTracks', to.params.id).catch(function (e) {
              vm.$toasted.show(vm.getters['artist/error'].message, { type: 'error' });
            });
            vm.$store.dispatch('artist/getArtistPlaylists', to.params.id).catch(function (e) {
              vm.$toasted.show(vm.getters['artist/error'].message, { type: 'error' });
            });
            if (vm.$store.getters['user/isLoggedIn']) {
              vm.$store.dispatch('user/getMyVotes').catch(function (e) {
                vm.$toasted.show(vm.getters['user/error'].message, { type: 'error' });
              });
            }
            vm.$store.dispatch('artist/openProfile');
          });
        }
        if (matchedRoute.name === 'playlist') {
          next(function (vm) {
            vm.$store.dispatch('playlist/getPlaylist', to.params.id).then(function (data) {
              var playlist = data.tracks;
              if (playlist) {
                vm.$store.dispatch('player/setPlaylist', playlist);
                vm.$store.dispatch('player/playFirstTrack');
              }
            }).catch(function (e) {
              vm.$toasted.show(vm.getters['playlist/error'].message, { type: 'error' });
            });
            vm.$store.dispatch('playlist/openPlaylist');
          });
        }
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }

    if (typeof to.query.login !== 'undefined') {
      next(function (vm) {
        vm.$modal.show('login-modal');
      });
    } else if (typeof to.query.signup !== 'undefined') {
      next(function (vm) {
        vm.$modal.show('signup-modal');
      });
    } else if (typeof to.query.subscription !== 'undefined') {
      next(function (vm) {
        vm.$modal.show('subscription-modal');
      });
    } else if (typeof to.query.referredCode !== 'undefined') {
      next(function (vm) {
        vm.$modal.show('subscription-modal');
      });
    } else if (typeof to.query.track_id !== 'undefined') {
      next(function (vm) {
        vm.$http.get(__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].API_BASE_URL + ('/tracks/get/' + to.query.track_id)).then(function (res) {
          var track = res.body.data[0];
          if (track.length) {
            vm.$store.dispatch('player/setPlaylist', track);
            vm.$store.dispatch('player/playFirstTrack');
          }
        });
      });
    } else if (typeof to.query.playlist_id !== 'undefined') {
      next(function (vm) {
        vm.$http.get(__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].API_BASE_URL + ('/playlists/getPlaylist/' + to.query.playlist_id)).then(function (res) {
          var playlist = res.body.data.tracks;
          if (playlist) {
            vm.$store.dispatch('player/setPlaylist', playlist);
            vm.$store.dispatch('player/playFirstTrack');
          }
        });
      });
    } else {
      next();
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_17_vuex__["b" /* mapActions */])('user', ['checkUser', 'loginByMsisdn', 'loginAuth', 'getMyFollowedArtists', 'setSubsReferredCodeAction', 'checkMyActiveUserReferredPlan']), Object(__WEBPACK_IMPORTED_MODULE_17_vuex__["b" /* mapActions */])('artist', ['getArtist', 'getArtistTracks', 'getArtistPlaylists', 'openProfile', 'closeProfile']), Object(__WEBPACK_IMPORTED_MODULE_17_vuex__["b" /* mapActions */])('news', ['getNewsFeatures']), Object(__WEBPACK_IMPORTED_MODULE_17_vuex__["b" /* mapActions */])('playlist', ['getPlaylist', 'openPlaylist', 'closePlaylist']), Object(__WEBPACK_IMPORTED_MODULE_17_vuex__["b" /* mapActions */])('player', ['setPlaylist', 'setPlaying', 'changeTrack']), Object(__WEBPACK_IMPORTED_MODULE_17_vuex__["b" /* mapActions */])('pricing', ['getPricing']), Object(__WEBPACK_IMPORTED_MODULE_17_vuex__["b" /* mapActions */])('home', ['getProviders']), {
    onpopstate: function onpopstate(event) {
      // when the state is stored by `beforeRouteUpdate` event, the key is null
      if (this.isProfileOpen && event.state.key !== undefined) {
        this.closeProfile();
      }
    },
    checkUserLoguedIn: function checkUserLoguedIn() {
      var provider = localStorage.getItem('provider');
      if (!this.isLoggedIn && !provider) {
        this.$router.push({ path: '/' });
      }
    },
    playTrack: function playTrack(track) {
      if (this.currentTrack !== track) {
        this.$emit('play');
        this.changeTrack(track);
      } else {
        this.setPlaying(true);
      }
    },
    setPlayer: function setPlayer(track, playlist) {
      this.setPlaylist(playlist);
      this.playTrack(track);
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_17_vuex__["c" /* mapGetters */])('artist', ['isProfileOpen', 'error']), Object(__WEBPACK_IMPORTED_MODULE_17_vuex__["c" /* mapGetters */])('user', ['isLoggedIn', 'authToken', 'msisdn', 'provider', 'user', 'subsReferredCode']), Object(__WEBPACK_IMPORTED_MODULE_17_vuex__["c" /* mapGetters */])('news', ['news']), Object(__WEBPACK_IMPORTED_MODULE_17_vuex__["c" /* mapGetters */])('playlist', ['isPlaylistOpen']), Object(__WEBPACK_IMPORTED_MODULE_17_vuex__["c" /* mapGetters */])('translator', ['language']), Object(__WEBPACK_IMPORTED_MODULE_17_vuex__["c" /* mapGetters */])('player', ['isShareTrack', 'currentTrack'])),
  watch: {
    subsReferredCode: function subsReferredCode(newSubsReferredCode, oldSubsReferredCode) {
      if (this.subsReferredCode && !this.user.subscription.active) {
        this.$modal.show('subscription-modal');
      }
    }
  },
  created: function created() {
    var _this2 = this;

    this.checkUser().then(function () {
      var data = { 'user': _this2.user.id, 'language': _this2.language };
      var that = _this2;
      if (parseInt(that.user.user_type) === 3) {
        _this2.$modal.show('set-user-type-modal');
      } else {
        _this2.getNewsFeatures(data).then(function () {
          if (that.news.length !== 0) {
            that.$modal.show('new-features-modal');
          }
        });
        _this2.mk = localStorage.getItem('userFromLandingMK');
        if (_this2.$route.query.referredCode) {
          _this2.setSubsReferredCodeAction(_this2.$route.query.referredCode);
          localStorage.removeItem('referredCode');
        }
      }
    });
    this.getPricing();
    window.onpopstate = this.onpopstate;
    this.fPixel = this.$route.query.payment;
  },
  mounted: function mounted() {
    this.providerData.provider = localStorage.getItem('provider');
    this.providerData.providerCountry = localStorage.getItem('providerCountry');
    this.getProviders(this.providerData);
    if (this.fPixel) {
      window.fbq('track', 'CompleteRegistration');
    }
    if (this.mk === true) {
      localStorage.removeItem('userFromLandingMK');
      console.log('aquí se debe ejecutar el pixel que confirma el éxito de la operación de marketing');
    }
    this.getMyFollowedArtists({ getIds: true });
    this.checkMyActiveUserReferredPlan();
    if (!this.isShareTrack) setTimeout(this.checkUserLoguedIn, 15000);
  }
});

/***/ }),
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_UserInfo_vue__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_on_click_outside__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_on_click_outside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_on_click_outside__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fortawesome_vue_fontawesome__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__fortawesome_vue_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_spinner_src_ClipLoader_vue__ = __webpack_require__(25);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'navigation',
  components: {
    UserInfo: __WEBPACK_IMPORTED_MODULE_2__components_UserInfo_vue__["a" /* default */],
    FontAwesomeIcon: __WEBPACK_IMPORTED_MODULE_4__fortawesome_vue_fontawesome___default.a,
    ClipLoader: __WEBPACK_IMPORTED_MODULE_5_vue_spinner_src_ClipLoader_vue__["a" /* default */]
  },
  data: function data() {
    return {
      loginDropdown: false,
      dropdown: false,
      color: '#808080',
      size: '20px',
      provider: null,
      antelPublicUser: false,
      bitelFreeMusic: false
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_3_vue_on_click_outside__["mixin"]],
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('translator', ['setLanguage']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('user', ['logout']), {
    isLocale: function isLocale(lang) {
      return this.language === lang;
    },
    login: function login() {
      // this.loginDropdownTrigger()
      this.$auth0.loginWithRedirect();
    },
    signup: function signup() {
      this.$modal.show('signup-modal');
    },
    dropdownTrigger: function dropdownTrigger() {
      this.dropdown = !this.dropdown;
    },
    closeDropdown: function closeDropdown() {
      this.dropdown = false;
    },
    loginDropdownTrigger: function loginDropdownTrigger() {
      this.loginDropdown = !this.loginDropdown;
    },
    closeLoginDropdown: function closeLoginDropdown() {
      this.loginDropdown = false;
    },
    goToHome: function goToHome() {
      this.$router.push({ path: '/' });
    },
    goToMainPage: function goToMainPage() {
      this.$router.push({ path: '/home' });
    },
    logoutButton: function logoutButton() {
      var _this = this;

      this.logout().then(function () {
        _this.$auth0.logout();
      });
    },
    checkUser: function checkUser(route) {
      if (!this.isLoggedIn) {
        this.$modal.show('login-modal');
        // } else if (!this.isProducer) {
        //  this.$toasted.show(this.$t('tracks.newTrack.notProducer'), {type: 'error'})
      } else if (!this.isSubscribed) {
        this.$modal.show('subscription-modal');
      } else {
        this.$router.push(route);
      }
    }
  }),
  mounted: function mounted() {
    this.provider = localStorage.getItem('provider');
    var msisdn = localStorage.getItem('msisdn');
    if (msisdn && msisdn === 'PublicUser') {
      this.antelPublicUser = true;
    } else {
      this.antelPublicUser = false;
    }
    if (msisdn && msisdn === 'freeMusic') {
      this.bitelFreeMusic = true;
    } else {
      this.bitelFreeMusic = false;
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('user', ['isLoggedIn', 'isSubscribed', 'isProducer', 'user']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('translator', ['language']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('user', ['loginAuth']), {
    loading: function loading() {
      return this.$loading.isLoading('user login') || this.$loading.isLoading('user checkUser');
    }
  })
});

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__consts__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(11);

//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'user-info',
  components: {
    FontAwesomeIcon: __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('user', ['isLoggedIn', 'isSubscribed', 'isProducer', 'user']), {
    picture: function picture() {
      if (this.user.picture) {
        return __WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].MEDIA_BASE_URL + this.user.picture;
      } else {
        return '/static/assets/Img_Avatar_generico_Beathey.jpg';
      }
    }
  })
});

/***/ }),
/* 349 */,
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'ClipLoader',

  props: {
    loading: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: '#5dc596'
    },
    size: {
      type: String,
      default: '35px'
    },
    radius: {
      type: String,
      default: '100%'
    }
  },
  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size,
        width: this.size,
        borderWidth: '2px',
        borderStyle: 'solid',
        borderColor: this.color + ' ' + this.color + ' transparent',
        borderRadius: this.radius,
        background: 'transparent'
      };
    }
  }
});

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fortawesome_vue_fontawesome__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__fortawesome_vue_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_howler_dist_howler_js__ = __webpack_require__(769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_howler_dist_howler_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_howler_dist_howler_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_tracks_TrackInfo__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PlayerControls__ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__consts__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_on_click_outside__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_on_click_outside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_on_click_outside__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuedraggable__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_spinner_src_ClipLoader_vue__ = __webpack_require__(25);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'player',
  components: {
    FontAwesomeIcon: __WEBPACK_IMPORTED_MODULE_1__fortawesome_vue_fontawesome___default.a,
    TrackInfo: __WEBPACK_IMPORTED_MODULE_3__components_tracks_TrackInfo__["a" /* default */],
    draggable: __WEBPACK_IMPORTED_MODULE_8_vuedraggable___default.a,
    PlayerControls: __WEBPACK_IMPORTED_MODULE_4__PlayerControls__["a" /* default */],
    ClipLoader: __WEBPACK_IMPORTED_MODULE_9_vue_spinner_src_ClipLoader_vue__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_6_vue_on_click_outside__["mixin"]],
  data: function data() {
    return {
      howler: null,
      isCurrentAudioTrackSet: false,
      isPlaylistOpen: false,
      currentProgress: 0,
      color: '#808080',
      size: '20px',
      mytimerCounter: undefined,
      lastReportedTrack: null,
      trackIdShared: null,
      minimumTrackDuration: 0
    };
  },
  created: function created() {
    var _this = this;

    this.checkUserLogged().then(function () {
      if (_this.isShareTrack) {
        _this.trackIdShared = null;
        localStorage.removeItem('shareTrackId');
        _this.setIsShareTrack(false);
      }
    }).catch(function () {
      if (_this.isShareTrack) {
        var trackId = localStorage.getItem('shareTrackId');
        _this.trackIdShared = trackId;
      }
    });

    this.getMinTrackDuration().then(function (res) {
      _this.minimumTrackDuration = _this.minTrackDuration;
    });

    this.getPromotion().then(function () {
      if (_this.playlist.length === 0) {
        _this.setPlaylist(_this.promotion);
        _this.playFirstTrack();
      }
    });
    if ('mediaSession' in navigator) {
      navigator.mediaSession.setActionHandler('play', this.play.bind(this));
      navigator.mediaSession.setActionHandler('pause', this.pause.bind(this));
      navigator.mediaSession.setActionHandler('previoustrack', this.next.bind(this));
      navigator.mediaSession.setActionHandler('nexttrack', this.previous.bind(this));
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    document.addEventListener('keydown', function (event) {
      var inputs = ['input', 'textarea'];
      var activeElement = document.activeElement;
      if (!(activeElement && inputs.indexOf(activeElement.tagName.toLowerCase()) !== -1)) {
        if (event.which === 32) {
          _this2.setPlaying(!_this2.isPlaying);
          event.preventDefault();
        }
      }
    });
    /*
    const el = this
    const evt = function (event) {
      if (!el.isPlaying) {
        el.setPlaying(!el.isPlaying)
      }
      document.removeEventListener('click', evt, false)
    }
    document.addEventListener('click', evt, false)
    */
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])('player', ['setPlaying', 'setPlaylist', 'playNext', 'playPrevious', 'changeTrack', 'playFirstTrack', 'changeTrack', 'addAdsToCurrentPlaylist', 'removeAdsFromCurrentPlaylist', 'setIsShareTrack', 'getMinTrackDuration']), Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])('track', ['getPromotion', 'storeReproduction']), Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])('user', ['checkUserLogged']), {
    // Plays the received track
    playTrack: function playTrack(track) {
      var _this3 = this;

      if (this.howler) {
        this.howler.unload();
      }
      this.timerCounter();
      var el = this;
      var vol = this.howler ? this.howler.volume() : 1;
      if (!/\/uploads\/tracks\//.test(track.file)) {
        track.file = '/uploads/tracks/' + track.file;
      }
      this.howler = new __WEBPACK_IMPORTED_MODULE_2_howler_dist_howler_js___default.a.Howl({
        src: [__WEBPACK_IMPORTED_MODULE_5__consts__["a" /* default */].MEDIA_BASE_URL + track.file],
        html5: true,
        autoplay: true,
        volume: vol,
        onplayerror: function onplayerror() {
          el.setPlaying(false);
        },
        onend: function onend() {
          _this3.lastReportedTrack = undefined;
          if (_this3.currentTrack.isAd && _this3.isPlayingPrevious) {
            _this3.changeplayPrevious();
          } else {
            _this3.changeplayNext();
          }
        },
        onpause: function onpause() {
          _this3.stoptimerCounter();
        },
        onplay: function onplay() {
          _this3.timerCounter();
        }
      });
      /* para tener en cuenta cuando sea ncesario mostrar el progress de la carga
      const handleLoad = () => {
        const node = audio._sounds[0]._node;
        // const node:HTMLAudioElement = (audio as any)._sounds[0]._node; // For Typescript
        node.addEventListener('progress', () => {
          const duration = audio.duration();
           // https://developer.mozilla.org/en-US/Apps/Fundamentals/Audio_and_video_delivery/buffering_seeking_time_ranges#Creating_our_own_Buffering_Feedback
          if (duration > 0) {
            for (let i = 0; i < node.buffered.length; i++) {
              if (node.buffered.start(node.buffered.length - 1 - i) < node.currentTime) {
                const bufferProgress = (node.buffered.end(node.buffered.length - 1 - i) / duration) * 100;
                // do what you will with it. I.E - store.set({ bufferProgress });
                break;
              }
            }
          }
        }
      };
      audio.on('load', handleLoad); */

      this.updateNotificationBar(track);
      this.isCurrentAudioTrackSet = true;
      this.$_setProgress();
      clearInterval(this._currentInterval);
      this._currentInterval = setInterval(function () {
        _this3.$_setProgress(_this3.howler.seek() * 100 / _this3.howler.duration());
      }, 250);
    },
    $_setProgress: function $_setProgress() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.currentProgress = index;
      this.$refs.currentProgress.style.width = index + '%';
    },
    playlistTrigger: function playlistTrigger() {
      this.isPlaylistOpen = !this.isPlaylistOpen;
    },
    closePlaylist: function closePlaylist() {
      this.isPlaylistOpen = false;
    },
    updateNotificationBar: function updateNotificationBar(track) {
      if (!/\/uploads\/tracks\//.test(track.picture)) {
        track.picture = '/uploads/tracks/' + track.picture;
      }
      if (track.picture === '/uploads/tracks/undefined') {
        track.picture = '/static/assets/track4.jpg';
      }
      if ('mediaSession' in navigator) {
        // eslint-disable-next-line
        navigator.mediaSession.metadata = new MediaMetadata({
          title: track.title,
          artist: track.name,
          artwork: [{ src: __WEBPACK_IMPORTED_MODULE_5__consts__["a" /* default */].MEDIA_BASE_URL + track.picture, type: 'image/jpeg' }]
        });
      }
    },
    onProgressClick: function onProgressClick(event) {
      var playerWidth = this.$el.offsetWidth;
      var totalSeconds = this.howler.duration();
      var clickPosition = event.clientX;

      if (!this.currentTrack.isAd && this.howler.state('loaded')) {
        this.howler.seek(totalSeconds / playerWidth * clickPosition);
        this.$_setProgress(clickPosition * 100 / playerWidth);
      }
    },
    volumeHandler: function volumeHandler(volume) {
      if (this.howler) {
        this.howler.volume(volume);
      }
    },
    muteHandler: function muteHandler(value) {
      if (this.howler) {
        this.howler.mute(value);
      }
    },
    timerCounter: function timerCounter() {
      var _this4 = this;

      this.stoptimerCounter(); // just in case there's any chance of calling timerCounter() twice in a row...
      this.setPlaying(true);
      var reproductionTimer = 0;
      if (this.lastReportedTrack !== this.currentTrack && this.currentTrack.seconds > this.minimumTrackDuration) {
        var markedTrack = this.currentTrack.seconds * Math.random();
        this.mytimerCounter = setInterval(function () {
          if (!_this4.currentTrack.isAd) {
            if (reproductionTimer > markedTrack) {
              _this4.storeReproduction(_this4.currentTrack);
              _this4.lastReportedTrack = _this4.currentTrack;
              clearInterval(_this4.mytimerCounter);
            } else {
              reproductionTimer++;
            }
          }
        }, 1000);
      }
    },
    stoptimerCounter: function stoptimerCounter() {
      this.setPlaying(false);
      clearInterval(this.mytimerCounter); // will be a harmless no-op if mytimerCounter is false
      this.mytimerCounter = undefined; // not strictly necessary, but just to be tidy
    },
    changeplayPrevious: function changeplayPrevious() {
      this.timerCounter();
      this.playPrevious();
    },
    changeplayNext: function changeplayNext() {
      this.timerCounter();
      this.playNext();
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])('player', ['isPlaying', 'currentTrack', 'canPrevious', 'canNext', 'playlist', 'currentIndex', 'isPlayingPrevious', 'isShareTrack', 'minTrackDuration']), Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])('track', ['promotion', 'ads']), Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])('user', ['isSubscribed']), {
    currentSeconds: function currentSeconds() {
      return Math.floor(this.currentProgress * this.currentTrack.seconds / 100);
    },
    playlist: {
      get: function get() {
        return this.$store.state.player.playlist;
      },
      set: function set(value) {
        this.$store.commit('player/setPlaylist', value);
      }
    },
    options: function options() {
      return {
        handle: '.drag-icon',
        disabled: !this.isSubscribed
      };
    }
  }),
  watch: {
    currentTrack: function currentTrack(newCurrentTrack) {
      if (this.trackIdShared !== null && this.trackIdShared !== newCurrentTrack.id) {
        this.setPlaying(false);
        this.$modal.show('login-unauthorized-user');
      } else {
        this.playTrack(newCurrentTrack);
      }
    },
    isPlaying: function isPlaying(newValue) {
      if (this.howler) {
        if (newValue) {
          this.howler.play();
        } else {
          this.howler.pause();
        }
      }
    },
    isSubscribed: function isSubscribed() {
      if (this.isSubscribed) {
        this.removeAdsFromCurrentPlaylist();
      } else {
        this.addAdsToCurrentPlaylist();
      }
    }
  }
});

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__consts__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_tracks_TrackOptionsButton_vue__ = __webpack_require__(102);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'track-info',
  props: {
    track: {
      required: true
    },
    inPlayer: {
      defaut: false
    },
    inModal: {
      defaut: false
    },
    inPlayerPlaylist: {
      defaut: false
    }
  },
  components: {
    TrackOptionsButton: __WEBPACK_IMPORTED_MODULE_3__components_tracks_TrackOptionsButton_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('player', ['currentTrack', 'isPlaying']), {
    picture: function picture() {
      var trackPicture = '';
      if (!/\/uploads\/tracks\//.test(this.track.picture)) {
        trackPicture = '/uploads/tracks/' + this.track.picture;
      } else {
        trackPicture = this.track.picture;
      }
      if (trackPicture === '/uploads/tracks//static/assets/track4.jpg') {
        return __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].MEDIA_BASE_URL + '/static/assets/track4.jpg';
      }
      return __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].MEDIA_BASE_URL + trackPicture;
    }
  })
});

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fortawesome_vue_fontawesome__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__fortawesome_vue_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TrackOptions_vue__ = __webpack_require__(772);
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'track-options-button',
  props: {
    track: {
      require: true
    },
    inPlayer: {
      default: false
    },
    playlist: {
      default: null
    },
    inHome: {
      default: false
    },
    inMyLikes: {
      default: false
    }
  },
  data: function data() {
    return {
      showOptions: false
    };
  },

  components: {
    FontAwesomeIcon: __WEBPACK_IMPORTED_MODULE_0__fortawesome_vue_fontawesome___default.a,
    TrackOptions: __WEBPACK_IMPORTED_MODULE_1__TrackOptions_vue__["a" /* default */]
  },
  methods: {
    showOptionsTrigger: function showOptionsTrigger() {
      this.showOptions = !this.showOptions;
    },
    closeDropdown: function closeDropdown() {
      this.showOptions = false;
    }
  }
});

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_on_click_outside__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_on_click_outside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_on_click_outside__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__consts__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(44);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







__WEBPACK_IMPORTED_MODULE_5_vue__["default"].component('multiline-text', {
  props: ['text'],
  template: '\n      <div>\n        <p v-for="line in text.split(\'\n\')">{{ line }}</p>\n      </div>\n    '
});

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'track-options',
  props: {
    track: {
      require: true
    },
    inPlayer: {
      default: false
    },
    showOptions: {
      default: false
    },
    playlist: {
      default: null
    },
    inMyLikes: {
      default: false
    }
  },
  data: function data() {
    return {
      host: __WEBPACK_IMPORTED_MODULE_4__consts__["a" /* default */].BASE_HOST,
      transitionVisible: false,
      antelPublicUser: false,
      isLiked: false,
      canRemoveTracks: false,
      bitelFreeMusic: false
    };
  },

  components: {
    FontAwesomeIcon: __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_3_vue_on_click_outside__["mixin"]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('player', ['currentTrack']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('user', ['myTracks', 'isSubscribed', 'isLoggedIn', 'user']), {
    isMyTrack: function isMyTrack() {
      return this.myTracks.includes(this.track);
    },
    picture: function picture() {
      return __WEBPACK_IMPORTED_MODULE_4__consts__["a" /* default */].API_BASE_URL + this.track.path + this.track.picture;
    }
  }),
  mounted: function mounted() {
    if (this.playlist) {
      if (this.playlist.user.id === this.user.id) {
        this.canRemoveTracks = true;
      }
    }
    if (this.inPlayer) {
      this.isLiked = this.currentTrack.is_liked;
    } else if (this.$route.name === 'my-favorites') {
      this.isLiked = true;
    } else {
      if (this.track.is_liked || this.track.like) {
        this.isLiked = true;
      }
    }
    var msisdn = localStorage.getItem('msisdn');
    if (msisdn && msisdn === 'PublicUser') {
      this.antelPublicUser = true;
    } else {
      this.antelPublicUser = false;
    }
    if (msisdn && msisdn === 'freeMusic') {
      this.bitelFreeMusic = true;
    } else {
      this.bitelFreeMusic = false;
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('player', ['setPlaying', 'setCurrentIndexOfPlaylist', 'addToQueue', 'setCurrentTrackLike']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('track', ['setLike', 'delete']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('playlist', ['deleteTrackFromPlaylist', 'getPlaylist']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('user', ['getMyFavorites']), {
    addTrackToQueue: function addTrackToQueue() {
      this.addToQueue(this.track);
      this.closeDropdown();
    },
    checkUserState: function checkUserState() {
      if (!this.isLoggedIn) {
        this.$modal.show('login-modal');
        return false;
      } else if (!this.isSubscribed) {
        this.$modal.show('subscription-modal');
        return false;
      } else {
        return true;
      }
    },
    buyTrack: function buyTrack() {
      this.$modal.show('buy-track-modal', { track: this.track });
      this.closeDropdown();
    },
    shareTrack: function shareTrack() {
      this.$modal.show('share-modal', {
        link: this.host + '/services/share/track/' + this.track.id,
        title: this.track.title,
        description: this.track.name,
        track: this.track
      });
      this.closeDropdown();
    },
    like: function like() {
      var _this = this;

      if (!this.isLoggedIn) {
        this.$modal.show('login-modal');
      } else {
        this.setLike(this.track.id).then(function (item) {
          if (_this.track.id === _this.currentTrack.id) {
            _this.setCurrentTrackLike(_this.isLiked !== true).then(function () {
              _this.isLiked = _this.isLiked !== true;
            });
          } else {
            _this.isLiked = _this.isLiked !== true;
          }
          _this.getMyFavorites({ genreIdFilter: 0, textToFilter: null }).catch(function (e) {
            _this.$toasted.show(_this.error.message, { type: 'error' });
          });
          _this.closeDropdown();
        });
      }
    },
    deleteTrack: function deleteTrack() {
      var _this2 = this;

      this.$modal.show('dialog', {
        title: this.$t('tracks.deleteTrack.title'),
        text: this.$t('tracks.deleteTrack.confirm'),
        buttons: [{
          title: this.$t('app.yes'),
          handler: function handler() {
            _this2.delete(_this2.track.id).then(function () {
              _this2.closeDropdown();
              _this2.$toasted.show(_this2.$t('tracks.deleteTrack.success'), { type: 'success' });
            }).catch(function (e) {
              _this2.$toasted.show(_this2.error.message, { type: 'error' });
            });
            _this2.$modal.hide('dialog');
          }
        }, {
          title: this.$t('app.no'),
          default: true,
          handler: function handler() {
            _this2.$modal.hide('dialog');
          }
        }]
      });
    },
    addTrackToPlaylist: function addTrackToPlaylist() {
      // if (this.checkUserState()) {
      if (!this.isLoggedIn) {
        this.$modal.show('login-modal');
      } else {
        this.$modal.show('add-to-playlist-modal', { track: this.track });
      }
      // }
    },
    deleteFromPlaylist: function deleteFromPlaylist() {
      var _this3 = this;

      if (!this.isLoggedIn) {
        this.$modal.show('login-modal');
      } else {
        this.$modal.show('dialog', {
          title: this.$t('playlists.deleteTrackFromPlaylist.title'),
          text: this.$t('playlists.deleteTrackFromPlaylist.confirm'),
          buttons: [{
            title: this.$t('app.yes'),
            handler: function handler() {
              _this3.deleteTrackFromPlaylist({ trackId: _this3.track.id, playlistId: _this3.playlist.id }).then(function () {
                _this3.closeDropdown();
                _this3.$toasted.show(_this3.$t('playlists.deleteTrackFromPlaylist.success'), { type: 'success' });
              }).catch(function (e) {
                _this3.$toasted.show(e, { type: 'error' });
              });
              _this3.$modal.hide('dialog');
            }
          }, {
            title: this.$t('app.no'),
            default: true,
            handler: function handler() {
              _this3.$modal.hide('dialog');
            }
          }]
        });
      }
    },
    closeDropdown: function closeDropdown() {
      if (this.transitionVisible && this.showOptions) {
        this.$emit('close-dropdown');
      }
    },
    afterEnter: function afterEnter() {
      this.transitionVisible = true;
    },
    beforeLeave: function beforeLeave() {
      this.transitionVisible = false;
    },
    creditsView: function creditsView() {
      this.$modal.show('credits-modal', {
        credits: this.track.credits
      });
    }
  })
});

/***/ }),
/* 355 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fortawesome_vue_fontawesome__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__fortawesome_vue_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(11);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'player-controls',
  data: function data() {
    return {
      volume: 1,
      mute: false,
      volumeOpen: false
    };
  },

  components: {
    FontAwesomeIcon: __WEBPACK_IMPORTED_MODULE_1__fortawesome_vue_fontawesome___default.a
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('player', ['setPlaying', 'playNext', 'playPrevious']), {
    volumeTrigger: function volumeTrigger() {
      this.mute = !this.mute;
      this.$emit('mute', this.mute);
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])('player', ['isPlaying', 'canPrevious', 'canNext', 'isUnauthorized'])),
  watch: {
    volume: function volume() {
      this.$emit('changeVolume', this.volume);
    }
  }
});

/***/ }),
/* 357 */,
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Login__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ForgotPass__ = __webpack_require__(809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_spinner_src_ClipLoader_vue__ = __webpack_require__(25);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var MODAL_WIDTH = 500;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'login-modal',
  components: {
    FontAwesomeIcon: __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome___default.a,
    Login: __WEBPACK_IMPORTED_MODULE_3__Login__["a" /* default */],
    ForgotPass: __WEBPACK_IMPORTED_MODULE_4__ForgotPass__["a" /* default */],
    ClipLoader: __WEBPACK_IMPORTED_MODULE_5_vue_spinner_src_ClipLoader_vue__["a" /* default */]
  },
  data: function data() {
    return {
      modalWidth: MODAL_WIDTH,
      forgotModal: false,
      color: '#808080',
      size: '20px'
    };
  },
  created: function created() {
    this.modalWidth = window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('user', ['error']), {
    loading: function loading() {
      return this.$loading.isLoading('user login');
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('user', ['resetError']), {
    forgotTrigger: function forgotTrigger() {
      this.forgotModal = !this.forgotModal;
      this.resetError();
    },
    closeModal: function closeModal() {
      this.$modal.hide('login-modal');
    },
    beforeOpen: function beforeOpen() {
      this.forgotModal = false;
      this.resetError();
    }
  })
});

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(11);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'login',
  data: function data() {
    return {
      email: '',
      pass: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])('user', ['isLoggedIn'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('user', ['login']), {
    modalLogin: function modalLogin() {
      var _this = this;

      if (!this.$v.$invalid) {
        if (!this.isLoggedIn) {
          this.login({ email: this.email, pass: this.pass }).then(function () {
            _this.$modal.hide('login-modal');
          }).catch(function () {});
        }
      } else {
        this.$v.$touch();
      }
    }
  }),
  validations: {
    email: {
      email: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["email"],
      required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
    },
    pass: {
      required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
    }
  }
});

/***/ }),
/* 360 */,
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(11);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'forgot-pass',
  data: function data() {
    return {
      email: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])('user', ['isLoggedIn', 'isEmailSent', 'error'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('user', ['forgotPass']), {
    forgotPassword: function forgotPassword(email) {
      var _this = this;

      if (!this.$v.email.$invalid) {
        if (!this.isLoggedIn) {
          this.forgotPass(email).then(function () {
            if (_this.isEmailSent) {
              _this.$toasted.show(_this.$t('user.forgetPassword.success'), {
                type: 'success'
              });
              _this.$modal.hide('login-modal');
            }
          }).catch(function (e) {});
        }
      } else {
        this.$v.$touch();
      }
    }
  }),
  validations: {
    email: {
      email: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["email"],
      required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
    }
  }
});

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fortawesome_vue_fontawesome__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__fortawesome_vue_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_spinner_src_ClipLoader_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(11);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var MODAL_WIDTH = 600;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'signup-modal',
  components: {
    FontAwesomeIcon: __WEBPACK_IMPORTED_MODULE_1__fortawesome_vue_fontawesome___default.a,
    ClipLoader: __WEBPACK_IMPORTED_MODULE_2_vue_spinner_src_ClipLoader_vue__["a" /* default */]
  },
  data: function data() {
    return {
      modalWidth: MODAL_WIDTH,
      color: '#808080',
      size: '50px',
      months: this.$i18n.t('users.months'),
      username: '',
      pass: '',
      dni: '',
      phone: '',
      email: '',
      email2: '',
      address: '',
      day: '',
      month: '',
      year: '',
      userType: 0,
      voucher: ''
    };
  },
  created: function created() {
    this.modalWidth = window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('user', ['error', 'loading', 'input', 'validVoucher']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('translator', ['language'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('user', ['register', 'checkVoucher', 'resetError']), {
    closeModal: function closeModal() {
      this.$modal.hide('signup-modal');
      this.resetError();
    },
    login: function login() {
      this.closeModal();
      this.$modal.show('login-modal');
    },
    modalRegister: function modalRegister() {
      var _this = this;

      if (!this.$v.$invalid) {
        // var birthdate = new Date(this.year, this.month, this.day)
        this.checkVoucher(this.voucher).then(function () {
          if (_this.validVoucher) {
            _this.register({
              username: _this.username,
              pass: _this.pass,
              dni: _this.dni,
              phone: _this.phone,
              email: _this.email,
              address: _this.address,
              birthdate: _this.year + '-' + (parseInt(_this.month) + 1) + '-' + _this.day,
              userType: _this.userType,
              voucher: _this.voucher
            }).then(function () {
              _this.$modal.hide('signup-modal');
              _this.$modal.show('subscription-modal');
            }).catch(function (e) {});
          }
        });
      } else {
        this.$v.$touch();
      }
    },
    opened: function opened() {
      this.$v.$reset();
    },
    beforeClose: function beforeClose() {
      this.resetError();
    }
  }),
  validations: {
    username: {
      required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"]
    },
    pass: {
      required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"]
    },
    dni: {
      required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"],
      minLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["minLength"])(7)
    },
    phone: {
      numeric: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["numeric"]
    },
    email: {
      required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"],
      email: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["email"]
    },
    email2: {
      required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"],
      sameAsEmail: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["sameAs"])('email')
    },
    day: {
      required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"]
    },
    month: {
      required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"]
    },
    year: {
      required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"]
    },
    address: {
      required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"]
    },
    voucher: {
      minLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["minLength"])(10),
      maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(15)
    }
  }
});

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_spinner_src_ClipLoader_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SubscriptionInfo_vue__ = __webpack_require__(818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(11);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var MODAL_WIDTH = 600;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'subscription-modal',
  components: {
    ClipLoader: __WEBPACK_IMPORTED_MODULE_1_vue_spinner_src_ClipLoader_vue__["a" /* default */],
    FontAwesomeIcon: __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome___default.a,
    SubscriptionInfo: __WEBPACK_IMPORTED_MODULE_3__SubscriptionInfo_vue__["a" /* default */]
  },
  data: function data() {
    return {
      modalWidth: MODAL_WIDTH,
      color: '#808080',
      size: '30px',
      voucherCode: null,
      showUSD: false,
      showARG: false,
      refCodeInp: null,
      canRefer: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('user', ['error', 'loading', 'isLoggedIn', 'user', 'subsReferredCode']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('pricing', ['pricing']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('translator', ['language'])),
  watch: {
    subsReferredCode: function subsReferredCode(newSubsReferredCode, oldSubsReferredCode) {
      if (this.subsReferredCode && this.subsReferredCode !== 'false') {
        this.refCodeInp = this.subsReferredCode;
      }
    }
  },
  created: function created() {
    this.modalWidth = window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('user', ['getSubscriptionLinks', 'checkVoucher']), {
    closeModal: function closeModal() {
      this.$modal.hide('subscription-modal');
      this.voucherCode = null;
      this.refCodeInp = null;
    },
    beforeOpen: function beforeOpen(event) {
      this.showCurrency();
      if (this.subsReferredCode && this.subsReferredCode !== 'false') {
        this.refCodeInp = this.subsReferredCode;
      } else {
        this.refCodeInp = '';
      }
    },
    openPayment: function openPayment() {
      var _this = this;

      this.checkVoucher(this.voucherCode).then(function (voucher) {
        if (voucher && !voucher.hasOwnProperty('id')) {
          _this.closeModal();
          return _this.$toasted.show(_this.$i18n.t(voucher), { type: 'error' });
        }
        if (_this.isLoggedIn) {
          if (!_this.isSubscribed) {
            _this.$modal.show('payment-modal', {
              paymentUrl: '/payment/subscribe/',
              voucher: voucher,
              refCode: _this.refCodeInp
            });
            _this.closeModal();
          } else {
            _this.$toasted.show('Ya estas suscrito!', { type: 'info' });
          }
        } else {
          _this.closeModal();
          _this.$modal.show('login-modal');
        }
      });
    },
    showCurrency: function showCurrency() {
      if (this.language === 'es') {
        if (this.user.country === 'AR' || this.user.country === 'argentina' || this.user.country === 'Argentina' || this.user.country === 'ARG') {
          this.showUSD = false;
          this.showARG = true;
        }
        if (this.user.country !== 'AR' && this.user.country !== 'argentina' && this.user.country !== 'Argentina' && this.user.country !== 'ARG') {
          this.showUSD = true;
          this.showARG = false;
        }
      }
      if (this.language === 'en') {
        this.showUSD = true;
        this.showARG = false;
      }
    }
  })
});

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_carousel__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SlideInfo_vue__ = __webpack_require__(820);

//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'subscription-info',
  components: {
    Carousel: __WEBPACK_IMPORTED_MODULE_2_vue_carousel__["Carousel"],
    Slide: __WEBPACK_IMPORTED_MODULE_2_vue_carousel__["Slide"],
    SlideInfo: __WEBPACK_IMPORTED_MODULE_3__SlideInfo_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('user', ['error', 'loading', 'isProducer'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('user', ['resetError']))
});

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'slide-info',
  props: {
    text: {
      required: true
    },
    img: {
      required: true
    }
  }
});

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_spinner_src_ClipLoader_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PaypalPayment_vue__ = __webpack_require__(826);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var MODAL_WIDTH = 600;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'payment-modal',
  components: {
    FontAwesomeIcon: __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome___default.a,
    ClipLoader: __WEBPACK_IMPORTED_MODULE_1_vue_spinner_src_ClipLoader_vue__["a" /* default */],
    PaypalPayment: __WEBPACK_IMPORTED_MODULE_4__PaypalPayment_vue__["a" /* default */]
  },
  data: function data() {
    return {
      modalWidth: MODAL_WIDTH,
      color: '#808080',
      size: '30px',
      paymentUrl: '',
      email: '',
      currency: 'ARS',
      track: null,
      disabled: false,
      tab: null,
      providerCountry: null,
      voucher: null,
      ppPlans: null,
      suggestedValues: null,
      index: null,
      valueARS: 0,
      valueUSD: 0,
      message: '',
      refCode: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    isLoadingLink: function isLoadingLink() {
      return this.$loading.isLoading('user getSubscriptionLink') || this.$loading.isLoading('track getBuyLink');
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('user', ['user']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('pricing', ['pricing'])),
  created: function created() {
    var _this = this;

    this.providerCountry = localStorage.getItem('providerCountry');
    this.getPPplans().then(function (plans) {
      if (plans) {
        _this.ppPlans = plans;
      }
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('user', ['getSubscriptionLink']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('track', ['getBuyLink']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('home', ['getPPplans']), {
    closeModal: function closeModal() {
      this.valueARS = 0;
      this.valueUSD = 0;
      localStorage.removeItem('userFromLandingMK');
      this.$modal.hide('payment-modal');
    },
    beforeOpen: function beforeOpen(event) {
      var _this2 = this;

      this.disabled = false;
      this.paymentUrl = event.params.paymentUrl;
      this.voucher = event.params.voucher;
      this.refCode = event.params.refCode;
      if (event.params.track) {
        this.track = event.params.track;
        this.email = event.params.email;
        this.suggestedValues = event.params.suggestedValues;
        if (event.params.currency === 'ARS') {
          this.message = 'Abonando con Paypal se cobrará el valor del track en USD';
          this.suggestedValues.ARS.forEach(function (element, idx) {
            if (parseFloat(element) === parseFloat(event.params.value)) {
              _this2.index = idx;
            }
          });
          this.valueARS = this.suggestedValues.ARS[this.index];
          this.valueUSD = this.suggestedValues.USD[this.index];
        }
        if (event.params.currency === 'USD') {
          this.message = 'Abonando con Mercado Pago se cobrará el valor del track en ARS';
          this.suggestedValues.USD.forEach(function (element, idx) {
            if (parseFloat(element) === parseFloat(event.params.value)) {
              _this2.index = idx;
            }
          });
          this.valueARS = this.suggestedValues.ARS[this.index];
          this.valueUSD = this.suggestedValues.USD[this.index];
        }
      } else {
        this.track = null;
        this.valueARS = 0;
        this.valueUSD = 0;
      }
    },
    getPaymentLink: function getPaymentLink(gateway) {
      // this.tab = window.open('', '_blank') mercadopago
      this.disabled = true;

      if (this.track) {
        this.getTrackLink(gateway);
      } else if (gateway === 'mercadopago') {
        this.$modal.show('set-email-modal', {
          paymentUrl: this.paymentUrl,
          voucher: this.voucher,
          refCode: this.refCode,
          gateway: gateway
        });
        this.closeModal();
      } else {
        this.getSubsLink(gateway);
      }
    },
    getSubsLink: function getSubsLink(gateway) {
      var _this3 = this;

      this.getSubscriptionLink({ gateway: gateway, paymentUrl: this.paymentUrl, voucher: this.voucher, refCode: this.refCode }).then(function (nextUrl) {
        window.location.href = nextUrl;
      }).catch(function (e) {
        if (e.message === 'Ya se encuentra una suscripción activa para este usuario') {
          localStorage.removeItem('userFromLandingMK');
          _this3.$modal.hide('payment-modal');
          _this3.disabled = false;
          _this3.$router.push({ path: '/home' });
        }
        if (e.message === 'Invalid Voucher Code') {
          _this3.$modal.hide('payment-modal');
        }
        _this3.$toasted.show(e.message, { type: 'error' });
        _this3.disabled = false;
      });
    },
    getTrackLink: function getTrackLink(gateway) {
      var _this4 = this;

      this.getBuyLink({
        value: this.valueARS,
        track: this.track,
        gateway: gateway,
        currency: this.currency
      }).then(function (nextUrl) {
        window.location.href = nextUrl;
        _this4.$toasted.show(_this4.$t('tracks.buyTrack.emailMessage'), { type: 'success' });
        _this4.disabled = false;
        _this4.$modal.hide('payment-modal');
      }).catch(function (e) {
        _this4.tab = null;
        _this4.$toasted.show(e.message, { type: 'error' });
        _this4.disabled = false;
      });
    }
  })
});

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__consts__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(11);



//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PaypalPayment',
  props: {
    track: {
      default: null
    },
    value: {
      default: null
    },
    ppPlans: {
      default: null
    },
    refCode: {
      default: null
    },
    voucher: {
      default: null
    }
  },
  data: function data() {
    return {
      loaded: false,
      paidFor: false,
      product: {
        price: 0,
        description: ''
      },
      subscriptionPaymentURL: __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].PP_SUBSCRIPTION_PAYMENT_URL,
      trackPaymentURL: __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].PP_TRACK_PAYMENT_URL
    };
  },
  created: function created() {},
  mounted: function mounted() {
    var script = document.createElement('script');
    if (this.track && this.value) {
      script.src = this.trackPaymentURL;
      script.addEventListener('load', this.buyTrack);
    } else if (this.ppPlans) {
      script.src = this.subscriptionPaymentURL;
      script.addEventListener('load', this.newSubscription);
    }
    document.body.appendChild(script);
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('user', ['subscribeByPaypal', 'paypalCaptureOrder']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('track', ['getBuyLink']), {
    newSubscription: function newSubscription() {
      var that = this;
      that.loaded = true;
      var ppPlan = void 0;
      if (this.voucher && this.voucher.months === 3) {
        ppPlan = that.ppPlans.find(function (plan) {
          return plan.id === 'P-0MJ6500297088250TMZCNHPY';
        });
      } else {
        ppPlan = that.ppPlans[0];
      }
      window.paypal.Buttons({
        createSubscription: function createSubscription(data, actions) {
          return actions.subscription.create({
            plan_id: ppPlan.id
          });
        },
        onApprove: function onApprove(data, actions) {
          var _this = this;

          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            var subscriptionPlan, amountPayed, tokenData, subsData;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    subscriptionPlan = ppPlan;

                    that.paidFor = true;
                    amountPayed = null;
                    tokenData = null;

                    if (data) {
                      tokenData = data.facilitatorAccessToken;
                    }

                    subsData = {
                      gateway: 'paypal',
                      details: { data: data, subscriptionPlan: subscriptionPlan },
                      amount: amountPayed,
                      token: tokenData,
                      refCode: that.refCode,
                      voucherCode: that.voucher.code
                    };

                    that.subscribeByPaypal(subsData);

                    setTimeout(function () {
                      that.$router.push({ path: '/' });
                    }, 5000);
                    that.$modal.hide('payment-modal');

                  case 9:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, _this);
          }))();
        },
        onError: function onError(err) {
          console.log(err);
          that.$toasted.show(err, { type: 'error' });
          that.$modal.hide('payment-modal');
        }
      }).render(that.$refs.paypal);
    },
    buyTrack: function buyTrack() {
      var that = this;
      that.loaded = true;
      window.paypal.Buttons({
        createOrder: function createOrder(data, actions) {
          return actions.order.create({
            purchase_units: [{
              description: 'Track: ' + that.track.title + ', ' + 'Artist_code: ' + that.track.id_artist,
              amount: {
                currency_code: 'USD',
                value: that.value,
                breakdown: {
                  item_total: {
                    currency_code: 'USD',
                    value: that.value
                  }
                }
              },
              items: [{
                name: 'Track: ' + that.track.title + ', ' + 'Artist_code: ' + that.track.id_artist,
                unit_amount: {
                  currency_code: 'USD',
                  value: that.value
                },
                quantity: 1
              }]
            }]
          });
        },
        onApprove: function onApprove(data, actions) {
          var _this2 = this;

          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    that.paypalCaptureOrder(data.orderID).then(function (response) {
                      if (response.status === 'COMPLETED') {
                        that.paidFor = true;
                        that.getBuyLink({
                          value: that.value,
                          track: that.track,
                          gateway: 'paypal',
                          currency: 'USD',
                          description: response
                        });
                        that.$modal.hide('payment-modal');
                        that.$toasted.show(that.$t('tracks.buyTrack.downloadMessage'), { type: 'success' });
                      } else {
                        that.$modal.hide('payment-modal');
                        that.$toasted.show('The payment is pending approval.', { type: 'success' });
                      }
                    });

                  case 1:
                  case 'end':
                    return _context2.stop();
                }
              }
            }, _callee2, _this2);
          }))();
        },
        onError: function onError(err) {
          console.log(err);
          that.$toasted.show(err, { type: 'error' });
          that.$modal.hide('payment-modal');
        }
      }).render(that.$refs.paypal);
    }
  })
});

/***/ }),
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fortawesome_vue_fontawesome__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__fortawesome_vue_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_tracks_TrackInfo_vue__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_playlists_PlaylistInfo_vue__ = __webpack_require__(846);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var MODAL_WIDTH = 600;
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'share-modal',
  components: {
    FontAwesomeIcon: __WEBPACK_IMPORTED_MODULE_0__fortawesome_vue_fontawesome___default.a,
    TrackInfo: __WEBPACK_IMPORTED_MODULE_1__components_tracks_TrackInfo_vue__["a" /* default */],
    PlaylistInfo: __WEBPACK_IMPORTED_MODULE_2__components_playlists_PlaylistInfo_vue__["a" /* default */]
  },
  data: function data() {
    return {
      modalWidth: MODAL_WIDTH,
      color: '#808080',
      size: '50px',
      link: '',
      title: '',
      description: '',
      track: null,
      playlist: null
    };
  },
  created: function created() {
    this.modalWidth = window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
  },

  methods: {
    closeModal: function closeModal() {
      this.track = Object;
      this.artist = Object;
      this.$modal.hide('share-modal');
    },
    beforeOpen: function beforeOpen(event) {
      this.track = null;
      this.playlist = null;
      this.link = event.params.link;
      this.title = event.params.title;
      this.decription = event.params.description;
      if (event.params.track) {
        this.track = event.params.track;
      } else if (event.params.playlist) {
        this.playlist = event.params.playlist;
      }
    },
    clipboardSuccess: function clipboardSuccess() {
      this.$toasted.show(this.$t('tracks.shareTrack.success'), { type: 'success' });
    },
    clipboardError: function clipboardError() {
      this.$toasted.show(this.$t('tracks.shareTrack.error'), { type: 'error' });
    }
  }
});

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__consts__ = __webpack_require__(21);
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'playlist-info',
  props: {
    playlist: {
      required: true
    }
  },
  computed: {
    picture: function picture() {
      return __WEBPACK_IMPORTED_MODULE_0__consts__["a" /* default */].MEDIA_BASE_URL + this.playlist.picture;
    }
  }
});

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_spinner_src_ClipLoader_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_tracks_TrackInfo_vue__ = __webpack_require__(232);



var _value;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var MODAL_WIDTH = 600;

var currencies = ['ARS', 'USD'];

var minValueHelper = function minValueHelper(track) {
  return function (value, v) {
    return value >= v.suggestedValues[v.currency][0];
  };
};
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'buy-track-modal',
  components: {
    FontAwesomeIcon: __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome___default.a,
    ClipLoader: __WEBPACK_IMPORTED_MODULE_3_vue_spinner_src_ClipLoader_vue__["a" /* default */],
    TrackInfo: __WEBPACK_IMPORTED_MODULE_6__components_tracks_TrackInfo_vue__["a" /* default */]
  },
  data: function data() {
    return {
      modalWidth: MODAL_WIDTH,
      color: '#808080',
      size: '30px',
      value: 10,
      currency: currencies[0],
      currencies: currencies,
      suggestedValues: {
        ARS: [],
        USD: []
      },
      track: null,
      actualLicense: null
    };
  },
  created: function created() {
    this.modalWidth = window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
    this.getLicenses();
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])('track', ['error', 'prices']), Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])('user', ['user', 'isLoggedIn']), Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])('license', ['licenses']), {
    licenseIcon: function licenseIcon() {
      return '/static/' + this.actualLicense.icon;
    },
    loading: function loading() {
      return this.$loading.isLoading('track getBuyLink') || this.$loading.isLoading('track getLicenses');
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('track', ['getBuyLink', 'resetError', 'getConvertedValues']), Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('license', ['getLicenses']), {
    closeModal: function closeModal() {
      this.value = 1;
      this.$modal.hide('buy-track-modal');
    },
    modalBuy: function modalBuy() {
      if (!this.$v.$invalid) {
        this.$modal.hide('buy-track-modal');
        this.$modal.show('payment-modal', {
          value: this.value,
          track: this.track,
          currency: this.currency,
          paymentUrl: '',
          suggestedValues: this.suggestedValues
        });
        this.value = 1;
      } else {
        this.$v.$touch();
      }
    },
    beforeOpen: function beforeOpen(event) {
      var _this = this;

      var providerCountry = localStorage.getItem('providerCountry');
      if (this.user.country) {
        if (this.user.country !== 'ARG' && this.user.country !== 'AR' && this.user.country !== 'Argentina' && this.user.country !== 'argentina') {
          this.currencies = ['USD'];
          this.currency = currencies[1];
        }
      }
      if (providerCountry) {
        if (providerCountry !== 'ARG' && this.user.country !== 'AR') {
          this.currencies = ['USD'];
          this.currency = currencies[1];
        }
      }
      this.track = null;
      this.actualLicense = null;
      this.$v.$reset();
      this.track = event.params.track;
      this.actualLicense = this.licenses[this.track.id_lisense - 1];
      this.getConvertedValues({
        track: this.track,
        toCurrency: 'ARS'
      }).then(function (res) {
        _this.suggestedValues[res.currency] = res.values;
      });

      this.getConvertedValues({
        track: this.track,
        toCurrency: 'USD'
      }).then(function (res) {
        _this.suggestedValues[res.currency] = res.values;
      });
    },
    beforeClose: function beforeClose() {
      this.resetError();
    }
  }),
  validations: {
    value: (_value = {
      required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"],
      decimal: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["decimal"]
    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_value, __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["minValue"], minValueHelper(this.track)), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_value, 'greaterThanZero', function greaterThanZero(value) {
      return value > 0;
    }), _value)
  }
});

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'credits-modal',
  data: function data() {
    return {
      credits: ''
    };
  },

  methods: {
    closeModal: function closeModal() {
      this.$modal.hide('credits-modal');
    },
    beforeOpen: function beforeOpen(event) {
      this.credits = event.params.credits !== "''" ? event.params.credits : '';
    }
  }
});

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArtistProfile_vue__ = __webpack_require__(382);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_106e43d6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArtistProfile_vue__ = __webpack_require__(880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(860)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-106e43d6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArtistProfile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_106e43d6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArtistProfile_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_106e43d6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArtistProfile_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_on_click_outside__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_on_click_outside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_on_click_outside__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__consts__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_spinner_src_ClipLoader_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ArtistInfo_vue__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ArtistContact_vue__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ArtistTracks_vue__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ArtistPlaylists_vue__ = __webpack_require__(392);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'artist-profile',
  components: {
    FontAwesomeIcon: __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome___default.a,
    ClipLoader: __WEBPACK_IMPORTED_MODULE_5_vue_spinner_src_ClipLoader_vue__["a" /* default */],
    'artist-contact': __WEBPACK_IMPORTED_MODULE_7__ArtistContact_vue__["a" /* default */],
    'artist-info': __WEBPACK_IMPORTED_MODULE_6__ArtistInfo_vue__["a" /* default */],
    'artist-playlists': __WEBPACK_IMPORTED_MODULE_9__ArtistPlaylists_vue__["a" /* default */],
    'artist-tracks': __WEBPACK_IMPORTED_MODULE_8__ArtistTracks_vue__["a" /* default */]
  },
  data: function data() {
    return {
      color: '#808080',
      size: '20px',
      tab: 'artist-tracks',
      aId: null,
      followedArtistsArray: null,
      isFollowed: false
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_1_vue_on_click_outside__["mixin"]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    picture: function picture() {
      if (this.artist.primary_picture) {
        return __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].MEDIA_BASE_URL + this.artist.path + this.artist.primary_picture;
      } else {
        return '/static/assets/Img_generico_principal3.jpg';
      }
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('artist', ['artistTracks', 'error', 'artist']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('user', ['isLoggedIn', 'isSubscribed', 'myVotes', 'followedArtists']), {
    loadingArtist: function loadingArtist() {
      return this.$loading.isLoading('artist getArtist');
    },
    loadingVote: function loadingVote() {
      return this.$loading.isLoading('artist setVote');
    },
    hasTracks: function hasTracks() {
      return this.artistTracks.length > 0;
    },
    voteDisabled: function voteDisabled() {
      return this.isSubscribed && this.myVotes === null;
    }
  }),
  watch: {
    artist: function artist(newArtist, oldArtist) {
      if (this.artist) {
        this.followedArtistsArray = localStorage.getItem('followedArtists').split(',');
        if (this.followedArtistsArray.includes(this.artist.id)) {
          this.isFollowed = true;
        } else {
          this.isFollowed = false;
        }
      }
    }
  },
  created: function created() {
    this.aId = localStorage.getItem('qrArtistId');
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('artist', ['setVote', 'getArtist', 'closeProfile']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('user', ['setFollowArtist', 'getMyFollowedArtists']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapMutations */])('user', ['setFollowing']), {
    close: function close() {
      if (this.aId && this.aId !== null) {
        localStorage.removeItem('qrArtistId');
        this.aId = null;
        this.closeProfile();
        this.tab = 'artist-tracks';
        this.$router.push({ path: '/artists' });
      } else {
        history.back();
        this.closeProfile();
        this.tab = 'artist-tracks';
      }
    },
    checkVote: function checkVote() {
      if (!this.isLoggedIn) {
        this.$modal.show('login-modal');
      } else if (!this.isSubscribed && (this.myVotes === 0 || !this.myVotes)) {
        this.$modal.show('subscription-modal');
      } else {
        this.vote();
      }
    },
    vote: function vote() {
      var _this = this;

      this.setVote(this.artist.id).then(function () {
        _this.$toasted.show(_this.$t('vinylContest.success'), { type: 'success' });
      }).catch(function (e) {
        _this.$toasted.show(_this.error.message, { type: 'error' });
      });
    },
    changeTab: function changeTab(tab) {
      history.replaceState({}, null, '/artists/' + this.artist.id + '/' + tab);
      this.tab = 'artist-' + tab;
    },
    setFollow: function setFollow() {
      var _this2 = this;

      this.setFollowArtist(this.artist.id).then(function (response) {
        if (response) {
          _this2.getMyFollowedArtists({ getIds: true });
          if (_this2.isFollowed === false) {
            _this2.isFollowed = true;
            _this2.$toasted.show(_this2.$t('users.followArtist') + ' ' + _this2.artist.name, { type: 'success' });
          } else {
            _this2.isFollowed = false;
            _this2.$toasted.show(_this2.$t('users.unfollowArtist') + ' ' + _this2.artist.name, { type: 'success' });
          }
        }
        _this2.getMyFollowedArtists({ getIds: null }).then(function (items) {
          _this2.setFollowing(items);
        });
      });
    }
  })
});

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArtistInfo_vue__ = __webpack_require__(384);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d6770952_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArtistInfo_vue__ = __webpack_require__(864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(861)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d6770952"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArtistInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d6770952_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArtistInfo_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d6770952_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArtistInfo_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_spinner_src_PulseLoader_vue__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(11);

//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'artist-info',
  components: {
    PulseLoader: __WEBPACK_IMPORTED_MODULE_1_vue_spinner_src_PulseLoader_vue__["a" /* default */]
  },
  data: function data() {
    return {
      color: '#808080',
      size: '10px'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])('artist', ['artist']), {
    hasInfo: function hasInfo() {
      return this.artist.phrase !== '';
    },
    loading: function loading() {
      return this.$loading.isLoading('artist getArtist');
    }
  })
});

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'PulseLoader',

  props: {
    loading: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: '#5dc596'
    },
    size: {
      type: String,
      default: '15px'
    },
    margin: {
      type: String,
      default: '2px'
    },
    radius: {
      type: String,
      default: '100%'
    }
  },
  data: function data() {
    return {
      spinnerStyle: {
        backgroundColor: this.color,
        width: this.size,
        height: this.size,
        margin: this.margin,
        borderRadius: this.radius,
        display: 'inline-block',
        animationName: 'v-pulseStretchDelay',
        animationDuration: '0.75s',
        animationIterationCount: 'infinite',
        animationTimingFunction: 'cubic-bezier(.2,.68,.18,1.08)',
        animationFillMode: 'both'
      },
      spinnerDelay1: {
        animationDelay: '0.12s'
      },
      spinnerDelay2: {
        animationDelay: '0.24s'
      },
      spinnerDelay3: {
        animationDelay: '0.36s'
      }
    };
  }
});

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArtistContact_vue__ = __webpack_require__(387);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15715a6d_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArtistContact_vue__ = __webpack_require__(866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(865)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-15715a6d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArtistContact_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15715a6d_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArtistContact_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15715a6d_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArtistContact_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'artist-contact',
  data: function data() {
    return {
      message: ''
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('artist', ['contact']), {
    sendMessage: function sendMessage() {
      var _this = this;

      if (!this.$v.$invalid) {
        this.contact({ message: this.message, artist_id: this.artist.id, userEmail: this.user.email, userFirstName: this.user.first_name, userLastName: this.user.last_name, username: this.user.user_name }).then(function () {
          _this.message = '';
          _this.$v.$reset();
          _this.$toasted.show(_this.$t('artists.contact.success'), { type: 'success' });
        }).catch(function (e) {
          _this.$toasted.show(e.message, { type: 'error' });
        });
      } else {
        this.$v.$touch();
      }
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('artist', ['artist']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('user', ['user'])),
  validations: {
    message: {
      required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
      maxLength: Object(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["maxLength"])(2048)
    }
  }
});

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArtistTracks_vue__ = __webpack_require__(389);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4313a646_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArtistTracks_vue__ = __webpack_require__(872);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(867)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4313a646"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArtistTracks_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4313a646_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArtistTracks_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4313a646_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArtistTracks_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_tracks_TrackData__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_tracks_TrackImage__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_spinner_src_PulseLoader_vue__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_tracks_TrackOptionsButton_vue__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(11);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'artist-tracks',
  components: {
    TrackData: __WEBPACK_IMPORTED_MODULE_1__components_tracks_TrackData__["a" /* default */],
    TrackImage: __WEBPACK_IMPORTED_MODULE_2__components_tracks_TrackImage__["a" /* default */],
    PulseLoader: __WEBPACK_IMPORTED_MODULE_3_vue_spinner_src_PulseLoader_vue__["a" /* default */],
    TrackOptionsButton: __WEBPACK_IMPORTED_MODULE_4__components_tracks_TrackOptionsButton_vue__["a" /* default */]
  },
  data: function data() {
    return {
      color: '#808080',
      size: '10px'
    };
  },
  created: function created() {
    var _this = this;

    if (this.artistTracks.length === 0 && this.artist.id !== undefined) {
      this.getArtistTracks(this.artist.id).catch(function (e) {
        _this.$toasted.show(_this.error.message, { type: 'error' });
      });
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])('artist', ['artistTracks', 'artist', 'error']), Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])('player', ['currentTrack']), {
    hasTracks: function hasTracks() {
      return this.artistTracks.length > 0;
    },
    loading: function loading() {
      return this.$loading.isLoading('artist getArtistTracks');
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('artist', ['getArtistTracks']), Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('player', ['setPlaying', 'setPlaylist', 'changeTrack']))
});

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'track-data',
  props: {
    track: {
      required: true
    }
  }
});

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__consts__ = __webpack_require__(21);

//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'track-image',
  props: {
    track: {
      required: true
    }
  },
  components: {
    FontAwesomeIcon: __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('player', ['currentTrack', 'isPlaying']), {
    picture: function picture() {
      var trackPicture = '';
      if (!/\/uploads\/tracks\//.test(this.track.picture)) {
        trackPicture = '/uploads/tracks/' + this.track.picture;
      } else {
        trackPicture = this.track.picture;
      }
      return __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].MEDIA_BASE_URL + trackPicture;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('player', ['setPlaying', 'changeTrack']))

});

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArtistPlaylists_vue__ = __webpack_require__(393);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aaf5e386_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArtistPlaylists_vue__ = __webpack_require__(879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArtistPlaylists_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aaf5e386_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArtistPlaylists_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aaf5e386_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArtistPlaylists_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_playlists_PlaylistList_vue__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_spinner_src_PulseLoader_vue__ = __webpack_require__(172);

//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'artist-playlists',
  data: function data() {
    return {
      color: '#808080',
      size: '10px'
    };
  },
  created: function created() {
    var _this = this;

    if (this.artistPlaylists.length === 0) {
      this.getArtistPlaylists(this.artist.id).catch(function (e) {
        _this.$toasted.show(_this.error.message, { type: 'error' });
      });
    }
  },

  components: {
    PlaylistList: __WEBPACK_IMPORTED_MODULE_2__components_playlists_PlaylistList_vue__["a" /* default */],
    PulseLoader: __WEBPACK_IMPORTED_MODULE_3_vue_spinner_src_PulseLoader_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('artist', ['artist', 'artistPlaylists', 'error']), {
    loading: function loading() {
      return this.$loading.isLoading('artist getArtistPlaylists');
    },
    hasPlaylists: function hasPlaylists() {
      return this.artistPlaylists.length > 0;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('artist', ['getArtistPlaylists']))
});

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlaylistList_vue__ = __webpack_require__(395);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10bc0fb6_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlaylistList_vue__ = __webpack_require__(878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(873)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlaylistList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10bc0fb6_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlaylistList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10bc0fb6_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlaylistList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PlaylistCard_vue__ = __webpack_require__(396);
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'playlist-list',
  components: {
    PlaylistCard: __WEBPACK_IMPORTED_MODULE_0__PlaylistCard_vue__["a" /* default */]
  },
  props: {
    playlists: {
      required: true
    },
    inArtistProfile: {
      default: false
    },
    section: {
      default: ''
    }
  }
});

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlaylistCard_vue__ = __webpack_require__(397);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66fa974c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlaylistCard_vue__ = __webpack_require__(877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(874)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-66fa974c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlaylistCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66fa974c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlaylistCard_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66fa974c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlaylistCard_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_tracks_TrackData__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__consts__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fortawesome_vue_fontawesome__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__fortawesome_vue_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_tracks_SimpleTracksList_vue__ = __webpack_require__(398);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'paylist-card',
  props: {
    playlist: {
      required: true
    },
    inArtistProfile: {
      default: false
    },
    section: { default: '' }
  },
  data: function data() {
    return {
      liking: null
    };
  },

  components: {
    TrackData: __WEBPACK_IMPORTED_MODULE_1__components_tracks_TrackData__["a" /* default */],
    FontAwesomeIcon: __WEBPACK_IMPORTED_MODULE_4__fortawesome_vue_fontawesome___default.a,
    SimpleTracksList: __WEBPACK_IMPORTED_MODULE_5__components_tracks_SimpleTracksList_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('player', ['isPlaying']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('user', ['myPlaylists', 'user']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('playlist', ['playlistLiked']), {
    isMyPlaylist: function isMyPlaylist() {
      return this.user && this.playlist.user.id === this.user.id;
    },
    picture: function picture() {
      if (this.playlist.picture) {
        return __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].MEDIA_BASE_URL + this.playlist.picture;
      } else {
        return '/static/assets/Img_comodines_Beathey_Playlist.jpg';
      }
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('player', ['setPlaylist', 'changeTrack', 'playFirstTrack']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('playlist', ['delete', 'togglePlaylistLike']), {
    deletePlaylist: function deletePlaylist() {
      var _this = this;

      this.$modal.show('dialog', {
        title: this.$t('playlists.delete.title'),
        text: this.$t('playlists.delete.confirm'),
        buttons: [{
          title: this.$t('app.yes'),
          handler: function handler() {
            _this.delete(_this.playlist.id).then(function () {
              _this.$toasted.show(_this.$t('playlists.delete.success'), { type: 'success' });
            }).catch(function (e) {
              _this.$toasted.show(_this.error.message, { type: 'error' });
            });
            _this.$modal.hide('dialog');
          }
        }, {
          title: this.$t('app.no'),
          default: true,
          handler: function handler() {
            _this.$modal.hide('dialog');
          }
        }]
      });
    },
    editPlaylist: function editPlaylist() {
      this.$modal.show('new-playlist-modal', { playlist: this.playlist, picturePath: this.picture });
    },
    sharePlaylist: function sharePlaylist() {
      this.$modal.show('share-modal', {
        link: __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].BASE_HOST + '/services/share/playlist/' + this.playlist.id,
        title: this.playlist.title,
        // playlist de artistname
        description: '',
        playlist: this.playlist
      });
    },
    likePlaylist: function likePlaylist() {
      var _this2 = this;

      this.togglePlaylistLike(this.playlist.id).then(function () {
        _this2.liking = _this2.playlistLiked;
      }).catch(function (e) {
        console.log('error');
        console.log(e.message);
        // this.$toasted.show(this.error.message, {type: 'error'})
      });
    }
  }),
  mounted: function mounted() {
    this.liking = this.playlist.liked;
  }
});

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SimpleTracksList_vue__ = __webpack_require__(399);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_289f9e6c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SimpleTracksList_vue__ = __webpack_require__(876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(875)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-289f9e6c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SimpleTracksList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_289f9e6c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SimpleTracksList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_289f9e6c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SimpleTracksList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_tracks_TrackData_vue__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TrackOptionsButton_vue__ = __webpack_require__(102);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'simple-tracks-list',
  props: {
    tracks: {
      required: true
    },
    inArtistProfile: {
      default: false
    },
    playlist: {
      default: null
    }
  },
  components: {
    TrackData: __WEBPACK_IMPORTED_MODULE_1__components_tracks_TrackData_vue__["a" /* default */],
    FontAwesomeIcon: __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome___default.a,
    TrackOptionsButton: __WEBPACK_IMPORTED_MODULE_4__TrackOptionsButton_vue__["a" /* default */]
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('player', ['setPlaylist', 'changeTrack']))
});

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_spinner_src_ClipLoader_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_playlists_PlaylistSelect_vue__ = __webpack_require__(883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fortawesome_vue_fontawesome__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__fortawesome_vue_fontawesome__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var MODAL_WIDTH = '30%';
var MODAL_HEIGHT = '60%';

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'add-to-playlist',
  data: function data() {
    return {
      selectedPlaylistId: null,
      track: null,
      modalWidth: MODAL_WIDTH,
      modalHeight: MODAL_HEIGHT,
      color: '#808080',
      size: '20px'
    };
  },

  components: {
    ClipLoader: __WEBPACK_IMPORTED_MODULE_2_vue_spinner_src_ClipLoader_vue__["a" /* default */],
    PlaylistSelect: __WEBPACK_IMPORTED_MODULE_3__components_playlists_PlaylistSelect_vue__["a" /* default */],
    FontAwesomeIcon: __WEBPACK_IMPORTED_MODULE_4__fortawesome_vue_fontawesome___default.a
  },
  created: function created() {
    this.modalWidth = window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('user', ['getMyPlaylists']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('playlist', ['addToPlaylist']), {
    beforeOpen: function beforeOpen(event) {
      var _this = this;

      // !Aca
      this.getMyPlaylists().then(function () {
        _this.selectedPlaylistId = _this.myPlaylists[0].id;
      }).catch(function (e) {
        _this.$toasted.show(_this.userError, { type: 'error' });
      });
      this.track = event.params.track;
    },
    closeModal: function closeModal() {
      this.$modal.hide('add-to-playlist-modal');
    },
    addTrackToPlaylist: function addTrackToPlaylist() {
      var _this2 = this;

      if (this.selectedPlaylistId) {
        this.addToPlaylist({ trackId: this.track.id, playlistId: this.selectedPlaylistId }).then(function () {
          _this2.$toasted.show(_this2.$t('playlists.addToPlaylist.success'), { type: 'success' });
          _this2.closeModal();
        }).catch(function (e) {
          if (_this2.playlistError.message === _this2.$t('playlists.addToPlaylist.trackAlreadyExist')) {
            _this2.closeModal();
            _this2.$toasted.show(_this2.playlistError.message, { theme: 'primary' });
          } else {
            _this2.$toasted.show(_this2.playlistError.message, { type: 'error' });
          }
        });
      } else {
        this.$toasted.show(this.$t('error.playlistRequired'), { type: 'error' });
      }
    },
    selectPlaylist: function selectPlaylist(playlistId) {
      this.selectedPlaylistId = playlistId;
    },
    newPlaylist: function newPlaylist() {
      this.closeModal();
      this.$modal.show('new-playlist-modal', { track: this.track });
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('user', {
    myPlaylists: 'myPlaylists',
    userError: 'error'
  }), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('playlist', {
    playlistError: 'error'
  }), {
    loading: function loading() {
      return this.$loading.isLoading('user getMyPlaylists') || this.$loading.isLoading('playlist addToPlaylist');
    }
  })
});

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__consts__ = __webpack_require__(21);
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'playlist-select',
  props: {
    playlist: {
      required: true
    }
  },
  computed: {
    picture: function picture() {
      return __WEBPACK_IMPORTED_MODULE_0__consts__["a" /* default */].MEDIA_BASE_URL + this.playlist.picture;
    }
  }
});

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fortawesome_vue_fontawesome__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__fortawesome_vue_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_UploadImage_vue__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_spinner_src_ClipLoader_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(11);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var MODAL_WIDTH = 500;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'new-playlist',
  data: function data() {
    return {
      track: null,
      title: '',
      type: 1,
      picture: '',
      picturePath: '',
      color: '#808080',
      size: '20px',
      isEdit: false,
      disabled: false
    };
  },

  components: {
    ClipLoader: __WEBPACK_IMPORTED_MODULE_3_vue_spinner_src_ClipLoader_vue__["a" /* default */],
    FontAwesomeIcon: __WEBPACK_IMPORTED_MODULE_1__fortawesome_vue_fontawesome___default.a,
    UploadImage: __WEBPACK_IMPORTED_MODULE_2__components_UploadImage_vue__["a" /* default */]
  },
  created: function created() {
    this.modalWidth = window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])('playlist', ['error', 'newPlaylistId']), {
    loading: function loading() {
      return this.$loading.isLoading('playlist setPlaylist') || this.$loading.isLoading('playlist setPlaylistAndTrack') || this.$loading.isLoading('playlist edit');
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('playlist', ['setPlaylist', 'resetError', 'edit', 'setPlaylistAndTrack']), {
    beforeOpen: function beforeOpen(event) {
      this.resetError();
      this.$v.$reset();
      this.track = event.params.track;
      if (event.params.playlist) {
        this.title = event.params.playlist.title;
        this.picture = event.params.playlist.picture;
        this.picturePath = event.params.picturePath;
        this.type = event.params.playlist.type;
        this.id = event.params.playlist.id;
        this.isEdit = true;
      } else {
        this.title = '';
        this.picture = '';
        this.type = 1;
        this.id = '';
        this.isEdit = false;
      }
    },
    closeModal: function closeModal() {
      this.$modal.hide('new-playlist-modal');
    },
    newPlaylist: function newPlaylist() {
      var _this = this;

      if (this.track) {
        this.setPlaylistAndTrack({ title: this.title, picture: this.picture, type: this.type, trackId: this.track.id }).then(function () {
          _this.closeModal();
          _this.$toasted.show(_this.$t('playlists.newPlaylist.success'), { type: 'success' });
        }).catch(function (e) {
          _this.$toasted.show(_this.error.message, { type: 'error' });
        });
      } else {
        this.setPlaylist({ playlist: this.playlist }).then(function () {
          _this.closeModal();
          _this.$toasted.show(_this.$t('playlists.newPlaylist.success'), { type: 'success' });
        }).catch(function (e) {
          _this.$toasted.show(_this.error.message, { type: 'error' });
        });
      }
    },
    editPlaylist: function editPlaylist() {
      var _this2 = this;

      this.edit({ title: this.title, picture: this.picture, type: this.type, playlistId: this.id }).then(function () {
        _this2.closeModal();
        _this2.$toasted.show(_this2.$t('playlists.edit.success'), { type: 'success' });
      }).catch(function (e) {
        _this2.$toasted.show(_this2.error.message, { type: 'error' });
      });
    },
    savePlaylist: function savePlaylist() {
      if (!this.$v.$invalid) {
        if (this.isEdit) {
          this.editPlaylist();
        } else {
          this.newPlaylist();
        }
      } else {
        this.$v.$touch();
      }
    },
    handleUploadFinished: function handleUploadFinished(event) {
      this.picture = event;
      this.disabled = false;
    }
  }),
  validations: {
    title: {
      required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"]
    }
  }
});

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_upload_component__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_upload_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_upload_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__consts__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fortawesome_vue_fontawesome__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__fortawesome_vue_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_spinner_src_ClipLoader_vue__ = __webpack_require__(25);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'upload-image',
  props: {
    path: {
      required: true
    },
    picturePath: {
      default: ''
    },
    trackEdit: {
      default: 'false'
    },
    newPlaylist: {
      default: 'false'
    }
  },
  data: function data() {
    return {
      imageFiles: [],
      color: '#808080',
      size: '30px',
      localPicturePath: ''
    };
  },

  components: {
    FontAwesomeIcon: __WEBPACK_IMPORTED_MODULE_3__fortawesome_vue_fontawesome___default.a,
    FileUpload: __WEBPACK_IMPORTED_MODULE_0_vue_upload_component___default.a,
    ClipLoader: __WEBPACK_IMPORTED_MODULE_4_vue_spinner_src_ClipLoader_vue__["a" /* default */]
  },
  created: function created() {
    this.localPicturePath = this.picturePath;
  },

  computed: {
    url: function url() {
      return __WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].API_BASE_URL + this.path;
    },

    postFileHeaders: function postFileHeaders() {
      return __WEBPACK_IMPORTED_MODULE_2__auth__["b" /* default */].getHeader();
    },
    picture: function picture() {
      if (this.imageFiles.length > 0) {
        if (this.imageFiles[0].success && this.imageFiles[0].response.status === 'ok') {
          return __WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].MEDIA_BASE_URL + this.imageFiles[0].response.data.path + this.imageFiles[0].response.data.filename;
        } else if (this.imageFiles[0].response.status === 'error') {
          this.$toasted.show(this.$t('tracks.newTrack.imageError'), { type: 'error' });
          this.imageFiles = [];
        }
      } else if (this.localPicturePath) {
        return this.localPicturePath;
      }
    }
  },
  methods: {
    deleteImage: function deleteImage() {
      this.localPicturePath = '';
      this.imageFiles = [];
      this.$emit('uploadFinished', '');
    },

    imageInputFile: function imageInputFile(newFile, oldFile) {
      // auto start
      if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
        if (!this.$refs.imageUpload.active) {
          this.$emit('uploadStart');
          this.$refs.imageUpload.active = true;
        }
      }
      if (newFile && oldFile) {
        if (newFile.success !== oldFile.success) {
          if (newFile.response) {
            this.$emit('uploadFinished', newFile.response.data.filename);
          }
        }
      }
    },
    imageInputFilter: function imageInputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Filter non-image file
        if (!/\.(jpg|jpeg|png|webp)$/i.test(newFile.name)) {
          this.$toasted.show(this.$t('tracks.newTrack.imageType'), { type: 'error' });
          return prevent();
        }
      }
    }
  }

});

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getInstance; });
/* unused harmony export useAuth0 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Auth0Plugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__auth0_auth0_spa_js__ = __webpack_require__(892);







var DEFAULT_REDIRECT_CALLBACK = function DEFAULT_REDIRECT_CALLBACK() {
  return window.history.replaceState({}, document.title, window.location.pathname);
};

var instance = void 0;

var getInstance = function getInstance() {
  return instance;
};

var useAuth0 = function useAuth0(_ref) {
  var _ref$onRedirectCallba = _ref.onRedirectCallback,
      onRedirectCallback = _ref$onRedirectCallba === undefined ? DEFAULT_REDIRECT_CALLBACK : _ref$onRedirectCallba,
      _ref$redirectUri = _ref.redirectUri,
      redirectUri = _ref$redirectUri === undefined ? window.location.origin : _ref$redirectUri,
      options = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['onRedirectCallback', 'redirectUri']);

  if (instance) return instance;

  instance = new __WEBPACK_IMPORTED_MODULE_4_vue__["default"]({
    data: function data() {
      return {
        loading: true,
        isAuthenticated: false,
        user: {},
        auth0Client: null,
        popupOpen: false,
        error: null
      };
    },

    methods: {
      loginWithPopup: function loginWithPopup(options, config) {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _this.popupOpen = true;

                  _context.prev = 1;
                  _context.next = 4;
                  return _this.auth0Client.loginWithPopup(options, config);

                case 4:
                  _context.next = 6;
                  return _this.auth0Client.getUser();

                case 6:
                  _this.user = _context.sent;
                  _context.next = 9;
                  return _this.auth0Client.isAuthenticated();

                case 9:
                  _this.isAuthenticated = _context.sent;

                  _this.error = null;
                  _context.next = 17;
                  break;

                case 13:
                  _context.prev = 13;
                  _context.t0 = _context['catch'](1);

                  console.error(_context.t0);
                  _this.error = _context.t0;

                case 17:
                  _context.prev = 17;

                  _this.popupOpen = false;
                  return _context.finish(17);

                case 20:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this, [[1, 13, 17, 20]]);
        }))();
      },
      handleRedirectCallback: function handleRedirectCallback() {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _this2.loading = true;
                  _context2.prev = 1;
                  _context2.next = 4;
                  return _this2.auth0Client.handleRedirectCallback();

                case 4:
                  _context2.next = 6;
                  return _this2.auth0Client.getUser();

                case 6:
                  _this2.user = _context2.sent;

                  _this2.isAuthenticated = true;
                  _this2.error = null;
                  _context2.next = 14;
                  break;

                case 11:
                  _context2.prev = 11;
                  _context2.t0 = _context2['catch'](1);

                  _this2.error = _context2.t0;

                case 14:
                  _context2.prev = 14;

                  _this2.loading = false;
                  return _context2.finish(14);

                case 17:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, _this2, [[1, 11, 14, 17]]);
        }))();
      },
      loginWithRedirect: function loginWithRedirect(o) {
        return this.auth0Client.loginWithRedirect(o);
      },
      getIdTokenClaims: function getIdTokenClaims(o) {
        return this.auth0Client.getIdTokenClaims(o);
      },
      getTokenSilently: function getTokenSilently(o) {
        return this.auth0Client.getTokenSilently(o);
      },
      getTokenWithPopup: function getTokenWithPopup(o) {
        return this.auth0Client.getTokenWithPopup(o);
      },
      logout: function logout(o) {
        return this.auth0Client.logout(o);
      }
    },
    created: function created() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var _ref2, appState;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_5__auth0_auth0_spa_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, options, {
                  client_id: options.clientId,
                  redirect_uri: redirectUri
                }));

              case 2:
                _this3.auth0Client = _context3.sent;
                _context3.prev = 3;

                if (!(window.location.search.includes('code=') && window.location.search.includes('state='))) {
                  _context3.next = 11;
                  break;
                }

                _context3.next = 7;
                return _this3.auth0Client.handleRedirectCallback();

              case 7:
                _ref2 = _context3.sent;
                appState = _ref2.appState;

                _this3.error = null;
                onRedirectCallback(appState);

              case 11:
                _context3.next = 16;
                break;

              case 13:
                _context3.prev = 13;
                _context3.t0 = _context3['catch'](3);

                _this3.error = _context3.t0;

              case 16:
                _context3.prev = 16;
                _context3.next = 19;
                return _this3.auth0Client.isAuthenticated();

              case 19:
                _this3.isAuthenticated = _context3.sent;
                _context3.next = 22;
                return _this3.auth0Client.getUser();

              case 22:
                _this3.user = _context3.sent;

                _this3.loading = false;
                return _context3.finish(16);

              case 25:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[3, 13, 16, 25]]);
      }))();
    }
  });

  return instance;
};


var Auth0Plugin = {
  install: function install(Vue, options) {
    Vue.prototype.$auth0 = useAuth0(options);
  }
};

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

var MODAL_WIDTH = 500;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'direct-link-modal',
  methods: {
    closeModal: function closeModal() {
      this.$modal.hide('direct-link');
    }
  },
  data: function data() {
    return {
      modalWidth: MODAL_WIDTH,
      forgotModal: false,
      color: '#808080',
      size: '20px'
    };
  },
  created: function created() {
    this.modalWidth = window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
  }
});

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fortawesome_vue_fontawesome__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__fortawesome_vue_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(11);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'provider-link',
  components: {
    FontAwesomeIcon: __WEBPACK_IMPORTED_MODULE_1__fortawesome_vue_fontawesome___default.a
  },
  data: function data() {
    return {
      hidden: false
    };
  },

  methods: {
    showHelpModal: function showHelpModal() {
      this.$modal.show('direct-link-modal');
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])('user', ['isLoggedIn', 'msisdn', 'provider']))
});

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_spinner_src_ClipLoader_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(11);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var MODAL_WIDTH = 1000;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'new-features-modal',
  components: { ClipLoader: __WEBPACK_IMPORTED_MODULE_1_vue_spinner_src_ClipLoader_vue__["a" /* default */] },
  data: function data() {
    return {
      modalWidth: MODAL_WIDTH,
      color: '#808080',
      size: '20px',
      newsResponse: null,
      msisdn: null
    };
  },
  created: function created() {
    this.modalWidth = window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
    this.msisdn = localStorage.getItem('msisdn');
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    Cerrar: function Cerrar() {
      this.$modal.hide('new-features-modal');
    },
    Enviar: function Enviar() {
      var data = {};
      if (!this.msisdn) {
        data = {
          'user_id': this.user.id,
          'feature_id': this.news[0].id,
          'type': this.news[0].type,
          'ln': this.language
        };
      } else {
        data = {
          'user_id': this.user.id,
          'feature_id': this.news[1].id,
          'type': this.news[1].type,
          'ln': this.language
        };
      }
      this.setNewFeatureSeen(data);
      this.Cerrar();
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('news', ['getNewsFeatures', 'setNewFeatureSeen'])),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])('news', ['news']), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])('translator', ['language']), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])('user', ['user']))
});

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_spinner_src_ClipLoader_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fortawesome_vue_fontawesome__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__fortawesome_vue_fontawesome__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var MODAL_WIDTH = 500;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'local-radio-modal',
  components: {
    FontAwesomeIcon: __WEBPACK_IMPORTED_MODULE_1__fortawesome_vue_fontawesome___default.a,
    ClipLoader: __WEBPACK_IMPORTED_MODULE_0_vue_spinner_src_ClipLoader_vue__["a" /* default */]
  },
  data: function data() {
    return {
      modalWidth: MODAL_WIDTH,
      color: '#808080',
      size: '30px',
      radio: {
        link: '',
        name: '',
        picture: '',
        category: '',
        dial: ''
      }
    };
  },

  computed: {},
  created: function created() {
    this.modalWidth = window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
  },

  methods: {
    closeModal: function closeModal() {
      this.$modal.hide('local-radio-modal');
    },
    beforeOpen: function beforeOpen(event) {
      if (event.params) {
        this.radio.link = event.params.radioUrl;
        this.radio.name = event.params.radioName;
        this.radio.picture = event.params.radioPicture;
        this.radio.category = event.params.radioCategory;
        this.radio.dial = event.params.radioDial;
      }
    }
  }
});

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlaylistProfile_vue__ = __webpack_require__(410);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13af75a7_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlaylistProfile_vue__ = __webpack_require__(911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(908)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-13af75a7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlaylistProfile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13af75a7_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlaylistProfile_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13af75a7_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlaylistProfile_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_on_click_outside__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_on_click_outside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_on_click_outside__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__consts__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_spinner_src_ClipLoader_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_PlaylistProfile_PlaylistTracks_vue__ = __webpack_require__(411);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'playlist-profile',
  components: {
    FontAwesomeIcon: __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome___default.a,
    ClipLoader: __WEBPACK_IMPORTED_MODULE_5_vue_spinner_src_ClipLoader_vue__["a" /* default */],
    PlayliststTracks: __WEBPACK_IMPORTED_MODULE_6__components_PlaylistProfile_PlaylistTracks_vue__["a" /* default */]
  },
  data: function data() {
    return {
      color: '#808080',
      size: '20px',
      aId: null,
      followedArtistsArray: null,
      isFollowed: false,
      liking: false
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_1_vue_on_click_outside__["mixin"]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    picture: function picture() {
      return '/static/assets/Img_generico_principal3.jpg';
    },
    playlistPicture: function playlistPicture() {
      if (this.playlist.picture) {
        return __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].MEDIA_BASE_URL + this.playlist.picture;
      } else {
        return __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].BASE_HOST + '/static/assets/Img_comodines_Beathey_Playlist.jpg';
      }
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('player', ['currentTrack']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('playlist', ['playlist', 'playlistLiked']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('user', ['isLoggedIn', 'isSubscribed']), {
    loadingArtist: function loadingArtist() {
      return this.$loading.isLoading('artist getArtist');
    },
    loadingVote: function loadingVote() {
      return this.$loading.isLoading('artist setVote');
    },
    hasTracks: function hasTracks() {
      return this.artistTracks.length > 0;
    },
    voteDisabled: function voteDisabled() {
      return this.isSubscribed && this.myVotes === null;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('user', ['setFollowArtist', 'getMyFollowedArtists']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('playlist', ['closePlaylist', 'delete', 'togglePlaylistLike']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapMutations */])('user', ['setFollowing']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('player', ['setPlaylist', 'setPlaying', 'changeTrack']), {
    playTrack: function playTrack(track) {
      if (this.currentTrack !== track) {
        this.$emit('play');
        this.changeTrack(track);
      } else {
        this.setPlaying(true);
      }
    },
    setPlayer: function setPlayer(track, playlist) {
      this.setPlaylist(playlist);
      this.playTrack(track);
    },
    close: function close() {
      this.closePlaylist();
      history.back();
      this.tab = 'artist-tracks';
    },
    deletePlaylist: function deletePlaylist() {
      var _this = this;

      this.$modal.show('dialog', {
        title: this.$t('playlists.delete.title'),
        text: this.$t('playlists.delete.confirm'),
        buttons: [{
          title: this.$t('app.yes'),
          handler: function handler() {
            _this.delete(_this.playlist.id).then(function () {
              _this.$toasted.show(_this.$t('playlists.delete.success'), { type: 'success' });
              _this.close();
            }).catch(function (e) {
              _this.$toasted.show(_this.error.message, { type: 'error' });
            });
            _this.$modal.hide('dialog');
          }
        }, {
          title: this.$t('app.no'),
          default: true,
          handler: function handler() {
            _this.$modal.hide('dialog');
          }
        }]
      });
    },
    editPlaylist: function editPlaylist() {
      this.playlist.picture = this.playlist.picture ? this.playlist.picture : '/static/assets/Img_comodines_Beathey_Playlist.jpg';
      this.$modal.show('new-playlist-modal', { playlist: this.playlist });
    },
    sharePlaylist: function sharePlaylist() {
      this.$modal.show('share-modal', {
        link: __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].BASE_HOST + '/services/share/playlist/' + this.playlist.id,
        title: this.playlist.title,
        // playlist de artistname
        description: '',
        playlist: this.playlist
      });
    },
    likePlaylist: function likePlaylist() {
      var _this2 = this;

      this.togglePlaylistLike(this.playlist.id).then(function () {
        _this2.$root.$emit('togglePlaylistLike', _this2.playlist.id);
        _this2.liking = _this2.playlistLiked;
      }).catch(function (e) {
        _this2.$toasted.show(_this2.error.message, { type: 'error' });
      });
    }
  }),
  beforeUpdate: function beforeUpdate() {
    this.liking = this.playlist.liked;
  }
});

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlaylistTracks_vue__ = __webpack_require__(412);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f3bf99b_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlaylistTracks_vue__ = __webpack_require__(910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(909)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0f3bf99b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlaylistTracks_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f3bf99b_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlaylistTracks_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f3bf99b_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlaylistTracks_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_tracks_TrackData__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_tracks_TrackImage__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_spinner_src_PulseLoader_vue__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_tracks_TrackOptionsButton_vue__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(11);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'playlist-tracks',
  components: {
    TrackData: __WEBPACK_IMPORTED_MODULE_1__components_tracks_TrackData__["a" /* default */],
    TrackImage: __WEBPACK_IMPORTED_MODULE_2__components_tracks_TrackImage__["a" /* default */],
    PulseLoader: __WEBPACK_IMPORTED_MODULE_3_vue_spinner_src_PulseLoader_vue__["a" /* default */],
    TrackOptionsButton: __WEBPACK_IMPORTED_MODULE_4__components_tracks_TrackOptionsButton_vue__["a" /* default */]
  },
  data: function data() {
    return {
      color: '#808080',
      size: '10px',
      hasTracks: false
    };
  },

  props: {
    section: {
      default: ''
    }
  },
  beforeUpdate: function beforeUpdate() {
    var _this = this;

    if (this.tracks && this.tracks !== undefined) {
      if (this.tracks.length === 0 && this.playlist.id !== undefined) {
        this.getPlaylist(this.playlist.id).catch(function (e) {
          _this.$toasted.show(_this.error.message, { type: 'error' });
        });
      }
    }
    this.playlistHasTracks();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])('player', ['currentTrack']), Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])('playlist', ['playlist']), {
    loading: function loading() {
      // return this.$loading.isLoading('artist getArtistTracks')
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('playlist', ['getPlaylist']), Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('player', ['setPlaying', 'setPlaylist', 'changeTrack']), {
    playlistHasTracks: function playlistHasTracks() {
      if (this.playlist && this.playlist !== undefined) {
        if (this.playlist.tracks) {
          this.hasTracks = this.playlist.tracks.length > 0;
        } else {
          this.hasTracks = false;
        }
      }
      return this.hasTracks;
    }
  })
});

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_spinner_src_ClipLoader_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(11);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var MODAL_WIDTH = 600;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'set-email-modal',
  components: {
    FontAwesomeIcon: __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome___default.a,
    ClipLoader: __WEBPACK_IMPORTED_MODULE_1_vue_spinner_src_ClipLoader_vue__["a" /* default */]
  },
  data: function data() {
    return {
      modalWidth: MODAL_WIDTH,
      color: '#808080',
      size: '30px',
      paymentUrl: '',
      emailNeeded: '',
      email: '',
      currency: 'ARS',
      disabled: false,
      tab: null,
      providerCountry: null,
      voucher: null,
      ppPlan: null,
      suggestedValues: null,
      index: null,
      valueARS: 0,
      valueUSD: 0,
      message: '',
      refCode: null,
      gateway: null,
      emailError: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    isLoadingLink: function isLoadingLink() {
      return this.$loading.isLoading('user getSubscriptionLink');
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('user', ['user']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('pricing', ['pricing'])),
  created: function created() {
    var _this = this;

    this.providerCountry = localStorage.getItem('providerCountry');
    this.getPPplans().then(function (plans) {
      if (plans) {
        _this.ppPlan = plans[0];
      }
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('user', ['getSubscriptionLink']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('home', ['getPPplans']), {
    closeModal: function closeModal() {
      this.valueARS = 0;
      this.valueUSD = 0;
      localStorage.removeItem('userFromLandingMK');
      this.$modal.hide('set-email-modal');
    },
    beforeOpen: function beforeOpen(event) {
      this.disabled = false;
      this.emailError = '';
      this.emailNeeded = this.user.email;
      this.paymentUrl = event.params.paymentUrl;
      this.voucher = event.params.voucher;
      this.refCode = event.params.refCode;
      this.gateway = event.params.gateway;
      this.valueARS = 0;
      this.valueUSD = 0;
    },
    getSubsLink: function getSubsLink(gateway) {
      var _this2 = this;

      this.disabled = true;
      this.getSubscriptionLink({ gateway: gateway, paymentUrl: this.paymentUrl, voucher: this.voucher, refCode: this.refCode, emailNeeded: this.emailNeeded }).then(function (nextUrl) {
        window.location.href = nextUrl;
      }).catch(function (e) {
        if (e.message === 'Ya se encuentra una suscripción activa para este usuario') {
          localStorage.removeItem('userFromLandingMK');
          _this2.$modal.hide('set-email-modal');
          _this2.disabled = false;
          _this2.$router.push({ path: '/home' });
        }
        if (e.message === 'Invalid Voucher Code') {
          _this2.$modal.hide('set-email-modal');
        }
        _this2.$toasted.show(e.message, { type: 'error' });
        _this2.disabled = false;
      });
    },
    validateEmail: function validateEmail() {
      var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (!emailRegex.test(this.emailNeeded)) {
        this.emailError = 'Correo electrónico no válido';
        this.disabled = true;
      } else {
        this.emailError = '';
        this.disabled = false;
      }
    }
  })
});

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_spinner_src_ClipLoader_vue__ = __webpack_require__(25);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var MODAL_WIDTH = 600;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'set-user-type-modal',
  components: {
    ClipLoader: __WEBPACK_IMPORTED_MODULE_2_vue_spinner_src_ClipLoader_vue__["a" /* default */]
  },
  data: function data() {
    return {
      modalWidth: MODAL_WIDTH,
      color: '#808080',
      size: '30px'
    };
  },

  computed: {
    isLoadingLink: function isLoadingLink() {
      return this.$loading.isLoading('user editUserType');
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('user', ['editUserType']), {
    setUserType: function setUserType(type) {
      var _this = this;

      this.$modal.hide('set-user-type-modal');
      if (parseInt(type) === 1) {
        this.$modal.show('set-name-artist-modal');
      } else {
        this.editUserType({ userType: type }).catch(function (e) {
          _this.$toasted.show(e.message, { type: 'error' });
        });
        location.reload();
      }
    }
  })
});

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_spinner_src_ClipLoader_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(11);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var MODAL_WIDTH = 600;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'set-name-artist-modal',
  components: {
    FontAwesomeIcon: __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome___default.a,
    ClipLoader: __WEBPACK_IMPORTED_MODULE_1_vue_spinner_src_ClipLoader_vue__["a" /* default */]
  },
  data: function data() {
    return {
      modalWidth: MODAL_WIDTH,
      color: '#808080',
      size: '30px',
      nameError: '',
      nameNeeded: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    isLoadingLink: function isLoadingLink() {
      return this.$loading.isLoading('artist setArtisticName');
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('user', ['user'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('artist', ['setArtisticName']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('user', ['editUserType']), {
    beforeOpen: function beforeOpen(event) {
      this.disabled = false;
      this.nameError = '';
      this.nameNeeded = '';
    },
    sendNameArtist: function sendNameArtist() {
      var _this = this;

      this.disabled = true;
      this.editUserType({ userType: 1 }).then(function () {
        _this.setArtisticName({ name: _this.nameNeeded, user_id: _this.user.id, text: '', phrase: '' }).then(function () {
          location.reload();
        }).catch(function (e) {
          _this.$toasted.show(e.message, { type: 'error' });
          _this.disabled = false;
        });
      }).catch(function (e) {
        _this.$toasted.show(e.message, { type: 'error' });
        _this.disabled = false;
      });
      this.disabled = false;
    },
    validateName: function validateName() {
      var nameRegex = /^(?=.*[a-zA-Z0-9])\s*([a-zA-Z0-9\s]+)\s*$/g;

      if (!nameRegex.test(this.nameNeeded)) {
        this.nameError = 'Nombre vacío';
        this.disabled = true;
      } else {
        this.nameError = '';
        this.disabled = false;
      }
    }
  })
});

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_spinner_src_ClipLoader_vue__ = __webpack_require__(25);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var MODAL_WIDTH = 350;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'login-unauthorized-user',
  components: {
    ClipLoader: __WEBPACK_IMPORTED_MODULE_2_vue_spinner_src_ClipLoader_vue__["a" /* default */]
  },
  data: function data() {
    return {
      modalWidth: MODAL_WIDTH,
      color: '#808080',
      size: '30px',
      disabled: false,
      isFirstEnter: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('player', ['isShareTrack', 'isUnauthorized'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('player', ['setIsShareTrack', 'setPlaying', 'setIsUnauthorized']), {
    beforeOpen: function beforeOpen(event) {
      this.disabled = false;
      if (!this.isFirstEnter) this.setPlaying(false);
      if (!this.isUnauthorized) this.setIsUnauthorized(true);
    },
    goToLogin: function goToLogin(goToLoginFlag) {
      if (goToLoginFlag) {
        this.disabled = true;
        if (this.isShareTrack) {
          localStorage.removeItem('shareTrackId');
          this.setIsShareTrack(false);
        }
        if (this.isUnauthorized) this.setIsUnauthorized(false);
        this.$modal.hide('login-unauthorized-user');
        this.$auth0.loginWithRedirect();
      } else {
        if (!this.isFirstEnter) this.isFirstEnter = true;
        this.$modal.hide('login-unauthorized-user');
      }
    }
  })
});

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ckeditor_ckeditor5_build_classic__ = __webpack_require__(925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ckeditor_ckeditor5_build_classic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ckeditor_ckeditor5_build_classic__);

//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'editor-ck',
  props: {
    placeholder: String,
    credits: String,
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '500px'
    }
  },
  data: function data() {
    return {
      content: '',
      backgroundColor: '#333',
      textColor: '#ddd',
      editor: __WEBPACK_IMPORTED_MODULE_1__ckeditor_ckeditor5_build_classic___default.a,
      editorConfig: {
        theme: 'lark',
        placeholder: this.placeholder,
        extraPlugins: [this.spacebarPlugin],
        toolbar: {
          items: ['heading', '|', 'bold', 'italic', '|', 'bulletedList', 'numberedList', '|', 'link', '|', 'undo', 'redo'],
          shouldNotGroupWhenFull: true
        }
      }
    };
  },
  mounted: function mounted() {
    this.editorConfig.placeholder = this.placeholder;
    this.content = this.credits;
  },

  methods: {
    focusEditor: function focusEditor() {
      this.$refs.ckeditor.editorInstance.editing.view.focus();
    },
    onEditorInput: function onEditorInput(event) {
      this.$emit('content-change', event);
      if (this.content !== '') this.editorConfig.placeholder = '';
    },
    spacebarPlugin: function spacebarPlugin(editor) {
      editor.keystrokes.set('space', function (data, cancel) {
        console.log('Funciono?', editor.model.document.selection.focus.stickiness);
        if (editor.model.document.selection.focus.stickiness === 'toNone') {
          editor.model.change(function (writer) {
            writer.insertText(' ', editor.model.document.selection.getFirstPosition());
          });
        } else {
          editor.model.change(function (writer) {
            var selectedRanges = editor.model.document.selection.getFirstRange();
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(selectedRanges.getItems()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var item = _step.value;

                writer.remove(item);
                writer.insertText(' ', editor.model.document.selection.getFirstPosition());
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }
          });
        }
        return false;
      });
    }
  }
});

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'terms-es'
});

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'terms-subs-es'
});

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'terms-en'
});

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'terms-subs-en'
});

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'terms-subs-pt'
});

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VinylContestHome_vue__ = __webpack_require__(945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Recommended_vue__ = __webpack_require__(954);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FeaturedPlaylist_vue__ = __webpack_require__(959);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LatestNews_vue__ = __webpack_require__(965);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Banner_vue__ = __webpack_require__(971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__HomeFooter_vue__ = __webpack_require__(106);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home-list',
  components: {
    VinylContestHome: __WEBPACK_IMPORTED_MODULE_2__VinylContestHome_vue__["a" /* default */],
    Recommended: __WEBPACK_IMPORTED_MODULE_3__Recommended_vue__["a" /* default */],
    LatestNews: __WEBPACK_IMPORTED_MODULE_5__LatestNews_vue__["a" /* default */],
    FeaturedPlaylist: __WEBPACK_IMPORTED_MODULE_4__FeaturedPlaylist_vue__["a" /* default */],
    Banner: __WEBPACK_IMPORTED_MODULE_6__Banner_vue__["a" /* default */],
    HomeFooter: __WEBPACK_IMPORTED_MODULE_7__HomeFooter_vue__["a" /* default */]
  },
  created: function created() {
    this.providerLogin();
    if (this.$route.query.playlist_id) {
      this.$router.push({ name: 'playlist', params: { id: this.$route.query.playlist_id } });
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('user', ['loginByMsisdn']), {
    providerLogin: function providerLogin() {
      /*
      if (this.$route.query.xmsisdn) {
        this.loginByMsisdn({msisdn: this.$route.query.xmsisdn, provider: 'movistar', enc: true}).then((e) => {
        }).catch(() => {
        })
      }
      */
    }
  })
});

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_charts_VinylContestPodium_vue__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_spinner_src_ClipLoader_vue__ = __webpack_require__(25);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vinyl-contest-home',
  components: {
    FontAwesomeIcon: __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome___default.a,
    VinylContestPodium: __WEBPACK_IMPORTED_MODULE_3__components_charts_VinylContestPodium_vue__["a" /* default */],
    ClipLoader: __WEBPACK_IMPORTED_MODULE_4_vue_spinner_src_ClipLoader_vue__["a" /* default */]
  },
  data: function data() {
    return {
      color: '#808080',
      size: '30px'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('artist', ['vinylContest', 'vinylContestInfo', 'error']), {
    loading: function loading() {
      return this.$loading.isLoading('artist getVinylContest');
    }
  }),
  created: function created() {
    var _this = this;

    this.getVinylContest().catch(function (e) {
      _this.$toasted.show(_this.error.message, { type: 'error' });
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('artist', ['getVinylContest']))
});

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VinylContestPodium_vue__ = __webpack_require__(426);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67dc7329_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VinylContestPodium_vue__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(947)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-67dc7329"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VinylContestPodium_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67dc7329_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VinylContestPodium_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67dc7329_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VinylContestPodium_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_charts_ArtistData__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_charts_CircleProgress__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__consts__ = __webpack_require__(21);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vinyl-contest-podium',
  props: {
    artist: {
      required: true
    },
    index: {
      required: true
    },
    inHome: {
      default: false
    }
  },
  components: {
    ArtistData: __WEBPACK_IMPORTED_MODULE_0__components_charts_ArtistData__["a" /* default */],
    CircleProgress: __WEBPACK_IMPORTED_MODULE_1__components_charts_CircleProgress__["a" /* default */]
  },
  computed: {
    picture: function picture() {
      return __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].MEDIA_BASE_URL + this.artist.path + this.artist.picture;
    }
  }
});

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArtistData_vue__ = __webpack_require__(428);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea886f14_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArtistData_vue__ = __webpack_require__(949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(948)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ea886f14"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArtistData_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea886f14_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArtistData_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea886f14_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArtistData_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fortawesome_vue_fontawesome__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__fortawesome_vue_fontawesome__);
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'artist-data',
  props: {
    artist: {
      required: true
    },
    isFirstArtist: {
      default: false
    },
    isPodium: {
      default: false
    },
    inHome: {
      default: false
    }
  },
  components: {
    FontAwesomeIcon: __WEBPACK_IMPORTED_MODULE_0__fortawesome_vue_fontawesome___default.a
  }
});

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_circle_progress__ = __webpack_require__(950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_circle_progress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue2_circle_progress__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    VueCircle: __WEBPACK_IMPORTED_MODULE_0_vue2_circle_progress___default.a
  },
  props: {
    percent: {
      required: true
    },
    size: {
      default: 75
    },
    emptyFill: {
      default: '#aaa'
    },
    fill: {
      default: function _default() {
        return { gradient: ['#E6007E'] };
      }
    }
  },
  computed: {
    value: function value() {
      return this.percent.toFixed(2);
    }
  },
  watch: {
    percent: function percent(newVal) {
      this.$refs.circle.updateProgress(newVal);
    }
  }
});

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_spinner_src_ClipLoader_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_tracks_TrackCard_vue__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(11);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'recommended',
  data: function data() {
    return {
      color: '#808080',
      size: '30px'
    };
  },

  components: {
    ClipLoader: __WEBPACK_IMPORTED_MODULE_1_vue_spinner_src_ClipLoader_vue__["a" /* default */],
    TrackCard: __WEBPACK_IMPORTED_MODULE_2__components_tracks_TrackCard_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('track', ['promotion']), {
    loading: function loading() {
      return this.$loading.isLoading('track getPromotion');
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('player', ['changeTrack', 'setPlaylist', 'setPlaying']), {
    playTrack: function playTrack(track) {
      if (this.currentTrack !== track) {
        this.changeTrack(track);
      } else {
        this.setPlaying(true);
      }
    }
  })
});

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrackCard_vue__ = __webpack_require__(432);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a3686de_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrackCard_vue__ = __webpack_require__(957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(956)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1a3686de"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrackCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a3686de_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrackCard_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a3686de_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrackCard_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TrackImage__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TrackData__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_tracks_TrackOptionsButton_vue__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fortawesome_vue_fontawesome__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__fortawesome_vue_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__consts__ = __webpack_require__(21);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'track-card',
  props: {
    track: {
      required: true
    },
    inHome: {
      default: false
    },
    profileTracks: {
      default: false
    }
  },
  data: function data() {
    return {
      trackTime: null
    };
  },

  components: {
    TrackImage: __WEBPACK_IMPORTED_MODULE_2__TrackImage__["a" /* default */],
    TrackData: __WEBPACK_IMPORTED_MODULE_3__TrackData__["a" /* default */],
    TrackOptionsButton: __WEBPACK_IMPORTED_MODULE_4__components_tracks_TrackOptionsButton_vue__["a" /* default */],
    FontAwesomeIcon: __WEBPACK_IMPORTED_MODULE_5__fortawesome_vue_fontawesome___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('player', ['currentTrack', 'isPlaying']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('track', ['loading']), {
    picture: function picture() {
      // return consts.MEDIA_BASE_URL + ((this.track.path) ? this.track.path : '') + this.track.picture
      var trackPicture = '';
      if (!/\/uploads\/tracks\//.test(this.track.picture)) {
        trackPicture = '/uploads/tracks/' + this.track.picture;
      } else {
        trackPicture = this.track.picture;
      }
      return __WEBPACK_IMPORTED_MODULE_6__consts__["a" /* default */].MEDIA_BASE_URL + trackPicture;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('player', ['setPlaying', 'changeTrack']), {
    playTrack: function playTrack() {
      this.$emit('play');
    },
    trackTimeToMin: function trackTimeToMin() {
      var seg = this.track.seconds;
      var min = 0;
      this.trackTime = 0;
      for (var i = 0; i < 60; i++) {
        if (seg >= 60) {
          min++;
          seg -= 60;
        } else if (seg < 60) {
          if (seg <= 9) {
            this.trackTime = min + ':0' + seg;
            return this.trackTime;
          } else {
            this.trackTime = min + ':' + seg;
            return this.trackTime;
          }
        }
      }
    }
  }),
  mounted: function mounted() {
    this.trackTimeToMin();
  }
});

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__consts__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_spinner_src_ClipLoader_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fortawesome_vue_fontawesome__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__fortawesome_vue_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__HomeTrackCard_vue__ = __webpack_require__(961);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'featured-playlist',
  data: function data() {
    return {
      featuredPlaylist: {},
      featuredPlaylistImg: null,
      color: '#808080',
      size: '30px'
    };
  },

  components: {
    FontAwesomeIcon: __WEBPACK_IMPORTED_MODULE_4__fortawesome_vue_fontawesome___default.a,
    ClipLoader: __WEBPACK_IMPORTED_MODULE_2_vue_spinner_src_ClipLoader_vue__["a" /* default */],
    HomeTrackCard: __WEBPACK_IMPORTED_MODULE_5__HomeTrackCard_vue__["a" /* default */]
  },
  created: function created() {
    var _this = this;

    this.getFeaturedPlaylist().then(function (data) {
      _this.featuredPlaylist = data;
      _this.featuredPlaylistImg = __WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].MEDIA_BASE_URL + _this.featuredPlaylist.image;
    }).catch(function (e) {
      _this.$toasted.show(e, { type: 'error' });
    });
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('player', ['isPlaying']), {
    loading: function loading() {
      return this.$loading.isLoading('playlist getFeaturedPlaylist');
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('player', ['setPlaylist', 'playFirstTrack', 'changeTrack']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('playlist', ['getFeaturedPlaylist']), {
    setFeaturedPlaylist: function setFeaturedPlaylist() {
      if (this.featuredPlaylist.tracks) {
        this.setPlaylist(this.featuredPlaylist.tracks);
      }
    },
    playTrackHandler: function playTrackHandler(event) {
      this.setFeaturedPlaylist();
      this.changeTrack(event);
    }
  })
});

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fortawesome_vue_fontawesome__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__fortawesome_vue_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__consts__ = __webpack_require__(21);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home-track-card',
  props: {
    track: {
      required: true
    }
  },
  components: { FontAwesomeIcon: __WEBPACK_IMPORTED_MODULE_0__fortawesome_vue_fontawesome___default.a },
  computed: {
    picture: function picture() {
      if (this.track.picture) {
        if (!/\/uploads\/tracks\//.test(this.track.picture)) {
          return __WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].MEDIA_BASE_URL + '/uploads/tracks/' + this.track.picture;
        } else {
          return __WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].MEDIA_BASE_URL + this.track.picture;
        }
      } else {
        return '/static/assets/track.jpg';
      }
    }
  },
  methods: {
    playTrack: function playTrack() {
      this.$emit('playTrack', this.track);
    }
  }
});

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_spinner_src_ClipLoader_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fortawesome_vue_fontawesome__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__fortawesome_vue_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__consts__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__News_vue__ = __webpack_require__(967);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'latest-news',
  data: function data() {
    return {
      news: [],
      loading: true,
      latestNewsImg: String,
      latestNewsLoaded: false,
      selectedNews: {},
      color: '#808080',
      size: '30px'
    };
  },

  components: {
    FontAwesomeIcon: __WEBPACK_IMPORTED_MODULE_1__fortawesome_vue_fontawesome___default.a,
    ClipLoader: __WEBPACK_IMPORTED_MODULE_0_vue_spinner_src_ClipLoader_vue__["a" /* default */],
    News: __WEBPACK_IMPORTED_MODULE_3__News_vue__["a" /* default */]
  },
  created: function created() {
    var _this = this;

    this.getNews().then(function (response) {
      _this.loading = false;
      _this.news = response.body.data;
      _this.selectedNews = response.body.data[0];
      _this.latestNewsLoaded = true;
    });
  },

  methods: {
    getNews: function getNews() {
      return this.$http.get(__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].API_BASE_URL + '/news/getHome');
    },
    picture: function picture(news) {
      return __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].MEDIA_BASE_URL + news.path + news.image;
    },
    selectNews: function selectNews(index) {
      this.$refs.carousel.goToPage(index);
    },
    selected: function selected(index) {
      return this.$refs.carousel.currentPage === index;
    }
  }
});

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__consts__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fortawesome_vue_fontawesome__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__fortawesome_vue_fontawesome__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'news',
  props: {
    news: {
      required: true
    }
  },
  components: {
    FontAwesomeIcon: __WEBPACK_IMPORTED_MODULE_1__fortawesome_vue_fontawesome___default.a
  },
  computed: {
    picture: function picture() {
      return __WEBPACK_IMPORTED_MODULE_0__consts__["a" /* default */].MEDIA_BASE_URL + this.news.path + this.news.image;
    }
  },
  methods: {
    open: function open() {
      if (this.news) {
        this.$router.push({ name: 'news', params: { id: this.news.id } });
      }
    }
  }
});

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_spinner_src_ClipLoader_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__consts__ = __webpack_require__(21);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'banner',
  data: function data() {
    return {
      banners: [],
      color: '#808080',
      size: '30px'
    };
  },

  components: {
    ClipLoader: __WEBPACK_IMPORTED_MODULE_1_vue_spinner_src_ClipLoader_vue__["a" /* default */]
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('home', ['getBanners']), {
    picture: function picture(banner) {
      return __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].MEDIA_BASE_URL + banner.image;
    }
  }),
  created: function created() {
    var _this = this;

    this.getBanners().then(function (res) {
      _this.banners = res;
    }).catch(function (e) {
      _this.$toasted.show(e, { type: 'error' });
    });
  },

  computed: {
    loading: function loading() {
      return this.$loading.isLoading('home getBanners');
    }
  }
});

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home-footer',
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('translator', ['setLanguage'])),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('translator', ['language', 'isCurrentLanguage']))

});

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__consts__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_spinner_src_ClipLoader_vue__ = __webpack_require__(25);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'news',
  components: { ClipLoader: __WEBPACK_IMPORTED_MODULE_1_vue_spinner_src_ClipLoader_vue__["a" /* default */] },
  data: function data() {
    return {
      news: Object,
      color: '#808080',
      size: '100px',
      loading: true,
      img1URL: String,
      img2URL: String
    };
  },
  created: function created() {
    var _this = this;

    this.$http.get(__WEBPACK_IMPORTED_MODULE_0__consts__["a" /* default */].API_BASE_URL + '/news/get/' + this.$route.params.id).then(function (res) {
      _this.news = res.body.data;
      _this.img1URL = __WEBPACK_IMPORTED_MODULE_0__consts__["a" /* default */].MEDIA_BASE_URL + _this.news.path + _this.news.image;
      _this.img2URL = __WEBPACK_IMPORTED_MODULE_0__consts__["a" /* default */].MEDIA_BASE_URL + _this.news.path + _this.news.image1;
      _this.loading = false;
    });
  }
});

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FaqsEs_vue__ = __webpack_require__(982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FaqsEn_vue__ = __webpack_require__(985);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fortawesome_vue_fontawesome__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__fortawesome_vue_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(11);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'help',
  data: function data() {
    return {
      name: '',
      email: '',
      message: '',
      provider: {
        name: null,
        msj: null,
        number: null,
        email: null
      }
    };
  },

  components: {
    FontAwesomeIcon: __WEBPACK_IMPORTED_MODULE_3__fortawesome_vue_fontawesome___default.a,
    FaqsEs: __WEBPACK_IMPORTED_MODULE_1__FaqsEs_vue__["a" /* default */],
    FaqsEn: __WEBPACK_IMPORTED_MODULE_2__FaqsEn_vue__["a" /* default */]
  },
  created: function created() {
    this.provider.name = localStorage.getItem('provider');
    this.provider.msj = localStorage.getItem('provider_msj');
    this.provider.number = localStorage.getItem('provider_n');
    this.provider.email = localStorage.getItem('provider_email');
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])('user', ['error']), {
    faqs: function faqs() {
      return 'faqs-' + this.$i18n.locale;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('user', ['contact']), {
    sendEmail: function sendEmail() {
      var _this = this;

      if (!this.$v.$invalid) {
        this.contact({ email: this.email, name: this.name, message: this.message, provider: this.provider.email }).then(function () {
          _this.$toasted.show(_this.$t('help.contactForm.success'), { type: 'success' });
        }).catch(function (e) {
          _this.$toasted.show(_this.error.message, { type: 'error' });
        });
      } else {
        this.$v.$touch();
      }
    }
  }),
  validations: {
    email: {
      email: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["email"],
      required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"]
    },
    name: {
      required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"]
    },
    message: {
      required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"]
    }
  }
});

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'faqs-es',
  data: function data() {
    return {
      questions: ['¿Los masterings se encargan ustedes?', '¿La música debe ser exclusiva para Beathey?', '¿Qué hace Beathey? ¿Qué lo diferencia?', 'Subiendo mi música a BeatHey, ¿Tengo mas oportunidades de ser parte de los eventos?', '¿Qué gano pagando una suscripción?', '¿Porque me suscribiría a Beathey teniendo otras plataformas?'],
      answers: ['No. los tracks deben subirlos masterizados ya que los usuarios que los compran, son artistas que usaran la musica en sus actuaciones.', 'La música que subes a BeatHey no tiene que ser exclusiva. Puede ser música editada con anterioridad. Tu eres responsable por el material que subes a BeatHey. Te recomendamos leer los TyC de BeatHey antes de subir música.', 'BeatHey es un Market network para artistas independientes. Puedes subir tu música directamente a BeatHey, sin intermediarios ni agregadoras, y obtendrás el 100% de las ganancias sobre tus ventas conservando el 100% de los derechos de la misma. También participarás del contest donde los cuatros artistas más votados del trimestre ganan un premio en efectivo y son editados en un disco digital. Este disco es gratuito para toda la comunidad.En BeatHey cada reproducción cuenta!! Pagamos por Streaming. Cuanto más te escuchen en BeatHey mas podrás monetizar tu trabajo. BeatHey, adicionalmente, edita su propia revista, produce eventos, edita discos, produce radio shows y fomenta la escena cultural independiente global.', 'En BeatHey tenemos como misión generar más y mejores oportunidades de monetización y exposición a los artistas independientes. Si eres parte de la comunidad BeatHey puedes ser parte de nuestros eventos, radio shows, Revistas, discos y demás acciones culturales que realizamos.', 'Pagando una suscripción a BeatHey contribuyes al crecimiento de la escena musical independiente y recibes diferentes beneficios; revistas gratuitas, discos digitales gratuitos y descuentos en shows son algunos de ellos.', ' BeatHey es una herramienta MÁS que SUMA y se acopla con las demás plataformas. La audiencia de BeatHey, 50 países, busca música que en otras plataformas es difícil de encontrar si no la buscas directamente. BeatHey brinda una oportunidad no sólo de monetización, sino también de formación y crecimiento conjunto.']
    };
  }
});

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'faqs-en',
  data: function data() {
    return {
      questions: ['Is the mastering done by yourself?', 'Should the music be exclusive to BeatHey?', 'What does BeatHey do? What makes it different?', 'If I\'m part of BeatHey, am I going to play at the events?', 'What do I gain by paying a subscription?', 'Why would I subscribe to BeatHey when I have other platforms?'],
      answers: ['No. The tracks should be uploaded mastered because the users who buy them are artists who will use the music in their performances', 'No. It can be music that has already been edited; as long as you have no problem with the label where it was edited. The artist is responsible for the material that is uploaded.', 'We are a music sales and streaming platform where 100% of the music profits and rights are for the artists. We also publish on vinyl every 3 to 4 months to the 4 most voted-on artists by the community. We pay these artists upon release, in turn, this album is given for free to all subscribers. We are also a digital label, publishing the best artists on our platform. We are also an event producer and booking agency. In turn, we promote all the members of our community in our networks and make them known. It is a subscription platform that today costs USD 8 per month. That money helps us edit albums and create electronic culture, and each album that comes out is yours, free for being a part of that culture. The first month is Free. There are already more than 250 subscribed artists and more than 900 uploaded tracks. We have released 5 vinyls and just released our label on all platforms around the world. We put on more than 60 events per year ("no envuentro la enie, ja") and we give space to more than 200 different artists.', 'If you are part of the community you can play at the events. We do a weekly cycle on Thursdays and also have two monthly dates at shamrock and bahrain. We give space to over 200 artists annually and pay them to play.', 'Let\'s see, there are several things. In principle, each vinyl that we release is yours for free, so you contribute to releasing records and creating electronic culture. Later, you can be edited on these vinyls if you are voted on by the community, and we would pay you for the edit. In turn, 100% of the profits from the sale of your music are yours and the rights to it are yours as well. We also talk about all the artists and their music in our networks. In turn, we do events in which the members of our platform play ( you can see everything we do in our networks or in my Face too), in turn you can also edit in our digital Label. Additionally, you will receive a magazine that we are about to launch in which we talk about the local scene and all its artists., among other things.', 'Because BeatHey is not only a platform for selling and streaming electronic music. BeatHey is an opportunity to support emerging artists and make them grow with their art. In addition, the contribution of each subscriber helps the production of vinyls and a magazine, which you receive free of charge for being subscribed to the platform. At BeatHey there are benefits for community members at events, a full agenda, and more.']
    };
  }
});

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'msisdn',
  data: function data() {
    this.modalLogin();
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('user', ['isLoggedIn', 'provider'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('user', ['loginByMsisdn']), {
    modalLogin: function modalLogin() {
      var _this = this;

      this.loginByMsisdn({ msisdn: this.$route.params.msisdn }).then(function (e) {
        if (_this.provider === 'bitel') {
          localStorage.setItem('providerCountry', 'PER');
        }
      }).catch(function () {});
    }
  })
});

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'autologin',
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('user', ['isLoggedIn'])),
  created: function created() {
    this.providerLogin();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('user', ['loginByMsisdn']), {
    providerLogin: function providerLogin() {
      var provider = this.$route.params.provider;

      if (provider === 'entel') {
        var providerCountry = this.$route.query.country ? this.$route.query.country : 'PER';
        localStorage.setItem('providerCountry', providerCountry);
        if (this.$route.query.msfw) {
          this.loginByMsisdn({ msisdn: this.$route.query.msfw, provider: provider, enc: true }).then(function (e) {}).catch(function () {});
        }
      }
    }
  })
});

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_spinner_src_ClipLoader_vue__ = __webpack_require__(25);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'waiting',
  data: function data() {
    return {
      loading: true,
      color: '#ffffff',
      size: '65px'
    };
  },

  components: {
    ClipLoader: __WEBPACK_IMPORTED_MODULE_2_vue_spinner_src_ClipLoader_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('user', ['isLoggedIn'])),
  created: function created() {
    this.providerLogin();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('user', ['loginByMsisdn', 'autologinRecurrentEntel']), {
    providerLogin: function providerLogin() {
      var provider = this.$route.params.provider;
      if (provider === 'entel') {
        var providerCountry = this.$route.query.country ? this.$route.query.country : 'PER';
        localStorage.setItem('providerCountry', providerCountry);
        if (this.$route.query.msfw) {
          var route = this.$router.resolve({ name: 'provider-tyc' });
          this.autologinRecurrentEntel({ iterations: 20, interval: 5, msisdn: this.$route.query.msfw, provider: provider, enc: true, route: route.href }).then(function (e) {}).catch(function () {});
        }
      }
    }
  })
});

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ProviderTyC',
  data: function data() {
    return {
      showText: false
    };
  },
  created: function created() {
    document.body.className = 'tyc';
  },

  methods: {
    activateShowText: function activateShowText() {
      this.showText = true;
      document.body.className = 'tyc Text';
    }
  }
});

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__consts__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_modals_provider_DirectLinkModal_vue__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_providerLink_ProviderLink_vue__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fortawesome_vue_fontawesome__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__fortawesome_vue_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_home_HomeFooter_vue__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Landing_LandingNavBar_vue__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__auth_index__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_modals_PaymentModal_vue__ = __webpack_require__(233);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'landing',
  components: {
    ProviderLink: __WEBPACK_IMPORTED_MODULE_4__components_providerLink_ProviderLink_vue__["a" /* default */],
    DirectLinkModal: __WEBPACK_IMPORTED_MODULE_3__components_modals_provider_DirectLinkModal_vue__["a" /* default */],
    FontAwesomeIcon: __WEBPACK_IMPORTED_MODULE_6__fortawesome_vue_fontawesome___default.a,
    HomeFooter: __WEBPACK_IMPORTED_MODULE_7__components_home_HomeFooter_vue__["a" /* default */],
    LandingNavBar: __WEBPACK_IMPORTED_MODULE_8__components_Landing_LandingNavBar_vue__["a" /* default */],
    PaymentModal: __WEBPACK_IMPORTED_MODULE_10__components_modals_PaymentModal_vue__["a" /* default */]
  },
  data: function data() {
    return {
      userFromLandingMK: false
    };
  },
  created: function created() {
    var _this = this;

    if (this.$route.query.referredCode) {
      localStorage.setItem('referredCode', this.$route.query.referredCode);
    }
    var provider = this.$route.query.provider;
    this.getPricing();
    this.userFromLandingMK = localStorage.getItem('userFromLandingMK');
    var shareTrackId = this.$route.query.track_id;
    if (shareTrackId) {
      localStorage.setItem('shareTrackId', shareTrackId);
      this.setIsShareTrack(true);
    }
    var sharePlayListId = this.$route.query.playlist_id;
    if (sharePlayListId) {
      localStorage.setItem('sharePlayListId', sharePlayListId);
    }
    var qrArtistId = this.$route.query.artist_id;
    if (qrArtistId) {
      localStorage.setItem('qrArtistId', qrArtistId);
    }
    this.providerLogin();
    if (provider === null || !provider) {
      if (this.userFromLandingMK === false || this.userFromLandingMK === null || !this.userFromLandingMK) {
        if (this.authToken || shareTrackId !== null && shareTrackId !== undefined) {
          if (shareTrackId !== null && shareTrackId !== undefined) {
            this.goToHome();
          } else {
            this.checkUser().then(function (i) {
              _this.goToHome();
            });
          }
        }
      } else {
        if (this.authToken) {
          this.checkUser().then(function (i) {
            _this.$router.push({ path: '/paymentsMk' });
          });
        }
      }
    }
    window.onpopstate = this.onpopstate;
  },
  beforeRHomeFooterouteUpdate: function beforeRHomeFooterouteUpdate(to, from, next) {
    var _this2 = this;

    var matched = false;
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(to.matched), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var matchedRoute = _step.value;

        if (matchedRoute.name === 'artist') {
          next(false);
          this.getArtist(to.params.id).catch(function (e) {
            _this2.$toasted.show(_this2.error.message, { type: 'error' });
          });
          this.getArtistTracks(to.params.id).catch(function (e) {
            _this2.$toasted.show(_this2.error.message, { type: 'error' });
          });
          this.getArtistPlaylists(to.params.id).catch(function (e) {
            _this2.$toasted.show(_this2.error.message, { type: 'error' });
          });
          this.openProfile();
          history.pushState({}, null, to.path);
          matched = true;
        }
      }
      // close sidebar if route change
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    if (!matched) {
      this.closeProfile();
      next();
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    // Open sidebar if artist route is requested
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(to.matched), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var matchedRoute = _step2.value;

        if (matchedRoute.name === 'artist') {
          next(function (vm) {
            vm.$store.dispatch('artist/getArtist', to.params.id).catch(function (e) {
              vm.$toasted.show(vm.getters['artist/error'].message, { type: 'error' });
            });
            vm.$store.dispatch('artist/getArtistTracks', to.params.id).catch(function (e) {
              vm.$toasted.show(vm.getters['artist/error'].message, { type: 'error' });
            });
            vm.$store.dispatch('artist/getArtistPlaylists', to.params.id).catch(function (e) {
              vm.$toasted.show(vm.getters['artist/error'].message, { type: 'error' });
            });
            if (vm.$store.getters['user/isLoggedIn']) {
              vm.$store.dispatch('user/getMyVotes').catch(function (e) {
                vm.$toasted.show(vm.getters['user/error'].message, { type: 'error' });
              });
            }
            vm.$store.dispatch('artist/openProfile');
          });
        }
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }

    if (typeof to.query.login !== 'undefined') {
      next(function (vm) {
        vm.$modal.show('login-modal');
      });
    } else if (typeof to.query.signup !== 'undefined') {
      next(function (vm) {
        vm.$modal.show('signup-modal');
      });
    } else if (typeof to.query.subscription !== 'undefined') {
      next(function (vm) {
        vm.$modal.show('subscription-modal');
      });
    } else if (typeof to.query.track_id !== 'undefined') {
      next(function (vm) {
        vm.$http.get(__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].API_BASE_URL + ('/tracks/get/' + to.query.track_id)).then(function (res) {
          var track = res.body.data[0];
          if (track.length) {
            // vm.$store.dispatch('player/setPlaylist', track)
            // vm.$store.dispatch('player/playFirstTrack')
          }
        });
      });
    } else {
      next();
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('user', ['checkUser', 'loginByMsisdn', 'loginAuth']), Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('artist', ['getArtist', 'getArtistTracks', 'getArtistPlaylists', 'openProfile', 'closeProfile']), Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('user', ['loginByMsisdn']), Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('pricing', ['getPricing']), Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('player', ['setIsShareTrack']), {
    providerLogin: function providerLogin() {
      if (this.$route.query.xmsisdn) {
        var provider = this.$route.query.provider ? this.$route.query.provider : 'movistar';
        var providerCountry = this.$route.query.country ? this.$route.query.country : 'ARG';
        localStorage.setItem('providerCountry', providerCountry);
        this.loginByMsisdn({ msisdn: this.$route.query.xmsisdn, provider: provider, country: providerCountry, enc: true }).then(function (e) {}).catch(function () {});
      }
    },
    onpopstate: function onpopstate(event) {
      // when the state is stored by `beforeRouteUpdate` event, the key is null
      if (this.isProfileOpen && event.state.key !== undefined) {
        this.closeProfile();
      }
    },
    goToHome: function goToHome() {
      var tId = localStorage.getItem('shareTrackId');
      var aId = localStorage.getItem('qrArtistId');
      var pId = localStorage.getItem('sharePlayListId');
      var rc = localStorage.getItem('referredCode');
      if (tId && tId !== null && tId !== undefined && tId !== '') {
        this.$router.push({ path: '/home?track_id=' + tId });
      }if (pId && pId !== null && pId !== undefined && pId !== '') {
        this.$router.push({ path: '/home?playlist_id=' + pId });
      } else if (aId && aId !== null && aId !== undefined && aId !== '') {
        this.$router.push({ path: '/artists/' + aId + '/tracks' });
      } else if (rc) {
        this.$router.push({ path: '/home?referredCode=' + rc });
      } else {
        this.$router.push({ path: '/home' });
      }
    },
    scrollToTop: function scrollToTop() {
      window.scrollTo(0, 0);
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])('artist', ['isProfileOpen', 'error']), Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])('user', ['authToken', 'msisdn', 'provider', 'user'])),
  mounted: function mounted() {
    var _this3 = this;

    var authService = Object(__WEBPACK_IMPORTED_MODULE_9__auth_index__["c" /* getInstance */])();
    var that = this;
    authService.$watch('loading', function (loading) {
      if (loading === false) {
        return test(authService.user);
      }
    });
    if (this.authToken || this.user) {
      if (that.userFromLandingMK === false || that.userFromLandingMK === null || !that.userFromLandingMK) {
        this.checkUser().then(function (i) {
          _this3.goToHome();
        });
      } else {
        that.$router.push({ path: '/paymentsMk' });
      }
    }
    var test = function test(user) {
      if (user !== undefined) {
        that.loginAuth(user).then(function () {
          if (that.userFromLandingMK === false || that.userFromLandingMK === null || !that.userFromLandingMK) {
            that.goToHome();
          } else {
            that.$router.push({ path: '/paymentsMk' });
          }
        });
      }
    };
    if (this.msisdn) {
      this.loginByMsisdn({ msisdn: this.msisdn, provider: this.provider, enc: true, isValidation: true });
    }
    this.scrollToTop();
  }
});

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_UserInfo_vue__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_on_click_outside__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_on_click_outside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_on_click_outside__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fortawesome_vue_fontawesome__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__fortawesome_vue_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_spinner_src_ClipLoader_vue__ = __webpack_require__(25);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'landingNavBar',
  components: {
    UserInfo: __WEBPACK_IMPORTED_MODULE_2__components_UserInfo_vue__["a" /* default */],
    FontAwesomeIcon: __WEBPACK_IMPORTED_MODULE_4__fortawesome_vue_fontawesome___default.a,
    ClipLoader: __WEBPACK_IMPORTED_MODULE_5_vue_spinner_src_ClipLoader_vue__["a" /* default */]
  },
  data: function data() {
    return {
      loginDropdown: false,
      dropdown: false,
      color: '#808080',
      size: '20px',
      CurrentPage: ''
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_3_vue_on_click_outside__["mixin"]],
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('translator', ['setLanguage']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('user', ['logout']), {
    isLocale: function isLocale(lang) {
      return this.language === lang;
    },
    login: function login() {
      this.$auth0.loginWithRedirect();
    },
    signup: function signup() {
      this.$modal.show('signup-modal');
    },
    dropdownTrigger: function dropdownTrigger() {
      this.dropdown = !this.dropdown;
    },
    closeDropdown: function closeDropdown() {
      this.dropdown = false;
    },
    loginDropdownTrigger: function loginDropdownTrigger() {
      this.loginDropdown = !this.loginDropdown;
    },
    closeLoginDropdown: function closeLoginDropdown() {
      this.loginDropdown = false;
    },
    goToHome: function goToHome() {
      this.$router.push({ path: '/' });
    },
    logoutButton: function logoutButton() {
      if (!this.preventLogout || this.preventLogout && window.confirm(this.$t('app.leaveConfirmation'))) {
        this.closeDropdown();
        this.$auth0.logout();
        this.logout();
      }
    },
    checkUser: function checkUser(route) {
      if (!this.isLoggedIn) {
        this.$modal.show('login-modal');
        // } else if (!this.isProducer) {
        //  this.$toasted.show(this.$t('tracks.newTrack.notProducer'), {type: 'error'})
      } else if (!this.isSubscribed) {
        this.$modal.show('subscription-modal');
      } else {
        this.$router.push(route);
      }
    }
  }),
  created: function created() {
    this.CurrentPage = this.$route.name;
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('user', ['isLoggedIn', 'isSubscribed', 'isProducer', 'user', 'preventLogout']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('translator', ['language']), {
    loading: function loading() {
      return this.$loading.isLoading('user login') || this.$loading.isLoading('user checkUser');
    }
  })
});

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_modals_provider_DirectLinkModal_vue__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_providerLink_ProviderLink_vue__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fortawesome_vue_fontawesome__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__fortawesome_vue_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_home_HomeFooter_vue__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LandingNavBar_vue__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_carousel__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(11);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'oyendo',
  components: {
    ProviderLink: __WEBPACK_IMPORTED_MODULE_2__components_providerLink_ProviderLink_vue__["a" /* default */],
    DirectLinkModal: __WEBPACK_IMPORTED_MODULE_1__components_modals_provider_DirectLinkModal_vue__["a" /* default */],
    FontAwesomeIcon: __WEBPACK_IMPORTED_MODULE_3__fortawesome_vue_fontawesome___default.a,
    HomeFooter: __WEBPACK_IMPORTED_MODULE_4__components_home_HomeFooter_vue__["a" /* default */],
    LandingNavBar: __WEBPACK_IMPORTED_MODULE_5__LandingNavBar_vue__["a" /* default */],
    Carousel: __WEBPACK_IMPORTED_MODULE_6_vue_carousel__["Carousel"],
    Slide: __WEBPACK_IMPORTED_MODULE_6_vue_carousel__["Slide"]
  },
  mounted: function mounted() {
    this.scrollToTop();
  },

  methods: {
    scrollToTop: function scrollToTop() {
      window.scrollTo(0, 0);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])('translator', ['joinImage']))
});

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_modals_provider_DirectLinkModal_vue__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_providerLink_ProviderLink_vue__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fortawesome_vue_fontawesome__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__fortawesome_vue_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_home_HomeFooter_vue__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LandingNavBar_vue__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_carousel__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(11);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'creando',
  components: {
    ProviderLink: __WEBPACK_IMPORTED_MODULE_2__components_providerLink_ProviderLink_vue__["a" /* default */],
    DirectLinkModal: __WEBPACK_IMPORTED_MODULE_1__components_modals_provider_DirectLinkModal_vue__["a" /* default */],
    FontAwesomeIcon: __WEBPACK_IMPORTED_MODULE_3__fortawesome_vue_fontawesome___default.a,
    HomeFooter: __WEBPACK_IMPORTED_MODULE_4__components_home_HomeFooter_vue__["a" /* default */],
    LandingNavBar: __WEBPACK_IMPORTED_MODULE_5__LandingNavBar_vue__["a" /* default */],
    Carousel: __WEBPACK_IMPORTED_MODULE_6_vue_carousel__["Carousel"],
    Slide: __WEBPACK_IMPORTED_MODULE_6_vue_carousel__["Slide"]
  },
  mounted: function mounted() {
    this.scrollToTop();
  },

  methods: {
    scrollToTop: function scrollToTop() {
      window.scrollTo(0, 0);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])('translator', ['joinImage']))
});

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_modals_provider_DirectLinkModal_vue__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_providerLink_ProviderLink_vue__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fortawesome_vue_fontawesome__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__fortawesome_vue_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_home_HomeFooter_vue__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__LandingNavBar_vue__ = __webpack_require__(146);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'planes',
  components: {
    ProviderLink: __WEBPACK_IMPORTED_MODULE_2__components_providerLink_ProviderLink_vue__["a" /* default */],
    DirectLinkModal: __WEBPACK_IMPORTED_MODULE_1__components_modals_provider_DirectLinkModal_vue__["a" /* default */],
    FontAwesomeIcon: __WEBPACK_IMPORTED_MODULE_4__fortawesome_vue_fontawesome___default.a,
    HomeFooter: __WEBPACK_IMPORTED_MODULE_5__components_home_HomeFooter_vue__["a" /* default */],
    LandingNavBar: __WEBPACK_IMPORTED_MODULE_6__LandingNavBar_vue__["a" /* default */]
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('user', ['checkUser', 'loginByMsisdn']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('artist', ['getArtist', 'getArtistTracks', 'getArtistPlaylists', 'openProfile', 'closeProfile']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('pricing', ['getPricing']), {
    login: function login() {
      this.$auth0.loginWithRedirect();
    },
    onpopstate: function onpopstate(event) {
      // when the state is stored by `beforeRouteUpdate` event, the key is null
      if (this.isProfileOpen && event.state.key !== undefined) {
        this.closeProfile();
      }
    },
    scrollToTop: function scrollToTop() {
      window.scrollTo(0, 0);
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('artist', ['isProfileOpen', 'error']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('user', ['authToken', 'msisdn', 'provider']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('translator', ['language']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('pricing', ['pricing'])),
  created: function created() {
    this.getPricing();
    if (this.authToken) {
      this.checkUser();
    }
    window.onpopstate = this.onpopstate;
  },
  mounted: function mounted() {
    if (this.msisdn) {
      // this.loginByMsisdn({msisdn: this.msisdn, provider: this.provider, enc: true, isValidation: true})
    }
    this.scrollToTop();
  }
});

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_modals_provider_DirectLinkModal_vue__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_providerLink_ProviderLink_vue__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fortawesome_vue_fontawesome__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__fortawesome_vue_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_home_HomeFooter_vue__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Landing_LandingNavBar_vue__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_UserInfo_vue__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_on_click_outside__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_on_click_outside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_on_click_outside__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_spinner_src_ClipLoader_vue__ = __webpack_require__(25);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'landingMK',
  components: {
    ProviderLink: __WEBPACK_IMPORTED_MODULE_2__components_providerLink_ProviderLink_vue__["a" /* default */],
    DirectLinkModal: __WEBPACK_IMPORTED_MODULE_1__components_modals_provider_DirectLinkModal_vue__["a" /* default */],
    FontAwesomeIcon: __WEBPACK_IMPORTED_MODULE_3__fortawesome_vue_fontawesome___default.a,
    HomeFooter: __WEBPACK_IMPORTED_MODULE_4__components_home_HomeFooter_vue__["a" /* default */],
    LandingNavBar: __WEBPACK_IMPORTED_MODULE_5__components_Landing_LandingNavBar_vue__["a" /* default */],
    UserInfo: __WEBPACK_IMPORTED_MODULE_7__components_UserInfo_vue__["a" /* default */],
    ClipLoader: __WEBPACK_IMPORTED_MODULE_9_vue_spinner_src_ClipLoader_vue__["a" /* default */]
  },
  data: function data() {
    return {
      userFromLandingMK: true,
      loginDropdown: false,
      dropdown: false,
      color: '#808080',
      size: '20px',
      CurrentPage: ''
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_8_vue_on_click_outside__["mixin"]],
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('translator', ['setLanguage']), Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('user', ['logout']), Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('pricing', ['getPricing']), {
    isLocale: function isLocale(lang) {
      return this.language === lang;
    },
    login: function login() {
      this.$auth0.loginWithRedirect();
    },
    signup: function signup() {
      this.$modal.show('signup-modal');
    },
    dropdownTrigger: function dropdownTrigger() {
      this.dropdown = !this.dropdown;
    },
    closeDropdown: function closeDropdown() {
      this.dropdown = false;
    },
    loginDropdownTrigger: function loginDropdownTrigger() {
      this.loginDropdown = !this.loginDropdown;
    },
    closeLoginDropdown: function closeLoginDropdown() {
      this.loginDropdown = false;
    },
    goToHome: function goToHome() {
      this.$router.push({ path: '/' });
    },
    logoutButton: function logoutButton() {
      if (!this.preventLogout || this.preventLogout && window.confirm(this.$t('app.leaveConfirmation'))) {
        this.closeDropdown();
        this.$auth0.logout();
        this.logout();
      }
    },
    checkUser: function checkUser(route) {
      if (!this.isLoggedIn) {
        this.$modal.show('login-modal');
        // } else if (!this.isProducer) {
        //  this.$toasted.show(this.$t('tracks.newTrack.notProducer'), {type: 'error'})
      } else if (!this.isSubscribed) {
        this.$modal.show('subscription-modal');
      } else {
        this.$router.push(route);
      }
    }
  }),
  created: function created() {
    this.CurrentPage = this.$route.name;
    localStorage.setItem('userFromLandingMK', this.userFromLandingMK);
    this.getPricing();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])('user', ['isLoggedIn', 'isSubscribed', 'isProducer', 'user', 'preventLogout']), Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])('translator', ['language']), Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])('pricing', ['pricing']), {
    loading: function loading() {
      return this.$loading.isLoading('user login') || this.$loading.isLoading('user checkUser');
    }
  })
});

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_modals_provider_DirectLinkModal_vue__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_providerLink_ProviderLink_vue__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home_HomeFooter_vue__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_modals_PaymentModal_vue__ = __webpack_require__(233);
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'paymentsMK',
  components: {
    ProviderLink: __WEBPACK_IMPORTED_MODULE_1__components_providerLink_ProviderLink_vue__["a" /* default */],
    DirectLinkModal: __WEBPACK_IMPORTED_MODULE_0__components_modals_provider_DirectLinkModal_vue__["a" /* default */],
    FontAwesomeIcon: __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome___default.a,
    HomeFooter: __WEBPACK_IMPORTED_MODULE_3__components_home_HomeFooter_vue__["a" /* default */],
    PaymentModal: __WEBPACK_IMPORTED_MODULE_4__components_modals_PaymentModal_vue__["a" /* default */]
  },
  mounted: function mounted() {
    this.$modal.show('payment-modal', { paymentUrl: '/payment/subscribe/' });
  }
});

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'intellectualProp-es'
});

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'intellectualProp-es'
});

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'intellectualProp-en'
});

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'intellectualProp-pt'
});

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TracksList_vue__ = __webpack_require__(235);

//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'all-tracks-list',
  components: {
    TracksList: __WEBPACK_IMPORTED_MODULE_2__TracksList_vue__["a" /* default */]
  },
  created: function created() {
    var _this = this;

    this.setFrom(0);
    this.getAll().catch(function (e) {
      _this.$toasted.show(_this.error.message, { type: 'error' });
    });
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('track', ['allTracks']), {
    loading: function loading() {
      return this.$loading.isLoading('track getAll');
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('track', ['getAll', 'setFrom']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('player', ['setPlaylist']))
});

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TrackItemList_vue__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_spinner_src_ClipLoader_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_infinite_scroll__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_infinite_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_infinite_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debounce__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_debounce__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'tracks-list',
  props: {
    tracks: {
      required: true
    },
    withFilters: {
      default: true
    },
    withPagination: {
      default: true
    },
    loading: {
      required: true
    },
    showGenMain: {
      default: true
    },
    showGenSecon: {
      default: true
    },
    profileTracks: {
      default: false
    }
  },
  components: {
    ClipLoader: __WEBPACK_IMPORTED_MODULE_3_vue_spinner_src_ClipLoader_vue__["a" /* default */],
    TrackItemList: __WEBPACK_IMPORTED_MODULE_2__TrackItemList_vue__["a" /* default */]
  },
  directives: {
    infiniteScroll: __WEBPACK_IMPORTED_MODULE_4_vue_infinite_scroll___default.a
  },
  data: function data() {
    return {
      color: '#808080',
      size1: '100px',
      size2: '30px',
      disablePagination: false,
      genSeconByMain: [],
      genMainTranslatePosition: 0,
      genSeconTranslatePosition: 0,
      hasSelectedGenMain: false,
      hasSelectedGenSecon: false,
      genMainLastEvent: { // emazzu, para mantener el color de padre seleccionado
        event: null,
        background: null,
        color: null
      },
      busy: false,
      translatePosition: null,
      textToFilter: '',
      selectedGenre: null,
      discoverSelectedGenre: null,
      mobileWidth: false,
      mainGenre: {
        name: null,
        id: null
      },
      seconGenre: {
        name: null,
        id: null
      },
      filteredText: null
    };
  },
  created: function created() {
    this.discoverSelectedGenre = this.genreFilter;
    if (this.discoverMainGenre && this.discoverMainGenre.name !== null) {
      this.mainGenre = this.discoverMainGenre;
    }
    if (this.discoverSeconGenre && this.discoverSeconGenre.name !== null) {
      this.seconGenre = this.discoverSeconGenre;
    }
    this.selectedGenre = this.genreFilter;
    this.disablePagination = !this.withPagination;
    if (this.withFilters) {
      if (this.discoverSelectedGenre !== null) {
        this.getGenresMain(true);
        this.setGenreFilter(this.discoverSelectedGenre);
      } else {
        this.getGenresMain(true);
        this.setGenreFilter(0);
      }
    }
    window.innerWidth <= 360 ? this.mobileWidth = true : this.mobileWidth = false;
  },
  mounted: function mounted() {
    window.scrollTo(0, 0);
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('track', ['getGenresMain', 'setGenreFilter', 'getAll', 'loadMore', 'setFrom']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('player', ['setPlaylist']), {
    clearFilters: function clearFilters() {
      this.textToFilter = '';
      this.filteredText = null;
    },


    update: __WEBPACK_IMPORTED_MODULE_5_debounce___default()(function (e) {
      if (this.textToFilter !== '') {
        this.busy = true;
        this.filteredText = this.textToFilter;
        this.selectTrackByFilter(this.selectedGenre, this.textToFilter);
        this.busy = false;
        this.textToFilter = '';
      } else {
        this.selectTrackByFilter(this.selectedGenre, null);
        this.filteredText = null;
      }
    }, 1000, true),

    selectTrackByFilter: function selectTrackByFilter() {
      var _this = this;

      var selectedId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var textToFilter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      this.setGenreFilter(selectedId);
      this.setFrom(0);
      this.getAll(textToFilter).catch(function (e) {
        _this.$toasted.show(_this.error.message, { type: 'error' });
      });
    },


    // emazzu, start, para mantener el color de seleccion en el genero padre
    selectGenMainBlur: function selectGenMainBlur(event) {
      this.genMainLastEvent = {
        background: event.target.style.background,
        color: event.target.style.color,
        event: event
      };
      event.target.style.background = '#E6007E';
      event.target.style.color = 'white';
    },
    selectGenMainFocus: function selectGenMainFocus(event) {
      if (this.genMainLastEvent.event === null) {
        return;
      }

      this.genMainLastEvent.event.target.style.background = this.genMainLastEvent.background;
      this.genMainLastEvent.event.target.style.color = this.genMainLastEvent.color;
    },

    // emazzu, end, para mantener el color de seleccion en el genero padre

    // emazzu, cuando se hace clic en el genero primario
    selectGenMain: function selectGenMain(selectedId) {
      var _this2 = this;

      if (selectedId === '') {
        if (this.genMainLastEvent && this.genMainLastEvent.event) {
          this.genMainLastEvent.event.target.style.background = '';
          this.genMainLastEvent.event.target.style.color = '';
        }
        selectedId = 0;
        this.setGenreFilter(selectedId);
        this.setFrom(0);
        this.getAll().catch(function (e) {
          _this2.$toasted.show(_this2.error.message, { type: 'error' });
        });
      }
      // selectedId = selectedId || 0
      // emazzu, filter todos los tracks que corresponden al genero primario
      this.selectedGenre = selectedId;
      if (this.withFilters && selectedId !== this.genreFilter) {
        this.setGenreFilter(selectedId);
        this.setFrom(0);
        this.getAll().catch(function (e) {
          _this2.$toasted.show(_this2.error.message, { type: 'error' });
        });
      }

      // emazzu, find genero primario seleccionado
      var found = this.genresMain.find(function (ele) {
        return ele.id === selectedId;
      });
      if (selectedId !== 0) {
        this.mainGenre = found;
      } else {
        this.mainGenre = {
          name: null,
          id: null
        };
      }
      this.seconGenre = {
        name: null,
        id: null
      };
      this.textToFilter = '';
      this.filteredText = null;

      // emazzu, si encontro, que siempre va a encontrar, menos si selecciona TODOS
      if (typeof found !== 'undefined') {
        this.genSeconByMain = found.children.sort(function (a, b) {
          if (a.name > b.name) {
            return 1;
          }
          if (a.name < b.name) {
            return -1;
          }
          // a must be equal to b
          return 0;
        });
      } else {
        this.genSeconByMain = [];
      }

      // flags
      this.hasSelectedGenMain = true;
      this.hasSelectedGenSecon = false;

      // flag, si selecciono TODOS, vuelvo para atras uno de los flag
      if (selectedId === '') {
        this.hasSelectedGenMain = false;
      }

      // los 2 filtros siempre visibles, dejamos los flags x las dudas
      this.showGenMain = true;
      this.showGenSecon = true;
      // Resetea lo posicion del genSecon
      var style = 'transform: translateX( 0px)';
      this.$el.querySelector('#genSecon').style = style;
      this.genSeconTranslatePosition = 0;
      this.translatePosition = 0;

      return null;
    },
    selectGenSecon: function selectGenSecon(selectedId) {
      // emazzu, filter todos los tracks que corresponden al genero primario
      if (this.withFilters && selectedId !== this.genreFilter) {
        this.selectTrackByFilter(selectedId);
      }
      this.selectedGenre = selectedId;
      this.textToFilter = '';
      this.filteredText = null;
      // flags
      this.hasSelectedGenMain = true;
      this.hasSelectedGenSecon = true;

      // los 2 filtros siempre visibles, dejamos los flags x las dudas
      this.showGenMain = true;
      this.showGenSecon = true;
      var found = this.genSeconByMain.find(function (ele) {
        return ele.id === selectedId;
      });
      this.seconGenre = found;
      return null;
    },
    nextPage: function nextPage() {
      var _this3 = this;

      if (!this.preventLoadMore) {
        this.busy = true;
        this.loadMore(this.textToFilter).then(function () {
          _this3.busy = false;
        });
      }
    },

    // emazzu, transition genero principal y secundario
    genTranslate: function genTranslate(element, arrow) {
      var transitionValue = 120;

      if (element === 'genMain') {
        this.genMainTranslatePosition += arrow === 'left' ? transitionValue : transitionValue * -1;
        this.translatePosition = this.genMainTranslatePosition;
      }

      if (element === 'genSecon') {
        this.genSeconTranslatePosition += arrow === 'left' ? transitionValue : transitionValue * -1;
        this.translatePosition = this.genSeconTranslatePosition;
      }

      if (this.translatePosition >= 120) {
        this.translatePosition = 0;
        this.genMainTranslatePosition = 0;
        this.genSeconTranslatePosition = 0;
      }
      if (this.translatePosition <= -(120 * (this.genresMain.length - 1)) && element === 'genMain') {
        this.translatePosition = -(120 * (this.genresMain.length - 1));
        this.genMainTranslatePosition = -(120 * (this.genresMain.length - 1));
        this.genSeconTranslatePosition = 0;
      }
      if (this.translatePosition <= -(120 * (this.genSeconByMain.length - 1)) && element === 'genSecon') {
        this.translatePosition = -(120 * (this.genSeconByMain.length - 1));
        this.genMainTranslatePosition = 0;
        this.genSeconTranslatePosition = -(120 * (this.genSeconByMain.length - 1));
      }
      var style = 'transform: translateX(' + this.translatePosition.toString() + 'px' + ')';
      this.$el.querySelector('#' + element).style = style;
    },
    filterByMainGenreLabel: function filterByMainGenreLabel() {
      if (this.genMainLastEvent && this.genMainLastEvent.event) {
        this.genMainLastEvent.event.target.style.background = '';
        this.genMainLastEvent.event.target.style.color = '';
      }
      this.mainGenre = {
        name: null,
        id: null
      };
      this.seconGenre = {
        name: null,
        id: null
      };
      this.genSeconByMain = [];
      var text = this.filteredText ? this.filteredText : null;
      this.selectedGenre = 0;
      this.selectTrackByFilter(0, text);
    },
    removeSeconGenreLabel: function removeSeconGenreLabel() {
      this.seconGenre = {
        name: null,
        id: null
      };
      var text = this.filteredText ? this.filteredText : null;
      this.selectedGenre = this.mainGenre.id;
      this.selectTrackByFilter(this.mainGenre.id, text);
    },
    removeFilteredTextLabel: function removeFilteredTextLabel() {
      this.selectTrackByFilter(this.selectedGenre);
      this.clearFilters();
    },
    removeAllLabels: function removeAllLabels() {
      this.selectedGenre = 0;
      this.genSeconByMain = [];
      if (this.genMainLastEvent && this.genMainLastEvent.event) {
        this.genMainLastEvent.event.target.style.background = '';
        this.genMainLastEvent.event.target.style.color = '';
      }
      this.mainGenre = {
        name: null,
        id: null
      };
      this.seconGenre = {
        name: null,
        id: null
      };
      this.filteredText = null;
      if (this.textToFilter === '') {
        this.selectTrackByFilter(0);
      } else {
        this.textToFilter = '';
      }
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('player', ['currentTrack']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('track', ['allTracks', 'genresMain', 'genreFilter', 'noMoreResults', 'discoverMainGenre', 'discoverSeconGenre']), {
    loadingMore: function loadingMore() {
      return this.$loading.isLoading('track loadMore');
    },
    preventLoadMore: function preventLoadMore() {
      return this.loadingMore || this.noMoreResults || this.busy;
    },


    // emazzu, para lista desplegable
    loadingGenresMain: function loadingGenresMain() {
      return this.$loading.isLoading('track getGenresMain');
    }
  })
});

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrackItemList_vue__ = __webpack_require__(461);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78ae2c52_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrackItemList_vue__ = __webpack_require__(1037);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1036)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-78ae2c52"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrackItemList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78ae2c52_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrackItemList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78ae2c52_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrackItemList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TrackImage__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TrackData__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TrackCard__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_tracks_TrackOptionsButton_vue__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fortawesome_vue_fontawesome__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__fortawesome_vue_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__consts__ = __webpack_require__(21);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'track-item-list',
  props: {
    track: {
      required: true
    },
    profileTracks: {
      default: false
    }
  },
  data: function data() {
    return {
      trackTime: null
    };
  },

  components: {
    TrackImage: __WEBPACK_IMPORTED_MODULE_2__TrackImage__["a" /* default */],
    TrackData: __WEBPACK_IMPORTED_MODULE_3__TrackData__["a" /* default */],
    TrackOptionsButton: __WEBPACK_IMPORTED_MODULE_5__components_tracks_TrackOptionsButton_vue__["a" /* default */],
    FontAwesomeIcon: __WEBPACK_IMPORTED_MODULE_6__fortawesome_vue_fontawesome___default.a,
    TrackCard: __WEBPACK_IMPORTED_MODULE_4__TrackCard__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('player', ['currentTrack', 'isPlaying']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('track', ['loading', 'allTracks']), {
    picture: function picture() {
      return __WEBPACK_IMPORTED_MODULE_7__consts__["a" /* default */].MEDIA_BASE_URL + this.track.picture;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('player', ['setPlaying', 'changeTrack']), {
    playTrack: function playTrack() {
      if (this.currentTrack !== this.track) {
        this.$emit('play');
        this.changeTrack(this.track);
      } else {
        this.setPlaying(true);
      }
    },
    trackTimeToMin: function trackTimeToMin() {
      var seg = this.track.seconds;
      var min = 0;
      this.trackTime = 0;
      for (var i = 0; i < 60; i++) {
        if (seg >= 60) {
          min++;
          seg -= 60;
        } else if (seg < 60) {
          if (seg <= 9) {
            this.trackTime = min + ':0' + seg;
            return this.trackTime;
          } else {
            this.trackTime = min + ':' + seg;
            return this.trackTime;
          }
        }
      }
    }
  }),
  mounted: function mounted() {
    this.trackTimeToMin();
  }
});

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'new-track-wrapper',
  data: function data() {
    return {
      routeName: 'new-track'
    };
  }
});

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_upload_component__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_upload_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_upload_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__consts__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__auth__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TrackEdit_vue__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_charts_CircleProgress_vue__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_spinner_src_ClipLoader_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuelidate_lib_validators__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuelidate_lib_validators_minValue__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuelidate_lib_validators_minValue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vuelidate_lib_validators_minValue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_UploadImage_vue__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__textEditor_EditorCK_vue__ = __webpack_require__(175);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'track-new',
  data: function data() {
    return {
      files: [],
      fileValidator: true,
      color: '#808080',
      size: '30px',
      smallSize: '15px',
      circleFill: { gradient: ['#272727'] },
      track: {
        title: '',
        id_music_type: '',
        tags: '',
        picture: '',
        id_lisense: 0,
        min_price: null,
        recommendedGenre: '',
        iswc: null,
        credits: ''
      },
      isSaving: false,
      loadingPicture: false,
      canEdit: false,
      isOthers: false,
      isOthersChildren: false,
      mainGenreSelected: '',
      childrensGenres: []
    };
  },

  components: {
    FileUpload: __WEBPACK_IMPORTED_MODULE_1_vue_upload_component___default.a,
    FontAwesomeIcon: __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome___default.a,
    TrackEdit: __WEBPACK_IMPORTED_MODULE_5__TrackEdit_vue__["a" /* default */],
    UploadImage: __WEBPACK_IMPORTED_MODULE_11__components_UploadImage_vue__["a" /* default */],
    CircleProgress: __WEBPACK_IMPORTED_MODULE_7__components_charts_CircleProgress_vue__["a" /* default */],
    ClipLoader: __WEBPACK_IMPORTED_MODULE_8_vue_spinner_src_ClipLoader_vue__["a" /* default */],
    EditorCK: __WEBPACK_IMPORTED_MODULE_12__textEditor_EditorCK_vue__["a" /* default */]
  },
  created: function created() {
    var _this = this;

    if (this.userPromise) {
      // wait until user promise is resolved
      this.userPromise.then(function () {
        if (_this.isSubscribed) {
          _this.setTrackUploaded(false);
          _this.setPreventLogout(true);
          _this.resetError();
          _this.getGenresMain().catch(function (e) {
            _this.redirectHome(e.message);
          });
          if (_this.licenses.length === 0) {
            _this.getLicenses().then(function () {
              _this.setActualLicense();
            }).catch(function (e) {
              _this.redirectHome(e.message);
            });
          }
          if (!_this.isNewTrack) {
            _this.getTrack(_this.$route.params.id).then(function (res) {
              if (res.canEdit) {
                _this.canEdit = true;
                _this.track = res.track;
                _this.setLicenseValues(_this.track.id_lisense);
                _this.setActualLicense();
              } else {
                _this.redirectHome(_this.$t('app.notAllowed'));
              }
            }).catch(function (e) {
              _this.redirectHome(e.message);
            });
          } else {
            _this.resetLicense();
            /*
            if (this.file === undefined) {
              this.redirectHome(this.$t('tracks.newTrack.trackError'))
            }
            */
          }
        } else {
          // user is not subscribed
          _this.redirectHome(_this.$t('app.notAllowed'));
        }
      }).catch(function () {
        // user promise was rejected
        _this.redirectHome(_this.$store.getters['user/error']);
      });
    } else {
      // user is not logged in
      this.redirectHome(this.$t('app.notAllowed'));
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (this.isTrackUploaded || !this.files.length || !this.isLoggedIn || this.files.length && this.userConfirm()) {
      next();
    } else {
      next(false);
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])('track', ['genresMain', 'genres', 'error', 'isTrackUploaded']), Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])('license', ['actualLicense', 'licenses']), Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])('user', ['isLoggedIn', 'isSubscribed', 'userPromise', 'user']), {
    url: function url() {
      return __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/tracks/upload/file';
    },

    postFileHeaders: function postFileHeaders() {
      return __WEBPACK_IMPORTED_MODULE_4__auth__["b" /* default */].getHeader();
    },
    adaptationCondition: {
      get: function get() {
        return this.$store.state.license.adaptationCondition;
      },
      set: function set(value) {
        this.setAdaptationCondition(value);
      }
    },
    commercialCondition: {
      get: function get() {
        return this.$store.state.license.commercialCondition;
      },
      set: function set(value) {
        this.setCommercialCondition(value);
      }
    },
    picture: function picture() {
      if (this.track && this.track.picture) {
        return __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].MEDIA_BASE_URL + this.track.path + this.track.picture;
      }
    },
    licenseIcon: function licenseIcon() {
      return this.track.actualLicense ? 'static' + this.actualLicense.icon : '';
    },
    buttonDisabled: function buttonDisabled() {
      if (this.file !== undefined) {
        return this.loadingPicture || this.file.progress < 100 || this.loadingEdition;
      } else {
        return this.loadingPicture || this.loadingEdition;
      }
    },
    loading: function loading() {
      return this.$loading.isLoading('track getGenresMain') || this.$loading.isLoading('license getLicenses') || this.$loading.isLoading('getTrack') || !this.isNewTrack && !this.canEdit;
    },
    loadingEdition: function loadingEdition() {
      return this.$loading.isLoading('track editTrack');
    },
    isNewTrack: function isNewTrack() {
      return !this.$route.params.id;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('track', ['getGenresMain', 'editTrack', 'setTrackUploaded', 'resetError', 'getTrack']), Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('license', ['getLicenses', 'setLicenseValues', 'setActualLicense', 'setAdaptationCondition', 'setCommercialCondition', 'resetLicense']), Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('user', ['setPreventLogout']), {
    edit: function edit() {
      var _this2 = this;

      if (this.files.length === 0) {
        this.fileValidator = false;
        return;
      }
      if (!this.$v.$invalid) {
        if (this.files[0] === undefined || this.files[0] !== undefined && this.files[0].response.status === 'ok') {
          if (!this.disable) {
            this.track.id = this.files[0] !== undefined ? this.files[0].response.data.track_id : this.track.id;
            this.track.new_release = this.isNewTrack;
            this.editTrack(this.track).then(function () {
              _this2.$store.dispatch('track/setTrackUploaded', true);
              if (_this2.isNewTrack) {
                _this2.$toasted.show(_this2.$t('tracks.newTrack.uploaded'), { type: 'success' });
                _this2.$router.push('/discover');
              } else {
                _this2.$toasted.show(_this2.$t('tracks.editTrack.uploaded'), { type: 'success' });
                _this2.isSaving = true;
                _this2.$router.push({ name: 'my-tracks' });
              }
            }).catch(function (e) {
              _this2.$toasted.show(_this2.error, {
                type: 'error'
              });
            });
          } else {
            this.$toasted.show(this.$t('tracks.newTrack.imageError'), {
              type: 'error'
            });
          }
        } else {
          this.$toasted.show(this.$t('error.trackUpload'), {
            type: 'error'
          });
        }
      } else {
        this.$v.$touch();
      }
    },
    handleUploadFinished: function handleUploadFinished(picture) {
      if (picture === '') {
        this.track.picture = '/static/assets/Img_comodines_Beathey_Playlist.jpg';
      } else {
        this.track.picture = picture;
      }
      this.loadingPicture = false;
    },
    redirectHome: function redirectHome(message) {
      this.$router.push({ path: '/home' });
      this.$toasted.show(message, { type: 'error' });
    },
    userConfirm: function userConfirm() {
      return window.confirm(this.$t('tracks.newTrack.leaveConfirmation'));
    },
    filterChildrensGenres: function filterChildrensGenres() {
      var _this3 = this;

      this.isOthers = false;
      this.track.id_music_type = '';
      if (this.mainGenreSelected !== '') {
        this.genresMain.forEach(function (item) {
          if (item.id === _this3.mainGenreSelected) {
            if (item.name !== 'OTHERS') {
              _this3.childrensGenres = item.children.sort(function (a, b) {
                if (a.name > b.name) {
                  return 1;
                }
                if (a.name < b.name) {
                  return -1;
                }
                // a must be equal to b
                return 0;
              });
            } else {
              _this3.isOthers = true;
              _this3.track.id_music_type = item.children[0].id;
            }
          }
        });
      }
    },
    otherSelected: function otherSelected() {
      var _this4 = this;

      this.isOthersChildren = false;
      this.childrensGenres.forEach(function (item) {
        if (item.id === _this4.track.id_music_type) {
          if (item.name === 'OTHERS') {
            _this4.isOthersChildren = true;
          }
        }
      });
    },

    inputFile: function inputFile(newFile, oldFile) {
      // auto start
      if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
        if (!this.$refs.upload.active) {
          this.$refs.upload.active = true;
        }
      }
    },
    inputFilter: function inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Filter mp3
        if (!/\.(mp3)$/i.test(newFile.name)) {
          this.$toasted.show(this.$t('tracks.newTrack.extensionMessage'), { type: 'error' });
          return prevent();
        }
      }
    },
    handleContentChange: function handleContentChange(content) {
      this.track.credits = content;
    }
  }),
  watch: {
    adaptationCondition: function adaptationCondition() {
      this.setActualLicense();
    },
    commercialCondition: function commercialCondition() {
      this.setActualLicense();
    }
  },
  validations: {
    track: {
      title: {
        required: __WEBPACK_IMPORTED_MODULE_9_vuelidate_lib_validators__["required"]
      },
      id_music_type: {
        required: __WEBPACK_IMPORTED_MODULE_9_vuelidate_lib_validators__["required"]
      },
      picture: {
        required: __WEBPACK_IMPORTED_MODULE_9_vuelidate_lib_validators__["required"]
      },
      min_price: {
        required: __WEBPACK_IMPORTED_MODULE_9_vuelidate_lib_validators__["required"],
        minValue: __WEBPACK_IMPORTED_MODULE_10_vuelidate_lib_validators_minValue___default()(1)
      },
      iswc: {
        minLength: Object(__WEBPACK_IMPORTED_MODULE_9_vuelidate_lib_validators__["minLength"])(13),
        maxLength: Object(__WEBPACK_IMPORTED_MODULE_9_vuelidate_lib_validators__["maxLength"])(13)
      }
    }
  }
});

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_upload_component__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_upload_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_upload_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__consts__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_charts_CircleProgress_vue__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_spinner_src_ClipLoader_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators_minValue__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators_minValue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators_minValue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_UploadImage_vue__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__textEditor_EditorCK_vue__ = __webpack_require__(175);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'track-edit',
  data: function data() {
    return {
      color: '#808080',
      size: '30px',
      smallSize: '15px',
      circleFill: { gradient: ['#272727'] },
      track: {
        title: '',
        id_music_type: '',
        tags: '',
        picture: '',
        id_lisense: 0,
        min_price: null,
        recommendedGenre: '',
        iswc: null,
        credits: ''
      },
      isSaving: false,
      loadingPicture: false,
      canEdit: false,
      isOthers: false,
      isOthersChildren: false,
      mainGenreSelected: '',
      childrensGenres: []
    };
  },

  props: {
    trackFile: Object
  },
  components: {
    UploadImage: __WEBPACK_IMPORTED_MODULE_9__components_UploadImage_vue__["a" /* default */],
    FontAwesomeIcon: __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome___default.a,
    FileUpload: __WEBPACK_IMPORTED_MODULE_1_vue_upload_component___default.a,
    CircleProgress: __WEBPACK_IMPORTED_MODULE_4__components_charts_CircleProgress_vue__["a" /* default */],
    ClipLoader: __WEBPACK_IMPORTED_MODULE_6_vue_spinner_src_ClipLoader_vue__["a" /* default */],
    EditorCK: __WEBPACK_IMPORTED_MODULE_10__textEditor_EditorCK_vue__["a" /* default */]
  },
  created: function created() {
    var _this = this;

    if (this.userPromise) {
      // wait until user promise is resolved
      this.userPromise.then(function () {
        if (_this.isSubscribed) {
          _this.setTrackUploaded(false);
          _this.setPreventLogout(true);
          _this.resetError();
          _this.getGenresMain().catch(function (e) {
            _this.redirectHome(e.message);
          });
          if (_this.licenses.length === 0) {
            _this.getLicenses().then(function () {
              _this.setActualLicense();
            }).catch(function (e) {
              _this.redirectHome(e.message);
            });
          }
          if (!_this.isNewTrack) {
            _this.getTrack(_this.$route.params.id).then(function (res) {
              if (res.canEdit) {
                _this.canEdit = true;
                _this.track = res.track;
                _this.setLicenseValues(_this.track.id_lisense);
                _this.setActualLicense();
              } else {
                _this.redirectHome(_this.$t('app.notAllowed'));
              }
            }).catch(function (e) {
              _this.redirectHome(e.message);
            });
          } else {
            _this.resetLicense();
            if (_this.trackFile === undefined) {
              _this.redirectHome(_this.$t('tracks.newTrack.trackError'));
            }
          }
        } else {
          // user is not subscribed
          _this.redirectHome(_this.$t('app.notAllowed'));
        }
      }).catch(function () {
        // user promise was rejected
        _this.redirectHome(_this.$store.getters['user/error']);
      });
    } else {
      // user is not logged in
      this.redirectHome(this.$t('app.notAllowed'));
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])('track', ['genresMain', 'genres', 'error', 'isTrackUploaded']), Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])('license', ['actualLicense', 'licenses']), Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])('user', ['isLoggedIn', 'isSubscribed', 'userPromise', 'user']), {
    adaptationCondition: {
      get: function get() {
        return this.$store.state.license.adaptationCondition;
      },
      set: function set(value) {
        this.setAdaptationCondition(value);
      }
    },
    commercialCondition: {
      get: function get() {
        return this.$store.state.license.commercialCondition;
      },
      set: function set(value) {
        this.setCommercialCondition(value);
      }
    },
    picture: function picture() {
      if (this.track && this.track.picture) {
        return __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].MEDIA_BASE_URL + this.track.path + this.track.picture;
      }
    },
    licenseIcon: function licenseIcon() {
      return this.track.actualLicense ? 'static' + this.actualLicense.icon : '';
    },
    buttonDisabled: function buttonDisabled() {
      if (this.trackFile !== undefined) {
        return this.loadingPicture || this.trackFile.progress < 100 || this.loadingEdition;
      } else {
        return this.loadingPicture || this.loadingEdition;
      }
    },
    loading: function loading() {
      return this.$loading.isLoading('track getGenresMain') || this.$loading.isLoading('license getLicenses') || this.$loading.isLoading('getTrack') || !this.isNewTrack && !this.canEdit;
    },
    loadingEdition: function loadingEdition() {
      return this.$loading.isLoading('track editTrack');
    },
    isNewTrack: function isNewTrack() {
      return !this.$route.params.id;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('track', ['getGenresMain', 'editTrack', 'setTrackUploaded', 'resetError', 'getTrack']), Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('license', ['getLicenses', 'setLicenseValues', 'setActualLicense', 'setAdaptationCondition', 'setCommercialCondition', 'resetLicense']), Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('user', ['setPreventLogout']), {
    edit: function edit() {
      var _this2 = this;

      if (!this.$v.$invalid) {
        if (this.trackFile === undefined || this.trackFile !== undefined && this.trackFile.response.status === 'ok') {
          if (!this.disable) {
            this.track.id = this.trackFile !== undefined ? this.trackFile.response.data.track_id : this.track.id;
            this.track.new_release = this.isNewTrack;
            this.editTrack(this.track).then(function () {
              _this2.$store.dispatch('track/setTrackUploaded', true);
              if (_this2.isNewTrack) {
                _this2.$toasted.show(_this2.$t('tracks.newTrack.uploaded'), { type: 'success' });
                _this2.$router.push('/discover');
              } else {
                _this2.$toasted.show(_this2.$t('tracks.editTrack.uploaded'), { type: 'success' });
                _this2.isSaving = true;
                _this2.$router.push({ name: 'my-tracks' });
              }
            }).catch(function (e) {
              _this2.$toasted.show(_this2.error, {
                type: 'error'
              });
            });
          } else {
            this.$toasted.show(this.$t('tracks.newTrack.imageError'), {
              type: 'error'
            });
          }
        } else {
          this.$toasted.show(this.$t('error.trackUpload'), {
            type: 'error'
          });
        }
      } else {
        this.$v.$touch();
      }
    },
    handleUploadFinished: function handleUploadFinished(picture) {
      if (picture === '') {
        this.track.picture = '/static/assets/Img_comodines_Beathey_Playlist.jpg';
      } else {
        this.track.picture = picture;
      }
      this.loadingPicture = false;
    },
    redirectHome: function redirectHome(message) {
      this.$router.push({ path: '/home' });
      this.$toasted.show(message, { type: 'error' });
    },
    userConfirm: function userConfirm() {
      return window.confirm(this.$t('tracks.newTrack.leaveConfirmation'));
    },
    filterChildrensGenres: function filterChildrensGenres() {
      var _this3 = this;

      this.isOthers = false;
      this.track.id_music_type = '';
      if (this.mainGenreSelected !== '') {
        this.genresMain.forEach(function (item) {
          if (item.id === _this3.mainGenreSelected) {
            if (item.name !== 'OTHERS') {
              _this3.childrensGenres = item.children.sort(function (a, b) {
                if (a.name > b.name) {
                  return 1;
                }
                if (a.name < b.name) {
                  return -1;
                }
                // a must be equal to b
                return 0;
              });
            } else {
              _this3.isOthers = true;
              _this3.track.id_music_type = item.children[0].id;
            }
          }
        });
      }
    },
    otherSelected: function otherSelected() {
      var _this4 = this;

      this.isOthersChildren = false;
      this.childrensGenres.forEach(function (item) {
        if (item.id === _this4.track.id_music_type) {
          if (item.name === 'OTHERS') {
            _this4.isOthersChildren = true;
          }
        }
      });
    },
    handleContentChange: function handleContentChange(content) {
      this.track.credits = content;
    }
  }),
  watch: {
    adaptationCondition: function adaptationCondition() {
      this.setActualLicense();
    },
    commercialCondition: function commercialCondition() {
      this.setActualLicense();
    }
  },
  validations: {
    track: {
      title: {
        required: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["required"]
      },
      id_music_type: {
        required: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["required"]
      },
      picture: {
        required: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["required"]
      },
      min_price: {
        required: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["required"],
        minValue: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators_minValue___default()(1)
      },
      iswc: {
        minLength: Object(__WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["minLength"])(13),
        maxLength: Object(__WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["maxLength"])(13)
      }
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (this.isSaving || !this.isLoggedIn || !this.isSubscribed || !this.canEdit || !this.isSaving && this.userConfirm()) {
      this.setPreventLogout(false);
      next();
    } else {
      next(false);
    }
  }
});

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_charts_ArtistData__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_charts_CircleProgress__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_spinner_src_ClipLoader_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__consts__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Countdown_vue__ = __webpack_require__(1050);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__VinylContestPodium_vue__ = __webpack_require__(425);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      artists: [],
      info: [],
      loading: true,
      hasArtists: false,
      color: '#808080',
      size: '30px'
    };
  },

  components: {
    Countdown: __WEBPACK_IMPORTED_MODULE_4__Countdown_vue__["a" /* default */],
    ArtistData: __WEBPACK_IMPORTED_MODULE_0__components_charts_ArtistData__["a" /* default */],
    CircleProgress: __WEBPACK_IMPORTED_MODULE_1__components_charts_CircleProgress__["a" /* default */],
    ClipLoader: __WEBPACK_IMPORTED_MODULE_2_vue_spinner_src_ClipLoader_vue__["a" /* default */],
    VinylContestPodium: __WEBPACK_IMPORTED_MODULE_5__VinylContestPodium_vue__["a" /* default */]
  },
  created: function created() {
    var _this = this;

    this.getArtists().then(function (response) {
      if (response.body.data['cant'] > 0) {
        _this.artists = response.body.data.data;
        _this.info = response.body.data;
        _this.loading = false;
        _this.hasArtists = true;
      } else {
        _this.hasArtists = false;
      }
    });
  },

  methods: {
    getArtists: function getArtists(from) {
      return this.$http.get(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/tracks/getContest');
    },
    picture: function picture(artist) {
      return __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].MEDIA_BASE_URL + artist.path + artist.picture;
    }
  }
});

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'countdown',
  props: {
    end: {
      required: true
    }
  },
  data: function data() {
    return {
      days: 0,
      hours: 0,
      minutes: 0
    };
  },
  mounted: function mounted() {
    setInterval(this.updateDateTime, 1000);
  },

  methods: {
    updateDateTime: function updateDateTime() {
      var now = new Date().getTime();
      var final = new Date(this.end * 1000);
      var distance = final - now;
      this.days = Math.floor(distance / (1000 * 60 * 60 * 24));
      this.hours = Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
      this.minutes = Math.floor(distance % (1000 * 60 * 60) / (1000 * 60));
    }
  }
});

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__consts__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amcharts_amcharts4_core__ = __webpack_require__(1055);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amcharts_amcharts4_charts__ = __webpack_require__(1074);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amcharts_amcharts4_themes_dark__ = __webpack_require__(1097);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue2_datepicker__ = __webpack_require__(1099);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue2_datepicker_index_css__ = __webpack_require__(1103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue2_datepicker_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue2_datepicker_index_css__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











__WEBPACK_IMPORTED_MODULE_4__amcharts_amcharts4_core__["e" /* useTheme */](__WEBPACK_IMPORTED_MODULE_6__amcharts_amcharts4_themes_dark__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component('date-picker', __WEBPACK_IMPORTED_MODULE_7_vue2_datepicker__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dashboard',
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_4__amcharts_amcharts4_core__["d" /* ready */](function () {
      var chart = __WEBPACK_IMPORTED_MODULE_4__amcharts_amcharts4_core__["c" /* create */](_this.$refs.chartdiv, __WEBPACK_IMPORTED_MODULE_5__amcharts_amcharts4_charts__["d" /* XYChart */]);

      chart.paddingleft = 0;
      chart.paddingRight = 40;

      var data = [];

      chart.data = data;
      // let title = chart.titles.create()

      // title.text = 'Reproducciones por Período de Tiempo'
      // title.fontSize = 15

      var dateAxis = chart.xAxes.push(new __WEBPACK_IMPORTED_MODULE_5__amcharts_amcharts4_charts__["a" /* DateAxis */]());
      dateAxis.renderer.grid.template.location = 0;

      var valueAxis = chart.yAxes.push(new __WEBPACK_IMPORTED_MODULE_5__amcharts_amcharts4_charts__["c" /* ValueAxis */]());
      valueAxis.tooltip.disabled = true;
      valueAxis.renderer.minWidth = 35;
      // valueAxis.renderer.inside = true
      // valueAxis.title.text = 'Reproducciones'

      var series = chart.series.push(new __WEBPACK_IMPORTED_MODULE_5__amcharts_amcharts4_charts__["b" /* LineSeries */]());
      series.dataFields.dateX = 'timestamp';
      series.dataFields.valueY = 'reproductions';
      series.stroke = __WEBPACK_IMPORTED_MODULE_4__amcharts_amcharts4_core__["b" /* color */]('white');
      series.tooltipText = '{timestamp}: {reproductions}';
      series.tooltip.getFillFromObject = false;
      series.tooltip.background.fill = __WEBPACK_IMPORTED_MODULE_4__amcharts_amcharts4_core__["b" /* color */]('#E6007E');

      chart.cursor = new __WEBPACK_IMPORTED_MODULE_5__amcharts_amcharts4_charts__["e" /* XYCursor */]();

      // Add scrollbar
      chart.scrollbarX = new __WEBPACK_IMPORTED_MODULE_4__amcharts_amcharts4_core__["a" /* Scrollbar */]();
      chart.scrollbarX.height = 10;
      chart.scrollbarX.minHeight = 10;
      chart.scrollbarX.startGrip.background.fill = __WEBPACK_IMPORTED_MODULE_4__amcharts_amcharts4_core__["b" /* color */]('#d3d3d3');
      chart.scrollbarX.endGrip.background.fill = __WEBPACK_IMPORTED_MODULE_4__amcharts_amcharts4_core__["b" /* color */]('#d3d3d3');
      chart.scrollbarX.thumb.background.fill = __WEBPACK_IMPORTED_MODULE_4__amcharts_amcharts4_core__["b" /* color */]('#d3d3d3');

      _this.chart = chart;
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
    }
  },
  data: function data() {
    return {
      chart: null,
      dateFrom: '',
      dateTo: '',
      dateRange: '',
      dataChart: null,
      dia: 1000 * 60 * 60 * 24,
      /* table, definicion */
      fields: [{ key: 'picture', label: '' }, { key: 'title', sortable: true }, { key: 'artistName', tdClass: 'artistColor' }, { key: 'reproductions', sortable: true, sortDirection: 'desc' }, { key: 'likes', sortable: true }]
    };
  },


  components: {},

  watch: {
    /*
    al grafico se le cambia el array de datos mediante un objeto, agregamos un observador y un estado en el store, me avisa una vez que los datos estan disponibles
    */
    reproductionsRefresh: function reproductionsRefresh(newQuestion, oldQuestion) {
      var _this2 = this;

      // this.chart.data = this.reproductions
      // while, array con set de datos con las reproducciones
      this.reproductions.forEach(function (element) {
        // find, busco en array generado con el rango completo seleccionado, generado en 0 con anterioridad
        var index = _this2.dataChart.findIndex(function (element2) {
          return element2.timestamp === element.timestamp;
        });
        if (index !== -1) {
          // assign, el valor de las reproducciones, ahora va a graficar bien, valores en 0, va a mostrar un 0
          _this2.dataChart[index].reproductions = element.reproductions;
        }
      });

      this.chart.data = this.dataChart;
    },
    /*
    como la info del artista es a demanda y no la carga a nivel de aplicacion
    agregamos un observador para cuando cargo la info del artista
    user_type = 0: FAN, user_type = 1: ARTIST, role: ROLE_USER o ROLE_ADMIN
    */
    myArtistInfoRefresh: function myArtistInfoRefresh(newArtist, oldArtist) {
      // check, si usuario es artista
      var artistId = this.myArtistInfo === undefined ? null : this.myArtistInfo.id;

      // assign, valores por defecto para dateRange dateFrom = hoy - 7 dias, dateTo = hoy
      var hoy = new Date();
      var semana = this.dia * 7;
      var operacion = hoy.getTime() - semana;
      var menosSemana = new Date(operacion);

      // this.dateFrom = menosSemana
      // this.dateTo = new Date()
      this.dateRange = [new Date(menosSemana), new Date()];

      // call
      this.getData(menosSemana, new Date(), artistId);
    },
    dateRange: function dateRange(newDateRange, oldDateRange) {
      var fromAux = new Date(newDateRange[0]);
      var toAux = new Date(newDateRange[1]);

      // check, si usuario es artista
      var artistId = this.myArtistInfo === undefined ? null : this.myArtistInfo.id;

      // call
      this.getData(fromAux, toAux, artistId);
    }
  },

  created: function created() {
    // get, informacion del artista
    this.getMyArtistInfo();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('dashboard', ['metrics', 'reproductions', 'songRanking', 'reproductionsRefresh']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('user', ['user']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('artist', ['myArtistInfo', 'myArtistInfoRefresh'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('dashboard', ['getMetrics', 'getReproductions', 'getSongRanking']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('artist', ['getMyArtistInfo']), {
    getImageUrl: function getImageUrl(item) {
      return item.value;
    },
    computedAverage: function computedAverage(value) {
      return typeof value !== 'undefined' ? value.toFixed(2) : 0;
    },
    computedTime: function computedTime(value) {
      return typeof value !== 'undefined' ? (value / 60).toFixed(2) : 0;
    },
    computedImage: function computedImage(value) {
      return __WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].BASE_HOST + '/services' + value;
    },


    rangeClick: function rangeClick(value) {
      var cantidad = null;
      var operacion = null;
      var menosDias = null;

      var hoy = new Date();

      switch (value) {
        case 7:
          cantidad = this.dia * 7;
          operacion = hoy.getTime() - cantidad;
          menosDias = new Date(operacion);
          this.dateFrom = menosDias;
          break;
        case 15:
          cantidad = this.dia * 15;
          operacion = hoy.getTime() - cantidad;
          menosDias = new Date(operacion);
          this.dateFrom = menosDias;
          break;
        case 30:
          cantidad = this.dia * 30;
          operacion = hoy.getTime() - cantidad;
          menosDias = new Date(operacion);
          this.dateFrom = menosDias;
          break;
        case 60:
          cantidad = this.dia * 60;
          operacion = hoy.getTime() - cantidad;
          menosDias = new Date(operacion);
          this.dateFrom = menosDias;
          break;
        case 90:
          cantidad = this.dia * 90;
          operacion = hoy.getTime() - cantidad;
          menosDias = new Date(operacion);
          this.dateFrom = menosDias;
          break;
        case 180:
          cantidad = this.dia * 180;
          operacion = hoy.getTime() - cantidad;
          menosDias = new Date(operacion);
          this.dateFrom = menosDias;
          break;
        default:
          break;
      }

      // this.dateTo = hoy
      this.dateRange = [new Date(menosDias), hoy];

      // check, si usuario es artista
      var artistId = this.myArtistInfo === undefined ? null : this.myArtistInfo.id;

      // call
      this.getData(menosDias, hoy, artistId);
    },

    getData: function getData(dateFrom, dateTo, artistId) {
      var aux1, aux2;

      var param = {
        from: dateFrom.toISOString().substring(0, 10),
        to: dateTo.toISOString().substring(0, 10),
        artistId: artistId

        // clear, generate de datos vacios para chart para el rango de fechas seleccionadao
      };this.dataChart = [];
      var diffInTime = dateTo.getTime() - dateFrom.getTime();
      var diffInDays = diffInTime / (1000 * 3600 * 24);

      // while, tantas veces, como diferencia entre rango seleccionada haya
      for (var i = 0; i <= diffInDays; i++) {
        aux1 = dateFrom.getTime() + i * (1000 * 3600 * 24);
        aux2 = new Date(aux1);

        // add, una json para cada fecha seleccionada, para que no falte ninguna y el grafico funcione bien
        this.dataChart.push({
          reproductions: '0',
          timestamp: aux2.toISOString().substring(0, 10)
        });
      }

      // call, libreria vuex del store, populan estados
      this.getMetrics(param);
      this.getReproductions(param);
      this.getSongRanking(param);
    }
  })
});

/***/ }),
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__consts__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_upload_component__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_upload_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_upload_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__auth__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_spinner_src_ClipLoader_vue__ = __webpack_require__(25);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'user-profile',
  data: function data() {
    return {
      routeName: 'Info',
      files: [],
      color: '#808080',
      size: '30px',
      msg: 'Img size 170x170',
      bitelFreeMusic: false
    };
  },

  components: {
    FontAwesomeIcon: __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome___default.a,
    FileUpload: __WEBPACK_IMPORTED_MODULE_3_vue_upload_component___default.a,
    ClipLoader: __WEBPACK_IMPORTED_MODULE_6_vue_spinner_src_ClipLoader_vue__["a" /* default */]
  },
  created: function created() {
    this.resetError();
  },
  mounted: function mounted() {
    var msisdn = localStorage.getItem('msisdn');
    if (msisdn && msisdn === 'freeMusic') {
      this.bitelFreeMusic = true;
    } else {
      this.bitelFreeMusic = false;
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])('user', ['isLoggedIn', 'isSubscribed', 'isProducer', 'user']), {
    picture: function picture() {
      if (this.user) {
        if (this.user.picture) {
          return __WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].MEDIA_BASE_URL + this.user.picture;
        }
      } else {
        return '/static/assets/Img_Avatar_generico_Beathey.jpg';
      }
    },
    url: function url() {
      if (this.user) {
        if (this.user.picture) {
          return __WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].API_BASE_URL + '/users/uploadUserPicture/picture';
        } else {
          return __WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].API_BASE_URL + '/artists/uploadArtistPicture/picture';
        }
      }
    },

    postFileHeaders: function postFileHeaders() {
      return __WEBPACK_IMPORTED_MODULE_4__auth__["b" /* default */].getHeader();
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('user', ['updateProfileImage']), Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('artist', ['resetError']), {
    imageInputFile: function imageInputFile(newFile, oldFile) {
      // auto start
      if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
        if (!this.$refs.imageUpload.active) {
          this.$refs.imageUpload.active = true;
        }
      }
      if (newFile && oldFile) {
        if (newFile.success !== oldFile.success) {
          if (newFile.response) {
            if (newFile.response.status === 'error') {
              this.$toasted.show(this.$t('error.imageUpload'), { type: 'error' });
            } else {
              this.updateProfileImage(newFile.response.data);
            }
            this.files = [];
          }
        }
      }
    },
    imageInputFilter: function imageInputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Filter non-image file
        if (!/\.(jpg|jpeg|png|webp)$/i.test(newFile.name)) {
          this.$toasted.show(this.$t('tracks.newTrack.imageType'), { type: 'error' });
          return prevent();
        }
      }
    }
  })
});

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_tracks_TracksList_vue__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_spinner_src_ClipLoader_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuedraggable__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_tracks_TrackItemList_vue__ = __webpack_require__(460);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'my-tracks',
  components: {
    TracksList: __WEBPACK_IMPORTED_MODULE_2__components_tracks_TracksList_vue__["a" /* default */],
    ClipLoader: __WEBPACK_IMPORTED_MODULE_3_vue_spinner_src_ClipLoader_vue__["a" /* default */],
    draggable: __WEBPACK_IMPORTED_MODULE_4_vuedraggable___default.a,
    TrackItemList: __WEBPACK_IMPORTED_MODULE_5__components_tracks_TrackItemList_vue__["a" /* default */]
  },
  data: function data() {
    return {
      color: '#808080',
      size: '30px',
      tracks: null,
      showReorderButton: false
    };
  },

  watch: {
    myTracks: function myTracks(newTracks, oldTracks) {
      if (this.myTracks) {
        this.tracks = this.myTracks;
      }
    },
    tracks: function tracks(newTracks, oldTracks) {
      var _this = this;

      var oldPosition = this.myTracks.map(function (x) {
        return x.id;
      });
      var newPosition = this.tracks.map(function (x) {
        return x.id;
      });
      oldPosition.forEach(function (id, idx) {
        if (newPosition.indexOf(id) !== idx) {
          _this.showReorderButton = true;
        }
      });
    }
  },
  created: function created() {
    var _this2 = this;

    this.getMyTracks().catch(function (e) {
      _this2.$toasted.show(_this2.error.message, { type: 'error' });
    });
    this.getMyArtistInfo().catch(function (e) {
      _this2.$toasted.show(_this2.error.message, { type: 'error' });
    });
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('user', ['myTracks', 'error', 'loading']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('artist', ['myArtistInfo']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('player', ['currentTrack']), {
    options: function options() {
      return {
        handle: '.drag-icon'
      };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('user', ['getMyTracks']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('track', ['setMyTrackOrder']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('artist', ['getMyArtistInfo']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('player', ['setPlaylist']), {
    confirmTracksOrderChange: function confirmTracksOrderChange() {
      var _this3 = this;

      var newOrder = [];
      this.tracks.forEach(function (track, idx) {
        newOrder.push({
          track_id: track.id,
          order_position: idx + 1
        });
      });
      this.setMyTrackOrder({
        artist_id: this.myArtistInfo.id,
        reorder: newOrder
      }).then(function (res) {
        if (res === 'ok') {
          _this3.$toasted.show(_this3.$t('tracks.editTrack.listUploaded'), { type: 'success' });
          _this3.showReorderButton = false;
        }
      });
    }
  })
});

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_playlists_PlaylistList_vue__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_spinner_src_ClipLoader_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__carousel_MyPlaylistsCarousel_vue__ = __webpack_require__(1116);

//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'my-playlists',
  data: function data() {
    return {
      color: '#808080',
      size: '30px'
    };
  },
  created: function created() {
    var _this = this;

    this.getMyPlaylists().catch(function (e) {
      _this.$toasted.show(_this.error.message, { type: 'error' });
    });
  },

  components: {
    PlaylistList: __WEBPACK_IMPORTED_MODULE_2__components_playlists_PlaylistList_vue__["a" /* default */],
    ClipLoader: __WEBPACK_IMPORTED_MODULE_3_vue_spinner_src_ClipLoader_vue__["a" /* default */],
    MyPlaylistsCarousel: __WEBPACK_IMPORTED_MODULE_4__carousel_MyPlaylistsCarousel_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('user', ['myPlaylists', 'error']), {
    loading: function loading() {
      return this.$loading.isLoading('user getMyPlaylists');
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('user', ['getMyPlaylists']))
});

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CarouselItem_vue__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PlaylistProfile_ModalPlaylistCard_vue__ = __webpack_require__(269);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    CarouselItem: __WEBPACK_IMPORTED_MODULE_2__CarouselItem_vue__["a" /* default */],
    ModalPlaylistCard: __WEBPACK_IMPORTED_MODULE_3__PlaylistProfile_ModalPlaylistCard_vue__["a" /* default */]
  },
  name: 'my-playlists-carousel',
  props: {
    playlists: {
      default: false
    }
  },
  data: function data() {
    return {
      color: '#808080',
      size1: '100px',
      size2: '30px',
      disablePagination: false,
      carouselTranslatePosition: 0,
      translatePosition: 0
    };
  },

  methods: {
    carouselTranslate: function carouselTranslate(element, arrow) {
      var transitionValue = 200;
      if (element === 'playlistsCarousel') {
        this.carouselTranslatePosition += arrow === 'left' ? transitionValue : transitionValue * -1;
        this.translatePosition = this.carouselTranslatePosition;
      }

      if (this.translatePosition >= transitionValue) {
        this.translatePosition = 0;
        this.carouselTranslatePosition = 0;
      }

      if (this.translatePosition <= -(transitionValue * this.playlists.length) && element === 'playlistsCarousel') {
        this.translatePosition = -(transitionValue * (this.playlists.length - 1));
        this.carouselTranslatePosition = -(transitionValue * (this.playlists.length - 1));
      }

      var style = 'transform: translateX(' + this.translatePosition.toString() + 'px' + ')';
      this.$el.querySelector('#' + element).style = style;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('player', ['currentTrack']))
});

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CarouselItem_vue__ = __webpack_require__(545);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03c1d3f2_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CarouselItem_vue__ = __webpack_require__(1119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1118)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-03c1d3f2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CarouselItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03c1d3f2_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CarouselItem_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03c1d3f2_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CarouselItem_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_tracks_TrackOptionsButton_vue__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fortawesome_vue_fontawesome__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__fortawesome_vue_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__consts__ = __webpack_require__(21);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'carousel-item',
  props: {
    track: {
      default: false
    },
    playlist: {
      default: false
    },
    isMyFavorites: {
      default: false
    },
    isMyPlaylists: {
      default: false
    }
  },
  data: function data() {
    return {
      trackTime: null,
      liking: null
    };
  },

  components: {
    TrackOptionsButton: __WEBPACK_IMPORTED_MODULE_2__components_tracks_TrackOptionsButton_vue__["a" /* default */],
    FontAwesomeIcon: __WEBPACK_IMPORTED_MODULE_3__fortawesome_vue_fontawesome___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('player', ['currentTrack', 'isPlaying']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('track', ['loading', 'allTracks']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('playlist', ['playlistLiked']), {
    trackPicture: function trackPicture() {
      return __WEBPACK_IMPORTED_MODULE_4__consts__["a" /* default */].MEDIA_BASE_URL + this.track.picture;
    },
    playlistPicture: function playlistPicture() {
      if (!this.playlist.picture) {
        return __WEBPACK_IMPORTED_MODULE_4__consts__["a" /* default */].BASE_HOST + '/static/assets/Img_comodines_Beathey_Playlist.jpg';
      }
      return __WEBPACK_IMPORTED_MODULE_4__consts__["a" /* default */].MEDIA_BASE_URL + this.playlist.picture;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('player', ['setPlaying', 'changeTrack']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('playlist', ['togglePlaylistLike']), {
    playTrack: function playTrack() {
      if (this.currentTrack !== this.track) {
        this.$emit('play');
        this.changeTrack(this.track);
      } else {
        this.setPlaying(true);
      }
    },
    trackTimeToMin: function trackTimeToMin() {
      var seg = this.track.seconds;
      var min = 0;
      this.trackTime = 0;
      for (var i = 0; i < 60; i++) {
        if (seg >= 60) {
          min++;
          seg -= 60;
        } else if (seg < 60) {
          if (seg <= 9) {
            this.trackTime = min + ':0' + seg;
            return this.trackTime;
          } else {
            this.trackTime = min + ':' + seg;
            return this.trackTime;
          }
        }
      }
    },
    likePlaylist: function likePlaylist() {
      var _this = this;

      this.togglePlaylistLike(this.playlist.id).then(function () {
        _this.liking = _this.playlistLiked;
      }).catch(function (e) {
        // console.log('error')
        // console.log(e.message)
        // this.$toasted.show(this.error.message, {type: 'error'})
      });
    }
  }),
  mounted: function mounted() {
    this.trackTimeToMin();
    this.liking = this.playlist.liked;
  }
});

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_tracks_TrackData__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__consts__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fortawesome_vue_fontawesome__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__fortawesome_vue_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_tracks_SimpleTracksList_vue__ = __webpack_require__(398);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'modal-playlist-card',
  props: {
    playlist: {
      default: null
    },
    isPlaylistList: {
      default: false
    },
    isProfile: {
      default: false
    }
  },
  data: function data() {
    return {
      liking: null
    };
  },

  components: {
    TrackData: __WEBPACK_IMPORTED_MODULE_1__components_tracks_TrackData__["a" /* default */],
    FontAwesomeIcon: __WEBPACK_IMPORTED_MODULE_4__fortawesome_vue_fontawesome___default.a,
    SimpleTracksList: __WEBPACK_IMPORTED_MODULE_5__components_tracks_SimpleTracksList_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    playlistPicture: function playlistPicture() {
      if (this.playlist.picture) {
        return __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].MEDIA_BASE_URL + this.playlist.picture;
      } else {
        return __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].BASE_HOST + '/static/assets/Img_comodines_Beathey_Playlist.jpg';
      }
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('player', ['isPlaying']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('user', ['myPlaylists', 'user']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('playlist', ['playlistLiked']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('playlist', {
    selectedPlaylist: 'playlist'
  }), {
    isMyPlaylist: function isMyPlaylist() {
      return this.user && this.playlist.user.id === this.user.id;
    },
    picture: function picture() {
      if (this.playlist.picture) {
        return __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].MEDIA_BASE_URL + this.playlist.picture;
      } else {
        return '/static/assets/Img_comodines_Beathey_Playlist.jpg';
      }
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('player', ['setPlaylist', 'changeTrack', 'playFirstTrack']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('playlist', ['delete', 'togglePlaylistLike']), {
    deletePlaylist: function deletePlaylist() {
      var _this = this;

      this.$modal.show('dialog', {
        title: this.$t('playlists.delete.title'),
        text: this.$t('playlists.delete.confirm'),
        buttons: [{
          title: this.$t('app.yes'),
          handler: function handler() {
            _this.delete(_this.playlist.id).then(function () {
              _this.$toasted.show(_this.$t('playlists.delete.success'), { type: 'success' });
            }).catch(function (e) {
              _this.$toasted.show(_this.error.message, { type: 'error' });
            });
            _this.$modal.hide('dialog');
          }
        }, {
          title: this.$t('app.no'),
          default: true,
          handler: function handler() {
            _this.$modal.hide('dialog');
          }
        }]
      });
    },
    editPlaylist: function editPlaylist() {
      this.$modal.show('new-playlist-modal', { playlist: this.playlist, picturePath: this.picture });
    },
    sharePlaylist: function sharePlaylist() {
      this.$modal.show('share-modal', {
        link: __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].BASE_HOST + '/services/share/playlist/' + this.playlist.id,
        title: this.playlist.title,
        // playlist de artistname
        description: '',
        playlist: this.playlist
      });
    },
    likePlaylist: function likePlaylist() {
      var _this2 = this;

      this.togglePlaylistLike(this.playlist.id).then(function () {
        _this2.liking = _this2.playlistLiked;
      }).catch(function (e) {
        _this2.$toasted.show(_this2.error.message, { type: 'error' });
      });
    }
  }),
  mounted: function mounted() {
    this.liking = this.playlist.liked;
  },

  watch: {
    selectedPlaylist: function selectedPlaylist() {
      var _this3 = this;

      this.$root.$on('togglePlaylistLike', function (id) {
        if (_this3.playlist.id === id) {
          _this3.liking = _this3.selectedPlaylist.liked;
        }
      });
    }
  }
});

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_tracks_TracksList_vue__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_spinner_src_ClipLoader_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_carousel__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_artists_ArtistCard__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_infinite_scroll__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_infinite_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_infinite_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__carousel_CustomCarousel_vue__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_debounce__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_debounce__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'my-favorites',
  props: {
    withFilters: {
      default: true
    },
    withPagination: {
      default: true
    },
    showGenMain: {
      default: true
    },
    showGenSecon: {
      default: true
    },
    profileTracks: {
      default: false
    }
  },
  data: function data() {
    return {
      color: '#808080',
      size: '30px',
      artists: null,
      size1: '100px',
      size2: '30px',
      disablePagination: false,
      genSeconByMain: [],
      genMainTranslatePosition: 0,
      genSeconTranslatePosition: 0,
      hasSelectedGenMain: false,
      hasSelectedGenSecon: false,
      genMainLastEvent: { // emazzu, para mantener el color de padre seleccionado
        event: null,
        background: null,
        color: null
      },
      busy: false,
      translatePosition: null,
      textToFilter: '',
      isUpdate: false,
      discoverSelectedGenre: null,
      mainGenre: {
        name: null,
        id: null
      },
      seconGenre: {
        name: null,
        id: null
      },
      filteredText: null
    };
  },

  components: {
    TracksList: __WEBPACK_IMPORTED_MODULE_2__components_tracks_TracksList_vue__["a" /* default */],
    ClipLoader: __WEBPACK_IMPORTED_MODULE_3_vue_spinner_src_ClipLoader_vue__["a" /* default */],
    Carousel: __WEBPACK_IMPORTED_MODULE_4_vue_carousel__["Carousel"],
    Slide: __WEBPACK_IMPORTED_MODULE_4_vue_carousel__["Slide"],
    ArtistCard: __WEBPACK_IMPORTED_MODULE_5__components_artists_ArtistCard__["a" /* default */],
    CustomCarousel: __WEBPACK_IMPORTED_MODULE_7__carousel_CustomCarousel_vue__["a" /* default */]
  },
  directives: {
    infiniteScroll: __WEBPACK_IMPORTED_MODULE_6_vue_infinite_scroll___default.a
  },
  created: function created() {
    var _this = this;

    this.discoverSelectedGenre = 0;
    this.disablePagination = !this.withPagination;
    if (this.withFilters) {
      this.getGenresMain(true);
      this.setGenreFilter(0);
      this.setArtistGenreFilter(0);
      // this.setPlaylistGenreFilter(0)
    }
    this.getMyFavorites({ genreIdFilter: 0, textToFilter: null }).catch(function (e) {
      _this.$toasted.show(_this.error.message, { type: 'error' });
    });
    this.getMyFollowedArtists({ getIds: null }).then(function (items) {
      _this.artists = items;
    });
    this.getMyLikedPlaylists({ genreIdFilter: 0, textToFilter: null }).catch(function (e) {
      _this.$toasted.show(_this.error.message, { type: 'error' });
    });
  },
  mounted: function mounted() {
    window.scrollTo(0, 0);
  },

  watch: {
    followedArtists: function followedArtists(newArtist, oldArtist) {
      if (this.followedArtists) {
        this.artists = this.followedArtists;
      }
    },
    myFavorites: function myFavorites(newTracks, oldTracks) {}
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('user', ['myFavorites', 'loading', 'error', 'followedArtists', 'myLikedPlaylists']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('player', ['currentTrack']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('track', ['genresMain', 'genreFilter', 'noMoreResults'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('user', ['getMyFavorites', 'getMyFollowedArtists', 'getMyLikedPlaylists']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('track', ['getGenresMain', 'setGenreFilter', 'getAll', 'setFrom']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('player', ['setPlaylist']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('artist', ['getAllArtists', 'setArtistGenreFilter', 'setPageFrom']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('playlist', ['getAllPlaylist', 'setPlaylistFrom', 'setPlaylistGenreFilter']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])('track', ['setDiscoverMainGenre', 'setDiscoverSeconGenre']), {

    update: __WEBPACK_IMPORTED_MODULE_8_debounce___default()(function (e) {
      if (this.textToFilter !== '') {
        this.filteredText = this.textToFilter;
        this.selectTrackByFilter(this.discoverSelectedGenre, this.textToFilter);
        this.selectArtistByFilter(this.discoverSelectedGenre, this.textToFilter);
        this.selectLikedPlaylistByFilter(this.discoverSelectedGenre, this.textToFilter);
        this.textToFilter = '';
      } else {
        this.selectTrackByFilter(this.discoverSelectedGenre, null);
        this.selectArtistByFilter(this.discoverSelectedGenre, null);
        this.selectLikedPlaylistByFilter(this.discoverSelectedGenre, null);
        this.filteredText = null;
      }
    }, 1000, true),

    clearFilters: function clearFilters() {
      this.textToFilter = '';
      this.filteredText = null;
    },


    // emazzu, start, para mantener el color de seleccion en el genero padre
    selectGenMainBlur: function selectGenMainBlur(event) {
      this.genMainLastEvent = {
        background: event.target.style.background,
        color: event.target.style.color,
        event: event
      };
      event.target.style.background = '#E6007E';
      event.target.style.color = 'white';
    },
    selectGenMainFocus: function selectGenMainFocus(event) {
      if (this.genMainLastEvent.event === null) {
        return;
      }

      this.genMainLastEvent.event.target.style.background = this.genMainLastEvent.background;
      this.genMainLastEvent.event.target.style.color = this.genMainLastEvent.color;
    },

    // emazzu, end, para mantener el color de seleccion en el genero padre

    // emazzu, cuando se hace clic en el genero primario
    selectGenMain: function selectGenMain(selectedId) {
      if (selectedId === '') {
        this.genMainLastEvent.event.target.style.background = '';
        this.genMainLastEvent.event.target.style.color = '';
      }
      selectedId = selectedId || 0;
      // emazzu, filter todos los tracks que corresponden al genero primario
      if (this.withFilters && selectedId !== this.genreFilter) {
        this.selectTrackByFilter(selectedId);
        this.selectArtistByFilter(selectedId);
        this.selectLikedPlaylistByFilter(selectedId);
      }

      this.discoverSelectedGenre = selectedId;

      // emazzu, find genero primario seleccionado
      var found = this.genresMain.find(function (ele) {
        return ele.id === selectedId;
      });
      if (selectedId !== 0) {
        this.mainGenre = found;
        this.setDiscoverMainGenre(found);
      } else {
        this.mainGenre = {
          name: null,
          id: null
        };
        this.setDiscoverMainGenre({ name: null, id: null });
      }
      this.seconGenre = {
        name: null,
        id: null
      };
      this.setDiscoverSeconGenre({ name: null, id: null });
      this.textToFilter = '';
      this.filteredText = null;

      // emazzu, si encontro, que siempre va a encontrar, menos si selecciona TODOS
      if (typeof found !== 'undefined') {
        this.genSeconByMain = found.children.sort(function (a, b) {
          if (a.name > b.name) {
            return 1;
          }
          if (a.name < b.name) {
            return -1;
          }
          // a must be equal to b
          return 0;
        });
      } else {
        this.genSeconByMain = [];
      }

      // flags
      this.hasSelectedGenMain = true;
      this.hasSelectedGenSecon = false;

      // flag, si selecciono TODOS, vuelvo para atras uno de los flag
      if (selectedId === '') {
        this.hasSelectedGenMain = false;
      }

      // los 2 filtros siempre visibles, dejamos los flags x las dudas
      this.showGenMain = true;
      this.showGenSecon = true;
      // Resetea lo posicion del genSecon
      var style = 'transform: translateX( 0px)';
      this.$el.querySelector('#genSecon').style = style;
      this.genSeconTranslatePosition = 0;
      this.translatePosition = 0;

      return null;
    },
    selectGenSecon: function selectGenSecon(selectedId) {
      // emazzu, filter todos los tracks que corresponden al genero primario
      if (this.withFilters && selectedId !== this.genreFilter) {
        this.selectTrackByFilter(selectedId);
        this.selectArtistByFilter(selectedId);
        this.selectLikedPlaylistByFilter(selectedId);
      }
      this.discoverSelectedGenre = selectedId;
      this.textToFilter = '';
      this.filteredText = null;

      // flags
      this.hasSelectedGenMain = true;
      this.hasSelectedGenSecon = true;

      // los 2 filtros siempre visibles, dejamos los flags x las dudas
      this.showGenMain = true;
      this.showGenSecon = true;
      var found = this.genSeconByMain.find(function (ele) {
        return ele.id === selectedId;
      });
      this.seconGenre = found;
      this.setDiscoverSeconGenre(found);

      return null;
    },
    selectTrackByFilter: function selectTrackByFilter() {
      var _this2 = this;

      var selectedId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var textToFilter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      this.setGenreFilter(selectedId);
      this.setFrom(0);
      /*
      this.getAll(textToFilter).catch((e) => {
        this.$toasted.show(this.error.message, { type: 'error' })
      })
      */
      this.getMyFavorites({ genreIdFilter: selectedId, textToFilter: textToFilter }).then(function (items) {
        _this2.tracksList = items;
      }).catch(function (e) {
        _this2.$toasted.show(_this2.error.message, { type: 'error' });
      });
    },
    selectArtistByFilter: function selectArtistByFilter() {
      var _this3 = this;

      var selectedId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var textToFilter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      this.setArtistGenreFilter(selectedId);
      this.setPageFrom(0);
      /*
      this.getAllArtists(textToFilter).catch((e) => {
        this.$toasted.show(this.error.message, {type: 'error'})
      })
      */
      this.getMyFollowedArtists({ getIds: null, genreIdFilter: selectedId, textToFilter: textToFilter }).then(function (items) {
        _this3.artists = items;
      }).catch(function (e) {
        _this3.$toasted.show(_this3.error.message, { type: 'error' });
      });
    },
    selectLikedPlaylistByFilter: function selectLikedPlaylistByFilter() {
      var _this4 = this;

      var selectedId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var textToFilter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      this.setPlaylistGenreFilter(selectedId);
      this.setPlaylistFrom(0);
      this.getMyLikedPlaylists({ genreIdFilter: selectedId, textToFilter: textToFilter }).catch(function (e) {
        _this4.$toasted.show(_this4.error.message, { type: 'error' });
      });
    },


    // emazzu, transition genero principal y secundario
    genTranslate: function genTranslate(element, arrow) {
      var transitionValue = 120;

      if (element === 'genMain') {
        this.genMainTranslatePosition += arrow === 'left' ? transitionValue : transitionValue * -1;
        this.translatePosition = this.genMainTranslatePosition;
      }

      if (element === 'genSecon') {
        this.genSeconTranslatePosition += arrow === 'left' ? transitionValue : transitionValue * -1;
        this.translatePosition = this.genSeconTranslatePosition;
      }

      if (this.translatePosition >= 120) {
        this.translatePosition = 0;
        this.genMainTranslatePosition = 0;
        this.genSeconTranslatePosition = 0;
      }
      if (this.translatePosition <= -(120 * (this.genresMain.length - 1)) && element === 'genMain') {
        this.translatePosition = -(120 * (this.genresMain.length - 1));
        this.genMainTranslatePosition = -(120 * (this.genresMain.length - 1));
        this.genSeconTranslatePosition = 0;
      }
      if (this.translatePosition <= -(120 * (this.genSeconByMain.length - 1)) && element === 'genSecon') {
        this.translatePosition = -(120 * (this.genSeconByMain.length - 1));
        this.genMainTranslatePosition = 0;
        this.genSeconTranslatePosition = -(120 * (this.genSeconByMain.length - 1));
      }
      var style = 'transform: translateX(' + this.translatePosition.toString() + 'px' + ')';
      this.$el.querySelector('#' + element).style = style;
    },
    filterByMainGenreLabel: function filterByMainGenreLabel() {
      this.genMainLastEvent.event.target.style.background = '';
      this.genMainLastEvent.event.target.style.color = '';
      this.mainGenre = {
        name: null,
        id: null
      };
      this.seconGenre = {
        name: null,
        id: null
      };
      this.setDiscoverMainGenre({ name: null, id: null });
      this.setDiscoverSeconGenre({ name: null, id: null });
      this.genSeconByMain = [];
      var text = this.filteredText ? this.filteredText : null;
      this.discoverSelectedGenre = 0;
      this.selectTrackByFilter(0, text);
      this.selectArtistByFilter(0, text);
      this.selectLikedPlaylistByFilter(0, text);
    },
    removeSeconGenreLabel: function removeSeconGenreLabel() {
      this.seconGenre = {
        name: null,
        id: null
      };
      this.setDiscoverSeconGenre({ name: null, id: null });
      var text = this.filteredText ? this.filteredText : null;
      this.discoverSelectedGenre = this.mainGenre.id;
      this.selectTrackByFilter(this.mainGenre.id, text);
      this.selectArtistByFilter(this.mainGenre.id, text);
      this.selectLikedPlaylistByFilter(this.mainGenre.id, text);
    },
    removeFilteredTextLabel: function removeFilteredTextLabel() {
      this.clearFilters();
      this.selectTrackByFilter(this.discoverSelectedGenre);
      this.selectArtistByFilter(this.discoverSelectedGenre);
      this.selectLikedPlaylistByFilter(this.discoverSelectedGenre);
    }
  })
});

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fortawesome_vue_fontawesome__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__fortawesome_vue_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__consts__ = __webpack_require__(21);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'artist-card',
  props: {
    artist: {
      default: null
    },
    isArtistList: {
      default: false
    },
    isProfile: {
      default: false
    }
  },
  components: { FontAwesomeIcon: __WEBPACK_IMPORTED_MODULE_1__fortawesome_vue_fontawesome___default.a },
  computed: {
    hasTracks: function hasTracks() {
      return this.artist.tracks && this.artist.tracks.length > 0;
    },
    listPicture: function listPicture() {
      if (this.artist.picture) {
        if (this.isProfile) {
          return __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].MEDIA_BASE_URL + '/uploads/users/' + this.artist.picture;
        } else {
          return __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].MEDIA_BASE_URL + this.artist.picture;
        }
      } else {
        return '/static/assets/Img_Avatar_generico_Beathey.jpg';
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('player', ['setPlaylist', 'playFirstTrack']), {
    playArtistTracks: function playArtistTracks() {
      this.setPlaylist(this.artist.tracks);
      this.playFirstTrack();
    }
  })
});

/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomCarousel_vue__ = __webpack_require__(550);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cd27dd9_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomCarousel_vue__ = __webpack_require__(1129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1128)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2cd27dd9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomCarousel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cd27dd9_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomCarousel_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cd27dd9_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomCarousel_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CarouselItem_vue__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__artists_ArtistCard__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PlaylistProfile_ModalPlaylistCard_vue__ = __webpack_require__(269);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    CarouselItem: __WEBPACK_IMPORTED_MODULE_2__CarouselItem_vue__["a" /* default */],
    ArtistCard: __WEBPACK_IMPORTED_MODULE_3__artists_ArtistCard__["a" /* default */],
    ModalPlaylistCard: __WEBPACK_IMPORTED_MODULE_4__PlaylistProfile_ModalPlaylistCard_vue__["a" /* default */]
  },
  name: 'custom-carousel',
  props: {
    withFilters: {
      default: true
    },
    allTracks: {
      default: false
    },
    artists: {
      default: false
    },
    playlists: {
      default: false
    },
    recommendedPlaylists: {
      default: false
    },
    withPagination: {
      default: true
    },
    loading: {
      required: true
    },
    showGenMain: {
      default: true
    },
    showGenSecon: {
      default: true
    },
    profileTracks: {
      default: false
    },
    textToFilter: {
      default: 'null'
    },
    isMyFavorites: {
      default: false
    }
  },
  data: function data() {
    return {
      color: '#808080',
      size1: '100px',
      size2: '30px',
      disablePagination: false,
      genMainTranslatePosition: 0,
      genMainLastEvent: { // emazzu, para mantener el color de padre seleccionado
        event: null,
        background: null,
        color: null
      },
      busy: false,
      translatePosition: 0,
      filterText: this.textToFilter
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('track', ['getGenresMain', 'setGenreFilter', 'getAll', 'loadMore', 'setFrom']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('player', ['setPlaylist', 'setPlaying', 'changeTrack']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('artist', ['loadMoreArtists']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('playlist', ['loadMorePlaylist']), {
    playTrack: function playTrack(track) {
      if (this.currentTrack !== track) {
        this.$emit('play');
        this.changeTrack(track);
      } else {
        this.setPlaying(true);
      }
    },
    resetPositions: function resetPositions() {
      this.translatePosition = 0;
      this.genMainTranslatePosition = 0;
      var style = 'transform: translateX(' + this.translatePosition.toString() + 'px' + ')';
      this.$el.querySelector('#genMain').style = style;
    },
    setPlayer: function setPlayer(track, playlist) {
      this.setPlaylist(playlist);
      this.playTrack(track);
    },


    // emazzu, start, para mantener el color de seleccion en el genero padre
    selectGenMainBlur: function selectGenMainBlur(event) {
      this.genMainLastEvent = {
        background: event.target.style.background,
        color: event.target.style.color,
        event: event
      };
      event.target.style.background = '#E6007E';
      event.target.style.color = 'white';
    },

    // emazzu, end, para mantener el color de seleccion en el genero padre

    nextPage: function nextPage() {
      var _this = this;

      if (this.filterText === '' || this.filterText === null) {
        this.filterText = null;
      }
      if (!this.preventLoadMore) {
        this.busy = true;
        if (this.artists) {
          this.loadMoreArtists(this.filterText).then(function () {
            _this.busy = false;
          });
        }
        if (this.allTracks) {
          this.loadMore(this.filterText).then(function (res) {
            _this.busy = false;
          });
        }
        if (this.playlists) {
          this.loadMorePlaylist(this.filterText).then(function () {
            _this.busy = false;
          });
        }
        if (this.recommendedPlaylists) {
          this.loadMoreRecommendedPlaylist(this.filterText).then(function () {
            _this.busy = false;
          });
        }
      }
    },
    genTranslate: function genTranslate(element, arrow) {
      var transitionValue = 200;
      if (!this.busy) {
        if (element === 'genMain') {
          this.genMainTranslatePosition += arrow === 'left' ? transitionValue : transitionValue * -1;
          this.translatePosition = this.genMainTranslatePosition;
        }

        if (this.translatePosition >= transitionValue) {
          this.translatePosition = 0;
          this.genMainTranslatePosition = 0;
        }

        if (this.translatePosition <= -(transitionValue * (this.allTracks.length - 3)) && element === 'genMain' && arrow === 'right') {
          // this.nextPage()
        }

        if (this.translatePosition <= -(transitionValue * (this.artists.length - 3)) && element === 'genMain' && arrow === 'right') {
          // this.nextPage()
        }

        if (this.translatePosition <= -(transitionValue * (this.playlists.length - 3)) && element === 'genMain' && arrow === 'right') {
          // this.nextPage()
        }

        if (this.translatePosition <= -(transitionValue * (this.recommendedPlaylists.length - 3)) && element === 'genMain' && arrow === 'right') {
          // this.nextPage()
        }

        if (this.translatePosition <= -(transitionValue * this.allTracks.length) && element === 'genMain') {
          this.translatePosition = -(transitionValue * (this.allTracks.length - 2));
          this.genMainTranslatePosition = -(transitionValue * (this.allTracks.length - 2));
        }

        if (this.translatePosition <= -(transitionValue * this.artists.length) && element === 'genMain') {
          this.translatePosition = -(transitionValue * (this.artists.length - 4));
          this.genMainTranslatePosition = -(transitionValue * (this.artists.length - 4));
        }

        if (this.translatePosition <= -(transitionValue * this.playlists.length) && element === 'genMain') {
          this.translatePosition = -(transitionValue * (this.playlists.length - 1));
          this.genMainTranslatePosition = -(transitionValue * (this.playlists.length - 1));
        }

        if (this.translatePosition <= -(transitionValue * this.recommendedPlaylists.length) && element === 'genMain') {
          this.translatePosition = -(transitionValue * (this.recommendedPlaylists.length - 1));
          this.genMainTranslatePosition = -(transitionValue * (this.recommendedPlaylists.length - 1));
        }

        var style = 'transform: translateX(' + this.translatePosition.toString() + 'px' + ')';
        this.$el.querySelector('#' + element).style = style;
      }
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('player', ['currentTrack']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('track', ['genresMain', 'genreFilter', 'noMoreResults']), {
    loadingMore: function loadingMore() {
      return this.$loading.isLoading('track loadMore');
    },
    preventLoadMore: function preventLoadMore() {
      return this.loadingMore || this.noMoreResults || this.busy;
    },
    loadingGenresMain: function loadingGenresMain() {
      return this.$loading.isLoading('track getGenresMain');
    }
  }),
  watch: {
    genreFilter: function genreFilter() {
      this.resetPositions();
    }
  }
});

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_tracks_TrackDownload_vue__ = __webpack_require__(1132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_spinner_src_ClipLoader_vue__ = __webpack_require__(25);

//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'my-shopping',
  components: {
    TrackDownload: __WEBPACK_IMPORTED_MODULE_2__components_tracks_TrackDownload_vue__["a" /* default */],
    ClipLoader: __WEBPACK_IMPORTED_MODULE_3_vue_spinner_src_ClipLoader_vue__["a" /* default */]
  },
  data: function data() {
    return {
      color: '#808080',
      size: '30px'
    };
  },
  created: function created() {
    var _this = this;

    this.getMyShopping().catch(function (e) {
      _this.$toasted.show(_this.error.message, { type: 'error' });
    });
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('user', ['error', 'loading', 'myShopping'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('user', ['getMyShopping']))
});

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TrackDownloadItemList_vue__ = __webpack_require__(1134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_spinner_src_ClipLoader_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_infinite_scroll__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_infinite_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_infinite_scroll__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'track-download',
  props: {
    purchasedTracks: {
      required: true
    },
    withFilters: {
      default: true
    },
    withPagination: {
      default: true
    },
    loading: {
      required: true
    }
  },
  components: {
    ClipLoader: __WEBPACK_IMPORTED_MODULE_3_vue_spinner_src_ClipLoader_vue__["a" /* default */],
    TrackDownloadItemList: __WEBPACK_IMPORTED_MODULE_2__TrackDownloadItemList_vue__["a" /* default */]
  },
  directives: { infiniteScroll: __WEBPACK_IMPORTED_MODULE_4_vue_infinite_scroll___default.a },
  data: function data() {
    return {
      color: '#808080',
      size1: '100px',
      size2: '30px',
      disablePagination: false
    };
  },
  created: function created() {
    this.disablePagination = !this.withPagination;
    if (this.withFilters) {
      this.getGenres();
      this.setGenreFilter('');
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('track', ['getGenres', 'setGenreFilter', 'getAll', 'loadMore', 'setFrom']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('player', ['setPlaylist']), {
    selectGenre: function selectGenre(id) {
      var _this = this;

      if (this.withFilters && id !== this.genreFilter) {
        this.setGenreFilter(id);
        this.setFrom(0);
        this.getAll().catch(function (e) {
          _this.$toasted.show(_this.error.message, { type: 'error' });
        });
      }
    },
    nextPage: function nextPage() {
      if (this.withPagination && !this.loadingMore && !this.noMoreResults) {
        this.loadMore();
      }
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('player', ['currentTrack']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('track', ['allTracks', 'genres', 'genreFilter', 'noMoreResults']), {
    loadingMore: function loadingMore() {
      return this.$loading.isLoading('tarck loadMore');
    },
    loadingGenres: function loadingGenres() {
      return this.$loading.isLoading('track getGenres');
    }
  })
});

/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__consts__ = __webpack_require__(21);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'track-download-item-list',
  props: {
    purchase: {
      required: true
    }
  },
  data: function data() {
    return {
      trackTime: null,
      download_url: null,
      payment_date: null
    };
  },

  components: {},
  created: function created() {
    this.download_url = __WEBPACK_IMPORTED_MODULE_0__consts__["a" /* default */].API_BASE_URL + '/tracks/download/' + this.purchase.hash.hash;
  },

  computed: {},
  methods: {
    trackTimeToMin: function trackTimeToMin() {
      var seg = this.purchase.track.seconds;
      var min = 0;
      this.trackTime = 0;
      for (var i = 0; i < 60; i++) {
        if (seg > 60) {
          min++;
          seg -= 60;
        } else if (seg < 60) {
          if (seg <= 9) {
            this.trackTime = min + ':0' + seg;
            return this.trackTime;
          } else {
            this.trackTime = min + ':' + seg;
            return this.trackTime;
          }
        }
      }
    },
    formatPaymentDate: function formatPaymentDate() {
      var d = this.purchase.payment.date.split('T');
      this.payment_date = d[0].split('-').reverse().join('-');
    }
  },
  mounted: function mounted() {
    this.trackTimeToMin();
    this.formatPaymentDate();
  }
});

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__countries__ = __webpack_require__(1141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MyArtistInfo_vue__ = __webpack_require__(1142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fortawesome_vue_fontawesome__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__fortawesome_vue_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_spinner_src_ClipLoader_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__consts__ = __webpack_require__(21);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'my-info',
  data: function data() {
    return {
      months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
      username: '',
      name: '',
      surname: '',
      password: '',
      password2: '',
      dni: '',
      phone: '',
      email: '',
      email2: '',
      address: '',
      day: '',
      month: '',
      year: '',
      userType: 0,
      bio: '',
      country: '',
      city: '',
      edit: true,
      color: '#808080',
      size: '30px',
      countries: __WEBPACK_IMPORTED_MODULE_3__countries__["a" /* default */].countries,
      currentYear: new Date().getFullYear(),
      subscriptionGateway: null,
      acceptNewsLetter: 1,
      acceptShareInfo: 1,
      link: '',
      rcode: '',
      disableButton: false
    };
  },

  components: {
    FontAwesomeIcon: __WEBPACK_IMPORTED_MODULE_5__fortawesome_vue_fontawesome___default.a,
    ClipLoader: __WEBPACK_IMPORTED_MODULE_6_vue_spinner_src_ClipLoader_vue__["a" /* default */],
    MyArtistInfo: __WEBPACK_IMPORTED_MODULE_4__MyArtistInfo_vue__["a" /* default */]
  },
  created: function created() {
    var _this = this;

    if (this.user) {
      this.username = this.user.user_name;
      this.name = this.user.first_name;
      this.surname = this.user.last_name;
      this.dni = this.user.dni;
      this.email = this.user.email;
      this.email2 = this.user.email;
      this.address = this.user.direccion;
      this.phone = this.user.telefono;
      this.userType = this.user.user_type;
      this.bio = this.user.bio;
      this.country = this.user.country;
      this.city = this.user.city;
      if (this.user.birth) {
        var bd = this.user.birth.split('-');
        this.year = bd[0];
        this.month = bd[1] - 1;
        this.day = bd[2];
      }
      this.acceptNewsLetter = this.user.accept_news_letter;
      this.acceptShareInfo = this.user.accept_share_info;
    }
    this.checkSubscriptionGateway().then(function (res) {
      _this.subscriptionGateway = res;
    });
  },
  mounted: function mounted() {
    var _this2 = this;

    this.checkMyActiveUserReferredPlan().then(function (res) {
      if (res) {
        _this2.link = __WEBPACK_IMPORTED_MODULE_7__consts__["a" /* default */].BASE_HOST + '?referredCode=' + res.code;
        _this2.rcode = res.code;
        _this2.disableButton = true;
      } else {
        _this2.disableButton = false;
      }
    });
  },

  watch: {
    user: function user(newVal) {
      if (newVal !== null) {
        this.username = newVal.user_name;
        this.name = this.user.first_name;
        this.surname = this.user.last_name;
        this.dni = newVal.dni;
        this.email = newVal.email;
        this.email2 = newVal.email;
        this.address = newVal.direccion;
        this.phone = newVal.telefono;
        this.userType = newVal.user_type;
        this.bio = newVal.bio;
        this.country = newVal.country;
        this.city = newVal.city;

        var bd = this.user.birth.split('-');
        this.year = bd[0];
        this.month = bd[1] - 1;
        this.day = bd[2];
        this.acceptNewsLetter = newVal.accept_news_letter;
        this.acceptShareInfo = newVal.accept_share_info;
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])('user', ['error', 'loading', 'input', 'validVoucher', 'user', 'isProducer', 'referredCode', 'isSubscribed']), {
    canRefer: function canRefer() {
      console.log(this.user.id);
      if (this.user && this.user.user_type !== 0 && this.isSubscribed) {
        if (this.user.subscription) {
          if (this.user.subscription.pricing) {
            if (this.user.subscription.pricing.id === 1) {
              return true;
            } else {
              return false;
            }
          } else {
            return false;
          }
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('user', ['register', 'checkVoucher', 'resetError', 'editUser', 'checkSubscriptionGateway', 'cancelBeatheySuscription', 'saveReferredCode', 'checkMyActiveUserReferredPlan', 'deleteBeatheyAccount', 'logout']), {
    editTrigger: function editTrigger() {
      // this.edit = !this.edit
    },
    updateUser: function updateUser() {
      var _this3 = this;

      if (!this.$v.$invalid) {
        this.editUser({
          username: this.username,
          password: this.password,
          name: this.name,
          surname: this.surname,
          dni: this.dni,
          phone: this.phone,
          email: this.email,
          address: this.address,
          birthdate: this.year + '-' + (parseInt(this.month) + 1) + '-' + this.day,
          userType: this.userType,
          country: this.country,
          city: this.city,
          bio: this.bio,
          acceptNewsLetter: this.acceptNewsLetter,
          acceptShareInfo: this.acceptShareInfo
        }).then(function () {
          _this3.editTrigger();
          _this3.$toasted.show(_this3.$t('users.editSuccess'), { type: 'success' });
        }).catch(function (e) {
          _this3.$toasted.show(_this3.error, { type: 'error' });
        });
      } else {
        this.$v.$touch();
      }
    },
    mpCancelSubscription: function mpCancelSubscription() {
      var _this4 = this;

      if (this.user.subscription.pricing.id === 2 && this.user.country === 'PER') {
        // added so telco users of Peru unsuscribe from correct link
        window.location.href = 'https://peentel-hub.wazzupmobile.com/#/out?productId=1000007285';
        return window.location.href;
      }
      if (this.subscriptionGateway.gateway === 'mercadopago') {
        this.$modal.show('dialog', {
          title: this.$t('users.subscription.cancelTitle'),
          text: this.$t('users.subscription.cancelMessage'),
          buttons: [{
            title: this.$t('users.subscription.confirm'),
            handler: function handler() {
              _this4.cancelBeatheySuscription().then(function (res) {
                if (res === 'You can not modify a cancelled preapproval.') {
                  _this4.$toasted.show(_this4.$t('users.subscription.canceledMPsubError'), { type: 'error' });
                  _this4.$modal.hide('dialog');
                }
                if (res) {
                  if (res === 'cancelled') {
                    _this4.$toasted.show(_this4.$t('users.subscription.canceledMPsubSuccess'), { type: 'success' });
                    _this4.$modal.hide('dialog');
                    location.reload();
                  }
                }
              });
            }
          }, {
            title: this.$t('users.subscription.reject'),
            default: true,
            handler: function handler() {
              _this4.$modal.hide('dialog');
            }
          }]
        });
      }
    },
    genToken: function genToken() {
      var _this5 = this;

      var URL = __WEBPACK_IMPORTED_MODULE_7__consts__["a" /* default */].BASE_HOST;
      this.rcode = this.random();
      if (URL === 'http://localhost') {
        this.link = __WEBPACK_IMPORTED_MODULE_7__consts__["a" /* default */].BASE_HOST + ':8081' + '?referredCode=' + this.rcode;
      } else {
        this.link = __WEBPACK_IMPORTED_MODULE_7__consts__["a" /* default */].BASE_HOST + '?referredCode=' + this.rcode;
      }
      this.saveReferredCode(this.rcode).then(function (res) {
        if (res) {
          _this5.link = _this5.link = __WEBPACK_IMPORTED_MODULE_7__consts__["a" /* default */].BASE_HOST + '?referredCode=' + res.code;
          _this5.rcode = res.code;
          _this5.disableButton = true;
        } else {
          _this5.disableButton = false;
        }
      });
    },
    random: function random() {
      return Math.random().toString(16).substr(2) + Math.random().toString(16).substr(2);
    },
    clipboardLinkSuccess: function clipboardLinkSuccess() {
      this.$toasted.show(this.$t('users.copyLinkSucces'), { type: 'success' });
    },
    clipboardCodeSuccess: function clipboardCodeSuccess() {
      this.$toasted.show(this.$t('users.copyCodeSucces'), { type: 'success' });
    },
    clipboardError: function clipboardError() {
      this.$toasted.show(this.$t('users.copyError'), { type: 'error' });
    },
    deleteAccount: function deleteAccount() {
      var _this6 = this;

      this.$modal.show('dialog', {
        title: this.$t('users.subscription.cancelTitle'),
        text: this.$t('users.subscription.cancelAccountMessage'),
        buttons: [{
          title: this.$t('users.subscription.confirm'),
          handler: function handler() {
            _this6.deleteBeatheyAccount().then(function (res) {
              if (!res) {
                _this6.$toasted.show(_this6.$t('users.subscription.cancelAccountError'), { type: 'error' });
                _this6.$modal.hide('dialog');
              }

              if (res) {
                _this6.$toasted.show(_this6.$t('users.subscription.cancelAccountSuccess'), { type: 'success' });
                _this6.$modal.hide('dialog');
                _this6.$auth0.logout();
                _this6.logout();
                _this6.$router.push({ path: '/' });
              }
            });
          }
        }, {
          title: this.$t('users.subscription.reject'),
          default: true,
          handler: function handler() {
            _this6.$modal.hide('dialog');
          }
        }]
      });
    }
  }),
  validations: {
    username: {
      required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
    },
    dni: {
      required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
    },
    phone: {
      numeric: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["numeric"]
    },
    email: {
      required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
      email: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["email"]
    },
    email2: {
      required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
      sameAsEmail: Object(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["sameAs"])('email')
    },
    password2: {
      sameAsEmail: Object(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["sameAs"])('password')
    },
    day: {
      required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
    },
    month: {
      required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
    },
    year: {
      required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
    },
    address: {
      required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
    }
  }
});

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__consts__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_spinner_src_ClipLoader_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fortawesome_vue_fontawesome__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__fortawesome_vue_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_upload_component__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_upload_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_upload_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__auth__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_user_PaymentInfo__ = __webpack_require__(1144);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'my-artist-info',
  data: function data() {
    return {
      color: '#808080',
      size: '50px',
      files: [],
      msg: 'Img size 578x280'
    };
  },

  props: {
    edit: {
      required: true
    }
  },
  components: {
    ClipLoader: __WEBPACK_IMPORTED_MODULE_3_vue_spinner_src_ClipLoader_vue__["a" /* default */],
    FontAwesomeIcon: __WEBPACK_IMPORTED_MODULE_4__fortawesome_vue_fontawesome___default.a,
    FileUpload: __WEBPACK_IMPORTED_MODULE_5_vue_upload_component___default.a,
    PaymentInfo: __WEBPACK_IMPORTED_MODULE_7__components_user_PaymentInfo__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('artist', ['myArtistInfo', 'error']), {
    picture: function picture() {
      if (this.myArtistInfo.primary_picture) {
        return __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].MEDIA_BASE_URL + this.myArtistInfo.path + this.myArtistInfo.primary_picture;
      } else {
        return '/static/assets/Img_generico_principal3.jpg';
      }
    },
    url: function url() {
      return __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].API_BASE_URL + '/artists/uploadArtistPicture/primary_picture';
    },

    postFileHeaders: function postFileHeaders() {
      return __WEBPACK_IMPORTED_MODULE_6__auth__["b" /* default */].getHeader();
    },
    loadingMyArtistInfo: function loadingMyArtistInfo() {
      return this.$loading.isLoading('artist getMyArtistInfo');
    },
    loadingEdit: function loadingEdit() {
      return this.$loading.isLoading('artist editArtist');
    }
  }),
  created: function created() {
    this.getMyArtistInfo();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('artist', ['getMyArtistInfo', 'editArtist', 'updatePrimaryPicture']), {
    updateArtist: function updateArtist() {
      this.editArtist({
        name: this.myArtistInfo.name,
        phrase: this.myArtistInfo.phrase,
        text: this.myArtistInfo.text
      }).then(function () {
        // this.editTrigger()
      }).catch(function (e) {});
    },

    imageInputFile: function imageInputFile(newFile, oldFile) {
      // auto start
      if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
        if (!this.$refs.imageUpload.active) {
          this.$refs.imageUpload.active = true;
        }
      }
      if (newFile && oldFile) {
        if (newFile.success !== oldFile.success) {
          if (newFile.response) {
            if (newFile.response.status === 'error') {
              this.$toasted.show(this.$t('error.imageUpload'), { type: 'error' });
            } else {
              this.updatePrimaryPicture(newFile.response.data);
            }
            this.files = [];
          }
        }
      }
    },
    imageInputFilter: function imageInputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Filter non-image file
        if (!/\.(jpg|jpeg|png|webp)$/i.test(newFile.name)) {
          this.$toasted.show(this.$t('tracks.newTrack.imageType'), { type: 'error' });
          return prevent();
        }
      }
    }
  })
});

/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'payment-info',
  data: function data() {
    return {
      info: null,
      error: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('user', ['user'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('artist', ['getPaymentInfo', 'mpConnect']), {
    connect: function connect() {
      var _this = this;

      this.mpConnect().then(function (res) {
        window.location.href = res.next_url;
      }).catch(function (e) {
        _this.error = e.message;
      });
    }
  }),
  created: function created() {
    var _this2 = this;

    if (this.user.mpConnected) {
      this.getPaymentInfo().then(function (res) {
        _this2.info = res;
      }).catch(function (e) {
        _this2.error = e.message;
      });
    }
  }
});

/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_spinner_src_ClipLoader_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_infinite_scroll__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_infinite_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_infinite_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_carousel__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debounce__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_artists_ArtistCard__ = __webpack_require__(270);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'new-artists-list',
  props: {
    withFilters: {
      default: true
    },
    withPagination: {
      default: true
    },
    loading: {
      required: false
    },
    showGenMain: {
      default: true
    },
    showGenSecon: {
      default: true
    },
    profileTracks: {
      default: false
    }
  },
  components: {
    ClipLoader: __WEBPACK_IMPORTED_MODULE_2_vue_spinner_src_ClipLoader_vue__["a" /* default */],
    Carousel: __WEBPACK_IMPORTED_MODULE_4_vue_carousel__["Carousel"],
    Slide: __WEBPACK_IMPORTED_MODULE_4_vue_carousel__["Slide"],
    ArtistCard: __WEBPACK_IMPORTED_MODULE_6__components_artists_ArtistCard__["a" /* default */]
  },
  directives: {
    infiniteScroll: __WEBPACK_IMPORTED_MODULE_3_vue_infinite_scroll___default.a
  },
  data: function data() {
    return {
      color: '#808080',
      size1: '100px',
      size2: '30px',
      disablePagination: false,
      genSeconByMain: [],
      genMainTranslatePosition: 0,
      genSeconTranslatePosition: 0,
      hasSelectedGenMain: false,
      hasSelectedGenSecon: false,
      genMainLastEvent: { // emazzu, para mantener el color de padre seleccionado
        event: null,
        background: null,
        color: null
      },
      busy: false,
      translatePosition: null,
      textToFilter: '',
      isUpdate: false,
      selectedGenre: null,
      mainGenre: {
        name: null,
        id: null
      },
      seconGenre: {
        name: null,
        id: null
      },
      filteredText: null
    };
  },
  created: function created() {
    if (this.discoverMainGenre && this.discoverMainGenre.name !== null) {
      this.mainGenre = this.discoverMainGenre;
    }
    if (this.discoverSeconGenre && this.discoverSeconGenre.name !== null) {
      this.seconGenre = this.discoverSeconGenre;
    }
    this.selectedGenre = this.genreFilter;
    this.disablePagination = !this.withPagination;
    if (this.withFilters) {
      this.getGenresMain(true);
      if (this.selectedGenre !== null && this.selectedGenre !== '' && this.selectedGenre !== undefined) {
        this.setArtistGenreFilter(this.selectedGenre);
      } else {
        this.setArtistGenreFilter(0);
      }
    }
    this.busy = true;
    this.selectArtistByFilter(this.selectedGenre);
    this.busy = false;
  },
  mounted: function mounted() {
    window.scrollTo(0, 0);
  },


  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('track', ['getGenresMain', 'setGenreFilter', 'getAll', 'setFrom']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('player', ['setPlaylist']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('artist', ['getAllArtists', 'setArtistGenreFilter', 'setPageFrom', 'loadMoreArtists']), {
    loadMorePaginated: function loadMorePaginated() {
      if (this.textToFilter === '' || this.textToFilter === undefined) {
        this.textToFilter = null;
      }
      if (!this.busy) {
        this.loadMore(this.textToFilter);
      }
    },
    clearFilters: function clearFilters() {
      this.textToFilter = '';
      this.busy = false;
      this.filteredText = null;
    },


    update: __WEBPACK_IMPORTED_MODULE_5_debounce___default()(function (e) {
      if (this.textToFilter !== '') {
        this.busy = true;
        this.filteredText = this.textToFilter;
        this.selectArtistByFilter(this.selectedGenre, 0, this.textToFilter);
        this.busy = false;
        this.textToFilter = '';
      } else {
        this.busy = true;
        this.selectArtistByFilter(this.selectedGenre, 0, null);
        this.filteredText = null;
        this.busy = false;
      }
    }, 1000, true),

    // emazzu, start, para mantener el color de seleccion en el genero padre
    selectGenMainBlur: function selectGenMainBlur(event) {
      this.genMainLastEvent = {
        background: event.target.style.background,
        color: event.target.style.color,
        event: event
      };
      event.target.style.background = '#E6007E';
      event.target.style.color = 'white';
    },
    selectGenMainFocus: function selectGenMainFocus(event) {
      if (this.genMainLastEvent.event === null) {
        return;
      }

      this.genMainLastEvent.event.target.style.background = this.genMainLastEvent.background;
      this.genMainLastEvent.event.target.style.color = this.genMainLastEvent.color;
    },

    // emazzu, end, para mantener el color de seleccion en el genero padre

    // emazzu, cuando se hace clic en el genero primario
    selectGenMain: function selectGenMain(selectedId) {
      if (selectedId === '') {
        if (this.genMainLastEvent && this.genMainLastEvent.event) {
          this.genMainLastEvent.event.target.style.background = '';
          this.genMainLastEvent.event.target.style.color = '';
        }
        selectedId = 0;
        this.selectArtistByFilter(selectedId, 0);
      }
      this.selectedGenre = selectedId;

      // emazzu, filter todos los tracks que corresponden al genero primario
      if (this.withFilters && selectedId !== this.genreFilter) {
        this.selectArtistByFilter(selectedId, 0);
      }

      // emazzu, find genero primario seleccionado
      var found = this.genresMain.find(function (ele) {
        return ele.id === selectedId;
      });
      if (selectedId !== 0) {
        this.mainGenre = found;
      } else {
        this.mainGenre = {
          name: null,
          id: null
        };
      }
      this.seconGenre = {
        name: null,
        id: null
      };
      this.textToFilter = '';
      this.filteredText = null;

      // emazzu, si encontro, que siempre va a encontrar, menos si selecciona TODOS
      if (typeof found !== 'undefined') {
        this.genSeconByMain = found.children.sort(function (a, b) {
          if (a.name > b.name) {
            return 1;
          }
          if (a.name < b.name) {
            return -1;
          }
          // a must be equal to b
          return 0;
        });
      } else {
        this.genSeconByMain = [];
      }

      // flags
      this.hasSelectedGenMain = true;
      this.hasSelectedGenSecon = false;

      // flag, si selecciono TODOS, vuelvo para atras uno de los flag
      if (selectedId === '') {
        this.hasSelectedGenMain = false;
      }

      // los 2 filtros siempre visibles, dejamos los flags x las dudas
      this.showGenMain = true;
      this.showGenSecon = true;
      // Resetea lo posicion del genSecon
      var style = 'transform: translateX( 0px)';
      this.$el.querySelector('#genSecon').style = style;
      this.genSeconTranslatePosition = 0;
      this.translatePosition = 0;

      return null;
    },
    selectGenSecon: function selectGenSecon(selectedId) {
      this.selectedGenre = selectedId;
      // emazzu, filter todos los tracks que corresponden al genero primario
      if (this.withFilters && selectedId !== this.genreFilter) {
        this.selectArtistByFilter(selectedId, 0);
      }
      this.textToFilter = '';
      this.filteredText = null;
      // flags
      this.hasSelectedGenMain = true;
      this.hasSelectedGenSecon = true;

      // los 2 filtros siempre visibles, dejamos los flags x las dudas
      this.showGenMain = true;
      this.showGenSecon = true;
      var found = this.genSeconByMain.find(function (ele) {
        return ele.id === selectedId;
      });
      this.seconGenre = found;
      return null;
    },
    selectArtistByFilter: function selectArtistByFilter(selectedId) {
      var _this = this;

      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var textToFilter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      this.setArtistGenreFilter(selectedId);
      this.setPageFrom(0);
      this.getAllArtists(textToFilter).catch(function (e) {
        _this.$toasted.show(_this.error.message, { type: 'error' });
      });
    },
    loadMore: function loadMore() {
      var _this2 = this;

      var textToFilter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      this.busy = true;
      this.loadMoreArtists(textToFilter).then(function (response) {
        _this2.busy = false;
      }).catch(function (e) {
        _this2.$toasted.show(_this2.error.message, { type: 'error' });
        _this2.busy = false;
      });
    },


    // emazzu, transition genero principal y secundario
    genTranslate: function genTranslate(element, arrow) {
      var transitionValue = 120;

      if (element === 'genMain') {
        this.genMainTranslatePosition += arrow === 'left' ? transitionValue : transitionValue * -1;
        this.translatePosition = this.genMainTranslatePosition;
      }

      if (element === 'genSecon') {
        this.genSeconTranslatePosition += arrow === 'left' ? transitionValue : transitionValue * -1;
        this.translatePosition = this.genSeconTranslatePosition;
      }

      if (this.translatePosition >= 120) {
        this.translatePosition = 0;
        this.genMainTranslatePosition = 0;
        this.genSeconTranslatePosition = 0;
      }
      if (this.translatePosition <= -(120 * (this.genresMain.length - 1)) && element === 'genMain') {
        this.translatePosition = -(120 * (this.genresMain.length - 1));
        this.genMainTranslatePosition = -(120 * (this.genresMain.length - 1));
        this.genSeconTranslatePosition = 0;
      }
      if (this.translatePosition <= -(120 * (this.genSeconByMain.length - 1)) && element === 'genSecon') {
        this.translatePosition = -(120 * (this.genSeconByMain.length - 1));
        this.genMainTranslatePosition = 0;
        this.genSeconTranslatePosition = -(120 * (this.genSeconByMain.length - 1));
      }
      var style = 'transform: translateX(' + this.translatePosition.toString() + 'px' + ')';
      this.$el.querySelector('#' + element).style = style;
    },
    filterByMainGenreLabel: function filterByMainGenreLabel() {
      if (this.genMainLastEvent && this.genMainLastEvent.event) {
        this.genMainLastEvent.event.target.style.background = '';
        this.genMainLastEvent.event.target.style.color = '';
      }
      this.mainGenre = {
        name: null,
        id: null
      };
      this.seconGenre = {
        name: null,
        id: null
      };
      this.genSeconByMain = [];
      var text = this.filteredText ? this.filteredText : null;
      this.selectedGenre = 0;
      this.selectArtistByFilter(0, 0, text);
    },
    removeSeconGenreLabel: function removeSeconGenreLabel() {
      this.seconGenre = {
        name: null,
        id: null
      };
      var text = this.filteredText ? this.filteredText : null;
      this.selectedGenre = this.mainGenre.id;
      this.selectArtistByFilter(this.mainGenre.id, 0, text);
    },
    removeFilteredTextLabel: function removeFilteredTextLabel() {
      this.clearFilters();
      this.selectArtistByFilter(this.selectedGenre);
    },
    removeAllLabels: function removeAllLabels() {
      this.selectedGenre = 0;
      this.genSeconByMain = [];
      if (this.genMainLastEvent && this.genMainLastEvent.event) {
        this.genMainLastEvent.event.target.style.background = '';
        this.genMainLastEvent.event.target.style.color = '';
      }
      this.mainGenre = {
        name: null,
        id: null
      };
      this.seconGenre = {
        name: null,
        id: null
      };
      this.filteredText = null;
      if (this.textToFilter === '') {
        this.selectArtistByFilter(0, 0, null);
      } else {
        this.textToFilter = '';
      }
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('player', ['currentTrack']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('track', ['genresMain', 'discoverMainGenre', 'discoverSeconGenre']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('artist', ['artists', 'noMoreResults', 'page', 'genreFilter']), {
    loadingMore: function loadingMore() {
      return this.$loading.isLoading('artist loadMoreArtists');
    },
    preventLoadMore: function preventLoadMore() {
      return this.noMoreResults || this.busy || this.page === 0;
    }
  })
});

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_spinner_src_ClipLoader_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_infinite_scroll__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_infinite_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_infinite_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_carousel__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debounce__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_playlists_PlaylistCard_vue__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PlaylistProfile_ModalPlaylistCard_vue__ = __webpack_require__(269);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'new-playlists-list',
  props: {
    withFilters: {
      default: true
    },
    withPagination: {
      default: true
    },
    loading: {
      required: false
    },
    showGenMain: {
      default: true
    },
    showGenSecon: {
      default: true
    },
    profileTracks: {
      default: false
    }
  },
  components: {
    ClipLoader: __WEBPACK_IMPORTED_MODULE_2_vue_spinner_src_ClipLoader_vue__["a" /* default */],
    Carousel: __WEBPACK_IMPORTED_MODULE_4_vue_carousel__["Carousel"],
    Slide: __WEBPACK_IMPORTED_MODULE_4_vue_carousel__["Slide"],
    PlaylistCard: __WEBPACK_IMPORTED_MODULE_6__components_playlists_PlaylistCard_vue__["a" /* default */],
    ModalPlaylistCard: __WEBPACK_IMPORTED_MODULE_7__PlaylistProfile_ModalPlaylistCard_vue__["a" /* default */]
  },
  directives: {
    infiniteScroll: __WEBPACK_IMPORTED_MODULE_3_vue_infinite_scroll___default.a
  },
  data: function data() {
    return {
      color: '#808080',
      size1: '100px',
      size2: '30px',
      disablePagination: false,
      genSeconByMain: [],
      genMainTranslatePosition: 0,
      genSeconTranslatePosition: 0,
      hasSelectedGenMain: false,
      hasSelectedGenSecon: false,
      genMainLastEvent: { // emazzu, para mantener el color de padre seleccionado
        event: null,
        background: null,
        color: null
      },
      busy: false,
      translatePosition: null,
      textToFilter: '',
      isUpdate: false,
      selectedGenre: null,
      mainGenre: {
        name: null,
        id: null
      },
      seconGenre: {
        name: null,
        id: null
      },
      filteredText: null
    };
  },
  created: function created() {
    if (this.discoverMainGenre && this.discoverMainGenre.name !== null) {
      this.mainGenre = this.discoverMainGenre;
    }
    if (this.discoverSeconGenre && this.discoverSeconGenre.name !== null) {
      this.seconGenre = this.discoverSeconGenre;
    }
    this.selectedGenre = this.genreFilter;
    this.disablePagination = !this.withPagination;
    if (this.withFilters) {
      this.getGenresMain(true);
      if (this.selectedGenre !== null && this.selectedGenre !== '' && this.selectedGenre !== undefined) {
        this.setPlaylistGenreFilter(this.selectedGenre);
      } else {
        this.setPlaylistGenreFilter(0);
      }
    }
    this.busy = true;
    this.selectPlaylistByFilter(this.selectedGenre);
    this.busy = false;
  },
  mounted: function mounted() {
    window.scrollTo(0, 0);
  },


  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('track', ['getGenresMain', 'setGenreFilter', 'getAll', 'setFrom']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('player', ['setPlaylist', 'setPlaying', 'changeTrack']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('playlist', ['getAllPlaylist', 'setPlaylistGenreFilter', 'setPlaylistFrom', 'loadMorePlaylist']), {
    playTrack: function playTrack(track) {
      if (this.currentTrack !== track) {
        this.$emit('play');
        this.changeTrack(track);
      } else {
        this.setPlaying(true);
      }
    },
    loadMorePaginated: function loadMorePaginated() {
      if (this.textToFilter === '' || this.textToFilter === undefined) {
        this.textToFilter = null;
      }
      if (!this.busy) {
        this.loadMore(this.textToFilter);
      }
    },
    setPlayer: function setPlayer(track, playlist) {
      this.setPlaylist(playlist);
      this.playTrack(track);
    },
    clearFilters: function clearFilters() {
      this.textToFilter = '';
      this.busy = false;
      this.filteredText = null;
    },


    update: __WEBPACK_IMPORTED_MODULE_5_debounce___default()(function (e) {
      if (this.textToFilter !== '') {
        this.busy = true;
        this.filteredText = this.textToFilter;
        this.selectPlaylistByFilter(this.selectedGenre, 0, this.textToFilter);
        this.busy = false;
        this.textToFilter = '';
      } else {
        this.busy = true;
        this.selectPlaylistByFilter(this.selectedGenre, 0, null);
        this.filteredText = null;
        this.busy = false;
      }
    }, 1000, true),

    // emazzu, start, para mantener el color de seleccion en el genero padre
    selectGenMainBlur: function selectGenMainBlur(event) {
      this.genMainLastEvent = {
        background: event.target.style.background,
        color: event.target.style.color,
        event: event
      };
      event.target.style.background = '#E6007E';
      event.target.style.color = 'white';
    },
    selectGenMainFocus: function selectGenMainFocus(event) {
      if (this.genMainLastEvent.event === null) {
        return;
      }

      this.genMainLastEvent.event.target.style.background = this.genMainLastEvent.background;
      this.genMainLastEvent.event.target.style.color = this.genMainLastEvent.color;
    },

    // emazzu, end, para mantener el color de seleccion en el genero padre

    // emazzu, cuando se hace clic en el genero primario
    selectGenMain: function selectGenMain(selectedId) {
      if (selectedId === '') {
        if (this.genMainLastEvent && this.genMainLastEvent.event) {
          this.genMainLastEvent.event.target.style.background = '';
          this.genMainLastEvent.event.target.style.color = '';
        }
        selectedId = 0;
        this.selectPlaylistByFilter(selectedId, 0);
      }
      this.selectedGenre = selectedId;

      // emazzu, filter todos los tracks que corresponden al genero primario
      if (this.withFilters && selectedId !== this.genreFilter) {
        this.selectPlaylistByFilter(selectedId, 0);
      }

      // emazzu, find genero primario seleccionado
      var found = this.genresMain.find(function (ele) {
        return ele.id === selectedId;
      });
      if (selectedId !== 0) {
        this.mainGenre = found;
      } else {
        this.mainGenre = {
          name: null,
          id: null
        };
      }
      this.seconGenre = {
        name: null,
        id: null
      };
      this.textToFilter = '';
      this.filteredText = null;

      // emazzu, si encontro, que siempre va a encontrar, menos si selecciona TODOS
      if (typeof found !== 'undefined') {
        this.genSeconByMain = found.children.sort(function (a, b) {
          if (a.name > b.name) {
            return 1;
          }
          if (a.name < b.name) {
            return -1;
          }
          // a must be equal to b
          return 0;
        });
      } else {
        this.genSeconByMain = [];
      }

      // flags
      this.hasSelectedGenMain = true;
      this.hasSelectedGenSecon = false;

      // flag, si selecciono TODOS, vuelvo para atras uno de los flag
      if (selectedId === '') {
        this.hasSelectedGenMain = false;
      }

      // los 2 filtros siempre visibles, dejamos los flags x las dudas
      this.showGenMain = true;
      this.showGenSecon = true;
      // Resetea lo posicion del genSecon
      var style = 'transform: translateX( 0px)';
      this.$el.querySelector('#genSecon').style = style;
      this.genSeconTranslatePosition = 0;
      this.translatePosition = 0;

      return null;
    },
    selectGenSecon: function selectGenSecon(selectedId) {
      this.selectedGenre = selectedId;
      // emazzu, filter todos los tracks que corresponden al genero primario
      if (this.withFilters && selectedId !== this.genreFilter) {
        this.selectPlaylistByFilter(selectedId, 0);
      }
      this.textToFilter = '';
      this.filteredText = null;
      // flags
      this.hasSelectedGenMain = true;
      this.hasSelectedGenSecon = true;

      // los 2 filtros siempre visibles, dejamos los flags x las dudas
      this.showGenMain = true;
      this.showGenSecon = true;
      var found = this.genSeconByMain.find(function (ele) {
        return ele.id === selectedId;
      });
      this.seconGenre = found;
      return null;
    },
    selectPlaylistByFilter: function selectPlaylistByFilter(selectedId) {
      var _this = this;

      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var textToFilter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      this.setPlaylistGenreFilter(selectedId);
      this.setPlaylistFrom(0);
      this.getAllPlaylist(textToFilter).catch(function (e) {
        _this.$toasted.show(_this.error.message, { type: 'error' });
      });
    },
    loadMore: function loadMore() {
      var _this2 = this;

      var textToFilter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      this.busy = true;
      this.loadMorePlaylist(textToFilter).then(function (response) {
        _this2.busy = false;
      }).catch(function (e) {
        _this2.$toasted.show(_this2.error.message, { type: 'error' });
        _this2.busy = false;
      });
    },


    // emazzu, transition genero principal y secundario
    genTranslate: function genTranslate(element, arrow) {
      var transitionValue = 120;

      if (element === 'genMain') {
        this.genMainTranslatePosition += arrow === 'left' ? transitionValue : transitionValue * -1;
        this.translatePosition = this.genMainTranslatePosition;
      }

      if (element === 'genSecon') {
        this.genSeconTranslatePosition += arrow === 'left' ? transitionValue : transitionValue * -1;
        this.translatePosition = this.genSeconTranslatePosition;
      }

      if (this.translatePosition >= 120) {
        this.translatePosition = 0;
        this.genMainTranslatePosition = 0;
        this.genSeconTranslatePosition = 0;
      }
      if (this.translatePosition <= -(120 * (this.genresMain.length - 1)) && element === 'genMain') {
        this.translatePosition = -(120 * (this.genresMain.length - 1));
        this.genMainTranslatePosition = -(120 * (this.genresMain.length - 1));
        this.genSeconTranslatePosition = 0;
      }
      if (this.translatePosition <= -(120 * (this.genSeconByMain.length - 1)) && element === 'genSecon') {
        this.translatePosition = -(120 * (this.genSeconByMain.length - 1));
        this.genMainTranslatePosition = 0;
        this.genSeconTranslatePosition = -(120 * (this.genSeconByMain.length - 1));
      }
      var style = 'transform: translateX(' + this.translatePosition.toString() + 'px' + ')';
      this.$el.querySelector('#' + element).style = style;
    },
    filterByMainGenreLabel: function filterByMainGenreLabel() {
      if (this.genMainLastEvent && this.genMainLastEvent.event) {
        this.genMainLastEvent.event.target.style.background = '';
        this.genMainLastEvent.event.target.style.color = '';
      }
      this.mainGenre = {
        name: null,
        id: null
      };
      this.seconGenre = {
        name: null,
        id: null
      };
      this.genSeconByMain = [];
      var text = this.filteredText ? this.filteredText : null;
      this.selectedGenre = 0;
      this.selectPlaylistByFilter(0, 0, text);
    },
    removeSeconGenreLabel: function removeSeconGenreLabel() {
      this.seconGenre = {
        name: null,
        id: null
      };
      var text = this.filteredText ? this.filteredText : null;
      this.selectedGenre = this.mainGenre.id;
      this.selectPlaylistByFilter(this.mainGenre.id, 0, text);
    },
    removeFilteredTextLabel: function removeFilteredTextLabel() {
      this.clearFilters();
      this.selectPlaylistByFilter(this.selectedGenre);
    },
    removeAllLabels: function removeAllLabels() {
      this.selectedGenre = 0;
      this.genSeconByMain = [];
      if (this.genMainLastEvent && this.genMainLastEvent.event) {
        this.genMainLastEvent.event.target.style.background = '';
        this.genMainLastEvent.event.target.style.color = '';
      }
      this.mainGenre = {
        name: null,
        id: null
      };
      this.seconGenre = {
        name: null,
        id: null
      };
      this.filteredText = null;
      if (this.textToFilter === '') {
        this.selectPlaylistByFilter(0, 0, null);
      } else {
        this.textToFilter = '';
      }
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('player', ['currentTrack']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('track', ['genresMain', 'discoverMainGenre', 'discoverSeconGenre']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('playlist', ['playlists', 'noMoreResults', 'page', 'genreFilter']), {
    loadingMore: function loadingMore() {
      return this.$loading.isLoading('playlist loadMorePlaylist');
    },
    preventLoadMore: function preventLoadMore() {
      return this.noMoreResults || this.busy || this.page === 0;
    }
  })
});

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_upload_component__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_upload_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_upload_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__consts__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__auth__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TrackEdit_vue__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_charts_CircleProgress_vue__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_spinner_src_ClipLoader_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuelidate_lib_validators__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuelidate_lib_validators_minValue__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuelidate_lib_validators_minValue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vuelidate_lib_validators_minValue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_UploadImage_vue__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__textEditor_EditorCK_vue__ = __webpack_require__(175);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'new-album',
  data: function data() {
    return {
      tracks: [],
      files: [],
      subirFiles: false,
      fileValidator: true,
      color: '#808080',
      size: '30px',
      smallSize: '15px',
      circleFill: { gradient: ['#272727'] },
      album: {
        title: '',
        id_music_type: '',
        tags: '',
        picture: '',
        id_lisense: 1,
        min_price: null,
        recommendedGenre: '',
        tracks: null,
        credits: ''
      },
      isSaving: false,
      loadingPicture: false,
      canEdit: false,
      isOthers: false,
      isOthersChildren: false,
      mainGenreSelected: '',
      childrensGenres: []
    };
  },

  components: {
    FileUpload: __WEBPACK_IMPORTED_MODULE_1_vue_upload_component___default.a,
    FontAwesomeIcon: __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome___default.a,
    TrackEdit: __WEBPACK_IMPORTED_MODULE_5__TrackEdit_vue__["a" /* default */],
    UploadImage: __WEBPACK_IMPORTED_MODULE_11__components_UploadImage_vue__["a" /* default */],
    CircleProgress: __WEBPACK_IMPORTED_MODULE_7__components_charts_CircleProgress_vue__["a" /* default */],
    ClipLoader: __WEBPACK_IMPORTED_MODULE_8_vue_spinner_src_ClipLoader_vue__["a" /* default */],
    EditorCK: __WEBPACK_IMPORTED_MODULE_12__textEditor_EditorCK_vue__["a" /* default */]
  },
  created: function created() {
    var _this = this;

    if (this.userPromise) {
      this.userPromise.then(function () {
        if (_this.isSubscribed) {
          _this.setTrackUploaded(false);
          _this.setPreventLogout(true);
          _this.resetError();
          _this.getGenresMain().catch(function (e) {
            _this.redirectHome(e.message);
          });
          if (_this.licenses.length === 0) {
            _this.getLicenses().then(function () {
              _this.setActualLicense();
            }).catch(function (e) {
              _this.redirectHome(e.message);
            });
          }
          _this.resetLicense();
        } else {
          _this.redirectHome(_this.$t('app.notAllowed'));
        }
      }).catch(function () {
        _this.redirectHome(_this.$store.getters['user/error']);
      });
    } else {
      this.redirectHome(this.$t('app.notAllowed'));
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (this.isTrackUploaded || !this.files.length || !this.isLoggedIn || this.files.length && this.userConfirm()) {
      next();
    } else {
      next(false);
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])('track', ['genresMain', 'genres', 'error', 'isTrackUploaded']), Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])('license', ['actualLicense', 'licenses']), Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])('user', ['isLoggedIn', 'isSubscribed', 'userPromise', 'user']), {
    url: function url() {
      return __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/tracks/upload/file';
    },

    postFileHeaders: function postFileHeaders() {
      return __WEBPACK_IMPORTED_MODULE_4__auth__["b" /* default */].getHeader();
    },
    adaptationCondition: {
      get: function get() {
        return this.$store.state.license.adaptationCondition;
      },
      set: function set(value) {
        this.setAdaptationCondition(value);
      }
    },
    commercialCondition: {
      get: function get() {
        return this.$store.state.license.commercialCondition;
      },
      set: function set(value) {
        this.setCommercialCondition(value);
      }
    },
    picture: function picture() {
      if (this.album && this.album.picture) {
        return __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].MEDIA_BASE_URL + this.album.path + this.album.picture;
      }
    },
    licenseIcon: function licenseIcon() {
      return this.album.actualLicense ? 'static' + this.actualLicense.icon : '';
    },
    buttonDisabled: function buttonDisabled() {
      if (this.file !== undefined) {
        return this.loadingPicture || this.file.progress < 100 || this.loadingEdition;
      } else {
        return this.loadingPicture || this.loadingEdition;
      }
    },
    loading: function loading() {
      return this.$loading.isLoading('track getGenresMain') || this.$loading.isLoading('license getLicenses') || this.$loading.isLoading('getTrack') || !this.isNewTrack && !this.canEdit;
    },
    loadingEdition: function loadingEdition() {
      return this.$loading.isLoading('track editTrack');
    },
    isNewTrack: function isNewTrack() {
      return !this.$route.params.id;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('track', ['getGenresMain', 'editTrack', 'setTrackUploaded', 'resetError', 'getTrack', 'uploadAlbum']), Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('license', ['getLicenses', 'setLicenseValues', 'setActualLicense', 'setAdaptationCondition', 'setCommercialCondition', 'resetLicense']), Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('user', ['setPreventLogout']), {
    save: function save() {
      var _this2 = this;

      if (this.files.length === this.tracks.length) {
        var count = 0;
        this.files.forEach(function (file, fileIdx) {
          _this2.tracks[fileIdx].id = file.response.data.track_id;
          _this2.tracks[fileIdx].file = file.response.data.filename;
          if (_this2.tracks[fileIdx].title === '') {
            _this2.tracks[fileIdx].title = _this2.album.title;
          }
          if (_this2.tracks[fileIdx].id_music_type === '') {
            _this2.tracks[fileIdx].id_music_type = _this2.album.id_music_type;
          }
          if (_this2.tracks[fileIdx].min_price === '') {
            _this2.tracks[fileIdx].min_price = 1;
          }
          _this2.tracks[fileIdx].id_lisense = _this2.actualLicense.id;
          count = count + 1;
          if (count === _this2.tracks.length) {
            _this2.album.tracks = _this2.tracks;
            _this2.uploadAlbum(_this2.album).then(function () {
              _this2.$store.dispatch('track/setTrackUploaded', true);
              _this2.$toasted.show(_this2.$t('albums.newAlbum.uploaded'), { type: 'success' });
              _this2.$router.push('/discover');
            }).catch(function (e) {
              _this2.$toasted.show(_this2.error, {
                type: 'error'
              });
            });
          }
        });
      }
    },
    handleUploadFinished: function handleUploadFinished(picture) {
      if (picture === '') {
        this.album.picture = '/static/assets/Img_comodines_Beathey_Playlist.jpg';
      } else {
        this.album.picture = picture;
      }
      this.loadingPicture = false;
    },
    redirectHome: function redirectHome(message) {
      this.$router.push({ path: '/home' });
      this.$toasted.show(message, { type: 'error' });
    },
    userConfirm: function userConfirm() {
      return window.confirm(this.$t('tracks.newTrack.leaveConfirmation'));
    },
    filterChildrensGenres: function filterChildrensGenres() {
      var _this3 = this;

      this.isOthers = false;
      this.album.id_music_type = '';
      if (this.mainGenreSelected !== '') {
        this.genresMain.forEach(function (item) {
          if (item.id === _this3.mainGenreSelected) {
            if (item.name !== 'OTHERS') {
              _this3.childrensGenres = item.children.sort(function (a, b) {
                if (a.name > b.name) {
                  return 1;
                }
                if (a.name < b.name) {
                  return -1;
                }
                // a must be equal to b
                return 0;
              });
            } else {
              _this3.isOthers = true;
              _this3.album.id_music_type = item.children[0].id;
            }
          }
        });
      }
      if (this.tracks.length > 0) {
        this.tracks.forEach(function (track) {
          track.id_music_type = '';
        });
      }
    },
    otherSelected: function otherSelected() {
      var _this4 = this;

      this.isOthersChildren = false;
      this.childrensGenres.forEach(function (item) {
        if (item.id === _this4.album.id_music_type) {
          if (item.name === 'OTHERS') {
            _this4.isOthersChildren = true;
          }
        }
      });
    },

    inputFile: function inputFile(newFile, oldFile) {
      // auto start
      if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
        if (!this.$refs.upload.active) {
          this.$refs.upload.active = true;
        }
      }
      if (newFile.response.status === 'ok' && this.subirFiles === false) {
        this.subirFile();
      }
    },
    inputFilter: function inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Filter mp3
        if (!/\.(mp3)$/i.test(newFile.name)) {
          this.$toasted.show(this.$t('tracks.newTrack.extensionMessage'), { type: 'error' });
          return prevent();
        }
      }
    },
    subirFile: function subirFile() {
      var _this5 = this;

      this.subirFiles = true;
      if (this.files.length > this.tracks.length) {
        if (this.album.id_music_type !== '' && this.album.picture !== '' && this.album.title !== '') {
          var regex = /\.(mp3)$/i;
          var correctedName = void 0;
          this.files.forEach(function (item) {
            correctedName = item.file.name.replace(regex, '');
            _this5.tracks.push({
              title: '',
              id: '',
              id_music_type: _this5.album.id_music_type,
              tags: _this5.album.tags,
              picture: _this5.album.picture,
              id_lisense: _this5.album.id_lisense,
              min_price: _this5.album.min_price,
              recommendedGenre: _this5.album.recommendedGenre,
              iswc: null,
              file: null,
              newRelease: 1,
              correctedName: correctedName
            });
          });
        }
      }
      this.subirFiles = false;
    },
    handleContentChange: function handleContentChange(content) {
      this.album.credits = content;
    }
  }),
  watch: {
    adaptationCondition: function adaptationCondition() {
      this.setActualLicense();
    },
    commercialCondition: function commercialCondition() {
      this.setActualLicense();
    }
  },
  validations: {
    album: {
      title: {
        required: __WEBPACK_IMPORTED_MODULE_9_vuelidate_lib_validators__["required"]
      },
      id_music_type: {
        required: __WEBPACK_IMPORTED_MODULE_9_vuelidate_lib_validators__["required"]
      },
      picture: {
        required: __WEBPACK_IMPORTED_MODULE_9_vuelidate_lib_validators__["required"]
      },
      min_price: {
        required: __WEBPACK_IMPORTED_MODULE_9_vuelidate_lib_validators__["required"],
        minValue: __WEBPACK_IMPORTED_MODULE_10_vuelidate_lib_validators_minValue___default()(1)
      },
      iswc: {
        minLength: Object(__WEBPACK_IMPORTED_MODULE_9_vuelidate_lib_validators__["minLength"])(13),
        maxLength: Object(__WEBPACK_IMPORTED_MODULE_9_vuelidate_lib_validators__["maxLength"])(13)
      }
    }
  }
});

/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_spinner_src_ClipLoader_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_infinite_scroll__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_infinite_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_infinite_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_carousel__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__carousel_CustomCarousel_vue__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_debounce__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_debounce__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'new-discover',
  props: {
    withFilters: {
      default: true
    },
    withPagination: {
      default: true
    },
    loading: {
      required: false
    },
    showGenMain: {
      default: true
    },
    showGenSecon: {
      default: true
    },
    profileTracks: {
      default: false
    }
  },
  components: {
    ClipLoader: __WEBPACK_IMPORTED_MODULE_2_vue_spinner_src_ClipLoader_vue__["a" /* default */],
    Carousel: __WEBPACK_IMPORTED_MODULE_4_vue_carousel__["Carousel"],
    Slide: __WEBPACK_IMPORTED_MODULE_4_vue_carousel__["Slide"],
    CustomCarousel: __WEBPACK_IMPORTED_MODULE_5__carousel_CustomCarousel_vue__["a" /* default */]
  },
  directives: {
    infiniteScroll: __WEBPACK_IMPORTED_MODULE_3_vue_infinite_scroll___default.a
  },
  data: function data() {
    return {
      color: '#808080',
      size1: '100px',
      size2: '30px',
      disablePagination: false,
      genSeconByMain: [],
      genMainTranslatePosition: 0,
      genSeconTranslatePosition: 0,
      hasSelectedGenMain: false,
      hasSelectedGenSecon: false,
      genMainLastEvent: { // emazzu, para mantener el color de padre seleccionado
        event: null,
        background: null,
        color: null
      },
      busy: false,
      translatePosition: null,
      textToFilter: '',
      isUpdate: false,
      discoverSelectedGenre: null,
      mainGenre: {
        name: null,
        id: null
      },
      seconGenre: {
        name: null,
        id: null
      },
      filteredText: null
    };
  },

  /*
  watch: {
    textToFilter: function (newText, oldText) {
      if ((!newText || newText === undefined || newText === '')) {
        this.selectTrackByFilter(this.discoverSelectedGenre)
        this.selectArtistByFilter(this.discoverSelectedGenre)
        // this.selectPlaylistByFilter()
        this.filteredText = null
      }
    }
  },
  */
  created: function created() {
    this.discoverSelectedGenre = 0;
    this.disablePagination = !this.withPagination;
    if (this.withFilters) {
      this.getGenresMain(true);
      this.setGenreFilter(0);
      this.setArtistGenreFilter(0);
      this.setPlaylistGenreFilter(0);
    }
    this.selectTrackByFilter();
    this.selectArtistByFilter();
    this.selectPlaylistByFilter();
  },
  mounted: function mounted() {
    window.scrollTo(0, 0);
  },


  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('track', ['getGenresMain', 'setGenreFilter', 'getAll', 'setFrom']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('player', ['setPlaylist']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('artist', ['getAllArtists', 'setArtistGenreFilter', 'setPageFrom']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('playlist', ['getAllPlaylist', 'setPlaylistFrom', 'setPlaylistGenreFilter', 'getAllRecommendedPlaylist']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])('track', ['setDiscoverMainGenre', 'setDiscoverSeconGenre']), {
    clearFilters: function clearFilters() {
      this.textToFilter = '';
      this.filteredText = null;
    },


    update: __WEBPACK_IMPORTED_MODULE_6_debounce___default()(function (e) {
      if (this.textToFilter !== '') {
        this.filteredText = this.textToFilter;
        this.selectTrackByFilter(this.discoverSelectedGenre, this.textToFilter);
        this.selectArtistByFilter(this.discoverSelectedGenre, this.textToFilter);
        this.selectPlaylistByFilter(this.discoverSelectedGenre, this.textToFilter);
        this.textToFilter = '';
      } else {
        this.selectTrackByFilter(this.discoverSelectedGenre, null);
        this.selectArtistByFilter(this.discoverSelectedGenre, null);
        this.filteredText = null;
      }
    }, 1000, true),

    // emazzu, start, para mantener el color de seleccion en el genero padre
    selectGenMainBlur: function selectGenMainBlur(event) {
      this.genMainLastEvent = {
        background: event.target.style.background,
        color: event.target.style.color,
        event: event
      };
      event.target.style.background = '#E6007E';
      event.target.style.color = 'white';
    },
    selectGenMainFocus: function selectGenMainFocus(event) {
      if (this.genMainLastEvent.event === null) {
        return;
      }

      this.genMainLastEvent.event.target.style.background = this.genMainLastEvent.background;
      this.genMainLastEvent.event.target.style.color = this.genMainLastEvent.color;
    },

    // emazzu, end, para mantener el color de seleccion en el genero padre

    // emazzu, cuando se hace clic en el genero primario
    selectGenMain: function selectGenMain(selectedId) {
      if (selectedId === '') {
        this.genMainLastEvent.event.target.style.background = '';
        this.genMainLastEvent.event.target.style.color = '';
      }
      selectedId = selectedId || 0;
      // emazzu, filter todos los tracks que corresponden al genero primario
      if (this.withFilters && selectedId !== this.genreFilter) {
        this.selectTrackByFilter(selectedId);
        this.selectArtistByFilter(selectedId);
        this.selectPlaylistByFilter(selectedId);
      }

      this.discoverSelectedGenre = selectedId;

      // emazzu, find genero primario seleccionado
      var found = this.genresMain.find(function (ele) {
        return ele.id === selectedId;
      });
      if (selectedId !== 0) {
        this.mainGenre = found;
        this.setDiscoverMainGenre(found);
      } else {
        this.mainGenre = {
          name: null,
          id: null
        };
        this.setDiscoverMainGenre({ name: null, id: null });
      }
      this.seconGenre = {
        name: null,
        id: null
      };
      this.setDiscoverSeconGenre({ name: null, id: null });
      this.textToFilter = '';
      this.filteredText = null;

      // emazzu, si encontro, que siempre va a encontrar, menos si selecciona TODOS
      if (typeof found !== 'undefined') {
        this.genSeconByMain = found.children.sort(function (a, b) {
          if (a.name > b.name) {
            return 1;
          }
          if (a.name < b.name) {
            return -1;
          }
          // a must be equal to b
          return 0;
        });
      } else {
        this.genSeconByMain = [];
      }

      // flags
      this.hasSelectedGenMain = true;
      this.hasSelectedGenSecon = false;

      // flag, si selecciono TODOS, vuelvo para atras uno de los flag
      if (selectedId === '') {
        this.hasSelectedGenMain = false;
      }

      // los 2 filtros siempre visibles, dejamos los flags x las dudas
      this.showGenMain = true;
      this.showGenSecon = true;
      // Resetea lo posicion del genSecon
      var style = 'transform: translateX( 0px)';
      this.$el.querySelector('#genSecon').style = style;
      this.genSeconTranslatePosition = 0;
      this.translatePosition = 0;

      return null;
    },
    selectGenSecon: function selectGenSecon(selectedId) {
      // emazzu, filter todos los tracks que corresponden al genero primario
      if (this.withFilters && selectedId !== this.genreFilter) {
        this.selectTrackByFilter(selectedId);
        this.selectArtistByFilter(selectedId);
        this.selectPlaylistByFilter(selectedId);
      }
      this.discoverSelectedGenre = selectedId;
      this.textToFilter = '';
      this.filteredText = null;

      // flags
      this.hasSelectedGenMain = true;
      this.hasSelectedGenSecon = true;

      // los 2 filtros siempre visibles, dejamos los flags x las dudas
      this.showGenMain = true;
      this.showGenSecon = true;
      var found = this.genSeconByMain.find(function (ele) {
        return ele.id === selectedId;
      });
      this.seconGenre = found;
      this.setDiscoverSeconGenre(found);

      return null;
    },
    selectTrackByFilter: function selectTrackByFilter() {
      var selectedId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var textToFilter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      this.setGenreFilter(selectedId);
      this.setFrom(0);
      this.getAll(textToFilter);
    },
    selectArtistByFilter: function selectArtistByFilter() {
      var selectedId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var textToFilter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      this.setArtistGenreFilter(selectedId);
      this.setPageFrom(0);
      this.getAllArtists(textToFilter);
    },
    selectPlaylistByFilter: function selectPlaylistByFilter() {
      var _this = this;

      var selectedId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var textToFilter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      this.setPlaylistGenreFilter(selectedId);
      this.setPlaylistFrom(0);
      this.getAllPlaylist(textToFilter).catch(function (e) {
        _this.$toasted.show(_this.error.message, { type: 'error' });
      });
      this.getAllRecommendedPlaylist(textToFilter).catch(function (e) {
        _this.$toasted.show(_this.error.message, { type: 'error' });
      });
    },


    // emazzu, transition genero principal y secundario
    genTranslate: function genTranslate(element, arrow) {
      var transitionValue = 120;

      if (element === 'genMain') {
        this.genMainTranslatePosition += arrow === 'left' ? transitionValue : transitionValue * -1;
        this.translatePosition = this.genMainTranslatePosition;
      }

      if (element === 'genSecon') {
        this.genSeconTranslatePosition += arrow === 'left' ? transitionValue : transitionValue * -1;
        this.translatePosition = this.genSeconTranslatePosition;
      }

      if (this.translatePosition >= 120) {
        this.translatePosition = 0;
        this.genMainTranslatePosition = 0;
        this.genSeconTranslatePosition = 0;
      }
      if (this.translatePosition <= -(120 * (this.genresMain.length - 1)) && element === 'genMain') {
        this.translatePosition = -(120 * (this.genresMain.length - 1));
        this.genMainTranslatePosition = -(120 * (this.genresMain.length - 1));
        this.genSeconTranslatePosition = 0;
      }
      if (this.translatePosition <= -(120 * (this.genSeconByMain.length - 1)) && element === 'genSecon') {
        this.translatePosition = -(120 * (this.genSeconByMain.length - 1));
        this.genMainTranslatePosition = 0;
        this.genSeconTranslatePosition = -(120 * (this.genSeconByMain.length - 1));
      }
      var style = 'transform: translateX(' + this.translatePosition.toString() + 'px' + ')';
      this.$el.querySelector('#' + element).style = style;
    },
    filterByMainGenreLabel: function filterByMainGenreLabel() {
      this.genMainLastEvent.event.target.style.background = '';
      this.genMainLastEvent.event.target.style.color = '';
      this.mainGenre = {
        name: null,
        id: null
      };
      this.seconGenre = {
        name: null,
        id: null
      };
      this.setDiscoverMainGenre({ name: null, id: null });
      this.setDiscoverSeconGenre({ name: null, id: null });
      this.genSeconByMain = [];
      var text = this.filteredText ? this.filteredText : null;
      this.discoverSelectedGenre = 0;
      this.selectTrackByFilter(0, text);
      this.selectArtistByFilter(0, text);
      this.selectPlaylistByFilter(0, text);
    },
    removeSeconGenreLabel: function removeSeconGenreLabel() {
      this.seconGenre = {
        name: null,
        id: null
      };
      this.setDiscoverSeconGenre({ name: null, id: null });
      var text = this.filteredText ? this.filteredText : null;
      this.discoverSelectedGenre = this.mainGenre.id;
      this.selectTrackByFilter(this.mainGenre.id, text);
      this.selectArtistByFilter(this.mainGenre.id, text);
      this.selectPlaylistByFilter(this.mainGenre.id, text);
    },
    removeFilteredTextLabel: function removeFilteredTextLabel() {
      this.clearFilters();
      this.selectTrackByFilter(this.discoverSelectedGenre);
      this.selectArtistByFilter(this.discoverSelectedGenre);
      this.selectPlaylistByFilter(this.discoverSelectedGenre);
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('player', ['currentTrack']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('track', ['allTracks', 'genresMain', 'genreFilter', 'noMoreResults']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('artist', ['artists']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('playlist', ['playlists', 'recommendedPlaylists']))
});

/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_localRadios_RadioCard__ = __webpack_require__(1166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(11);

//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'RadiosList',
  components: { RadioCard: __WEBPACK_IMPORTED_MODULE_1__components_localRadios_RadioCard__["a" /* default */] },
  props: {},
  data: function data() {
    return {
      radios: []
    };
  },
  created: function created() {
    var _this = this;

    var country = localStorage.getItem('providerCountry');
    if (country) {
      this.getLocalRadios(country).then(function (radios) {
        _this.radios = radios;
      });
    }
  },
  mounted: function mounted() {
    this.setPlaying(false);
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('home', ['getLocalRadios']), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('player', ['setPlaying']))
});

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fortawesome_vue_fontawesome__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__fortawesome_vue_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(11);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'radio-card',
  props: ['radio'],
  components: { FontAwesomeIcon: __WEBPACK_IMPORTED_MODULE_1__fortawesome_vue_fontawesome___default.a },
  computed: {
    listPicture: function listPicture() {
      if (this.radio.picture) {
        return this.radio.picture;
      } else {
        return '/static/assets/radio_online.jpg';
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('player', ['setPlaying']), {
    listenToRadio: function listenToRadio() {
      this.setPlaying(false);
      this.$modal.show('local-radio-modal', {
        radioName: this.radio.name,
        radioUrl: this.radio.link,
        radioPicture: this.listPicture,
        radioCategory: this.radio.category,
        radioDial: this.radio.dial
      });
      /*
      let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=600,height=300,left=400,top=250`
      window.open(this.radio.link, 'radio', params)
      */
    }
  })
});

/***/ }),
/* 564 */,
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Join.en.ac863a7.png";

/***/ }),
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tachyons__ = __webpack_require__(1170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tachyons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_tachyons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_resource__ = __webpack_require__(1171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_router__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fortawesome_fontawesome_styles_css__ = __webpack_require__(1173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fortawesome_fontawesome_styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__fortawesome_fontawesome_styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__fortawesome_fontawesome__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fortawesome_vue_fontawesome__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__fortawesome_vue_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__fortawesome_fontawesome_free_brands__ = __webpack_require__(1174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__fortawesome_fontawesome_free_solid__ = __webpack_require__(1175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store__ = __webpack_require__(1176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_toasted__ = __webpack_require__(1206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_toasted___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_toasted__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_js_modal__ = __webpack_require__(1207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_js_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_js_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vuelidate__ = __webpack_require__(1208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__translator__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__filters_time__ = __webpack_require__(1210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__filters_currency__ = __webpack_require__(1211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_carousel__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vue_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_social_sharing__ = __webpack_require__(1212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_social_sharing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vue_social_sharing__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_mq__ = __webpack_require__(1213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vuex_loading__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vuex_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_vuex_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_clipboards__ = __webpack_require__(1216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_analytics__ = __webpack_require__(1217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vue_gtm__ = __webpack_require__(1218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vue_gtm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_vue_gtm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_v_tooltip__ = __webpack_require__(1219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__auth__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__auth_config_json__ = __webpack_require__(1308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__auth_config_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__auth_config_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_bootstrap_vue__ = __webpack_require__(1309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__(1347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_vue_grid_responsive__ = __webpack_require__(1348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__assets_styles_css__ = __webpack_require__(1349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__assets_styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__assets_styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__ckeditor_ckeditor5_vue2__ = __webpack_require__(1350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__ckeditor_ckeditor5_vue2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__ckeditor_ckeditor5_vue2__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



























// Auth0 Plugin










__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('row', __WEBPACK_IMPORTED_MODULE_30_vue_grid_responsive__["b" /* Row */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('column', __WEBPACK_IMPORTED_MODULE_30_vue_grid_responsive__["a" /* Column */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('b-container', __WEBPACK_IMPORTED_MODULE_28_bootstrap_vue__["c" /* BContainer */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('b-row', __WEBPACK_IMPORTED_MODULE_28_bootstrap_vue__["f" /* BRow */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('b-col', __WEBPACK_IMPORTED_MODULE_28_bootstrap_vue__["b" /* BCol */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('b-button', __WEBPACK_IMPORTED_MODULE_28_bootstrap_vue__["a" /* BButton */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('BIcon', __WEBPACK_IMPORTED_MODULE_28_bootstrap_vue__["d" /* BIcon */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('BIconPlayCircle', __WEBPACK_IMPORTED_MODULE_28_bootstrap_vue__["e" /* BIconPlayCircle */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('b-table', __WEBPACK_IMPORTED_MODULE_28_bootstrap_vue__["g" /* BTable */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('b-tooltip', __WEBPACK_IMPORTED_MODULE_28_bootstrap_vue__["h" /* BTooltip */]);

/**
 * @see https://github.com/FortAwesome/vue-fontawesome/issues/22
 * @type {{autoAddCss: boolean}}
 */
__WEBPACK_IMPORTED_MODULE_7__fortawesome_fontawesome__["default"].config = {
  autoAddCss: false
};

__WEBPACK_IMPORTED_MODULE_7__fortawesome_fontawesome__["default"].library.add(__WEBPACK_IMPORTED_MODULE_9__fortawesome_fontawesome_free_brands__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__fortawesome_fontawesome_free_solid__["a" /* faEdit */], __WEBPACK_IMPORTED_MODULE_10__fortawesome_fontawesome_free_solid__["b" /* faQuestionCircle */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('FontAwesomeIcon', __WEBPACK_IMPORTED_MODULE_8__fortawesome_vue_fontawesome___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('time', __WEBPACK_IMPORTED_MODULE_16__filters_time__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('currency', __WEBPACK_IMPORTED_MODULE_17__filters_currency__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_26__auth__["a" /* Auth0Plugin */], {
  domain: __WEBPACK_IMPORTED_MODULE_27__auth_config_json__["domain"],
  clientId: __WEBPACK_IMPORTED_MODULE_27__auth_config_json__["clientId"],
  onRedirectCallback: function onRedirectCallback(appState) {
    __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(appState && appState.targetUrl ? appState.targetUrl : window.location.pathname);
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_vue_toasted___default.a, {
  position: 'top-center',
  duration: 5000,
  singleton: true
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_20_vue_mq__["a" /* default */], {
  breakpoints: {
    sm: 450,
    md: 1250,
    lg: Infinity
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13_vue_js_modal___default.a, { dialog: true });
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14_vuelidate___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_18_vue_carousel___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_19_vue_social_sharing___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_21_vuex_loading___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_22_vue_clipboards__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_25_v_tooltip__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_32__ckeditor_ckeditor5_vue2___default.a);

if (true) {
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_23_vue_analytics___default.a, {
    // id: 'UA-93769421-4',
    id: 'UA-93769421-1',
    router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */]
  });
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_24_vue_gtm___default.a, {
    vueRouter: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */]
  });
}

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.interceptors.push(function (request, next) {
  request.headers.set('access-token', localStorage.getItem('token'));
  request.headers.set('Content-Language', __WEBPACK_IMPORTED_MODULE_15__translator__["a" /* default */].locale);
  next();
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */],
  i18n: __WEBPACK_IMPORTED_MODULE_15__translator__["a" /* default */],
  vueLoading: new __WEBPACK_IMPORTED_MODULE_21_vuex_loading___default.a({ useVuex: true, moduleName: 'loading', registerComponents: false }),
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),
/* 732 */,
/* 733 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 734 */,
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []


/***/ }),
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_router__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AppWrapper__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_policy_TermsEs__ = __webpack_require__(928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_policy_TermsSubsEs__ = __webpack_require__(931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_policy_TermsEn__ = __webpack_require__(934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_policy_TermsSubsEn__ = __webpack_require__(937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_policy_TermsSubsPt__ = __webpack_require__(940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_home_HomeList__ = __webpack_require__(943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_news_News__ = __webpack_require__(977);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_help_Help__ = __webpack_require__(980);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_help_Msisdn__ = __webpack_require__(989);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_provider_Autologin__ = __webpack_require__(990);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Waiting__ = __webpack_require__(991);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_ProviderTyC__ = __webpack_require__(995);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Landing_Landing_vue__ = __webpack_require__(1000);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Landing_Oyendo_vue__ = __webpack_require__(1005);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Landing_Creando_vue__ = __webpack_require__(1008);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Landing_Planes_vue__ = __webpack_require__(1011);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_landingMK_LandingMK_vue__ = __webpack_require__(1015);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_paymentsMK_PaymentsMK_vue__ = __webpack_require__(1018);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_policy_IntellectualPropEs__ = __webpack_require__(1021);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_policy_PrivacyPolicyEs__ = __webpack_require__(1024);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_policy_PrivacyPolicyEn__ = __webpack_require__(1027);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_policy_PrivacyPolicyPt__ = __webpack_require__(1030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_tracks_AllTracksList__ = __webpack_require__(1033);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_tracks_NewTrackWrapper__ = __webpack_require__(1040);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_tracks_TrackNew__ = __webpack_require__(1043);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_tracks_TrackEdit__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_charts_VinylContest__ = __webpack_require__(1048);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_dashboard_Dashboard__ = __webpack_require__(1053);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_user_UserProfile__ = __webpack_require__(1108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_user_MyTracks__ = __webpack_require__(1111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_user_MyPlaylists__ = __webpack_require__(1114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_user_MyFavorites__ = __webpack_require__(1124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_user_MyShopping__ = __webpack_require__(1131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_user_MyInfo__ = __webpack_require__(1139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_artistProfile_ArtistProfile__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_artistProfile_ArtistInfo__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_artistProfile_ArtistTracks__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_artistProfile_ArtistPlaylists__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_artistProfile_ArtistContact__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_artists_NewArtistsList__ = __webpack_require__(1149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_playlists_NewPlaylistsList_vue__ = __webpack_require__(1152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_PlaylistProfile_PlaylistProfile_vue__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_PlaylistProfile_PlaylistTracks_vue__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_vrtify_Vrtify_vue__ = __webpack_require__(1155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_tracks_albums_NewAlbum__ = __webpack_require__(1158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_discover_NewDiscover__ = __webpack_require__(1161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_localRadios_RadiosList__ = __webpack_require__(1164);














































// import ArtistsList from '@/components/artists/ArtistsList'









// import PlaylistInfo from '@/components/playlists/PlaylistInfo.vue'









var router = new __WEBPACK_IMPORTED_MODULE_0_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/provider/waiting/:provider',
    name: 'provider-waiting',
    component: __WEBPACK_IMPORTED_MODULE_13__components_Waiting__["a" /* default */]
  }, {
    path: '/provider/tyc/:provider',
    name: 'provider-tyc',
    component: __WEBPACK_IMPORTED_MODULE_14__components_ProviderTyC__["a" /* default */]
  }, {
    path: '',
    name: 'landign',
    component: __WEBPACK_IMPORTED_MODULE_15__components_Landing_Landing_vue__["a" /* default */]
  }, {
    path: '/oyendo',
    name: 'oyendo',
    component: __WEBPACK_IMPORTED_MODULE_16__components_Landing_Oyendo_vue__["a" /* default */]
  }, {
    path: '/creando',
    name: 'creando',
    component: __WEBPACK_IMPORTED_MODULE_17__components_Landing_Creando_vue__["a" /* default */]
  }, {
    path: '/planes',
    name: 'planes',
    component: __WEBPACK_IMPORTED_MODULE_18__components_Landing_Planes_vue__["a" /* default */]
  }, {
    path: '/mk',
    name: 'landingMK',
    component: __WEBPACK_IMPORTED_MODULE_19__components_landingMK_LandingMK_vue__["a" /* default */]
  }, {
    path: '/paymentsMk',
    name: 'paymentsMK',
    component: __WEBPACK_IMPORTED_MODULE_20__components_paymentsMK_PaymentsMK_vue__["a" /* default */]
  }, {
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_1__components_AppWrapper__["a" /* default */],
    children: [{
      path: 'home',
      name: 'home',
      component: __WEBPACK_IMPORTED_MODULE_8__components_home_HomeList__["a" /* default */]
    }, {
      path: 'm/:msisdn',
      name: 'msisdn',
      component: __WEBPACK_IMPORTED_MODULE_11__components_help_Msisdn__["a" /* default */]
    }, {
      path: 'dashboard',
      name: 'Dashboard',
      component: __WEBPACK_IMPORTED_MODULE_30__components_dashboard_Dashboard__["a" /* default */]
    }, {
      path: 'localContent',
      name: 'local-content',
      component: __WEBPACK_IMPORTED_MODULE_49__components_localRadios_RadiosList__["a" /* default */]
    }, {
      path: 'provider/:provider',
      name: 'provider-autologin',
      component: __WEBPACK_IMPORTED_MODULE_12__components_provider_Autologin__["a" /* default */]
    }, {
      path: 'playlists',
      name: 'new-playlists-list',
      component: __WEBPACK_IMPORTED_MODULE_43__components_playlists_NewPlaylistsList_vue__["a" /* default */]
    }, {
      path: 'playlist/:id',
      name: 'playlist',
      components: {
        PlaylistProfile: __WEBPACK_IMPORTED_MODULE_44__components_PlaylistProfile_PlaylistProfile_vue__["a" /* default */]
      },
      children: [{
        path: 'tracks',
        name: 'playlist-tracks',
        components: {
          'profile-tab': __WEBPACK_IMPORTED_MODULE_45__components_PlaylistProfile_PlaylistTracks_vue__["a" /* default */]
        }
      }]
    }, {
      path: 'artists',
      name: 'new-artists-list',
      component: __WEBPACK_IMPORTED_MODULE_42__components_artists_NewArtistsList__["a" /* default */],
      children: [{
        path: ':id',
        name: 'artist',
        components: {
          ArtistProfile: __WEBPACK_IMPORTED_MODULE_37__components_artistProfile_ArtistProfile__["a" /* default */]
        },
        children: [{
          path: 'info',
          name: 'artist-info',
          components: {
            'profile-tab': __WEBPACK_IMPORTED_MODULE_38__components_artistProfile_ArtistInfo__["a" /* default */]
          }
        }, {
          path: 'tracks',
          name: 'artist-tracks',
          components: {
            'profile-tab': __WEBPACK_IMPORTED_MODULE_39__components_artistProfile_ArtistTracks__["a" /* default */]
          }
        }, {
          path: 'playlists',
          name: 'artist-playlists',
          components: {
            'profile-tab': __WEBPACK_IMPORTED_MODULE_40__components_artistProfile_ArtistPlaylists__["a" /* default */]
          }
        }, {
          path: 'contact',
          name: 'artist-contact',
          components: {
            'profile-tab': __WEBPACK_IMPORTED_MODULE_41__components_artistProfile_ArtistContact__["a" /* default */]
          }
        }]
      }]
    }, {
      path: 'charts',
      name: 'charts',
      component: __WEBPACK_IMPORTED_MODULE_29__components_charts_VinylContest__["a" /* default */]
    }, {
      path: 'tracks',
      name: 'new-track-wrapper',
      components: {
        default: __WEBPACK_IMPORTED_MODULE_26__components_tracks_NewTrackWrapper__["a" /* default */]
      },
      children: [{
        path: 'new-track',
        name: 'track-new',
        component: __WEBPACK_IMPORTED_MODULE_27__components_tracks_TrackNew__["a" /* default */]
      }, {
        path: 'new-album',
        name: 'new-album',
        component: __WEBPACK_IMPORTED_MODULE_47__components_tracks_albums_NewAlbum__["a" /* default */]
      }]
    }, {
      path: 'tracks/edit/:id',
      name: 'track-edit',
      component: __WEBPACK_IMPORTED_MODULE_28__components_tracks_TrackEdit__["a" /* default */]
    }, {
      path: 'discover',
      name: 'discover',
      component: __WEBPACK_IMPORTED_MODULE_48__components_discover_NewDiscover__["a" /* default */]
    }, {
      path: 'tracksList',
      name: 'tracksList',
      component: __WEBPACK_IMPORTED_MODULE_25__components_tracks_AllTracksList__["a" /* default */]
    }, {
      path: 'profile',
      name: 'profile',
      components: {
        default: __WEBPACK_IMPORTED_MODULE_31__components_user_UserProfile__["a" /* default */]
      },
      children: [{
        path: 'info',
        name: 'profile-info',
        component: __WEBPACK_IMPORTED_MODULE_36__components_user_MyInfo__["a" /* default */]
      }, {
        path: 'my-tracks',
        name: 'my-tracks',
        component: __WEBPACK_IMPORTED_MODULE_32__components_user_MyTracks__["a" /* default */]
      }, {
        path: 'my-playlists',
        name: 'my-playlists',
        component: __WEBPACK_IMPORTED_MODULE_33__components_user_MyPlaylists__["a" /* default */]
      }, {
        path: 'my-favorites',
        name: 'my-favorites',
        component: __WEBPACK_IMPORTED_MODULE_34__components_user_MyFavorites__["a" /* default */]
      }, {
        path: 'my-shopping',
        name: 'my-shopping',
        component: __WEBPACK_IMPORTED_MODULE_35__components_user_MyShopping__["a" /* default */]
      }]
    },
    // Future implementation of news list section now redirects to the home page
    {
      path: 'news',
      name: 'news-list',
      redirect: '/'
    }, {
      path: 'news/:id',
      name: 'news',
      component: __WEBPACK_IMPORTED_MODULE_9__components_news_News__["a" /* default */]
    }, {
      path: 'help',
      name: 'help',
      component: __WEBPACK_IMPORTED_MODULE_10__components_help_Help__["a" /* default */]
    }, {
      path: '360',
      redirect: '/',
      name: '360',
      component: __WEBPACK_IMPORTED_MODULE_46__components_vrtify_Vrtify_vue__["a" /* default */]
    }]
  }, {
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */],
    children: [{
      path: 'terms/es',
      name: 'terms-es',
      component: __WEBPACK_IMPORTED_MODULE_3__components_policy_TermsEs__["a" /* default */]
    }, {
      path: 'terms/en',
      name: 'terms-en',
      component: __WEBPACK_IMPORTED_MODULE_5__components_policy_TermsEn__["a" /* default */]
    }, {
      path: 'general-terms/es',
      name: 'general-terms-es',
      component: __WEBPACK_IMPORTED_MODULE_4__components_policy_TermsSubsEs__["a" /* default */]
    }, {
      path: 'general-terms/en',
      name: 'general-terms-en',
      component: __WEBPACK_IMPORTED_MODULE_6__components_policy_TermsSubsEn__["a" /* default */]
    }, {
      path: 'general-terms/pt',
      name: 'general-terms-pt',
      component: __WEBPACK_IMPORTED_MODULE_7__components_policy_TermsSubsPt__["a" /* default */]
    }, {
      path: 'intellectual-prop/es',
      name: 'intellectual-prop-es',
      component: __WEBPACK_IMPORTED_MODULE_21__components_policy_IntellectualPropEs__["a" /* default */]
    }, {
      path: 'privacy-policy/es',
      name: 'privacy-policy-es',
      component: __WEBPACK_IMPORTED_MODULE_22__components_policy_PrivacyPolicyEs__["a" /* default */]
    }, {
      path: 'privacy-policy/en',
      name: 'privacy-policy-en',
      component: __WEBPACK_IMPORTED_MODULE_23__components_policy_PrivacyPolicyEn__["a" /* default */]
    }, {
      path: 'privacy-policy/pt',
      name: 'privacy-policy-pt',
      component: __WEBPACK_IMPORTED_MODULE_24__components_policy_PrivacyPolicyPt__["a" /* default */]
    }]
  }]
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppWrapper_vue__ = __webpack_require__(337);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ecba8832_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppWrapper_vue__ = __webpack_require__(927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(738)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppWrapper_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ecba8832_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppWrapper_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ecba8832_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppWrapper_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 738 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigation_vue__ = __webpack_require__(347);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_573fa2b2_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navigation_vue__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(761)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-573fa2b2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_573fa2b2_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navigation_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_573fa2b2_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navigation_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 761 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 762 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center flex-start"},[_c('div',{staticClass:"db-ns dn"},[_c('font-awesome-icon',{staticClass:"iconColor pa2",attrs:{"icon":"bars"}})],1),_vm._v(" "),_c('div',{staticClass:"image-container"},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.user.picture),expression:"user.picture"}],staticClass:"mw-100 h-100",attrs:{"src":_vm.picture}})])])}
var staticRenderFns = []


/***/ }),
/* 764 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"v-spinner"},[_c('div',{staticClass:"v-clip",style:(_vm.spinnerStyle)})])}
var staticRenderFns = []


/***/ }),
/* 766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"flex bg-black justify-between"},[_c('div',{staticClass:"fl flex w-25 items-center h-100"},[_c('div',{staticClass:"mh2 mv1 logo-container mw-100"},[_c('img',{staticClass:"h-100 w-100 pointer db-l dn",attrs:{"src":__webpack_require__(71),"alt":"BeatHey Logo"},on:{"click":_vm.goToMainPage}}),_vm._v(" "),_c('div',{staticClass:"dn-l pv1 isologo-container"},[_c('img',{staticClass:"w-100 h-100 pointer",attrs:{"src":__webpack_require__(170),"alt":"BeatHey Logo"},on:{"click":_vm.goToMainPage}})])])]),_vm._v(" "),_c('div',{staticClass:"fl flex mw-50 justify-center items-center ttu"},[_c('router-link',{staticClass:"link-primary ttu f5 flex items-center h-100 no-underline dib pa3 textColor",attrs:{"title":_vm.$t('app.discover'),"to":{name:'discover'}}},[_c('font-awesome-icon',{staticClass:"iconColor mr0 mr2-l",attrs:{"icon":"compass"}}),_vm._v(" "),_c('span',{staticClass:"dn di-l"},[_vm._v(_vm._s(_vm.$t('app.discover')))])],1),_vm._v(" "),_c('router-link',{staticClass:"link-primary ttu f5 flex items-center h-100 no-underline dib pa3 textColor",attrs:{"title":_vm.$t('vinylContest.title'),"to":{name:'charts'}}},[_c('font-awesome-icon',{staticClass:"iconColor mr0 mr2-l",attrs:{"icon":"trophy"}}),_vm._v(" "),_c('span',{staticClass:"dn di-l"},[_vm._v(_vm._s(_vm.$t('vinylContest.title')))])],1),_vm._v(" "),(_vm.user.user_type === 1)?_c('router-link',{staticClass:"link-primary ttu f5 flex items-center h-100 no-underline dib pa3 textColor",attrs:{"title":_vm.$t('dashboard.title'),"to":{name:'Dashboard'}}},[_c('font-awesome-icon',{staticClass:"iconColor mr0 mr2-l",attrs:{"icon":"tachometer-alt"}}),_vm._v(" "),_c('span',{staticClass:"dn di-l"},[_vm._v(_vm._s(_vm.$t('dashboard.title')))])],1):_vm._e(),_vm._v(" "),(false)?_c('router-link',{staticClass:"link-primary ttu f5 flex items-center h-100 no-underline dib pa3 textColor",attrs:{"title":_vm.$t('app.360'),"to":{name:'360'}}},[_c('font-awesome-icon',{staticClass:"iconColor mr0 mr2-l",attrs:{"icon":"street-view"}}),_vm._v(" "),_c('span',{staticClass:"dn di-l"},[_vm._v(_vm._s(_vm.$t("app.360")))])],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"fl flex min-w-25 justify-end items-center iconColor"},[_c('clip-loader',{staticClass:"mh2",attrs:{"loading":_vm.loading,"color":_vm.color,"size":_vm.size}}),_vm._v(" "),(!_vm.loading && !_vm.isLoggedIn)?_c('div',{staticClass:"mr2 h-100 flex items-center"},[_c('div',{staticClass:"dn login"},[_c('div',{staticClass:"pr1 pointer ttu db",on:{"click":_vm.login}},[_vm._v(_vm._s(_vm.$t("app.signin")))])]),_vm._v(" "),_c('div',{staticClass:"h-100"},[(!_vm.$auth0.isAuthenticated)?_c('div',{directives:[{name:"on-click-outside",rawName:"v-on-click-outside",value:(_vm.closeLoginDropdown),expression:"closeLoginDropdown"}],staticClass:"flex items-center h-100",on:{"click":_vm.loginDropdownTrigger}},[_c('font-awesome-icon',{staticClass:"iconColor pa2 pointer",attrs:{"icon":"bars"}})],1):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loginDropdown),expression:"loginDropdown"}],staticClass:"dropdown-content db absolute w5-ns w4 flex flex-column"},[_c('div',{staticClass:"login-dropdown pv2 ph3 f5 pointer w-100 ttu iconColor",on:{"click":_vm.login}},[_vm._v(_vm._s(_vm.$t("app.signin")))]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLocale('es')),expression:"!isLocale('es')"}],staticClass:"pv2 ph3 f5 pointer w-100 ttu",on:{"click":function($event){return _vm.setLanguage('es')}}},[_vm._v(_vm._s(_vm.$t("footer.language.spanish")))]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLocale('en')),expression:"!isLocale('en')"}],staticClass:"pv2 ph3 f5 pointer w-100 ttu",on:{"click":function($event){return _vm.setLanguage('en')}}},[_vm._v(_vm._s(_vm.$t("footer.language.english")))]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLocale('pt')),expression:"!isLocale('pt')"}],staticClass:"pv2 ph3 f5 pointer w-100 ttu",on:{"click":function($event){return _vm.setLanguage('pt')}}},[_vm._v(_vm._s(_vm.$t("footer.language.portuguese")))]),_vm._v(" "),_c('router-link',{staticClass:"no-underline pv2 ph3 f5 pointer w-100 ttu iconColor",attrs:{"to":{ name: 'help' }}},[_vm._v(_vm._s(_vm.$t("footer.help"))+"\n            ")])],1)])],1)]):_vm._e(),_vm._v(" "),(!_vm.loading && _vm.isLoggedIn)?_c('div',{staticClass:"flex justify-end iconColor hamburger"},[(!_vm.isSubscribed)?_c('div',[(_vm.isLoggedIn && !_vm.isProducer && !_vm.isSubscribed)?_c('div',{staticClass:"mh2 mv1 subs-container mw-100"},[_c('a',{staticClass:"dn f5 flex-l items-center h-100 no-underline bn pointer ttu mobile-subs",on:{"click":function($event){return _vm.$modal.show('subscription-modal')}}},[_vm._v("\n            "+_vm._s(_vm.$t("users.subscription.button"))+"\n          ")])]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLoggedIn || _vm.isProducer),expression:"!isLoggedIn || isProducer"}]},[_c('a',{staticClass:"dn f5 flex-l items-center h-100 no-underline bn pointer ttu callToAction",on:{"click":function($event){$event.preventDefault();return _vm.checkUser('/tracks/new-track')}}},[_c('font-awesome-icon',{staticClass:"pa2",attrs:{"icon":"upload"}}),_vm._v("\n            "+_vm._s(_vm.$t("tracks.newTrack.button"))+"\n          ")],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoggedIn && !_vm.isProducer && !_vm.isSubscribed && !_vm.bitelFreeMusic),expression:"isLoggedIn && !isProducer && !isSubscribed && !bitelFreeMusic"}]},[_c('a',{staticClass:"dn f5 flex-l items-center h-100 no-underline bn pointer ttu callToAction",on:{"click":function($event){return _vm.$modal.show('subscription-modal')}}},[_c('font-awesome-icon',{staticClass:"pa2",attrs:{"icon":"bullhorn"}}),_vm._v("\n            "+_vm._s(_vm.$t("users.subscription.title"))+"\n          ")],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoggedIn && !_vm.isProducer && !_vm.isSubscribed && _vm.bitelFreeMusic),expression:"isLoggedIn && !isProducer && !isSubscribed && bitelFreeMusic"}]},[_c('a',{staticClass:"dn f5 flex-l items-center h-100 no-underline bn pointer ttu callToAction",attrs:{"href":"https://play.bitel.com.pe"}},[_c('font-awesome-icon',{staticClass:"pa2",attrs:{"icon":"bullhorn"}}),_vm._v("\n            "+_vm._s(_vm.$t("users.subscription.title"))+"\n          ")],1)])]):_vm._e(),_vm._v(" "),(_vm.isSubscribed)?_c('div',[(_vm.user.subscription.pricing.id !== 3)?_c('div',[(_vm.isLoggedIn && !_vm.isProducer && !_vm.isSubscribed)?_c('div',{staticClass:"mh2 mv1 subs-container mw-100"},[_c('a',{staticClass:"dn f5 flex-l items-center h-100 no-underline bn pointer ttu mobile-subs",on:{"click":function($event){return _vm.$modal.show('subscription-modal')}}},[_vm._v("\n              "+_vm._s(_vm.$t("users.subscription.button"))+"\n            ")])]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLoggedIn || _vm.isProducer),expression:"!isLoggedIn || isProducer"}]},[_c('a',{staticClass:"dn f5 flex-l items-center h-100 no-underline bn pointer ttu callToAction",on:{"click":function($event){$event.preventDefault();return _vm.checkUser('/tracks/new-track')}}},[_c('font-awesome-icon',{staticClass:"pa2",attrs:{"icon":"upload"}}),_vm._v("\n              "+_vm._s(_vm.$t("tracks.newTrack.button"))+"\n            ")],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoggedIn && !_vm.isProducer && !_vm.isSubscribed),expression:"isLoggedIn && !isProducer && !isSubscribed"}]},[_c('a',{staticClass:"dn f5 flex-l items-center h-100 no-underline bn pointer ttu callToAction",on:{"click":function($event){return _vm.$modal.show('subscription-modal')}}},[_c('font-awesome-icon',{staticClass:"pa2",attrs:{"icon":"bullhorn"}}),_vm._v("\n              "+_vm._s(_vm.$t("users.subscription.title"))+"\n            ")],1)])]):_vm._e(),_vm._v(" "),(_vm.user.subscription.pricing.id === 3)?_c('div',{staticClass:"flexdiv"},[(_vm.isLoggedIn && !_vm.isProducer && !_vm.isSubscribed)?_c('div',{staticClass:"mh2 mv1 subs-container mw-100"},[_c('a',{staticClass:"dn f5 flex-l items-center h-100 no-underline bn pointer ttu mobile-subs",on:{"click":function($event){return _vm.$modal.show('subscription-modal')}}},[_vm._v("\n              "+_vm._s(_vm.$t("users.subscription.button"))+"\n            ")])]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLoggedIn || _vm.isProducer),expression:"!isLoggedIn || isProducer"}]},[_c('a',{staticClass:"dn f5 flex-l items-center h-100 no-underline bn pointer ttu callToActionUpload",on:{"click":function($event){$event.preventDefault();return _vm.checkUser('/tracks/new-track')}}},[_c('font-awesome-icon',{staticClass:"pa2",attrs:{"icon":"upload"}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoggedIn),expression:"isLoggedIn"}]},[_c('a',{staticClass:"dn f5 flex-l items-center h-100 no-underline bn pointer ttu callToActionSuscription",on:{"click":function($event){return _vm.$modal.show('subscription-modal')}}},[_vm._v("\n              "+_vm._s(_vm.$t("users.subscription.title"))+"\n            ")])])]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"on-click-outside",rawName:"v-on-click-outside",value:(_vm.closeDropdown),expression:"closeDropdown"}],staticClass:"relative iconColor"},[_c('div',{on:{"click":_vm.dropdownTrigger}},[(_vm.user)?_c('user-info',{staticClass:"mw5 pointer iconColor"}):_vm._e()],1),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.dropdown),expression:"dropdown"}],staticClass:"dropdown-content db absolute w5 flex flex-column iconColor"},[_c('h2',{staticClass:"user-name f7 ttu f5-ns lh-title mv0 mr2-ns"},[_vm._v(_vm._s(_vm.user.user_name))]),_vm._v(" "),_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(!_vm.antelPublicUser && !_vm.bitelFreeMusic),expression:"!antelPublicUser && !bitelFreeMusic"}],staticClass:"no-underline pv2 ph3 f5 pointer w-100",attrs:{"to":{ name: 'profile-info' }},nativeOn:{"click":function($event){return _vm.closeDropdown.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t("users.userMenu.myProfile"))+"\n            ")]),_vm._v(" "),(_vm.isProducer)?_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(!_vm.antelPublicUser && !_vm.bitelFreeMusic),expression:"!antelPublicUser && !bitelFreeMusic"}],staticClass:"no-underline pv2 ph3 f5 pointer w-100",attrs:{"to":{ name: 'my-tracks' }},nativeOn:{"click":function($event){return _vm.closeDropdown.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t("users.userMenu.myTracks"))+"\n            ")]):_vm._e(),_vm._v(" "),_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(!_vm.antelPublicUser),expression:"!antelPublicUser"}],staticClass:"no-underline pv2 ph3 f5 pointer w-100",attrs:{"to":{ name: 'my-playlists' }},nativeOn:{"click":function($event){return _vm.closeDropdown.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t("users.userMenu.myPlaylists"))+"\n            ")]),_vm._v(" "),_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(!_vm.antelPublicUser),expression:"!antelPublicUser"}],staticClass:"no-underline pv2 ph3 f5 pointer w-100",attrs:{"to":{ name: 'my-favorites' }},nativeOn:{"click":function($event){return _vm.closeDropdown.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t("users.userMenu.myFavorites"))+"\n            ")]),_vm._v(" "),_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(!_vm.antelPublicUser && !_vm.bitelFreeMusic),expression:"!antelPublicUser && !bitelFreeMusic"}],staticClass:"no-underline pv2 ph3 f5 pointer w-100",attrs:{"to":{ name: 'my-shopping' }},nativeOn:{"click":function($event){return _vm.closeDropdown.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t("users.userMenu.myShopping"))+"\n            ")]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLocale('es')),expression:"!isLocale('es')"}],staticClass:"pv2 ph3 f5 pointer w-100",on:{"click":function($event){return _vm.setLanguage('es')}}},[_vm._v(_vm._s(_vm.$t("footer.language.spanish")))]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLocale('en')),expression:"!isLocale('en')"}],staticClass:"pv2 ph3 f5 pointer w-100",on:{"click":function($event){return _vm.setLanguage('en')}}},[_vm._v(_vm._s(_vm.$t("footer.language.english")))]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLocale('pt')),expression:"!isLocale('pt')"}],staticClass:"pv2 ph3 f5 pointer w-100",on:{"click":function($event){return _vm.setLanguage('pt')}}},[_vm._v(_vm._s(_vm.$t("footer.language.portuguese")))]),_vm._v(" "),_c('router-link',{staticClass:"no-underline pv2 ph3 f5 pointer w-100",attrs:{"to":{ name: 'help' }},nativeOn:{"click":function($event){return _vm.closeDropdown.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t("users.userMenu.help"))+"\n            ")]),_vm._v(" "),_c('a',{staticClass:"no-underline pv2 ph3 f5 pointer w-100",on:{"click":_vm.logoutButton}},[_vm._v(_vm._s(_vm.$t("users.userMenu.logout")))])],1)])],1)]):_vm._e()],1)])}
var staticRenderFns = []


/***/ }),
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Player_vue__ = __webpack_require__(351);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74e8be44_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Player_vue__ = __webpack_require__(781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(768)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-74e8be44"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Player_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74e8be44_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Player_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74e8be44_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Player_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 768 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 769 */,
/* 770 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 771 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrackOptions_vue__ = __webpack_require__(354);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44793c02_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrackOptions_vue__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(773)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-44793c02"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrackOptions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44793c02_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrackOptions_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44793c02_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrackOptions_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 773 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"},on:{"after-enter":_vm.afterEnter,"before-leave":_vm.beforeLeave}},[_c('div',{directives:[{name:"on-click-outside",rawName:"v-on-click-outside.static",value:(_vm.closeDropdown),expression:"closeDropdown",modifiers:{"static":true}},{name:"show",rawName:"v-show",value:(_vm.showOptions),expression:"showOptions"}],staticClass:"dropdown-content db f7 w4 right-0",class:{'track-options': _vm.inPlayer, 'top-2': !_vm.inPlayer, 'absolute': !_vm.inMyLikes}},[_c('button',{staticClass:"pv2 bn pointer tl w-100 flex justify-between",class:{'displayNone': _vm.inMyLikes},on:{"click":function($event){$event.stopPropagation();return _vm.addTrackToQueue.apply(null, arguments)}}},[_vm._v("\n      "+_vm._s(_vm.$t("tracks.actions.addToQueue"))+"\n      "),_c('font-awesome-icon',{staticClass:"iconColor",attrs:{"icon":"plus"}})],1),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.antelPublicUser && !_vm.bitelFreeMusic),expression:"!antelPublicUser && !bitelFreeMusic"}],staticClass:"pv2 bn pointer tl w-100 flex justify-between",on:{"click":function($event){$event.stopPropagation();return _vm.buyTrack.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t("tracks.actions.buy"))+"\n      "),_c('font-awesome-icon',{staticClass:"iconColor",attrs:{"icon":"arrow-down"}})],1),_vm._v(" "),(!_vm.inPlayer)?_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.antelPublicUser),expression:"!antelPublicUser"}],staticClass:"pa2 bn pointer tl w-100 flex justify-between",on:{"click":function($event){$event.stopPropagation();return _vm.like.apply(null, arguments)}}},[_vm._v("\n      "+_vm._s(_vm.$t("tracks.actions.like"))+"\n      "),_c('font-awesome-icon',{class:{'isLiked': _vm.isLiked || _vm.track.like, 'iconColor': !_vm.isLiked},attrs:{"icon":"heart"}})],1):_vm._e(),_vm._v(" "),_c('button',{staticClass:"pa2 bn pointer tl w-100 flex justify-between",on:{"click":function($event){$event.stopPropagation();return _vm.shareTrack.apply(null, arguments)}}},[_vm._v("\n      "+_vm._s(_vm.$t("tracks.actions.share"))+"\n      "),_c('font-awesome-icon',{staticClass:"iconColor",attrs:{"icon":"share-alt"}})],1),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isMyTrack),expression:"isMyTrack"}],staticClass:"pa2 bn pointer tl w-100 flex justify-between",on:{"click":function($event){$event.stopPropagation();return _vm.deleteTrack.apply(null, arguments)}}},[_vm._v("\n      "+_vm._s(_vm.$t("app.delete"))+"\n      "),_c('font-awesome-icon',{staticClass:"iconColor",attrs:{"icon":"trash"}})],1),_vm._v(" "),_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.isMyTrack),expression:"isMyTrack"}],staticClass:"iconColor no-underline pa2 pointer tl w-100 flex justify-between",attrs:{"to":{name: 'track-edit', params: {id: _vm.track.id}}}},[_vm._v("\n      "+_vm._s(_vm.$t("tracks.actions.edit"))+"\n      "),_c('font-awesome-icon',{staticClass:"iconColor",attrs:{"icon":"edit"}})],1),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.antelPublicUser),expression:"!antelPublicUser"}],staticClass:"pa2 bn pointer tl w-100 flex justify-between",on:{"click":function($event){$event.stopPropagation();return _vm.addTrackToPlaylist.apply(null, arguments)}}},[_vm._v("\n      "+_vm._s(_vm.$t("tracks.actions.addToPlaylist"))+"\n      "),_c('font-awesome-icon',{staticClass:"iconColor",attrs:{"icon":"indent"}})],1),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.playlist && _vm.canRemoveTracks),expression:"playlist && canRemoveTracks"}],staticClass:"pa2 bn pointer tl w-100 flex justify-between",on:{"click":function($event){$event.stopPropagation();return _vm.deleteFromPlaylist.apply(null, arguments)}}},[_vm._v("\n      "+_vm._s(_vm.$t("tracks.actions.deleteFromPlaylist"))+"\n      "),_c('font-awesome-icon',{staticClass:"iconColor",attrs:{"icon":"minus-circle"}})],1),_vm._v(" "),_c('button',{staticClass:"pa2 bn pointer tl w-100 flex justify-between",on:{"click":function($event){$event.stopPropagation();return _vm.creditsView.apply(null, arguments)}}},[_vm._v("\n      "+_vm._s(_vm.$t("tracks.actions.credits"))+"\n      "),_c('font-awesome-icon',{staticClass:"iconColor",attrs:{"icon":"bars"}})],1)],1)])}
var staticRenderFns = []


/***/ }),
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-column items-end"},[_c('a',{staticClass:"pa2 h-100 pointer",on:{"click":_vm.showOptionsTrigger}},[_c('font-awesome-icon',{class:{'textColor': _vm.inHome, 'textColor': !_vm.inHome},attrs:{"icon":"ellipsis-v"}})],1),_vm._v(" "),_c('track-options',{attrs:{"track":_vm.track,"showOptions":_vm.showOptions,"inPlayer":_vm.inPlayer,"inMyLikes":_vm.inMyLikes,"playlist":_vm.playlist},on:{"close-dropdown":_vm.closeDropdown}})],1)}
var staticRenderFns = []


/***/ }),
/* 776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center justify-center track-container w-100 relative mw-100 overflow-hidden",class:{'justify-between': _vm.inPlayer}},[_c('div',{staticClass:"flex items-center justify-start"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.track.picture),expression:"track.picture"}],staticClass:"track-picture flex item-center justify-center",style:({'padding': _vm.inPlayer ? '2.5px' : '0'})},[_c('img',{staticClass:"w-100 h-100",attrs:{"src":_vm.picture}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.track == _vm.currentTrack && !_vm.inPlayer && _vm.isPlaying),expression:"track == currentTrack && !inPlayer && isPlaying"}],staticClass:"track-picture-vinyl vinyl-rotation top-50 left-50 z-2 w-70",attrs:{"src":__webpack_require__(355),"alt":"playing track"}})]),_vm._v(" "),_c('div',{staticClass:"mw-100",class:{'track-data' : !_vm.inPlayer}},[_c('h1',{staticClass:"track-info f6 f5-ns fw6 lh-title mv0 mw-100 textColor",class:{ 'player-track-info' : _vm.inPlayer }},[_vm._v(_vm._s((_vm.track.isAd)? _vm.$t('ads.advertisingSpace') : _vm.track.title))]),_vm._v(" "),(_vm.inModal === true)?_c('h2',{staticClass:"track-info f6 fw4 mt0 mb0 mw-100 textColor",class:{ 'player-track-info' : _vm.inPlayer }},[_vm._v(_vm._s(_vm.track && !_vm.track.artist ? _vm.track.name : _vm.track.artist.name))]):_vm._e(),_vm._v(" "),(_vm.inPlayer === true)?_c('router-link',{staticClass:"text-width textColor no-underline",attrs:{"to":{ name:'artist-info', params:{ id:_vm.track.id_artist }}}},[_c('h2',{staticClass:"track-info f6 fw4 mt0 mb0 mw-100 textColor",class:{ 'player-track-info' : _vm.inPlayer }},[_vm._v(_vm._s(_vm.track && !_vm.track.artist ? _vm.track.name : _vm.track.artist.name))])]):_vm._e()],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.inPlayerPlaylist && !_vm.currentTrack.isAd),expression:"!inPlayerPlaylist && !currentTrack.isAd"}]},[_c('track-options-button',{attrs:{"inPlayer":true,"track":_vm.track}})],1)])}
var staticRenderFns = []


/***/ }),
/* 777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlayerControls_vue__ = __webpack_require__(356);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_792ac200_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlayerControls_vue__ = __webpack_require__(779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(778)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-792ac200"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlayerControls_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_792ac200_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlayerControls_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_792ac200_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlayerControls_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 778 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"player-controls flex items-center h-100 p1-ns f5"},[_c('button',{staticClass:"pa2",attrs:{"disabled":!_vm.canPrevious || _vm.isUnauthorized,"title":"Anterior"},on:{"click":_vm.playPrevious}},[_c('font-awesome-icon',{staticClass:"iconColor",attrs:{"icon":"step-backward"}})],1),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isPlaying),expression:"isPlaying"}],staticClass:"pa2",attrs:{"disabled":_vm.isUnauthorized,"title":"Pausa"},on:{"click":function($event){return _vm.setPlaying(false)}}},[_c('font-awesome-icon',{staticClass:"iconColor",attrs:{"icon":"pause"}})],1),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isPlaying),expression:"!isPlaying"}],staticClass:"pa2",attrs:{"disabled":_vm.isUnauthorized,"title":"Play"},on:{"click":function($event){return _vm.setPlaying(true)}}},[_c('font-awesome-icon',{staticClass:"iconColor",attrs:{"icon":"play"}})],1),_vm._v(" "),_c('button',{staticClass:"pa2",attrs:{"disabled":!_vm.canNext || _vm.isUnauthorized,"title":"Siguiente"},on:{"click":_vm.playNext}},[_c('font-awesome-icon',{staticClass:"iconColor",attrs:{"icon":"step-forward"}})],1),_vm._v(" "),_c('div',{staticClass:"dn flex-ns flex-column w2",class:{'h5': _vm.volumeOpen},on:{"mouseover":function($event){_vm.volumeOpen=true},"mouseout":function($event){_vm.volumeOpen=false}}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.volumeOpen),expression:"volumeOpen"}],staticClass:"slider-container relative bg-secondary relative flex items-center"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.volume),expression:"volume"}],staticClass:"slider absolute",attrs:{"type":"range","min":"0","max":"1","step":"0.1"},domProps:{"value":(_vm.volume)},on:{"__r":function($event){_vm.volume=$event.target.value}}})]),_vm._v(" "),_c('button',{staticClass:"w-100 dialog db-ns pa2",attrs:{"title":"Volumen"},on:{"click":function($event){return _vm.volumeTrigger()}}},[_c('font-awesome-icon',{staticClass:"iconColor",attrs:{"icon":_vm.mute ? 'volume-off' : (_vm.volume > 0.5 ? 'volume-up' : 'volume-down')}})],1)])])}
var staticRenderFns = []


/***/ }),
/* 780 */,
/* 781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"z-9999 bottom-0 bg-black fixed noselect"},[_c('div',{staticClass:"progress-bar w-100 absolute top-0 bg-black-40",on:{"click":_vm.onProgressClick}},[_c('div',{ref:"currentProgress",staticClass:"current-progress absolute left-0 top-0 h-100 flex justify-end",attrs:{"id":"current-progress"}},[_c('div',{staticClass:"progress-circle br-100 absolute"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentSeconds),expression:"currentSeconds"}],staticClass:"f7 tr seconds dn absolute textColor"},[_vm._v(_vm._s(_vm._f("time")(_vm.currentSeconds)))]),_vm._v(" "),_c('span',{staticClass:"f7 tr seconds dn absolute textColor"},[_vm._v(_vm._s(_vm.minimumTrackDuration))])])])]),_vm._v(" "),_c('div',{directives:[{name:"on-click-outside",rawName:"v-on-click-outside",value:(_vm.closePlaylist),expression:"closePlaylist"}],staticClass:"flex items-center justify-between w-100 h-100 textColor"},[_c('player-controls',{on:{"changeVolume":_vm.volumeHandler,"mute":_vm.muteHandler}}),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isPlaylistOpen),expression:"isPlaylistOpen"}],staticClass:"playlist flex flex-column self-end overflow-y-scroll pr1 pl1 textColor"},[_c('draggable',{attrs:{"options":_vm.options},model:{value:(_vm.playlist),callback:function ($$v) {_vm.playlist=$$v},expression:"playlist"}},_vm._l((_vm.playlist),function(track,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(!track.isAd),expression:"!track.isAd"}],key:index,staticClass:"bb b--black-05 pa1 nowrap textColor",class:{'track-playing' : track === _vm.currentTrack}},[_c('div',{staticClass:"drag-icon dib v-mid ma0 pointer textColor"},[_c('font-awesome-icon',{attrs:{"icon":"bars","size":"lg"}})],1),_vm._v(" "),_c('a',{staticClass:"dib v-mid",class:{'pointer': track === _vm.currentTrack},on:{"click":function($event){_vm.changeTrack(track); _vm.closePlaylist()}}},[_c('track-info',{attrs:{"inPlayer":true,"inPlayerPlaylist":true,"track":track}})],1)])}),0)],1)]),_vm._v(" "),(_vm.isCurrentAudioTrackSet)?_c('track-info',{staticClass:"h-100",attrs:{"inPlayer":true,"track":_vm.currentTrack}}):_vm._e(),_vm._v(" "),(!_vm.currentTrack.isAd)?_c('div',{staticClass:"w4 dn db-ns tr textColor"},[_c('clip-loader',{staticClass:"mh2",attrs:{"loading":!_vm.currentSeconds,"color":_vm.color,"size":_vm.size}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentSeconds),expression:"currentSeconds"}],staticClass:"f7 ph2 textColor"},[_vm._v("\n        "+_vm._s(_vm._f("time")(_vm.currentSeconds))+" - "+_vm._s(_vm._f("time")(_vm.currentTrack.seconds))+"\n      ")])],1):_vm._e(),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.isCurrentAudioTrackSet),expression:"isCurrentAudioTrackSet"}],staticClass:"mr3 pa2 pointer textColor",on:{"click":_vm.playlistTrigger}},[_c('font-awesome-icon',{attrs:{"icon":"indent","size":"lg"}})],1)],1)])}
var staticRenderFns = []


/***/ }),
/* 782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginModal_vue__ = __webpack_require__(358);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_019b7491_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginModal_vue__ = __webpack_require__(812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(783)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-019b7491"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_019b7491_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginModal_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_019b7491_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginModal_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 783 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(359);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d220fcb8_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(785)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d220fcb8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d220fcb8_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d220fcb8_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 785 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100 flex flex-column items-center background-color"},[_c('div',{staticClass:"w-50-ns w-90"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.modalLogin.apply(null, arguments)}}},[_c('div',{staticClass:"flex flex-column items-center"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"w-100 block ph1 pv2 input",class:{error: _vm.$v.email.$error},attrs:{"type":"text","placeholder":_vm.$t('users.email')},domProps:{"value":(_vm.email)},on:{"blur":_vm.$v.email.$touch,"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),(_vm.$v.email.$error && !_vm.$v.email.required)?_c('span',{staticClass:"errorText ma1 f7"},[_vm._v(_vm._s(_vm.$t('error.emailRequired')))]):_vm._e(),_vm._v(" "),(_vm.$v.email.$error && !_vm.$v.email.email)?_c('span',{staticClass:"errorText ma1 f7"},[_vm._v(_vm._s(_vm.$t('error.emailInvalid')))]):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pass),expression:"pass"}],staticClass:"w-100 block mt2 ph1 pv2 input",class:{error: _vm.$v.pass.$error},attrs:{"type":"password","placeholder":_vm.$t('users.password')},domProps:{"value":(_vm.pass)},on:{"blur":_vm.$v.pass.$touch,"input":function($event){if($event.target.composing){ return; }_vm.pass=$event.target.value}}}),_vm._v(" "),(_vm.$v.pass.$error && !_vm.$v.pass.required)?_c('span',{staticClass:"errorText ma1 f7"},[_vm._v(_vm._s(_vm.$t('error.passwordRequired')))]):_vm._e(),_vm._v(" "),_c('input',{staticClass:"w-50-ns w-100 block mv2 pointer btn dim b f5 fw4 bg-black",attrs:{"type":"submit"},domProps:{"value":_vm.$t('users.login')}})])])])])}
var staticRenderFns = []


/***/ }),
/* 809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForgotPass_vue__ = __webpack_require__(361);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6af0e80e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForgotPass_vue__ = __webpack_require__(811);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(810)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6af0e80e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForgotPass_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6af0e80e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForgotPass_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6af0e80e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForgotPass_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 810 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100 flex flex-column items-center background-color"},[_c('div',{staticClass:"w-50-ns w-90"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.forgotPassword(_vm.email)}}},[_c('div',{staticClass:"flex flex-column items-center"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"w-100 block pl1 pr1 pt2 pb2 input",class:{error: _vm.$v.email.$error},attrs:{"type":"text","placeholder":_vm.$t('users.email')},domProps:{"value":(_vm.email)},on:{"blur":_vm.$v.email.$touch,"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),(_vm.$v.email.$error && !_vm.$v.email.required)?_c('span',{staticClass:"errorText ma1 f7"},[_vm._v(_vm._s(_vm.$t('error.emailRequired')))]):_vm._e(),_vm._v(" "),(_vm.$v.email.$error && !_vm.$v.email.email)?_c('span',{staticClass:"errorText ma1 f7"},[_vm._v(_vm._s(_vm.$t('error.emailInvalid')))]):_vm._e(),_vm._v(" "),_c('input',{staticClass:"w-100 block mv2 pointer btn dim b f5 fw4 bg-black text-color",attrs:{"type":"submit"},domProps:{"value":_vm.$t('users.forgetPassword.button')}})])])])])}
var staticRenderFns = []


/***/ }),
/* 812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{staticClass:"modal",attrs:{"name":"login-modal","transition":"pop-out","width":_vm.modalWidth,"height":"auto","adaptive":true},on:{"before-open":_vm.beforeOpen}},[_c('div',{staticClass:"flex flex-column items-center mb3 background-color"},[_c('div',{staticClass:"flex justify-end w-100"},[_c('a',{staticClass:"pa3 pointer textColor",on:{"click":_vm.closeModal}},[_c('font-awesome-icon',{attrs:{"icon":"times"}})],1)]),_vm._v(" "),_c('div',{staticClass:"flex justify-center fl w-40 h-100 pb2"},[_c('img',{staticClass:"h-100 w-100",attrs:{"src":__webpack_require__(71),"alt":"BeatHey Logo"}})]),_vm._v(" "),_c('div',{staticClass:"mv2"},[_c('clip-loader',{attrs:{"loading":_vm.loading,"color":_vm.color,"size":_vm.size}})],1),_vm._v(" "),(_vm.error)?_c('span',{staticClass:"errorText ma3 tc f7"},[_vm._v(_vm._s(_vm.error))]):_vm._e(),_vm._v(" "),(!_vm.forgotModal)?_c('login'):_vm._e(),_vm._v(" "),(_vm.forgotModal)?_c('forgot-pass'):_vm._e(),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(!_vm.forgotModal),expression:"!forgotModal"}],staticClass:"f6 text-color"},[_vm._v(_vm._s(_vm.$t('users.forgetPassword.question'))+" "),_c('span',{staticClass:"pointer",on:{"click":_vm.forgotTrigger}},[_vm._v(_vm._s(_vm.$t('app.clickHere')))])]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.forgotModal),expression:"forgotModal"}],staticClass:"f6 text-color"},[_vm._v(_vm._s(_vm.$t('users.rememberPassword'))+" "),_c('span',{staticClass:"pointer",on:{"click":_vm.forgotTrigger}},[_vm._v(_vm._s(_vm.$t('app.back')))])])],1)])}
var staticRenderFns = []


/***/ }),
/* 813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignupModal_vue__ = __webpack_require__(362);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_676080cb_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignupModal_vue__ = __webpack_require__(815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(814)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-676080cb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignupModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_676080cb_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignupModal_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_676080cb_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignupModal_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 814 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{staticClass:"modal",attrs:{"name":"signup-modal","transition":"pop-out","width":_vm.modalWidth,"height":"auto","scrollable":true,"adaptive":true},on:{"opened":_vm.opened,"before-close":_vm.beforeClose}},[_c('div',{staticClass:"flex flex-column items-center modal bg-tertiary textColor"},[_c('div',{staticClass:"flex justify-end w-100"},[_c('a',{staticClass:"pa3 pointer textColor",on:{"click":_vm.closeModal}},[_c('font-awesome-icon',{attrs:{"icon":"times"}})],1)]),_vm._v(" "),_c('div',{staticClass:"flex justify-center fl w-30 pb2"},[_c('img',{staticClass:"h-100 w-100",attrs:{"src":__webpack_require__(71),"alt":"BeatHey Logo"}})]),_vm._v(" "),_c('div',{staticClass:"mv2"},[_c('clip-loader',{attrs:{"loading":_vm.loading,"color":_vm.color,"size":_vm.size}})],1),_vm._v(" "),_c('div',{staticClass:"mh5"},[(_vm.error && _vm.input === '')?_c('p',{staticClass:"errorText mh3 tc f7"},[_vm._v(_vm._s(_vm.error))]):_vm._e(),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.modalRegister(_vm.username, _vm.email, _vm.pass, _vm.day, _vm.month, _vm.year, _vm.userType, _vm.voucher)}}},[_c('div',{staticClass:"flex flex-column f6"},[_c('div',{staticClass:"flex-ns justify-center"},[_c('div',{staticClass:"w-50-ns w-100 ph2-ns"},[(_vm.$v.username.$error && !_vm.$v.username.required)?_c('span',{staticClass:"errorText f7"},[_vm._v(_vm._s(_vm.$t('error.usernameRequired')))]):_vm._e(),_vm._v(" "),(_vm.error && _vm.input === 'username')?_c('span',{staticClass:"errorText f7"},[_vm._v(_vm._s(_vm.error))]):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.username),expression:"username"}],staticClass:"w-100 mv2 block ph1 pv2 bg-tertiary",class:{error: _vm.$v.username.$error || (_vm.error && _vm.input === 'username'), 'input-margin': _vm.$v.pass.$error && !_vm.$v.username.$error},attrs:{"type":"text","name":"username","id":"username","placeholder":_vm.$t('users.username')},domProps:{"value":(_vm.username)},on:{"blur":_vm.$v.username.$touch,"input":function($event){if($event.target.composing){ return; }_vm.username=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"w-50-ns w-100 ph2-ns"},[(_vm.$v.pass.$error && !_vm.$v.pass.required)?_c('span',{staticClass:"errorText f7"},[_vm._v(_vm._s(_vm.$t('error.passwordRequired')))]):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pass),expression:"pass"}],staticClass:"w-100 mv2 block ph1 pv2 bg-tertiary",class:{error: _vm.$v.pass.$error, 'input-margin': !_vm.$v.pass.$error && (_vm.$v.username.$error || (_vm.error && _vm.input === 'username'))},attrs:{"type":"password","name":"password","id":"password","placeholder":_vm.$t('users.password')},domProps:{"value":(_vm.pass)},on:{"blur":_vm.$v.pass.$touch,"input":function($event){if($event.target.composing){ return; }_vm.pass=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"flex-ns justify-center"},[_c('div',{staticClass:"w-50-ns w-100 ph2-ns"},[(_vm.$v.dni.$error && !_vm.$v.dni.required)?_c('span',{staticClass:"errorText f7"},[_vm._v(_vm._s(_vm.$t('error.idRequired')))]):_vm._e(),_vm._v(" "),(_vm.$v.dni.$error && !_vm.$v.dni.minLength)?_c('span',{staticClass:"errorText f7"},[_vm._v(" "+_vm._s(_vm.$t('error.shortId')))]):_vm._e(),_vm._v(" "),(_vm.error && _vm.input === 'dni')?_c('span',{staticClass:"errorText f7"},[_vm._v(_vm._s(_vm.error))]):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dni),expression:"dni"}],staticClass:"w-100 mv2 block ph1 pv2 bg-tertiary",class:{error: _vm.$v.dni.$error, 'input-margin': _vm.$v.phone.$error && !_vm.$v.dni.$error},attrs:{"type":"text","name":"dni","id":"dni","placeholder":_vm.$t('users.id')},domProps:{"value":(_vm.dni)},on:{"blur":_vm.$v.dni.$touch,"input":function($event){if($event.target.composing){ return; }_vm.dni=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"w-50-ns w-100 ph2-ns"},[(_vm.$v.phone.$error && !_vm.$v.phone.numeric)?_c('span',{staticClass:"errorText f7"},[_vm._v(_vm._s(_vm.$t('error.phoneInvalid')))]):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone),expression:"phone"}],staticClass:"w-100 mv2 block ph1 pv2 bg-tertiary",class:{error: _vm.$v.phone.$error, 'input-margin': _vm.$v.dni.$error && !_vm.$v.phone.$error},attrs:{"type":"text","name":"phone","id":"phone","placeholder":_vm.$t('users.phone')},domProps:{"value":(_vm.phone)},on:{"blur":_vm.$v.phone.$touch,"input":function($event){if($event.target.composing){ return; }_vm.phone=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"flex-ns db justify-center"},[_c('div',{staticClass:"w-50-ns w-100 ph2-ns"},[(_vm.error && _vm.input === 'email')?_c('span',{staticClass:"errorText f7"},[_vm._v(_vm._s(_vm.error))]):_vm._e(),_vm._v(" "),(_vm.$v.email.$error && !_vm.$v.email.required)?_c('span',{staticClass:"errorText f7"},[_vm._v(_vm._s(_vm.$t('error.emailRequired')))]):_vm._e(),_vm._v(" "),(_vm.$v.email.$error && !_vm.$v.email.email)?_c('span',{staticClass:"errorText f7"},[_vm._v(_vm._s(_vm.$t('error.emailInvalid')))]):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"w-100 mv2 block ph1 pv2 bg-tertiary",class:{'error': _vm.$v.email.$error || (_vm.error && _vm.input === 'email'), 'input-margin': _vm.$v.email2.$error && !_vm.$v.email.$error},attrs:{"type":"text","name":"email","id":"email","placeholder":_vm.$t('users.email')},domProps:{"value":(_vm.email)},on:{"blur":_vm.$v.email.$touch,"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"w-50-ns w-100 ph2-ns"},[(_vm.$v.email2.$error && !_vm.$v.email2.required)?_c('span',{staticClass:"errorText f7"},[_vm._v(_vm._s(_vm.$t('error.confirmEmailRequired')))]):_vm._e(),_vm._v(" "),(_vm.$v.email2.$error && !_vm.$v.email2.sameAs && _vm.$v.email2.required)?_c('span',{staticClass:"errorText f7"},[_vm._v(_vm._s(_vm.$t('error.confirmEmailInvalid')))]):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email2),expression:"email2"}],staticClass:"w-100 mv2 block ph1 pv2 bg-tertiary",class:{error: _vm.$v.email2.$error, 'input-margin': (_vm.$v.email.$error ||(_vm.error && _vm.input === 'email')) && !_vm.$v.email2.$error},attrs:{"type":"text","name":"email2","id":"email2","placeholder":_vm.$t('users.emailConfirmation')},domProps:{"value":(_vm.email2)},on:{"blur":_vm.$v.email2.$touch,"input":function($event){if($event.target.composing){ return; }_vm.email2=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"flex"},[(_vm.$v.address.$error && !_vm.$v.address.required)?_c('span',{staticClass:"errorText f7 mh2-ns"},[_vm._v(_vm._s(_vm.$t('error.addressRequired')))]):_vm._e(),_vm._v(" "),(_vm.error && _vm.input === 'address')?_c('span',{staticClass:"errorText f7"},[_vm._v(_vm._s(_vm.error))]):_vm._e()]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.address),expression:"address"}],staticClass:"mv2 mh2-ns block ph1 pv2 bg-tertiary",class:{error: _vm.$v.address.$error},attrs:{"type":"text","name":"address","id":"address","placeholder":_vm.$t('users.address')},domProps:{"value":(_vm.address)},on:{"blur":_vm.$v.address.$touch,"input":function($event){if($event.target.composing){ return; }_vm.address=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"flex"},[((_vm.$v.day.$error && !_vm.$v.day.required) || (_vm.$v.month.$error && !_vm.$v.month.required) ||
            (_vm.$v.year.$error && !_vm.$v.year.required))?_c('span',{staticClass:"errorText f7 mh2-ns"},[_vm._v(_vm._s(_vm.$t('error.birthdateRequired')))]):_vm._e()]),_vm._v(" "),_c('label',{staticClass:"mt2 mh2-ns"},[_vm._v(_vm._s(_vm.$t('users.birthdate')))]),_vm._v(" "),_c('div',{staticClass:"flex-ns justify-between items-center"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.day),expression:"day"}],staticClass:"w-third-ns w-100 mv2 mh2-ns block ph1 pv2 bg-tertiary textColor",class:{error: _vm.$v.day.$error},attrs:{"id":"birth-day"},on:{"blur":_vm.$v.day.$touch,"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.day=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v(_vm._s(_vm.$t('users.day')))]),_vm._v(" "),_vm._l((31),function(n){return _c('option',{key:n,attrs:{"track-by":n},domProps:{"value":n}},[_vm._v(_vm._s(n))])})],2),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.month),expression:"month"}],staticClass:"w-third-ns w-100 mv2 mh2-ns block ph1 pv2 bg-tertiary textColor",class:{error: _vm.$v.month.$error},attrs:{"id":"birth-month"},on:{"blur":_vm.$v.month.$touch,"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.month=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v(_vm._s(_vm.$t('users.month')))]),_vm._v(" "),_vm._l((_vm.months),function(month,index){return _c('option',{key:index,attrs:{"track-by":index},domProps:{"value":index}},[_vm._v(_vm._s(month))])})],2),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.year),expression:"year"}],staticClass:"w-third-ns w-100 mv2 mh2-ns block ph1 pv2 bg-tertiary textColor",class:{error: _vm.$v.year.$error},attrs:{"id":"birth-year"},on:{"blur":_vm.$v.year.$touch,"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.year=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v(_vm._s(_vm.$t('users.year')))]),_vm._v(" "),_vm._l((70),function(n){return _c('option',{key:n,attrs:{"track-by":n},domProps:{"value":n+1940}},[_vm._v(_vm._s(n+1940))])})],2)]),_vm._v(" "),_c('div',{staticClass:"flex-ns db justify-between items-center"},[_c('label',{staticClass:"mv2 mh2-ns"},[_c('strong',[_vm._v(_vm._s(_vm.$t('users.voucher')))])]),_vm._v(" "),_c('div',{staticClass:"flex flex-column w-50-ns w-100"},[(_vm.$v.voucher.$error && !_vm.$v.voucher.minLength)?_c('span',{staticClass:"errorText f7 mh2-ns"},[_vm._v(_vm._s(_vm.$t('error.shortVoucher')))]):_vm._e(),_vm._v(" "),(_vm.$v.voucher.$error && !_vm.$v.voucher.maxLength)?_c('span',{staticClass:"errorText f7 mh2-ns"},[_vm._v(_vm._s(_vm.$t('error.longVoucher')))]):_vm._e(),_vm._v(" "),(_vm.error && _vm.input === 'voucher')?_c('span',{staticClass:"errorText f7 mh2-ns"},[_vm._v(_vm._s(_vm.error))]):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.voucher),expression:"voucher"}],staticClass:"mv2 mh2-ns block ph1 pv2 bg-tertiary",class:{error: _vm.$v.voucher.$error || _vm.error && _vm.input === 'voucher'},attrs:{"type":"text","name":"voucher","id":"voucher","placeholder":_vm.$t('users.code')},domProps:{"value":(_vm.voucher)},on:{"blur":_vm.$v.voucher.$touch,"input":function($event){if($event.target.composing){ return; }_vm.voucher=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"flex-ns justify-center items-center"},[_c('label',{staticClass:"ma2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userType),expression:"userType"}],attrs:{"name":"user_type","type":"radio","value":"0","checked":""},domProps:{"checked":_vm._q(_vm.userType,"0")},on:{"change":function($event){_vm.userType="0"}}}),_vm._v(_vm._s(_vm.$t('users.userType.musicFan')))]),_vm._v(" "),_c('label',{staticClass:"ma2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userType),expression:"userType"}],attrs:{"name":"user_type","type":"radio","value":"1"},domProps:{"checked":_vm._q(_vm.userType,"1")},on:{"change":function($event){_vm.userType="1"}}}),_vm._v(_vm._s(_vm.$t('users.userType.producer')))])]),_vm._v(" "),_c('div',{staticClass:"flex items-center"},[_c('input',{staticClass:"ma2",attrs:{"type":"checkbox","name":"accept","id":"accept","checked":""}}),_vm._v(" "),_c('label',{staticClass:"ma2 f7",attrs:{"for":"accept"}},[_vm._v(_vm._s(_vm.$t('users.registration.shareData')))])]),_vm._v(" "),_c('p',{staticClass:"f7"},[_vm._v(_vm._s(_vm.$t('users.registration.accept'))+"\n            "),_c('router-link',{staticClass:"textColor",attrs:{"to":{ name: 'general-terms-' + _vm.language},"target":"_blank"}},[_vm._v(_vm._s(_vm.$t('footer.termsOfUse')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('users.registration.comma')))]),_vm._v(" "),_c('router-link',{staticClass:"textColor",attrs:{"to":{ name: 'intellectual-prop-' + _vm.language},"target":"_blank"}},[_vm._v(_vm._s(_vm.$t('footer.intellectuallyProp')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('users.registration.andThe')))]),_vm._v(" "),_c('router-link',{staticClass:"textColor",attrs:{"to":{ name: 'privacy-policy-' + _vm.language},"target":"_blank"}},[_vm._v(_vm._s(_vm.$t('footer.privacyPolicy')))])],1),_vm._v(" "),_c('div',{staticClass:"flex justify-center"},[_c('input',{staticClass:"w-50-ns w-100 block mv2 pointer btn dim b f5 fw4",attrs:{"type":"submit"},domProps:{"value":_vm.$t('users.registration.register')}})]),_vm._v(" "),_c('p',{staticClass:"tc f7"},[_vm._v(_vm._s(_vm.$t('users.registration.alreadyHaveAnAccount'))+"\n            "),_c('span',{staticClass:"pointer",on:{"click":_vm.login}},[_vm._v(_vm._s(_vm.$t('users.login')))])])])])])])])}
var staticRenderFns = []


/***/ }),
/* 816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SubscriptionModal_vue__ = __webpack_require__(363);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e30120a0_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SubscriptionModal_vue__ = __webpack_require__(824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(817)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e30120a0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SubscriptionModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e30120a0_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SubscriptionModal_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e30120a0_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SubscriptionModal_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 817 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SubscriptionInfo_vue__ = __webpack_require__(364);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e44cab4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SubscriptionInfo_vue__ = __webpack_require__(823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(819)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6e44cab4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SubscriptionInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e44cab4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SubscriptionInfo_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e44cab4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SubscriptionInfo_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 819 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SlideInfo_vue__ = __webpack_require__(365);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_075dcc00_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SlideInfo_vue__ = __webpack_require__(822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(821)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SlideInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_075dcc00_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SlideInfo_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_075dcc00_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SlideInfo_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 821 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-column justify-center"},[_c('div',{staticClass:"flex justify-center w-100 h-100 pt3"},[_c('img',{staticClass:"slideInfoImg",attrs:{"src":_vm.img}})]),_vm._v(" "),_c('div',{staticClass:"ph3 self-center"},[_c('p',{staticClass:"tc silver"},[_vm._v(_vm._s(_vm.text))])])])}
var staticRenderFns = []


/***/ }),
/* 823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-column justify-center"},[_c('carousel',{attrs:{"per-page":1,"navigationEnabled":true,"paginationActiveColor":"#272727","paginationColor":"#ccc","paginationEnabled":false,"loop":true,"autoplay":true}},_vm._l((5),function(n){return _c('slide',{key:n},[_c('slide-info',{attrs:{"text":_vm.$t('users.subscription.info'+n),"img":("/static/assets/subscription/" + n + ".png")}})],1)}),1)],1)}
var staticRenderFns = []


/***/ }),
/* 824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{staticClass:"modal mt4",attrs:{"name":"subscription-modal","transition":"pop-out","width":_vm.modalWidth,"height":"auto","adaptive":true},on:{"before-open":_vm.beforeOpen}},[_c('div',{staticClass:"flex flex-column items-center mb3"},[_c('div',{staticClass:"flex justify-end w-100"},[_c('a',{staticClass:"pa3 pointer textColor",on:{"click":_vm.closeModal}},[_c('font-awesome-icon',{attrs:{"icon":"times"}})],1)]),_vm._v(" "),_c('div',{staticClass:"flex justify-center fl w-30 pb2"},[_c('img',{staticClass:"h-100 w-100",attrs:{"src":__webpack_require__(71),"alt":"BeatHey Logo"}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}]},[_c('clip-loader',{staticClass:"mv2",attrs:{"loading":_vm.loading,"color":_vm.color,"size":_vm.size}})],1),_vm._v(" "),_c('div',{staticClass:"w-70 hide-s"},[_c('subscription-info')],1),_vm._v(" "),_c('p',{staticClass:"tc silver mb0"},[_vm._v(_vm._s(_vm.$t("users.subscription.valueTitle")))]),_vm._v(" "),_c('p',{staticClass:"tc silver f1 fw2 ma0"},[(_vm.showARG)?_c('span',{staticClass:"f3"},[_vm._v("AR$")]):_vm._e(),_vm._v(" "),(_vm.showUSD)?_c('span',{staticClass:"f3"},[_vm._v("U$D")]):_vm._e(),_vm._v(" "),(_vm.showARG)?_c('span',[_vm._v(_vm._s(_vm.pricing[0].currency_override.ARS))]):_vm._e(),_vm._v(" "),(_vm.showUSD)?_c('span',[_vm._v(_vm._s(_vm.pricing[0].amount))]):_vm._e()]),_vm._v(" "),_c('div',[_c('p',[_vm._v(_vm._s(_vm.$t("users.subscription.voucherCodeMsg")))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.voucherCode),expression:"voucherCode"}],staticClass:"w-100",attrs:{"type":"text","maxlength":"55"},domProps:{"value":(_vm.voucherCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.voucherCode=$event.target.value}}})]),_vm._v(" "),_c('div',[_c('p',[_vm._v(_vm._s(_vm.$t("users.subscription.referredCodeMsg")))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.refCodeInp),expression:"refCodeInp"}],staticClass:"w-100",attrs:{"type":"text","maxlength":"55"},domProps:{"value":(_vm.refCodeInp)},on:{"input":function($event){if($event.target.composing){ return; }_vm.refCodeInp=$event.target.value}}})]),_vm._v(" "),_c('button',{staticClass:"w-40-ns w-90 block mv2 pointer btn dim b f5 fw4",on:{"click":_vm.openPayment}},[_vm._v(_vm._s(_vm.$t("users.subscription.title")))])])])}
var staticRenderFns = []


/***/ }),
/* 825 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaypalPayment_vue__ = __webpack_require__(367);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b539e98_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaypalPayment_vue__ = __webpack_require__(841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaypalPayment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b539e98_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaypalPayment_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b539e98_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaypalPayment_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"paypal"})])}
var staticRenderFns = []


/***/ }),
/* 842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{staticClass:"modal",attrs:{"name":"payment-modal","transition":"pop-out","width":_vm.modalWidth,"height":260,"adaptive":true,"clickToClose":false},on:{"before-open":_vm.beforeOpen}},[_c('div',{staticClass:"flex flex-column items-center justify-center mb3"},[_c('div',{staticClass:"flex justify-end w-100"},[_c('a',{staticClass:"pa3 pointer textColor",on:{"click":_vm.closeModal}},[_c('font-awesome-icon',{attrs:{"icon":"times","size":"2x"}})],1)]),_vm._v(" "),_c('div',{staticClass:"h2 heigthMobile"},[_c('clip-loader',{attrs:{"loading":_vm.isLoadingLink,"color":_vm.color,"size":_vm.size}})],1),_vm._v(" "),_c('div',{staticClass:"mb4 flex items-center flex-wrap justify-center"},[(_vm.user.country === 'argentina' || _vm.user.country === 'Argentina' || _vm.user.country === 'ARG' || _vm.user.country === 'AR' || _vm.providerCountry === 'ARG')?_c('div',[_c('button',{staticClass:"payment-button mh2 pointer borderButton",class:{ 'disabled': _vm.disabled },attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.getPaymentLink('mercadopago')}}},[_c('div',{staticClass:"h2",staticStyle:{"width":"190px"}},[_c('img',{attrs:{"src":__webpack_require__(843)}})])]),_vm._v(" "),_c('div',{staticStyle:{"min-height":"17.5px"}})]):_vm._e(),_vm._v(" "),_c('div',[_c('paypal-payment',{attrs:{"track":_vm.track,"value":_vm.valueUSD,"ppPlans":_vm.ppPlans,"refCode":_vm.refCode,"voucher":_vm.voucher}}),_vm._v(" "),(_vm.user.country === 'argentina' || _vm.user.country === 'Argentina' || _vm.user.country === 'ARG' || _vm.user.country === 'AR' || _vm.providerCountry === 'ARG')?_c('span',{staticStyle:{"display":"flex","justify-content":"center"}},[_vm._v("Aplica tarifa internacional USD "+_vm._s(_vm.pricing[0].amount)+" ")]):_vm._e()],1),_vm._v(" "),(_vm.voucher)?_c('span',{staticClass:"accent fsize15"},[_vm._v("El Beneficio del Voucher ( "+_vm._s(_vm.voucher.months)+" meses gratis )"),(_vm.voucher.months !== 3)?_c('span',[_vm._v(" sólo es aplicable con Mercado Pago.")]):_vm._e()]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"w-100 tc textColor"},[_vm._v(_vm._s(_vm.$t("users.payment.message")))]),_vm._v(" "),(_vm.user.country === 'argentina' || _vm.user.country === 'Argentina' || _vm.user.country === 'ARG' || _vm.user.country === 'AR' || _vm.providerCountry === 'ARG')?_c('p',{staticClass:"w-100 tc textColor"},[_vm._v(_vm._s(_vm.message))]):_vm._e()])])])}
var staticRenderFns = []


/***/ }),
/* 843 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHkAAAAgCAYAAAA2e9d2AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAADGNJREFUeNrsWwtQ1McZ/1SCUuQ4OkhF2uGgDzEkHoox0ypyihoTh3LYqNU63hEbqY4p5zQTTWLKMbGjxk4BnXbqazxqxmqM8VBjO9OoR2NnOigN4Iv4OA4VKAHlZVR0jN1v+fZclrvjTh7NZPiYnbv//77/7v739713GfLo0SN4UhqfvDaJfRhY09KnILwfzloFay10Dz/LRass2+iCQRoQGhIIyAxUBNOI7b5Gk3EvMhLusvZlTAz/XXyqNOz+fRjR2Oj+HFlbC6G1tTXsJwdrdga4fRAKv5UK1yqWtels3Rz+PBfkZ+eopRYGakbzuHHQGh8PD8LC/J7cw+BgtwC0xcXBF523YzXV1SaN02lK/Elu27COjnx2zzao4T7JSAAHREF+SE4BAza1OSHBq6Y+KSHg2CAtTRNRVZUbVVqay8bMwzEZ2C2DmAak5Vpyky5VUTyaa3rAykDNqUtJATTLgRAzxfwzpKmJm3PUembe/XqWgQ3Rn36Kmm16EjPO5o7SXiBJPLoFCy2AhWIFpBK8ZmOUS8+a8b2VZ3EOVlnoGJ+O+IzUXx773SqUgrVUaUo19LxNXlvWzNJckIqJr9zLe+DvCF4OXXNz7YGv25jdQKYXsIdOeFp/IVoHbcw0+0MMFAQHIqqr4amhADHxoyFo6BC41XoXbl1rgK/CNdA0NgGa9Hp4OHy4776Y7449dgxCb9woZBO1BAjwoQBkopU1HQLIni2QFlAlDCANxKej4FEGKI+E4TMfYwlBQIBzvc2H8Wj9fI/pFPD64stCoINU8xwaqf1n/p+zw0oOngI4fAI6Th6H1rh4aI4ew821rJHBbW0wgmkramxURQX84EfR8OZWEzyX3FUw2tvvwgnHBSg6eBqu7NjRaaaZ8GBfwgWg9mN/EfV1oKl2QnhYCMx+a1EOSj6bqNlP0Aqk74X0maNIuI20OoOAMrMx7BJfK/XjIs3XUzPTfasCcA3x2hThQV4UCBPds0gaLHgs9KyVtD+c4p8CD3M2KBZCfd9iEjSDNGYBvptbk3ExGcDXtu3JCRsfFeJ+8nSZE06cPA+Of1+F2ur/wlCtBh4wcIK+aIRH9zpg+LeGQ8edDshalgarV87qAmzVpfpugFd9XgcHis/AZxfq4MrZrjFWwngdJCfGwHOT4mGGIZHf+2tZPWxYXljkD9DsHYRZclsARUMnSOawhcAqpig/X9Y4yapVi8Vm93XSGK1k7m0KH1Kc8IskQFopcBKWSaSTSYq5XYSvLWu29H4uiW+1NGc+N4mvnAQTKVPWZMfm7Su7AIyEIGFbIwEnKGzkCFiybBu8te5l+HnmJDe4v914BI7//T+d2s6E4J03fgoZ6cmdQI4dw6/9pUXJ0XA6O92EE2cvUuDnYy2evsv+lxY4lQDQSvcx+PNkTtWotlz4PNJYQSVy4MO+GxVBtBPQFsUiCBotY6L8Jluc0cp9lU+AnBQkAo6MtYv1U2N9B0dhzIQKzUSNXPrLbfCLxVPdAJ9wnIc173wAo0ZHwK7tyyGBme+de07Bu+8dhqOfnIM/rF/A+wiUcs0/hkpHxXo2T9sARN0VipB4o/InjIAdEriiVqDzYIrBwzx0fg6l7ZZCjYyKWP96xjMBTfhvx8+DhgG20DgJ6uqaYfXb+8F5pR5yVsyCJQx4QWjCkSfbUgQLX9kGOwtNMGZMREBjhQcPhWW/yQxlZtsqmbv+onI/Y4AWL9+TKI5oUdyCCJbE92Kh5YxH1tjb0neDMqZ8zYImbmBVN6DylQdhJDczOz0GFzIQejEtEf5VehXmpG/i12lzJsLOLSaPmoqg7t2Vzc24cWEh/GXncm62AyE021sita/0E8h2KeI10aK7aPFyVFBUQjfAnqkhk44guti1RUqxkIq8aLYaUH1CGo59xdJcbErKhT74qDSmyqeX4gYHImt4Ovbb3JcGQgjSh7Zf4Qvylv8736YYf0Oe9PSJsISZ+eIjZQEjkTjn+TDKRfuUyFfLIOxm7aQScfckXPLv4dRHhnTPRmXIGrrG35qVFKiI/LlVupdKfaV6GMvSEx9aFAQ5aWv+UZhiyIPZP8vn/hN9a38RBl28WQ/AvkNnfPKiG3h/7ykwv1YEyVNz4VzZ5UD8UqBAowZkSSCAVDQx9FRupcJNJvl01cfLdWYzRfSgpEl5wk1QQOetr0xRJPIxZg3xdRZDnp24xnF21apUnu82NvJ8FQsawcMAUqYlwuJ5k7qlQX1BmJqtZH4aU6VN7y7oAux++xkeqDXWNMCDUZHQOiaG59MhDQ0QVVbmTnH6uUyo+6bU0YNEhQlLl9hwA+IGFScaLl6EE78ugghNCGxmkTEC4Lx+iwdSYWEjeDqFEXQgETOaaUynUHD27MzmETpqaubsZzqLJSx3RmCbEsZBW+oLXYovKIgDRd+kjRIOMm7/qZsPeI2tvqMDIisqYNny7e6Cxe5dx/l3LIQMYX9/LFjKc2Z/gqnTZ5y8rc+bz/mPH1sLi1muvW7DYWjU66F56TSvde7g9naggGiQAgTZpXE6U73tMGGduWHyZF62XGFKgRXZM2Fd7gFelUKNXP32B24BCAkdAUU7fEfOCC4+k8Gi7PdZlI1WYDMz1wsWb+Hj+LHx0e8gD9l9I0nONR9lfdfhhU9OVVyMz+WFR/Tn8NGXfACDV8M89fdE78N8soVpTv7nS5f6ZPzhvn0Qfqcd1rGgCVMi4acxKq9lZhyBxaDt6vVmsG01dXt+0++PwJrX0x/nzwxozKvXvZEOHzIfbK9sgEvGTJ8Axx/igWhEfxVE2ELrKA1J9bCRYWaLbic+UccO9xCkWRhfOYFmk9IZOSgyC7AZn5ZSOE/FkDzG1+v4A6NrO24MoEn2RddnzoRbEZE8Kt6+v7RLaiQ0d8rk78OlS3WQ/6d/dEvJ2tvvwfxFhe77mE7dbL3DrcD+i81wbWqKz/G/U1oqSob9WfHyttgIpo2EALwALNIYq8Sj91IetUt9eRuTF/sYn7HXIFOAURLFFvGpTp/nkTAoc2ZmwoVXX4XKqjoeQGHD8qYMJBZJ0GfPz9rGAzWRjqGZ1kZpWY68nXalzsNtxo/91cyd63PPGgWQTLWtH020USkiZFGFqkIC2kJ8AmDc6Yqg5i4pkhanKn1NIE0XfZkVvhriw77ypP4Kev1uuAtF21snOZDz5vHjOr4I945xvxctwPdCh8HBfTluky0iaNR4rF9v2HwEFiycwuvbCO4LLxfA7aZW+Gp4MPPBz/P9ZV+kYelc7McfiyqPrh9BtkpVr0JmJi2STz0pmWOzlKtr6btBKnyUkHbmqybXQ18OT2MSr1wOnYAuoFfRNZ0wKGQpSk78Rx/1CDQGY6jVCHbwYTtMe3EjPLzbwUubaIZlwkBs1txNcPlyHYyOjoC7X97jz/pzlIhOiYBURBgocshBF1twd10agyF2bYHuJzu8bRB468vrmKLmLGm5ttcpFBFKm4EBrR9bVAQ1L73UIxAIduX8hTx/jWA5NW4vLqi7BVWVnUHha2/uh2eT4iCIpVp7j53lR4Gap6f5BTC6D/LDQNUgxwCCrFOCMXcETQDnSCbWTgBZvfhg2Vpo/RmzL4BVAy+R/LeQ2alADcVIFrUICyU9EZr5+pQUuJGWBmU3H/DPs6tWwblpM+BIezCUT50BVSYT9709HSdCgcGxJYCLBqLCpZBRAkQOfFzKtZlMrEsBWBZIo6JIoPTXjY8ES99TCheQT1bKeWLPUy+0Ff3mzaSkHn11bwiDPgQWLYJEAZ3x6kOfLAImFbwsynmFJucRj1kyrcUMFBQSFzw+aFACj//hQE63jPS8ur8s56BFrD9zn4Isgd3lYBuCjVrIGx6j7QNCK6FxOjmw4oSnnJcO5KF7BeRWTzkwW2wDaVm1l27wOYOPPFnuV/Tn69BeBfXX0i8gE9CejphywEXZE/3svVGj/NJyNMVYmsQyajgD10stGtMS60Cfu1ZAziTXJbY1HXJRgoAxKn4UA6UCuUpFJt8Cj48Y2eToGkGWzLNV6Q8F3NZbgHsEWQLbQJPN8MWHNWdP/1mBYKKf90GttAAF/6+NAQXk6b3xg6TFIr9tId/dwu7bpTXsk2pWn4Gs+GshxQYfKYQ/9LX6XygF5F7lpdSf7JPF+8rXcX1Vm+5TkL2Ycx08LsB7O7Uh/qNRRJ7lX7d/g6F6NDZXbwMdSZsdXhQhi41hG7B36w3Ig9Qj0FrJdyeRoNsGSoMF/U+AAQAtFNmGC2jb+gAAAABJRU5ErkJggg=="

/***/ }),
/* 844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShareModal_vue__ = __webpack_require__(377);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d4d2c76_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShareModal_vue__ = __webpack_require__(849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(845)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7d4d2c76"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShareModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d4d2c76_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShareModal_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d4d2c76_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShareModal_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 845 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlaylistInfo_vue__ = __webpack_require__(378);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d5ced1e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlaylistInfo_vue__ = __webpack_require__(848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(847)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7d5ced1e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlaylistInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d5ced1e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlaylistInfo_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d5ced1e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlaylistInfo_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 847 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center justify-center playlist-container w-100 relative mw-100 overflow-hidden textColor"},[_c('div',{staticClass:"flex items-center justify-start"},[_c('div',{staticClass:"picture flex item-center justify-center"},[_c('img',{staticClass:"w-100 h-100",attrs:{"src":_vm.picture}})]),_vm._v(" "),_c('div',{staticClass:"mw-100 playlist-data"},[_c('h1',{staticClass:"playlist-info f6 f5-ns fw6 lh-title mv0 mw-100 textColor"},[_vm._v(_vm._s(_vm.playlist.title))]),_vm._v(" "),_c('h2',{staticClass:"playlist-info f6 fw4 mt0 mb0 black-60 mw-100 textColor"},[_vm._v(_vm._s(_vm.playlist.name))])])])])}
var staticRenderFns = []


/***/ }),
/* 849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"name":"share-modal","transition":"pop-out","width":_vm.modalWidth,"height":"auto","adaptive":true},on:{"before-open":_vm.beforeOpen}},[_c('div',{staticClass:"flex flex-column items-center mb3"},[_c('div',{staticClass:"flex justify-end w-100"},[_c('a',{staticClass:"pointer pa3 textColor",on:{"click":_vm.closeModal}},[_c('font-awesome-icon',{attrs:{"icon":"times","size":"2x"}})],1)]),_vm._v(" "),_c('div',{staticClass:"flex justify-center fl w-30 pb2"},[_c('img',{staticClass:"h-100 w-100",attrs:{"src":__webpack_require__(71),"alt":"BeatHey Logo"}})]),_vm._v(" "),(_vm.track !== null)?_c('div',[_c('h3',{directives:[{name:"show",rawName:"v-show",value:(_vm.track),expression:"track"}],staticClass:"mv1 tc textColor"},[_vm._v(_vm._s(_vm.$t("tracks.shareTrack.title")))]),_vm._v(" "),_c('div',{staticClass:"flex justify-center ma3-ns ma1 w-100"},[_c('track-info',{directives:[{name:"show",rawName:"v-show",value:(_vm.track),expression:"track"}],staticClass:"flex justify-center textColor",attrs:{"track":_vm.track,"inModal":true}})],1)]):_vm._e(),_vm._v(" "),(_vm.playlist !== null)?_c('div',[_c('h3',{staticClass:"mv1 tc textColor"},[_vm._v(_vm._s(_vm.$t("playlists.sharePlaylist")))]),_vm._v(" "),_c('div',{staticClass:"flex justify-center ma3-ns ma1 w-100"},[_c('playlist-info',{directives:[{name:"show",rawName:"v-show",value:(_vm.playlist),expression:"playlist"}],staticClass:"flex justify-center textColor",attrs:{"playlist":_vm.playlist}})],1)]):_vm._e(),_vm._v(" "),_c('social-sharing',{staticClass:"flex w-100 justify-center",attrs:{"url":_vm.link,"title":_vm.title,"description":_vm.description,"hashtags":"BeatHey"},inlineTemplate:{render:function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('network',{staticClass:"pointer pa3 textColor",attrs:{"network":"facebook"}},[_c('font-awesome-icon',{attrs:{"icon":['fab', 'facebook-square'],"size":"2x"}})],1),_vm._v(" "),_c('network',{staticClass:"pointer pa3 textColor",attrs:{"network":"twitter"}},[_c('font-awesome-icon',{attrs:{"icon":['fab', 'twitter-square'],"size":"2x"}})],1),_vm._v(" "),_c('network',{staticClass:"pointer pa3 textColor dn-ns db",attrs:{"network":"whatsapp"}},[_c('font-awesome-icon',{attrs:{"icon":['fab', 'whatsapp'],"size":"2x"}})],1)],1)},staticRenderFns:[]}}),_vm._v(" "),_c('div',{staticClass:"flex flex-column items-center mh2 w-100"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.link),expression:"link"}],staticClass:"w-two-thirds block ma2 ph1 pv2 input bg-white h2",attrs:{"contenteditable":"true","readonly":""},domProps:{"value":(_vm.link)},on:{"input":function($event){if($event.target.composing){ return; }_vm.link=$event.target.value}}}),_vm._v(" "),_c('button',{directives:[{name:"clipboard",rawName:"v-clipboard",value:(_vm.link),expression:"link"}],staticClass:"btn w-third pointer",on:{"success":_vm.clipboardSuccess,"error":_vm.clipboardError}},[_vm._v(" "+_vm._s(_vm.$t("tracks.shareTrack.copy")))])])],1)])}
var staticRenderFns = []


/***/ }),
/* 850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BuyTrackModal_vue__ = __webpack_require__(379);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66d5831a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BuyTrackModal_vue__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(851)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-66d5831a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BuyTrackModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66d5831a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BuyTrackModal_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66d5831a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BuyTrackModal_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 851 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{staticClass:"modal",attrs:{"name":"buy-track-modal","transition":"pop-out","width":_vm.modalWidth,"height":"auto","scrollable":true,"adaptive":true,"clickToClose":false},on:{"before-close":_vm.beforeClose,"before-open":_vm.beforeOpen}},[_c('div',{staticClass:"flex flex-column items-center modal"},[_c('div',{staticClass:"flex justify-end w-100"},[_c('a',{staticClass:"pa3 pointer textColor",on:{"click":_vm.closeModal}},[_c('font-awesome-icon',{attrs:{"icon":"times"}})],1)]),_vm._v(" "),_c('div',{staticClass:"flex justify-center fl w-30 pb2"},[_c('img',{staticClass:"h-100 w-100",attrs:{"src":__webpack_require__(71),"alt":"BeatHey Logo"}})]),_vm._v(" "),(_vm.track)?_c('h1',{staticClass:"f3 mv2 textColor"},[_vm._v(_vm._s(_vm.$t("tracks.buyTrack.title") + _vm.track.name))]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"mv2 textColor"},[_c('clip-loader',{attrs:{"loading":_vm.loading,"color":_vm.color,"size":_vm.size}})],1),_vm._v(" "),_c('div',{staticClass:"flex justify-center ph5-ns w-100"},[(_vm.track)?_c('track-info',{staticClass:"flex justify-center",attrs:{"track":_vm.track,"inModal":true}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"f7 ph6-ns w-100 miniscreen textColor"},[_c('p',{staticClass:"tc textColor"},[_vm._v(" "+_vm._s(_vm.$t("tracks.buyTrack.line1")))]),_vm._v(" "),_c('p',{staticClass:"tc textColor"},[_vm._v(" "+_vm._s(_vm.$t("tracks.buyTrack.line2")))]),_vm._v(" "),(_vm.error)?_c('p',{staticClass:"errorText mh3 tc f7"},[_vm._v(_vm._s(_vm.error))]):_vm._e(),_vm._v(" "),_c('form',[_c('div',{staticClass:"flex flex-column justify-center items-center"},[(_vm.$v.value.$error && !_vm.$v.value.required)?_c('span',{staticClass:"errorText ma1 f7"},[_vm._v(_vm._s(_vm.$t("error.valueRequired")))]):_vm._e(),_vm._v(" "),(_vm.suggestedValues[_vm.currency])?_c('div',{staticClass:"flex justify-center"},_vm._l((_vm.suggestedValues[_vm.currency]),function(item){return _c('label',{key:item,staticClass:"ma2 flex items-center miniscreen",attrs:{"track-by":item}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],attrs:{"name":"value","type":"radio","checked":""},domProps:{"value":_vm._f("currency")(item,2),"checked":_vm._q(_vm.value,_vm._f("currency")(item,2))},on:{"change":function($event){_vm.value=_vm._f("currency")(item,2)}}}),_vm._v(" $"+_vm._s(_vm._f("currency")(item,2))+"\n            ")])}),0):_vm._e(),_vm._v(" "),_c('div',{staticClass:"w-100 flex items-center justify-center flex-wrap mv1"},[(_vm.$v.value.$error && !_vm.$v.value.decimal)?_c('span',{staticClass:"errorText ma1 f7"},[_vm._v(_vm._s(_vm.$t("error.valueInvalid")))]):_vm._e(),_vm._v(" "),(_vm.$v.value.$error && !_vm.$v.value.greaterThanZero)?_c('span',{staticClass:"errorText ma1 f7"},[_vm._v(_vm._s(_vm.$t("error.valueInvalid")))]):_vm._e(),_vm._v(" "),(_vm.$v.value.$error && !_vm.$v.value.minValue)?_c('span',{staticClass:"errorText ma1 f7"},[_vm._v(_vm._s(_vm.$t("error.valueMinPrice"))+" $"+_vm._s(_vm._f("currency")(_vm.suggestedValues[_vm.currency][0],2)))]):_vm._e(),_vm._v(" "),_c('label',{staticClass:"mh2 textColor"},[_vm._v(" "+_vm._s(_vm.$t("tracks.buyTrack.valueLabel"))+": "+_vm._s(_vm.value))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.currency),expression:"currency"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.currency=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.currencies),function(curr){return _c('option',{key:curr,domProps:{"value":curr}},[_vm._v(_vm._s(curr))])}),0)]),_vm._v(" "),_c('p',{staticClass:"tc mt0 textColor"},[_vm._v(" "+_vm._s(_vm.$t("tracks.buyTrack.downloadMessage")))]),_vm._v(" "),_c('button',{staticClass:"w-30-ns w-90 block pointer dim b f5 fw4 btn textColor",on:{"click":function($event){$event.preventDefault();return _vm.modalBuy.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t("tracks.buyTrack.button"))+"\n          ")])])])]),_vm._v(" "),_c('div',{staticClass:"ph4-ns ph1 pv1 f7 w-100 flex"},[_c('div',{staticClass:"flex flex-column"},[(_vm.actualLicense)?_c('p',{staticClass:"b textColor"},[_vm._v(_vm._s(_vm.actualLicense.titulo))]):_vm._e(),_vm._v(" "),(_vm.actualLicense)?_c('a',{attrs:{"href":_vm.actualLicense.link,"target":"_blank"}},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.licenseIcon),expression:"licenseIcon"}],attrs:{"src":_vm.licenseIcon,"alt":_vm.actualLicense.titulo}})]):_vm._e()]),_vm._v(" "),(_vm.actualLicense)?_c('p',{staticClass:"pl2 textColor"},[_vm._v(_vm._s(_vm.actualLicense.descripcion))]):_vm._e()])])])}
var staticRenderFns = []


/***/ }),
/* 857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreditsModal_vue__ = __webpack_require__(380);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a771afdc_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreditsModal_vue__ = __webpack_require__(859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(858)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a771afdc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreditsModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a771afdc_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreditsModal_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a771afdc_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreditsModal_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 858 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{staticClass:"modal",attrs:{"name":"credits-modal","transition":"pop-out","adaptive":true,"clickToClose":false,"heigth":'40vh',"width":'35%'},on:{"before-open":_vm.beforeOpen}},[_c('div',{staticClass:"flex flex-column items-center justify-center",staticStyle:{"margin":"0"}},[_c('div',{staticClass:"flex justify-end w-100"},[_c('a',{staticClass:"pa3 pointer textColor",on:{"click":_vm.closeModal}},[_c('font-awesome-icon',{attrs:{"icon":"times","size":"0.5x"}})],1)]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('h2',{staticStyle:{"text-align":"center","margin-top":"0px"}},[_vm._v(_vm._s(_vm.$t("tracks.actions.credits")))]),_vm._v(" "),_c('div',{staticClass:"div-credits"},[_c('div',{staticClass:"overflow-x-y"},[_c('ckeditor',{attrs:{"readonly":true},domProps:{"innerHTML":_vm._s(_vm.credits)}})],1)])])])])}
var staticRenderFns = []


/***/ }),
/* 860 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 861 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 862 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"v-spinner"},[_c('div',{staticClass:"v-pulse v-pulse1",style:([_vm.spinnerStyle,_vm.spinnerDelay1])}),_c('div',{staticClass:"v-pulse v-pulse2",style:([_vm.spinnerStyle,_vm.spinnerDelay2])}),_c('div',{staticClass:"v-pulse v-pulse3",style:([_vm.spinnerStyle,_vm.spinnerDelay3])})])}
var staticRenderFns = []


/***/ }),
/* 864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info h-100 bg-black-05 overflow-y-scroll textColor"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"flex justify-center items-center h5"},[_c('pulse-loader',{attrs:{"loading":_vm.loading,"color":_vm.color,"size":_vm.size}})],1),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hasInfo),expression:"!hasInfo"}],staticClass:"pa2 center tc"},[_vm._v(_vm._s(_vm.$t("artists.hasNotInfo")))]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasInfo),expression:"hasInfo"}],staticClass:"ma0 pa2 f4 lh-copy"},[_c('i',{staticClass:"db mv2 tc"},[_vm._v(_vm._s(_vm.artist.phrase))])]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasInfo),expression:"hasInfo"}],staticClass:"ma0 pa2"},[_vm._v(_vm._s(_vm.artist.text))])])}
var staticRenderFns = []


/***/ }),
/* 865 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{staticClass:"pa4-ns pa2 h-100 w-100 textColor",on:{"submit":function($event){$event.preventDefault();return _vm.sendMessage.apply(null, arguments)}}},[_c('label',{staticClass:"f6 b db mb2",attrs:{"for":"message"}},[_vm._v(_vm._s(_vm.$t("form.message"))+":")]),_vm._v(" "),(_vm.$v.message.$error && !_vm.$v.message.required)?_c('span',{staticClass:"errorText ma1 f7"},[_vm._v(_vm._s(_vm.$t("error.messageRequired")))]):_vm._e(),_vm._v(" "),(_vm.$v.message.$error && !_vm.$v.message.maxLength)?_c('span',{staticClass:"errorText ma1 f7"},[_vm._v(_vm._s(_vm.$t("error.messageMaxLength")))]):_vm._e(),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.message),expression:"message"}],staticClass:"h4 f7 db border-box w-100 ba b--black-20 pa2 br2 mb2 textAreaContact",class:{error: _vm.$v.message.$error},attrs:{"id":"message","name":"message","aria-describedby":"comment-desc","placeholder":_vm.$t('artists.contact.messagePlaceholder')},domProps:{"value":(_vm.message)},on:{"blur":_vm.$v.message.$touch,"input":function($event){if($event.target.composing){ return; }_vm.message=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"w-100 pa2 flex justify-end"},[_c('input',{staticClass:"ttu tracked tabs ba ph3 pv2 input-reset bg-primary textColor bg-transparent grow pointer f6",attrs:{"type":"submit"},domProps:{"value":_vm.$t('form.send')}})])])])}
var staticRenderFns = []


/***/ }),
/* 867 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 868 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.track),expression:"track"}],staticClass:"ml2 mv2 w-100 textColor"},[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.track.title),expression:"track.title"}],staticClass:"track-info fw6 lh-title mv0 mw-100 textColor"},[_vm._v(_vm._s(_vm.track.title)+" ")]),_vm._v(" "),_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.track.artist.name),expression:"track.artist.name"}],staticClass:"track-info fw4 mt0 mb0 mw-100 textColor",attrs:{"to":{ name: 'artist-info', params: { id: _vm.track.artist.id }}}},[_vm._v("\n    "+_vm._s(_vm.track.artist.name)+"\n  ")])],1)}
var staticRenderFns = []


/***/ }),
/* 870 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa1-l flex justify-center items-center body relative hide-child w-100 h-100"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.track !== _vm.currentTrack),expression:"track !== currentTrack"}],staticClass:"white absolute top-0 v-mid w-100 h-100 child bg-black-40 flex items-center justify-center pointer",on:{"click":function($event){return _vm.changeTrack(_vm.track)}}},[_c('font-awesome-icon',{attrs:{"icon":"play","size":"2x"}})],1),_vm._v(" "),_c('img',{staticClass:"mw-100 h-100",attrs:{"src":_vm.picture}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.track == _vm.currentTrack && _vm.isPlaying),expression:"track == currentTrack && isPlaying"}],staticClass:"track-picture-vinyl vinyl-rotation absolute top-50 left-50 z-2 w-90 w-80-ns",attrs:{"src":__webpack_require__(355),"alt":"playing track"}})])}
var staticRenderFns = []


/***/ }),
/* 872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tracks-container overflow-y-scroll pa1 h-100 textColor",class:{'bg-black-05':!_vm.hasTracks}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"flex justify-center items-center h5"},[_c('pulse-loader',{attrs:{"loading":_vm.loading,"color":_vm.color,"size":_vm.size}})],1),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading & !_vm.hasTracks),expression:"!loading & !hasTracks"}],staticClass:"pa2 center tc textColor"},[_vm._v("El artista no tiene tracks")]),_vm._v(" "),_vm._l((_vm.artistTracks),function(track){return _c('div',{key:track.id,staticClass:"bb b--black-05 pa1 flex justify-between ma0 relative",class:{'track-playing' : track == _vm.currentTrack},attrs:{"track-by":track.id}},[_c('a',{staticClass:"dim db mr3 w-100",class:{'pointer': track !== _vm.currentTrack},on:{"click":function($event){_vm.setPlaylist(_vm.artistTracks);_vm.changeTrack(track)}}},[_c('div',{staticClass:"track-container flex items-center flex-start"},[_c('div',{staticClass:"image-container ml-2"},[_c('track-image',{attrs:{"track":track}})],1),_vm._v(" "),_c('div',{staticClass:"flex justify-between w-100"},[_c('track-data',{staticClass:"fw6 info-container textColor",attrs:{"track":track}}),_vm._v(" "),_c('p',{staticClass:"mv2 f7 textColor"},[_vm._v(_vm._s(_vm._f("time")(track.seconds)))])],1)])]),_vm._v(" "),_c('track-options-button',{attrs:{"track":track}})],1)})],2)}
var staticRenderFns = []


/***/ }),
/* 873 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 874 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 875 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mw-100"},_vm._l((_vm.tracks),function(track){return _c('div',{key:track.id,staticClass:"flex items-center w-100"},[_c('div',{staticClass:"flex justify-between items-center w-100 pr2"},[_c('button',{staticClass:"pa2 textColor",attrs:{"title":"Play"},on:{"click":function($event){_vm.setPlaylist(_vm.tracks); _vm.changeTrack(track)}}},[_c('font-awesome-icon',{attrs:{"icon":"play"}})],1),_vm._v(" "),_c('track-data',{class:{'info-container': !_vm.inArtistProfile, 'artist-profile-info-container': _vm.inArtistProfile},attrs:{"track":track}}),_vm._v(" "),_c('div',{staticClass:"playlistGenre"},[_c('p',{staticClass:"mv2 f7 textColor"},[_vm._v(_vm._s(track.genre.name))])]),_vm._v(" "),_c('p',{staticClass:"mv2 f7 textColor"},[_vm._v(_vm._s(_vm._f("time")(track.seconds)))]),_vm._v(" "),_c('div',{staticClass:"track-options relative"},[_c('track-options-button',{attrs:{"track":track,"playlist":_vm.playlist}})],1)],1)])}),0)}
var staticRenderFns = []


/***/ }),
/* 877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100 flex pa3-ns ma2 bb b--black-30 textColor PlaylistFLex"},[_c('div',{staticClass:"flex w-100 ph2"},[_c('div',{staticClass:"image-container flex items-center justify-center ml-2"},[_c('img',{staticClass:"mw-100 h-100",attrs:{"src":_vm.picture}})]),_vm._v(" "),_c('div',{staticClass:"w-100 flex justify-between items-center"},[_c('h3',{staticClass:"ml2 mt2",class:{'title': !_vm.inArtistProfile, 'artist-profile-title': _vm.inArtistProfile}},[_vm._v("\n        "+_vm._s(_vm.playlist.title)+" "),(_vm.playlist.private)?_c('span',{staticClass:"bg-gray br1 white f5 pa1 ttu"},[_vm._v(_vm._s(_vm.$t('playlists.type.private')))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('button',{staticClass:"pa2 iconColor",attrs:{"title":"Play"},on:{"click":function($event){_vm.setPlaylist(_vm.playlist.tracks); _vm.playFirstTrack()}}},[_c('font-awesome-icon',{staticClass:"iconColor",attrs:{"icon":"play"}})],1),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isMyPlaylist),expression:"isMyPlaylist"}],staticClass:"pa2 iconColor",attrs:{"title":_vm.$t('playlists.delete.title')},on:{"click":function($event){return _vm.deletePlaylist()}}},[_c('font-awesome-icon',{staticClass:"iconColor",attrs:{"icon":"trash"}})],1),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isMyPlaylist),expression:"isMyPlaylist"}],staticClass:"pa2 iconColor",attrs:{"title":_vm.$t('playlists.edit.button')},on:{"click":function($event){return _vm.editPlaylist()}}},[_c('font-awesome-icon',{staticClass:"iconColor",attrs:{"icon":"edit"}})],1),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.playlist.private),expression:"!playlist.private"}],staticClass:"pa2 iconColor",attrs:{"title":_vm.$t('playlists.share.button')},on:{"click":function($event){return _vm.sharePlaylist()}}},[_c('font-awesome-icon',{staticClass:"iconColor",attrs:{"icon":"share-alt"}})],1),_vm._v(" "),(_vm.section !== 'my-playlists')?_c('button',{staticClass:"pa2 iconColor",attrs:{"title":_vm.$t('playlists.like.button')},on:{"click":function($event){return _vm.likePlaylist()}}},[_c('font-awesome-icon',{class:_vm.liking ? 'liked' : 'iconColor',attrs:{"icon":"heart"}})],1):_vm._e()])]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.playlist.tracks && _vm.playlist.tracks.length === 0),expression:"playlist.tracks && playlist.tracks.length === 0"}]},[_vm._v(_vm._s(_vm.$tc('tracks.track', 0)))])]),_vm._v(" "),_c('div',{staticClass:"flex flex-column"},[_c('simple-tracks-list',{attrs:{"inArtistProfile":_vm.inArtistProfile,"tracks":_vm.playlist.tracks,"playlist":_vm.isMyPlaylist ? _vm.playlist : null}})],1)])}
var staticRenderFns = []


/***/ }),
/* 878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.playlists),function(playlist){return _c('playlist-card',{key:playlist.id,attrs:{"playlist":playlist,"inArtistProfile":_vm.inArtistProfile,"section":_vm.section}})}),1)}
var staticRenderFns = []


/***/ }),
/* 879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info h-100 bg-black-05 overflow-y-scroll textColor"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"flex justify-center items-center h5"},[_c('pulse-loader',{attrs:{"loading":_vm.loading,"color":_vm.color,"size":_vm.size}})],1),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading && !_vm.hasPlaylists),expression:"!loading && !hasPlaylists"}],staticClass:"pa2 center tc textColor"},[_vm._v(_vm._s(_vm.$t("artists.hasNotPlaylists")))]),_vm._v(" "),_c('playlist-list',{attrs:{"playlists":_vm.artistPlaylists,"inArtistProfile":true}})],1)}
var staticRenderFns = []


/***/ }),
/* 880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide-fade"}},[_c('div',{staticClass:"overlay w-100 absolute"},[_c('div',{staticClass:"w-60-l w-50-m db-ns dn absolute z-2 bottom-0 top-0 overlay-width",on:{"click":_vm.close}}),_vm._v(" "),_c('div',{staticClass:"profile z-3 fixed flex flex-column w-40-l w-50-m w-100 profile-width bg-tertiary"},[_c('div',{staticClass:"image-container relative db w-100 cover center",style:({ 'background-image': 'url(' + _vm.picture + ')' })},[_c('a',{staticClass:"ma2 pointer z-4 fixed right-0 textColor",on:{"click":_vm.close}},[_c('font-awesome-icon',{attrs:{"icon":"times","size":"2x"}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loadingArtist),expression:"!loadingArtist"}],staticClass:"artist-name-container absolute flex justify-start items-center bg-primary mw-50"},[_c('span',{staticClass:"artist-name z-4 f3-ns f4 white pa2 textColor"},[_vm._v(_vm._s(_vm.artist.name))])]),_vm._v(" "),(!_vm.loadingArtist && !_vm.isFollowed)?_c('button',{staticClass:"pointer follow-container absolute pv1 flex justify-start items-center followButton",on:{"click":_vm.setFollow}},[_c('span',{staticClass:"z-4 f5 white pa1 flex justify-start items-end"},[_vm._v("\n            "+_vm._s(_vm.$t("users.follow"))+"\n          ")])]):_vm._e(),_vm._v(" "),(!_vm.loadingArtist && _vm.isFollowed)?_c('button',{staticClass:"pointer follow-container absolute pv1 flex justify-start items-center bg-primary followinButton",on:{"click":_vm.setFollow}},[_c('span',{staticClass:"z-4 f5 white pa1 flex justify-start items-end textColor"},[_vm._v("\n            "+_vm._s(_vm.$t("users.following"))+"\n          ")])]):_vm._e(),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loadingArtist && _vm.hasTracks),expression:"!loadingArtist && hasTracks"}],staticClass:"pointer vote-container absolute pv1 flex justify-start items-center bg-primary",class:{disabled: _vm.voteDisabled},attrs:{"disabled":_vm.voteDisabled},on:{"click":function($event){$event.preventDefault();return _vm.checkVote.apply(null, arguments)}}},[_c('span',{staticClass:"z-4 f4 white pa1 flex justify-start items-end textColor"},[_c('font-awesome-icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loadingVote),expression:"!loadingVote"}],staticClass:"accent ph1",attrs:{"icon":"bolt","size":"1x"}}),_vm._v(" "),_c('clip-loader',{staticClass:"flex ph1",attrs:{"loading":_vm.loadingVote,"color":_vm.color,"size":_vm.size}}),_vm._v("\n            "+_vm._s(_vm.$t("vinylContest.vote"))+"\n            "),(_vm.myVotes !== null)?_c('span',{staticClass:"br-100 bg-accent f6 votes ml2 mb1"},[_vm._v(_vm._s(_vm.myVotes))]):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"data-container"},[_c('div',{staticClass:"profile-tabs bg-tertiary h-6"},[_c('div',{staticClass:"h-100 bg-tertiary flex justify-center pl1 pr1"},[_c('a',{staticClass:"ttu tracked dib link pa2 textColor pointer tab flex justify-center items-center",class:{'disabled-tab': _vm.loadingArtist},on:{"click":function($event){return _vm.changeTab('info')}}},[_vm._v(_vm._s(_vm.$t('artists.section.info')))]),_vm._v(" "),_c('a',{staticClass:"ttu tracked dib link pa2 textColor pointer tab flex justify-center items-center",class:{'disabled-tab': _vm.loadingArtist},on:{"click":function($event){return _vm.changeTab('tracks')}}},[_vm._v(_vm._s(_vm.$tc('tracks.track', 2)))]),_vm._v(" "),_c('a',{staticClass:"ttu tracked dib link pa2 textColor pointer tab flex justify-center items-center",class:{'disabled-tab': _vm.loadingArtist},on:{"click":function($event){return _vm.changeTab('playlists')}}},[_vm._v(_vm._s(_vm.$tc('playlists.playlist', 2)))]),_vm._v(" "),_c('a',{staticClass:"ttu tracked dib link pa2 textColor pointer tab flex justify-center items-center",class:{'disabled-tab': _vm.loadingArtist},on:{"click":function($event){return _vm.changeTab('contact')}}},[_vm._v(_vm._s(_vm.$t('artists.section.contact')))])])]),_vm._v(" "),_c('div',{staticClass:"profile-tab-content"},[_c(_vm.tab,{tag:"component"})],1)])])])])}
var staticRenderFns = []


/***/ }),
/* 881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddToPlaylist_vue__ = __webpack_require__(400);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d731e220_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddToPlaylist_vue__ = __webpack_require__(886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(882)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d731e220"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddToPlaylist_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d731e220_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddToPlaylist_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d731e220_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddToPlaylist_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 882 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlaylistSelect_vue__ = __webpack_require__(401);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75fc891a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlaylistSelect_vue__ = __webpack_require__(885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(884)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-75fc891a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlaylistSelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75fc891a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlaylistSelect_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75fc891a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlaylistSelect_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 884 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100 flex b--black-20 br1 ba dim pointer w-100 mw5 textColor"},[_c('div',{staticClass:"image-container flex items-center justify-center ml-2"},[(_vm.playlist.picture)?_c('img',{staticClass:"mw-100 h-100",attrs:{"src":_vm.picture}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"w-100 ph2 flex flex-column justify-center items-start"},[_c('p',{staticClass:"mv0 fw7 title textColor"},[_vm._v(_vm._s(_vm.playlist.title))]),_vm._v(" "),_c('p',{staticClass:"mv0 f7 textColor"},[_vm._v(" "+_vm._s(_vm.playlist.trackCount)+"\n      "),_c('span',{staticClass:"textColor"},[_vm._v(_vm._s(_vm.$tc('tracks.track', _vm.playlist.trackCount )))])])])])}
var staticRenderFns = []


/***/ }),
/* 886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{staticClass:"modal overflow-y-scroll",attrs:{"name":"add-to-playlist-modal","transition":"pop-out","width":_vm.modalWidth,"height":_vm.modalHeight,"scrollable":false,"adaptive":true},on:{"before-open":_vm.beforeOpen}},[_c('div',{staticClass:"flex justify-end w-100"},[_c('a',{staticClass:"pa3 pointer iconColor",on:{"click":_vm.closeModal}},[_c('font-awesome-icon',{attrs:{"icon":"times"}})],1)]),_vm._v(" "),_c('div',{staticClass:"flex flex-column items-center"},[_c('h1',{staticClass:"tc mt0 f4 f3-ns textColor"},[_vm._v(_vm._s(_vm.$t("playlists.addToPlaylist.title")))]),_vm._v(" "),(_vm.track)?_c('h2',{staticClass:"tc mv0 f6 f5-ns ph5-ns ph3 mw-100 title textColor"},[_vm._v(_vm._s(_vm.track.title))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mv2"},[_c('clip-loader',{attrs:{"loading":_vm.loading,"color":_vm.color,"size":_vm.size}})],1),_vm._v(" "),_c('div',{staticClass:"w-100 flex flex-column items-center mv2"},[(!_vm.loading && !_vm.selectedPlaylistId)?_c('span',{staticClass:"dark-red f7 mh2-ns mv2"},[_vm._v(_vm._s(_vm.$t("error.playlistRequired")))]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"w-90 flex b--black-20 br1 ba dim pointer mw5 mv1",on:{"click":_vm.newPlaylist}},[_c('p',{staticClass:"tc textColor"},[_c('font-awesome-icon',{staticClass:"iconColor mh2",attrs:{"icon":"plus"}}),_vm._v(_vm._s(_vm.$t("playlists.addToPlaylist.title")))],1)]),_vm._v(" "),_c('div',{staticClass:"scrollable-container"},[_c('ul',_vm._l((_vm.myPlaylists),function(playlist){return _c('li',{key:playlist.id,staticClass:"mv1 w-90 mw5 textColor overflow",class:{'bg-black-20': _vm.selectedPlaylistId && playlist.id === _vm.selectedPlaylistId},attrs:{"track-by":playlist},on:{"click":function($event){return _vm.selectPlaylist(playlist.id)}}},[_c('playlist-select',{attrs:{"playlist":playlist}})],1)}),0)]),_vm._v(" "),_c('button',{staticClass:"w-50-ns w-90 block mv2 pointer btn textColor",on:{"click":function($event){$event.preventDefault();return _vm.addTrackToPlaylist.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t("playlists.addToPlaylist.add")))])])])])}
var staticRenderFns = []


/***/ }),
/* 887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewPlaylist_vue__ = __webpack_require__(402);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39f6b99d_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewPlaylist_vue__ = __webpack_require__(897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(888)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-39f6b99d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewPlaylist_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39f6b99d_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewPlaylist_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39f6b99d_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewPlaylist_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 888 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 889 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export authGuard */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__authWrapper__ = __webpack_require__(404);


var authGuard = function authGuard(to, from, next) {
  var authService = Object(__WEBPACK_IMPORTED_MODULE_0__authWrapper__["b" /* getInstance */])();

  var fn = function fn() {
    if (authService.isAuthenticated) {
      return next();
    }

    authService.loginWithRedirect({ appState: { targetUrl: to.fullPath } });
  };

  if (!authService.loading) {
    return fn();
  }

  authService.$watch('loading', function (loading) {
    if (loading === false) {
      return fn();
    }
  });
};

/***/ }),
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.imageFiles.length || _vm.localPicturePath),expression:"imageFiles.length || localPicturePath"}],staticClass:"w4 flex items-center justify-center"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.localPicturePath || (_vm.imageFiles.length && _vm.imageFiles[0].success)),expression:"localPicturePath || (imageFiles.length && imageFiles[0].success)"}],staticClass:"flex flex-column items-center"},[_c('div',{staticClass:"image-container relative db cover center h4 w4 pa3",style:({ 'background-image': 'url(' + _vm.picture + ')' })}),_vm._v(" "),_c('button',{staticClass:"btn w4 f6",on:{"click":_vm.deleteImage}},[_vm._v(_vm._s(_vm.$t("app.delete")))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.imageFiles.length && _vm.imageFiles[0].progress < 100),expression:"imageFiles.length && imageFiles[0].progress < 100"}],staticClass:"ba br2 b--light-silver flex justify-center items-center h4 w4"},[_c('clip-loader',{attrs:{"loading":(_vm.imageFiles[0] && _vm.imageFiles[0].progress < 100),"color":_vm.color,"size":_vm.size}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.imageFiles.length && !_vm.localPicturePath),expression:"!imageFiles.length && !localPicturePath"}],staticClass:"flex flex-column h-100 justify-end"},[_c('label',{staticClass:"flex justify-center item-center pa3 pointer w4",attrs:{"for":"file"}},[_c('font-awesome-icon',{staticClass:"iconColor pa2 white",attrs:{"icon":"upload","size":"5x"}})],1),_vm._v(" "),_c('div',{staticClass:"flex flex-column justify-center"},[_c('file-upload',{ref:"imageUpload",staticClass:"btn ph2 pointer",attrs:{"post-action":_vm.url,"headers":_vm.postFileHeaders,"extensions":"jpg,jpeg,png,webp"},on:{"input-file":_vm.imageInputFile,"input-filter":_vm.imageInputFilter},model:{value:(_vm.imageFiles),callback:function ($$v) {_vm.imageFiles=$$v},expression:"imageFiles"}},[_vm._v("\n        "+_vm._s(_vm.$t("uploadPicture.selectPicture"))+"\n      ")]),_vm._v(" "),(_vm.trackEdit === true)?_c('span',{staticClass:"sizeImg"},[_vm._v("Size 200x200")]):_vm._e(),_vm._v(" "),(_vm.newPlaylist === true)?_c('span',{staticClass:"sizeImg"},[_vm._v("Size 200x200")]):_vm._e()],1)])])}
var staticRenderFns = []


/***/ }),
/* 897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{staticClass:"modal",attrs:{"name":"new-playlist-modal","transition":"pop-out","width":_vm.modalWidth,"height":"auto","adaptive":true},on:{"before-open":_vm.beforeOpen}},[_c('div',{staticClass:"flex justify-end w-100"},[_c('a',{staticClass:"pa3 pointer primary textColor",on:{"click":_vm.closeModal}},[_c('font-awesome-icon',{attrs:{"icon":"times"}})],1)]),_vm._v(" "),_c('div',{staticClass:"flex flex-column items-center mb3"},[_c('h1',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isEdit),expression:"!isEdit"}],staticClass:"tc mt0 f4 f3-ns textColor"},[_vm._v(_vm._s(_vm.$t("playlists.newPlaylist.title")))]),_vm._v(" "),_c('h1',{directives:[{name:"show",rawName:"v-show",value:(_vm.isEdit),expression:"isEdit"}],staticClass:"tc mt0 f4 f3-ns textColor"},[_vm._v(_vm._s(_vm.$t("playlists.edit.title")))]),_vm._v(" "),_c('div',{staticClass:"mv2"},[_c('clip-loader',{attrs:{"loading":_vm.loading,"color":_vm.color,"size":_vm.size}})],1),_vm._v(" "),_c('div',{staticClass:"flex flex-wrap justify-around w-100 ph3"},[_c('upload-image',{attrs:{"path":"/playlists/upload/picture","picturePath":_vm.picturePath,"newPlaylist":true},on:{"uploadFinished":_vm.handleUploadFinished,"uploadStart":function($event){_vm.disabled = true}}}),_vm._v(" "),_c('div',{staticClass:"w-100 w-50-ns ph3 flex flex-column justify-end"},[_c('div',{staticClass:"mt3 mt0-ns"},[(_vm.$v.title.$error && !_vm.$v.title.required)?_c('span',{staticClass:"dark-red f7"},[_vm._v(_vm._s(_vm.$t("error.playlistNameRequired")))]):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.title),expression:"title"}],staticClass:"w-100 ph1 pv2 input",class:{error: _vm.$v.title.$error},attrs:{"name":"title","placeholder":_vm.$t('playlists.newPlaylist.playlistName')},domProps:{"value":(_vm.title)},on:{"blur":_vm.$v.title.$touch,"input":function($event){if($event.target.composing){ return; }_vm.title=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"flex-ns justify-center items-center mv3"},[_c('label',{staticClass:"ma2 textColor"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.type),expression:"type"}],attrs:{"name":"type","type":"radio","value":"0"},domProps:{"checked":_vm._q(_vm.type,"0")},on:{"change":function($event){_vm.type="0"}}}),_vm._v(_vm._s(_vm.$t('playlists.type.public')))]),_vm._v(" "),_c('label',{staticClass:"ma2 textColor"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.type),expression:"type"}],attrs:{"name":"type","type":"radio","value":"1","checked":""},domProps:{"checked":_vm._q(_vm.type,"1")},on:{"change":function($event){_vm.type="1"}}}),_vm._v(_vm._s(_vm.$t('playlists.type.private')))])])]),_vm._v(" "),_c('div',{staticClass:"flex justify-center"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.track),expression:"track"}],staticClass:"btn",class:{'pointer': !_vm.disabled},attrs:{"disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();return _vm.savePlaylist()}}},[_vm._v(_vm._s(_vm.$t("playlists.newPlaylist.saveAndAdd")))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.track),expression:"!track"}],staticClass:"btn",class:{'pointer': !_vm.disabled},attrs:{"disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();return _vm.savePlaylist()}}},[_vm._v(_vm._s(_vm.$t("app.save")))])])])],1)])])}
var staticRenderFns = []


/***/ }),
/* 898 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{staticClass:"modal p-3",attrs:{"name":"direct-link-modal","transition":"pop-out","width":_vm.modalWidth,"height":"auto","adaptive":true}},[_c('div',{staticClass:"flex flex-column items-center mb3 modal-padding"},[_c('h2',[_vm._v("Crear Acceso directo")]),_vm._v(" "),_c('p',[_vm._v("\n      Para agregar un acceso directo de este sitio web a tu pantalla de inicio debes acceder al menú\n      pulsando el ícono de los tres puntos situado en la parte superior derecha del navegador. Luego\n      selecciona la opción \"añadir a pantalla de inicio\" ó en inglés (\"Add to Home Screen\")\n    ")])])])}
var staticRenderFns = []


/***/ }),
/* 900 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobileShow"},[(!_vm.hidden && _vm.isLoggedIn && ( _vm.msisdn!='' && _vm.msisdn!= null ) && _vm.provider == 'entel')?_c('div',{staticClass:"fl flex w-100 items-center bg-primary text-light justify-between"},[_c('div',{staticClass:"fl flex justify-center w-100",on:{"click":_vm.showHelpModal}},[_c('div',{staticClass:"link-primary ttu f5 flex items-center h-100 no-underline dib pa3 white"},[_c('span',{},[_vm._v(_vm._s(_vm.$tc('provider.directLink', 2)))])])]),_vm._v(" "),_c('div',{staticClass:"fl flex justify-end mr-2",on:{"click":function($event){_vm.hidden=true}}},[_c('font-awesome-icon',{staticClass:"iconColor text-white",attrs:{"icon":"times"}})],1)]):_vm._e()])}
var staticRenderFns = []


/***/ }),
/* 902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewFeaturesModal_vue__ = __webpack_require__(407);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20935216_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewFeaturesModal_vue__ = __webpack_require__(904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(903)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewFeaturesModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20935216_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewFeaturesModal_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20935216_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewFeaturesModal_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 903 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{staticClass:"modal",attrs:{"name":"new-features-modal","transition":"pop-out","width":_vm.modalWidth,"height":"auto","adaptive":true,"clickToClose":false}},[_c('div',{staticClass:"flex-row justify-center fl w-100 h-100 pb2"},[_c('div',{staticClass:"w-100 h-100 flex justify-center mt4"},[_c('img',{staticClass:"w-25",attrs:{"src":__webpack_require__(71),"alt":"BeatHey Logo"}})]),_vm._v(" "),_c('div',{staticClass:"h-100 w-100 nfmDiv"},[(!_vm.msisdn)?_c('h1',{domProps:{"innerHTML":_vm._s(_vm.news[0].title)}}):_vm._e(),_vm._v(" "),(_vm.msisdn)?_c('h1',{domProps:{"innerHTML":_vm._s(_vm.news[1].title)}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"NFMspan"},[(!_vm.msisdn)?_c('span',{staticStyle:{"font-size":"25px"},domProps:{"innerHTML":_vm._s(_vm.news[0].content)}}):_vm._e(),_vm._v(" "),(_vm.msisdn)?_c('span',{staticStyle:{"font-size":"25px"},domProps:{"innerHTML":_vm._s(_vm.news[1].content)}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"flex justify-center mb3 mt3"},[_c('button',{staticClass:"NFMcallToAction",on:{"click":_vm.Enviar}},[_vm._v(_vm._s(_vm.$t("app.notShowAgain")))])])])])}
var staticRenderFns = []


/***/ }),
/* 905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LocalRadioModal_vue__ = __webpack_require__(408);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4efa7f6e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LocalRadioModal_vue__ = __webpack_require__(907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(906)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4efa7f6e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LocalRadioModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4efa7f6e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LocalRadioModal_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4efa7f6e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LocalRadioModal_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 906 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{staticClass:"modal",attrs:{"name":"local-radio-modal","transition":"pop-out","width":_vm.modalWidth,"height":"auto","scrollable":true,"adaptive":true,"clickToClose":false},on:{"before-open":_vm.beforeOpen}},[_c('div',{staticClass:"flex flex-column items-center justify-center"},[_c('div',{staticClass:"flex justify-end w-100"},[_c('a',{staticClass:"pa3 pointer textColor",on:{"click":_vm.closeModal}},[_c('font-awesome-icon',{attrs:{"icon":"times","size":"2x"}})],1)]),_vm._v(" "),_c('div',{staticClass:"radio-content"},[_c('h2',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.radio.name))]),_vm._v(" "),_c('img',{staticClass:"radio-picture db",attrs:{"src":_vm.radio.picture,"alt":_vm.radio.name}}),_vm._v(" "),_c('div',{staticClass:"text-center radio-info"},[(_vm.radio.category)?_c('span',[_vm._v(_vm._s(_vm.$t('localContent.category'))+": "+_vm._s(_vm.radio.category)+" / ")]):_vm._e(),_vm._v(" "),(_vm.radio.dial)?_c('span',[_vm._v("Dial: "+_vm._s(_vm.radio.dial))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"flex items-center bg-primary iframeDiv"},[_c('video',{attrs:{"controls":"","autoplay":"","name":"media"}},[_c('source',{attrs:{"src":_vm.radio.link,"type":"audio/mpeg"}})])])])])}
var staticRenderFns = []


/***/ }),
/* 908 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 909 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"playlist-tracks-container pa1 h-100 textColor",class:{'bg-black-05':!_vm.hasTracks}},[_c('p',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hasTracks),expression:"!hasTracks"}],staticClass:"pa2 center tc textColor"},[_vm._v("La playlist no tiene tracks")]),_vm._v(" "),_vm._l((_vm.playlist.tracks),function(track){return _c('div',{key:track.id,staticClass:"bb b--black-05 pa1 flex justify-between ma0 relative",class:{'track-playing' : track == _vm.currentTrack},attrs:{"track-by":track.id}},[_c('a',{staticClass:"dim db mr3 w-100",class:{'pointer': track !== _vm.currentTrack},on:{"click":function($event){_vm.setPlaylist(_vm.playlist.tracks);_vm.changeTrack(track)}}},[_c('div',{staticClass:"track-container flex items-center flex-start"},[_c('div',{staticClass:"image-container ml-2"},[_c('track-image',{attrs:{"track":track}})],1),_vm._v(" "),_c('div',{staticClass:"flex justify-between w-100"},[_c('track-data',{staticClass:"fw6 info-container textColor",attrs:{"track":track}}),_vm._v(" "),_c('p',{staticClass:"mv2 f7 textColor"},[_vm._v(_vm._s(_vm._f("time")(track.seconds)))])],1)])]),_vm._v(" "),_c('track-options-button',{attrs:{"playlist":_vm.playlist,"track":track}})],1)})],2)}
var staticRenderFns = []


/***/ }),
/* 911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide-fade"}},[_c('div',{staticClass:"overlay w-100 absolute"},[_c('div',{staticClass:"w-60-l w-50-m db-ns dn absolute z-2 bottom-0 top-0 overlay-width",on:{"click":_vm.close}}),_vm._v(" "),_c('div',{staticClass:"profile z-3 fixed flex flex-column w-40-l w-50-m w-100 profile-width bg-tertiary"},[_c('div',{staticClass:"image-container relative db w-100 cover center",style:({ 'background-image': 'url(' + _vm.picture + ')' })},[_c('a',{staticClass:"ma2 pointer z-4 fixed right-0 textColor",on:{"click":_vm.close}},[_c('font-awesome-icon',{attrs:{"icon":"times","size":"2x"}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loadingArtist),expression:"!loadingArtist"}],staticClass:"playlist-picture-container absolute flex justify-start items-center bg-primary"},[_c('img',{attrs:{"src":_vm.playlistPicture,"alt":((_vm.playlist.title) + " Picture")}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loadingArtist),expression:"!loadingArtist"}],staticClass:"playlist-name-container absolute flex justify-start items-center bg-primary mw-50"},[_c('span',{staticClass:"playlit-name z-4 f3-ns f4 white pa2 textColor"},[_vm._v(_vm._s(_vm.playlist.title))])]),_vm._v(" "),_c('div',{staticClass:"follow-container absolute flex"},[_c('button',{staticClass:"like-button pa2 pointer pv1 flex justify-start items-center",attrs:{"title":"Play"},on:{"click":function($event){return _vm.setPlayer(_vm.playlist.tracks[0], _vm.playlist.tracks)}}},[_c('font-awesome-icon',{staticClass:"iconColor playlistOptions",attrs:{"icon":"play"}})],1),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.$router.history.current.name === 'my-playlists'),expression:"$router.history.current.name === 'my-playlists'"}],staticClass:"like-button pa2 pointer pv1 flex justify-start items-center",attrs:{"title":_vm.$t('playlists.delete.title')},on:{"click":function($event){return _vm.deletePlaylist()}}},[_c('font-awesome-icon',{staticClass:"iconColor playlistOptions",attrs:{"icon":"trash"}})],1),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.$router.history.current.name === 'my-playlists'),expression:"$router.history.current.name === 'my-playlists'"}],staticClass:"like-button pa2 pointer pv1 flex justify-start items-center",attrs:{"title":_vm.$t('playlists.edit.button')},on:{"click":function($event){return _vm.editPlaylist()}}},[_c('font-awesome-icon',{staticClass:"iconColor playlistOptions",attrs:{"icon":"edit"}})],1),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.playlist.private),expression:"!playlist.private"}],staticClass:"like-button pa2 pointer pv1 flex justify-start items-center",attrs:{"title":_vm.$t('playlists.share.button')},on:{"click":function($event){return _vm.sharePlaylist()}}},[_c('font-awesome-icon',{staticClass:"iconColor playlistOptions",attrs:{"icon":"share-alt"}})],1),_vm._v(" "),(_vm.$router.history.current.name !== 'my-playlists')?_c('button',{staticClass:"like-button pa2 pointer pv1 flex justify-start items-center",attrs:{"title":_vm.$t('playlists.like.button')},on:{"click":function($event){return _vm.likePlaylist()}}},[_c('font-awesome-icon',{staticClass:"playlistOptions",class:_vm.liking ? 'liked' : 'iconColor',attrs:{"icon":"heart"}})],1):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"data-container"},[_c('div',{staticClass:"profile-tabs bg-tertiary h-6"},[_c('div',{staticClass:"h-100 bg-tertiary flex justify-center pl1 pr1"},[_c('p',{staticClass:"ttu tracked dib pa2 textColor pointer tab flex justify-center items-center"},[_vm._v(_vm._s(_vm.$tc('tracks.track', 2)))])])]),_vm._v(" "),_c('div',[_c('PlayliststTracks')],1)])])])])}
var staticRenderFns = []


/***/ }),
/* 912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SetEmailModal_vue__ = __webpack_require__(413);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6395eb18_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SetEmailModal_vue__ = __webpack_require__(914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(913)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6395eb18"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SetEmailModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6395eb18_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SetEmailModal_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6395eb18_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SetEmailModal_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 913 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{staticClass:"modal",attrs:{"name":"set-email-modal","transition":"pop-out","width":_vm.modalWidth,"height":260,"adaptive":true,"clickToClose":false},on:{"before-open":_vm.beforeOpen}},[_c('div',{staticClass:"flex flex-column items-center justify-center w-100 h-100"},[_c('div',{staticClass:"flex justify-end w-100 mt-2"},[_c('a',{staticClass:"pa3 pointer textColor",on:{"click":_vm.closeModal}},[_c('font-awesome-icon',{attrs:{"icon":"times","size":"2x"}})],1)]),_vm._v(" "),_c('div',{staticClass:"h2 heigthMobile"},[_c('clip-loader',{attrs:{"loading":_vm.isLoadingLink,"color":_vm.color,"size":_vm.size}})],1),_vm._v(" "),_c('div',{staticClass:"custom-padding"},[_c('div',{staticClass:"text-center mb-3"},[_c('p',{staticClass:"w-100 tc textColor"},[_vm._v(_vm._s(_vm.$t("users.subscription.infoEmailNeeded1")))]),_vm._v(" "),_c('div',{staticClass:"custom-padding-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.emailNeeded),expression:"emailNeeded"}],staticClass:"form-control dark-text-color",attrs:{"type":"email","id":"email","maxlength":"200"},domProps:{"value":(_vm.emailNeeded)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.emailNeeded=$event.target.value},_vm.validateEmail]}})]),_vm._v(" "),(_vm.emailError)?_c('p',{staticClass:"error"},[_vm._v(_vm._s(_vm.emailError))]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"w-100 tc textColor"},[_vm._v(_vm._s(_vm.$t("users.subscription.infoEmailNeeded2")))])])]),_vm._v(" "),_c('div',{staticClass:"mb-4 flex items-center flex-wrap justify-center"},[_c('button',{staticClass:"w-90 block mv2 pointer btn dim b f5 fw4",class:{ 'disabled': _vm.disabled },attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.getSubsLink('mercadopago')}}},[_vm._v("\n        "+_vm._s(_vm.$t("users.subscription.sendEmailNeeded"))+"\n      ")])])])])}
var staticRenderFns = []


/***/ }),
/* 915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SetUserTypeModal_vue__ = __webpack_require__(414);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57a0e8fc_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SetUserTypeModal_vue__ = __webpack_require__(917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(916)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-57a0e8fc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SetUserTypeModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57a0e8fc_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SetUserTypeModal_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57a0e8fc_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SetUserTypeModal_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 916 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{staticClass:"modal",attrs:{"name":"set-user-type-modal","transition":"pop-out","width":_vm.modalWidth,"height":320,"adaptive":true,"clickToClose":false}},[_c('div',{staticClass:"flex flex-column items-center justify-center w-100 h-100"},[_c('div',{staticClass:"h2 heigthMobile"},[_c('clip-loader',{attrs:{"loading":_vm.isLoadingLink,"color":_vm.color,"size":_vm.size}})],1),_vm._v(" "),_c('span',{staticClass:"mb-4 flex items-center flex-wrap justify-center dn f3"},[_vm._v(_vm._s(_vm.$t("users.choseUserType")))]),_vm._v(" "),_c('div',{staticClass:"w-100 flex flex-column items-center background-color custom-margin-top"},[_c('div',{staticClass:"w-50-ns w-50"},[_c('div',{staticClass:"flex justify-center items-center"},[_c('div',{staticClass:"text-center"},[_c('img',{staticClass:"dim",attrs:{"src":"https://beathey.com/uploads/banners/04-04.jpg","alt":"Fan"},on:{"click":function($event){return _vm.setUserType(0)}}}),_vm._v(" "),_c('span',{staticClass:"mt2 flex items-center flex-wrap justify-center dn ttu f5"},[_vm._v(_vm._s(_vm.$t("users.userType.musicFan")))])]),_vm._v(" "),_c('div',{staticClass:"w-30"}),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('img',{staticClass:"dim",attrs:{"src":"https://beathey.com/uploads/banners/00-02.jpg","alt":"Artista"},on:{"click":function($event){return _vm.setUserType(1)}}}),_vm._v(" "),_c('span',{staticClass:"mt2 flex items-center flex-wrap justify-center dn ttu f5"},[_vm._v(_vm._s(_vm.$t("users.userType.producer")))])])])])]),_vm._v(" "),_c('div',{staticClass:"mt3 mb3"},[_c('span',{staticClass:"mb-4 flex items-center flex-wrap justify-center f5"},[_vm._v(_vm._s(_vm.$t("users.textUserType")))])])])])}
var staticRenderFns = []


/***/ }),
/* 918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SetNameArtistModal_vue__ = __webpack_require__(415);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab6c2834_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SetNameArtistModal_vue__ = __webpack_require__(920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(919)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ab6c2834"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SetNameArtistModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab6c2834_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SetNameArtistModal_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab6c2834_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SetNameArtistModal_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 919 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{staticClass:"modal",attrs:{"name":"set-name-artist-modal","transition":"pop-out","width":_vm.modalWidth,"height":260,"adaptive":true,"clickToClose":false},on:{"before-open":_vm.beforeOpen}},[_c('div',{staticClass:"flex flex-column items-center justify-center w-100 h-100"},[_c('div',{staticClass:"h2 heigthMobile"},[_c('clip-loader',{attrs:{"loading":_vm.isLoadingLink,"color":_vm.color,"size":_vm.size}})],1),_vm._v(" "),_c('div',{staticClass:"custom-padding"},[_c('div',{staticClass:"text-center mb-3"},[_c('p',{staticClass:"flex items-center flex-wrap justify-center dn f3"},[_vm._v(_vm._s(_vm.$t("users.userType.flowArtist.artisticName")))]),_vm._v(" "),_c('div',{staticClass:"custom-padding-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.nameNeeded),expression:"nameNeeded"}],staticClass:"form-control dark-text-color",attrs:{"type":"text","id":"name","maxlength":"50"},domProps:{"value":(_vm.nameNeeded)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.nameNeeded=$event.target.value},_vm.validateName]}})]),_vm._v(" "),(_vm.nameError)?_c('p',{staticClass:"error"},[_vm._v(_vm._s(_vm.nameError))]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"w-100 tc textColor"},[_vm._v(_vm._s(_vm.$t("users.userType.flowArtist.text")))])])]),_vm._v(" "),_c('div',{staticClass:"mb-4 flex items-center flex-wrap justify-center"},[_c('button',{staticClass:"w-90 block mv2 pointer btn dim b f5 fw4",class:{ 'disabled': _vm.disabled },attrs:{"disabled":_vm.disabled},on:{"click":_vm.sendNameArtist}},[_vm._v("\n        "+_vm._s(_vm.$t("app.save"))+"\n      ")])])])])}
var staticRenderFns = []


/***/ }),
/* 921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginUnauthorizedUser_vue__ = __webpack_require__(416);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd03d886_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginUnauthorizedUser_vue__ = __webpack_require__(923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(922)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bd03d886"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginUnauthorizedUser_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd03d886_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginUnauthorizedUser_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd03d886_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginUnauthorizedUser_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 922 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{staticClass:"modal",attrs:{"name":"login-unauthorized-user","transition":"pop-out","width":_vm.modalWidth,"height":160,"adaptive":true,"clickToClose":false},on:{"before-open":_vm.beforeOpen}},[_c('div',{staticClass:"flex flex-column items-center justify-center w-100 h-100"},[_c('span',{staticClass:"mb-4 flex items-center flex-wrap justify-center mt4 dn f6 mx1 alignText"},[_vm._v(_vm._s(_vm.$t("users.loginToUnauthorizedUser")))]),_vm._v(" "),_c('div',{staticClass:"flex items-center flex-wrap justify-center"},[_c('div',{staticClass:"mt4 mx3"},[_c('button',{staticClass:"w-100 block mv2 pointer btn dim b f6 fw3",class:{ 'disabled': _vm.disabled },attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.goToLogin(true)}}},[_vm._v("\n          "+_vm._s(_vm.$t("users.registration.register"))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"mt4 mx3"},[_c('button',{staticClass:"w-90 block mv2 pointer btn dim b f6 fw3",class:{ 'disabled': _vm.disabled },attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.goToLogin(false)}}},[_vm._v("\n          "+_vm._s(_vm.$t("users.cancelLoginToUnauthorizedUser"))+"\n        ")])])])])])}
var staticRenderFns = []


/***/ }),
/* 924 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 925 */,
/* 926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['editor-wrapper', { 'has-content': _vm.content }],style:({ width: _vm.width, height: _vm.height })},[_c('ckeditor',{attrs:{"editor":_vm.editor,"config":_vm.editorConfig},on:{"input":_vm.onEditorInput},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1)}
var staticRenderFns = []


/***/ }),
/* 927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app-wrapper"}},[_c('Navigation',{staticClass:"navigationMenu"}),_vm._v(" "),_c('main',{staticClass:"main"},[_c('provider-link'),_vm._v(" "),_c('signup-modal'),_vm._v(" "),_c('login-modal'),_vm._v(" "),_c('new-features-modal'),_vm._v(" "),_c('subscription-modal'),_vm._v(" "),_c('direct-link-modal'),_vm._v(" "),_c('payment-modal'),_vm._v(" "),_c('set-email-modal'),_vm._v(" "),_c('set-user-type-modal'),_vm._v(" "),_c('set-name-artist-modal'),_vm._v(" "),_c('login-unauthorized-user'),_vm._v(" "),_c('share-modal'),_vm._v(" "),_c('buy-track-modal'),_vm._v(" "),_c('local-radio-modal'),_vm._v(" "),_c('credits-modal'),_vm._v(" "),_c('add-to-playlist'),_vm._v(" "),_c('new-playlist'),_vm._v(" "),_c('v-dialog'),_vm._v(" "),_c('editor-ck'),_vm._v(" "),_c('artist-profile',{directives:[{name:"show",rawName:"v-show",value:(_vm.isProfileOpen),expression:"isProfileOpen"}]}),_vm._v(" "),_c('playlist-profile',{directives:[{name:"show",rawName:"v-show",value:(_vm.isPlaylistOpen),expression:"isPlaylistOpen"}]}),_vm._v(" "),_c('router-view')],1),_vm._v(" "),_c('player')],1)}
var staticRenderFns = []


/***/ }),
/* 928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsEs_vue__ = __webpack_require__(418);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cda84866_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsEs_vue__ = __webpack_require__(930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(929)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cda84866"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsEs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cda84866_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsEs_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cda84866_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsEs_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 929 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"terms flex justify-center"},[_c('div',{staticClass:"mw7"},[_c('router-link',{attrs:{"to":{name:'home'}}},[_vm._v("Volver")]),_vm._v(" "),_c('h1',[_vm._v("TERMINOS Y CONDICIONES GENERALES DE BEATHEY")]),_vm._v("\n    Antes de suscribirse al sitio lea cuidadosamente estos términos y condiciones de uso del Sitio www.beathey.com.\n    Al clickear el botón “Acepto” de la página de registro, el Usuario está declarando haber leído integralmente, sin cualquier reserva, este Reglamento de uso que tiene como partes al Usuario y a BEATHEY.\n    Esperamos que el sitio www.beathey.com., de ahora en mas BEATHEY, está dedicado a la difusión de obras fonográficas y/o audiovisuales en adelante las “Obras”, bajo la modalidad de descarga o streaming en todas sus formas y para su acceso a través de distintos tipos de dispositivos que permitirá al Usuario subir contenidos fonográficos y/o audiovisuales.\n    La suscripción a BEATHEY importa la aprobación de la totalidad de estos Términos y Condiciones, que el Usuario declara haber leído y aceptar íntegramente. Si no acepta estos Términos y Condiciones no utilice los servicios de BEATHEY.\n    BEATHEY podrá a su exclusivo criterio y de forma discrecional efectuar modificaciones en el servicio y en estos Términos y Condiciones. Las modificaciones relevantes serán notificadas al Usuario mediante correo electrónico denunciado por éste en el formulario de registro. Si el Usuario continuara utilizando el servicio BEATHEY se entenderá que han sido aceptadas las modificaciones realizadas.\n    Para poder suscribirse al servicio de BEATHEY se requiere ser mayor de 18 de años o contar con el consentimiento de padre, madre o tutor.\n\n\n    "),_c('h3',[_vm._v("Definiciones")]),_vm._v("\n    A los fines de estos Términos y Condiciones, se definen los siguientes términos:\n    a) Obras: Creaciones artísticas en formato audio y/o video.\n    b) BEATHEY: Plataforma de audio y/o video a demanda donde se ponen a disposición del público, vía web, las Obras. También llamado el Sitio.\n    c) Usuario: Toda aquella persona que se registra y/o accede y/o utiliza los servicios prestados por BEATHEY.\n    d) Descarga: Servicio que permite descargar o downloading el audio y/o video.\n    d) Streaming: Servicio que permite transferir audio y/o video desde una fuente de generación para que los Usuarios de BEATHEY puedan seleccionar el contenido y escuchar y/o visualizar un determinado contenido sin posibilidad de descarga o downloading.\n\n    "),_c('h3',[_vm._v("Información del Usuario")]),_vm._v("\n    Para registrarse y crear una cuenta en el BEATHEY el Usuario deberá brindar al Sitio la siguiente información, completando el formulario previsto en el BEATHEY al efecto:\n    a) Nombre y apellido\n    b) DNI\n    c) Fecha de nacimiento\n    d) Domicilio\n    e) Dirección de correo electrónico\n    El Usuario se responsabiliza por la veracidad de la información brindada.\n\n    "),_c('h3',[_vm._v("Modalidad de Acceso al BEATHEY")]),_vm._v("\n    El Usuario de BEATHEY podrá acceder al Sitio.\n    La forma de prestación del servicio, las distintas modalidades de acceso, y los contenidos estarán sujetos a la voluntad, disponibilidad y capacidad técnica de BEATHEY, quien podrá variarlos a su exclusivo criterio, sin expresión de causa y sin obligación de notificación previa al Usuario.\n\n    "),_c('h3',[_vm._v("Acceso al servicio")]),_vm._v("\n    El Usuario accederá al servicio a través de su Cuenta por medio de una contraseña, de su exclusiva responsabilidad.\n    El uso y acceso de la Cuenta es estrictamente personal. El Usuario no podrá revelar ni brindar a terceros el nombre y contraseña de acceso a su Cuenta.\n    Sin que ello implique limitar lo previamente establecido, BEATHEY podrá decidir y modificar a su exclusivo criterio las funcionalidades y mecanismos de registro y participación del Sitio.\n\n    "),_c('h3',[_vm._v("Acceso Gratuito")]),_vm._v("\n    El Usuario podrá acceder a todos los contenidos disponibles en BEATHEY bajo esta modalidad en forma gratuita.\n    BEATHEY podrá dar de baja el o los contenidos, el servicio y/o BEATHEY en cualquier momento sin que esto genere derecho alguno a favor del Usuario.\n    BEATHEY podrá establecer un acceso pago a BEATHEY cuando lo considere. Así como podrá rescindir el acceso en cualquier momento sin necesidad de expresión de causa.\n    La Forma de Pago será informada en cada ocasión por BEATHEY pudiendo modificar a su exclusivo criterio.\n    BEATHEY podrá modificar el valor de la tarifa a su exclusivo criterio, autorizando el Usuario a su pago mediante la Forma de Pago seleccionada.\n\n    "),_c('h3',[_vm._v("Obligaciones del Usuario")]),_vm._v("\n    El Usuario se obliga a utilizar el servicio y acceder a BEATHEY, de conformidad con estos Términos y Condiciones, y en cumplimiento de las normas vigentes.\n    El Usuario sólo podrá acceder a las Obras disponibles en BEATHEY, de conformidad y con las limitaciones en función de su modalidad de acceso, en un todo de acuerdo con estos Términos y Condiciones. El Usuario no podrá almacenar, descargar, reproducir, distribuir, difundir, comunicar o poner a disposición del público, modificar, utilizar todo o parte, o editar en cualquier modo, con cualquier fin o por cualquier medio las Obras disponibles en BEATHEY.\n    El Usuario realizará un uso personal y doméstico (privado) del Sitio y de los contenidos disponibles en BEATHEY. El Usuario no podrá utilizar en forma comercial, ni podrá difundir y/o poner a disposición del público los contenidos disponibles en BEATHEY, ni realizar un uso ilícito de éstos.\n    El permiso de acceso brindado por BEATHEY al Usuario es no exclusivo, temporal, y limitado con el alcance fijado en estos Términos y condiciones.\n    El Usuario se abstendrá de todo acto que pueda afectar el normal funcionamiento de BEATHEY y/o que de cualquier modo afecte o altere la prestación del Servicio, así como de eludir o interferir todas las medidas de protección del Servicio y de los contenidos de BEATHEY. BEATHEY no será responsable de la conducta del Usuario que afecte a terceros.\n\n    "),_c('h3',[_vm._v("Contenidos. Las Obras. Calidad")]),_vm._v("\n    BEATHEY podrá modificar la modalidad de acceso a las Obras disponibles en BEATHEY en cualquier momento y a su exclusivo criterio.\n    La calidad técnica y de imagen de las Obras será el disponible (en el estado que se encuentran), la que podrá variar en función de los dispositivos de acceso, capacidad tecnológica de transferencia, ubicación, etc. y otras cuestiones por las que BEATHEY no será responsable.\n\n    "),_c('h3',[_vm._v("Actualizaciones")]),_vm._v("\n    Al suscribirse a BEATHEY, como un producto de software, una aplicación o un plug-in para el navegador, el Usuario acepta que, periódicamente, BEATHEY pueda descargar e instalar cualquier tipo de mejoras, actualizaciones, reducir aplicaciones y funciones adicionales a fin de mejorar y desarrollar el servicio.\n\n    "),_c('h3',[_vm._v("Propiedad Intelectual")]),_vm._v("\n    BEATHEY es titular o cuenta con los derechos para la puesta a disposición de las Obras a través de BEATHEY y con el alcance establecido en estos Términos y Condiciones.\n    La totalidad de las Obras y contenidos que forman parte de BEATHEY, así como el software, los logotipos, íconos, audiologos y demás aspectos artísticos y creativos de BEATHEY se encuentran protegidos por el Derecho de Autor, Propiedad Intelectual e Industrial y/o Copyright.\n    BEATHEY es una marca protegida por la Propiedad Intelectual conforme la Ley de la República Argentina y los Tratados Internacionales que la República Argentina ha suscripto en la materia.\n    El uso de BEATHEY no otorga derecho de propiedad intelectual alguno sobre nuestros servicios o contenidos al que se acceda.\n    El Usuario no puede utilizar nuestros contenidos, ni nuestras marcas registradas ni ninguna marca que se parezca a las nuestras, excepto si recibe consentimiento previo por escrito de BEATHEY.\n    Las aplicaciones de software de BEATHEY se le otorgan al Usuario bajo licencia, no le son vendidas, y BEATHEY conserva la propiedad de todas las copias de las aplicaciones de software, incluso después de que hayan sido instaladas en sus equipos.\n    BEATHEY podrá retirar cualquier contenido que considere que atenten contra los derechos de terceros, incluyendo pero sin limitarse a derechos de propiedad intelectual e industrial, la dignidad y/o derechos personalísimos de las personas, tales como el honor, el nombre y la imagen, ni podrá ser considerada discriminatoria y/o fomentar la violencia ni deberá afectar la moral y/o las buenas costumbres.\n\n    "),_c('h3',[_vm._v("Denuncia de Infracción")]),_vm._v("\n    BEATHEY no asume ni puede asumir ningún deber ni obligación de controlar la adecuación de las Obras al ordenamiento jurídico y derechos de terceros.\n    Cualquier persona (en adelante, el \"Denunciante\") podrá denunciar que un Usuario infringe el ordenamiento jurídico y/o atentan contra los derechos de terceros, incluyendo pero sin limitarse a derechos personalísimos y de propiedad intelectual e industrial.\n    Frente a la recepción de una denuncia, BEATHEY podrá proceder a suspender al Usuario objeto de la denuncia, en forma automática, sin análisis de ningún tipo y sin necesidad de notificación alguna. Simultáneamente a la recepción de la denuncia, BEATHEY comunicará la existencia y contenido de la denuncia al Usuario.\n    BEATHEY no asume responsabilidad de ningún tipo ni asume la obligación de actuar de ningún modo a fines de decidir la procedencia o improcedencia de la denuncia. Cualquier conducta ilícita y/o abusiva del Denunciante será de entera responsabilidad del Denunciante y cualquier conducta ilícita y/o abusiva del Usuario será de entera responsabilidad del Usuario, sin que en ninguno caso sea responsable BEATHEY bajo ningún concepto.\n    El Denunciante y los Usuarios aceptan en forma expresa e irrevocable el Mecanismo de Denuncia de Contenidos establecidos en los distintos incisos de este punto. En particular, los Usuarios no podrán efectuar ningún tipo de reclamo por ningún concepto vinculado con la suspensión y/o eliminación definitiva de los Usuario y/o con la descalificación del Concurso.\n    Sin perjuicio del procedimiento establecido en el Mecanismo de Denuncia de Contenidos previsto, BEATHEY se reserva el derecho de decidir a su exclusivo criterio, en cualquier momento, la suspensión y/o eliminación de Usuarios, e incluso la descalificación de los Usuarios del Concurso, todo ello en forma automática y sin necesidad de notificación alguna, cuando a su criterio exista una violación del ordenamiento jurídico, los derechos de terceros y/o las condiciones. Los Usuarios aceptan irrevocable e incondicionalmente que sus Contenidos sean removidos a exclusivo criterio de BEATHEY, por lo que nada tendrán que reclamar a BEATHEY en caso que dicha remoción sea decidida por BEATHEY.\n\n    "),_c('h3',[_vm._v("Datos Personales")]),_vm._v("\n    BEATHEY adopta medidas de seguridad físicas e informáticas respecto de las bases de datos que contienen los Datos Personales. Sin perjuicio de ello, BEATHEY no garantiza a los Usuarios frente al uso ilícito de los Datos Personales que puedan llegar a realizar los terceros. En consecuencia, BEATHEY no garantiza ni asume responsabilidad alguna por los daños y perjuicios, incluyendo pero sin limitarse a daño directo o indirecto, mediato, inmediato, consecuente, moral o patrimonial, daño emergente, lucro cesante y/o pérdida de chance, que puedan derivarse de la alteración, pérdida, tratamiento, acceso no autorizado o uso ilícito de los Datos Personales por parte de terceros.\n    Los Usuarios serán responsables de los daños y perjuicios que BEATHEY, sus sociedades controladas o controlantes, directivos, empleados y/o terceros puedan sufrir como consecuencia de la falta de veracidad, inexactitud, falta de vigencia y autenticidad de los Datos Personales.\n    Los Usuarios se obligan a mantener indemne a BEATHEY, sus sociedades controladas o controlantes, directivos y empleados de cualquier y todo reclamo, pérdida, gasto y/o daño de cualquier tipo, incluyendo pero sin limitarse a daño directo o indirecto, mediato, inmediato, consecuente, moral o patrimonial, daño emergente, lucro cesante y/o pérdida de chance, derivado de la conducta y/o la actividad de los Usuarios violatoria del ordenamiento jurídico, los derechos de terceros y/o de las condiciones, y/o que le sea jurídicamente imputable a los Usuarios.\n    BEATHEY puede utilizar cookies en relación al Sitio. Las cookies constituyen una herramienta empleada por los servidores Web para almacenar y recuperar información acerca de sus visitantes. Las cookies podrán eventualmente instalarse en la computadora de los Usuarios cuando éste navegue por el Sitio. Las cookies empleadas por BEATHEY se asocian únicamente con un Usuario anónimo y su ordenador y no proporcionan referencias que permitan deducir el nombre y apellido del Usuario y no pueden tomar datos de su disco duro. Los Usuarios podrán libremente decidir acerca de la implantación o no en su disco duro de las cookies empleadas por BEATHEY configurando su navegador en tal sentido.\n    La Dirección Nacional de Protección de DATOS PERSONALES, Órgano de Control de la Ley Nº 25.326, tiene la atribución de atender las denuncias y reclamos que se interpongan con relación al incumplimiento de las normas sobre protección de Datos Personales.\n\n    "),_c('h3',[_vm._v("Información")]),_vm._v("\n    BEATHEY podrá reunir información respecto al uso de BEATHEY y del acceso a los distintos contenidos por parte del Usuario. Esta información incluye las Obras a las que se ha tenido acceso, el historial de accesos, búsquedas efectuadas, aspectos técnicos de conectividad (dispositivos, tipo de conexión, etc.), y toda otra información relativa al acceso y/o utilización del servicio.\n    BEATHEY se compromete a realizar un uso privado de dicha información y a no comercializar ni ceder la misma a terceros, así como a dar cumplimiento con la normativa vigente sobre la materia.\n    BEATHEY utilizará y analizará dicha información con el objeto de administrar, mejorar y optimizar BEATHEY y la prestación del servicio, llevar registros estadísticos de modalidades de accesos y contenidos, pagos, etc.\n\n    "),_c('h3',[_vm._v("Funcionamiento de BEATHEY")]),_vm._v("\n    BEATHEY no garantiza de ningún modo la inviolabilidad de sus sistemas y/o del Sitio ni la disponibilidad y/o continuidad del funcionamiento del Sitio y excluye cualquier responsabilidad por los daños y perjuicios de toda naturaleza que puedan deberse a la falta de disponibilidad o de continuidad del funcionamiento del Sitio.\n\n    "),_c('h3',[_vm._v("Validez")]),_vm._v("\n    La nulidad parcial de una o más disposiciones de estos Términos y Condiciones no afecta su validez y vigencia. En tal supuesto, la disposición nula se entenderá por no escrita, sin afectar la validez del resto.\n\n    "),_c('h3',[_vm._v("Jurisdicción y Competencia")]),_vm._v("\n    Estos Términos y Condiciones se acuerdan con BEATHEY, con domicilio en Soler 4227 1M, de la Ciudad Autónoma de Buenos Aires, República Argentina, y se regirá e interpretará conforme a las leyes de la República Argentina.\n    La interpretación de estos Términos y Condiciones, las reclamaciones de incumplimiento del mismo y todas las demás reclamaciones (incluidas las reclamaciones por protección al consumidor, competencia desleal y responsabilidad extracontractual), y todos los conflictos que surjan como consecuencia de los Términos y Condiciones, o que estén relacionados con los mismos, independientemente de los conflictos de principios legales, y toda cuestión que surja de o en relación con éste se someterá a la competencia de los tribunales ordinarios del fuero Civil de la Nación, con renuncia a cualquier otro fuero de excepción.\n\n    BEATHEY es una empresa de Music Dreams S.R.L., CUIT 30-71538505-4, con domicilio en Soler 4227 1M, Ciudad Autónoma de Buenos Aires, República Argentina.\n  ")],1)])}
var staticRenderFns = []


/***/ }),
/* 931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsSubsEs_vue__ = __webpack_require__(419);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39e94e48_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsSubsEs_vue__ = __webpack_require__(933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(932)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-39e94e48"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsSubsEs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39e94e48_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsSubsEs_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39e94e48_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsSubsEs_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 932 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"terms flex justify-center"},[_c('div',{staticClass:"mw7"},[_c('button',{staticClass:"backButton"},[_c('router-link',{staticClass:"rlink",attrs:{"to":{name:'home'}}},[_vm._v("Volver")])],1),_vm._v(" "),_vm._m(0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mainContentTyCandPolicy"},[_c('h1',{staticClass:"mainTitleTyCandPolicy"},[_vm._v("BEATHEY Bases y Condiciones de Uso")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("\n            Por favor, lea estas Condiciones de Uso (\"Acuerdo\" o \"Condiciones de Uso\") antes de utilizar los servicios ofrecidos por BEATHEY (\"BeatHey\", “Empresa”, \"Nosotros\", \"Nos\" o \"Nuestro\"). Este acuerdo establece los términos jurídicamente vinculantes y condiciones para el uso del sitio Web en www.BeatHey.com (el \"Sitio\") y el servicio de su propiedad y operado por BeatHey, incluyendo las aplicaciones de software móviles ofrecidos o publicados por la empresa (en conjunto con el sitio, el \"Servicio\"). Al utilizar el Sitio o Servicio de cualquier manera, incluyendo pero no limitado el visitar o navegar por la web, usted acepta que quedará vinculado por estas Condiciones de Uso. Estas condiciones de uso se aplican a todos los usuarios del Sitio o Servicio, incluidos los usuarios que también son contribuyentes de contenido, información y otros materiales o servicios en el Sitio.\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Aceptación de los términos.")]),_vm._v("\n          El Servicio se ofrece sujeto a la aceptación sin excepciones de todos los términos y condiciones contenidos en este documento (las \"Condiciones de Uso\"), los cuales incorporan también la política de privacidad disponible en https://services.BeatHey.com/policy/privacy , y todas las demás reglas de operación, políticas y procedimientos que puedan ser publicadas en el sitio por la Empresa, cada uno de los cuales se incorpora por referencia en estas Condiciones de Uso y cada uno de los cuales puede ser actualizada por la Empresa de vez en cuando sin previo aviso. Además, algunos servicios ofrecidos a través del Servicio pueden estar sujetos a términos y condiciones adicionales publicadas por BeatHey cuando así lo disponga; el uso de este tipo de servicios está sujeto a los términos y condiciones adicionales, que se incorporen a las presentes Condiciones de Uso por esta referencia.\n          Si está utilizando o desea abrir una cuenta a nombre de una empresa, entidad u organización (incluyendo, pero no limitado a un sello discográfico) (cada uno un \"Artista Entidad\"), entonces usted declara y garantiza que: (i) está debidamente autorizado por el Artista Entidad y/o por cualquier artista representados por tales Artista Entidad (un \"Artista Representada\") con la autoridad para obligar a dicho Artista Entidad o Artista Representado a estas Condiciones de Uso y (ii) acepta que quedará vinculado por estas Condiciones de Uso para el uso del nombre de dicho Artista Entidad y/o Artista Representada.\n          El Servicio está disponible sólo para personas que tengan al menos 13 años de edad. Usted manifies ta y garantiza que si es un individuo, entonces usted tiene la edad legal para contraer un acuerdo vinculante, y que toda la información presentada para su registro es exacta y veraz. BeatHey puede, a su sola discreción, negarse a ofrecer el Servicio a cualquier persona o entidad y cambiar sus criterios de elegibilidad en cualquier momento. Esta disposición es nula donde esté prohibido por la ley y el derecho a acceder al servicio sea revocado en dichas jurisdicciones.\n          "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Modificación de las Condiciones de Uso.")]),_vm._v("\n          BeatHey se reserva el derecho, a su sola discreción, de modificar o sustituir cualquiera de los términos de estas Condiciones de Uso, o cambiar, suspender o interrumpir el Servicio (incluyendo, sin limitación, la disponibilidad de cualquier característica, base de datos o contenido) en cualquier momento mediante la publicación en el Sitio o mediante el envío de un correo electrónico. BeatHey también puede imponer límites a ciertos servicios o restringir el acceso a la totalidad del Servicio sin previo aviso o responsabilidad. Es su responsabilidad revisar estos Condiciones de Uso periódicamente. El uso continuado del Servicio después de la publicación de cualquier cambio en estas Condiciones de Uso implica la aceptación de dichos cambios. \n          "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Reglas y Conducta.")]),_vm._v("\n          Como condición de uso, usted se compromete a no utilizar el Servicio para ningún propósito que esté prohibido por estas Condiciones de Uso. El Servicio (incluyendo, sin limitación, cualquier Contenido como se define a continuación) se proporciona únicamente para su uso personal, no comercial (excepto con respecto a los artistas individuales, Entidades de artistas o Artistas Representados, cada uno, un \"artista\") la venta de música, merchandising u otro contenido (cada uno como se define a continuación) según lo autorizado por el Servicio. Usted es responsable de la totalidad de su accionar con relación con el Servicio. A los efectos de estas Condiciones de Uso, el término \"Contenido\" incluye, sin limitación, cualquier Archivo de Usuario, vídeos, clips de audio, comentarios por escrito en el foro, información, datos, texto, fotografías, software, guiones, gráficos, accesible a través del Servicio.\n          A modo de ejemplo, y no como una limitación, Ud. no podrá (a) tomar cualquier acción o (b) cargar, descargar, publicar, enviar, distribuir o facilitar la distribución de cualquier contenido a través del Servicio, incluyendo sin limitación cualquier Archivo de usuario, que:\n              • infrinja cualquier patente, marcas, secretos comerciales, derechos de autor, derecho de publicidad u otro derecho de cualquier otra persona o entidad, o que viole cualquier ley o deber contractual;\n              • usted sabe que es falsa, engañosa, falsa o inexacta;\n              • es ilegal, amenazador, abusivo, acosador, difamatorio, calumnioso, engañoso, fraudulento, invasivo de la privacidad, agraviante, obsceno, ofensivo o profano;\n              • constituye publicidad no autorizada o no solicitada, no deseado o correo electrónico no solicitado (\"spamming\");\n              • implique actividades comerciales y/o ventas sin el consentimiento previo por escrito de la empresa, tales como concursos, sorteos, canjes, publicidad o esquemas piramidales;\n              • explota a la gente de una manera sexual o violenta;\n              • contenga virus de software o cualquier otro código de computadora, archivos o programas que están diseñados o destinados a interrumpir, dañar, limitar o interferir con el correcto funcionamiento de cualquier software, hardware o equipo de telecomunicaciones o para dañar u obtener acceso no autorizado a cualquier sistema, datos, contraseña u otra información de la empresa o de terceros; o\n              • pasar por cualquier persona o entidad, incluyendo cualquier empleado o representante de la Empresa.\n          Además, no deberá: (i) tomar cualquier acción que imponga o pueda imponer (según lo determinado por BeatHey a su entera discreción) una carga irrazonable o desproporcionadamente grande sobre la infraestructura de la empresa (o sus terceros proveedores); (ii) interferir o intentar interferir con el funcionamiento adecuado del Servicio o de cualquier actividad realizada en el Servicio; (iii) Anular las medidas que BeatHey puede utilizar para evitar o restringir el acceso al Servicio (u otras cuentas, sistemas informáticos o redes conectadas al Servicio); (iv) ejecutar maillist, Listserv, cualquier forma de auto-respuesta o \"spam\" en el Servicio; o (v) utilizar software manual o automático, dispositivos, u otros procesos para \"rastrear\" o \"spider\" cualquier página del sitio.\n          Usted no deberá (directa o indirectamente): (i) descifrar, descompilar, desensamblar, realizar ingeniería inversa o intentar derivar el código fuente o subyacentes a las ideas o algoritmos de cualquier parte del Servicio, con excepción de las leyes aplicables de forma limitada específicamente prohíbe tales restricción, (ii) modificar, traducir o crear trabajos derivados de cualquier parte del Servicio, o (iii) copiar, alquilar, arrendar, distribuir o transferir cualquiera de los derechos que reciba a continuación. Usted deberá cumplir con todas las leyes estatales, locales, nacionales e internacionales y reglamentos.\n          BeatHey se reserva el derecho a investigar y tomar las medidas legales pertinentes contra cualquier persona que, a la sola discreción de la empresa, viole esta disposición, incluyendo, sin limitación, la terminación de su cuenta y/o la transmisión de dicha actividad o contenido a las autoridades policiales.\n          "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Uso del Contenido")]),_vm._v("\n          Además de las anteriores restricciones generales, las siguientes restricciones y condiciones aplicarán específicamente al uso del Contenido.\n          A. El Contenido en el Servicio, las marcas, marcas del servicio y logotipos (las \"Marcas\") contenidos en el Servicio, son propiedad o se encuentran licenciadas en favor de BeatHey, sujetas a derechos de autor y otros derechos de propiedad industrial e intelectual bajo la ley.\n          B. El Contenido se provee en EL ESTADO EN QUE SE ENCUENTRA. Usted podrá acceder al Contenido para su información y uso personal solamente conforme a lo previsto a través de las funciones que se proporcionan en el Servicio y según lo permitido en virtud de estas Condiciones de Uso. Usted no descargará ningún Contenido a menos que vea un enlace de \"descarga\" o similar mostrado por BeatHey en el Servicio para ese Contenido. Usted no deberá copiar, reproducir, distribuir, transferir, transmitir, exponer, vender, licenciar ni explotar de cualquier otra forma cualquier Contenido para cualquier propósito sin la debida autorización de BeatHey o de los correspondientes licenciantes del Contenido. Se entenderá autorizado para ello si la copia, reproducción, distribución, transmisión, exposición, venta, licencia o explotación, se realiza a través de esta plataforma en un todo de acuerdo a la Condiciones de Uso. BeatHey y sus licenciantes se reservan todos los derechos que no se encuentran expresamente otorgados en y para el Servicio y el Contenido.\n          C. Usted se obliga a no circunvenir, deshabilitar o de cualquier otra forma interferir con las funciones relacionadas con la seguridad del Servicio o las funciones que previenen o restringen el uso o copiado de cualquier Contenido o que establecen limitaciones en el uso del Servicio o el Contenido del mismo.\n          D. Usted entiende que al utilizar el Servicio se expone a Contenido de una gran variedad de fuentes y que BeatHey no es responsable por la exactitud, utilidad, seguridad ni derechos de propiedad intelectual o relacionados con dicho Contenido. Asimismo entiende y acepta que podrá estar expuesto a Contenido que puede ser impreciso, ofensivo, indecente u objetable y se obliga a renunciar y por medio del presente renuncia a cualquier derecho o defensa legal, ya sea en dinero o de cualquier otra forma que tenga o pueda tener en contra de BeatHey al respecto y, de la forma más amplia que permita la legislación aplicable, se obliga a indemnizar y mantener libres a BeatHey, sus propietarios, operadores, afiliados, licenciantes y licenciatarios, de cualquier daño o reclamación de conformidad con las leyes correspondientes en todos los asuntos relacionados con el uso del Servicio.\n          "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Información Personal - Los aficionados.")]),_vm._v("\n          Como condición para utilizar ciertas características del Servicio (incluyendo, sin limitación, la función de descarga libre, o hacer una compra de la empresa o un artista), se le puede pedir que proporcione cierta información personal a BeatHey, tales como su dirección de correo electrónico, país de residencia y zip / código postal (\"Información del aficionado\").\n          Puede registrarse con BeatHey como un aficionado y crear una cuenta de usuario (\"Cuenta de aficionado\"), que le permitirá acceder a ciertas características del Servicio que sólo están disponibles a través de cuentas de aficionados, tales como una página de perfil de aficionado, una lista de la historia de las compras de música junto con la información que usted decide compartir sobre sí mismo, y la capacidad de seguir a otros aficionados o artistas. El seguimiento de un artista o la compra de una suscripción de un artista (una \"suscripción del artista\") le da acceso al artista a su dirección de correo electrónico. Su historia de las compras de música, y cualquier información que proporcione a su página de perfil estarán disponibles para otros usuarios del servicio de forma predeterminada, sujeto a nuestra política de privacidad.\n          Como condición al derecho de los artistas a recibir información del aficionado, BeatHey requiere que cada artista este de acuerdo con los términos establecidos en la siguiente sección de este Acuerdo. Sin embargo, reconoce que BeatHey no tiene control sobre el uso de la información del aficionado por parte de los artistas, y usted reconoce y acepta que BeatHey no será responsable o estará obligado, directa o indirectamente, por cualquier daño o pérdida causada o supuestamente causada por o en conexión con el uso de dicha información por parte de los artistas.\n          "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Información Personal - Artistas.")]),_vm._v("\n          En relación con ciertas características del Servicio, incluyendo el exigir que los aficionados proporcionen sus direcciones de correo electrónico y demás información personal con el fin de acceder a la opción de descarga, es posible recoger ciertos tipos de información del aficionado. Como condición para recibir dicha información del aficionado, usted reconoce y acepta que no revelará o venderá ninguna información del aficionado a terceros, y que va a utilizar la información del aficionado sólo en relación con la lista de correo del artista o suscripción del artista, con el fin de ofrecer a los aficionados información general y noticias sobre el artista, como por ejemplo los próximos shows, nueva música u otro contenido que se ofrece en relación con su suscripción del artista. Asimismo, acepta que cualquier correo electrónico u otra comunicación enviada a la lista de correo del artista o enviados con relación a la suscripción del artista va a cumplir con las leyes de marketing para correo electrónico e incluya un mecanismo por el cual el destinatario puede darse de baja de la lista de correo, junto con instrucciones claras sobre cómo hacerlo (es decir, un \"opt-out\" mecanismo de funcionamiento). \n          "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Registro de cuenta.")]),_vm._v(" \n          Para utilizar algunos de los servicios de la Web debe registrarse y proporcionar cierta información (por ejemplo, un nombre de usuario, contraseña, información de facturación y dirección de correo electrónico válida) para BeatHey (\"Datos de Registro\") a los efectos de crear una cuenta (su \"cuenta\"). El usuario acepta proporcionar Datos de registro actuales, completos y exactos en el momento de registrarse y va a actualizar su registro de datos según sea necesario para mantenerla actualizada, completa y exacta. BeatHey puede cancelar su cuenta y cualquier o todos los derechos de la página web si la información que proporcione es inexacta, falsa, incompleta, o, si BeatHey, a su propia discreción, sospecha que el comportamiento fraudulento y/o ilegal, tales como, pero no limitado al identificar robo, tarjetas de crédito robadas o compra artificial para inflar los datos de ventas, asociados con su registro. El usuario acepta que BeatHey puede almacenar y utilizar los Datos de Registro que suministra con el del servicio de facturación a su tarjeta de crédito y el mantenimiento de su cuenta. Usted es el único responsable de mantener la confidencialidad y seguridad de su cuenta. Usted se compromete a notificar a BeatHey inmediatamente de cualquier uso no autorizado de su contraseña y/o cuenta. BeatHey no será responsable de ninguna pérdida derivada del uso no autorizado de sus datos de registro o cuenta, y usted acepta mantener indemne e indemnizar BeatHey, sus socios, empresas matrices, subsidiarias, agentes, afiliados y/o licenciantes, según sea el caso, para cualquier uso inapropiado, no autorizado o ilegal de su cuenta. Usted no debe intentar obtener acceso no autorizado a la Web. En caso de intentar hacerlo, ayudar a otros en tales intentos, o la distribución de instrucciones, software o herramientas para tal fin, BeatHey tendrá el derecho de cancelar su cuenta y llevar a cabo todas las acciones legales disponibles en la ley. Usted se compromete a notificar a BeatHey inmediatamente de cualquier uso no autorizado de su contraseña y/o cuenta. BeatHey no será responsable de ninguna pérdida derivada del uso no autorizado de sus datos de registro o cuenta, y usted acepta mantener indemne e indemnizar BeatHey, sus socios, empresas matrices, subsidiarias, agentes, afiliados y/o licenciantes, según sea el caso, para cualquier uso inapropiado, no autorizado o ilegal de su cuenta.\n          "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Requisitos del sistema para el uso.")]),_vm._v("\n          Usted es responsable por el uso de cualquier hardware, sistemas y/o programa (s) de software y de las comisiones y gastos derivados (a) para conectarse, navegar o utilizar el Internet, y/o (b) acceder al Sitio Web, y/o (c) para buscar, escuchar, descargar, cargar, reproducir, o transferir el Contenido Digital. En determinado momento, es posible que tenga que instalar software, el que estará disponible a través de la Web, para ayudar en la accesibilidad de los contenidos. Sin embargo, la compra o adquisición de cualquier otro producto no se entenderán que representa o garantiza el acceso al Contenido Digital. Si necesita información sobre las especificaciones de cualquier equipo, acceso a Internet o software para poder utilizar los servicios proporcionados por el Sitio Web, póngase en contacto con el equipo de soporte al cliente. Usted no puede intentar, ni apoyar los intentos de terceros, para desencriptar, realizar ingeniería inversa, eludir o alterar o interferir con el software necesario para el uso del sitio Web o Contenido Digital. Si tiene acceso a la Web a través del móvil o a través de una aplicación para Android o iOS, se aplicará un recargo de datos.\n          "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Membresía – Cargos")]),_vm._v("\n          En determinadas circunstancias el uso del Servicio en el Sitio no será gratuito. En consecuencia BEATHEY podrá cobrar una suma mensual expresada en dólares estadounidenses en concepto de Membresía a todos aquellos que utilicen el Servicio, ya sea como aficionados y/o como artistas y/o de cualquier otra manera, mediante el alta de una Cuenta a esos efectos. BEATHEY podrá fijar y modificar el valor de la Membresía a su criterio, sin necesidad de previo aviso. Para el caso que el medio de pago utilizado por el usuario implique la facturación en pesos, la misma será calculada a la cotización del dólar tipo vendedor del Banco Central de la República Argentina del día anterior a la fecha transacción.\n          "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Cargos y pagos - Los aficionados.")]),_vm._v("\n          Usted puede comprar productos y/o servicios de un artista a través del Sitio, incluyendo, sin limitación, las compras de contenido (incluidos los contenidos digitales disponibles a través de descarga y el streaming a través del Servicio (\"Contenido Digital\"), y mercancía física (\"Merchandising\"). Cada uno de dichas compras se considera una \"transacción\".\n          A esos efectos, Ud. podrá, a su elección, adquirir Contenido Digital optando por el valor que desee abonar por la descarga de dicho Contenido Digital, teniendo en cuenta los valores que se publican en Pesos Argentinos. Los valores son expresados en dólares estadounidenses. Para el caso que el medio de pago utilizado por el usuario implique la facturación en pesos, la misma será calculada a la cotización del dólar tipo vendedor del Banco Central de la República Argentina del día anterior a la fecha transacción. \n          Todas las consultas relativas a transacciones sobre Merchandising serán dirigidos a la artista relevante. BeatHey no se hace responsable de las restituciones por merchandising, salvo lo dispuesto en el presente Acuerdo.\n          Todas las ventas de contenido digital son finales (excepto donde esté prohibido por la ley), a menos que se determine otra cosa por parte de BeatHey. Si no recibe el contenido digital o tiene un problema con el contenido digital entregado, debe ponerse en contacto con BeatHey con su solicitud y comprobante de pago, y BeatHey le notificará al artista relevante para que le resuelva su problema. A criterio exclusivo de BeatHey, Ud. puede ser reembolsado o acreditado en cuenta por la compra del Contenido Digital. Sin embargo, usted entiende y acepta que BeatHey es una plataforma que los artistas utilizan para vender sus productos, y el contenido digital se deriva de los archivos proporcionados por el artista relevante, y el artista relevante es el único responsable de este tipo de archivos.\n          El precio total del contenido digital incluirá el precio del producto más cualquier impuesto sobre las ventas aplicables en el momento de adquirir el producto. Se cargará el impuesto sólo en estados o países en los que los bienes digitales están sujetos a impuestos.\n          BeatHey no puede garantizar que el Contenido que usted compra en una transacción esté disponible de manera perpetua. Por ejemplo, si Ud. o su agente recibe una notificación de infracción al derecho de autor con respecto al contenido específico, y si una autoridad judicial ordena quitar dicho Contenido del Servicio, no permitiendo que esté disponible para la venta futura o niegue el acceso continuo a cualquier persona que previamente compró dicho contenido. Esto significa que puede perder el acceso a contenido adquirido previamente a través del Servicio.\n          En caso de vernos obligados por ley a no permitir el acceso a través del Servicio del contenido previamente adquirido, incluyendo, eliminando el acceso al contenido de la colección personal de un aficionado a través de cualquier aplicación móvil, BeatHey y los artistas no proporcionarán un reembolso al aficionado que compró ese contenido, excepto cuando sea requerido por la ley aplicable. Los usuarios asumen todo el riesgo por la prohibición al acceso a cualquier contenido comprado a través del Servicio.\n          Debido a que existe la posibilidad de que se nos pueda exigir que le neguemos el acceso al contenido previamente adquirido, le recomendamos descargar rápidamente a sus propios dispositivos cualquier contenido que usted compra a través del Sitio para que mantenga el control y la posesión de dicho contenido, incluso si son necesarios para eliminar el contenido del Servicio.\n          Usted garantiza que si se realiza una transacción, entonces usted será capaz de hacer el pago total e inmediato de los productos o servicios solicitados.\n          "),_c('h3',[_vm._v("Cargos y pagos - artistas.")]),_vm._v("\n          BeatHey será el único facultado a fijar los precios del Contenido Digital y servicios que se cobren mediante transacciones (los \"precios\") a través del Sitio, siendo BeatHey el único facultado a modificar los precios cuando así lo disponga. BeatHey puede redistribuir copias previamente adquiridas por los aficionados, en caso el producto se encuentre dañado, sea una versión del formato de archivo incorrecto de su producto, una copia incompleta de su producto, sin cargo al aficionado. Tal redistribución se puede efectuar permitiendo que un aficionado vuelva a descargar un reemplazo del Contendido Digital ya descargado con anterioridad.\n          Usted será el único responsable, y BeatHey no tendrá ninguna responsabilidad por cualquier tasa o cargo que pueda aplicar  las plataformas de pago (excepto para los honorarios de BeatHey), las tasas de transacción de tarjeta de crédito (en conjunto, \"Comisiones\"), cargo por morosidad (tales como declaraciones de tarjetas de crédito o fraude), pagos en disputa, y reembolsos, salvo lo dispuesto en el presente Acuerdo.\n          BeatHey podrá retener cualquier impuesto, derecho, cargas y/o gravámenes sobre los pagos efectuado por el aficionado que sea requerido por la ley aplicable, regla o regulación. BeatHey deberá remitir dichos impuestos, derechos, cargas o gravámenes a la autoridad legal correspondiente.\n          BeatHey y/o sus licenciantes y/o cesionarios, podrá efectuar pagos a los Artista calculados en base a la cantidad de reproducciones vía streaming que cada Usuario o Aficionado realicen del Contenido Digital (clips de audio) de los Artistas. A estos efectos se considerará como contenido apto para registro de reproducciones a obras que superen los 45 segundos de duración total. La reproducción se contabilizará, en forma aleatoria, en cualquier instante entre ese valor y la duración total de la obra. Asimismo no se computarán todas aquellas reproducciones que realicen los Artistas a sus propio Contenido Digital. El precio por cada reproducción, incluyendo su forma de cálculo, porcentajes, aplicación, etc, será determinado por BeatHey y podrá variar en el tiempo a sola discreción de BeatHey. \n          Por el Contenido Digital, BeatHey recogerá el precio de compra o de reproducción via streaming, los honorarios y los impuestos aplicables. BeatHey le pagará al artista de manera bimestral el total de ingresos verificados a favor del artista, menos los impuestos y/u otros cargos en caso de corresponder (el \"Pago del artista\").\n          El Pago del artista podrá ser efectuado mediante la plataforma de pago que BeatHey considere pertinente, la cual podrá encontrarse radicada en cualquier parte del mundo. El Artista deberá ajustarse a los requisitos exigidos por la plataforma de pago para el procedimiento de cobro, como así también aquellos que el país de radicación del Artista exija para el cobro de los importes que se encuentren depositados en el exterior, según sea el caso. El Artista acepta que, en razón de su país de radicación, la autoridad local pueda debitar cargos, tasas, impuestos, etc, sobre el monto a cobrar por el Artista.\n          Cuando recibe un pago por contenido digital o merchandising, usted es responsable por el importe total del pago más las tasas si el pago se invalida, por cualquier motivo, con posterioridad. Si no hay fondos suficientes para cubrir su responsabilidad, se compromete a reembolsar a BeatHey a través de otros medios.\n          BeatHey tiene el derecho, pero no tiene la obligación, de suspender de inmediato la oferta o venta de cualquier producto o servicio, impedir o restringir el acceso al Sitio o de los Servicios o tomar cualquier otra acción en caso de problemas técnicos, material objetable, inexactitud en anuncios o acciones prohibidas en los procedimientos y directrices contenidas en el Sitio, o por cualquier otra razón a sola y absoluta discreción de BeatHey, y para corregir cualquier información inexacta o problema técnico en el Sitio. BeatHey puede suspender de inmediato la oferta o venta de cualquier producto o servicio si recibe notificaciones de violaciones, toma conocimiento de alguna infracción, o de hechos o circunstancias que hacen evidentes la infracción con respecto a cualquier producto o servicio.\n          "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Cuotas adicionales.")]),_vm._v("\n          Además de las tasas establecidas anteriormente, BeatHey se reserva el derecho a exigir el pago de tasas para determinadas funciones adicionales del Servicio, que en el futuro puedan establecerse. BeatHey se reserva el derecho de modificar su lista de precios y para establecer nuevos cargos en cualquier momento, con diez (10) días de preaviso, que puede ser enviado por correo electrónico o publicado en el Sitio. El uso del Servicio por su parte con posterioridad a dicha notificación constituye su aceptación de todos los cargos nuevos o mayores.\n          "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Facturación.")]),_vm._v(" \n          BeatHey actualmente acepta distintas plataformas de pago, por ejemplo Paypal y/o Mercado Pago. BeatHey no acepta dinero en efectivo, giros postales, o cheques. BeatHey se reserva el derecho de cambiar esta política en cualquier momento. Usted acepta pagar todos los cargos asociados con su compra (s) (incluyendo cualquier impuesto aplicable), a las tarifas en vigor cuando los cargos fueron efectuados. Usted, no BeatHey, es responsable de todos los importes facturados no autorizados a su tarjeta de crédito por un tercero. Como titular de la tarjeta, el acuerdo con el emisor de la tarjeta rige para el uso de la tarjeta designada, y como tal, se debe hacer referencia a ese acuerdo para determinar sus derechos y responsabilidades como titular de la tarjeta. La obligación de pagar por las compras previamente aceptadas por BeatHey sobrevivirán a su terminación de su cuenta. Debido a la naturaleza del servicio, los reembolsos están disponibles sólo en circunstancias excepcionales a criterio exclusivo de BeatHey.\n          Usted es responsable de proporcionar a BeatHey una tarjeta de crédito válida y con el pago puntual de todos los gastos. A su discreción, BeatHey puede aplicar cargos de forma individual o agregarlos a otras compras que realice en el Sitio Web. Usted es responsable de actualizar la información en la sección correspondiente de su cuenta. Usted es responsable por cualquier cargo en su cuenta en que se incurra a través de un tercero, independientemente de si usted autorizó dicha compra o no. Usted es el único responsable de mantener su cuenta segura y confidencial. BeatHey puede, a su discreción, modificar, suspender o interrumpir el Sitio Web (o cualquier parte o contenido de éste) en cualquier momento con o sin previo aviso, y BeatHey no será responsable ante usted ni a ningún tercero en caso de ejercer tales derechos. \n          "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Sitio de Terceros.")]),_vm._v("\n          El Servicio puede permitir que usted pueda vincularse a otros sitios web o recursos en Internet, y otros sitios web o recursos puedan conectar enlaces con el Sitio. Cuando se accede a sitios web de terceros, lo hace bajo su propio riesgo. Estas otras páginas web no están bajo el control de BeatHey, y usted reconoce que BeatHey no se hace responsable por el contenido, funciones, exactitud, legalidad, idoneidad o cualquier otro aspecto de dichos sitios web o recursos. La inclusión de cualquier enlace no implica aprobación por parte de BeatHey, ni asociación con sus operadores. Además, usted reconoce y acepta que BeatHey no será responsable o estará obligado, directa o indirectamente, por cualquier daño o pérdida causada o supuestamente causada por conexión, el uso o la credibilidad de cualquier Contenido de este tipo, bienes o servicios disponibles en o por medio de otro sitio o recurso.\n          "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("El contenido y la licencia.")]),_vm._v("\n          El usuario acepta que el Servicio posee contenido específicamente proporcionados por BeatHey o sus socios y que dicho contenido está protegido por derechos de autor, marcas registradas, marcas de servicio, patentes, secretos comerciales, etc. Usted deberá respetar y mantener todos los avisos de derechos de autor, información y restricciones contenidas en cualquier Contenido accedido a través del Servicio.\n          BeatHey otorga a cada usuario del Sitio y/o el Servicio una licencia mundial no exclusiva, no sublicenciable y no transferible, para utilizar, modificar y reproducir el contenido, únicamente para uso personal, no comercial. El uso, reproducción, modificación, distribución o almacenamiento de cualquier contenido que no sea de uso personal, está expresamente prohibido sin previa autorización por escrito de BeatHey o del titular de los derechos de autor identificado en el aviso de derechos de autor de dicho contenido. Usted no podrá vender, licenciar, alquilar, o de otra manera utilizar o explotar cualquier Contenido para uso comercial o de cualquier manera que viole cualquier derecho de terceros.\n          Usted no puede realizar ingeniería inversa, descompilar, desmontar, modificar o desactivar cualquier protección de copia o utilizar sistemas de limitación asociados con las descargas del Contenido Digital. El usuario no puede reproducir y luego volver a digitalizar cualquier Contenido Digital. Usted no puede crear ningún \"obras derivadas\" mediante la alteración de cualquiera de los contenidos, excepto lo permitido en el presente documento. Usted no puede usar el Contenido Digital junto con cualquier otro contenido de terceros (por ejemplo, para proporcionar un sonido para una película) a menos que obtenga tales derechos del propietario del copyright. Peer-2-peer para compartir archivos está estrictamente prohibido. Cualquier otro tipo de uso compartido de archivos de red y la transferencia de Contenido Digital para tal propósito está expresamente prohibido y es una violación de las leyes internacionales de derechos de autor.\n          "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Derechos de Propiedad Intelectual - artistas.")]),_vm._v("\n          El servicio ofrece a los artistas la posibilidad de cargar el contenido digital de su propiedad o controlada por dichos artistas en el Sitio, incluyendo pero no limitado a las grabaciones sonoras (\"Las grabaciones de sonido\"), videos sincronizados con grabaciones sonoras y otras obras audiovisuales (colectivamente, \"Los vídeos musicales\"), y las obras musicales incorporadas en grabaciones de sonido y vídeos musicales (\"obras musicales”, en conjunto con grabaciones sonoras y vídeos musicales, del artista \"Música\"). BeatHey no tendrá ningún derecho de propiedad sobre el Contenido Digital de un artista, sin embargo, BeatHey necesita de la siguiente licencia para realizar el servicio. Cada artista que sube Contenido Digital al Servicio otorga a BeatHey y sus licenciatarios, distribuidores autorizados, la licencia mundial, no exclusiva, transferible a terceros, libre de royalties para: (i) reproducir, distribuir, ejecutar públicamente (incluido por medio de una transmisión de audio digital), mostrar públicamente, crear trabajos derivados, comunicar al público, sincronizar y explotar de otra manera (en conjunto, \"explotar\") (1) Música del artista y realizar el Servicio en nombre del artista (por ejemplo, reproducir, transmitir, copiar y almacenar música del artista, en servidores pertenecientes y/o gestionados por o en nombre de BeatHey o de sus licenciatarios autorizados y distribuidores, y ejecutar públicamente, transmitir, sincronizar, distribuir, y reproducir la música del artista) utilizando cualquier tecnología o metodologías ahora conocidos o desarrollados en el futuro, y (2) Explotar todas las obras, incluyendo, sin limitación, letras de canciones y notaciones musicales, ilustraciones de la cubierta del álbum, fotografías, gráficos, y descriptivo texto (\"Obras\") en relación con el Servicio); (II) permitir a los usuarios del servicio recibir los espectáculos y la exhibición pública de la música del artista y obras de arte y reproducir la música del artista y obras de arte en cualquiera y todos los dispositivos de propiedad o controladas por el usuario para fines no comerciales y recibir espectáculos y exhibiciones de los mismos; y (iii) reproducir, utilizar y publicar, y para permitir a otros a reproducir, utilizar y publicar, el nombre, marcas comerciales, y los materiales personales y biográficos del artista, en relación con la prestación del servicio; (iv) usar, distribuir, reproducir, copiar y mostrar sus marcas registradas, marcas de servicio, lemas, logotipos o derechos de propiedad similares (colectivamente, las \"Marcas Registradas\") únicamente en relación con el servicio o en la comercialización, promoción o publicidad de los servicios, incluyendo en todas las formas de comercialización, promoción, y materiales publicitarios conocen ahora o en el futuro creado.\n          Al subir Contenido Digital (música u obras) en el Sitio:\n              • Usted representa y garantiza, y puede demostrar a plena satisfacción o petición de BeatHey, que (i) es el propietario o de alguna manera controla todos los derechos de su música y obras (o que la música y obras de arte son de dominio público o de lo contrario, hubieran sido cedidos al artista con licencia por escrito con una concesión de derechos suficientes para permitir que el artista cumplir con este Acuerdo y otorgar todos los derechos con respecto a la música u obras de arte del artista como se establece en el presente Acuerdo (en adelante, \"licencia directa\"); (ii) tiene plena autoridad para actuar en nombre de cualquiera y de todos los propietarios de cualquier derecho, título o interés y para cualquier tipo de música u obra que suba al Servicio; (iii) tiene permiso para utilizar el nombre e imagen de cada individuo cuyo nombre o imagen se incluya o se utiliza dentro de la música y/o obras de arte, y para utilizar dicha de identificación individual o información personal (en la medida en que esa información se utiliza o contenida en la música y/o obras de arte) según se contempla en estos Condiciones de uso, y (iv) que están autorizados para otorgar todos los derechos antes mencionados a la música y/o obras de arte a BeatHey y a todos los usuarios del servicio.\n              • usted representa y garantiza que el uso u otra explotación de su música y/o obras de arte por BeatHey y sus licenciatarios y distribuidores autorizados y/o por los usuarios del sitio como se contempla en el presente Acuerdo no infringe ni viola los derechos de terceros, incluyendo, sin limitación, cualquier derecho de privacidad, derechos de publicidad, derechos de autor, derechos contractuales o cualquier otra propiedad intelectual o derechos de propiedad.\n              • usted representa y garantiza que, en la medida en que es el compositor de cualquier o todas las obras musicales incorporadas en sus grabaciones de sonido o música de videos, ya sea en su totalidad o en parte (por ejemplo, como un co-autor), usted tiene el pleno derecho, poder y autoridad para conceder los derechos establecidos en el presente Acuerdo no obstante las disposiciones de cualquier acuerdo que pueda haber contraído con cualquier organización de derechos de ejecución (\"ODE\"), ya sea con base en la República Argentina (por ejemplo SADAIC, AADI CAPIF ACR), los Estados Unidos (por ejemplo, la ASCAP, BMI o SESAC) o en otro lugar, o cualquier editor de música, y que es el único responsable para tomar todas las medidas necesarias para informar a tales ODE de su concesión de una licencia libre de regalías a favor de BeatHey para la comunicación y reproducción pública de su música y obras, y que no hay honorarios o pagos pendientes de cualquier tipo a tales ODE para la ejecución pública o la comunicación al público de sus obras musicales.\n              • usted declara y garantiza que no debe ningún fee o retribución de cualquier tipo a cualquier tercero, incluyendo, pero no limitado a, cualquier sindicato, gremio, músico, ingeniero o productor, por el uso o reutilización de la Música según lo autorizado en virtud del presente Acuerdo.\n          "),_c('strong',[_vm._v("\n            Si cualquier acuerdo que haya celebrado con terceros, incluyendo, pero no limitado a un ODE, editor de música, sindicato o gremio, ya sea por ley o contrato, le prohíbe garantizar a BeatHey el derecho y la licencia establecida en este Acuerdo y ejercer la representación y garantías establecidas en los cuatro párrafos inmediatamente anteriores, entonces se les prohíbe subir su música al Servicio y será responsable de indemnizar y mantener indemne a BeatHey contra cualquiera y todas las reclamaciones derivadas de la explotación de su música en el servicio, incluyendo todos los costos y honorarios legales.\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Derechos de Propiedad Intelectual - Los aficionados.")]),_vm._v("\n          El servicio proporciona a los usuarios la capacidad de agregar, crear, cargar, enviar, distribuir o postear (\"Envío\") contenido digital, videos (incluyendo videos musicales), clips de audio (incluida la música), comentarios escritos en el foro, datos, texto, fotografías, software, guiones, gráficos u otra información al sitio (colectivamente, los \"Envíos de usuario\"). Mediante el Envío en el Sitio o de otra manera a través del Servicio, usted:\n              • Reconoce que mediante el envió de cualquier Archivo de Usuario Ud. puede ser identificado públicamente por su ID de usuario en asociación con cualquier Archivo de Usuario;\n              • Al enviar cualquier Archivo de Usuario a través del Sitio o el Servicio, usted otorga a BeatHey una licencia mundial, no exclusiva, perpetua, irrevocable y totalmente pagada, sublicenciable y transferible libre de regalías para usar, editar, modificar, reproducir, distribuir, preparar trabajos derivados de, mostrar públicamente, ejecutar públicamente (incluido por medio de una transmisión de audio digital), comunicar al público, sincronizar y explotar plenamente los envíos de usuario en relación con el Sitio, el negocio de servicio y de BeatHey (y de sus sucesores y cesionarios), incluyendo sin limitación, la promoción y redistribución de parte o la totalidad del Sitio (y las obras derivadas de los mismos) o el Servicio en cualquier formato a través de cualquier canal de comunicación (incluyendo, sin limitación, sitios web de terceros), conocidos o desarrollados con posterioridad. Para mayor claridad, la concesión de licencia otorgada a BeatHey no afecta a los otros derechos de propiedad o licencia del usuario, incluyendo el derecho a conceder licencias adicionales para el material presentado por el usuario, a menos que se acuerde lo contrario por escrito;\n              • Representa y garantiza, y se puede demostrar a plena satisfacción y petición de BeatHey que (i) posee o controla todos los derechos sobre todo el contenido de sus envíos de usuario, o que el contenido de dichos Archivos de Usuario está en el dominio público o directa con licencia, (ii) que tiene plena autoridad para actuar en nombre de cualquiera o de todos los propietarios de cualquier derecho, título o interés en y para cualquier contenido en sus envíos de usuario para utilizar dicho contenido según se contempla en estas condiciones de uso y la concesión de los derechos de licencia establecidos anteriormente, (iii) usted tiene el permiso para utilizar el nombre e imagen de cada persona individual identificable y utilizar dicha identificación del individuo o de la información personal tal como se contempla en estas condiciones de uso; y (iv) está autorizado para otorgar todos los derechos antes mencionados a los envíos de usuario a la empresa y todos los usuarios del servicio;\n              • Usted acepta pagar todas las regalías y otras cantidades debidas a cualquier persona o entidad, incluyendo cualquier OPI, con motivo de la presentación de cualquier Archivo de Usuario en el Servicio;\n              • Que el uso u otra explotación de dichos Archivos de Usuario por BeatHey y el uso u otra explotación por los usuarios del sitio y de servicios como se contempla en el presente Acuerdo no infringe o violar los derechos de terceros, incluyendo sin limitación alguna los derechos de privacidad, derechos de publicidad, derechos de autor, derechos contractuales o cualquier otra propiedad intelectual o derechos de propiedad; y\n              • Entiende que BeatHey tendrá el derecho de borrar, editar, modificar, reformatear, traducir cualquier material, contenido o información presentada por usted; y que toda la información públicamente o en privado a través del Sitio es responsabilidad exclusiva de la persona que originó dicho contenido y que BeatHey no será responsable por cualquier error u omisión en cualquier contenido; y que BeatHey no puede garantizar la identidad de los otros usuarios con los que puede interactuar en el curso de la utilización del Servicio.\n          BeatHey no respalda y no tiene ningún control sobre cualquier Archivo de Usuario. BeatHey no puede garantizar la autenticidad de los datos que los usuarios pueden dar de sí mismos. Usted reconoce que todo el Contenido que se accede por el uso del servicio es bajo su propio riesgo y usted será el único responsable de cualquier daño o pérdida de cualquiera de las partes resultante de la misma.\n          "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Terminación.")]),_vm._v("\n          BeatHey puede terminar su acceso a todo o parte del Servicio en cualquier momento, con o sin causa, con o sin previo aviso, con efecto inmediato, lo que puede resultar en la pérdida y destrucción de toda la información asociada con su membresía, incluyendo, sin limitación, cualquier acceso a cualquier tipo de música que puede haber comprado a través del Servicio. Los términos y condiciones se seguirán aplicando hasta que usted o BeatHey los rescindan. Sin embargo, usted reconoce y acepta que la licencia indefinida que se le otorgó en relación con el Contenido de usuario, incluidos los comentarios, es irrevocable y, por lo tanto, seguirá vigente después del vencimiento o rescisión del Servicio por el motivo que fuere. Si usted o BeatHey rescinden el Servicio, o si BeatHey suspende su acceso al Servicio, usted acepta que BeatHey no será responsable ante usted y que no deberá reintegrar ningún monto que ya haya pagado, en la medida que lo permita la ley vigente. Esta sección se implementará en la medida que lo permita la ley aplicable. Usted puede rescindir el Servicio en cualquier momento.\n          "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Liberación de Responsabilidad por Garantías")]),_vm._v("\n          Usted acuerda que el uso de los Servicios correrá bajo su propio riesgo en la medida de lo permitido por la legislación aplicable, BeatHey, sus funcionarios, administradores (directores), empleados, representantes y agentes quedan liberados de cualquier responsabilidad bajo cualquier tipo de garantía, sea expresa o implícita, en relación con los servicios y el uso de los mismos por usted. BeatHey no garantiza ni emite declaración alguna acerca de la veracidad o exactitud del contenido del sitio de internet o del contenido de cualquier sitio de internet ligado a este sitio de internet y no asume responsabilidad civil o penal por ningún (i) error, inconsistencia o inexactitud del contenido, (ii) daño personal o a la propiedad, de cualquier naturaleza, que resulte de su acceso y uso de los servicios, (iii) acceso o uso no autorizado de nuestros servidores restringidos o de cualquier información personal o financiera almacenada en dichos servidores, (iv) interrupción o terminación de la transmisión para o desde nuestros servicios, (v) cualquier defecto, bug, virus, caballos de troya (trojan horses) o similares que pudieran ser transmitidos por medio o a través de nuestros servicios por cualquier tercero, o (vi) cualquier error u omisión en cualquier contenido o por cualquier daño o pérdida de cualquier naturaleza que resulte del uso de cualquier contenido publicado, enviado vía correo electrónico, transmitido o puesto a su disposición de cualquier otra forma por conducto de los Servicios. BeatHey no garantiza, patrocina ni asume responsabilidad alguna por ningún Contenido Digital o servicio promocionado u ofrecido por un tercero a través de los servicios o cualquier servicio conectado por un \"hyperlink\" o promocionado en cualquier anuncio u otro tipo de publicidad. BeatHey no será parte ni de manera alguna responsable de controlar cualquier transacción entre usted y un tercer proveedor de productos o servicios como en cualesquiera adquisición de Contenido Digital o Merchandising o servicios a través de cualquier medio, usted deberá usar su mejor juicio y tomar las precauciones que fueren apropiadas.\n          BeatHey no otorga garantía de confidencialidad o privacidad de cualquier comunicación o información difundida en el Sitio o cualquier sitio web vinculado al Sitio. BeatHey no será responsable por la privacidad de las direcciones de correo electrónico, información de registro e identificación, espacio en disco, comunicaciones, información confidencial o secreto comercial, o cualquier otro contenido almacenado en el equipo de la empresa, que se transmite a través de redes que accede el sitio, o de otro modo conectada con su uso del Servicio.\n          "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Indemnización.")]),_vm._v("\n          De la forma más amplia que permita la legislación aplicable, usted se obliga a defender, indemnizar y mantener libres de cualquier daño a BeatHey, su sociedad controladora, sus funcionarios, directores, empleados y representantes de cualquier reclamación, daño, obligación, pérdida, responsabilidad, costo o deudas y gastos (incluyendo, sin limitar, honorarios de abogados) que resulten de: (i) su uso y acceso al Servicio; (ii) incumplimiento de cualquier disposición de estos Términos del Servicio; (iii) violación de los derechos de terceros, incluyendo, sin limitar, derechos de autor, propiedad o derechos de privacidad; o (iv) toda reclamación que argumente que su Contenido ha causado daño a un tercero. Esta defensa y obligación de indemnización sobrevivirá estas Condiciones de Uso y el uso del Servicio por parte suya.\n          "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Limitación de responsabilidad.")]),_vm._v("\n          Bajo ninguna circunstancia BeatHey, sus funcionarios, administradores (directores), empleados o agentes serán responsables por cualquier daño, sea, directo, indirecto, incidental, moral, especial, o punitivo que resulte de (i) errores o inconsistencias del contenido, (ii) lesión o daño a la propiedad, de cualquier naturaleza, que resulte de su acceso y uso de nuestros servicios, (iii) cualquier acceso no autorizado o uso de nuestros servidores restringidos y/o de cualquier información personal y/o financiera almacenada dentro de dichos servidores, (iv) cualquier interrupción o terminación de la transmisión para o desde nuestros servicios, (v) cualquier bug, defecto, virus, caballo de troya (trojan horses) o similares que pudieran ser transmitidos por medio o a través de nuestros servicios por cualquier tercero, y/o (vi) cualquier error u omisión en cualquier contenido o por cualquier pérdida o daño, de cualquier naturaleza, que resulte del uso del contenido publicado, enviado vía correo electrónico, transmitido o puesto a disposición de cualquier otra forma vía los Servicios, ya sea que los anteriores tengan como base una garantía, contrato, responsabilidad civil o cualquier otra teoría legal, sin importar que la BeatHey haya sido advertida o no del alcance de dichos daños. La limitación de responsabilidad antes mencionada, será aplicable de la forma más amplia que permita la legislación vigente en la jurisdicción correspondiente.\n          Usted específicamente reconoce que BeatHey no será responsable por el contenido ni por las conductas difamatorias, ofensivas o ilegales de cualquier tercero y que el riesgo de daño o perjuicio en relación con lo anterior recae completamente sobre usted.\n          Debido a que BeatHey no es el comprador o vendedor en una Transacción entre artistas y aficionados, y no es agente de los artistas o aficionados para cualquier propósito, BeatHey no tiene la obligación de resolver y/o no estará involucrado en la resolución de controversias entre los usuarios relacionados con o que surja de cualquier Transacción. Los artistas son los responsables de cumplir con todas las leyes de derechos de consumo aplicables a sus Transacciones.\n          El Servicio es controlado y ofrecido por BeatHey desde sus instalaciones en la República Argentina. BeatHey no hace ninguna declaración de que el Servicio es apropiado o se encuentra disponible para su uso en otras localidades. Aquellos que ingresan o utilicen el Servicio desde otras jurisdicciones lo hacen por su propia voluntad y son responsables por el cumplimiento de la legislación local.\n          "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Internacional.")]),_vm._v("\n          BeatHey no garantiza que el contenido sea apropiado o esté disponible para su uso en lugares fuera de la República Argentina, y el acceso al Servicio está prohibido desde los territorios donde el contenido sea ilegal. Si accede al servicio desde otros lugares, lo hace bajo su propia iniciativa y es responsable de cumplir con las leyes locales.\n          "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Resolución de conflictos.")]),_vm._v("\n          Una versión impresa de estas Condiciones de Uso y de cualquiera de las notificaciones en forma electrónica será admisible en procedimientos judiciales o administrativos basados ​​en o relacionados con estas condiciones de uso en la misma medida y sujeto a las mismas condiciones que otros documentos y registros comerciales. Usted y BeatHey acepta que cualquier causa de acción que surja del o esté relacionada con el Servicio debe comenzar dentro de un (1) año a partir del nacimiento de dicha acción legal; de lo contrario, dicha causa de acción caducará de forma definitiva.\n          Cualquier divergencia sobre la validez, existencia, interpretación, cumplimiento, incumplimiento o ejecución de estos Términos y Condiciones, así como cualquier aspectos de los Servicios, será dirimida exclusivamente por ante la justicia competente de acuerdo al domicilio real del Usuario.\n          "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Integración e independencia.")]),_vm._v("\n          Estas Condiciones de Uso, junto con la Política de Privacidad disponible en la página de Internet https://beathey.com/privacy-policy/es, la cual se entiende expresamente aceptada por usted y se tiene aquí por reproducida como si a la letra se insertare, y cualquier otra notificación legal publicada en el Servicio, serán parte integrante y constituirán el Contrato total entre usted y BeatHey en relación con el Servicio. Si cualquiera de las disposiciones de estas Condiciones de Uso es considerada nula o no válida por un tribunal competente, la nulidad o invalidez de dicha disposición no afectará la validez de las disposiciones restantes de estas Condiciones de Uso, los que permanecerán con plena fuerza y vigor. Ninguna renuncia a cualquiera de las disposiciones de estas Condiciones de Uso será considerada como una renuncia futura o continua a dicho término o a cualquier otro término y el no ejercicio por parte de BeatHey de algún derecho o disposición bajo estas Condiciones de Uso no constituirá una renuncia a dicho derecho o disposición. BeatHey se reserva el derecho para modificar estas Condiciones de Uso en cualquier momento y sin previo aviso, y es su responsabilidad revisar estas Condiciones de Uso por cualquier modificación. El uso del Servicio después de una modificación a las Condiciones de Uso significará su aceptación y sujeción expresa a dichos términos, según los mismos hayan sido modificados. \n          "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Misceláneos.")]),_vm._v("\n          BeatHey no será responsable por el incumplimiento de sus obligaciones cuando dicho incumplimiento fuera por cuestiones ajenas al control razonable de BeatHey, incluyendo, sin limitación, insuficiencia mecánica, electrónica o comunicaciones o degradación (incluida interferencia). Estas condiciones de uso son personales, y no son asignables, transferibles a terceros por usted, excepto mediante el consentimiento previo por escrito de BeatHey. La BeatHey puede asignar, transferir o delegar cualquiera de sus derechos y obligaciones sin el consentimiento de usted. Ninguna agencia, asociación, empresa conjunta o relación de empleo se crea como resultado de estas condiciones de uso y ninguna de las partes tiene autoridad de ningún tipo para obligar a la otra por la causa que fuere. En cualquier acción o procedimiento para hacer cumplir los derechos bajo estas condiciones de uso, la parte ganadora tendrá derecho a recuperar los costos y honorarios de abogados. Todas las notificaciones en virtud de estas condiciones de uso serán por escrito y se considerará que han sido debidamente dada cuando se reciben, si se entrega o se enviará por correo certificado o registrado personalmente, con acuse de recibo; cuando la recepción se confirma por vía electrónica, si se transmiten por fax o correo electrónico; o el día después de que se envíe, si se envía para entrega al día siguiente por el servicio de entrega al día siguiente reconocida. \n          "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Contacto.")]),_vm._v("\n          Puede ponerse en contacto con la empresa en la siguiente dirección: contacto@BeatHey.com\n    ")])}]


/***/ }),
/* 934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsEn_vue__ = __webpack_require__(420);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0da55d65_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsEn_vue__ = __webpack_require__(936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(935)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0da55d65"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsEn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0da55d65_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsEn_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0da55d65_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsEn_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 935 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"terms flex justify-center"},[_c('div',{staticClass:"mw7"},[_c('router-link',{attrs:{"to":{name:'home'}}},[_vm._v("Go back")]),_vm._v(" "),_c('h1',[_vm._v("BEATHEY GENERAL TERMS AND CONDITIONS")]),_vm._v("\n    Before subscribing to the site, please read carefully these terms and conditions of use of the Site www.beathey.com.\n    By clicking on the \"I accept\" button on the registration page, the User is declaring that he has read in full, without any reservation, this Terms of Use, which include the User and BEATHEY.\n    We hope that the site www.beathey.com., from now on BEATHEY, is dedicated to the diffusion of phonographic and/or audiovisual works from now on the \"Works\", under the modality of downloading or streaming in all its forms and for its access through different types of devices that will allow the User to upload phonographic and/or audiovisual contents.\n    By subscribing to BEATHEY, you agree to be bound by all of these Terms and Conditions, which you declare that you have read and fully accept. If you do not accept these Terms and Conditions do not use BEATHEY's services.\n    BEATHEY may at its sole discretion and discretion make modifications to the service and these Terms and Conditions. Any relevant changes will be notified to the User by means of an e-mail address denounced by the User in the registration form. If the User continues to use the BEATHEY service, it will be understood that the modifications made have been accepted.\n    In order to subscribe to BEATHEY's service, you must be over 18 years of age or have the consent of a parent or guardian.\n\n\n    "),_c('h3',[_vm._v("Definitions")]),_vm._v("\n    For purposes of these Terms and Conditions, the following terms are defined:\n    a) Works: Artistic creations in audio and/or video format.\n    b) BEATHEY: On-demand audio and/or video platform where the Works are made available to the public via the web. Also called the Site.\n    c) User: Any person who registers and/or accesses and/or uses the services provided by BEATHEY.\n    d) Download: Service that allows downloading audio and/or video.\n    d) Streaming: Service that allows the transfer of audio and/or video from a generation source so that BEATHEY Users can select the content and listen to and/or view a certain content without the possibility of downloading or downloading.\n\n\n    "),_c('h3',[_vm._v("User Information")]),_vm._v("\n    In order to register and create an account with BEATHEY, the User must provide the Site with the following information by completing the form provided by BEATHEY for this purpose:\n    a) Name and surname\n    b) ID card\n    c) Date of birth\n    d) Domicile\n    e) E-mail address\n\n    The User is responsible for the accuracy of the information provided.\n\n    "),_c('h3',[_vm._v("Access to BEATHEY")]),_vm._v("\n    The BEATHEY User may access the Site.\n    The way in which the service is provided, the different modalities of access, and the contents will be subject to the will, availability and technical capacity of BEATHEY, which may change them at its sole discretion, without expression of cause and without obligation of prior notification to the User.\n\n    "),_c('h3',[_vm._v("Access to the service")]),_vm._v("\n    The User will access the service through his/her Account by means of a password, at his/her own risk.\n    The use and access to the Account is strictly personal. The User may not disclose or provide to any third party the login name and password for access to his/her Account.\n    Without this implying any limitation of the foregoing, BEATHEY may decide and modify the functions and mechanisms for registration and participation of the Site at its sole discretion.\n\n    "),_c('h3',[_vm._v("Free Access")]),_vm._v("\n    The User will be able to access all the contents available in BEATHEY under this modality free of charge.\n    BEATHEY may cancel the content, service and/or BEATHEY at any time without this generating any rights in favour of the User.\n    BEATHEY may establish a paid access to BEATHEY at any time. You can also terminate your access at any time without having to state the reasons for the termination.\n    The method of payment will be informed on each occasion by BEATHEY and may be modified at its sole discretion.\n    BEATHEY may modify the value of the tariff at its sole discretion, authorising the User to pay by means of the selected Method of Payment.\n\n    "),_c('h3',[_vm._v("Obligations of the User")]),_vm._v("\n    The User undertakes to use the service and access BEATHEY, in accordance with these Terms and Conditions, and in compliance with current regulations.\n    The User will only be able to access the Works available on BEATHEY, in accordance with and with the limitations of the access modality, in accordance with these Terms and Conditions. The User may not store, download, reproduce, distribute, disseminate, communicate or make available to the public, modify, use all or part of, or edit in any way, for any purpose or by any means the Works available on BEATHEY.\n    The User will make personal and domestic (private) use of the Site and the contents available on BEATHEY. The User may not use the contents available on BEATHEY in a commercial manner, nor may he or she disseminate and/or make them available to the public, or make unlawful use thereof.\n    The access permission granted by BEATHEY to the User is non-exclusive, temporary, and limited to the extent set forth in these Terms and Conditions.\n    The User shall abstain from any act that may affect the normal functioning of BEATHEY and/or that in any way affects or alters the provision of the Service, as well as from evading or interfering with all measures to protect the Service and the contents of BEATHEY. BEATHEY shall not be liable for the User's conduct affecting third parties.\n\n    "),_c('h3',[_vm._v("Contents. The Works. Quality")]),_vm._v("\n    BEATHEY may modify the mode of access to the Works available at BEATHEY at any time and at its sole discretion.\n    The technical and image quality of the Works will be that available (in the state they are in), which may vary depending on the access devices, technological transfer capacity, location, etc. and other issues for which BEATHEY will not be responsible.\n\n    "),_c('h3',[_vm._v("Upgrades")]),_vm._v("\n    By subscribing to BEATHEY as a software product, application or browser plug-in, the User agrees that BEATHEY may periodically download and install any enhancements, updates, reduce applications and additional features in order to improve and develop the service.\n\n    "),_c('h3',[_vm._v("Intellectual Property Rights")]),_vm._v("\n    BEATHEY owns or has the rights to make the Works available through BEATHEY and to the extent set out in these Terms and Conditions.\n    All the Works and contents that form part of BEATHEY, as well as the software, logos, icons, audiologists and other artistic and creative aspects of BEATHEY are protected by Copyright, Intellectual and Industrial Property and/or Copyright.\n    BEATHEY is a trademark protected by Intellectual Property under the Law of the Republic of Argentina and the International Treaties that the Republic of Argentina has signed on the subject.\n    The use of BEATHEY does not grant any intellectual property right whatsoever over our services or content accessed.\n    The User may not use our content, our trademarks or any marks resembling ours, except with the prior written consent of BEATHEY.\n    BEATHEY software applications are licensed to you, not sold to you, and BEATHEY retains ownership of all copies of the software applications, even after they have been installed on your computers.\n    BEATHEY may remove any content that it considers to infringe the rights of third parties, including but not limited to intellectual and industrial property rights, the dignity and/or personal rights of persons, such as honour, name and image, nor may it be considered discriminatory and/or encourage violence or affect morals and/or good customs.\n\n    "),_c('h3',[_vm._v("Complaint of Infraction")]),_vm._v("\n    BEATHEY does not assume and cannot assume any duty or obligation to control the adequacy of the Works to the legal system and rights of third parties.\n    Any person (hereinafter, the \"Complainant\") may report that a User infringes the legal system and/or infringes the rights of third parties, including but not limited to personal rights and intellectual and industrial property.\n    Upon receipt of a complaint, BEATHEY may automatically suspend the User who is the subject of the complaint, without analysis of any kind and without the need for any notification. At the same time as receiving the complaint, BEATHEY will inform the User of the existence and content of the complaint.\n    BEATHEY assumes no responsibility whatsoever and assumes no obligation to act in any way in order to decide whether or not the complaint is justified. Any unlawful and/or abusive conduct of the Whistleblower shall be the sole responsibility of the Whistleblower and any unlawful and/or abusive conduct of the User shall be the sole responsibility of the User, without BEATHEY being liable under any circumstances whatsoever.\n    The Complainant and the Users expressly and irrevocably accept the Content Complaint Mechanism established in the different paragraphs of this point. In particular, Users may not make any kind of claim for any reason related to the suspension and/or definitive elimination of the User and/or the disqualification from the Contest.\n    Without prejudice to the procedure established in the Content Complaint Mechanism, BEATHEY reserves the right to decide at its sole discretion, at any time, the suspension and/or removal of Users, and even the disqualification of Users from the Contest, all of this automatically and without the need for any notification whatsoever, when in its opinion there is a violation of the legal system, the rights of third parties and/or the conditions. The Users irrevocably and unconditionally accept that their Contents are removed at BEATHEY's sole discretion, so they will not have to claim anything from BEATHEY in the event that such removal is decided by BEATHEY.\n\n    "),_c('h3',[_vm._v("Personal Information")]),_vm._v("\n    BEATHEY adopts physical and computer security measures with respect to the databases containing the Personal Data. Notwithstanding the foregoing, BEATHEY does not guarantee Users against the unlawful use of Personal Data that may be made by third parties. Consequently, BEATHEY does not guarantee or assume any responsibility for damages, including but not limited to direct or indirect, immediate, consequential, moral or patrimonial damage, consequential, emergent damage, loss of profits and/or loss of chance, that may result from the alteration, loss, treatment, unauthorized access or illicit use of the Personal Data by third parties.\n    The Users will be responsible for the damages that BEATHEY, its controlled or controlling companies, directors, employees and/or third parties may suffer as a consequence of the lack of veracity, inaccuracy, lack of validity and authenticity of the Personal Data.\n    The Users undertake to hold BEATHEY, its controlled or controlling companies, directors and employees harmless from any and all claims, losses, expenses and/or damages of any kind, including but not limited to direct or indirect, immediate, consequential, moral or patrimonial damages, consequential or emergent damages, lost profits and/or loss of chance, derived from the conduct and/or activity of the Users in violation of the legal system, the rights of third parties and/or the conditions, and/or which are legally attributable to the Users.\n    BEATHEY may use cookies in connection with the Site. Cookies are a tool used by Web servers to store and retrieve information about their visitors. Cookies may eventually be installed on the User's computer when browsing the Site. The cookies used by BEATHEY are only associated with an anonymous User and his/her computer and do not provide references that allow the User's name and surname to be deduced and cannot take data from his/her hard disk. Users are free to decide whether or not to place the cookies used by BEATHEY on their hard drive by configuring their browser accordingly.\n    The National Directorate for the Protection of Personal Data, the Control Body of Law No. 25,326, has the power to deal with complaints and claims filed in relation to non-compliance with the rules on the protection of personal data.\n\n    "),_c('h3',[_vm._v("Information")]),_vm._v("\n    BEATHEY may collect information regarding the use of BEATHEY and the User's access to the different contents. This information includes the Works to which access has been given, the access history, searches carried out, technical aspects of connectivity (devices, type of connection, etc.), and any other information relating to access and/or use of the service.\n    BEATHEY undertakes to make private use of this information and not to market or transfer it to third parties, as well as to comply with current legislation on the subject.\n    BEATHEY will use and analyse this information in order to manage, improve and optimise BEATHEY and the provision of the service, keep statistical records of access and content modalities, payments, etc.\n\n    "),_c('h3',[_vm._v("How BEATHEY works")]),_vm._v("\n    BEATHEY does not guarantee in any way the inviolability of its systems and/or the Site or the availability and/or continuity of the Site's operation and excludes any liability for damages of any kind that may be due to the lack of availability or continuity of the Site's operation.\n\n    "),_c('h3',[_vm._v("Validity")]),_vm._v("\n    The partial invalidity of one or more provisions of these Terms and Conditions shall not affect their validity and enforceability. In such a case, the invalid provision shall be understood to be unwritten, without affecting the validity of the remainder.\n\n    "),_c('h3',[_vm._v("Jurisdiction and Competence")]),_vm._v("\n    These Terms and Conditions are agreed with BEATHEY, with registered office at Soler 4227 1M, of the Autonomous City of Buenos Aires, Argentina, and shall be governed by and construed in accordance with the laws of the Argentine Republic.\n    The interpretation of these Terms and Conditions, claims of breach thereof and all other claims (including claims for consumer protection, unfair competition and tort liability), and all disputes arising out of or relating to the Terms and Conditions, regardless of conflicts of law principles, and any matter arising out of or in connection with them shall be subject to the jurisdiction of the ordinary courts of the Civil Courts of the Nation, waiving any other forum of exception.\n\n    BEATHEY is a company of Music Dreams S.R.L., CUIT 30-71538505-4, with address at Soler 4227 1M, Autonomous City of Buenos Aires, Argentina.\n\n  ")],1)])}
var staticRenderFns = []


/***/ }),
/* 937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsSubsEn_vue__ = __webpack_require__(421);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10a23add_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsSubsEn_vue__ = __webpack_require__(939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(938)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-10a23add"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsSubsEn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10a23add_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsSubsEn_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10a23add_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsSubsEn_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 938 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"terms flex justify-center"},[_c('div',{staticClass:"mw7"},[_c('button',{staticClass:"backButton"},[_c('router-link',{staticClass:"rlink",attrs:{"to":{name:'home'}}},[_vm._v("Volver")])],1),_vm._v(" "),_vm._m(0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mainContentTyCandPolicy"},[_c('h1',{staticClass:"mainTitleTyCandPolicy"},[_vm._v("BEATHEY Terms of Use")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("\n              Please read these Terms of Use (\"Agreement\" or \"Terms of Use\") before using the services offered by BEATHEY (\"BeatHey\", \"Company\", \"We\", \"Us\" or \"Our\"). This Agreement sets out the legally binding terms and conditions for the use of the www.BeatHey.com website (the \"Site\") and the service owned and operated by BeatHey, including the mobile software applications offered or published by BeatHey (in conjunction with the Site, the \"Service\"). By using the Site or Service in any manner, including but not limited to visiting or browsing the Site or Service, you agree to be bound by these Terms of Use. These Terms of Use apply to all users of the Site or Service, including users who are also contributors of content, information and other materials or services on the Site.\n            ")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Acceptance of terms")]),_vm._v(" "),_c('p',[_vm._v("\n            The Service is offered subject to acceptance without exception of all terms and conditions contained herein (the \"Terms of Use\"), which also incorporate the privacy policy available at https://beathey.com/privacy-policy/en, and all other operating rules, policies and procedures that may be posted on the Site by the Company, each of which is incorporated by reference into these Terms of Use and each of which may be updated by the Company from time to time without notice. In addition, some services offered through the Service may be subject to additional terms and conditions posted by BeatHey where provided; use of such services is subject to additional terms and conditions, which are incorporated into these Terms of Use by this reference. \n            If you are using or wish to open an account in the name of a company, entity or organization (including, but not limited to, a record label) (each an \"Artist Entity\"), then you represent and warrant that: (i) is duly authorized by the Entity Artist and/or by any artist represented by such Entity Artist (a \"Represented Artist\") with the authority to bind such Entity Artist or Represented Artist to these Terms of Use and (ii) agrees that it will be bound by these Terms of Use for the use of the name of such Entity Artist and/or Represented Artist. \n            The Service is available only to persons who are at least 13 years of age. You represent and warrant that if you are an individual, then you are of legal age to enter into a binding agreement, and that all information submitted for your registration is accurate and truthful. BeatHey may, in its sole discretion, refuse to offer the Service to any person or entity and may change its eligibility criteria at any time. This provision is void where prohibited by law and the right to access the service is revoked in such jurisdictions.\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Modification of the Conditions of Use.")]),_vm._v(" "),_c('p',[_vm._v("\n            BeatHey reserves the right, in its sole discretion, to modify or replace any of the terms of these Terms of Use, or to change, suspend or discontinue the Service (including, without limitation, the availability of any features, database or content) at any time by posting on the Site or by sending an email. BeatHey may also impose limits on certain services or restrict access to the entire Service without notice or liability. It is your responsibility to review these Terms of Use periodically. Your continued use of the Service following the posting of any changes to these Terms of Use constitutes your acceptance of those changes.\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Rules and Conduct.")]),_vm._v(" "),_c('p',[_vm._v("\n            As a condition of use, you agree not to use the Service for any purpose that is prohibited by these Terms of Use. The Service (including, without limitation, any Content as defined below) is provided solely for your personal, non-commercial use (except in respect of individual artists, Artists' Entities or Performers, each of whom is a \"performer\") for the sale of music, merchandising or other content (each of which is defined below) as authorized by the Service. You are responsible for all of your actions in connection with the Service. For the purposes of these Terms of Use, the term \"Content\" includes, without limitation, any User Submissions, videos, audio clips, written comments on the Forum, information, data, text, photographs, software, scripts, graphics, accessible through the Service. \n            By way of example, and not as a limitation, you may not (a) take any action or (b) upload, download, post, post, send, distribute or facilitate the distribution of any content through the Service, including without limitation any User Submissions, which: \n                • infringes any patent, trademark, trade secret, copyright, right of publicity or other right of any other person or entity, or violates any law or contractual duty; \n                • you know it is false, misleading, false or inaccurate; \n                • is unlawful, threatening, abusive, harassing, defamatory, libelous, deceptive, fraudulent, invasive of privacy, offensive, obscene, profane, or profane; \n                • constitutes unauthorized or unsolicited, unsolicited, or unsolicited advertising or e-mail (\"spamming\"); \n                • involves commercial activities and/or sales without the prior written consent of the company, such as contests, sweepstakes, redemptions, advertising or pyramid schemes; \n                • exploits people in a sexual or violent way; \n                • contains software viruses or any other computer code, files or programs that are designed or intended to interrupt, damage, limit or interfere with the proper working of any software, hardware or telecommunications equipment or to damage or gain unauthorized access to any system, data, password or other information of the Company or any third party; or \n                • go through any person or entity, including any employee or representative of the Company. \n\n            Besides, you shouldn't: (i) take any action that imposes or may impose (as determined by BeatHey in its sole discretion) an unreasonable or disproportionately large burden on the infrastructure of the Company (or its third party providers); (ii) interfere or attempt to interfere with the proper working of the Service or any activity performed on the Service; (iii) terminate the measures that BeatHey may use to prevent or restrict access to the Service (or other accounts, computer systems or networks connected to the Service); (iv) run maillist, Listserv, any form of auto-reply or \"spam\" on the Service; or (v) use manual or automatic software, devices, or other processes to \"crawl\" or \"spider\" any page of the Site. \n            You shall not (directly or indirectly): (i) decipher, decompile, disassemble, reverse engineer, or attempt to derive the source code or underlying ideas or algorithms from any part of the Service, except to the extent that applicable law specifically prohibits such restriction, (ii) modify, translate or create derivative works from any part of the Service, or (iii) copy, rent, lease, distribute or transfer any of the rights you receive hereunder. You must comply with all state, local, national and international laws and regulations. \n            BeatHey reserves the right to investigate and take appropriate legal action against any person who, in the sole discretion of the Company, violates this provision, including, without limitation, terminating your account and/or transmitting such activity or content to law enforcement authorities.\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Use of Content")]),_vm._v(" "),_c('p',[_vm._v("\n            In addition to the foregoing general restrictions, the following restrictions and conditions shall apply specifically to the use of the Content. \n                A. The Content on the Service, the trademarks, service marks, service marks and logos (the \"Marks\") contained on the Service are owned by or licensed to BeatHey, subject to copyright and other intellectual property rights under the law. \n                B. Content is provided in THE STATE IN WHICH IT IS. You may access the Content for your information and personal use only as intended through the features provided on the Service and as permitted under these Terms of Use. You will not download any Content unless you see a \"download\" or similar link displayed by BeatHey on the Service for that Content. You may not copy, reproduce, distribute, transfer, transmit, display, sell, license or otherwise exploit any Content for any purpose whatsoever without the permission of BeatHey or its licensors. It will be considered authorized to do so if the copying, reproduction, distribution, transmission, exhibition, sale, license or exploitation is carried out through this platform in accordance with the Terms of Use. BeatHey and its licensors reserve all rights not expressly granted in and to the Service and Content. \n                C. You agree not to circumvent, disable or otherwise interfere with the security features of the Service or the features that prevent or restrict the use or copying of any Content or that establish limitations on your use of the Service or the Content thereof. \n                D. You understand that by using the Service you are exposing yourself to Content from a variety of sources and that BeatHey is not responsible for the accuracy, usefulness, security or intellectual property rights in or relating to such Content. You further understand and agree that you may be exposed to Content that may be inaccurate, offensive, indecent or objectionable and you agree to waive and hereby waive any right or legal defense, whether in cash or in any other form you have or may have against BeatHey in this respect and, to the fullest extent permitted by applicable law, you agree to indemnify and hold BeatHey, its owners, operators, affiliates, licensors and licensees, harmless from any and claims under applicable law in all matters relating to your use of the Service.\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Personal Information - Amateurs")]),_vm._v(" "),_c('p',[_vm._v("\n            As a condition of using certain features of the Service (including, without limitation, the free download feature, or making a purchase from the company or an artist), you may be required to provide certain personal information to BeatHey, such as your email address, country of residence and zip/zip code (\"Amateur Information\"). \n            You may register with BeatHey as an amateur and create a user account (\"Amateur Account\"), which will allow you to access certain features of the Service that are only available through amateur accounts, such as an amateur profile page, a list of the history of music purchases along with information you choose to share about yourself, and the ability to track other amateurs or artists. Tracking an artist or purchasing an artist subscription (an \"artist subscription\") gives the artist access to your email address. Your history of music purchases, and any information you provide to your profile page will be available to other users of the service by default, subject to our privacy policy. \n            As a condition of the artists' right to receive information from the fan, BeatHey requires that each artist agree to the terms set forth in the following section of this Agreement. However, you acknowledge that BeatHey has no control over the use of fan information by artists, and you acknowledge and agree that BeatHey shall not be liable or responsible, directly or indirectly, for any damage or loss caused or alleged to be caused by or in connection with the use of such information by artists.\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Personal Information - Artists")]),_vm._v(" "),_c('p',[_vm._v("\n            In connection with certain features of the Service, including requiring fans to provide their e-mail addresses and other personal information in order to access the download option, certain types of information may be collected from the fan. As a condition of receiving such fan information, you acknowledge and agree that you will not disclose or sell any fan information to any third party, and that you will use the fan information only in connection with the artist's mailing list or artist subscription, in order to provide fans with general information and news about the artist, such as upcoming shows, new music or other content offered in connection with your artist subscription. You further agree that any email or other communication sent to the artist's mailing list or sent in connection with the artist's subscription will comply with the laws of email marketing and include a mechanism by which the recipient may opt-out of the mailing list, along with clear instructions on how to do so (i.e., an \"opt-out\" mechanism).\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Account registration")]),_vm._v(" "),_c('p',[_vm._v("\n            In order to use some of the services on the Site, you must register and provide certain information (for example, a valid username, password, billing information and email address) for BeatHey (\"Registration Data\") in order to create an account (your \"account\"). You agree to provide current, complete and accurate Registration Data at the time of registration and you will update your registration data as necessary to keep it current, complete and accurate. BeatHey may terminate your account and any or all rights to the website if the information you provide is inaccurate, false, incomplete, or, if BeatHey, in its sole discretion, suspects that fraudulent and/or illegal behavior, such as, but not limited to, identifying theft, stolen credit cards or artificial purchases to inflate sales data, associated with your registration. You agree that BeatHey may store and use the Registration Data that you provide with that of the billing service to your credit card and the maintenance of your account. You are solely responsible for maintaining the confidentiality and security of your account. You agree to notify BeatHey immediately of any unauthorized use of your password and/or account. BeatHey shall not be liable for any loss arising from any unauthorized use of your registration or account data, and you agree to indemnify and hold harmless BeatHey, its partners, parent companies, subsidiaries, agents, affiliates and/or licensors, as the case may be, for any inappropriate, unauthorized or illegal use of your account. You should not attempt to gain unauthorized access to the Site. If you attempt to do so, assist others in such attempts, or distribute instructions, software or tools for such purpose, BeatHey shall have the right to terminate your account and take all legal action available at law. You agree to notify BeatHey immediately of any unauthorized use of your password and/or account. BeatHey shall not be liable for any loss arising from any unauthorized use of your registration or account data, and you agree to indemnify and hold harmless BeatHey, its partners, parent companies, subsidiaries, agents, affiliates and/or licensors, as the case may be, for any inappropriate, unauthorized or illegal use of your account.\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("System requirements for use")]),_vm._v(" "),_c('p',[_vm._v("\n            You are responsible for the use of any hardware, systems and/or software program(s) and for any fees and expenses incurred in (a) connecting to, browsing or using the Internet, and/or (b) accessing the Website, and/or (c) searching, listening to, downloading, uploading, reproducing, or transferring the Digital Content. At some point, you may need to install software, which will be available through the Web, to help with the accessibility of the content. However, the purchase or acquisition of any other product shall not be construed as representing or warranting access to Digital Content. If you need information about the specifications of any equipment, Internet access or software in order to use the services provided by the Website, please contact the customer support team. You may not attempt to, or support any attempt by any third party to, decrypt, reverse engineer, circumvent or alter or interfere with any software necessary for the use of the Website or Digital Content. If you access the Web via your mobile phone or an Android or iOS application, a data surcharge will apply.\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Membership - Charges")]),_vm._v(" "),_c('p',[_vm._v("\n            In certain circumstances the use of the Service in the Site will not be free of charge. Consequently, BEATHEY will be able to charge a monthly sum expressed in U.S. dollars as Membership to all those who use the Service, either as amateurs and/or as artists and/or in any other way, by registering an Account for this purpose. BEATHEY may modify the value of the Membership at its discretion, without prior notice. In the event that the means of payment used by the user involves invoicing in pesos, it will be calculated at the selling rate of the dollar of the Central Bank of the Argentine Republic on the day prior to the transaction date.\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Charges and payments - The fans")]),_vm._v(" "),_c('p',[_vm._v("\n            You may purchase products and/or services from an artist through the Site, including, without limitation, purchases of content (including digital content available through download and streaming through the Service (\"Digital Content\"), and physical merchandise (\"Merchandising\"). Each such purchase is considered a'transaction'. \n            To that end, you may, at your option, acquire Digital Content by choosing the value you wish to pay for the download of such Digital Content, taking into account the values published in Argentine Pesos. The values are expressed in US dollars. In the event that the means of payment used by the user involves invoicing in pesos, it will be calculated at the selling rate of the dollar of the Central Bank of the Argentine Republic on the day prior to the transaction date. \n            All inquiries regarding Merchandising transactions will be directed to the relevant artist. BeatHey is not responsible for refunds for merchandising, except as provided in this Agreement. \n            All sales of digital content are final (except where prohibited by law), unless otherwise determined by BeatHey. If you do not receive the digital content or have a problem with the delivered digital content, you should contact BeatHey with your request and proof of payment, and BeatHey will notify the relevant artist to resolve your problem. At BeatHey's sole discretion, you may be refunded or credited to an account for the purchase of Digital Content. However, you understand and agree that BeatHey is a platform that artists use to sell their products, and digital content is derived from files provided by the relevant artist, and the relevant artist is solely responsible for such files. \n            The total price of the digital content will include the price of the product plus any applicable sales taxes at the time of purchase. Tax will be charged only in states or countries where digital goods are taxable. \n            BeatHey cannot guarantee that the Content you purchase in a transaction will be available in perpetuity. For example, if you or your agent receive a notice of copyright infringement with respect to specific content, and a judicial authority orders the removal of such Content from the Service, not allowing it to be available for future sale or denying continued access to anyone who previously purchased such content. This means that you may lose access to content previously purchased through the Service. \n            In the event that we are required by law not to allow access through the Service to previously acquired content, including by removing access to content from an amateur's personal collection through any mobile application, BeatHey and the artists will not provide a refund to the amateur who purchased that content, except where required by applicable law. Users assume the entire risk for the prohibition of access to any content purchased through the Service. \n            Because we may be required to deny you access to previously acquired content, we recommend that you promptly download to your own devices any content you purchase through the Site to maintain control and possession of such content, even if it is necessary to remove the content from the Service. \n            You warrant that if a transaction is made, then you will be able to make full and immediate payment for the products or services ordered.\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Charges and payments - artists")]),_vm._v(" "),_c('p',[_vm._v("\n            BeatHey shall have sole authority to fix the prices of Digital Content and services charged by means of transactions (the \"prices\") through the Site, and BeatHey shall have sole authority to change the prices where so provided. BeatHey can redistribute copies previously purchased by fans, in case the product is damaged, whether it is a version of the incorrect file format of your product, an incomplete copy of your product, without charge to the fan. Such redistribution can be done by allowing an amateur to re-download a replacement of the previously downloaded. \n            You shall be solely responsible, and BeatHey shall have no liability for any PayPal fees (except for fees charged to BeatHey's PayPal account), credit card transaction fees (collectively, \"Fees\"), late payment fees (such as credit card statements or fraud), disputed payments, and refunds, except as provided in this Agreement. \n            BeatHey may withhold any taxes, duties, charges and/or liens on payments made by the fan that are required by applicable law, rule or regulation. BeatHey shall remit such taxes, duties, charges or levies to the appropriate legal authority. \n            BeatHey and/or its licensors and/or assigns, may make payments to the Artists calculated based on the number of streaming reproductions that each User or Fan makes of the Digital Content (audio clips) of the Artists. For these purposes, content that exceeds forty-five seconds in total duration shall be considered as content suitable for recording reproductions. The reproduction will be counted, randomly, at any time between that value and the total duration of the work. Likewise, all those reproductions made by the Artists of their own Digital Content will not be computed. The price for each reproduction, including the method of calculation, percentages, application, etc., shall be determined by BeatHey and may vary over time at BeatHey's sole discretion. \n            For Digital Content, BeatHey will collect the purchase or streaming price, fees and applicable taxes. \n            BeatHey will pay the Artist on a bimonthly basis the total verified revenue due to the Artist, less taxes and/or other charges if applicable (the \"Artist Payment\").\n            The Artist's payment may be made through the payment platform that BeatHey deems appropriate, which may be located anywhere in the world. The Artist shall comply with the requirements of the payment platform for the collection procedure, as well as those required by the Artist's country of residence for the collection of amounts deposited abroad, as the case may be. The Artist accepts that, due to his/her country of residence, the local authority may debit charges, fees, taxes, etc., on the amount to be collected by the Artist.\n            When you receive a payment for digital content or merchandising, you are responsible for the full amount of the payment plus fees if the payment is later invalidated for any reason. If there are insufficient funds to cover your liability, you agree to reimburse BeatHey by other means. \n            BeatHey has the right, but not the obligation, to immediately suspend the offer or sale of any product or service, to prevent or restrict access to the Site or the Services or to take any other action in the event of technical problems, objectionable material, inaccuracy in advertisements or actions prohibited by the procedures and guidelines contained in the Site, or for any other reason in BeatHey's sole and absolute discretion, and to correct any inaccurate information or technical problems on the Site. BeatHey may immediately suspend the offer or sale of any product or service if it receives notifications of violations, becomes aware of any violation, or of facts or circumstances that make the violation apparent with respect to any product or service.\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Additional fees")]),_vm._v(" "),_c('p',[_vm._v("\n            In addition to the fees set forth above, BeatHey reserves the right to require payment of fees for certain additional functions of the Service, which may be established in the future. BeatHey reserves the right to modify its price list and to establish new charges at any time, with ten (10) days notice, which may be sent by email or posted on the Site. Your use of the Service after such notice constitutes your acceptance of all new or increased charges.\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Billing")]),_vm._v(" "),_c('p',[_vm._v("\n            BeatHey currently accepts different payment platforms, such as Paypal and/or Mercado Pago. BeatHey does not accept cash, money orders, or checks. BeatHey reserves the right to change this policy at any time. You agree to pay all charges associated with your purchase(s) (including any applicable taxes), at the rates in effect when the charges were made. You, not BeatHey, are responsible for all amounts billed to your credit card by unauthorized third parties. As the cardholder, the agreement with the card issuer governs the use of the designated card, and as such, reference should be made to that agreement to determine your rights and responsibilities as the cardholder. The obligation to pay for purchases previously accepted by BeatHey will survive your termination of your account. Due to the nature of the service, refunds are available only in exceptional circumstances at the sole discretion of BeatHey. \n            You are responsible for providing BeatHey with a valid credit card and timely payment of all charges. At its discretion, BeatHey may apply charges individually or add charges to other purchases you make on the Website. You are responsible for updating the information in the appropriate section of your account. You are responsible for any charges to your account incurred through a third party, regardless of whether or not you authorized such a purchase. You are solely responsible for keeping your account secure and confidential. BeatHey may, in its sole discretion, modify, suspend or discontinue the Website (or any part or content thereof) at any time with or without notice, and BeatHey shall not be liable to you or any third party for any such exercise of such rights.\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Third Party Site")]),_vm._v(" "),_c('p',[_vm._v("\n            The Service may allow you to link to other websites or resources on the Internet, and other websites or resources may link to the Site. When you access third party websites, you do so at your own risk. These other websites are not under the control of BeatHey, and you acknowledge that BeatHey is not responsible for the content, functions, accuracy, legality, suitability or any other aspect of such websites or resources. The inclusion of any link does not imply endorsement by BeatHey or any association with its operators. Further, you acknowledge and agree that BeatHey shall not be liable or responsible, directly or indirectly, for any damage or loss caused or alleged to be caused by connection, use or reliance on any such Content, goods or services available on or through any other site or resource.\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("The content and the license")]),_vm._v(" "),_c('p',[_vm._v("\n            You agree that the Service contains content specifically provided by BeatHey or its partners and that such content is protected by copyright, trademarks, service marks, patents, trade secrets, etc. You must respect and maintain all copyright notices, information and restrictions contained in any Content accessed through the Service. \n            BeatHey grants each user of the Site and/or the Service a non-exclusive, non-sublicensable, non-transferable, worldwide license to use, modify and reproduce the content, solely for personal, non-commercial use. The use, reproduction, modification, distribution or storage of any content other than for personal use is expressly prohibited without the prior written permission of BeatHey or the copyright holder identified in the copyright notice for such content. You may not sell, license, rent, or otherwise use or exploit any Content for commercial use or in any manner that violates any third party rights. \n            You may not reverse engineer, decompile, disassemble, disassemble, modify or disable any copy protection or use any limitation systems associated with Digital Content downloads. The user may not reproduce and then re-digitize any Digital Content. You may not create any \"derivative works\" by altering any of the contents, except as permitted herein. You may not use the Digital Content in conjunction with any other third party content (for example, to provide sound for a movie) unless you obtain such rights from the copyright owner. Peer-2-peer file sharing is strictly prohibited. Any other type of network file sharing and transfer of Digital Content for such purpose is expressly prohibited and is a violation of international copyright laws.\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Intellectual Property Rights - artists")]),_vm._v(" "),_c('p',[_vm._v("\n            The service offers artists the ability to upload digital content owned or controlled by them to the Site, including but not limited to sound recordings (\"Sound Recordings\"), videos synchronized with sound recordings and other audiovisual works (collectively, \"Music Videos\"), and musical works embedded in sound recordings and music videos (\"Music Works\", in conjunction with sound recordings and music videos, by the artist \"Music\"). BeatHey shall have no ownership rights in an artist's Digital Content, however, BeatHey requires the following license to perform the service. Each artist who uploads Digital Content to the Service grants BeatHey and its licensors, authorized distributors, the worldwide, non-exclusive, third party, royalty-free, royalty-free license to: (i) reproduce, distribute, publicly perform (including by means of digital audio transmission), publicly display, create derivative works, communicate to the public, synchronize and otherwise exploit (collectively, \"exploit\") (1) the Music of the Artist and perform the Service on behalf of the Artist (e.g., reproduce, transmit, copy and store the Artist's music on servers owned and/or operated by and/or on behalf of BeatHey or its authorized licensees and distributors, and publicly perform, transmit, synchronize, distribute, and reproduce the artist's music) using any technologies or methodologies now known or developed in the future, and (2) Exploit all works, including, without limitation, song lyrics and musical notations, album cover artwork, photographs, graphics, and descriptive text (\"Works\") in connection with the Service; (II) allow users of the Service to receive performances and public display of the artist's music and works of art and to reproduce the artist's music and works of art on any and all devices owned or controlled by the user for non-commercial purposes and to receive performances and exhibitions thereof; and (iii) reproduce, use and publish, and to permit others to reproduce, use and publish, the name, trademarks, and personal and biographical materials of the artist in connection with the provision of the Service; (iv) use, distribute, reproduce, copy and display their trademarks, service marks, slogans, logos or similar proprietary rights (collectively, the \"Trademarks\") solely in connection with the Service or in the marketing, promotion or advertising of the Services, including in all forms of marketing, promotion, and advertising materials now or hereafter created. \n            By uploading Digital Content (music or works) to the Site: \n                • You represent and warrant, and may demonstrate to BeatHey's satisfaction or request, that (i) you own or otherwise control all of the rights to your music and works of art (or that the music and works of art are in the public domain or otherwise would have been licensed to the licensed artist in writing with a grant of sufficient rights to enable the artist to comply with this Agreement and to grant all rights with respect to the artist's music or works of art as set forth in this Agreement (\"Direct License\"); (ii) has full authority to act on behalf of any and all owners of any right, title or interest and for any music or work uploaded to the Service; (iii) you have permission to use the name and image of each individual whose name or image is included or used within the music and/or artwork, and to use such individual identification or personal information (to the extent that such information is used or contained in the music and/or artwork) as provided in these Terms of Use, and (iv) you are authorized to grant all of the above rights to the music and/or artwork to BeatHey and all users of the service. \n\n                • you represent and warrant that the use or other exploitation of your music and/or artwork by BeatHey and its licensors and authorized distributors and/or by users of the site as provided for in this Agreement does not infringe or violate the rights of any third party, including, without limitation, any rights of privacy, publicity rights, copyright, contractual rights or any other intellectual property or proprietary rights. \n\n\n                • you represent and warrant that, to the extent that you are the composer of any or all of the musical works incorporated into your sound recordings or music videos, either in whole or in part (for example, as a co-author), you have the full right, power and authority to grant the rights set forth in this Agreement notwithstanding the provisions of any agreement you may have entered into with any performance rights organization (\"ODE\"), whether based in the Argentine Republic (for example, SADAIC), AADI CAPIF ACR), the United States (e.g. ASCAP, BMI or SESAC) or elsewhere, or any music publisher, and that it is solely responsible for taking all necessary steps to inform such EDOs of its granting of a royalty-free license to BeatHey for the communication and public reproduction of its music and works, and that there are no outstanding fees or payments of any kind to such EDOs for the public performance or communication to the public of its musical works. \n\n                • you represent and warrant that you do not owe any fees or remuneration of any kind to any third party, including, but not limited to, any trade union, association, musician, engineer or producer, for the use or re-use of the Music as authorized under this Agreement.\n            "),_c('strong',[_vm._v("\n              If any agreement you have entered into with any third party, including, but not limited to an ODE, music publisher, union or guild, whether by law or contract, prohibits you from granting BeatHey the right and license set forth in this Agreement and from exercising the representation and warranties set forth in the immediately preceding four paragraphs, then you are prohibited from uploading your music to the Service and shall be responsible for indemnifying and holding BeatHey harmless against any and all claims arising from the exploitation of your music on the Service, including all costs and legal fees.\n            ")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Intellectual Property Rights - Amateurs")]),_vm._v(" "),_c('p',[_vm._v("\n            The service provides users with the ability to add, create, upload, post, upload, post, send, distribute or distribute (\"Submit\") digital content, videos (including music videos), audio clips (including music), forum posts, data, text, photographs, software, scripts, graphics or other information to the site (collectively, \"User Submissions\"). By Submitting on the Site or otherwise through the Service, you: \n                • You acknowledge that by submitting any User File you can be publicly identified by your User ID in association with any User File; \n\n                • By submitting any User Submissions through the Site or the Service, you grant BeatHey a worldwide, non-exclusive, perpetual, irrevocable, fully paid, sublicensable, royalty-free, fully transferable, royalty-free license to use, edit, modify, reproduce, distribute, prepare derivative works from, publicly display, publicly perform (including by means of a digital audio transmission), communicate to the public, synchronize and fully exploit your submissions in connection with the Site, the service business and BeatHey (and its successors and assigns), including without limitation, the promotion and redistribution of part or all of the Site (and any derivative works thereof) or the Service in any form through any communication channel (including, without limitation, third party websites), known or later developed. For the sake of clarity, the granting of a license to BeatHey does not affect the user's other rights of ownership or license, including the right to grant additional licenses for the material submitted by the user, unless otherwise agreed in writing; \n\n                • You represent and warrant, and it can be demonstrated to BeatHey's full satisfaction and request that (i) you own or control all rights in all of the content of your User Submissions, or that the content of such User Submissions is in the public domain or directly licensed, (ii) you have full authority to act on behalf of any or all of the owners of any rights, title or interest in and to any content in your User Submissions to use such content as contemplated in these Terms of Use and the granting of the license rights set forth above, (iii) you have permission to use the name and likeness of each individually identifiable person and to use such individual identification or personal information as contemplated in these Terms of Use; and (iv) is authorized to grant all of the above rights to User Submissions to Company and all users of the Service; \n\n\n                • You agree to pay all royalties and other amounts due to any person or entity, including any IPO, upon submission of any User Submissions to the Service; \n\n                • That the use or other exploitation of such User Submissions by BeatHey and the use or other exploitation of the Site and Services by users as provided for in this Agreement does not infringe or violate the rights of any third party, including without limitation any rights of privacy, publicity rights, copyright, contractual or other intellectual property or proprietary rights; and \n\n\n                • You understand that BeatHey shall have the right to delete, edit, modify, reformat, translate any material, content or information submitted by you; and that all information publicly or privately through the Site is the sole responsibility of the person who originated such content and that BeatHey shall not be liable for any errors or omissions in any content; and that BeatHey cannot guarantee the identity of other users with whom it may interact in the course of using the Service. \n            BeatHey does not endorse and has no control over any User Submissions. BeatHey cannot guarantee the authenticity of the data that users can give of themselves. You acknowledge that all Content accessed through the use of the Service is at your own risk and you shall be solely responsible for any damage or loss of any party resulting therefrom.\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Termination")]),_vm._v(" "),_c('p',[_vm._v("\n            BeatHey may terminate your access to all or part of the Service at any time, with or without cause, with or without notice, with immediate effect, which may result in the loss and destruction of all information associated with your membership, including, without limitation, any access to any music you may have purchased through the Service. The terms and conditions will continue to apply until terminated by you or BeatHey. However, you acknowledge and agree that the indefinite license granted to you in connection with the User Content, including any comments, is irrevocable and shall survive the expiration or termination of the Service for any reason whatsoever. If you or BeatHey terminate the Service, or if BeatHey suspends your access to the Service, you agree that BeatHey shall not be liable to you and shall not be liable for any amounts already paid, to the extent permitted by applicable law. This section shall be implemented to the extent permitted by applicable law. You may terminate the Service at any time.\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Disclaimer of Warranty Liability")]),_vm._v(" "),_c('p',[_vm._v("\n            You agree that your use of the Services shall be at your own risk to the extent permitted by applicable law, and BeatHey, its officers, directors, employees, representatives and agents are released from any liability under any warranty, express or implied, in connection with the Services and your use of the Services. BeatHey does not warrant or make any representations about the accuracy or truth of the content of the website or the content of any website linked to this website and assumes no civil or criminal liability for any (i) error, inconsistency or inaccuracy of the content, (ii) personal injury or property damage of any kind resulting from your access to and use of the services, (iii) unauthorized access to or use of our restricted servers or any personal or financial information stored on such servers, (iv) interruption or termination of transmission to or from our services, (v) any defects, bugs, viruses, trojan horses or the like that may be transmitted by or through our services by any third party, or (vi) any errors or omissions in any content or for any damages or losses of any kind resulting from the use of any content posted, sent via e-mail, transmitted or otherwise made available to you through the Services. BeatHey does not warrant, sponsor or assume any responsibility for any Digital Content or service promoted or offered by any third party through the services or any service connected by a hyperlink or promoted in any advertisement or other advertising. BeatHey will not be party to or in any way responsible for controlling any transactions between you and a third party provider of products or services such as in any acquisition of Digital Content or Merchandising or services through any means, you should use your best judgment and take such precautions as may be appropriate. \n            BeatHey does not guarantee the confidentiality or privacy of any communication or information posted on the Site or any website linked to the Site. BeatHey shall not be responsible for the privacy of e-mail addresses, registration and identification information, disk space, communications, confidential or trade secret information, or any other content stored on the Company's computer that is transmitted over networks accessing the Site, or otherwise connected with your use of the Service.\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Indemnification")]),_vm._v(" "),_c('p',[_vm._v("\n            To the fullest extent permitted by applicable law, you agree to defend, indemnify and hold harmless BeatHey, its parent company, its officers, directors, employees and representatives from any and all claims, damages, liabilities, losses, liabilities, costs or debts and expenses (including, without limitation, attorneys' fees) resulting from: (i) your use of and access to the Service; (ii) any breach of any provision of these Terms of Service; (iii) violation of any third party's rights, including, without limitation, copyright, property or privacy rights; or (iv) any claim that your Content has caused damage to any third party. This defense and indemnification obligation will survive these Terms of Use and your use of the Service\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Limitation of liability")]),_vm._v(" "),_c('p',[_vm._v("\n            Under no circumstances shall BeatHey, its officers, administrators (directors), employees or agents be liable for any damages whatsoever, whether direct, indirect, incidental, moral, special, or punitive, resulting from (i) errors or inconsistencies in content, (ii) injury or damage to property, of any nature, resulting from your access to and use of our services, (iii) any unauthorized access or use of our restricted servers and/or any personal and/or financial information stored within such servers, (iv) any interruption or termination of transmission to or from our services, (v) any bugs, defects, viruses, trojan horses or the like that may be transmitted by or through our services by any third party, and/or (vi) any errors or omissions in any content or for any loss or damage of any kind resulting from the use of content posted, sent via email, transmitted or otherwise made available via the Services, whether or not the foregoing are based on warranty, contract, tort or any other legal theory, whether or not the BeatHey has been advised of the extent of such damages. The above limitation of liability shall apply to the fullest extent permitted by applicable law in the applicable jurisdiction. \n            You specifically acknowledge that BeatHey shall not be liable for the content or defamatory, offensive or illegal conduct of any third party and that the risk of harm or injury in connection therewith lies entirely with you. \n            Because BeatHey is not the buyer or seller in an Artists-Amateur Transaction, and is not an agent of the Artists or Amateurs for any purpose, BeatHey has no obligation to resolve and/or will not be involved in the resolution of disputes between users relating to or arising out of any Transaction. Artists are responsible for complying with all consumer rights laws applicable to their Transactions. \n            The Service is controlled and offered by BeatHey from its facilities in the Republic of Argentina. BeatHey makes no representation that the Service is appropriate or available for use in other locations. Those who enter or use the Service from other jurisdictions do so of their own free will and are responsible for compliance with local laws.\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("International")]),_vm._v(" "),_c('p',[_vm._v("\n            BeatHey makes no representation that the content is appropriate or available for use in locations outside of the Republic of Argentina, and access to the Service is prohibited from territories where the content is illegal. If you access the service from other locations, you do so on your own initiative and are responsible for compliance with local laws.\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Conflict resolution")]),_vm._v(" "),_c('p',[_vm._v("\n            A printed version of these Terms of Use and of any notice in electronic form shall be admissible in judicial or administrative proceedings based on or relating to these Terms of Use to the same extent and subject to the same conditions as other business documents and records. You and BeatHey agree that any cause of action arising out of or relating to the Service must be commenced within one (1) year after the date on which such cause of action arose; otherwise, such cause of action shall forever lapse. \n            Any dispute regarding the validity, existence, interpretation, performance, breach or execution of these Terms and Conditions, as well as any aspect of the Services, shall be resolved exclusively by the competent court in accordance with the actual domicile of the User.\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Integration and independence")]),_vm._v(" "),_c('p',[_vm._v("\n            These Terms of Use, together with the Privacy Policy available on the https://beathey.com/privacy-policy/en website, which is expressly understood to be accepted by you and is hereby reproduced as if it were inserted, and any other legal notices posted on the Service, shall form an integral part of and constitute the entire Agreement between you and BeatHey in relation to the Service. If any provision of these Terms of Use is held by a court of competent jurisdiction to be invalid or unenforceable, the invalidity or unenforceability of that provision shall not affect the validity of the remaining provisions of these Terms of Use, which shall remain in full force and effect. No waiver of any provision of these Terms of Use shall be deemed a future or continuing waiver of any such term or any other term and failure by BeatHey to exercise any right or provision under these Terms of Use shall not constitute a waiver of such right or provision. BeatHey reserves the right to modify these Terms of Use at any time and without notice, and it is your responsibility to review these Terms of Use for any modifications. Your use of the Service after any modification to the Terms of Use shall constitute your express acceptance of and agreement to be bound by such terms, as modified herein.\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Miscellaneous")]),_vm._v(" "),_c('p',[_vm._v("\n            BeatHey shall not be liable for any breach of its obligations where such breach is for reasons beyond the reasonable control of BeatHey, including, without limitation, mechanical or electronic failure or communication failure or degradation (including interference). These Terms of Use are personal to you, and are not assignable, and may be transferred to third parties by you, except with the prior written consent of BeatHey. The BeatHey may assign, transfer or delegate any of your rights and obligations without your consent. No agency, partnership, joint venture or employment relationship is created as a result of these Terms of Use and neither party has any authority whatsoever to bind the other for any reason whatsoever. In any action or proceeding to enforce rights under these Terms of Use, the prevailing party shall be entitled to recover costs and attorneys' fees. All notices under these Terms of Use shall be in writing and shall be deemed to have been given when received, delivered or sent by registered or personally registered mail, with acknowledgement of receipt; when receipt is confirmed by electronic means, if transmitted by fax or e-mail; or on the day after it is sent, if sent for next day delivery by the recognized next day delivery service.\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Contact")]),_vm._v(" "),_c('p',[_vm._v("\n            The company can be contacted at the following address: contacto@BeatHey.com\n          ")])])}]


/***/ }),
/* 940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsSubsPt_vue__ = __webpack_require__(422);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2924f2d4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsSubsPt_vue__ = __webpack_require__(942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(941)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2924f2d4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsSubsPt_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2924f2d4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsSubsPt_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2924f2d4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsSubsPt_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 941 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"terms flex justify-center"},[_c('div',{staticClass:"mw7"},[_c('button',{staticClass:"backButton"},[_c('router-link',{staticClass:"rlink",attrs:{"to":{name:'home'}}},[_vm._v("Volver")])],1),_vm._v(" "),_vm._m(0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mainContentTyCandPolicy"},[_c('h1',{staticClass:"mainTitleTyCandPolicy"},[_vm._v("BEATHEY Termos e Condições de Uso")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("\n              Por favor, leia estes Termos de Uso (\"Contrato\" ou \"Termos de Uso\") antes de utilizar os serviços oferecidos pela BEATHEY (\"BeatHey\", \"Empresa\", \"Nós\", \"Nos\" ou \"Nosso\"). Este contrato estabelece os termos juridicamente vinculativos e condições para o uso do site em www.BeatHey.com (o \"Site\") e o serviço de propriedade e operado pela BeatHey, incluindo aplicativos de software móveis oferecidos ou publicados pela empresa (junto com o site, o \"Serviço\"). Ao utilizar o Site ou Serviço de qualquer forma, incluindo, mas não se limitando a visitar ou navegar pela web, você aceita estar vinculado a estes Termos de Uso. Estes termos de uso aplicam-se a todos os usuários do Site ou Serviço, incluindo os usuários que também são contribuintes de conteúdo, informações e outros materiais ou serviços no Site.\n            ")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Aceitação dos Termos")]),_vm._v(" "),_c('p',[_vm._v("\n            O Serviço é oferecido sujeito à aceitação sem exceções de todos os termos e condições contidos neste documento (os \"Termos de Uso\"), que também incorporam a política de privacidade disponível em https://services.BeatHey.com/policy/privacy e todas as demais regras de operação, políticas e procedimentos que possam ser publicados no site pela Empresa, cada um dos quais é incorporado por referência nestes Termos de Uso e cada um dos quais pode ser atualizado pela Empresa de tempos em tempos sem aviso prévio. Além disso, alguns serviços oferecidos por meio do Serviço podem estar sujeitos a termos e condições adicionais publicados pela BeatHey, conforme aplicável; o uso desses serviços está sujeito aos termos e condições adicionais, que são incorporados aos presentes Termos de Uso por esta referência.\n            Se você estiver usando ou quiser abrir uma conta em nome de uma empresa, entidade ou organização (incluindo, mas não se limitando a um selo musical) (cada uma, uma \"Entidade Artista\"), você declara e garante que: (i) está devidamente autorizado pela Entidade Artista e/ou por qualquer artista representado por tal Entidade Artista (um \"Artista Representado\") com autoridade para vincular a referida Entidade Artista ou Artista Representado a estes Termos de Uso; e (ii) aceita que estará vinculado a estes Termos de Uso em nome da referida Entidade Artista e/ou Artista Representado.\n            O Serviço está disponível apenas para pessoas com pelo menos 13 anos de idade. Você declara e garante que, se for uma pessoa física, tem idade legal para celebrar um contrato vinculante e que todas as informações fornecidas para o registro são precisas e verdadeiras. A BeatHey pode, a seu exclusivo critério, recusar-se a oferecer o Serviço a qualquer pessoa ou entidade e alterar seus critérios de elegibilidade a qualquer momento. Esta disposição é nula onde for proibida por lei, e o direito de acessar o serviço é revogado em tais jurisdições.\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Modificação dos Termos de Uso")]),_vm._v(" "),_c('p',[_vm._v("\n            A BeatHey reserva-se o direito, a seu exclusivo critério, de modificar ou substituir quaisquer dos termos destes Termos de Uso, ou alterar, suspender ou interromper o Serviço (incluindo, sem limitação, a disponibilidade de qualquer recurso, banco de dados ou conteúdo) a qualquer momento, mediante publicação no Site ou envio de um e-mail. A BeatHey também pode impor limites a certos serviços ou restringir o acesso a todo o Serviço sem aviso prévio ou responsabilidade. É sua responsabilidade revisar estes Termos de Uso periodicamente. O uso contínuo do Serviço após a publicação de qualquer alteração nestes Termos de Uso implica a aceitação de tais mudanças.\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Regras e Conduta")]),_vm._v(" "),_c('p',[_vm._v("\n            Como condição de uso, você concorda em não utilizar o Serviço para qualquer propósito proibido por estes Termos de Uso. O Serviço (incluindo, sem limitação, qualquer Conteúdo conforme definido abaixo) é fornecido exclusivamente para seu uso pessoal, não comercial (exceto para artistas individuais, Entidades de Artistas ou Artistas Representados, cada um denominado \"artista\") para venda de música, merchandising ou outro conteúdo (cada um conforme definido abaixo), conforme autorizado pelo Serviço. Você é responsável por todas as suas ações em relação ao Serviço. Para fins destes Termos de Uso, o termo \"Conteúdo\" inclui, sem limitação, qualquer Arquivo de Usuário, vídeos, clipes de áudio, comentários escritos em fórum, informações, dados, texto, fotografias, software, scripts, gráficos, acessíveis através do Serviço.\n            A título de exemplo, e não como limitação, você não poderá (a) tomar qualquer ação ou (b) carregar, baixar, publicar, enviar, distribuir ou facilitar a distribuição de qualquer conteúdo através do Serviço, incluindo, sem limitação, qualquer Arquivo de Usuário, que:\n                • infrinja qualquer patente, marca, segredo comercial, direito autoral, direito de publicidade ou outro direito de qualquer outra pessoa ou entidade, ou que viole qualquer lei ou dever contratual;\n                • seja falso, enganoso ou inverídico;\n                • seja ilegal, ameaçador, abusivo, assediador, difamatório, calunioso, fraudulento, invasivo da privacidade, ofensivo, obsceno ou profano;\n                • constitua publicidade não autorizada ou não solicitada, spam ou envio de e-mails não desejados;\n                • envolva atividades comerciais e/ou vendas sem o consentimento prévio por escrito da Empresa, tais como concursos, sorteios, permutas, publicidade ou esquemas de pirâmide;\n                • explore pessoas de maneira sexual ou violenta;\n                • contenha vírus de software ou qualquer outro código de computador, arquivos ou programas destinados a interromper, danificar, limitar ou interferir com o funcionamento adequado de qualquer software, hardware ou equipamento de telecomunicações, ou para danificar ou obter acesso não autorizado a qualquer sistema, dados, senha ou outra informação da Empresa ou de terceiros; ou\n                • se faça passar por qualquer pessoa ou entidade, incluindo qualquer funcionário ou representante da Empresa.\n            Além disso, você não deverá: (i) tomar qualquer ação que imponha ou possa impor (conforme determinado pela BeatHey a seu critério exclusivo) uma carga irracional ou desproporcionalmente grande sobre a infraestrutura da Empresa (ou seus provedores terceirizados); (ii) interferir ou tentar interferir no funcionamento adequado do Serviço ou de qualquer atividade realizada no Serviço; (iii) contornar as medidas que a BeatHey pode usar para impedir ou restringir o acesso ao Serviço (ou a outras contas, sistemas computacionais ou redes conectadas ao Serviço); (iv) executar maillist, Listserv, qualquer forma de resposta automática ou \"spam\" no Serviço; ou (v) usar software manual ou automatizado, dispositivos ou outros processos para \"rastrear\" ou \"cobrir\" qualquer página do Site.\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Uso do Conteúdo")]),_vm._v(" "),_c('p',[_vm._v("\n            Além das restrições gerais acima, as seguintes restrições e condições aplicam-se especificamente ao uso do Conteúdo.\n            O Conteúdo do Serviço, as marcas registradas, marcas de serviço e logotipos (as \"Marcas\") contidos no Serviço, são propriedade ou estão licenciados para a BeatHey, sujeitos a direitos autorais e outros direitos de propriedade intelectual, conforme a legislação vigente.\n            O Conteúdo é fornecido NO ESTADO EM QUE SE ENCONTRA. Você pode acessar o Conteúdo para sua informação e uso pessoal apenas conforme disponibilizado pelas funções fornecidas no Serviço e conforme permitido por estes Termos de Uso. Você não deve fazer download de qualquer Conteúdo, a menos que veja um link de \"download\" ou similar exibido pela BeatHey no Serviço para aquele Conteúdo. Você não deverá copiar, reproduzir, distribuir, transferir, transmitir, exibir, vender, licenciar ou explorar qualquer Conteúdo para qualquer finalidade sem a devida autorização da BeatHey ou dos licenciantes correspondentes do Conteúdo. Será entendido como autorizado caso a cópia, reprodução, distribuição, transmissão, exibição, venda, licença ou exploração seja realizada através desta plataforma, em total conformidade com os Termos de Uso. A BeatHey e seus licenciadores reservam todos os direitos não expressamente concedidos no Serviço e no Conteúdo.\n            Você se compromete a não contornar, desabilitar ou de qualquer outra forma interferir com as funções relacionadas à segurança do Serviço ou com as funções que evitam ou restringem o uso ou cópia de qualquer Conteúdo, ou que estabelecem limitações no uso do Serviço ou do Conteúdo.\n            Você entende que ao usar o Serviço estará exposto a Conteúdos de várias fontes e que a BeatHey não é responsável pela precisão, utilidade, segurança ou direitos de propriedade intelectual ou relacionados a tal Conteúdo. Além disso, você entende e aceita que poderá estar exposto a Conteúdos que podem ser imprecisos, ofensivos, indecentes ou questionáveis e concorda em renunciar, e por meio deste renuncia, a qualquer direito ou defesa legal, monetária ou de qualquer outra forma, que tenha ou possa ter contra a BeatHey em relação a isso e, na medida permitida pela legislação aplicável, compromete-se a indenizar e isentar a BeatHey, seus proprietários, operadores, afiliados, licenciadores e licenciados, de quaisquer danos ou reivindicações de acordo com as leis pertinentes em todos os assuntos relacionados ao uso do Serviço.\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Informação Pessoal - Fãs")]),_vm._v(" "),_c('p',[_vm._v("\n            Como condição para utilizar certos recursos do Serviço (incluindo, sem limitação, a função de download gratuito ou a realização de uma compra da empresa ou de um artista), pode ser solicitado que você forneça determinadas informações pessoais à BeatHey, como seu endereço de e-mail, país de residência e CEP/código postal (\"Informação do Fã\").\n            Você pode se registrar na BeatHey como um fã e criar uma conta de usuário (\"Conta de Fã\"), que permitirá acessar certos recursos do Serviço disponíveis apenas por meio de contas de fãs, como uma página de perfil de fã, um histórico de compras de música junto com as informações que você decidir compartilhar sobre si mesmo, e a capacidade de seguir outros fãs ou artistas. Seguir um artista ou adquirir uma assinatura de um artista (uma \"assinatura de artista\") dá ao artista acesso ao seu endereço de e-mail. Seu histórico de compras de música e qualquer informação que você forneça à sua página de perfil estarão disponíveis para outros usuários do Serviço por padrão, sujeito à nossa política de privacidade.\n            Como condição para o direito dos artistas de receber informações dos fãs, a BeatHey exige que cada artista concorde com os termos estabelecidos na próxima seção deste Acordo. No entanto, você reconhece que a BeatHey não tem controle sobre o uso das informações dos fãs pelos artistas e reconhece e aceita que a BeatHey não será responsável ou obrigada, direta ou indiretamente, por qualquer dano ou perda causada ou supostamente causada por ou em conexão com o uso de tais informações pelos artistas.\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Informação Pessoal - Artistas")]),_vm._v(" "),_c('p',[_vm._v("\n            Em relação a determinados recursos do Serviço, incluindo a exigência de que os fãs forneçam seus endereços de e-mail e outras informações pessoais para acessar a opção de download, é possível que sejam coletados determinados tipos de informações do fã. Como condição para receber essas informações dos fãs, você reconhece e aceita que não divulgará nem venderá quaisquer informações do fã a terceiros e que utilizará as informações dos fãs exclusivamente em relação à lista de e-mails do artista ou à assinatura do artista, com o objetivo de oferecer aos fãs informações gerais e notícias sobre o artista, como próximos shows, novas músicas ou outros conteúdos oferecidos em relação à assinatura do artista. Além disso, você concorda que qualquer e-mail ou outra comunicação enviada à lista de e-mails do artista ou enviada em relação à assinatura do artista estará em conformidade com as leis de marketing por e-mail e incluirá um mecanismo pelo qual o destinatário possa cancelar a inscrição na lista de e-mails, juntamente com instruções claras de como fazer isso (ou seja, um mecanismo de \"opt-out\" funcional).\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Registro de Conta")]),_vm._v(" "),_c('p',[_vm._v("\n            Para utilizar alguns dos serviços do Site, você deve se registrar e fornecer certas informações (por exemplo, um nome de usuário, senha, informações de faturamento e um endereço de e-mail válido) para a BeatHey (\"Dados de Registro\") com o objetivo de criar uma conta (sua \"Conta\"). Você concorda em fornecer Dados de Registro atualizados, completos e precisos no momento do registro e atualizar seus Dados de Registro conforme necessário para mantê-los atualizados, completos e precisos. A BeatHey poderá cancelar sua conta e quaisquer ou todos os direitos de uso do Site se as informações fornecidas forem incorretas, falsas, incompletas ou, se a BeatHey, a seu exclusivo critério, suspeitar de comportamento fraudulento e/ou ilegal, tais como, mas não limitado a roubo de identidade, uso de cartões de crédito roubados ou manipulação de dados de vendas para inflá-los artificialmente, associados ao seu registro. Você concorda que a BeatHey pode armazenar e utilizar os Dados de Registro que você fornece com o serviço de cobrança em seu cartão de crédito e a manutenção de sua conta. Você é o único responsável por manter a confidencialidade e a segurança de sua conta. Você concorda em notificar imediatamente a BeatHey sobre qualquer uso não autorizado de sua senha e/ou conta. A BeatHey não será responsável por qualquer perda resultante do uso não autorizado de seus Dados de Registro ou conta, e você concorda em isentar e indenizar a BeatHey, seus parceiros, empresas controladoras, subsidiárias, agentes, afiliados e/ou licenciantes, conforme aplicável, para qualquer uso impróprio, não autorizado ou ilegal de sua conta.\n            Você não deve tentar obter acesso não autorizado ao Site. Caso o faça, ajude outros em tais tentativas ou distribua instruções, softwares ou ferramentas para esse fim, a BeatHey terá o direito de cancelar sua conta e tomar todas as medidas legais disponíveis. Você concorda em notificar imediatamente a BeatHey sobre qualquer uso não autorizado de sua senha e/ou conta. A BeatHey não será responsável por qualquer perda decorrente do uso não autorizado de seus Dados de Registro ou conta, e você concorda em isentar e indenizar a BeatHey, seus parceiros, empresas controladoras, subsidiárias, agentes, afiliados e/ou licenciantes, conforme aplicável, por qualquer uso inadequado, não autorizado ou ilegal de sua conta.\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Requisitos do Sistema para o Uso")]),_vm._v(" "),_c('p',[_vm._v("\n            Você é responsável pelo uso de qualquer hardware, sistemas e/ou programas de software e pelas taxas e custos derivados para: (a) conectar-se, navegar ou utilizar a internet; (b) acessar o Site; e/ou (c) buscar, ouvir, baixar, carregar, reproduzir ou transferir o Conteúdo Digital. Em determinado momento, pode ser necessário instalar software, disponibilizado pelo Site, para auxiliar na acessibilidade dos conteúdos. No entanto, a compra ou aquisição de qualquer outro produto não representa ou garante acesso ao Conteúdo Digital. Se precisar de informações sobre as especificações de qualquer equipamento, acesso à internet ou software para utilizar os serviços fornecidos pelo Site, entre em contato com a equipe de suporte ao cliente.\n            Você não pode tentar, nem apoiar tentativas de terceiros, de decifrar, realizar engenharia reversa, contornar, alterar ou interferir com o software necessário para o uso do Site ou Conteúdo Digital. Caso acesse o Site pelo celular ou por meio de um aplicativo para Android ou iOS, podem ser aplicadas tarifas de dados adicionais.\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Membresia – Cargos")]),_vm._v(" "),_c('p',[_vm._v("\n            Em determinadas circunstâncias, o uso do Serviço no Site não será gratuito. Consequentemente, a BEATHEY poderá cobrar uma taxa mensal expressa em dólares americanos como Membresia de todos aqueles que utilizarem o Serviço, seja como fãs, artistas ou de qualquer outra forma, mediante a criação de uma Conta para esse fim. A BEATHEY poderá definir e modificar o valor da Membresia a seu critério, sem necessidade de aviso prévio. Caso o meio de pagamento utilizado pelo usuário implique faturamento em reais, o valor será calculado com base na cotação de venda do dólar pelo Banco Central do Brasil do dia anterior à data da transação.\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Cargos e Pagamentos - Fãs")]),_vm._v(" "),_c('p',[_vm._v("\n            Você pode adquirir produtos e/ou serviços de um artista por meio do Site, incluindo, sem limitação, compras de conteúdo (incluindo conteúdos digitais disponíveis para download e streaming através do Serviço (\"Conteúdo Digital\")) e mercadorias físicas (\"Merchandising\"). Cada uma dessas compras é considerada uma \"transação\".\n            Para isso, você poderá, a seu critério, adquirir Conteúdo Digital escolhendo o valor que deseja pagar pelo download desse Conteúdo Digital, considerando os valores publicados em reais. Os valores são expressos em dólares americanos. Caso o meio de pagamento utilizado pelo usuário implique faturamento em reais, o valor será calculado com base na cotação de venda do dólar pelo Banco Central do Brasil do dia anterior à data da transação.\n            Todas as consultas relativas a transações de Merchandising deverão ser direcionadas ao artista relevante. A BeatHey não é responsável por reembolsos de merchandising, salvo disposição em contrário neste Acordo.\n            Todas as vendas de conteúdo digital são finais (exceto onde proibido por lei), a menos que a BeatHey determine o contrário. Caso não receba o conteúdo digital ou tenha um problema com o conteúdo digital entregue, entre em contato com a BeatHey com sua solicitação e comprovante de pagamento, e a BeatHey notificará o artista relevante para resolver seu problema. A critério exclusivo da BeatHey, você poderá ser reembolsado ou receber um crédito pela compra do Conteúdo Digital. No entanto, você entende e concorda que a BeatHey é uma plataforma que os artistas utilizam para vender seus produtos, e o conteúdo digital é derivado dos arquivos fornecidos pelo artista relevante, sendo este o único responsável por esses arquivos.\n            O preço total do conteúdo digital incluirá o preço do produto mais qualquer imposto aplicável sobre vendas no momento da compra do produto. O imposto será cobrado apenas em estados ou países onde bens digitais estão sujeitos a tributação.\n            A BeatHey não pode garantir que o Conteúdo que você compra em uma transação estará disponível de forma perpétua. Por exemplo, se você ou seu agente receber uma notificação de violação de direitos autorais em relação a determinado conteúdo, e se uma autoridade judicial ordenar a remoção desse Conteúdo do Serviço, isso poderá resultar na indisponibilidade futura para venda ou no bloqueio de acesso de qualquer pessoa que tenha comprado o conteúdo anteriormente. Isso significa que você poderá perder o acesso a conteúdo adquirido anteriormente por meio do Serviço.\n            Caso sejamos obrigados por lei a negar o acesso ao conteúdo previamente adquirido através do Serviço, incluindo a remoção de acesso ao conteúdo da coleção pessoal de um fã por meio de qualquer aplicativo móvel, a BeatHey e os artistas não fornecerão reembolso ao fã que adquiriu esse conteúdo, exceto quando exigido pela legislação aplicável. Os usuários assumem todo o risco de perda de acesso a qualquer conteúdo comprado por meio do Serviço.\n            Devido à possibilidade de sermos obrigados a negar acesso ao conteúdo adquirido anteriormente, recomendamos que você baixe rapidamente para seus próprios dispositivos qualquer conteúdo adquirido no Site, para que mantenha o controle e a posse do conteúdo, mesmo que ele precise ser removido do Serviço.\n            Você garante que, ao realizar uma transação, poderá fazer o pagamento total e imediato dos produtos ou serviços solicitados.\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Cargos e Pagamentos - Artistas")]),_vm._v(" "),_c('p',[_vm._v("\n            A BeatHey será a única autorizada a definir os preços do Conteúdo Digital e serviços cobrados por meio de transações (os \"preços\") no Site, sendo a BeatHey a única autorizada a modificar os preços quando assim o determinar. A BeatHey pode redistribuir cópias previamente adquiridas pelos fãs, caso o produto esteja danificado, seja uma versão do formato de arquivo incorreto do produto ou uma cópia incompleta do produto, sem custo para o fã. Essa redistribuição pode ocorrer permitindo que o fã baixe novamente uma substituição do Conteúdo Digital já baixado anteriormente.\n            Você será o único responsável, e a BeatHey não terá nenhuma responsabilidade por quaisquer taxas ou cobranças que possam ser aplicadas pelas plataformas de pagamento (exceto pelas taxas da BeatHey), taxas de transação com cartão de crédito (coletivamente, \"Comissões\"), encargos por inadimplência (como estornos de cartão de crédito ou fraude), pagamentos contestados e reembolsos, salvo disposição em contrário neste Acordo.\n            A BeatHey pode reter quaisquer impostos, taxas, encargos e/ou tributos sobre os pagamentos efetuados pelo fã que forem exigidos pela legislação aplicável, norma ou regulamentação. A BeatHey deverá repassar tais impostos, taxas, encargos ou tributos à autoridade legal competente.\n            A BeatHey e/ou seus licenciadores e/ou cessionários podem realizar pagamentos aos Artistas calculados com base na quantidade de reproduções via streaming que cada Usuário ou Fã fizer do Conteúdo Digital (clipes de áudio) dos Artistas. Para isso, considerar-se-á como conteúdo elegível para registro de reproduções obras que superem 45 segundos de duração total. A reprodução será contabilizada, de forma aleatória, em qualquer momento entre esse valor e a duração total da obra. Além disso, não serão computadas reproduções realizadas pelos próprios Artistas em seu Conteúdo Digital. O valor por reprodução, incluindo sua forma de cálculo, percentuais, aplicação, etc., será determinado pela BeatHey e poderá variar ao longo do tempo, a exclusivo critério da BeatHey.\n            No caso de Conteúdo Digital, a BeatHey recolherá o valor de compra ou de reprodução via streaming, os honorários e os impostos aplicáveis. A BeatHey pagará ao artista, bimestralmente, o total das receitas verificadas em favor do artista, deduzidos os impostos e/ou outras taxas, se aplicáveis (o \"Pagamento ao Artista\").\n            O Pagamento ao Artista poderá ser efetuado por meio da plataforma de pagamento que a BeatHey considerar apropriada, a qual poderá estar localizada em qualquer parte do mundo. O Artista deverá cumprir os requisitos exigidos pela plataforma de pagamento para o procedimento de recebimento, bem como os requisitos do país de residência do Artista para o recebimento dos valores depositados no exterior, conforme aplicável. O Artista reconhece que, devido ao seu país de residência, a autoridade local poderá descontar taxas, encargos, impostos, etc., sobre o valor a ser recebido pelo Artista.\n            Quando você receber um pagamento por conteúdo digital ou merchandising, será responsável pelo valor total do pagamento, mais as taxas, caso o pagamento seja invalidado posteriormente, por qualquer motivo. Se não houver fundos suficientes para cobrir sua responsabilidade, você concorda em reembolsar a BeatHey por outros meios.\n            A BeatHey tem o direito, mas não a obrigação, de suspender imediatamente a oferta ou venda de qualquer produto ou serviço, impedir ou restringir o acesso ao Site ou aos Serviços ou tomar qualquer outra ação em caso de problemas técnicos, material ofensivo, imprecisão em anúncios ou ações proibidas nos procedimentos e diretrizes contidas no Site, ou por qualquer outro motivo, a exclusivo critério da BeatHey, e para corrigir qualquer informação imprecisa ou problema técnico no Site. A BeatHey pode suspender imediatamente a oferta ou venda de qualquer produto ou serviço se receber notificações de violações, tomar conhecimento de qualquer infração ou de fatos ou circunstâncias que tornem evidente a infração em relação a qualquer produto ou serviço.\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Taxas Adicionais")]),_vm._v(" "),_c('p',[_vm._v("\n            Além das taxas estabelecidas anteriormente, a BeatHey reserva-se o direito de cobrar taxas para determinados recursos adicionais do Serviço que possam ser estabelecidos no futuro. A BeatHey reserva-se o direito de modificar sua lista de preços e de estabelecer novos encargos a qualquer momento, mediante notificação prévia de dez (10) dias, que poderá ser enviada por e-mail ou publicada no Site. O uso do Serviço por você após tal notificação constitui a aceitação de todas as novas taxas ou encargos aumentados.\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Faturamento")]),_vm._v(" "),_c('p',[_vm._v("\n            Atualmente, a BeatHey aceita várias plataformas de pagamento, como PayPal e/ou Mercado Pago. A BeatHey não aceita dinheiro em espécie, ordens de pagamento ou cheques. A BeatHey reserva-se o direito de alterar essa política a qualquer momento. Você concorda em pagar todos os encargos associados às suas compras (incluindo quaisquer impostos aplicáveis), às tarifas em vigor quando os encargos foram efetuados. Você, e não a BeatHey, é responsável por todos os valores cobrados indevidamente em seu cartão de crédito por terceiros. Como titular do cartão, o contrato com a instituição financeira emissora rege o uso do cartão designado e, portanto, você deve consultar esse contrato para determinar seus direitos e responsabilidades como titular do cartão.\n            A obrigação de pagar por compras previamente aceitas pela BeatHey subsistirá após o encerramento de sua conta. Devido à natureza do serviço, os reembolsos estão disponíveis apenas em circunstâncias excepcionais, a exclusivo critério da BeatHey.\n            Você é responsável por fornecer à BeatHey um cartão de crédito válido e pelo pagamento pontual de todos os encargos. A critério da BeatHey, as taxas poderão ser aplicadas individualmente ou adicionadas a outras compras feitas no Site. Você é responsável por atualizar as informações na seção correspondente da sua conta. Você também é responsável por qualquer cobrança em sua conta efetuada por terceiros, independentemente de você ter autorizado essa compra ou não. Você é o único responsável por manter sua conta segura e confidencial. A BeatHey pode, a seu critério, modificar, suspender ou interromper o Site (ou qualquer parte ou conteúdo dele) a qualquer momento, com ou sem aviso prévio, e a BeatHey não será responsável perante você ou terceiros em caso de exercício de tais direitos.\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Site de Terceiros")]),_vm._v(" "),_c('p',[_vm._v("\n            O Serviço pode permitir que você se conecte a outros sites ou recursos na Internet, e outros sites ou recursos podem conter links para o Site. Ao acessar sites de terceiros, você o faz por sua conta e risco. Esses outros sites não estão sob o controle da BeatHey, e você reconhece que a BeatHey não é responsável pelo conteúdo, funcionalidades, exatidão, legalidade, adequação ou qualquer outro aspecto desses sites ou recursos. A inclusão de qualquer link não implica aprovação pela BeatHey nem associação com seus operadores.\n            Além disso, você reconhece e concorda que a BeatHey não será responsável, direta ou indiretamente, por qualquer dano ou perda causada, ou supostamente causada, em conexão com o uso ou confiança em qualquer conteúdo, bens ou serviços disponíveis em ou por meio de qualquer site ou recurso de terceiros.\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Conteúdo e Licença")]),_vm._v(" "),_c('p',[_vm._v("\n            Você concorda que o Serviço possui conteúdo fornecido especificamente pela BeatHey ou por seus parceiros e que esse conteúdo está protegido por direitos autorais, marcas registradas, marcas de serviço, patentes, segredos comerciais, entre outros direitos. Você deve respeitar e manter todos os avisos de direitos autorais, informações e restrições contidos em qualquer Conteúdo acessado por meio do Serviço.\n            A BeatHey concede a cada usuário do Site e/ou do Serviço uma licença mundial, não exclusiva, não sublicenciável e intransferível para usar, modificar e reproduzir o conteúdo, exclusivamente para uso pessoal e não comercial. O uso, reprodução, modificação, distribuição ou armazenamento de qualquer conteúdo para fins que não sejam o uso pessoal é expressamente proibido sem autorização prévia por escrito da BeatHey ou do titular dos direitos autorais identificados no aviso de direitos autorais do conteúdo. Você não pode vender, licenciar, alugar ou explorar comercialmente qualquer Conteúdo, nem utilizá-lo de forma que viole os direitos de terceiros.\n            Você não pode fazer engenharia reversa, descompilar, desmontar, modificar ou desativar qualquer sistema de proteção contra cópia ou sistemas de limitação associados aos downloads de Conteúdo Digital. Não pode reproduzir e depois redigitalizar qualquer Conteúdo Digital. Também não pode criar \"obras derivadas\" alterando qualquer conteúdo, exceto conforme permitido neste documento. É proibido o uso do Conteúdo Digital em conjunto com qualquer conteúdo de terceiros (por exemplo, para adicionar som a um vídeo) sem obter tais direitos do proprietário dos direitos autorais. O compartilhamento de arquivos peer-to-peer está estritamente proibido. Qualquer outro tipo de compartilhamento de arquivos de rede e a transferência de Conteúdo Digital para esse fim estão expressamente proibidos e constituem violação das leis internacionais de direitos autorais.\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Direitos de Propriedade Intelectual - Artistas")]),_vm._v(" "),_c('p',[_vm._v("\n            O Serviço oferece aos artistas a possibilidade de carregar o conteúdo digital de sua propriedade ou controlado por eles no Site, incluindo, mas não se limitando a gravações de áudio (\"Gravações de Som\"), vídeos sincronizados com gravações de som e outras obras audiovisuais (coletivamente, \"Videoclipes\") e as obras musicais incorporadas em gravações de som e videoclipes (\"Obras Musicais\"; em conjunto com as Gravações de Som e Videoclipes, a \"Música do Artista\"). A BeatHey não detém nenhum direito de propriedade sobre o Conteúdo Digital de um artista; no entanto, a BeatHey precisa da seguinte licença para realizar o Serviço.\n            Cada artista que carrega Conteúdo Digital no Serviço concede à BeatHey e aos seus licenciados e distribuidores autorizados uma licença mundial, não exclusiva, transferível a terceiros, livre de royalties, para:\n                1. Reproduzir, distribuir, executar publicamente (inclusive por meio de uma transmissão de áudio digital), exibir publicamente, criar obras derivadas, comunicar ao público, sincronizar e explorar de outra forma (em conjunto, \"explorar\") a Música do Artista e fornecer o Serviço em nome do Artista (por exemplo, reproduzir, transmitir, copiar e armazenar a Música do Artista em servidores pertencentes e/ou gerenciados pela BeatHey ou em nome dela, e executar publicamente, transmitir, sincronizar, distribuir e reproduzir a Música do Artista) utilizando qualquer tecnologia ou metodologia conhecida ou desenvolvida no futuro.\n                2. Permitir que os usuários do Serviço recebam as exibições e execuções públicas da Música do Artista e das obras visuais e reproduzam a Música do Artista e as obras visuais em quaisquer e todos os dispositivos de sua propriedade ou controle para fins não comerciais, além de receber exibições e execuções públicas dessas obras.\n                3. Reproduzir, utilizar e publicar, e permitir que outros reproduzam, utilizem e publiquem, o nome, marcas registradas e materiais pessoais e biográficos do artista em conexão com a prestação do Serviço.\n                4. Utilizar, distribuir, reproduzir, copiar e exibir suas marcas registradas, marcas de serviço, slogans, logotipos ou direitos de propriedade semelhantes (coletivamente, as \"Marcas Registradas\") exclusivamente em relação ao Serviço ou na comercialização, promoção ou publicidade dos serviços, inclusive em todos os tipos de materiais de marketing, promoção e publicidade conhecidos atualmente ou criados no futuro.\n            Ao carregar Conteúdo Digital (música ou obras) no Site:\n            Você declara e garante, e deve comprovar a plena satisfação da BeatHey, que (i) é proprietário ou, de alguma forma, controla todos os direitos sobre sua música e obras (ou que a música e obras estão em domínio público ou foram licenciadas ao artista por escrito com uma concessão de direitos suficientes para permitir que o artista cumpra este Acordo e conceda todos os direitos em relação à música ou obras do artista, conforme estabelecido neste Acordo); (ii) possui plena autoridade para atuar em nome de qualquer e todos os proprietários de quaisquer direitos, títulos ou interesses em relação a qualquer música ou obra que carregue no Serviço; (iii) possui permissão para utilizar o nome e imagem de cada indivíduo cujo nome ou imagem estejam incluídos ou usados na música e/ou obras, bem como para utilizar essa informação pessoal (na medida em que for usada ou esteja contida na música e/ou nas obras de arte) conforme previsto nestes Termos de Uso; e (iv) está autorizado a conceder todos os direitos mencionados sobre a música e/ou obras de arte para a BeatHey e para todos os usuários do Serviço.\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Direitos de Propriedade Intelectual - Fãs")]),_vm._v(" "),_c('p',[_vm._v("\n            O Serviço oferece aos usuários a capacidade de adicionar, criar, carregar, enviar, distribuir ou postar (\"Envio\") conteúdo digital, vídeos (incluindo videoclipes), clipes de áudio (incluindo música), comentários em fóruns, dados, texto, fotografias, software, scripts, gráficos ou outras informações no Site (coletivamente, os \"Envios de Usuário\"). Ao realizar um Envio no Site ou de outra forma por meio do Serviço, você:\n                • Reconhece que ao enviar qualquer Arquivo de Usuário, poderá ser publicamente identificado pelo seu ID de usuário em associação com o Arquivo de Usuário.\n                • Ao enviar qualquer Arquivo de Usuário pelo Site ou pelo Serviço, você concede à BeatHey uma licença mundial, não exclusiva, perpétua, irrevogável e totalmente paga, sublicenciável e transferível, livre de royalties, para usar, editar, modificar, reproduzir, distribuir, preparar obras derivadas, exibir publicamente, executar publicamente (inclusive por meio de transmissão de áudio digital), comunicar ao público, sincronizar e explorar integralmente os Envios de Usuário em conexão com o Site, o negócio do Serviço e da BeatHey (e de seus sucessores e cessionários), incluindo, sem limitação, a promoção e redistribuição de parte ou da totalidade do Site (e das obras derivadas do mesmo) ou do Serviço em qualquer formato por qualquer canal de comunicação (incluindo, sem limitação, sites de terceiros), conhecidos ou desenvolvidos posteriormente.\n                • Declara e garante, e pode comprovar a plena satisfação e pedido da BeatHey que (i) possui ou controla todos os direitos sobre o conteúdo dos seus Envios de Usuário, ou que o conteúdo desses Arquivos de Usuário está em domínio público ou devidamente licenciado; (ii) tem plena autoridade para agir em nome de todos os proprietários de quaisquer direitos sobre o conteúdo dos seus Envios de Usuário para utilizar o conteúdo conforme estabelecido nestes Termos de Uso; (iii) possui permissão para usar o nome e imagem de cada pessoa identificável individualmente e para usar tal identificação ou informação pessoal conforme estabelecido nestes Termos de Uso; e (iv) está autorizado a conceder todos os direitos mencionados sobre os Envios de Usuário à empresa e a todos os usuários do Serviço.\n                • Concorda em pagar todas as taxas e valores devidos a qualquer pessoa ou entidade, incluindo qualquer organização de direitos autorais, em decorrência da apresentação de qualquer Arquivo de Usuário no Serviço.\n                • Declara que o uso ou exploração dos Envios de Usuário pela BeatHey e o uso ou exploração pelos usuários do Site e dos serviços, conforme contemplado neste Acordo, não infringem ou violam os direitos de terceiros, incluindo, sem limitação, direitos de privacidade, direitos de publicidade, direitos autorais, direitos contratuais ou quaisquer outros direitos de propriedade intelectual ou de propriedade.\n                • Entende que a BeatHey terá o direito de excluir, editar, modificar, reformular, traduzir qualquer material, conteúdo ou informação enviada por você, e que toda a informação disponibilizada pública ou privadamente por meio do Site é de responsabilidade exclusiva da pessoa que originou tal conteúdo, não sendo a BeatHey responsável por qualquer erro ou omissão em qualquer conteúdo; entende ainda que a BeatHey não pode garantir a identidade dos outros usuários com quem possa interagir ao utilizar o Serviço.\n            A BeatHey não endossa e não tem controle sobre qualquer Arquivo de Usuário. A BeatHey não pode garantir a autenticidade dos dados que os usuários possam fornecer sobre si mesmos. Você reconhece que todo o Conteúdo acessado pelo uso do Serviço é por sua conta e risco e será o único responsável por qualquer dano ou perda para qualquer das partes resultante disso.\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Rescisão")]),_vm._v(" "),_c('p',[_vm._v("\n            A BeatHey pode encerrar seu acesso a todo ou parte do Serviço a qualquer momento, com ou sem motivo, com ou sem aviso prévio, com efeito imediato, o que pode resultar na perda e destruição de todas as informações associadas à sua conta, incluindo, sem limitação, qualquer acesso à música que você tenha comprado por meio do Serviço. Os termos e condições continuarão a se aplicar até que você ou a BeatHey os rescindam. No entanto, você reconhece e concorda que a licença indefinida concedida para o Conteúdo de Usuário, incluindo comentários, é irrevogável e, portanto, continuará vigente após o término ou rescisão do Serviço, independentemente do motivo.\n            Se você ou a BeatHey rescindirem o Serviço, ou se a BeatHey suspender seu acesso ao Serviço, você concorda que a BeatHey não será responsável perante você e não reembolsará nenhum valor que você já tenha pago, na medida em que a legislação aplicável permita. Esta seção será implementada na medida em que a legislação aplicável permita. Você pode rescindir o Serviço a qualquer momento.\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Isenção de Responsabilidade de Garantias")]),_vm._v(" "),_c('p',[_vm._v("\n            Você concorda que o uso dos Serviços será por sua conta e risco, na medida permitida pela legislação aplicável. A BeatHey, seus diretores, administradores, funcionários, representantes e agentes são isentos de qualquer responsabilidade em relação a qualquer tipo de garantia, seja expressa ou implícita, relacionada aos Serviços e ao seu uso dos mesmos. A BeatHey não garante nem declara a veracidade ou exatidão do conteúdo do site ou do conteúdo de qualquer site vinculado a este site e não assume responsabilidade civil ou criminal por nenhum: (i) erro, inconsistência ou imprecisão do conteúdo; (ii) dano pessoal ou à propriedade, de qualquer natureza, decorrente do seu acesso e uso dos Serviços; (iii) acesso ou uso não autorizado de nossos servidores restritos ou de qualquer informação pessoal ou financeira armazenada nesses servidores; (iv) interrupção ou término da transmissão para ou dos nossos Serviços; (v) qualquer defeito, bug, vírus, cavalos de troia ou similares que possam ser transmitidos através dos Serviços por qualquer terceiro; ou (vi) qualquer erro ou omissão em qualquer conteúdo ou por qualquer dano ou perda de qualquer natureza decorrente do uso de qualquer conteúdo publicado, enviado por e-mail, transmitido ou disponibilizado por qualquer meio através dos Serviços.\n            A BeatHey não garante, patrocina nem assume responsabilidade por qualquer Conteúdo Digital ou serviço promovido ou oferecido por terceiros por meio dos Serviços ou de qualquer serviço conectado por \"hyperlink\" ou promovido em qualquer anúncio ou outro tipo de publicidade. A BeatHey não será parte nem de qualquer forma responsável pelo controle de qualquer transação entre você e um fornecedor de produtos ou serviços de terceiros. Em qualquer aquisição de Conteúdo Digital, merchandising ou serviços por qualquer meio, você deverá agir com cautela e tomar as devidas precauções.\n            A BeatHey não garante confidencialidade ou privacidade de qualquer comunicação ou informação transmitida no Site ou em qualquer site vinculado ao Site. A BeatHey não é responsável pela privacidade dos endereços de e-mail, informações de registro, identificação, espaço em disco, comunicações, informações confidenciais ou segredos comerciais, ou qualquer outro conteúdo armazenado nos equipamentos da empresa, transmitido através de redes que acessam o site ou, de outra forma, conectado ao seu uso do Serviço.\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Indenização")]),_vm._v(" "),_c('p',[_vm._v("\n            Na medida mais ampla permitida pela legislação aplicável, você concorda em defender, indenizar e isentar a BeatHey, sua sociedade controladora, diretores, administradores, funcionários e representantes de qualquer reclamação, dano, obrigação, perda, responsabilidade, custo ou dívida e despesas (incluindo, sem limitação, honorários advocatícios) resultantes de: (i) seu uso e acesso ao Serviço; (ii) violação de qualquer disposição destes Termos de Uso; (iii) violação dos direitos de terceiros, incluindo, sem limitação, direitos autorais, de propriedade ou de privacidade; ou (iv) qualquer reclamação alegando que seu Conteúdo causou dano a terceiros. Esta obrigação de defesa e indenização continuará vigente após a rescisão destes Termos de Uso e do uso do Serviço por você.\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Limitação de Responsabilidade")]),_vm._v(" "),_c('p',[_vm._v("\n            Em nenhuma circunstância a BeatHey, seus diretores, administradores, funcionários ou agentes serão responsáveis por qualquer dano, seja ele direto, indireto, incidental, moral, especial ou punitivo, resultante de: (i) erros ou inconsistências do conteúdo; (ii) danos pessoais ou à propriedade, de qualquer natureza, resultantes do seu acesso e uso dos nossos Serviços; (iii) qualquer acesso não autorizado ou uso de nossos servidores restritos e/ou de qualquer informação pessoal e/ou financeira armazenada nesses servidores; (iv) qualquer interrupção ou término da transmissão para ou dos nossos Serviços; (v) qualquer bug, defeito, vírus, cavalo de troia ou similares que possam ser transmitidos por meio dos nossos Serviços por qualquer terceiro; e/ou (vi) qualquer erro ou omissão em qualquer conteúdo ou por qualquer perda ou dano, de qualquer natureza, resultante do uso do conteúdo publicado, enviado por e-mail, transmitido ou disponibilizado por qualquer meio por meio dos Serviços.\n            Essa limitação de responsabilidade será aplicável na medida mais ampla permitida pela legislação vigente na jurisdição correspondente.\n            Você reconhece especificamente que a BeatHey não será responsável pelo conteúdo nem por condutas difamatórias, ofensivas ou ilegais de qualquer terceiro, e que o risco de dano ou prejuízo relacionado ao acima exposto recairá completamente sobre você.\n            Como a BeatHey não é o comprador ou vendedor em uma Transação entre artistas e fãs e não age como agente dos artistas ou fãs para qualquer finalidade, a BeatHey não tem a obrigação de resolver ou se envolver na resolução de disputas entre os usuários relacionadas a ou decorrentes de qualquer Transação. Os artistas são responsáveis por cumprir todas as leis de proteção ao consumidor aplicáveis às suas Transações.\n            O Serviço é controlado e oferecido pela BeatHey a partir de suas instalações na República Argentina. A BeatHey não faz nenhuma declaração de que o Serviço é adequado ou está disponível para uso em outras localidades. Aqueles que acessarem ou usarem o Serviço em outras jurisdições o fazem por sua conta e risco e são responsáveis pelo cumprimento da legislação local.\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Internacional")]),_vm._v(" "),_c('p',[_vm._v("\n            A BeatHey não garante que o conteúdo seja adequado ou esteja disponível para uso em locais fora da República Argentina, e o acesso ao Serviço é proibido em territórios onde o conteúdo seja ilegal. Se você acessar o Serviço de outros locais, faz isso por sua iniciativa e é responsável por cumprir as leis locais.\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Resolução de Conflitos")]),_vm._v(" "),_c('p',[_vm._v("\n            Uma versão impressa destes Termos de Uso e de qualquer notificação enviada em formato eletrônico será admissível em procedimentos judiciais ou administrativos com base ou relacionados a estes Termos de Uso na mesma medida e sujeita às mesmas condições que outros documentos e registros comerciais. Você e a BeatHey concordam que qualquer ação judicial que surja ou esteja relacionada ao Serviço deve ser iniciada dentro de um (1) ano a partir do surgimento da causa da ação; caso contrário, essa causa será definitivamente extinta.\n            Qualquer divergência sobre a validade, existência, interpretação, cumprimento, descumprimento ou execução destes Termos e Condições, bem como qualquer aspecto dos Serviços, será dirimida exclusivamente perante a justiça competente, de acordo com o domicílio real do Usuário.\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Integração e Independência")]),_vm._v(" "),_c('p',[_vm._v("\n            Estes Termos de Uso, juntamente com a Política de Privacidade disponível na página de Internet https://beathey.com/privacy-policy/es, a qual é expressamente aceita por você e considerada aqui reproduzida como se estivesse inserida na íntegra, e qualquer outra notificação legal publicada no Serviço, constituem o contrato integral entre você e a BeatHey em relação ao Serviço.\n            Caso qualquer disposição destes Termos de Uso seja considerada nula ou inválida por um tribunal competente, a nulidade ou invalidade dessa disposição não afetará a validade das demais disposições destes Termos de Uso, que permanecerão em pleno vigor e efeito. Nenhuma renúncia a qualquer disposição destes Termos de Uso será considerada como uma renúncia futura ou contínua a tal disposição ou a qualquer outra, e a falta de exercício por parte da BeatHey de qualquer direito ou disposição destes Termos de Uso não constituirá uma renúncia a tal direito ou disposição.\n            A BeatHey se reserva o direito de modificar estes Termos de Uso a qualquer momento, sem aviso prévio, e é sua responsabilidade revisar estes Termos de Uso para verificar quaisquer alterações. O uso do Serviço após qualquer modificação nos Termos de Uso significará sua aceitação e adesão expressa a esses termos, conforme modificados.\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Miscelânea")]),_vm._v(" "),_c('p',[_vm._v("\n            A BeatHey não será responsável pelo descumprimento de suas obrigações quando tal descumprimento ocorrer por razões fora de seu controle razoável, incluindo, sem limitação, falhas mecânicas, eletrônicas ou de comunicação ou degradação (incluindo interferências). Estes Termos de Uso são pessoais e não são atribuíveis, transferíveis a terceiros por você, exceto mediante consentimento prévio por escrito da BeatHey. A BeatHey pode ceder, transferir ou delegar qualquer um de seus direitos e obrigações sem o seu consentimento.\n            Nenhuma agência, parceria, joint venture ou relação de emprego é criada como resultado destes Termos de Uso, e nenhuma das partes tem qualquer autoridade para vincular a outra por qualquer motivo. Em qualquer ação ou procedimento para fazer valer os direitos sob estes Termos de Uso, a parte vencedora terá o direito de recuperar os custos e honorários advocatícios. Todas as notificações sob estes Termos de Uso devem ser feitas por escrito e serão consideradas devidamente enviadas quando recebidas, se entregues pessoalmente ou enviadas por correio certificado ou registrado, com confirmação de recebimento; quando a recepção é confirmada eletronicamente, se transmitidas por fax ou e-mail; ou no dia seguinte ao envio, se enviadas para entrega no dia seguinte por um serviço reconhecido de entrega expressa.\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Contato")]),_vm._v(" "),_c('p',[_vm._v("\n            Você pode entrar em contato com a empresa através do seguinte endereço de e-mail: contcato@BeatHey.com.\n          ")])])}]


/***/ }),
/* 943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeList_vue__ = __webpack_require__(423);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06b20e7c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomeList_vue__ = __webpack_require__(976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(944)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-06b20e7c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06b20e7c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomeList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06b20e7c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomeList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 944 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VinylContestHome_vue__ = __webpack_require__(424);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fb433f96_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VinylContestHome_vue__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(946)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fb433f96"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VinylContestHome_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fb433f96_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VinylContestHome_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fb433f96_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VinylContestHome_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 946 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 947 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 948 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex justify-between flex-wrap mw-100"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.artist),expression:"artist"}],staticClass:"artist-data w-100"},[_c('h2',{staticClass:"artist-info f7 f5-ns fw6 lh-title mv0",class:{'light-silver' : _vm.isFirstArtist || _vm.isPodium, 'accent': _vm.inHome}},[_vm._v(_vm._s(_vm.artist.name)+" ")]),_vm._v(" "),_c('h3',{staticClass:"artist-info f7 fw4 mt0 mb0 textColor",class:{'light-silver' : _vm.isFirstArtist || _vm.isPodium }},[_vm._v(_vm._s(_vm.artist.phrase))])])])}
var staticRenderFns = []


/***/ }),
/* 950 */,
/* 951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-circle',{ref:"circle",attrs:{"progress":_vm.percent,"size":_vm.size,"reverse":false,"line-cap":"round","fill":_vm.fill,"empty-fill":_vm.emptyFill,"animation-start-value":0.0,"insert-mode":"append","thickness":5,"show-percent":false}},[_c('p',{staticClass:"f5-ns f7 b light-silver"},[_vm._v(_vm._s(_vm.value)+"%")])])}
var staticRenderFns = []


/***/ }),
/* 952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-primary w-100 flex items-center justify-between"},[_c('div',{staticClass:"flex items-center bg-primary"},[_c('div',{staticClass:"flex items-center justify-center flex-start",class:{'image-container': !_vm.inHome, 'home-image-container': _vm.inHome}},[_c('img',{staticClass:"mw-100 h-100",attrs:{"src":_vm.picture}})]),_vm._v(" "),_c('div',{staticClass:"pl3-l pr3-l pl1 pr1 flex items-center"},[_c('div',{staticClass:"flex items-center"},[_c('span',{staticClass:"light-silver",class:{'f-subheadline-ns f3 ml2': !_vm.inHome, 'f3-ns f5': _vm.inHome}},[_vm._v("#")]),_c('span',{staticClass:"light-silver f-headline-ns f2",class:{'f-headline-ns f2': !_vm.inHome, 'f2-ns f4': _vm.inHome}},[_vm._v(_vm._s(_vm.index + 1))])]),_vm._v(" "),_c('div',{class:{'artist-info': !_vm.inHome, 'artist-info-home': _vm.inHome}},[_c('router-link',{staticClass:"no-underline",class:{'primary': !_vm.inHome, 'accent': _vm.inHome},attrs:{"to":{ name:'artist-info', params: { id: _vm.artist.id }}}},[_c('artist-data',{attrs:{"artist":_vm.artist,"isFirstArtist":true,"inHome":_vm.inHome}})],1)],1)])]),_vm._v(" "),_c('div',{class:{'db-ns dn': !_vm.inHome, 'dn': _vm.inHome}},[_c('circle-progress',{staticClass:"mr5-l mr2",attrs:{"percent":_vm.artist.percent,"emptyFill":"rgba(0, 0, 0, .8)","size":90}})],1),_vm._v(" "),_c('div',{class:{'dn-ns mr5-l': !_vm.inHome}},[_c('circle-progress',{staticClass:"mr2",attrs:{"percent":_vm.artist.percent,"emptyFill":"rgba(0, 0, 0, .8)","size":60}})],1)])}
var staticRenderFns = []


/***/ }),
/* 953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pt3-ns pt2 ph3 ph0-l flex flex-column w-100 textColor"},[_c('h1',{staticClass:"bg-black-90 white fw2 f5 f4-ns ttu pv1 ph3 mr2-l mb0 mt3"},[_c('font-awesome-icon',{staticClass:"mr2",attrs:{"icon":"trophy","size":"sm"}}),_vm._v(_vm._s(_vm.$t("vinylContest.title")))],1),_vm._v(" "),_c('div',{staticClass:"vinyl-contest"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"flex justify-center h5 w-100 mv3"},[_c('clip-loader',{attrs:{"loading":_vm.loading,"color":_vm.color,"size":_vm.size}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],staticClass:"bg-primary flex flex-column justify-between mr2-l h-100"},[_vm._l((_vm.vinylContest),function(artist,index){return (index < 4)?_c('div',{key:artist.id,staticClass:"w-100 ph2 pv1 flex items-center justify-between",attrs:{"track-by":artist.id}},[_c('vinyl-contest-podium',{staticClass:"mr2-l",attrs:{"artist":artist,"index":index,"inHome":true}})],1):_vm._e()}),_vm._v(" "),_c('router-link',{staticClass:"no-underline textColor pa2 db tr f6",attrs:{"to":{ name:'charts'}}},[_c('font-awesome-icon',{staticClass:"white",attrs:{"icon":"external-link-alt"}}),_vm._v("\n        "+_vm._s(_vm.$t("vinylContest.link"))+"\n      ")],1)],2)])])}
var staticRenderFns = []


/***/ }),
/* 954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Recommended_vue__ = __webpack_require__(430);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4dd53ed2_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Recommended_vue__ = __webpack_require__(958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(955)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4dd53ed2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Recommended_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4dd53ed2_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Recommended_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4dd53ed2_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Recommended_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 955 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 956 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100 w-100 flex justify-between"},[_c('div',{staticClass:"pointer flex",on:{"click":_vm.playTrack}},[_c('div',{staticClass:"fl track-image ma0 flex flex-row items-center justify-between mr3 relative hide-child"},[_c('span',{staticClass:"play absolute top-0 v-mid w-100 h-100 child bg-black-40 flex items-center justify-center pointer textColor"},[_c('div',{staticClass:"grow ba bw1 br-100 h2 w2 flex items-center justify-center textColor",on:{"click":function($event){$event.preventDefault();return _vm.playTrack.apply(null, arguments)}}},[_c('font-awesome-icon',{attrs:{"icon":"play"}})],1)]),_vm._v(" "),_c('img',{staticClass:"h-100 w-100",attrs:{"src":_vm.picture}})]),_vm._v(" "),_c('div',{staticClass:"flex flex-column"},[_c('p',{staticClass:"text-width title fw6 fl pa1 pl3 ma0 text-ellipsis center-content textColor",on:{"click":_vm.playTrack}},[_vm._v(_vm._s(_vm.track.title))]),_vm._v(" "),_c('router-link',{staticClass:"text-width textColor no-underline",attrs:{"to":{ name:'artist-info', params:{ id:_vm.track.id_artist }},"append":""},nativeOn:{"click":function($event){$event.stopPropagation();}}},[(_vm.inHome === false && _vm.profileTracks === false)?_c('p',{staticClass:"text-width artist fl h-100 pa1 pl3 ma0 text-ellipsis center-content textColor",class:{'accent': _vm.inHome}},[_vm._v(_vm._s(_vm.track.artist.name))]):_vm._e(),_vm._v(" "),(_vm.inHome === true && _vm.profileTracks === false)?_c('p',{staticClass:"text-width artist fl h-100 pa1 pl3 ma0 text-ellipsis center-content textColor",class:{'accent': _vm.inHome}},[_vm._v(_vm._s(_vm.track.name))]):_vm._e(),_vm._v(" "),(_vm.inHome === false && _vm.profileTracks === true)?_c('p',{staticClass:"text-width artist fl h-100 pa1 pl3 ma0 text-ellipsis center-content textColor",class:{'accent': _vm.inHome}},[_vm._v(_vm._s(_vm.track.name))]):_vm._e()]),_vm._v(" "),(_vm.inHome === false && _vm.profileTracks === false)?_c('p',{staticClass:"text-width genre fl h-100 pa1 pl3 ma0 text-ellipsis center-content textColor"},[_vm._v("\n        "+_vm._s(_vm.track.genre.name))]):_vm._e(),_vm._v(" "),(_vm.inHome === true && _vm.profileTracks === false)?_c('p',{staticClass:"text-width genre fl h-100 pa1 pl3 ma0 text-ellipsis center-content textColor"},[_vm._v("\n        "+_vm._s(_vm.track.genre))]):_vm._e(),_vm._v(" "),(_vm.inHome === false && _vm.profileTracks === true)?_c('p',{staticClass:"text-width genre fl h-100 pa1 pl3 ma0 text-ellipsis center-content textColor"},[_vm._v("\n        "+_vm._s(_vm.track.music_type))]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"text-width released fl h-100 pa1 pl3 ma0 center-content textColor"},[_vm._v(_vm._s(this.trackTime))])],1)]),_vm._v(" "),_c('div',{staticClass:"track-options fl h-100 ma0 iconColor"},[_c('track-options-button',{staticClass:"ma0 relative",attrs:{"inHome":_vm.inHome,"track":_vm.track}})],1)])}
var staticRenderFns = []


/***/ }),
/* 958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100 pv2 pv3-ns ph3 mr2-l"},[_c('h1',{staticClass:"bg-black-90 white fw2 f5 f4-ns ttu pv1 ph3 mt3"},[_vm._v(_vm._s(_vm.$t("app.recommended")))]),_vm._v(" "),_c('div',{staticClass:"h-75 flex flex-wrap justify-center"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"flex justify-center h5 w-100 mv3"},[_c('clip-loader',{attrs:{"loading":_vm.loading,"color":_vm.color,"size":_vm.size}})],1),_vm._v(" "),_vm._l((_vm.promotion),function(track){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],key:track.id,staticClass:"track-container bg-primary w-100 textColor",attrs:{"track-by":track.id}},[_c('track-card',{staticClass:"w-100",attrs:{"track":track,"inHome":true},on:{"play":function($event){_vm.playTrack(track); _vm.setPlaylist(_vm.promotion)}}})],1)})],2)])}
var staticRenderFns = []


/***/ }),
/* 959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FeaturedPlaylist_vue__ = __webpack_require__(433);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f8f0f4c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FeaturedPlaylist_vue__ = __webpack_require__(964);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(960)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0f8f0f4c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FeaturedPlaylist_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f8f0f4c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FeaturedPlaylist_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f8f0f4c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FeaturedPlaylist_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 960 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeTrackCard_vue__ = __webpack_require__(434);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d048960c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomeTrackCard_vue__ = __webpack_require__(963);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(962)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d048960c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeTrackCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d048960c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomeTrackCard_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d048960c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomeTrackCard_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 962 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"track-card relative flex pointer cover bg-center bg-primary"},[_c('div',{staticClass:"flex-column w-100"},[_c('div',{staticClass:"track-info"},[_c('div',{staticClass:"body relative hide-child"},[_c('span',{staticClass:"white absolute top-0 v-mid w-100 h-100 child bg-black-40 flex items-center justify-center pointer"},[_c('div',{staticClass:"grow ba bw2 br-100 h3 w3 flex items-center justify-center",on:{"click":function($event){$event.preventDefault();return _vm.playTrack()}}},[_c('font-awesome-icon',{attrs:{"icon":"play","size":"2x"}})],1)]),_vm._v(" "),_c('img',{staticClass:"track-picture db",attrs:{"src":_vm.picture,"alt":((_vm.track.title) + " Picture")}})]),_vm._v(" "),_c('p',{staticClass:"pointer textColor f5 track-title ph2 mb1 b",on:{"click":function($event){return _vm.playTrack()}}},[_vm._v(_vm._s(_vm.track.title))]),_vm._v(" "),_c('router-link',{staticClass:"no-underline",attrs:{"to":{ name:'artist-info', params:{ id: _vm.track.artist.id }}}},[_c('p',{staticClass:"accent pointer f6 mt0 track-title ph2 b"},[_vm._v(_vm._s(_vm.track.artist.name))])])],1)])])}
var staticRenderFns = []


/***/ }),
/* 964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100 pt3-ns pt2 ph3 textColor"},[_c('div',{staticClass:"flex justify-center items center textColor"},[_c('h1',{staticClass:"fw2 f5 f4-ns bg-black-90 w-100 white pv1 ph3 ml2-l mt3 pointer textColor",on:{"click":function($event){_vm.setFeaturedPlaylist(); _vm.playFirstTrack()}}},[_c('span',{staticClass:"ttu pr3 di-ns flex justify-center"},[_c('font-awesome-icon',{staticClass:"mr2",attrs:{"icon":"play","size":"sm"}}),_vm._v(_vm._s(_vm.$t("app.featuredPlaylist.title"))+" ")],1),_vm._v(" "),_c('div',{staticClass:"f5 fw1 pr2 di-ns flex justify-center"},[_c('span',{staticClass:"accent"},[_vm._v(_vm._s(_vm.$t("app.featuredPlaylist.createdBy"))+" ")]),_vm._v(" "),_c('span',{staticClass:"accent"},[_vm._v(_vm._s(_vm.featuredPlaylist.name))])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"flex justify-center h5 w-100 mv3"},[_c('clip-loader',{attrs:{"loading":_vm.loading,"color":_vm.color,"size":_vm.size}})],1),_vm._v(" "),_c('div',{staticClass:"pv2 ph4-ns ph2 flex flex-column items-center"},[_c('div',{staticClass:"flex flex-wrap justify-center w-100"},[_c('div',{staticClass:"image-container flex item-center justify-center justify-start-ns mw-25"},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.featuredPlaylistImg),expression:"featuredPlaylistImg"}],staticClass:"w-100 h-100",attrs:{"src":_vm.featuredPlaylistImg}})]),_vm._v(" "),_c('p',{staticClass:"pa2 ma0 tj f6"},[_vm._v(_vm._s(_vm.featuredPlaylist.text))])]),_vm._v(" "),_c('carousel',{ref:"carousel",staticClass:"w-100-ns w-90 carousel",attrs:{"per-page":1,"paginationActiveColor":"#E6007E","paginationColor":"#ccc","perPageCustom":[[479,2],[768, 3], [1240, 4]],"loop":true,"autoplay":true,"autoplayTimeout":3500,"navigationEnabled":true}},_vm._l((_vm.featuredPlaylist.tracks),function(track){return _c('slide',{key:track.id,staticClass:"ph2 pt2 w-100 flex justify-center"},[_c('home-track-card',{attrs:{"track":track},on:{"playTrack":_vm.playTrackHandler}})],1)}),1)],1)])}
var staticRenderFns = []


/***/ }),
/* 965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LatestNews_vue__ = __webpack_require__(435);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_efd4c8f6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LatestNews_vue__ = __webpack_require__(970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(966)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-efd4c8f6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LatestNews_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_efd4c8f6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LatestNews_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_efd4c8f6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LatestNews_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 966 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_News_vue__ = __webpack_require__(436);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15d679e0_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_News_vue__ = __webpack_require__(969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(968)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-15d679e0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_News_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15d679e0_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_News_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15d679e0_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_News_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 968 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.news.path)?_c('div',{staticClass:"h-100 relative hide-child cover center background-center flex items-end",style:({'background-image': ("url(" + _vm.picture + ")")})},[_c('span',{staticClass:"white absolute top-0 v-mid w-100 h-100 child bg-black-40 flex items-center justify-center pointer",on:{"click":_vm.open}},[_c('font-awesome-icon',{staticClass:"white",attrs:{"icon":"external-link-alt","size":"2x"}})],1),_vm._v(" "),_c('div',{staticClass:"flex items-end w-100 justify-between"},[_c('div',{staticClass:"content-card bg-primary ml2 ml4-ns mb4 tc white pa3 flex pointer",on:{"click":_vm.open}},[_c('p',{staticClass:"f4-ns ma0 mt3-ns mt2 f5 text-ellipsis",attrs:{"title":_vm.news.title}},[_vm._v(_vm._s(_vm.news.title))])]),_vm._v(" "),_c('div',{staticClass:"home-button bg-primary mr4 mb4 tc pa3 br-100 pointer",on:{"click":_vm.open}},[_c('font-awesome-icon',{staticClass:"white",attrs:{"icon":"external-link-alt","size":"1x"}})],1)])]):_vm._e()}
var staticRenderFns = []


/***/ }),
/* 970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100 pt3-ns pt2 ph3 pb5"},[_c('h1',{staticClass:"bg-black-90 white fw2 f5 f4-ns ttu pv1 ph3 ml2-l mt3 mb0"},[_vm._v(_vm._s(_vm.$t("app.latestNews")))]),_vm._v(" "),_c('div',{staticClass:"flex flex-wrap news-container w-100"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"flex justify-center h5 w-100 mv3"},[_c('clip-loader',{attrs:{"loading":_vm.loading,"color":_vm.color,"size":_vm.size}})],1),_vm._v(" "),_c('carousel',{ref:"carousel",staticClass:"w-75-ns w-100",attrs:{"per-page":1,"paginationActiveColor":"#E6007E","paginationColor":"#ccc","loop":true,"autoplay":true,"autoplayTimeout":10000}},_vm._l((_vm.news),function(newsItem){return _c('slide',{key:newsItem.id,staticClass:"news-container pl2-l pr2-ns pt2 w-100"},[_c('news',{staticClass:"h-100",attrs:{"news":newsItem}})],1)}),1),_vm._v(" "),_c('div',{staticClass:"w-25 flex-ns dn flex-column"},_vm._l((_vm.news),function(newsItem,index){return _c('div',{key:newsItem.id,staticClass:"image-container pt2"},[_c('div',{staticClass:"pointer dim h-100 relative hide-child cover center background-center flex items-end",class:{'selected': _vm.selected(index)},style:({'background-image': ("url(" + (_vm.picture(newsItem)) + ")")}),on:{"click":function($event){return _vm.selectNews(index)}}})])}),0)],1)])}
var staticRenderFns = []


/***/ }),
/* 971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Banner_vue__ = __webpack_require__(437);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_85f2625e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Banner_vue__ = __webpack_require__(973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(972)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-85f2625e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Banner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_85f2625e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Banner_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_85f2625e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Banner_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 972 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner pt3-ns pt2 ph3 ph0-l mr2-l"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"flex justify-center w-100 mv3"},[_c('clip-loader',{attrs:{"loading":_vm.loading,"color":_vm.color,"size":_vm.size}})],1),_vm._v(" "),_c('carousel',{ref:"carousel",staticClass:"h-100 w-100",attrs:{"per-page":1,"loop":true,"autoplay":true,"autoplayTimeout":10000}},_vm._l((_vm.banners),function(banner){return _c('slide',{key:banner.id,staticClass:"h-100 w-100"},[_c('a',{staticClass:"banner w-100",attrs:{"href":banner.link,"target":"_blank"}},[_c('div',{staticClass:"image-container relative db w-100 banner cover center",style:({ 'background-image': 'url(' + _vm.picture(banner) + ')' })})])])}),1)],1)}
var staticRenderFns = []


/***/ }),
/* 974 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-primary w-100"},[_c('div',{staticClass:"flex justify-center"},[_c('div',{staticClass:"mw9-ns w-100 flex flex-wrap justify-between items-center ph3 pb5"},[_c('div',{staticClass:"flex di-ns justify-between w-100 w-auto-ns"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"flex justify-center"},[_c('a',{staticClass:"pa2 textColor",attrs:{"href":"https://www.facebook.com/BeatHeyOK/","target":"_blank"}},[_c('font-awesome-icon',{attrs:{"icon":['fab', 'facebook'],"size":"2x"}})],1),_vm._v(" "),_c('a',{staticClass:"pa2 textColor",attrs:{"href":"https://www.instagram.com/beatheyok/","target":"_blank"}},[_c('font-awesome-icon',{attrs:{"icon":['fab', 'instagram'],"size":"2x"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"flex justify-between w-50-l w-60-m w-100"},[_c('div',{staticClass:"textColor flex flex-column justify-start"},[_c('p',{staticClass:"b ph3"},[_vm._v(_vm._s(_vm.$t("footer.company")))]),_vm._v(" "),_c('router-link',{staticClass:"no-underline pv1 ph3 f6 pointer gray",attrs:{"to":{ name: 'general-terms-' + _vm.language },"target":"_blank"}},[_vm._v(_vm._s(_vm.$t("footer.termsOfUse"))+"\n          ")]),_vm._v(" "),_c('router-link',{staticClass:"no-underline pv1 ph3 f6 pointer gray",attrs:{"to":{ name: 'intellectual-prop-' + _vm.language },"target":"_blank"}},[_vm._v(_vm._s(_vm.$t("footer.intellectuallyProp"))+"\n          ")]),_vm._v(" "),_c('router-link',{staticClass:"no-underline pv1 ph3 f6 pointer gray",attrs:{"to":{ name: 'privacy-policy-' + _vm.language },"target":"_blank"}},[_vm._v(_vm._s(_vm.$t("footer.privacyPolicy"))+"\n          ")]),_vm._v(" "),_c('router-link',{staticClass:"no-underline pv1 ph3 f6 pointer gray",attrs:{"to":{ name: 'help' }}},[_vm._v(_vm._s(_vm.$t("footer.help"))+"\n          ")]),_vm._v(" "),_c('router-link',{staticClass:"no-underline pv1 ph3 f6 pointer gray",attrs:{"to":{ name: 'help' }}},[_vm._v(_vm._s(_vm.$t("footer.contact"))+"\n          ")])],1),_vm._v(" "),_c('div',{staticClass:"flex flex-column textColor justify-start h-100"},[_c('p',{staticClass:"b ph3"},[_vm._v(_vm._s(_vm.$t("footer.language.title")))]),_vm._v(" "),_c('button',{staticClass:"bn bg-primary ph3 f6 pv1 mv0 gray",class:{ 'pointer enabledButton': !_vm.isCurrentLanguage('es') },attrs:{"disabled":_vm.isCurrentLanguage('es')},on:{"click":function($event){return _vm.setLanguage('es')}}},[_vm._v(_vm._s(_vm.$t("footer.language.spanish")))]),_vm._v(" "),_c('button',{staticClass:"bn bg-primary ph3 f6 pv1 mv0 gray",class:{ 'pointer enabledButton': !_vm.isCurrentLanguage('en') },attrs:{"disabled":_vm.isCurrentLanguage('en')},on:{"click":function($event){return _vm.setLanguage('en')}}},[_vm._v(_vm._s(_vm.$t("footer.language.english")))]),_vm._v(" "),_c('button',{staticClass:"bn bg-primary ph3 f6 pv1 mv0 gray",class:{ 'pointer enabledButton': !_vm.isCurrentLanguage('pt') },attrs:{"disabled":_vm.isCurrentLanguage('pt')},on:{"click":function($event){return _vm.setLanguage('pt')}}},[_vm._v(_vm._s(_vm.$t("footer.language.portuguese")))])]),_vm._v(" "),_c('a',{staticClass:"mv3",attrs:{"href":"http://qr.afip.gob.ar/?qr=z2lwtWwTrNS5X9tbTtwmtw,,","target":"_blank"}},[_c('img',{staticClass:"h3",attrs:{"src":"/static/assets/DATAWEB.jpg","alt":"Dataweb"}})])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mh2 mv1 mw-100 h-100 w4 flex justify-start"},[_c('img',{staticClass:"h-100 w-100 pointer db-ns dn",attrs:{"src":__webpack_require__(71),"alt":"BeatHey Logo"}}),_vm._v(" "),_c('div',{staticClass:"dn-ns pv1 w-35"},[_c('img',{staticClass:"ph3 w-100 h-100 pointer",attrs:{"src":__webpack_require__(170),"alt":"BeatHey Logo"}})])])}]


/***/ }),
/* 976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-column items-center w-100 h-100 overflow-y-scroll"},[_c('div',{staticClass:"mw9-ns w-100"},[_c('div',{staticClass:"flex flex-wrap w-100"},[_c('div',{staticClass:"w-two-thirds-l w-100"},[_c('latest-news')],1),_vm._v(" "),_c('div',{staticClass:"w-third-l w-100 flex flex-column"},[_c('vinyl-contest-home'),_vm._v(" "),_c('banner')],1)]),_vm._v(" "),_c('div',{staticClass:"flex flex-wrap w-100"},[_c('div',{staticClass:"w-two-thirds-l w-100"},[_c('featured-playlist')],1),_vm._v(" "),_c('div',{staticClass:"w-third-l w-100 flex flex-column"},[_c('recommended')],1)])]),_vm._v(" "),_c('home-footer')],1)}
var staticRenderFns = []


/***/ }),
/* 977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_News_vue__ = __webpack_require__(439);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c41400e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_News_vue__ = __webpack_require__(979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(978)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_News_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c41400e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_News_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c41400e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_News_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 978 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100 h-100"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"flex justify-center items-center total-height"},[_c('clip-loader',{attrs:{"loading":_vm.loading,"color":_vm.color,"size":_vm.size}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],staticClass:"news-container w-100 h-100 flex"},[_c('div',{staticClass:"img-1 w-40 h-100 cover center background-center flex items-center",style:({ 'background-image': 'url(' + this.img1URL + ')' })}),_vm._v(" "),_c('div',{staticClass:"news-container-2 flex flex-column w-60 h-100"},[_c('div',{staticClass:"news-content w-100 flex flex-column pa4"},[_c('div',{staticClass:"news-header"},[_c('h2',{staticClass:"mb1 mt1 textColor"},[_vm._v(_vm._s(_vm.news.title))]),_vm._v(" "),_c('p',{staticClass:"i ma0 textColor"},[_vm._v(_vm._s(_vm.news.subtitle))])]),_vm._v(" "),_c('p',{staticClass:"news-text textColor",domProps:{"innerHTML":_vm._s(_vm.news.text)}})]),_vm._v(" "),_c('div',{staticClass:"img-2 w-100 h-100 cover center background-center flex items-center",style:({ 'background-image': 'url(' + this.img2URL + ')' })})])])])}
var staticRenderFns = []


/***/ }),
/* 980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Help_vue__ = __webpack_require__(440);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_598c98f3_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Help_vue__ = __webpack_require__(988);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(981)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-598c98f3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Help_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_598c98f3_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Help_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_598c98f3_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Help_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 981 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FaqsEs_vue__ = __webpack_require__(441);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ff13c0c_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FaqsEs_vue__ = __webpack_require__(984);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(983)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FaqsEs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ff13c0c_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FaqsEs_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ff13c0c_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FaqsEs_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 983 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"textColor"},_vm._l((6),function(n){return _c('div',{key:n,attrs:{"track-by":n}},[_c('p',{staticClass:"b"},[_vm._v(_vm._s(_vm.questions[n]))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.answers[n]))])])}),0)}
var staticRenderFns = []


/***/ }),
/* 985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FaqsEn_vue__ = __webpack_require__(442);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d3d1250_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FaqsEn_vue__ = __webpack_require__(987);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(986)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FaqsEn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d3d1250_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FaqsEn_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d3d1250_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FaqsEn_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 986 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"textColor"},_vm._l((6),function(n,i){return _c('div',{key:i,attrs:{"track-by":i}},[_c('p',{staticClass:"b"},[_vm._v(_vm._s(_vm.questions[i]))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.answers[i]))])])}),0)}
var staticRenderFns = []


/***/ }),
/* 988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100 ph5-l ph3-m ph2 flex flex-column items-center textColor overflow-y-scroll"},[_c('h1',{staticClass:"w-100 tc f1-ns f3"},[_vm._v(_vm._s(_vm.$t("help.title")))]),_vm._v(" "),_c('div',{staticClass:"w-100"},[_c('div',{staticClass:"flex flex-wrap justify-center w-100"},[_c('div',{staticClass:"w-50-ns w-100 ph3-ns ph1"},[_c('h2',{staticClass:"f3-ns f4 tl-ns tc bt bn-ns pt3 pt0-ns"},[_vm._v(_vm._s(_vm.$t("help.contactForm.title")))]),_vm._v(" "),(_vm.provider.name)?_c('span',[_vm._v("**"+_vm._s(_vm.$t("help.unsubscribe"))),_c('span',{staticClass:"bold ttu"},[_vm._v(_vm._s(this.provider.name))]),_vm._v(", "+_vm._s(_vm.$t("help.send"))+" "+_vm._s(this.provider.msj)+" "+_vm._s(_vm.$t("help.to"))+" "+_vm._s(this.provider.number))]):_vm._e(),_vm._v(" "),_c('form',{staticClass:"mtop",on:{"submit":function($event){$event.preventDefault();return _vm.sendEmail.apply(null, arguments)}}},[_c('div',{staticClass:"flex flex-wrap w-100"},[_c('div',{staticClass:"flex flex-column w-40-l w-100 mh1 textColor"},[_c('label',{staticClass:"b db mv1",attrs:{"for":"name"}},[_vm._v(_vm._s(_vm.$tc('users.name', 1))+":")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],staticClass:"w-100 ph1 input",attrs:{"id":"name","placeholder":_vm.$tc('users.name', 1)},domProps:{"value":(_vm.name)},on:{"blur":_vm.$v.name.$touch,"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}}),_vm._v(" "),(_vm.$v.name.$error && !_vm.$v.name.required)?_c('span',{staticClass:"errorText ma1 f7"},[_vm._v(_vm._s(_vm.$t("error.nameRequired")))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"flex flex-column w-40-l w-100 mh1 textColor"},[_c('label',{staticClass:"b db mv1",attrs:{"for":"email"}},[_vm._v(_vm._s(_vm.$t("users.email"))+":")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"w-100 ph1 input",attrs:{"id":"email","placeholder":_vm.$t('users.email')},domProps:{"value":(_vm.email)},on:{"blur":_vm.$v.email.$touch,"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),(_vm.$v.email.$error && !_vm.$v.email.required)?_c('span',{staticClass:"errorText ma1 f7"},[_vm._v(_vm._s(_vm.$t("error.emailRequired")))]):_vm._e(),_vm._v(" "),(_vm.$v.email.$error && !_vm.$v.email.email)?_c('span',{staticClass:"errorText ma1 f7"},[_vm._v(_vm._s(_vm.$t("error.emailInvallid")))]):_vm._e()])]),_vm._v(" "),_c('label',{staticClass:"b db mv1",attrs:{"for":"message"}},[_vm._v(_vm._s(_vm.$t("form.message"))+":")]),_vm._v(" "),(_vm.$v.message.$error && !_vm.$v.message.required)?_c('span',{staticClass:"errorText ma1 f7"},[_vm._v(_vm._s(_vm.$t("error.messageRequired")))]):_vm._e(),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.message),expression:"message"}],staticClass:"h4 f7 db w-100 ba pa2 br2 mb2 textAreaHelp",attrs:{"id":"message","name":"message"},domProps:{"value":(_vm.message)},on:{"blur":_vm.$v.message.$touch,"input":function($event){if($event.target.composing){ return; }_vm.message=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"w-100 flex justify-center"},[_c('input',{staticClass:"btn w-25 pointer",attrs:{"type":"submit"},domProps:{"value":_vm.$t('form.send')}})])])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"flex flex-column"},[_c('h1',{staticClass:"tc bt pt3 w-100 f3-ns f4"},[_vm._v(_vm._s(_vm.$t("help.faqs")))]),_vm._v(" "),_c('div',{staticClass:"mw8"},[_c(_vm.faqs,{tag:"component"})],1)])])}
var staticRenderFns = []


/***/ }),
/* 989 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Msisdn_vue__ = __webpack_require__(443);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
/* script */


/* template */
var __vue_render__, __vue_static_render_fns__
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Msisdn_vue__["a" /* default */],
  __vue_render__,
  __vue_static_render_fns__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Autologin_vue__ = __webpack_require__(444);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
/* script */


/* template */
var __vue_render__, __vue_static_render_fns__
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Autologin_vue__["a" /* default */],
  __vue_render__,
  __vue_static_render_fns__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Waiting_vue__ = __webpack_require__(445);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21e0ccc8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Waiting_vue__ = __webpack_require__(993);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(992)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Waiting_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21e0ccc8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Waiting_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21e0ccc8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Waiting_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 992 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"background-waiting",attrs:{"id":"app-wrapper"}},[_c('main',{staticClass:"main"},[_c('div',[_c('div',{staticClass:"flex flex-column items-center"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"mv2"},[_c('clip-loader',{attrs:{"loading":_vm.loading,"color":_vm.color,"size":_vm.size}})],1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex justify-center w-30 pb2"},[_c('img',{staticClass:"top-margin-2",attrs:{"src":__webpack_require__(994),"alt":"BeatHey Logo"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mv2"},[_c('h1',{staticClass:"waiting-msg"},[_vm._v("En breve serás redirigido a BeatHey!")])])}]


/***/ }),
/* 994 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProviderTyC_vue__ = __webpack_require__(446);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02ddf392_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProviderTyC_vue__ = __webpack_require__(997);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(996)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProviderTyC_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02ddf392_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProviderTyC_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02ddf392_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProviderTyC_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 996 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 997 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"tyc-wrapper"}},[_c('main',{staticClass:"main"},[_c('div',{staticClass:"container0"},[_c('div',{staticClass:"container1"},[_c('img',{staticClass:"logo",attrs:{"src":__webpack_require__(998),"alt":"","width":"216","height":"59"}}),_vm._v(" "),(_vm.showText)?_c('div',{staticClass:"container-body"},[_c('p',{staticClass:"titleTyC tyc"},[_vm._v("Términos y Condiciones")]),_vm._v(" "),_c('p',{staticClass:"tyc-text"},[_vm._v("BeatHey es una app que te da acceso a toda la música de artistas independientes. Servicio de suscripción diaria y mensual con renovación automática y para usuarios postpago con cargo al recibo. Costo diario: S/1.50 incl. IGV, costo mensual: S/12.90 incl. IGV. En la suscripción diaria recibirás un sms al día con un link para ingresar al portal del servicio, y en la suscripción mensual recibirás dos sms mensualmente. Para solicitar la cancelación del servicio envía un mensaje al 22122 con la palabra SALIR. Servicio exclusivo para clientes de Entel con terminales de tecnología GSM, 3G, 4G, LTE, con planes postpago vigentes y no vigentes, que tengan indispensablemente el servicio de DESCARGA DE CONTENIDOS y SMS PREMIUM aprovisionado y activo. La disponibilidad de los contenidos dependerá de cada modelo de celular. El cobro del servicio dependerá del plan tarifario contratado. Para planes Prepago el costo del Servicio se descontará del saldo de recargas prepago. La navegación por este sitio y descarga de contenidos genera costos por consumos de datos. Entel Perú no es responsable de este servicio, del contenido ni de la publicidad. El usuario se suscribe al Servicio declarando haber leído, comprendido y aceptado en su totalidad lo contenido en este documento, dejando constancia dando click en ACEPTAR, aceptando las condiciones y obligaciones del documento presente. Servicio provisto por Wazzup S.A.C - RUC 20510625588 Calle Elias Aguirre N°605 Miraflores, Lima -Perú, Lima, Perú.")])]):_c('div',{staticClass:"container-body"},[_vm._m(0)]),_vm._v(" "),_vm._m(1),_vm._v(" "),(!_vm.showText)?_c('div',{staticClass:"container-body"},[_c('p',{staticClass:"tyc-button",on:{"click":_vm.activateShowText}},[_vm._v("Términos y Condiciones")])]):_vm._e()])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"titleTyC index"},[_vm._v("\n              Bienvenido! presiona INGRESAR\n              "),_c('br'),_vm._v("\n              para acceder a toda nuestra música!\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"/home"}},[_c('img',{staticClass:"enter",attrs:{"src":__webpack_require__(999),"alt":"","width":"216","height":"59"}})])}]


/***/ }),
/* 998 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 999 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Landing_vue__ = __webpack_require__(447);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7cfd0de0_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Landing_vue__ = __webpack_require__(1004);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1001)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Landing_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7cfd0de0_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Landing_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7cfd0de0_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Landing_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1001 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1002 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1003 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header flex bg-black justify-between",attrs:{"id":"HeaderLNB"}},[_c('div',{staticClass:"fl flex w-25 items-center h-100"},[_c('div',{staticClass:"mh2 mv1 logo-container mw-100"},[_c('img',{staticClass:"h-100 w-100 pointer db-l dn",attrs:{"src":__webpack_require__(71),"alt":"BeatHey Logo"},on:{"click":_vm.goToHome}}),_vm._v(" "),_c('div',{staticClass:"dn-l pv1 isologo-container"},[_c('img',{staticClass:"w-100 h-100 pointer",attrs:{"src":__webpack_require__(170),"alt":"BeatHey Logo"},on:{"click":_vm.goToHome}})])])]),_vm._v(" "),_c('div',{staticClass:"fl flex mw-50 justify-center items-center ttu"},[(false)?_c('router-link',{staticClass:"link-primary ttu f5 flex items-center h-100 no-underline dib pa3 textColor",attrs:{"title":_vm.$t('app.360'),"to":{name:'360'}}},[_c('font-awesome-icon',{staticClass:"iconColor mr0 mr2-l",attrs:{"icon":"street-view"}}),_vm._v(" "),_c('span',{staticClass:"dn di-l"},[_vm._v(_vm._s(_vm.$t("app.360")))])],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"fl flex min-w-25 justify-end items-center iconColor"},[_c('clip-loader',{staticClass:"mh2",attrs:{"loading":_vm.loading,"color":_vm.color,"size":_vm.size}}),_vm._v(" "),(!_vm.loading && !_vm.isLoggedIn)?_c('div',{staticClass:"mr2 h-100 flex items-center"},[_c('div',{staticClass:"dn login"},[_c('div',{staticClass:"pr1 pointer ttu db customPosition"},[_c('router-link',{attrs:{"id":"LNB","to":{name: 'planes'},"title":"Planes"}},[_vm._v(_vm._s(_vm.$t("landing.plans")))])],1),_vm._v(" "),_c('span',{staticClass:"ph2 f5 dib-ns dn customPosition"},[_vm._v(" | ")]),_vm._v(" "),_c('div',{staticClass:"pr1 pointer ttu db btnLnb",on:{"click":_vm.login}},[_c('div',{staticClass:"customPosition"},[_vm._v("\n            "+_vm._s(_vm.$t("app.signin"))+" \n            "),_c('span',{staticClass:"ph2 ttl f5 dib-ns dn"},[_vm._v(_vm._s(_vm.$t("app.or")))]),_vm._v(" \n            "+_vm._s(_vm.$t("app.signup"))+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"pr1 pointer ttu btnLnbMobile",on:{"click":_vm.login}},[_c('div',{staticClass:"customPosition"},[_vm._v("\n            "+_vm._s(_vm.$t("app.signin"))+" \n          ")])]),_vm._v(" "),_c('div',{staticClass:"h-100"},[_c('div',{directives:[{name:"on-click-outside",rawName:"v-on-click-outside",value:(_vm.closeLoginDropdown),expression:"closeLoginDropdown"}],staticClass:"flex items-center h-100",on:{"click":_vm.loginDropdownTrigger}},[_c('font-awesome-icon',{staticClass:"iconColor pa2 pointer",attrs:{"icon":"bars"}})],1),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loginDropdown),expression:"loginDropdown"}],staticClass:"dropdown-content db absolute w5-ns w4 flex flex-column"},[_c('a',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLocale('es')),expression:"!isLocale('es')"}],staticClass:"pv2 ph3 f5 pointer w-100 ttu",on:{"click":function($event){return _vm.setLanguage('es')}}},[_vm._v(_vm._s(_vm.$t("footer.language.spanish")))]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLocale('en')),expression:"!isLocale('en')"}],staticClass:"pv2 ph3 f5 pointer w-100 ttu",on:{"click":function($event){return _vm.setLanguage('en')}}},[_vm._v(_vm._s(_vm.$t("footer.language.english")))]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLocale('pt')),expression:"!isLocale('pt')"}],staticClass:"pv2 ph3 f5 pointer w-100 ttu",on:{"click":function($event){return _vm.setLanguage('pt')}}},[_vm._v(_vm._s(_vm.$t("footer.language.portuguese")))]),_vm._v(" "),_c('router-link',{staticClass:"no-underline pv2 ph3 f5 pointer w-100 ttu iconColor",attrs:{"to":{ name: 'help' }}},[_vm._v(_vm._s(_vm.$t("footer.help"))+"\n            ")])],1)])],1)]):_vm._e(),_vm._v(" "),(!_vm.loading && _vm.isLoggedIn)?_c('div',{staticClass:"flex justify-end iconColor"},[_c('div',{directives:[{name:"on-click-outside",rawName:"v-on-click-outside",value:(_vm.closeDropdown),expression:"closeDropdown"}],staticClass:"relative iconColor"},[_c('div',{on:{"click":_vm.dropdownTrigger}},[(_vm.user)?_c('user-info',{staticClass:"mw5 pointer iconColor"}):_vm._e()],1),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.dropdown),expression:"dropdown"}],staticClass:"dropdown-content db absolute w5 flex flex-column iconColor"},[_c('router-link',{staticClass:"no-underline pv2 ph3 f5 pointer w-100",attrs:{"to":{ name: 'profile-info' }},nativeOn:{"click":function($event){return _vm.closeDropdown.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t("users.userMenu.myProfile"))+"\n            ")]),_vm._v(" "),(_vm.isProducer)?_c('router-link',{staticClass:"no-underline pv2 ph3 f5 pointer w-100",attrs:{"to":{ name: 'my-tracks' }},nativeOn:{"click":function($event){return _vm.closeDropdown.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t("users.userMenu.myTracks"))+"\n            ")]):_vm._e(),_vm._v(" "),_c('router-link',{staticClass:"no-underline pv2 ph3 f5 pointer w-100",attrs:{"to":{ name: 'my-playlists' }},nativeOn:{"click":function($event){return _vm.closeDropdown.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t("users.userMenu.myPlaylists"))+"\n            ")]),_vm._v(" "),_c('router-link',{staticClass:"no-underline pv2 ph3 f5 pointer w-100",attrs:{"to":{ name: 'my-favorites' }},nativeOn:{"click":function($event){return _vm.closeDropdown.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t("users.userMenu.myFavorites"))+"\n            ")]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLocale('es')),expression:"!isLocale('es')"}],staticClass:"pv2 ph3 f5 pointer w-100",on:{"click":function($event){return _vm.setLanguage('es')}}},[_vm._v(_vm._s(_vm.$t("footer.language.spanish")))]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLocale('en')),expression:"!isLocale('en')"}],staticClass:"pv2 ph3 f5 pointer w-100",on:{"click":function($event){return _vm.setLanguage('en')}}},[_vm._v(_vm._s(_vm.$t("footer.language.english")))]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLocale('pt')),expression:"!isLocale('pt')"}],staticClass:"pv2 ph3 f5 pointer w-100 ttu",on:{"click":function($event){return _vm.setLanguage('pt')}}},[_vm._v(_vm._s(_vm.$t("footer.language.portuguese")))]),_vm._v(" "),_c('router-link',{staticClass:"no-underline pv2 ph3 f5 pointer w-100",attrs:{"to":{ name: 'help' }},nativeOn:{"click":function($event){return _vm.closeDropdown.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t("users.userMenu.help"))+"\n            ")]),_vm._v(" "),_c('a',{staticClass:"no-underline pv2 ph3 f5 pointer w-100",on:{"click":_vm.logoutButton}},[_vm._v(_vm._s(_vm.$t("users.userMenu.logout")))])],1)])],1)]):_vm._e()],1)])}
var staticRenderFns = []


/***/ }),
/* 1004 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"landingContentDiv"},[_c('main',[_c('landing-nav-bar'),_vm._v(" "),_c('div',{staticClass:"flex flex-column items-center",staticStyle:{"height":"100vh"}},[_c('div',{staticClass:"flex flex-column items-center centerItem h-100 w-100 mainPage"},[_c('div',{staticClass:"mainTitle"},[_c('h1',{staticClass:"titleText ttu music"},[_vm._v(_vm._s(_vm.$t("landing.music")))]),_vm._v(" "),_c('h3',{staticClass:"titleText ttu"},[_vm._v(_vm._s(_vm.$t("landing.title")))])]),_vm._v(" "),_c('div',{staticClass:"Texto"},[_c('h3',{staticClass:"h3"},[_vm._v(_vm._s(_vm.$t("landing.description.t1")))]),_vm._v(" "),_c('h3',{staticClass:"h3"},[_vm._v(_vm._s(_vm.$t("landing.description.t2")))]),_vm._v(" "),_c('h3',{staticClass:"h3"},[_vm._v(_vm._s(_vm.$t("landing.description.t3")))])]),_vm._v(" "),_c('div',{staticClass:"buttonContainerLanding flex-column items-center"},[_c('p',{staticClass:"Texto2"},[_vm._v(_vm._s(_vm.$t("landing.leyend")))]),_vm._v(" "),_c('div',{staticClass:"flex landingButtons"},[_c('router-link',{staticClass:"btnPildoraLeft",attrs:{"title":"Oyendo","to":{name: 'oyendo'}}},[_vm._v(_vm._s(_vm.$t("landing.button1")))]),_vm._v(" "),_c('router-link',{staticClass:"btnPildoraRigth",attrs:{"title":"Creando","to":{name: 'creando'}}},[_vm._v(_vm._s(_vm.$t("landing.button2")))])],1)])])]),_vm._v(" "),_c('div',{staticClass:"w-100"},[_c('home-footer')],1),_vm._v(" "),_c('payment-modal')],1)])}
var staticRenderFns = []


/***/ }),
/* 1005 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Oyendo_vue__ = __webpack_require__(449);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_279cb6e0_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Oyendo_vue__ = __webpack_require__(1007);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1006)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Oyendo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_279cb6e0_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Oyendo_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_279cb6e0_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Oyendo_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1006 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1007 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"landingContentDiv"},[_c('main',{staticClass:"h-100 w-100"},[_c('landing-nav-bar'),_vm._v(" "),_c('div',{staticClass:"flex flex-column items-center padreOyendo"},[_c('div',{staticClass:"Oyendo flex flex-column items-center w-100",attrs:{"id":"Oyendo"}},[_c('div',{staticClass:"flex flex-column items-center justify-center mainContent"},[_c('div',{staticClass:"flex flex-column"},[_c('h3',{staticClass:"OyendoTitle"},[_vm._v(_vm._s(_vm.$t("landing.oyendo.title")))])]),_vm._v(" "),_c('div',{staticClass:"flex flex-column"},[_c('carousel',{staticClass:"Carousel2",attrs:{"per-page":1,"navigationEnabled":false,"paginationEnabled":false,"paginationActiveColor":"#FF0085","paginationColor":"#fff","loop":true,"autoplay":true,"autoplayTimeout":5000,"hover-cancel-play":false}},[_c('slide',[_c('div',{staticClass:"flex flex-column justify-center"},[_c('div',{staticClass:"flex justify-center flex-wrap items-center"},[_c('div',{staticClass:"OyendoText"},[_c('span',{staticClass:"OyendoText"},[_vm._v(_vm._s(_vm.$t("landing.oyendo.carousel.text1"))+" ")])])])])]),_vm._v(" "),_c('slide',[_c('div',{staticClass:"flex flex-column justify-center"},[_c('div',{staticClass:"flex justify-center flex-wrap items-center"},[_c('div',{staticClass:"OyendoText"},[_c('span',{staticClass:"OyendoText"},[_vm._v(_vm._s(_vm.$t("landing.oyendo.carousel.text2"))+" ")])])])])]),_vm._v(" "),_c('slide',[_c('div',{staticClass:"flex flex-column justify-center"},[_c('div',{staticClass:"flex justify-center flex-wrap items-center"},[_c('div',{staticClass:"OyendoText"},[_c('span',{staticClass:"OyendoText"},[_vm._v(_vm._s(_vm.$t("landing.oyendo.carousel.text3")))])])])])])],1)],1),_vm._v(" "),_c('div',{staticClass:"flex flex-column items-center ffblack sumate"},[_c('h1',{staticClass:"m-0"},[_vm._v(_vm._s(_vm.$t("landing.join")))]),_vm._v(" "),_c('h2',{staticClass:"m-0"},[_vm._v(_vm._s(_vm.$t("landing.joinText")))]),_vm._v(" "),_c('router-link',{staticClass:"btnPildoraPlanesO ffbold",attrs:{"to":{name: 'planes'},"title":"Planes"}},[_vm._v(_vm._s(_vm.$t("landing.oyendo.button")))])],1)])])]),_vm._v(" "),_c('home-footer')],1)])}
var staticRenderFns = []


/***/ }),
/* 1008 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Creando_vue__ = __webpack_require__(450);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7adc03d4_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Creando_vue__ = __webpack_require__(1010);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1009)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Creando_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7adc03d4_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Creando_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7adc03d4_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Creando_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1009 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1010 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"landingContentDiv"},[_c('main',{staticClass:"h-100 w-100"},[_c('landing-nav-bar'),_vm._v(" "),_c('div',{staticClass:"flex flex-column items-center padreCreando"},[_c('div',{staticClass:"Creando flex flex-column items-center w-100",attrs:{"id":"Creando"}},[_c('div',{staticClass:"flex flex-column items-center justify-center mainContentC"},[_c('div',{staticClass:"flex flex-column"},[_c('h3',{staticClass:"CreandoTitle"},[_vm._v(_vm._s(_vm.$t("landing.creando.title")))])]),_vm._v(" "),_c('div',{staticClass:"flex flex-column Carousel1"},[_c('carousel',{attrs:{"per-page":1,"navigationEnabled":false,"paginationEnabled":false,"paginationActiveColor":"#FF0085","paginationColor":"#fff","loop":true,"autoplay":true,"autoplayTimeout":5000,"hover-cancel-play":false}},[_c('slide',[_c('div',{staticClass:"flex flex-column justify-center"},[_c('div',{staticClass:"flex justify-center flex-wrap items-center"},[_c('div',{staticClass:"CreandoText"},[_c('span',[_vm._v(_vm._s(_vm.$t("landing.creando.carousel.text1")))])])])])]),_vm._v(" "),_c('slide',[_c('div',{staticClass:"flex flex-column justify-center"},[_c('div',{staticClass:"flex justify-center flex-wrap items-center"},[_c('div',{staticClass:"CreandoText"},[_c('span',[_vm._v(_vm._s(_vm.$t("landing.creando.carousel.text2")))])])])])]),_vm._v(" "),_c('slide',[_c('div',{staticClass:"flex flex-column justify-center"},[_c('div',{staticClass:"flex justify-center flex-wrap items-center"},[_c('div',{staticClass:"CreandoText"},[_c('span',[_vm._v(_vm._s(_vm.$t("landing.creando.carousel.text3")))])])])])])],1)],1),_vm._v(" "),_c('div',{staticClass:"flex flex-column items-center ffblack"},[_c('h1',{staticClass:"m-0"},[_vm._v(_vm._s(_vm.$t("landing.join")))]),_vm._v(" "),_c('h2',{staticClass:"m-0"},[_vm._v(_vm._s(_vm.$t("landing.joinText")))]),_vm._v(" "),_c('router-link',{staticClass:"btnPildoraPlanes ffbold",attrs:{"to":{name: 'planes'},"title":"Planes"}},[_vm._v(_vm._s(_vm.$t("landing.oyendo.button")))])],1)])])]),_vm._v(" "),_c('home-footer')],1)])}
var staticRenderFns = []


/***/ }),
/* 1011 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Planes_vue__ = __webpack_require__(451);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20f2fc1c_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Planes_vue__ = __webpack_require__(1013);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1012)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Planes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20f2fc1c_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Planes_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20f2fc1c_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Planes_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1012 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1013 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"landingContentDiv"},[_c('main',{staticClass:"h-100 w-100"},[_c('landing-nav-bar'),_vm._v(" "),_c('div',{staticClass:"flex flex-column w-100 mainPagePlanes"},[_c('div',{staticClass:"centerPlanes"},[_c('div',[_c('h5',{staticClass:"PlanesTitle"},[_vm._v(_vm._s(_vm.$t("landing.planes.title")))]),_vm._v(" "),_c('p',{staticClass:"PlanesText"},[_vm._v(_vm._s(_vm.$t("landing.planes.leyend")))]),_vm._v(" "),_c('div',{staticClass:"claseprueba"},[_c('div',{staticClass:"claseprueba1 mainPagePlanes freePlan"},[_c('div',{staticClass:"bg-Planes"},[_c('div',{staticClass:"titleDiv"},[_c('h3',{staticClass:"listTitle"},[_vm._v(" "+_vm._s(_vm.$t("users.userType.free"))+" "),_c('img',{staticClass:"rockIcone",attrs:{"src":__webpack_require__(1014),"title":"Icono Rock"}})])]),_vm._v(" "),_c('div',[_c('ul',{staticClass:"PlanesList"},[_c('li',[_vm._v(_vm._s(_vm.$t("landing.planes.free.text1")))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.$t("landing.planes.free.text2")))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.$t("landing.planes.free.text3")))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"PlanesPricing freePricing"},[_vm._v(_vm._s(_vm.$t("users.subscription.free"))+" ")])])])]),_vm._v(" "),_c('div',{staticClass:"claseprueba1 mainPagePlanes"},[_c('div',{staticClass:"bg-Planes"},[_c('div',{staticClass:"titleDiv"},[_c('h3',{staticClass:"listTitle"},[_vm._v(" "+_vm._s(_vm.$t("users.userType.musicFan"))+" ")])]),_vm._v(" "),_c('div',[_c('ul',{staticClass:"PlanesList"},[_c('li',[_vm._v(_vm._s(_vm.$t("landing.planes.fan.text1")))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.$t("landing.planes.fan.text2")))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.$t("landing.planes.fan.text3")))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.$t("landing.planes.fan.text4")))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.$t("landing.planes.fan.text5")))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.$t("landing.planes.fan.text6")))])]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.language === 'es')?_c('p',{staticClass:"PlanesPricing"},[_vm._v(_vm._s(_vm.$t("users.subscription.currency"))+" "+_vm._s(_vm.pricing[0].currency_override.ARS)+" ")]):_vm._e(),_vm._v(" "),(_vm.language === 'en')?_c('p',{staticClass:"PlanesPricing"},[_vm._v(_vm._s(_vm.$t("users.subscription.currency"))+" "+_vm._s(_vm.pricing[0].amount)+" ")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"claseprueba1 mainPagePlanes"},[_c('div',{staticClass:"bg-Planes"},[_c('div',{staticClass:"titleDiv"},[_c('h3',{staticClass:"listTitle"},[_vm._v(_vm._s(_vm.$t("users.userType.producer")))])]),_vm._v(" "),_c('div',[_c('ul',{staticClass:"PlanesList"},[_c('li',{staticClass:"EndTitle"},[_vm._v(_vm._s(_vm.$t("landing.planes.artist.header")))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.$t("landing.planes.artist.text1")))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.$t("landing.planes.artist.text2")))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.$t("landing.planes.artist.text3")))])]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.language === 'es')?_c('p',{staticClass:"PlanesPricing"},[_vm._v(_vm._s(_vm.$t("users.subscription.currency"))+" "+_vm._s(_vm.pricing[0].currency_override.ARS)+" ")]):_vm._e(),_vm._v(" "),(_vm.language === 'en')?_c('p',{staticClass:"PlanesPricing"},[_vm._v(_vm._s(_vm.$t("users.subscription.currency"))+" "+_vm._s(_vm.pricing[0].amount)+" ")]):_vm._e()])])])])])]),_vm._v(" "),_c('div',{staticClass:"buttonContainer",on:{"click":_vm.login}},[_c('p',{staticClass:"btnPlanesLeft"},[_vm._v("\n          "+_vm._s(_vm.$t("app.signin"))+" \n          "+_vm._s(_vm.$t("app.or"))+"\n          "+_vm._s(_vm.$t("app.signup"))+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"w-100 claseprueba3"},[_c('home-footer')],1)],1)])}
var staticRenderFns = []


/***/ }),
/* 1014 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1015 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LandingMK_vue__ = __webpack_require__(452);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_214eba37_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LandingMK_vue__ = __webpack_require__(1017);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1016)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LandingMK_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_214eba37_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LandingMK_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_214eba37_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LandingMK_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1016 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1017 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"landingContentDivMK"},[_c('main',[_c('header',{staticClass:"flex bg-black justify-between",attrs:{"id":"HeaderLNB"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"fl flex min-w-25 justify-end items-center iconColor hamburger"},[_c('clip-loader',{staticClass:"mh2",attrs:{"loading":_vm.loading,"color":_vm.color,"size":_vm.size}}),_vm._v(" "),(!_vm.loading && !_vm.isLoggedIn)?_c('div',{staticClass:"mr2 h-100 flex items-center"},[_c('div',{staticClass:"dn login"},[_c('div',{staticClass:"pr1 pointer ttu db btnLnb"},[_c('div',{staticClass:"customPositionMK"},[_c('a',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLocale('es')),expression:"!isLocale('es')"}],staticClass:"pv2 ph3 f5 pointer w-100 ttu",on:{"click":function($event){return _vm.setLanguage('es')}}},[_vm._v(_vm._s(_vm.$t("footer.language.spanish")))]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLocale('en')),expression:"!isLocale('en')"}],staticClass:"pv2 ph3 f5 pointer w-100 ttu",on:{"click":function($event){return _vm.setLanguage('en')}}},[_vm._v(_vm._s(_vm.$t("footer.language.english")))])])])])]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"flex flex-column items-center"},[_c('div',{staticClass:"flex flex-column items-center centerItem h-100 w-100"},[_c('h1',{staticClass:"titleTextMK accent"},[_c('span',{staticClass:"MusicMK textColor"},[_vm._v(_vm._s(_vm.$t("landing.music")))]),_vm._v(" "+_vm._s(_vm.$t("landing.title"))+" ")]),_vm._v(" "),_c('p',{staticClass:"TextoMK"},[_vm._v(_vm._s(_vm.$t("landing.subtitle")))])]),_vm._v(" "),_c('div',{staticClass:"buttonContainerMK",on:{"click":_vm.login}},[_c('p',{staticClass:"btnPlanesLeftMK ttu"},[_vm._v("\n          "+_vm._s(_vm.$t("app.signin"))+" \n          "),_c('span',{staticClass:"ph2 ttl f5 dib-ns dn"},[_vm._v(_vm._s(_vm.$t("app.or")))]),_vm._v(" \n          "+_vm._s(_vm.$t("app.signup"))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"h-100 w-100"},[_c('div',{staticClass:"flex flex-column w-100"},[_c('div',{staticClass:"centerPlanesMK"},[_c('div',[_c('h5',{staticClass:"PlanesTitleMK"},[_vm._v(_vm._s(_vm.$t("landing.planes.title")))]),_vm._v(" "),_c('p',{staticClass:"PlanesTextMK"},[_vm._v(_vm._s(_vm.$t("landing.planes.leyend")))]),_vm._v(" "),_c('div',{staticClass:"clasepruebaMK"},[_c('div',{staticClass:"claseprueba1MK"},[_c('div',{staticClass:"bg-PlanesMK"},[_c('div',{staticClass:"titleDivMK"},[_c('h3',{staticClass:"listTitleMK"},[_vm._v(" "+_vm._s(_vm.$t("users.userType.musicFan"))+" ")])]),_vm._v(" "),_c('div',[_c('ul',{staticClass:"PlanesListMK"},[_c('li',{attrs:{"type":"square"}},[_vm._v(_vm._s(_vm.$t("landing.planes.fan.text1")))]),_vm._v(" "),_c('li',{attrs:{"type":"square"}},[_vm._v(_vm._s(_vm.$t("landing.planes.fan.text2")))]),_vm._v(" "),_c('li',{attrs:{"type":"square"}},[_vm._v(_vm._s(_vm.$t("landing.planes.fan.text3")))]),_vm._v(" "),_c('li',{attrs:{"type":"square"}},[_vm._v(_vm._s(_vm.$t("landing.planes.fan.text4")))]),_vm._v(" "),_c('li',{attrs:{"type":"square"}},[_vm._v(_vm._s(_vm.$t("landing.planes.fan.text5")))]),_vm._v(" "),_c('li',{attrs:{"type":"square"}},[_vm._v(_vm._s(_vm.$t("landing.planes.fan.text6")))])]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.isLocale('es'))?_c('p',{staticClass:"PlanesPricingMK"},[_vm._v(_vm._s(_vm.$t("users.subscription.currency"))+" "+_vm._s(_vm.pricing[0].currency_override.ARS)+" ")]):_vm._e(),_vm._v(" "),(_vm.isLocale('en'))?_c('p',{staticClass:"PlanesPricingMK"},[_vm._v(_vm._s(_vm.$t("users.subscription.currency"))+" "+_vm._s(_vm.pricing[0].amount)+" ")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"claseprueba1MK"},[_c('div',{staticClass:"bg-PlanesMK"},[_c('div',{staticClass:"titleDivMK"},[_c('h3',{staticClass:"listTitleMK"},[_vm._v(_vm._s(_vm.$t("users.userType.producer")))])]),_vm._v(" "),_c('div',[_c('ul',{staticClass:"PlanesListMK"},[_c('li',{staticClass:"EndTitleMK",attrs:{"type":"none"}},[_vm._v(_vm._s(_vm.$t("landing.planes.artist.header")))]),_vm._v(" "),_c('li',{attrs:{"type":"square"}},[_vm._v(_vm._s(_vm.$t("landing.planes.artist.text1")))]),_vm._v(" "),_c('li',{attrs:{"type":"square"}},[_vm._v(_vm._s(_vm.$t("landing.planes.artist.text2")))]),_vm._v(" "),_c('li',{attrs:{"type":"square"}},[_vm._v(_vm._s(_vm.$t("landing.planes.artist.text3")))])]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.isLocale('es'))?_c('p',{staticClass:"PlanesPricingMK"},[_vm._v(_vm._s(_vm.$t("users.subscription.currency"))+" "+_vm._s(_vm.pricing[0].currency_override.ARS)+" ")]):_vm._e(),_vm._v(" "),(_vm.isLocale('en'))?_c('p',{staticClass:"PlanesPricingMK"},[_vm._v(_vm._s(_vm.$t("users.subscription.currency"))+" "+_vm._s(_vm.pricing[0].amount)+" ")]):_vm._e()])])])])])]),_vm._v(" "),_c('div',{staticClass:"w-100 claseprueba3MK"},[_c('home-footer')],1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fl flex w-25 items-center h-100"},[_c('div',{staticClass:"mh2 mv1 logo-container mw-100"},[_c('img',{staticClass:"h-100 w-100 db-l dn",attrs:{"src":__webpack_require__(71),"alt":"BeatHey Logo"}}),_vm._v(" "),_c('div',{staticClass:"dn-l pv1 isologo-container"},[_c('img',{staticClass:"w-100 h-100",attrs:{"src":__webpack_require__(170),"alt":"BeatHey Logo"}})])])])}]


/***/ }),
/* 1018 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentsMK_vue__ = __webpack_require__(453);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0edd0306_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentsMK_vue__ = __webpack_require__(1020);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1019)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentsMK_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0edd0306_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentsMK_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0edd0306_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentsMK_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1019 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"landingContentDivPayment"},[_c('main',[_c('payment-modal')],1)])}
var staticRenderFns = []


/***/ }),
/* 1021 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IntellectualPropEs_vue__ = __webpack_require__(454);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0160d6fa_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IntellectualPropEs_vue__ = __webpack_require__(1023);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1022)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0160d6fa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IntellectualPropEs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0160d6fa_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IntellectualPropEs_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0160d6fa_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IntellectualPropEs_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1022 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1023 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"terms flex justify-center"},[_c('div',{staticClass:"mw7"},[_c('button',{staticClass:"backButton"},[_c('router-link',{staticClass:"rlink",attrs:{"to":{name:'home'}}},[_vm._v("Volver")])],1),_vm._v(" "),_c('h1',{staticClass:"mainTitleTyCandPolicy"},[_vm._v("Política de Propiedad Intelectual")]),_vm._v(" "),_vm._m(0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mainContentTyCandPolicy"},[_vm._v("\n            Beathey ha adoptado la siguiente política general hacia las reclamaciones de infracción en materia\n            de propiedad intelectual propiedad de o controlada por terceros de conformidad con la  Ley de\n            Derechos de Autor del Milenio Digital . La dirección del agente designado de la empresa para\n            recibir la notificación de la infracción reclamada (\"Agente Designado\") aparece al final de esta\n            política.\n            Es política de Beathey (1) bloquear el acceso a, o eliminar el material que entienda de buena fe\n            que es propiedad intelectual de un tercero (por ejemplo, derechos de autor, marcas, secretos\n            comerciales, etc.) que se han copiado y distribuido de manera ilegal por cualquiera de nuestros\n            anunciantes, afiliados, proveedores de contenido, miembros o usuarios; y (2) retirar y suspender\n            el servicio a los reincidentes. Un infractor reincidente es un usuario para el que Beathey ha\n            recibido más de dos avisos de supuestas infracciones o para los que Beathey ha tenido que\n            eliminar el contenido más de dos veces. A pesar de lo anterior, Beathey se reserva el derecho de\n            interrumpir la cuenta de cualquier usuario por actividades ilícitas graves en la determinación\n            exclusiva y discreción de Beathey.\n\n            "),_c('h3',[_vm._v("A. Procedimiento para la presentación de informes invocó la infracción:")]),_vm._v("\n\n            Si cree que el material o contenido que se encuentre o sea accesible a través del Sitio Web infringe\n            un derecho de propiedad intelectual que Ud. posea o controle, por favor, envíe un aviso de\n            infracción que contenga solamente la siguiente información al agente mencionado abajo. Tenga\n            en cuenta que usted será responsable de los daños, incluidos los gastos y honorarios de abogados,\n            si afirma que el contenido o una actividad infringe sus derechos de autor. Su comunicación debe\n            incluir todos los siguientes elementos:\n\n            "),_c('ol',[_c('li',[_vm._v("Una firma física o electrónica de una persona autorizada para actuar en nombre\n            del propietario de la obra que ha sido supuestamente infringido;")]),_vm._v(" "),_c('li',[_vm._v("Identificación de las obras o materiales que se ha infringido;")]),_vm._v(" "),_c('li',[_vm._v("La identificación del material que presuntamente infrinja derechos de propiedad\n            intelectual, incluyendo la ubicación de aquel material que el propietario solicita\n            remover, con el suficiente detalle para que la empresa sea capaz de encontrar y\n            verificar su existencia; Proporcionar URL en el cuerpo de un correo electrónico\n            es la mejor manera de ayudar a localizar el contenido rápidamente.")]),_vm._v(" "),_c('li',[_vm._v("Información lo suficientemente razonable que nos permita ponernos en contacto\n            con usted, como una dirección, número de teléfono y, si está disponible, una\n            dirección de correo electrónico donde usted pueda ser contactado;")]),_vm._v(" "),_c('li',[_vm._v("Si denuncia una infracción a los derechos de autor, una declaración que diga:\n            \"Juro, bajo pena de perjurio que soy el propietario del copyright o estoy\n            autorizado para actuar en nombre del propietario de un derecho exclusivo que\n            presuntamente se ha infringido, y que la información de esta notificación es\n            exacta. Entiendo de buena fe que el uso de los materiales protegidos descritos\n            anteriormente como presuntamente infractores no está autorizado por el\n            propietario de los derechos de autor, su agente o la ley \".")]),_vm._v(" "),_c('li',[_vm._v("Si denuncia una infracción de marca, una declaración que diga: \"Juro, bajo pena\nde perjurio que soy el propietario de la marca o estoy autorizado para actuar en\nnombre del propietario de un derecho exclusivo que presuntamente se ha\ninfringido, y que la información de esta notificación es exacta. Entiendo de buena\nfe que el uso de los materiales descritos anteriormente no está autorizado por el\npropietario de los derechos de autor, su agente o la ley \".")])]),_vm._v("\n\n            Tenga en cuenta que una copia de su aviso legal se enviará a la persona obligada a suministrar el\nsupuesto contenido infractor.\n            Por favor no incluya ninguna información en su informe aparte de los elementos anteriores.\n\n            "),_c('h3',[_vm._v("B. Una vez que la notificación de infracción es recibida por el agente designado:")]),_vm._v("\n            Es política de la Beathey:\n\n            "),_c('ol',[_c('li',[_vm._v("eliminar o desactivar el acceso al material infractor;")]),_vm._v(" "),_c('li',[_vm._v("notificar al proveedor de contenido, miembro o usuario de que se ha eliminado o\n            desactivado el acceso al material; y")]),_vm._v(" "),_c('li',[_vm._v("eliminar del sistema el material infractor proporcionado por los reincidentes, y\n            Beathey dará por terminado el acceso al sistema a los proveedores o usuarios del\n            material infractor.")])]),_vm._v(" "),_c('h3',[_vm._v("C. Procedimiento para suministrar una descargo a la notificación al agente designado:")]),_vm._v("\n\n            Si el proveedor de contenidos, miembro o usuario cree que el material que se ha eliminado, o\n            cuyo acceso se ha deshabilitado, o bien no está infringiendo derechos, o el proveedor de\n            contenidos, miembro o usuario cree que tiene el derecho a publicar y utilizar dicho material\n            propiedad del titular de los derechos de la propiedad intelectual, o de conformidad con la ley, el\n            proveedor de contenidos, miembro o usuario debe enviar una contranotificaciòn que contenga la\n            siguiente información al agente mencionado a continuación:\n\n            "),_c('ol',[_c('li',[_vm._v("Una firma física o electrónica del proveedor de contenido, miembro o usuario;")]),_vm._v(" "),_c('li',[_vm._v("La identificación del material que ha sido eliminado o cuyo acceso ha sido\n            inhabilitado y el lugar en el que apareció el material antes de ser retirado o\n            desactivado;")]),_vm._v(" "),_c('li',[_vm._v("Una declaración del proveedor de contenidos, miembro o usuario manifestando\n            de buena fe que el material fue eliminado o inhabilitado como consecuencia de un\n            error o una identificación errónea del material; y")]),_vm._v(" "),_c('li',[_vm._v("Datos del proveedor de contenido, usuario o miembro, y, en su caso, dirección de\n            correo electrónico y una declaración de que dicha persona o entidad acepta la\n            jurisdicción de la Corte Federal del distrito judicial en el que el proveedor de\n            contenidos, miembro o usuario tenga su domicilio, o si, la dirección de usuario o\n            proveedor de contenidos o miembro se encuentra fuera de los Estados Unidos, por\n            cualquier distrito judicial en el que se encuentra la empresa, y que dicha persona o entidad aceptará la notificación de la demanda/actos procesales de la persona que\n            brindó la notificación de la presunta violación.")])]),_vm._v("\n\n            Si una contranotificación es recibida por el agente designado, Beathey puede enviar una copia de\n            la contranotificación al reclamante inicial informando que Beathey puede reemplazar el material\n            retirado o volver a habilitar el acceso a ella en 10 días hábiles. A menos que el propietario inicie\n            una acción judicial para obtener una orden judicial contra el proveedor de contenidos, miembro o\n            usuario, el material extraído se puede sustituir o restituir su acceso a ella en 10 a 14 días hábiles o\n            más después de la recepción de la respuesta a una notificación, a discreción de la empresa.\n            Por favor, póngase en contacto con Agente designado por la empresa para recibir la notificación\n            de la infracción reclamada en la siguiente dirección:  copyright@Beathey.com  , o por correo a:\n            \n            "),_c('p',[_vm._v("Las quejas DMCA"),_c('br'),_vm._v("\n            Beathey"),_c('br'),_vm._v(" \n            *******"),_c('br'),_vm._v(" \n            *********")]),_vm._v("\n\n            Por favor tener en cuenta que podemos procesar las reclamaciones presentadas por correo\n            electrónico a "),_c('a',{attrs:{"href":"mailto:copyright@beathey.com"}},[_vm._v("copyright@beathey.com")]),_vm._v("  mucho más rápidamente que las presentadas a la dirección\n            arriba señalada.\n        ")])}]


/***/ }),
/* 1024 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicyEs_vue__ = __webpack_require__(455);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e3590a8_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicyEs_vue__ = __webpack_require__(1026);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1025)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9e3590a8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicyEs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e3590a8_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicyEs_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e3590a8_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicyEs_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1025 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1026 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"terms flex justify-center"},[_c('div',{staticClass:"mw7"},[_c('button',{staticClass:"backButton"},[_c('router-link',{staticClass:"rlink",attrs:{"to":{name:'home'}}},[_vm._v("Volver")])],1),_vm._v(" "),_c('h1',{staticClass:"mainTitleTyCandPolicy"},[_vm._v("Política de Privacidad y Cookies")]),_vm._v(" "),_vm._m(0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"mainContentTyCandPolicy"},[_vm._v("\n              Esta política de privacidad describe los tipos de información que Beathey puede recopilar\n              sobre usted a través de nuestro Sitio web, y lo que podemos hacer con esa información. Nos\n              reservamos el derecho a modificar esta Política en cualquier momento mediante la publicación\n              de la versión actualizada aquí. Por lo tanto, por favor, consulte esta página para\n              actualizaciones cada vez que visita cualquiera de nuestros Sitios, y también podemos optar por\n              notificar a los usuarios registrados de los cambios importantes a través de correo electrónico u\n              otros medios. Esta política no se aplica a la información que pueda ser recopilada fuera de\n              línea."),_c('br'),_c('br'),_vm._v(" \n              ¿Qué información se recopila? Generalmente se recopila dos clases de información a través\n              del Sitio: \"información personal\" sobre usted, que usted nos proporciona, y la \"información no\n              personal\" sobre usted, su equipo y la tecnología y su uso del Sitio, que por sí solo no lo\n              identifica personalmente. A fin de que pueda convertirse en un usuario registrado, hacer\n              compras, o vender contenido a través de nuestro Sitio, nos tendrá que proporcionar cierta\n              información personal, como su edad, nombre, razón social en su caso, dirección de correo\n              electrónico, dirección postal y número de teléfono durante el proceso de registro. Cuando se\n              realizan los pagos a través del Sitio, es posible que tenga que proporcionar información de su\n              tarjeta de crédito, fecha de vencimiento, dirección de facturación y detalles relacionados (que\n              pueden incluir su número de documento o identificación fiscal) a nuestros proveedores de\n              servicios de terceros, tales como Paypal, y dicha información puede ser almacenada y utilizada\n              para la facturación y servicios de pago por dichos proveedores de servicios de pago. También\n              podemos pedir información personal adicional de vez en cuando, como por ejemplo, el género\n              y el nivel de ingresos, en relación con las promociones en línea, concursos, sorteos, encuestas\n              y otros programas, siendo su decisión si desea o no proporcionar esa información para\n              participar en esos programas. También podemos recopilar información no personal de los\n              visitantes y los usuarios registrados en el Sitio. Podemos pedirle también que proporcione\n              cierta información, como sus preferencias musicales, sus artistas favoritos, géneros, etc.\n              También se le podrá requerir datos técnicos geográficos y de uso e información tales como el\n              tipo de navegador, proveedor de Internet, sistema operativo, de registro, la dirección IP, el\n              código postal o la ubicación, y si usted compra o vende contenido a través del Sitio vamos a\n              hacer un seguimiento de las compras y / o ventas. Dicha información puede ser combinada con\n              su información personal. Si se comunica con nosotros o nuestros representantes por e-mail o a\n              través del Sitio, o si registra información sobre alguno de los foros, chats, páginas de perfil,\n              retroalimentación, el servicio al cliente de chat, etc, podemos recopilar, conservar y utilizar\n              cualquier información que usted proporcione."),_c('br'),_c('br'),_vm._v(" \n              ¿Utilizamos \"cookies\" o \"web beacons\"? nosotros utilizamos \"cookies\" para recoger datos de\n              uso del sitio y para mejorar su experiencia en los Sitios y nuestro servicio en general. Una\n              \"cookie\" es un pequeño archivo de datos transferido al ordenador para el acceso en futuras\n              visitas al sitio, lo que nos puede decir que usted (o alguien que use el mismo equipo o\n              dirección IP) visitó nuestro Sitio antes, etc. Usted puede dejar de aceptar cookies configurando\n              su navegador de Internet, pero esto probablemente no nos permita reconocerlo a usted o sus\n              preferencias en futuras visitas, por lo que puede tener que volver a introducir cierta\n              información. Nuestro Sitio y e-mails pueden contener imágenes electrónicas conocidas como\n              \"contadores de visitantes\". Estos son archivos que nos permiten contar los visitantes de\n              nuestro Sitio, para saber si un anuncio ha sido visto o si un mensaje ha sido abierto o reenviado, o para servir contenidos o servicios en particular. Balizas Web recogen información\n              no personal limitada, incluyendo el número de baliza, hora y fecha de una vista de página o\n              correo electrónico, y una descripción de la página en la que reside el web beacon, todos los\n              cuales podemos almacenar y utilizar. La mayoría de los navegadores tienen una opción para\n              apagar la función de cookies, lo que evitará que su navegador acepte nuevas cookies, así como\n              (dependiendo de la sofisticación de su software de navegación) que le permite decidir sobre la\n              aceptación de cada nueva cookie en una variedad de formas. Se recomienda que deje las\n              cookies activadas, porque le permiten aprovechar algunas de las características más atractivas\n              de nuestro servicio. ¿Qué clase de \"cookies\" usamos? Podemos usar las siguientes categorías:\n              cookies estrictamente necesarios. Estas cookies le permiten navegar por nuestro Sitio web y\n              utilizar sus funciones. Sin estas cookies, los servicios como los carros de compras y pagos\n              electrónicos no pueden ser proporcionados. Este tipo de cookies se utilizan sin el\n              consentimiento del usuario. Las cookies de rendimiento Estas cookies recopilan información\n              anónima sobre cómo los visitantes usan nuestro Sitio web y si se encuentran con mensajes de\n              error en nuestro Sitio web. Toda la información recopilada es agregada y, por tanto, anónima.\n              Sólo se utilizan para mejorar el funcionamiento de un sitio web. Al utilizar nuestro sitio web,\n              usted acepta que podemos colocar estos tipos de cookies en su dispositivo. Funcionalidad\n              cookies Estas cookies permiten a nuestro Sitio Web que recuerde decisiones que Ud. toma\n              durante la navegación, como el lenguaje, tamaño de fuente, y las preferencias de nombre de\n              usuario. También se pueden usar para ver vídeos o comentarios en un blog. La información\n              que estas cookies recopilan no lo identificará personalmente, y no pueden realizar un\n              seguimiento de su actividad de navegación fuera de nuestro Sitio web. Cuando se elige estas\n              preferencias, usted acepta que podemos colocar estas cookies de personalización funcional en\n              su dispositivo. Las cookies de publicidad Estas cookies son para controlar el tráfico de\n              anuncios-trackers. Son utilizados por terceros para servir anuncios y recopilar información no\n              personal cuando visite nuestro sitio web. Algunas de estas empresas utilizan cookies para\n              rastrear información sobre sus visitas a nuestro sitio web y otros sitios web con el fin de\n              proporcionar anuncios sobre bienes y servicios que le puedan interesar."),_c('br'),_c('br'),_vm._v("\n              ¿Qué hacemos con la información que recopilamos? La información personal que recogemos\n              es para procesar su registro, compras y pagos, y para mantener su cuenta de forma continua.\n              Si usted es un proveedor de contenidos, también vamos a utilizar su información personal para\n              hacer rendiciones de cuentas y el pago de regalías a usted. Si introduce información para\n              acceder a concursos, promociones, sorteos u otros programas opcionales, utilizaremos la\n              información que proporcione para facilitar y comunicarnos con usted acerca de esa\n              transacción en particular, para que se le notifique si ha ganado, para entregar los premios, etc.\n              Si usted mantiene una página de perfil de DJ, podemos utilizar su información personal para\n              comunicarnos con usted. También podemos utilizar su información personal y no personal\n              para mejorar su experiencia con el Sitio y nuestro servicio, como el envío de un e-mails para\n              proporcionarle otra información, contenido y material el cual creemos que puede interesarle;\n              la visualización de contenido y anuncios de acuerdo a su historial de navegación, preferencias y\n              ubicación; el cumplimiento de sus órdenes; proporcionar servicio al cliente y responder a sus\n              preguntas y comentarios; o a usted acerca de su cuenta o sobre nuestras promociones,\n              concursos, encuestas, u otras promociones. Podemos utilizar la información obtenida de las\n              cookies y balizas web para asegurarnos de que nuestro contenido y mensajes de correo\n              electrónico estén en un formato que se pueda leer, para analizar las tendencias acerca del\n              Sitio, el contenido y e-mails populares y si están siendo leídos y / o transmitidos, para mantener un historial de actividad de correo electrónico, y para evaluar la eficacia y la\n              eficiencia de ciertas comunicaciones. Sus comentarios y otra información también puede\n              usarse para evaluar y mejorar nuestro Sitio y servicios. Por ejemplo, podemos analizar el\n              tráfico y el uso de nuestro Sitio; la tasa de participación de nuestras diversas promociones,\n              ofertas, correos electrónicos y otros programas; y la popularidad de nuestro contenido,\n              artistas y proveedores participantes. También podemos utilizar esta información para fines de\n              desarrollo de productos, tales como determinar qué otras etiquetas, artistas, productos y\n              servicios son de interés de nuestros usuarios, y para fines técnicos, tales como el control de la\n              funcionalidad de nuestros servidores y sistemas de correo electrónico."),_c('br'),_c('br'),_vm._v("\n               \n              ¿Compartimos la información que recopilamos con terceros? Podemos compartir la\n              información que recopilamos, tanto a nivel personal y no personal, con terceros, como\n              anunciantes, patrocinadores del concurso, socios promocionales y de marketing, artistas y\n              demás personas que prestan nuestro contenido o cuyos productos o servicios pensamos que\n              pueden interesarle. También podemos compartir con nuestras sociedades actuales y futuros\n              afiliados y socios comerciales, y si estamos involucrados en una fusión, venta de activos u otra\n              reorganización empresarial, también podemos compartir o transferir su información personal\n              y no personal a nuestros sucesores. También podemos compartir la información con terceros\n              proveedores de servicios de confianza para realizar ciertas funciones o proporcionar ciertos\n              servicios, tales como hospedaje y mantenimiento de nuestros servidores y el sitio de\n              almacenamiento, bases de datos y de gestión, gestión de correo electrónico, la\n              comercialización de almacenamiento, procesamiento de tarjetas de crédito, servicio al cliente\n              y el cumplimiento de pedidos para productos y servicios que se pueden adquirir a través del\n              sitio. Probablemente vamos a compartir su información personal, y posiblemente alguna\n              información no personal, con estos terceros para que puedan realizar estos servicios para\n              nosotros y para usted. Podremos compartir porciones de nuestros archivos de registro,\n              incluyendo direcciones IP, para fines de análisis con terceros, como analistas web,\n              desarrolladores de aplicaciones y redes publicitarias. Si la dirección IP es compartida, puede\n              ser utilizado para estimar la ubicación general y otros technographics tales como la velocidad\n              de conexión, si ha visitado el Sitio desde una ubicación compartida, y el tipo de dispositivo\n              utilizado para visitar los Sitios. También pueden agregar información sobre nuestra publicidad\n              y lo que se ve en el Sitio y luego proporcionar a la auditoría, la investigación y la presentación\n              de informes para nosotros y nuestros anunciantes. También podemos revelar información\n              personal y no personal acerca de usted ante el requerimiento de gobiernos o de las fuerzas del\n              orden, a nuestra única discreción, con el fin de responder a las reclamaciones, proceso legal\n              (incluyendo citaciones), a los efectos de proteger nuestros derechos e intereses o los de un\n              tercero, la seguridad del público o cualquier persona, para prevenir o detener cualquier\n              actividad ilegal, no ética, o legalmente procesable, o para cumplir con otro modo aplicables\n              órdenes judiciales, leyes, normas y reglamentos."),_c('br'),_c('br'),_vm._v(" \n              Artistas: Al utilizar determinadas funciones o servicios, se pueden proporcionar cierta\n              información personal a los Artistas, tales como su dirección de correo electrónico, país de\n              residencia y zip / código postal (\"Información del Aficionado\") para agregarlo a la lista de\n              correo del Artista. Los Artistas sólo están autorizadas por nosotros para utilizar la información\n              del Aficionado para enviar correo electrónico a usted y no podrán compartir, alquilar o vender\n              la información a otras personas para cualquier otro propósito. Los perfiles de usuario: la\n              información del perfil del usuario que incluye el nombre del usuario, dirección de correo\n              electrónico, historial de compras y otra información que se introduce (\"Envíos de usuario\") puede ser presentada a otros usuarios para facilitar la interacción del usuario dentro del\n              servicio. Las direcciones de correo electrónico de los usuarios no se darán a conocer\n              directamente a otros usuarios por nosotros, excepto, cuando el usuario esté \"conectado\" a\n              otro usuario a través de una pertenencia a un grupo común, o una invitación, o si el usuario ha\n              optado por incluir su dirección de correo electrónico en su Perfil del usuario. Usted puede\n              designar ciertos envíos de usuario, incluyendo los elementos individuales de su historial de\n              compras, como privada, en cuyo caso no se mostrará a otros usuarios. ¿Es mi información\n              personal segura? Su información personal está protegida por una contraseña para su\n              privacidad y seguridad. Es necesario para evitar el acceso no autorizado a su cuenta e\n              información personal mediante la selección y la protección de la contraseña adecuada y limitar\n              el acceso a su ordenador y el navegador después de que haya terminado de acceder a su\n              cuenta. Beathey se esfuerza por proteger la información del usuario para asegurarse de que la\n              información de cuenta de usuario se mantenga privada, sin embargo, Beathey no puede\n              garantizar la seguridad de la información de la cuenta de usuario. La entrada no autorizada o\n              uso, la falla de hardware o software, y otros factores, pueden comprometer la seguridad de la\n              información del usuario en cualquier momento. El Servicio puede contener enlaces a otros\n              sitios. Beathey no es responsable de las políticas y / o prácticas de privacidad de otros sitios.\n              Cuando se enlaza a otro sitio debe leer la política de privacidad que aparece en ese sitio. Esta\n              política de privacidad sólo comprende la información recopilada en el Servicio."),_c('br'),_c('br'),_vm._v("\n              ¿Se aplica esta política a otros sitios o servicios? Los Sitios pueden contener enlaces a los sitios\n              web asociados con las discográficas, DJs, artistas, proveedores de contenido, anunciantes,\n              socios comerciales, patrocinadores de concursos, u otros terceros. Los enlaces, anuncios,\n              promociones, u otro menciones no cuentan con nuestra aprobación, autorización o representa\n              afiliación con ninguna tercera parte, o de sus productos o servicios. Los sitios de terceros\n              tienen sus propias políticas de privacidad y protección de datos, y pueden colocar sus propias\n              cookies u otros archivos en su computadora. Nosotros no controlamos otros sitios, empresas o\n              personas y no podemos ser responsables de su experiencia una vez que salga de nuestro Sitio.\n              Por lo tanto, le recomendamos leer detenidamente las políticas de privacidad, condiciones de\n              uso y otras políticas de otros sitios que visita."),_c('br'),_c('br'),_vm._v("\n               ¿Cuál es nuestra política con respecto a la información de los niños? No recopilamos,\n              mantenemos o utilizamos información personal de niños menores de 13 años de edad, y\n              ninguna parte del Servicio está dirigido a niños menores de 13. Si se entera de que su hijo nos\n              ha proporcionado información personal sin su consentimiento, nos puede alertar a\n              "),_c('a',{attrs:{"href":"mailto:support@beathey.com"}},[_vm._v("mailto:support@beathey.com")]),_vm._v(". Si descubrimos que hemos recopilado información personal de niños\n              menores de 13 años, inmediatamente tomaremos medidas para eliminar dicha información y\n              cancelar la cuenta del niño."),_c('br'),_c('br'),_vm._v("\n              ¿Dónde almacenamos y utilizamos su información? Almacenamos y procesamos la información\n              que recogemos en los Estados Unidos de América. Si está fuera de los EE.UU su información\n              personal y no personal puede ser transferida a los Estados Unidos. Los correos electrónicos\n              que reciba de nosotros incluirá instrucciones específicas sobre cómo dejar de recibir ciertas\n              comunicaciones. También nos puede enviar un correo electrónico a "),_c('a',{attrs:{"href":"mailto:support@beathey.com"}},[_vm._v("mailto:support@beathey.com")]),_vm._v("\n              para actualizar o corregir su información personal que tengamos en el archivo o para anular su\n              inscripción en marketing o e-mailings promocionales. Residentes en la República Argentina Si\n              es residente en La República Argentina y utiliza los servicios de Beathey, presta su consentimiento, conforme a lo establecido en la ley 25.326 de Protección de Datos Personales,\n              a tenor de lo cual declara conocer y aceptar, para que sus datos personales integren la base de\n              datos de Beathey, otorgando por la presente autorización expresa para: (i) el tratamiento\n              automatizado de dichos datos e información y (ii) su utilización para servicios actuales o\n              futuros, que desarrolle Beathey. El titular de los datos personales tiene la facultad de ejercer el\n              derecho de acceso a los mismos en forma gratuita y a intervalos no inferiores a seis meses,\n              salvo que se acredite tener un interés legítimo al efecto conforme lo establecido en el artículo\n              14, inciso 3 de la Ley Nº 25.326. El titular de los datos, tiene además la posibilidad de ejercer\n              los derechos de rectificación, y supresión de los datos conforme artículo 6, inciso \"e\" de la Ley\n              25.326. Los datos solicitados como obligatorios son aquellos que sirven para la identificación\n              del usuario conforme articulo 6, inciso \"c\", la inexactitud o la negativa a completar los cambios\n              obligatorios, podrá impedir la posibilidad de acceso al Sitio Web, conforme al articulo 6, inciso\n              \"d\". La DIRECCIÓN NACIONAL DE PROTECCIÓN DE DATOS PERSONALES, Órgano de Control de\n              la Ley 25.326, tiene la atribución de atender las denuncias y reclamos que se interpongan con\n              relación al incumplimiento de las normas sobre protección de datos personales. Limitación de\n              responsabilidad: Hay enlaces de terceros en el Sitio que lo enviará a otros sitios web sobre los\n              cuales no tenemos ningún control. Al hacer clic en un enlace de terceros lo hace bajo su propia\n              responsabilidad y riesgo. Al hacer clic en un enlace de terceros, usted entiende que será el\n              único responsable de cualquier pérdida o daño que puede resultar de tales actividades."),_c('br'),_c('br')])}]


/***/ }),
/* 1027 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicyEn_vue__ = __webpack_require__(456);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f483315_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicyEn_vue__ = __webpack_require__(1029);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1028)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0f483315"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicyEn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f483315_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicyEn_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f483315_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicyEn_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1028 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1029 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"terms flex justify-center"},[_c('div',{staticClass:"mw7"},[_c('button',{staticClass:"backButton"},[_c('router-link',{staticClass:"rlink",attrs:{"to":{name:'home'}}},[_vm._v("Back")])],1),_vm._v(" "),_c('h1',{staticClass:"mainTitleTyCandPolicy"},[_vm._v("Privacy Policy for BeatHey")]),_vm._v(" "),_c('div',{staticClass:"mainContentTyCandPolicy"},[_c('p',[_vm._v("At BeatHey, accessible from www.beathey.com, one of our main priorities is the privacy of our visitors. This Privacy Policy document contains types of information that is collected and recorded by BeatHey and how we use it.")]),_vm._v(" "),_c('p',[_vm._v("If you have additional questions or require more information about our Privacy Policy, do not hesitate to contact us.")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('h2',[_vm._v("Consent")]),_vm._v(" "),_c('p',[_vm._v("By using our website, you hereby consent to our Privacy Policy and agree to its terms.")]),_vm._v(" "),_c('h2',[_vm._v("Information we collect")]),_vm._v(" "),_c('p',[_vm._v("The personal information that you are asked to provide, and the reasons why you are asked to provide it, will be made clear to you at the point we ask you to provide your personal information.")]),_vm._v(" "),_c('p',[_vm._v("If you contact us directly, we may receive additional information about you such as your name, email address, phone number, the contents of the message and/or attachments you may send us, and any other information you may choose to provide.")]),_vm._v(" "),_c('p',[_vm._v("When you register for an Account, we may ask for your contact information, including items such as name, company name, address, email address, and telephone number.")]),_vm._v(" "),_c('h2',[_vm._v("How we use your information")]),_vm._v(" "),_c('p',[_vm._v("We use the information we collect in various ways, including to:")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('h2',[_vm._v("Log Files")]),_vm._v(" "),_c('p',[_vm._v("BeatHey follows a standard procedure of using log files. These files log visitors when they visit websites. All hosting companies do this and a part of hosting services' analytics. The information collected by log files include internet protocol (IP) addresses, browser type, Internet Service Provider (ISP), date and time stamp, referring/exit pages, and possibly the number of clicks. These are not linked to any information that is personally identifiable. The purpose of the information is for analyzing trends, administering the site, tracking users' movement on the website, and gathering demographic information.")]),_vm._v(" "),_c('h2',[_vm._v("Cookies and Web Beacons")]),_vm._v(" "),_c('p',[_vm._v("Like any other website, BeatHey uses 'cookies'. These cookies are used to store information including visitors' preferences, and the pages on the website that the visitor accessed or visited. The information is used to optimize the users' experience by customizing our web page content based on visitors' browser type and/or other information.")]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('h2',[_vm._v("Advertising Partners Privacy Policies")]),_vm._v(" "),_c('P',[_vm._v("You may consult this list to find the Privacy Policy for each of the advertising partners of BeatHey.")]),_vm._v(" "),_c('p',[_vm._v("Third-party ad servers or ad networks uses technologies like cookies, JavaScript, or Web Beacons that are used in their respective advertisements and links that appear on BeatHey, which are sent directly to users' browser. They automatically receive your IP address when this occurs. These technologies are used to measure the effectiveness of their advertising campaigns and/or to personalize the advertising content that you see on websites that you visit.")]),_vm._v(" "),_c('p',[_vm._v("Note that BeatHey has no access to or control over these cookies that are used by third-party advertisers.")]),_vm._v(" "),_c('h2',[_vm._v("Third Party Privacy Policies")]),_vm._v(" "),_c('p',[_vm._v("BeatHey's Privacy Policy does not apply to other advertisers or websites. Thus, we are advising you to consult the respective Privacy Policies of these third-party ad servers for more detailed information. It may include their practices and instructions about how to opt-out of certain options. ")]),_vm._v(" "),_c('p',[_vm._v("You can choose to disable cookies through your individual browser options. To know more detailed information about cookie management with specific web browsers, it can be found at the browsers' respective websites.")]),_vm._v(" "),_c('h2',[_vm._v("CCPA Privacy Rights (Do Not Sell My Personal Information)")]),_vm._v(" "),_c('p',[_vm._v("Under the CCPA, among other rights, California consumers have the right to:")]),_vm._v(" "),_c('p',[_vm._v("Request that a business that collects a consumer's personal data disclose the categories and specific pieces of personal data that a business has collected about consumers.")]),_vm._v(" "),_c('p',[_vm._v("Request that a business delete any personal data about the consumer that a business has collected.")]),_vm._v(" "),_c('p',[_vm._v("Request that a business that sells a consumer's personal data, not sell the consumer's personal data.")]),_vm._v(" "),_c('p',[_vm._v("If you make a request, we have one month to respond to you. If you would like to exercise any of these rights, please contact us.")]),_vm._v(" "),_c('h2',[_vm._v("GDPR Data Protection Rights")]),_vm._v(" "),_c('p',[_vm._v("We would like to make sure you are fully aware of all of your data protection rights. Every user is entitled to the following:")]),_vm._v(" "),_c('p',[_vm._v("The right to access – You have the right to request copies of your personal data. We may charge you a small fee for this service.")]),_vm._v(" "),_c('p',[_vm._v("The right to rectification – You have the right to request that we correct any information you believe is inaccurate. You also have the right to request that we complete the information you believe is incomplete.")]),_vm._v(" "),_c('p',[_vm._v("The right to erasure – You have the right to request that we erase your personal data, under certain conditions.")]),_vm._v(" "),_c('p',[_vm._v("The right to restrict processing – You have the right to request that we restrict the processing of your personal data, under certain conditions.")]),_vm._v(" "),_c('p',[_vm._v("The right to object to processing – You have the right to object to our processing of your personal data, under certain conditions.")]),_vm._v(" "),_c('p',[_vm._v("The right to data portability – You have the right to request that we transfer the data that we have collected to another organization, or directly to you, under certain conditions.")]),_vm._v(" "),_c('p',[_vm._v("If you make a request, we have one month to respond to you. If you would like to exercise any of these rights, please contact us.")]),_vm._v(" "),_c('h2',[_vm._v("Children's Information")]),_vm._v(" "),_c('p',[_vm._v("Another part of our priority is adding protection for children while using the internet. We encourage parents and guardians to observe, participate in, and/or monitor and guide their online activity.")]),_vm._v(" "),_c('p',[_vm._v("BeatHey does not knowingly collect any Personal Identifiable Information from children under the age of 13. If you think that your child provided this kind of information on our website, we strongly encourage you to contact us immediately and we will do our best efforts to promptly remove such information from our records.")])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("This Privacy Policy applies only to our online activities and is valid for visitors to our website with regards to the information that they shared and/or collect in BeatHey. This policy is not applicable to any information collected offline or via channels other than this website. Our Privacy Policy was created with the help of the "),_c('a',{attrs:{"href":"https://www.privacypolicyonline.com/privacy-policy-generator/"}},[_vm._v("Online Generator of Privacy Policy")]),_vm._v(".")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("Provide, operate, and maintain our website")]),_vm._v(" "),_c('li',[_vm._v("Improve, personalize, and expand our website")]),_vm._v(" "),_c('li',[_vm._v("Understand and analyze how you use our website")]),_vm._v(" "),_c('li',[_vm._v("Develop new products, services, features, and functionality")]),_vm._v(" "),_c('li',[_vm._v("Communicate with you, either directly or through one of our partners, including for customer service, to provide you with updates and other information relating to the website, and for marketing and promotional purposes")]),_vm._v(" "),_c('li',[_vm._v("Send you emails")]),_vm._v(" "),_c('li',[_vm._v("Find and prevent fraud")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("For more general information on cookies, please read "),_c('a',{attrs:{"href":"https://www.privacypolicyonline.com/what-are-cookies/"}},[_vm._v("\"What Are Cookies\" from Cookie Consent")]),_vm._v(".")])}]


/***/ }),
/* 1030 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicyPt_vue__ = __webpack_require__(457);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78cb440c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicyPt_vue__ = __webpack_require__(1032);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1031)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-78cb440c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicyPt_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78cb440c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicyPt_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78cb440c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicyPt_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1031 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1032 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"terms flex justify-center"},[_c('div',{staticClass:"mw7"},[_c('button',{staticClass:"backButton"},[_c('router-link',{staticClass:"rlink",attrs:{"to":{name:'home'}}},[_vm._v("Back")])],1),_vm._v(" "),_c('h1',{staticClass:"mainTitleTyCandPolicy"},[_vm._v("Política de Privacidade e Cookies")]),_vm._v(" "),_vm._m(0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mainContentTyCandPolicy"},[_c('p',[_vm._v("Esta política de privacidade descreve os tipos de informações que a BeatHey pode coletar sobre você através do nosso site e o que podemos fazer com essas informações. Reservamo-nos o direito de modificar esta Política a qualquer momento mediante a publicação da versão atualizada aqui. Portanto, consulte esta página para atualizações cada vez que visitar nossos sites; também podemos optar por notificar usuários registrados sobre alterações importantes por e-mail ou outros meios. Esta política não se aplica às informações que podem ser coletadas offline.")]),_vm._v(" "),_c('h2',[_vm._v("Quais informações são coletadas?")]),_vm._v(" "),_c('p',[_vm._v("\n            Geralmente, são coletados dois tipos de informações através do Site: \"informações pessoais\" sobre você, que você nos fornece, e \"informações não pessoais\" sobre você, seu equipamento, a tecnologia que utiliza e seu uso do Site, que, por si só, não o identifica pessoalmente. Para que você possa se tornar um usuário registrado, fazer compras ou vender conteúdo através do nosso Site, precisaremos que você forneça certas informações pessoais, como idade, nome, razão social (se aplicável), endereço de e-mail, endereço postal e número de telefone durante o processo de registro. Quando os pagamentos são realizados através do Site, é possível que você precise fornecer informações do seu cartão de crédito, data de vencimento, endereço de faturamento e detalhes relacionados (que podem incluir seu número de documento ou identificação fiscal) aos nossos provedores de serviços terceirizados, como o PayPal, e tais informações podem ser armazenadas e usadas para faturamento e serviços de pagamento por esses provedores de pagamento.\n            Podemos pedir informações pessoais adicionais ocasionalmente, como gênero e nível de renda, em relação a promoções online, concursos, sorteios, pesquisas e outros programas, sendo opcional o fornecimento dessas informações para participação nesses programas. Também podemos coletar informações não pessoais dos visitantes e usuários registrados do Site. Podemos solicitar que você forneça certas informações, como suas preferências musicais, artistas e gêneros favoritos, etc. Também podem ser requeridos dados técnicos e geográficos, como tipo de navegador, provedor de internet, sistema operacional, endereço IP, código postal ou localização. Se você comprar ou vender conteúdo através do Site, rastrearemos suas compras e/ou vendas. Essas informações podem ser combinadas com suas informações pessoais.\n            Se você se comunicar conosco ou com nossos representantes por e-mail ou através do Site, ou registrar informações em fóruns, chats, páginas de perfil, feedbacks, serviço de atendimento ao cliente, etc., podemos coletar, reter e usar qualquer informação que você fornecer.\n          ")]),_vm._v(" "),_c('h2',[_vm._v("Utilizamos \"cookies\" ou \"web beacons\"?")]),_vm._v(" "),_c('p',[_vm._v("\n            Utilizamos \"cookies\" para coletar dados de uso do site e melhorar sua experiência em nossos Sites e nosso serviço em geral. Um \"cookie\" é um pequeno arquivo de dados transferido para o computador para acesso em visitas futuras ao site, o que pode nos informar que você (ou alguém usando o mesmo dispositivo ou endereço IP) já visitou nosso Site antes, entre outras coisas. Você pode parar de aceitar cookies configurando seu navegador de internet, mas isso provavelmente não permitirá que o reconheçamos ou suas preferências em futuras visitas, de modo que você pode ter que inserir certas informações novamente. Nosso Site e e-mails podem conter imagens eletrônicas conhecidas como \"web beacons\". Estes são arquivos que nos permitem contar os visitantes do nosso Site, saber se um anúncio foi visualizado ou se uma mensagem foi aberta ou encaminhada, ou para servir conteúdo ou serviços específicos.\n            Os web beacons coletam informações não pessoais limitadas, incluindo o número de beacons, hora e data de uma visualização de página ou e-mail, e uma descrição da página onde o web beacon reside, todos os quais podemos armazenar e usar. A maioria dos navegadores possui uma opção para desativar a função de cookies, o que evitará que seu navegador aceite novos cookies, bem como (dependendo da sofisticação do seu software de navegação) permitir que você decida sobre a aceitação de cada novo cookie de várias maneiras. Recomendamos que mantenha os cookies ativados, pois permitem que você aproveite algumas das funcionalidades mais atraentes do nosso serviço.\n          ")]),_vm._v(" "),_c('h2',[_vm._v("Que tipo de \"cookies\" usamos?")]),_vm._v(" "),_c('p',[_vm._v("\n            Podemos usar as seguintes categorias:\n            "),_c('ul',[_c('li',[_vm._v("\n                Cookies estritamente necessários: Estes cookies permitem que você navegue pelo nosso Site e utilize suas funções. Sem esses cookies, serviços como carrinhos de compras e pagamentos eletrônicos não podem ser fornecidos. Este tipo de cookie é usado sem o consentimento do usuário.\n              ")]),_vm._v(" "),_c('li',[_vm._v("\n                Cookies de desempenho: Estes cookies coletam informações anônimas sobre como os visitantes usam nosso Site e se encontram mensagens de erro em nosso Site. Todas as informações coletadas são agregadas e, portanto, anônimas. Só são usados para melhorar o funcionamento de um site. Ao utilizar nosso site, você aceita que podemos colocar esses tipos de cookies em seu dispositivo.\n              ")]),_vm._v(" "),_c('li',[_vm._v("\n                Cookies de funcionalidade: Estes cookies permitem que nosso Site lembre decisões que você toma durante a navegação, como idioma, tamanho da fonte e preferências de nome de usuário. Também podem ser usados para assistir a vídeos ou comentários em um blog. As informações que esses cookies coletam não o identificarão pessoalmente, e eles não podem rastrear sua atividade de navegação fora do nosso Site. Ao escolher essas preferências, você aceita que podemos colocar esses cookies de personalização funcional em seu dispositivo.\n              ")]),_vm._v(" "),_c('li',[_vm._v("\n                Cookies de publicidade: Estes cookies são usados para controlar o tráfego de anúncios. São utilizados por terceiros para veicular anúncios e coletar informações não pessoais quando você visita nosso site. Algumas dessas empresas usam cookies para rastrear informações sobre suas visitas ao nosso site e outros sites para fornecer anúncios sobre bens e serviços que podem interessar a você.\n              ")])])]),_vm._v(" "),_c('h2',[_vm._v("O que fazemos com a informação que coletamos?")]),_vm._v(" "),_c('p',[_vm._v("\n            As informações pessoais que coletamos são usadas para processar seu registro, compras e pagamentos, e para manter sua conta de forma contínua. Se você for um fornecedor de conteúdos, também utilizaremos suas informações pessoais para prestação de contas e pagamento de royalties. Se você inserir informações para participar de concursos, promoções, sorteios ou outros programas opcionais, utilizaremos as informações que você fornecer para facilitar e nos comunicar com você sobre essa transação específica, para notificá-lo caso tenha ganhado, entregar prêmios, etc.\n            Se você mantiver uma página de perfil de DJ, poderemos usar suas informações pessoais para nos comunicar com você. Também podemos usar suas informações pessoais e não pessoais para melhorar sua experiência com o Site e nossos serviços, como o envio de e-mails para fornecer informações, conteúdos e materiais que acreditamos que possam lhe interessar; a exibição de conteúdo e anúncios com base no seu histórico de navegação, preferências e localização; o cumprimento de seus pedidos; e para prestar serviço ao cliente e responder a perguntas e comentários.\n            Podemos usar as informações obtidas dos cookies e web beacons para garantir que nosso conteúdo e mensagens de e-mail estejam em um formato legível, analisar as tendências sobre o Site, entender quais conteúdos e e-mails são populares e estão sendo lidos e/ou encaminhados, manter um histórico de atividades de e-mail e avaliar a eficácia e eficiência de certas comunicações. Seus comentários e outras informações também podem ser usados para avaliar e melhorar nosso Site e serviços. Por exemplo, podemos analisar o tráfego e o uso do Site; a taxa de participação em promoções, ofertas, e-mails e outros programas; e a popularidade de nosso conteúdo, artistas e fornecedores participantes.\n            Também podemos usar essas informações para desenvolvimento de produtos, como determinar quais outras etiquetas, artistas, produtos e serviços interessam aos nossos usuários, e para fins técnicos, como monitorar a funcionalidade de nossos servidores e sistemas de e-mail.\n          ")]),_vm._v(" "),_c('h2',[_vm._v("Compartilhamos as informações que coletamos com terceiros?")]),_vm._v(" "),_c('p',[_vm._v("\n            Podemos compartilhar as informações que coletamos, tanto a nível pessoal quanto não pessoal, com terceiros, como anunciantes, patrocinadores de concursos, parceiros promocionais e de marketing, artistas e outras partes que fornecem nosso conteúdo ou cujos produtos ou serviços acreditamos que possam interessar a você. Também podemos compartilhar essas informações com nossos atuais e futuros afiliados e parceiros comerciais, e, se estivermos envolvidos em uma fusão, venda de ativos ou outra reorganização empresarial, poderemos compartilhar ou transferir suas informações pessoais e não pessoais para nossos sucessores.\n            Também podemos compartilhar informações com terceiros prestadores de serviços confiáveis para realizar certas funções ou fornecer determinados serviços, como hospedagem e manutenção de nossos servidores e do site, armazenamento, bases de dados e gestão, gestão de e-mails, marketing, processamento de cartões de crédito, atendimento ao cliente e execução de pedidos para produtos e serviços que podem ser adquiridos através do site. Podemos compartilhar suas informações pessoais, e possivelmente algumas informações não pessoais, com esses terceiros para que possam realizar esses serviços para nós e para você.\n            Podemos compartilhar partes de nossos arquivos de log, incluindo endereços IP, para fins de análise com terceiros, como analistas web, desenvolvedores de aplicativos e redes publicitárias. Se o endereço IP for compartilhado, ele poderá ser usado para estimar a localização geral e outros detalhes, como velocidade de conexão, se você visitou o Site a partir de uma localização compartilhada, e o tipo de dispositivo utilizado para acessar o Site. Essas partes também podem agregar informações sobre nossa publicidade e o que é visualizado no Site, e depois fornecer auditoria, pesquisa e relatórios para nós e nossos anunciantes.\n            Também podemos divulgar informações pessoais e não pessoais sobre você mediante solicitação de autoridades governamentais ou das forças da lei, a nosso critério exclusivo, para responder a reclamações, processos legais (incluindo intimações), para proteger nossos direitos e interesses ou os de terceiros, a segurança pública ou de qualquer pessoa, para prevenir ou interromper qualquer atividade ilegal, antiética ou passível de responsabilidade legal, ou para cumprir ordens judiciais, leis, normas e regulamentos aplicáveis.\n          ")]),_vm._v(" "),_c('h2',[_vm._v("Artistas")]),_vm._v(" "),_c('p',[_vm._v("\n            Ao utilizar determinadas funções ou serviços, certas informações pessoais podem ser fornecidas aos Artistas, como seu endereço de e-mail, país de residência e código postal (\"Informação do Fã\") para incluí-lo na lista de e-mails do Artista. Os Artistas estão autorizados por nós a utilizar a Informação do Fã apenas para enviar e-mails a você e não podem compartilhar, alugar ou vender essas informações a terceiros para qualquer outro propósito.\n          ")]),_vm._v(" "),_c('h2',[_vm._v("Perfis de Usuário")]),_vm._v(" "),_c('p',[_vm._v("\n            As informações do perfil de usuário, que incluem o nome do usuário, endereço de e-mail, histórico de compras e outras informações inseridas (\"Envios do Usuário\"), podem ser exibidas para outros usuários para facilitar a interação dentro do serviço. Os endereços de e-mail dos usuários não serão divulgados diretamente a outros usuários por nós, exceto quando o usuário estiver \"conectado\" a outro usuário através de uma associação a um grupo comum, de um convite ou se o usuário tiver optado por incluir seu endereço de e-mail em seu Perfil de Usuário. Você pode designar certos Envios de Usuário, incluindo elementos individuais do seu histórico de compras, como privados, e, nesse caso, não serão exibidos para outros usuários.\n          ")]),_vm._v(" "),_c('h2',[_vm._v("Minha informação pessoal está segura?")]),_vm._v(" "),_c('p',[_vm._v("\n            Suas informações pessoais estão protegidas por uma senha para garantir sua privacidade e segurança. É necessário impedir o acesso não autorizado à sua conta e informações pessoais escolhendo e protegendo sua senha adequadamente e limitando o acesso ao seu computador e navegador depois de ter terminado de acessar sua conta. A BeatHey se esforça para proteger as informações do usuário e assegurar que as informações da conta do usuário sejam mantidas privadas. No entanto, a BeatHey não pode garantir a segurança das informações da conta do usuário. Acesso ou uso não autorizado, falhas de hardware ou software e outros fatores podem comprometer a segurança das informações do usuário a qualquer momento.\n            O Serviço pode conter links para outros sites. A BeatHey não é responsável pelas políticas e/ou práticas de privacidade de outros sites. Ao se conectar a outro site, você deve ler a política de privacidade exibida nesse site. Esta política de privacidade aplica-se apenas às informações coletadas pelo Serviço.\n          ")]),_vm._v(" "),_c('h2',[_vm._v("Esta política se aplica a outros sites ou serviços?")]),_vm._v(" "),_c('p',[_vm._v("\n            Os Sites podem conter links para sites associados a gravadoras, DJs, artistas, provedores de conteúdo, anunciantes, parceiros comerciais, patrocinadores de concursos ou outros terceiros. Links, anúncios, promoções ou outras referências não constituem nossa aprovação, autorização ou afiliação com qualquer terceiro ou com seus produtos ou serviços. Os sites de terceiros possuem suas próprias políticas de privacidade e proteção de dados, podendo armazenar suas próprias cookies ou outros arquivos em seu computador. Não controlamos outros sites, empresas ou pessoas e não somos responsáveis por sua experiência ao sair do nosso Site. Por isso, recomendamos que você leia cuidadosamente as políticas de privacidade, termos de uso e outras políticas dos sites que visita.\n          ")]),_vm._v(" "),_c('h2',[_vm._v("Qual é nossa política com relação à informação de crianças?")]),_vm._v(" "),_c('p',[_vm._v("\n            Não coletamos, mantemos ou utilizamos informações pessoais de crianças menores de 13 anos de idade, e nenhuma parte do Serviço é direcionada a crianças menores de 13 anos. Se você tomar conhecimento de que seu filho nos forneceu informações pessoais sem o seu consentimento, você pode nos informar através do e-mail contacto@BeatHey.com. Se descobrirmos que coletamos informações pessoais de crianças menores de 13 anos, tomaremos medidas imediatas para excluir essas informações e cancelar a conta da criança.\n          ")]),_vm._v(" "),_c('h2',[_vm._v("Onde armazenamos e utilizamos suas informações?.")]),_vm._v(" "),_c('p',[_vm._v("\n            Armazenamos e processamos as informações que coletamos nos Estados Unidos da América. Se você estiver fora dos EUA, suas informações pessoais e não pessoais poderão ser transferidas para os Estados Unidos. Os e-mails que você receber de nós incluirão instruções específicas sobre como deixar de receber determinadas comunicações. Você também pode nos enviar um e-mail para contacto@BeatHey.com para atualizar ou corrigir suas informações pessoais em nossos registros, ou para cancelar sua inscrição em marketing ou e-mails promocionais.\n          ")]),_vm._v(" "),_c('h2',[_vm._v("Residentes na República Argentina")]),_vm._v(" "),_c('p',[_vm._v("\n            Se você reside na República Argentina e utiliza os serviços da BeatHey, fornece seu consentimento, conforme estabelecido na Lei 25.326 de Proteção de Dados Pessoais, declarando que conhece e aceita que seus dados pessoais integrem o banco de dados da BeatHey, autorizando expressamente para: (i) o tratamento automatizado desses dados e informações e (ii) sua utilização para serviços atuais ou futuros que a BeatHey venha a desenvolver.\n            O titular dos dados pessoais tem o direito de exercer o direito de acesso aos mesmos de forma gratuita e em intervalos não inferiores a seis meses, salvo se for comprovado um interesse legítimo, conforme estabelecido no artigo 14, inciso 3 da Lei nº 25.326. Além disso, o titular dos dados pode exercer os direitos de retificação e supressão dos dados, conforme o artigo 6, inciso \"e\" da Lei 25.326. Os dados solicitados como obrigatórios são aqueles necessários para a identificação do usuário, conforme o artigo 6, inciso \"c\". A imprecisão ou a recusa em fornecer os dados obrigatórios pode impedir o acesso ao Site, conforme o artigo 6, inciso \"d\".\n            A DIREÇÃO NACIONAL DE PROTEÇÃO DE DADOS PESSOAIS, órgão responsável pela aplicação da Lei 25.326, tem a competência para lidar com denúncias e reclamações relacionadas ao descumprimento das normas de proteção de dados pessoais.\n          ")])])}]


/***/ }),
/* 1033 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AllTracksList_vue__ = __webpack_require__(458);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1372ca06_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AllTracksList_vue__ = __webpack_require__(1039);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1034)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AllTracksList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1372ca06_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AllTracksList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1372ca06_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AllTracksList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1034 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1035 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1036 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1037 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"h-100 w-100 track-item flex"},[_c('div',{staticClass:"pointer h-100 w-95",on:{"click":_vm.playTrack}},[_c('div',{staticClass:"fl w-10 ma0 flex flex-row items-center justify-between"},[_c('font-awesome-icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentTrack != _vm.track || !_vm.isPlaying ),expression:"currentTrack != track || !isPlaying "}],staticClass:"play-pause-icon pointer ml3 mr1 h-100 textColor",attrs:{"icon":"play","size":"1x"},on:{"click":function($event){$event.stopPropagation();return _vm.playTrack.apply(null, arguments)}}}),_vm._v(" "),_c('font-awesome-icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentTrack == _vm.track && _vm.isPlaying),expression:"currentTrack == track && isPlaying"}],staticClass:"play-pause-icon pointer ml3 mr1 h-100 textColor",attrs:{"icon":"pause","size":"1x"},on:{"click":function($event){$event.stopPropagation();return _vm.setPlaying(false)}}}),_vm._v(" "),_c('div',{staticClass:"image-container"},[_c('img',{staticClass:"track-image h-100 w-100",attrs:{"src":_vm.picture}})])],1),_vm._v(" "),_c('p',{staticClass:"title fl w-30 h-100 pa1 pl3 ma0 text-ellipsis center-content textColor"},[_vm._v(_vm._s(_vm.track.title))]),_vm._v(" "),_c('router-link',{staticClass:"textColor no-underline",attrs:{"to":{ name:'artist-info', params:{ id:_vm.track.id_artist }},"append":""},nativeOn:{"click":function($event){$event.stopPropagation();}}},[(_vm.profileTracks === false)?_c('p',{staticClass:"artist fl w-20 h-100 pa1 pl3 ma0 text-ellipsis center-content textColor"},[_vm._v(_vm._s(_vm.track.artist.name))]):_vm._e(),_vm._v(" "),(_vm.profileTracks === true)?_c('p',{staticClass:"artist fl w-20 h-100 pa1 pl3 ma0 text-ellipsis center-content textColor"},[_vm._v(_vm._s(_vm.track.name))]):_vm._e()]),_vm._v(" "),(_vm.profileTracks === false)?_c('p',{staticClass:"genre fl w-20 h-100 pa1 pl3 ma0 text-ellipsis center-content textColor"},[_vm._v(_vm._s(_vm.track.genre.name))]):_vm._e(),_vm._v(" "),(_vm.profileTracks === true)?_c('p',{staticClass:"genre fl w-20 h-100 pa1 pl3 ma0 text-ellipsis center-content textColor"},[_vm._v(_vm._s(_vm.track.music_type))]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"released fl w-15 h-100 pa1 pl3 ma0 center-content textColor"},[_vm._v(_vm._s(this.trackTime))])],1),_vm._v(" "),_c('div',{staticClass:"w-5 h-100 ma0"},[_c('track-options-button',{staticClass:"ma0 textColor",attrs:{"track":_vm.track}})],1)]),_vm._v(" "),_c('track-card',{staticClass:"track-card w-100 textColor",attrs:{"profileTracks":_vm.profileTracks,"track":_vm.track},on:{"play":_vm.playTrack}})],1)}
var staticRenderFns = []


/***/ }),
/* 1038 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.withFilters && _vm.genresMain.length > 0),expression:"withFilters && genresMain.length > 0"}]},[_c('div',{staticClass:"w-100 justify-around items-center ttu",staticStyle:{"background-color":"#393839","position":"relative","display":"flex"}},[_c('div',[_c('a',{staticStyle:{"margin-left":"10px","fill":"white","cursor":"pointer"},on:{"click":function($event){return _vm.genTranslate('genMain', 'left')}}},[_c('svg',{staticClass:"bi bi-caret-left",attrs:{"width":"25","height":"25","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M10 12.796V3.204L4.519 8 10 12.796zm-.659.753-5.48-4.796a1 1 0 0 1 0-1.506l5.48-4.796A1 1 0 0 1 11 3.204v9.592a1 1 0 0 1-1.659.753z"}})])])]),_vm._v(" "),_c('div'),_vm._v(" "),_c('div',{staticClass:"container-scroll w-100"},[_c('div',{staticClass:"container-genbar",attrs:{"id":"genMain"}},[_c('a',{staticClass:"genre-filter f6 link dim ph3 pv2 dib white mr2",class:{
              'genre-filter-selected': _vm.genreFilter == '',
              pointer: _vm.genreFilter != '',
            },on:{"click":function($event){return _vm.selectGenMain('')}}},[_vm._v("\n            "+_vm._s(_vm.$t("tracks.genres.all"))+"\n          ")]),_vm._v(" "),_vm._l((_vm.genresMain),function(genre){return _c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.genresMain.length > 0),expression:"genresMain.length > 0"}],key:genre.id,staticClass:"genre-filter f6 link dim ph3 pv2 dib white mr2",class:{
              'genre-filter-selected': _vm.genreFilter == genre.id,
              pointer: _vm.genreFilter != genre.id,
            },attrs:{"track-by":genre.id,"tabindex":genre.id},on:{"click":function($event){return _vm.selectGenMain(genre.id)},"blur":function($event){return _vm.selectGenMainBlur($event)},"focus":function($event){return _vm.selectGenMainFocus($event)}}},[_vm._v("\n            "+_vm._s(genre.name)+"\n          ")])})],2)]),_vm._v(" "),_c('div',[_c('a',{staticStyle:{"margin-right":"10px","fill":"white","cursor":"pointer"},on:{"click":function($event){return _vm.genTranslate('genMain', 'right')}}},[_c('svg',{staticClass:"bi bi-caret-right",attrs:{"width":"25","height":"25","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M6 12.796V3.204L11.481 8 6 12.796zm.659.753 5.48-4.796a1 1 0 0 0 0-1.506L6.66 2.451C6.011 1.885 5 2.345 5 3.204v9.592a1 1 0 0 0 1.659.753z"}})])])])]),_vm._v(" "),_c('div',{staticClass:"w-100 justify-between items-center ttu black",staticStyle:{"background-color":"black","position":"relative","display":"flex"}},[_c('div',[_c('a',{staticStyle:{"fill":"white","cursor":"pointer"},on:{"click":function($event){return _vm.genTranslate('genSecon', 'left')}}},[_c('svg',{staticClass:"bi bi-caret-left",attrs:{"width":"25","height":"25","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M10 12.796V3.204L4.519 8 10 12.796zm-.659.753-5.48-4.796a1 1 0 0 1 0-1.506l5.48-4.796A1 1 0 0 1 11 3.204v9.592a1 1 0 0 1-1.659.753z"}})])])]),_vm._v(" "),_c('div',{staticClass:"container-scroll w-100"},[_c('div',{staticClass:"container-genbar",attrs:{"id":"genSecon"}},_vm._l((_vm.genSeconByMain),function(genre){return _c('a',{key:genre.id,staticClass:"genre-filter f6 link dim ph3 pv2 dib white mr2",class:{
              'genre-filter-selected': _vm.genreFilter == genre.id,
              pointer: _vm.genreFilter != genre.id,
            },staticStyle:{"font-size":"0.775rem","min-width":"120px","text-align":"center"},attrs:{"track-by":genre.id},on:{"click":function($event){return _vm.selectGenSecon(genre.id)}}},[_vm._v("\n            "+_vm._s(genre.name)+"\n          ")])}),0)]),_vm._v(" "),_c('div',[_c('a',{staticStyle:{"fill":"white","cursor":"pointer"},on:{"click":function($event){return _vm.genTranslate('genSecon', 'right')}}},[_c('svg',{staticClass:"bi bi-caret-right",attrs:{"width":"25","height":"25","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M6 12.796V3.204L11.481 8 6 12.796zm.659.753 5.48-4.796a1 1 0 0 0 0-1.506L6.66 2.451C6.011 1.885 5 2.345 5 3.204v9.592a1 1 0 0 0 1.659.753z"}})])])])])]),_vm._v(" "),(!_vm.profileTracks)?_c('div',{staticClass:"w-100 w-mobile mb-5"},[_c('div',{staticClass:"search-wrapper w-50-m w-100 block pointer z-1 relative bg-tertiary fr mt3"},[_c('button',{staticClass:"pointer btn1 dim b f5 fw4",class:{'w-10': this.mobileWidth},attrs:{"type":"button","icon":"search"},on:{"click":_vm.update}},[_c('font-awesome-icon',{staticClass:"search-left-icon",attrs:{"icon":"search"}})],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.textToFilter),expression:"textToFilter"}],staticClass:"pa2 input bg-transparent w-50-mobile",class:{'w-100': !this.mobileWidth, 'w-80': this.mobileWidth},attrs:{"maxlength":"255","placeholder":_vm.$t('artists.search.placeholder')},domProps:{"value":(_vm.textToFilter)},on:{"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.clearFilters.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.update.apply(null, arguments)}],"input":function($event){if($event.target.composing){ return; }_vm.textToFilter=$event.target.value}}})])]):_vm._e(),_vm._v(" "),(!_vm.profileTracks)?_c('div',{staticClass:"filtersLabelsDiv"},[_c('router-link',{staticClass:"filtersLinks",attrs:{"title":_vm.$t('app.discover'),"to":{name:'discover'}}},[_c('span',{staticClass:"filtersLabels"},[_vm._v("Tracks")])]),_vm._v(" "),(_vm.mainGenre.name || _vm.seconGenre.name || _vm.filteredText)?_c('span',{on:{"click":_vm.filterByMainGenreLabel}},[_vm._v(" - ")]):_vm._e(),_vm._v(" "),(_vm.mainGenre.name)?_c('span',{staticClass:"filtersLabels",on:{"click":_vm.filterByMainGenreLabel}},[_vm._v(_vm._s(_vm.mainGenre.name))]):_vm._e(),_vm._v(" "),(_vm.mainGenre.name && _vm.seconGenre.name)?_c('span',[_vm._v(" / ")]):_vm._e(),_vm._v(" "),(_vm.seconGenre.name)?_c('span',{staticClass:"filtersLabels",on:{"click":_vm.removeSeconGenreLabel}},[_vm._v(_vm._s(_vm.seconGenre.name))]):_vm._e(),_vm._v(" "),((_vm.mainGenre.name || _vm.seconGenre.name) && _vm.filteredText)?_c('span',[_vm._v(" / ")]):_vm._e(),_vm._v(" "),(_vm.filteredText)?_c('span',{staticClass:"filtersLabels mobileLabelsPosition",on:{"click":_vm.removeFilteredTextLabel}},[_vm._v(_vm._s(_vm.filteredText))]):_vm._e()],1):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.nextPage),expression:"nextPage"}],staticClass:"track-list pa1 pb3-ns pt3-ns ph5-l ph3-m",class:{ 'overflow-y-scroll': _vm.withPagination },attrs:{"infinite-scroll-immediate-check":"false","infinite-scroll-distance":"50","infinite-scroll-disabled":"disablePagination"}},[_c('div',{staticClass:"track-list-header h2 w-95 mb1 textColor"},[_c('p',{staticClass:"fl w-10 h-100 ma0 textColor"}),_vm._v(" "),_c('p',{staticClass:"fl w-30 h-100 pa1 pl3 ma0 text-ellipsis center-content b textColor"},[_vm._v("\n        "+_vm._s(_vm.$t("tracks.headers.title"))+"\n      ")]),_vm._v(" "),_c('p',{staticClass:"fl w-20 h-100 pa1 pl3 ma0 text-ellipsis center-content b textColor"},[_vm._v("\n        "+_vm._s(_vm.$t("tracks.headers.artist"))+"\n      ")]),_vm._v(" "),_c('p',{staticClass:"fl w-20 h-100 pa1 pl3 ma0 text-ellipsis center-content b textColor"},[_vm._v("\n        "+_vm._s(_vm.$t("tracks.headers.genre"))+"\n      ")]),_vm._v(" "),_c('p',{staticClass:"released fl w-15 h-100 pa1 ma0 center-content b textColor"},[_vm._v("\n        "+_vm._s(_vm.$t("tracks.headers.duration"))+"\n      ")]),_vm._v(" "),_c('p',{staticClass:"fl w-5 h-100 ma0"})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"flex justify-center items-center w-100"},[_c('clip-loader',{attrs:{"loading":_vm.loading,"color":_vm.color,"size":_vm.size2}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.tracks),expression:"!tracks"}],staticClass:"flex justify-center items-center w-100 noResults textColor"},[_vm._v("\n      "+_vm._s(_vm.$t("app.info.noResults"))+"\n    ")]),_vm._v(" "),_vm._l((_vm.tracks),function(track){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.tracks && !_vm.loading),expression:"tracks && !loading"}],key:track.id,staticClass:"track-container relative mb2",class:{ 'track-playing': track == _vm.currentTrack },attrs:{"track-by":track.id}},[_c('track-item-list',{staticClass:"item-container",attrs:{"track":track,"profileTracks":_vm.profileTracks},on:{"play":function($event){return _vm.setPlaylist(_vm.tracks)}}})],1)}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.withPagination && _vm.noMoreResults),expression:"withPagination && noMoreResults"}],staticClass:"flex justify-center items-center w-100 pt2 pb2 textColor"},[_vm._v("\n      "+_vm._s(_vm.$t("app.info.noMoreResults"))+"\n    ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.withPagination && _vm.loadingMore),expression:"withPagination && loadingMore"}],staticClass:"flex justify-center items-center w-100"},[_c('clip-loader',{attrs:{"loading":_vm.loadingMore,"color":_vm.color,"size":_vm.size2}})],1)],2)])}
var staticRenderFns = []


/***/ }),
/* 1039 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tracks-list',{attrs:{"tracks":_vm.allTracks,"loading":_vm.loading},on:{"play":function($event){return _vm.setPlaylist(_vm.allTracks)}}})}
var staticRenderFns = []


/***/ }),
/* 1040 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewTrackWrapper_vue__ = __webpack_require__(462);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_299fb9fd_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewTrackWrapper_vue__ = __webpack_require__(1042);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1041)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewTrackWrapper_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_299fb9fd_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewTrackWrapper_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_299fb9fd_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewTrackWrapper_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1041 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1042 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100 w-100 overflow-y-scroll"},[_c('h1',{staticClass:"tc textColor"},[_vm._v(_vm._s(_vm.$t("tracks.editTrack.title")))]),_vm._v(" "),_c('div',{staticClass:"flex justify-center"},[_c('router-link',{staticClass:"w4 bb bw1 ttu pa2 pointer flex justify-center items-center textColor no-underline link-primary",attrs:{"to":{ name: 'track-new' },"replace":""}},[_vm._v("\n      "+_vm._s(_vm.$t('tracks.uploadTrack'))+"\n    ")]),_vm._v(" "),_c('router-link',{staticClass:"w4 bb bw1 ttu pa2 pointer flex justify-center items-center textColor no-underline link-primary",attrs:{"to":{ name: 'new-album' },"replace":""}},[_vm._v("\n      "+_vm._s(_vm.$t('albums.uploadAlbum'))+"\n    ")])],1),_vm._v(" "),_c('div',{staticClass:"mh6-l mh5-m mh3"},[_c('router-view')],1)])}
var staticRenderFns = []


/***/ }),
/* 1043 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrackNew_vue__ = __webpack_require__(463);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8e0bdca8_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrackNew_vue__ = __webpack_require__(1047);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1044)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8e0bdca8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrackNew_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8e0bdca8_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrackNew_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8e0bdca8_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrackNew_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1044 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1045 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1046 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100 h-100 overflow-y-scroll"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"mv2 flex justify-center items-center h-100 w-100"},[_c('clip-loader',{attrs:{"loading":true,"color":_vm.color,"size":_vm.size}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],staticClass:"ph5-l flex flex-column justify-center items-center"},[_c('h1',{staticClass:"tc textColor"},[_vm._v(_vm._s(_vm.$t("tracks.editTrack.title")))]),_vm._v(" "),_c('div',{staticClass:"flex flex-wrap w-100 justify-center"},[_c('div',[(_vm.trackFile || _vm.track.id)?_c('upload-image',{staticClass:"ma3",attrs:{"path":"/tracks/upload/picture","picturePath":_vm.picture,"trackEdit":true},on:{"uploadFinished":_vm.handleUploadFinished,"uploadStart":function($event){_vm.loadingPicture = true}}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"justify-center"},[(_vm.$v.track.picture.$error && !_vm.$v.track.picture.required)?_c('span',{staticClass:"errorText f7 ph3 ptr"},[_vm._v(_vm._s(_vm.$t("error.pictureRequired")))]):_vm._e()])],1),_vm._v(" "),_c('div',{staticClass:"w-third-l w-100 w-50-m f6"},[_c('div',{staticClass:"w-100 ph2-ns"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.track.title),expression:"track.title"}],staticClass:"w-100 mv2 block ph1 pv2 input",class:{error: _vm.$v.track.title.$error},attrs:{"name":"title","placeholder":_vm.$t('tracks.editTrack.namePlaceholder')},domProps:{"value":(_vm.track.title)},on:{"blur":_vm.$v.track.title.$touch,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.track, "title", $event.target.value)}}}),_vm._v(" "),(_vm.$v.track.title.$error && !_vm.$v.track.title.required)?_c('span',{staticClass:"errorText f7"},[_vm._v(_vm._s(_vm.$t("error.trackNameRequired")))]):_vm._e()]),_vm._v(" "),_c('div',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.mainGenreSelected),expression:"mainGenreSelected"}],staticClass:"w-100 mv2 mh2-ns block ph1 pv2 input",class:{error: _vm.$v.track.id_music_type.$error},attrs:{"id":"id_music_type"},on:{"blur":_vm.$v.track.id_music_type.$touch,"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.mainGenreSelected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.filterChildrensGenres()}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Género")]),_vm._v(" "),_vm._l((_vm.genresMain),function(genre){return _c('option',{key:genre.id,attrs:{"track-by":genre.id},domProps:{"value":genre.id}},[_vm._v(_vm._s(genre.name)+"\n                ")])})],2),_vm._v(" "),(_vm.mainGenreSelected && _vm.isOthers === false)?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.track.id_music_type),expression:"track.id_music_type"}],staticClass:"w-100 mv2 mh2-ns block ph1 pv2 input",class:{error: _vm.$v.track.id_music_type.$error},attrs:{"id":"id_music_type"},on:{"blur":_vm.$v.track.id_music_type.$touch,"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.track, "id_music_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.otherSelected()}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Subgénero")]),_vm._v(" "),_vm._l((_vm.childrensGenres),function(genre){return _c('option',{key:genre.id,attrs:{"track-by":genre.id},domProps:{"value":genre.id}},[_vm._v(_vm._s(genre.name)+"\n                ")])})],2):_vm._e(),_vm._v(" "),(_vm.$v.track.id_music_type.$error && !_vm.$v.track.id_music_type.required)?_c('span',{staticClass:"errorText f7"},[_vm._v(_vm._s(_vm.$t("error.genreRequired")))]):_vm._e()]),_vm._v(" "),(_vm.isOthersChildren === true || _vm.isOthers === true)?_c('div',{staticClass:"w-100 ph2-ns"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.track.recommendedGenre),expression:"track.recommendedGenre"}],staticClass:"w-100 mv2 block ph1 pv2",attrs:{"rows":"4","type":"text","name":"tags","placeholder":_vm.$t('tracks.editTrack.recommendedPlaceHolder')},domProps:{"value":(_vm.track.recommendedGenre)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.track, "recommendedGenre", $event.target.value)}}})]):_vm._e(),_vm._v(" "),_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.track.min_price),expression:"track.min_price"}],staticClass:"w-100 mv2 block ph1 pv2 input",class:{error: _vm.$v.track.min_price.$error},attrs:{"name":"min_price","placeholder":_vm.$t('tracks.minPrice')},domProps:{"value":(_vm.track.min_price)},on:{"blur":_vm.$v.track.min_price.$touch,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.track, "min_price", $event.target.value)}}}),_vm._v(" "),(_vm.$v.track.min_price.$error && !_vm.$v.track.min_price.required)?_c('span',{staticClass:"errorText f7"},[_vm._v(_vm._s(_vm.$t("error.minPriceRequired")))]):_vm._e(),_vm._v(" "),(_vm.$v.track.min_price.$error && !_vm.$v.track.min_price.minValue)?_c('span',{staticClass:"errorText f7"},[_vm._v(_vm._s(_vm.$t("error.minPriceValue")))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"w-100 ph2-ns"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.track.tags),expression:"track.tags"}],staticClass:"w-100 mv2 block ph1 pv2",attrs:{"rows":"4","type":"text","name":"tags","placeholder":_vm.$t('tracks.editTrack.tagsPlaceholder')},domProps:{"value":(_vm.track.tags)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.track, "tags", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"w-100 ph2-ns"},[_c('EditorCK',{attrs:{"placeholder":_vm.$t('tracks.editTrack.creditsPlaceholder'),"credits":_vm.track.credits},on:{"content-change":_vm.handleContentChange}})],1),_vm._v(" "),_c('div',{staticClass:"w-100 ph2-ns"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.track.iswc),expression:"track.iswc"}],staticClass:"w-100 mv2 block ph1 pv2 input",class:{error: !_vm.$v.track.iswc.minLength || !_vm.$v.track.iswc.maxLength},attrs:{"name":"iswc","placeholder":_vm.$t('tracks.editTrack.iswcCode')},domProps:{"value":(_vm.track.iswc)},on:{"blur":_vm.$v.track.iswc.$touch,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.track, "iswc", $event.target.value)}}}),_vm._v(" "),(!_vm.$v.track.iswc.minLength || !_vm.$v.track.iswc.maxLength)?_c('span',{staticClass:"errorText f7"},[_vm._v(_vm._s(_vm.$t("error.iswcErrorCode")))]):_vm._e()])]),_vm._v(" "),(_vm.trackFile !== undefined)?_c('div',{staticClass:"flex flex-column justify-center items-center w4 ma3"},[_c('circle-progress',{ref:"circleProgress",attrs:{"percent":parseFloat(_vm.trackFile.progress),"fill":_vm.circleFill,"emptyFill":"#f4f3f4"}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.trackFile.progress < 100),expression:"trackFile.progress < 100"}],staticClass:"textColor"},[_vm._v(_vm._s(_vm.$t("app.loading")))]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.trackFile.progress == 100),expression:"trackFile.progress == 100"}],staticClass:"textColor"},[_vm._v(_vm._s(_vm.$t("tracks.editTrack.completed")))])],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"flex flex-wrap mv3 mh3 ba br2 b--light-silver w-75-l"},[_c('div',{staticClass:"f6 ph3 w-50-ns"},[_c('p',{staticClass:"b textColor"},[_vm._v(_vm._s(_vm.$t("tracks.licenses.features")))]),_vm._v(" "),_c('p',{staticClass:"mt0 b textColor"},[_vm._v(_vm._s(_vm.$t("tracks.licenses.questions.1.title")))]),_vm._v(" "),_c('div',{staticClass:"flex-ns justify-start items-center"},[_c('label',{staticClass:"ma2 textColor"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.adaptationCondition),expression:"adaptationCondition"}],attrs:{"name":"adaptationCondition","type":"radio","checked":""},domProps:{"value":0,"checked":_vm._q(_vm.adaptationCondition,0)},on:{"change":function($event){_vm.adaptationCondition=0}}}),_vm._v("\n            "+_vm._s(_vm.$t("tracks.licenses.questions.1.options.1")))]),_vm._v(" "),_c('label',{staticClass:"ma2 textColor"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.adaptationCondition),expression:"adaptationCondition"}],attrs:{"name":"adaptationCondition","type":"radio"},domProps:{"value":1,"checked":_vm._q(_vm.adaptationCondition,1)},on:{"change":function($event){_vm.adaptationCondition=1}}}),_vm._v("\n            "+_vm._s(_vm.$t("tracks.licenses.questions.1.options.2")))]),_vm._v(" "),_c('label',{staticClass:"ma2 textColor"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.adaptationCondition),expression:"adaptationCondition"}],attrs:{"name":"adaptationCondition","type":"radio"},domProps:{"value":2,"checked":_vm._q(_vm.adaptationCondition,2)},on:{"change":function($event){_vm.adaptationCondition=2}}}),_vm._v("\n            "+_vm._s(_vm.$t("tracks.licenses.questions.1.options.3")))])]),_vm._v(" "),_c('p',{staticClass:"mt0 b textColor"},[_vm._v(_vm._s(_vm.$t("tracks.licenses.questions.2.title")))]),_vm._v(" "),_c('div',{staticClass:"flex-ns justify-start items-center"},[_c('label',{staticClass:"ma2 textColor"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.commercialCondition),expression:"commercialCondition"}],attrs:{"name":"commercialCondition","type":"radio","checked":""},domProps:{"value":0,"checked":_vm._q(_vm.commercialCondition,0)},on:{"change":function($event){_vm.commercialCondition=0}}}),_vm._v("\n            "+_vm._s(_vm.$t("tracks.licenses.questions.2.options.1")))]),_vm._v(" "),_c('label',{staticClass:"ma2 textColor"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.commercialCondition),expression:"commercialCondition"}],attrs:{"name":"commercialCondition","type":"radio"},domProps:{"value":1,"checked":_vm._q(_vm.commercialCondition,1)},on:{"change":function($event){_vm.commercialCondition=1}}}),_vm._v("\n            "+_vm._s(_vm.$t("tracks.licenses.questions.2.options.2")))])])]),_vm._v(" "),_c('div',{staticClass:"f6 ph3 w-100 w-50-ns textColor"},[_c('p',{staticClass:"b textColor"},[_vm._v(_vm._s(_vm.$t("tracks.licenses.selected")))]),_vm._v(" "),(_vm.actualLicense)?_c('p',{staticClass:"textColor"},[_vm._v(_vm._s(_vm.actualLicense.titulo))]):_vm._e(),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.licenseIcon),expression:"licenseIcon"}],attrs:{"src":_vm.licenseIcon,"alt":_vm.actualLicense.titulo}}),_vm._v(" "),_c('p',{staticClass:"textColor"},[_vm._v(_vm._s(_vm.actualLicense.descripcion))])])]),_vm._v(" "),_c('div',{staticClass:"flex justify-center textColor"},[_c('button',{staticClass:"w4 block mv2 pointer btn dim b f5 fw4 textColor",class:{disabled: _vm.buttonDisabled},attrs:{"disabled":_vm.buttonDisabled},on:{"click":function($event){$event.preventDefault();return _vm.edit()}}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loadingEdition),expression:"!loadingEdition"}]},[_vm._v(_vm._s(_vm.trackFile ? _vm.$t("tracks.newTrack.button") : _vm.$t("app.save")))]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loadingEdition),expression:"loadingEdition"}],staticClass:"flex justify-center"},[_c('clip-loader',{attrs:{"loading":true,"color":_vm.color,"size":_vm.smallSize}})],1)])])])])}
var staticRenderFns = []


/***/ }),
/* 1047 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"example-drag flex justify-center h-100 w-100"},[_c('div',{staticClass:"w-100 h-100"},[_c('div',{staticClass:"w-100 h-100"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"mv2 flex justify-center items-center h-100 w-100"},[_c('clip-loader',{attrs:{"loading":true,"color":_vm.color,"size":_vm.size}})],1),_vm._v(" "),_c('div',{staticClass:"ph5-l flex flex-column justify-center items-center"},[_c('div',{staticClass:"flex flex-wrap w-100 justify-center"},[_c('div',[(_vm.files[0] || _vm.track.id)?_c('upload-image',{staticClass:"ma3",attrs:{"path":"/tracks/upload/picture","picturePath":_vm.picture,"trackEdit":true},on:{"uploadFinished":_vm.handleUploadFinished,"uploadStart":function($event){_vm.loadingPicture = true}}}):_vm._e(),_vm._v(" "),(_vm.files[0] || _vm.track.id)?_c('div',{staticClass:"justify-center"},[(_vm.$v.track.picture.$error && !_vm.$v.track.picture.required)?_c('span',{staticClass:"errorText f7 ph3 ptr"},[_vm._v(_vm._s(_vm.$t("error.pictureRequired")))]):_vm._e()]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"w-third-l w-100 w-50-m f6"},[_c('div',{staticClass:"w-100 ph2-ns"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.track.title),expression:"track.title"}],staticClass:"w-100 mv2 block ph1 pv2 input",class:{error: _vm.$v.track.title.$error},attrs:{"name":"title","placeholder":_vm.$t('tracks.editTrack.namePlaceholder')},domProps:{"value":(_vm.track.title)},on:{"blur":_vm.$v.track.title.$touch,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.track, "title", $event.target.value)}}}),_vm._v(" "),(_vm.$v.track.title.$error && !_vm.$v.track.title.required)?_c('span',{staticClass:"errorText f7"},[_vm._v(_vm._s(_vm.$t("error.trackNameRequired")))]):_vm._e()]),_vm._v(" "),_c('div',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.mainGenreSelected),expression:"mainGenreSelected"}],staticClass:"w-100 mv2 mh2-ns block ph1 pv2 input",class:{error: _vm.$v.track.id_music_type.$error},attrs:{"id":"id_music_type"},on:{"blur":_vm.$v.track.id_music_type.$touch,"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.mainGenreSelected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.filterChildrensGenres()}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Género")]),_vm._v(" "),_vm._l((_vm.genresMain),function(genre){return _c('option',{key:genre.id,attrs:{"track-by":genre.id},domProps:{"value":genre.id}},[_vm._v(_vm._s(genre.name)+"\n                    ")])})],2),_vm._v(" "),(_vm.mainGenreSelected && _vm.isOthers === false)?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.track.id_music_type),expression:"track.id_music_type"}],staticClass:"w-100 mv2 mh2-ns block ph1 pv2 input",class:{error: _vm.$v.track.id_music_type.$error},attrs:{"id":"id_music_type"},on:{"blur":_vm.$v.track.id_music_type.$touch,"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.track, "id_music_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.otherSelected()}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Subgénero")]),_vm._v(" "),_vm._l((_vm.childrensGenres),function(genre){return _c('option',{key:genre.id,attrs:{"track-by":genre.id},domProps:{"value":genre.id}},[_vm._v(_vm._s(genre.name)+"\n                    ")])})],2):_vm._e(),_vm._v(" "),(_vm.$v.track.id_music_type.$error && !_vm.$v.track.id_music_type.required)?_c('span',{staticClass:"errorText f7"},[_vm._v(_vm._s(_vm.$t("error.genreRequired")))]):_vm._e()]),_vm._v(" "),(_vm.isOthersChildren === true || _vm.isOthers === true)?_c('div',{staticClass:"w-100 ph2-ns"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.track.recommendedGenre),expression:"track.recommendedGenre"}],staticClass:"w-100 mv2 block ph1 pv2",attrs:{"rows":"4","type":"text","name":"tags","placeholder":_vm.$t('tracks.editTrack.recommendedPlaceHolder')},domProps:{"value":(_vm.track.recommendedGenre)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.track, "recommendedGenre", $event.target.value)}}})]):_vm._e(),_vm._v(" "),_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.track.min_price),expression:"track.min_price"}],staticClass:"w-100 mv2 block ph1 pv2 input",class:{error: _vm.$v.track.min_price.$error},attrs:{"name":"min_price","placeholder":_vm.$t('tracks.minPrice')},domProps:{"value":(_vm.track.min_price)},on:{"blur":_vm.$v.track.min_price.$touch,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.track, "min_price", $event.target.value)}}}),_vm._v(" "),(_vm.$v.track.min_price.$error && !_vm.$v.track.min_price.required)?_c('span',{staticClass:"errorText f7"},[_vm._v(_vm._s(_vm.$t("error.minPriceRequired")))]):_vm._e(),_vm._v(" "),(_vm.$v.track.min_price.$error && !_vm.$v.track.min_price.minValue)?_c('span',{staticClass:"errorText f7"},[_vm._v(_vm._s(_vm.$t("error.minPriceValue")))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"w-100 ph2-ns"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.track.tags),expression:"track.tags"}],staticClass:"w-100 mv2 block ph1 pv2",attrs:{"rows":"4","type":"text","name":"tags","placeholder":_vm.$t('tracks.editTrack.tagsPlaceholder')},domProps:{"value":(_vm.track.tags)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.track, "tags", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"w-100 ph2-ns"},[_c('EditorCK',{attrs:{"placeholder":_vm.$t('tracks.editTrack.creditsPlaceholder'),"credits":_vm.track.credits},on:{"content-change":_vm.handleContentChange}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.files.length),expression:"!files.length"}],staticClass:"pt4 ph4 pb2 w-30"},[_c('h4',{staticClass:"tc textColor"},[_vm._v(_vm._s(_vm.$t("tracks.newTrack.dropSelectTrack")))]),_vm._v(" "),_c('label',{staticClass:"flex justify-center pa3 pointer",attrs:{"for":"file textColor"}},[_c('font-awesome-icon',{staticClass:"iconColor pa2 white",attrs:{"icon":"upload","size":"6x"}})],1),_vm._v(" "),_c('div',{staticClass:"flex justify-center pv3"},[_c('file-upload',{ref:"upload",staticClass:"btn w5 pointer textColor",attrs:{"post-action":_vm.url,"headers":_vm.postFileHeaders,"extensions":"mp3","drop":!_vm.files.length},on:{"input-file":_vm.inputFile,"input-filter":_vm.inputFilter},model:{value:(_vm.files),callback:function ($$v) {_vm.files=$$v},expression:"files"}},[_vm._v("\n                "+_vm._s(_vm.$t("tracks.newTrack.selectFile"))+"\n              ")])],1),_vm._v(" "),(!_vm.fileValidator)?_c('span',{staticClass:"errorText f7 ph3 ptr"},[_vm._v(_vm._s(_vm.$t("error.trackFileRequired")))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"w-100 ph2-ns lwta"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.track.iswc),expression:"track.iswc"}],staticClass:"w-100 mv2 block ph1 pv2 input",class:{error: !_vm.$v.track.iswc.minLength || !_vm.$v.track.iswc.maxLength},attrs:{"name":"iswc","placeholder":_vm.$t('tracks.editTrack.iswcCode')},domProps:{"value":(_vm.track.iswc)},on:{"blur":_vm.$v.track.iswc.$touch,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.track, "iswc", $event.target.value)}}}),_vm._v(" "),(!_vm.$v.track.iswc.minLength || !_vm.$v.track.iswc.maxLength)?_c('span',{staticClass:"errorText f7"},[_vm._v(_vm._s(_vm.$t("error.iswcErrorCode")))]):_vm._e()])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$refs.upload && _vm.$refs.upload.dropActive),expression:"$refs.upload && $refs.upload.dropActive"}],staticClass:"drop-active"},[_c('h3',{staticClass:"textColor"},[_vm._v(_vm._s(_vm.$t("tracks.newTrack.dropMessage")))])]),_vm._v(" "),(_vm.files[0] !== undefined)?_c('div',{staticClass:"flex flex-column justify-center items-center w4 ma3"},[_c('circle-progress',{ref:"circleProgress",attrs:{"percent":parseFloat(_vm.files[0].progress),"fill":_vm.circleFill,"emptyFill":"#f4f3f4"}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.files[0].progress < 100),expression:"files[0].progress < 100"}],staticClass:"textColor"},[_vm._v(_vm._s(_vm.$t("app.loading")))]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.files[0].progress == 100),expression:"files[0].progress == 100"}],staticClass:"textColor"},[_vm._v(_vm._s(_vm.$t("tracks.editTrack.completed")))])],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"flex flex-wrap mv3 mh3 ba br2 b--light-silver w-75-l"},[_c('div',{staticClass:"f6 ph3 w-50-ns"},[_c('p',{staticClass:"b textColor"},[_vm._v(_vm._s(_vm.$t("tracks.licenses.features")))]),_vm._v(" "),_c('p',{staticClass:"mt0 b textColor"},[_vm._v(_vm._s(_vm.$t("tracks.licenses.questions.1.title")))]),_vm._v(" "),_c('div',{staticClass:"flex-ns justify-start items-center"},[_c('label',{staticClass:"ma2 textColor"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.adaptationCondition),expression:"adaptationCondition"}],attrs:{"name":"adaptationCondition","type":"radio","checked":""},domProps:{"value":0,"checked":_vm._q(_vm.adaptationCondition,0)},on:{"change":function($event){_vm.adaptationCondition=0}}}),_vm._v("\n                "+_vm._s(_vm.$t("tracks.licenses.questions.1.options.1")))]),_vm._v(" "),_c('label',{staticClass:"ma2 textColor"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.adaptationCondition),expression:"adaptationCondition"}],attrs:{"name":"adaptationCondition","type":"radio"},domProps:{"value":1,"checked":_vm._q(_vm.adaptationCondition,1)},on:{"change":function($event){_vm.adaptationCondition=1}}}),_vm._v("\n                "+_vm._s(_vm.$t("tracks.licenses.questions.1.options.2")))]),_vm._v(" "),_c('label',{staticClass:"ma2 textColor"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.adaptationCondition),expression:"adaptationCondition"}],attrs:{"name":"adaptationCondition","type":"radio"},domProps:{"value":2,"checked":_vm._q(_vm.adaptationCondition,2)},on:{"change":function($event){_vm.adaptationCondition=2}}}),_vm._v("\n                "+_vm._s(_vm.$t("tracks.licenses.questions.1.options.3")))])]),_vm._v(" "),_c('p',{staticClass:"mt0 b textColor"},[_vm._v(_vm._s(_vm.$t("tracks.licenses.questions.2.title")))]),_vm._v(" "),_c('div',{staticClass:"flex-ns justify-start items-center"},[_c('label',{staticClass:"ma2 textColor"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.commercialCondition),expression:"commercialCondition"}],attrs:{"name":"commercialCondition","type":"radio","checked":""},domProps:{"value":0,"checked":_vm._q(_vm.commercialCondition,0)},on:{"change":function($event){_vm.commercialCondition=0}}}),_vm._v("\n                "+_vm._s(_vm.$t("tracks.licenses.questions.2.options.1")))]),_vm._v(" "),_c('label',{staticClass:"ma2 textColor"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.commercialCondition),expression:"commercialCondition"}],attrs:{"name":"commercialCondition","type":"radio"},domProps:{"value":1,"checked":_vm._q(_vm.commercialCondition,1)},on:{"change":function($event){_vm.commercialCondition=1}}}),_vm._v("\n                "+_vm._s(_vm.$t("tracks.licenses.questions.2.options.2")))])])]),_vm._v(" "),_c('div',{staticClass:"f6 ph3 w-100 w-50-ns textColor"},[_c('p',{staticClass:"b textColor"},[_vm._v(_vm._s(_vm.$t("tracks.licenses.selected")))]),_vm._v(" "),(_vm.actualLicense)?_c('p',{staticClass:"textColor"},[_vm._v(_vm._s(_vm.actualLicense.titulo))]):_vm._e(),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.licenseIcon),expression:"licenseIcon"}],attrs:{"src":_vm.licenseIcon,"alt":_vm.actualLicense.titulo}}),_vm._v(" "),_c('p',{staticClass:"textColor"},[_vm._v(_vm._s(_vm.actualLicense.descripcion))])])]),_vm._v(" "),_c('div',{staticClass:"pt4 ph4 pb2 w-50-l w-100"},[_c('p',{staticClass:"f7 tc textColor"},[_c('span',{staticClass:"b"},[_vm._v(_vm._s(_vm.$t("tracks.newTrack.important")))]),_vm._v(_vm._s(_vm.$t("tracks.newTrack.info"))+" ")]),_vm._v(" "),_c('p',{staticClass:"f7 b tc textColor"},[_vm._v(_vm._s(_vm.$t("tracks.newTrack.question1")))]),_vm._v(" "),_c('p',{staticClass:"f7 mt0 tc textColor"},[_vm._v(_vm._s(_vm.$t("tracks.newTrack.answer1")))]),_vm._v(" "),_c('p',{staticClass:"f7 b tc textColor"},[_vm._v(_vm._s(_vm.$t("tracks.newTrack.question2")))]),_vm._v(" "),_c('p',{staticClass:"f7 mt0 tc textColor"},[_vm._v(_vm._s(_vm.$t("tracks.newTrack.answer2")))])]),_vm._v(" "),_c('div',{staticClass:"flex justify-center textColor"},[_c('button',{staticClass:"w4 block mv2 pointer btn dim b f5 fw4 textColor",class:{disabled: _vm.buttonDisabled},attrs:{"disabled":_vm.buttonDisabled},on:{"click":function($event){$event.preventDefault();return _vm.edit()}}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loadingEdition),expression:"!loadingEdition"}]},[_vm._v(_vm._s(_vm.files[0] ? _vm.$t("tracks.newTrack.button") : _vm.$t("app.save")))]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loadingEdition),expression:"loadingEdition"}],staticClass:"flex justify-center"},[_c('clip-loader',{attrs:{"loading":true,"color":_vm.color,"size":_vm.smallSize}})],1)])])])])])])}
var staticRenderFns = []


/***/ }),
/* 1048 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VinylContest_vue__ = __webpack_require__(465);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c584849_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VinylContest_vue__ = __webpack_require__(1052);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1049)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6c584849"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VinylContest_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c584849_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VinylContest_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c584849_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VinylContest_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1049 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1050 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Countdown_vue__ = __webpack_require__(466);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_378f6228_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Countdown_vue__ = __webpack_require__(1051);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Countdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_378f6228_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Countdown_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_378f6228_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Countdown_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1051 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"countdown"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.days),expression:"days"}]},[_c('span',{staticClass:"b number textColor"},[_vm._v(_vm._s(_vm.days))]),_vm._v(" "+_vm._s(_vm.$tc('vinylContest.day', _vm.days)))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.hours),expression:"hours"}]},[_c('span',{staticClass:"b number textColor"},[_vm._v(_vm._s(_vm.hours))]),_vm._v(" "+_vm._s(_vm.$tc('vinylContest.hour', _vm.hours)))]),_vm._v(" "),_c('span',{staticClass:"b number textColor"},[_vm._v(_vm._s(_vm.minutes))]),_vm._v(" "+_vm._s(_vm.$tc('vinylContest.minute', _vm.minutes))+"\n")])}
var staticRenderFns = []


/***/ }),
/* 1052 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"flex justify-center mt3"},[_c('clip-loader',{attrs:{"loading":_vm.loading,"color":_vm.color,"size":_vm.size}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],staticClass:"overflow-y-scroll total-height"},[_c('div',{staticClass:"mt3-l ml5-l mr5-l"},[_c('p',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hasArtists),expression:"!hasArtists"}],staticClass:"f3-ns tc textColor"},[_vm._v(_vm._s(_vm.$t('vinylContest.noArtist')))]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.info),expression:"info"}],staticClass:"f3-ns tc textColor"},[_vm._v(_vm._s(_vm.$t('vinylContest.closeIn'))+"\n        "),_c('countdown',{attrs:{"end":_vm.info.final}})],1),_vm._v(" "),_vm._l((_vm.artists),function(artist,index){return (index < 4)?_c('div',{key:artist.id,attrs:{"track-by":artist.id}},[_c('vinyl-contest-podium',{staticClass:"mr2",attrs:{"artist":artist,"index":index}})],1):_vm._e()}),_vm._v(" "),_c('div',{staticClass:"flex flex-column"},_vm._l((_vm.artists),function(artist,index){return (index >= 4)?_c('div',{key:artist.id,staticClass:"bb b--black-05 pa1",attrs:{"track-by":artist.id}},[_c('div',{staticClass:"flex items-center justify-between"},[_c('div',{staticClass:"flex justify-start items-center"},[_c('div',{staticClass:"image-container-list flex items-center justify-center"},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(artist),expression:"artist"}],staticClass:"h-100",attrs:{"src":_vm.picture(artist)}})]),_vm._v(" "),_c('div',{staticClass:"flex items-center number mr2 ml2"},[_c('span',{staticClass:"light-silver f2-l f5"},[_vm._v("#")]),_c('span',{staticClass:"light-silver f1-l f3"},[_vm._v(_vm._s(index + 1))])]),_vm._v(" "),_c('router-link',{staticClass:"textColor no-underline",attrs:{"to":{ name:'artist-info', params: { id: artist.id }}}},[_c('div',{staticClass:"artist-info"},[_c('artist-data',{attrs:{"artist":artist,"isPodium":index > 0 && index < 4}})],1)])],1),_vm._v(" "),_c('div',{staticClass:"db-ns dn pr4-l pr2"},[_c('circle-progress',{staticClass:"mr2-l",attrs:{"percent":artist.percent,"emptyFill":"#aaa","fill":{gradient: ['rgba(0, 0, 0, .8)', 'gray', 'darkgray']}}})],1),_vm._v(" "),_c('div',{staticClass:"dn-ns pr2"},[_c('circle-progress',{attrs:{"percent":artist.percent,"emptyFill":"#aaa","fill":{gradient: ['rgba(0, 0, 0, .8)', 'gray', 'darkgray']},"size":60}})],1)])]):_vm._e()}),0)],2)])])}
var staticRenderFns = []


/***/ }),
/* 1053 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__(467);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b2f724c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__(1104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1054)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0b2f724c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b2f724c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b2f724c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1054 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-panel"},[_c('div',{staticStyle:{"padding":"10px"}},[(!_vm.user.subscription)?_c('div',{staticClass:"bg-primary textColor",staticStyle:{"margin-top":"10px","padding":"20px","text-align":"center"}},[_c('h3',[_vm._v(_vm._s(_vm.$t("dashboard.atention")))]),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.$t("dashboard.warning")))])]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('row',{attrs:{"container":"","gutter":10}},[_c('column',{attrs:{"lg":4,"md":5,"xs":12,"lgOffset":2,"mdOffset":1}},[_c('div',{staticStyle:{"display":"flex","justify-content":"space-around"}},[_c('b-button',{staticClass:"btn2",attrs:{"size":"sm","disabled":!_vm.user.subscription},on:{"click":function($event){return _vm.rangeClick(180)}}},[_vm._v("180")]),_vm._v(" "),_c('b-button',{staticClass:"btn2",attrs:{"size":"sm","disabled":!_vm.user.subscription},on:{"click":function($event){return _vm.rangeClick(90)}}},[_vm._v("90")]),_vm._v(" "),_c('b-button',{staticClass:"btn2",attrs:{"size":"sm","disabled":!_vm.user.subscription},on:{"click":function($event){return _vm.rangeClick(60)}}},[_vm._v("60")]),_vm._v(" "),_c('b-button',{staticClass:"btn2",attrs:{"size":"sm","disabled":!_vm.user.subscription},on:{"click":function($event){return _vm.rangeClick(30)}}},[_vm._v("30")]),_vm._v(" "),_c('b-button',{staticClass:"btn2",attrs:{"size":"sm","disabled":!_vm.user.subscription},on:{"click":function($event){return _vm.rangeClick(15)}}},[_vm._v("15")]),_vm._v(" "),_c('b-button',{staticClass:"btn2",attrs:{"size":"sm","disabled":!_vm.user.subscription},on:{"click":function($event){return _vm.rangeClick(7)}}},[_vm._v("7")])],1)]),_vm._v(" "),_c('column',{attrs:{"lg":3,"md":5,"xs":12}},[_c('date-picker',{staticClass:"mx-datepicker-range",attrs:{"range":"","clearable":"","confirm":"","confirm-text":"OK","disabled":!_vm.user.subscription,"width":"100%","input-class":"form-control"},model:{value:(_vm.dateRange),callback:function ($$v) {_vm.dateRange=$$v},expression:"dateRange"}})],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('row',{attrs:{"container":"","gutter":10}},[_c('column',{attrs:{"xs":12,"md":6,"lg":3}},[_c('div',{staticClass:"widget navy-bg h-100"},[_c('b-row',[_c('b-col',[_c('font-awesome-icon',{attrs:{"icon":"upload","size":"2x","pull":"left"}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"9","align":"end"}},[_c('span',[_vm._v(_vm._s(_vm.$t("dashboard.upload")))]),_vm._v(" "),_c('h2',{staticClass:"font-bold"},[(_vm.user.role === 'ROLE_ADMIN')?_c('img',{staticStyle:{"filter":"invert(100%)"},attrs:{"id":"admin","src":__webpack_require__(1105),"height":"28"}}):_vm._e(),_vm._v(" "),_c('b-tooltip',{attrs:{"target":"admin","variant":"light"}},[_vm._v("  "+_vm._s(_vm.$t("dashboard.tooltipAdmin"))+"  \n                    ")]),_vm._v(" "),(_vm.myArtistInfo)?_c('img',{staticStyle:{"filter":"invert(100%)"},attrs:{"id":"artist","src":__webpack_require__(1106),"height":"28"}}):_vm._e(),_vm._v(" "),_c('b-tooltip',{attrs:{"target":"artist","variant":"light"}},[_vm._v("  "+_vm._s(_vm.$t("dashboard.tooltipArtist"))+"  \n                    ")]),_vm._v(" "),(_vm.user.subscription)?_c('img',{staticStyle:{"filter":"invert(100%)"},attrs:{"id":"subscription","src":__webpack_require__(1107),"height":"28"}}):_vm._e(),_vm._v(" "),_c('b-tooltip',{attrs:{"target":"subscription","variant":"light"}},[_vm._v("  "+_vm._s(_vm.$t("dashboard.tooltipSubscribed"))+"  \n                    ")]),_vm._v("\n                        \n                    "+_vm._s(_vm.metrics.uploads)+"\n                  ")],1)])],1)],1)]),_vm._v(" "),_c('column',{attrs:{"xs":12,"md":6,"lg":3}},[_c('div',{staticClass:"widget navy-bg h-100"},[_c('b-row',[_c('b-col',[_c('font-awesome-icon',{attrs:{"icon":"calendar","size":"2x","pull":"left"}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"8","align":"end"}},[_c('span',[_vm._v(_vm._s(_vm.$t("dashboard.daysWithoutUpload")))]),_vm._v(" "),(
                      _vm.metrics.lastDaysUpload !== 'El artista no tiene tracks'
                    )?_c('h2',{staticClass:"font-bold"},[_vm._v("\n                    "+_vm._s(_vm.metrics.lastDaysUpload)+"\n                  ")]):_vm._e(),_vm._v(" "),(
                      _vm.metrics.lastDaysUpload === 'El artista no tiene tracks'
                    )?_c('h2',{staticClass:"font-bold"},[_vm._v("\n                    0\n                  ")]):_vm._e()])],1)],1)]),_vm._v(" "),_c('column',{attrs:{"xs":12,"md":6,"lg":3}},[_c('div',{staticClass:"widget navy-bg h-100"},[_c('b-row',[_c('b-col',[_c('font-awesome-icon',{attrs:{"icon":"calculator","size":"2x","pull":"left"}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"8","align":"end"}},[_c('span',[_vm._v(_vm._s(_vm.$t("dashboard.avg")))]),_vm._v(" "),_c('h2',{staticClass:"font-bold"},[_vm._v("\n                    "+_vm._s(_vm.computedAverage(this.metrics.monthlyAverageUpload))+"\n                  ")])])],1)],1)]),_vm._v(" "),_c('column',{attrs:{"xs":12,"md":6,"lg":3}},[_c('div',{staticClass:"widget navy-bg h-100"},[_c('b-row',[_c('b-col',[_c('font-awesome-icon',{attrs:{"icon":"heart","size":"2x","pull":"left"}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"8","align":"end"}},[_c('span',[_vm._v(_vm._s(_vm.$t("dashboard.followers")))]),_vm._v(" "),_c('h2',{staticClass:"font-bold"},[_vm._v(_vm._s(_vm.metrics.followers))])])],1)],1)])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('row',{attrs:{"container":"","gutter":10}},[_c('column',{staticStyle:{"text-align":"center"},attrs:{"xs":12,"md":12,"lg":12}},[_c('h3',[_vm._v("\n          "+_vm._s(_vm.$t("dashboard.reproductionsRanking"))+"\n        ")])]),_vm._v(" "),_c('column',{attrs:{"xs":12,"md":12,"lg":12}},[_c('div',{ref:"chartdiv",staticStyle:{"width":"100%","height":"280px"},attrs:{"id":"chartdiv"}})])],1),_vm._v(" "),(_vm.songRanking && _vm.songRanking.length !== 0)?_c('row',{attrs:{"container":"","gutter":10}},[_c('column',{staticStyle:{"text-align":"center"},attrs:{"xs":12,"md":12,"lg":12}},[_c('h3',[_vm._v("\n          "+_vm._s(_vm.$t("dashboard.songRanking"))+"\n        ")])]),_vm._v(" "),_c('column',{attrs:{"lg":8,"md":12,"xs":12,"lgOffset":2}},[_c('div',[_c('b-table',{staticClass:"tableClass",attrs:{"items":_vm.songRanking,"fields":_vm.fields},scopedSlots:_vm._u([{key:"cell(picture)",fn:function(songRanking){return [_c('img',{staticClass:"img-fluid img-thumbnail",staticStyle:{"height":"40px","width":"auto","object-fit":"contain","object-position":"center"},attrs:{"src":_vm.computedImage(songRanking.item.picture)}})]}},{key:"head(title)",fn:function(songRanking){return [_c('div',{staticStyle:{"text-align":"left"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_vm._v(_vm._s(songRanking.label))]),_vm._v("\n                    "+_vm._s(_vm.$t("dashboard.tableName"))+"\n                  ")])]}},{key:"head(artistName)",fn:function(songRanking){return [_c('div',{staticStyle:{"text-align":"center"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_vm._v(_vm._s(songRanking.label))]),_vm._v("\n                    "+_vm._s(_vm.$t("dashboard.tableArtist"))+"\n                  ")])]}},{key:"head(reproductions)",fn:function(songRanking){return [_c('div',{staticStyle:{"text-align":"right"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_vm._v(_vm._s(songRanking.label))]),_vm._v("\n                  "+_vm._s(_vm.$t("dashboard.tableRepro"))+"\n                ")])]}},{key:"head(likes)",fn:function(songRanking){return [_c('div',{staticStyle:{"text-align":"right"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_vm._v(_vm._s(songRanking.label))]),_vm._v("\n                  "+_vm._s(_vm.$t("dashboard.tableLikes"))+"\n                ")])]}},{key:"cell(title)",fn:function(songRanking){return [_c('h3',[_vm._v("\n                    "+_vm._s(songRanking.item.title)+"\n                  ")])]}},{key:"cell(artistName)",fn:function(songRanking){return [_c('div',{staticClass:"artistColor",staticStyle:{"text-align":"center"}},[_vm._v("\n                  "+_vm._s(songRanking.item.artistName)+"\n                ")])]}},{key:"cell(reproductions)",fn:function(songRanking){return [_c('div',{staticStyle:{"text-align":"right"}},[_vm._v("\n                  "+_vm._s(songRanking.item.reproductions)+"\n                      \n                    "),_c('font-awesome-icon',{attrs:{"icon":"headphones","color":"green"}})],1)]}},{key:"cell(likes)",fn:function(songRanking){return [_c('div',{staticStyle:{"text-align":"right"}},[_vm._v("\n                  "+_vm._s(songRanking.item.likes)+"\n                      \n                    "),_c('font-awesome-icon',{attrs:{"icon":"heart","color":"red"}})],1)]}}],null,false,655799755)})],1)])],1):_vm._e(),_vm._v(" "),_c('br')],1)])}
var staticRenderFns = []


/***/ }),
/* 1105 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1106 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1107 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABmJLR0QA/wD/AP+gvaeTAAAFbklEQVR4nO2abYhVRRjHf67e626u7tZiIuVLabVoW5m1KRiRlET4SbNts6A3NqIkioIQlqCgFKLaokKlMMMPGUlGbb5ErxaYUUlpSb6UZaxpGvayu/fWvX2YszlnzpyXOTN77926f3i4954783/+M2fOzDPPHKiiiiqq+B9jWBn9jgcmAk3AKZ41SZ/1QB3QCIzyvo+ROLLe9QG+VBiRtmICZICzgOlAMzAZmOTZBGDkIPpODJcdcCowF5jl2QzEXfpPoxl4GNgO/A0Uy2QlRRa4EfjAgfCyd4Dp5HEtsAw4w8JnD3AA+MGzw8Axz45K3wveJ8DvQN7CZyiSdsAo4AVEByTFAeAz4HPPvvGu9ZsIrAQ0AB8RPwz/AF4BbkbM9JWAqcA+YAfQQcrl8g2iG74VaAdOstfrFFMRj5is9XlTkvmEN3wb0OpIrC3U5bwW2I9e9yIT4g0aggLwAFBjJdkd5iPmlgXK9WuAHEH9G03IezQEy+z0OkM9sIoTunLAQqWMrhPWmzjJE+yAcTaqHaEZ2ElQWw7RaBlyJ2xB7CkS45jGyekWwl1gEXCc8LlJ1wkLgW4MGw/wjsbB0pTCXaATMQfFLcl5DCe7MNyjIe8H2lyQGyCDCMRMwuM8ZoGbFk3AzxryAtBFadb+BuBtjYaknWB9sxZHONgNzLZ1EIFJwFcR/ks2EjojHOSAO2wdaDANOBjh18T6gXm2gu70iMKc3GbrQMIM9I+ejfUAJ9sKawX2hDjoxc0SORv98pvGtim/H3Sgj9HA6hCHT1hyXwb8FsJtal2ICfSQdG2HpT4fntM43WXBdwki8eGi8R8ilk6AV6Xrxy30BTBe47jPgm8sImli2/ifPG0DeE3676CFvgDqNM6PWnJOJLiHN7EcMEfia8Q/n7xuqc8HXa5gtwPeacARDXcSu13hekr5f7EDfYA4odmlEbAqBddw4Grl2izM54NHFY42/PuGb3F0DpJFH5oWgIsMuWqANYgzBXUvfxXRcYdsa/Hn+y5A5CjlMlcaatMiA6wLEWF694cBK6T6fxJMsbUTf+DyLv5jtrHAd0qZLkNtWoxEnyIrImbvRkO+JzU8PYgzRBlLQnwWEeu6HN1lgPeUMvKSmBq1wKYQET9qRMdhaQhXEbH5aVDKP6Qp9zXiPFLGM0oZdUlMhQxi+dCJ3Qecach3A/FJjc0E75oceO0FTlP+71A4+vEvialQA7wcIvITzPODc0k+sa3UaFmHiBPUETdHw3uLoTYtHgkRtwHzZEgL8GsIX5jdr3BkCTZ+Mv54vwg8bqhNi3noh+oazNfTcYjcvUnji4gV4LwI3jHAl0qdbkRsYYU64HuNoBWYH4hkEcdnpo0vEp2AHQG8pZTfSXACTYX7NGI2kq5nV2q44qwA3B3D+7RS5xB2x/b/YjjBDclezNd5EFkk08b3IQKgKNyl1OnFYW7yCo2oNJnVVvRnc1H2C3BpAu5bgb84MVquS6EvFMsVUV9g/tyPJjx1FmZ7gLMNfLQjMr6dhtpi8b4ibEkKjhcxa/xWRAxvipkMwruO6kbiXMP6CzBr/LNU2Ot0arBSa1A3S/Kh34ujaM015JPXAmZD7F6SNX4/cLE7yemhm9zkzOnALJ4URxB3NgqrgfMRL1dWJD7FPwLqDeu3ILaq6l0/TPA1lorEWvzCL0xQZwL+KLEeeMmrn0MkJ5vcyhw8qFHWTQnqbEI0WA2V24BznKorAabg3wVuiSl/uVRW1wlDEt34R8H1EWU/lsq9STBTMyQxE38cn0eEyNMJvmi0HZF4TBLDDynotsQD1lJGXSVFB/oc3vJyiio1pgCPIY6W+hDn95vLqqiKKqqoogo3+AfXF6yOS9JaYAAAAABJRU5ErkJggg=="

/***/ }),
/* 1108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserProfile_vue__ = __webpack_require__(540);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9450dc46_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserProfile_vue__ = __webpack_require__(1110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1109)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9450dc46"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserProfile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9450dc46_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserProfile_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9450dc46_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserProfile_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1109 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overflow-y-scroll h w-100"},[_c('div',{staticClass:"h4 db w-100 cover center bg-image"}),_vm._v(" "),_c('div',{staticClass:"position-100 relative"},[_c('div',{staticClass:"flex items-center ma3 h4"},[_c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
              content: _vm.msg,
              placement: 'bottom-center',
              classes: 'my_tooltip',
              offset: 5,
              delay: {
                show: 10,
                hide: 10,
              },
            }),expression:"{\n              content: msg,\n              placement: 'bottom-center',\n              classes: 'my_tooltip',\n              offset: 5,\n              delay: {\n                show: 10,\n                hide: 10,\n              },\n            }"},{name:"show",rawName:"v-show",value:(_vm.user),expression:"user"}],staticClass:"db br-100 w4 min-w4 h4 cover relative flex items-end justify-center",style:({ 'background-image': 'url(' + _vm.picture + ')' })},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.files.length && _vm.files[0].progress < 100),expression:"files.length && files[0].progress < 100"}],staticClass:"flex justify-center items-center h4 w4"},[_c('clip-loader',{attrs:{"loading":true,"color":_vm.color,"size":_vm.size}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.files.length),expression:"!files.length"}],staticClass:"flex justify-center items-end"},[_c('file-upload',{ref:"imageUpload",staticClass:"ph2 pointer",attrs:{"post-action":_vm.url,"headers":_vm.postFileHeaders,"extensions":"jpg,jpeg,png,webp","input-id":"file1"},on:{"input-file":_vm.imageInputFile,"input-filter":_vm.imageInputFilter},model:{value:(_vm.files),callback:function ($$v) {_vm.files=$$v},expression:"files"}},[_c('div',{staticClass:"edit-button bg-primary ma2 br-100 flex items-center justify-center pointer"},[_c('font-awesome-icon',{staticClass:"white",attrs:{"icon":"camera"}})],1)])],1)]),_vm._v(" "),(_vm.user)?_c('h1',{staticClass:"ttu ma3-ns ma2 secondary fw5 f2-ns f5 name textColor"},[_vm._v(_vm._s(_vm.user.first_name)+" "+_vm._s(_vm.user.last_name))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"flex bb bw1 mh6-l mh5-m mh3 mt33"},[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(!_vm.bitelFreeMusic),expression:"!bitelFreeMusic"}],staticClass:"w4 ttu pa2 pointer flex justify-center items-center textColor no-underline link-primary",attrs:{"to":{ name: 'profile-info' },"replace":""}},[_vm._v("\n        "+_vm._s(_vm.$t("users.userMenu.myProfile"))+"\n      ")]),_vm._v(" "),(_vm.isProducer)?_c('router-link',{staticClass:"w4 ttu pa2 pointer flex justify-center items-center textColor no-underline link-primary",attrs:{"to":{ name: 'my-tracks' },"replace":""}},[_vm._v("\n        "+_vm._s(_vm.$t("users.userMenu.myTracks"))+"\n      ")]):_vm._e(),_vm._v(" "),_c('router-link',{staticClass:"w4 ttu pa2 pointer flex justify-center items-center textColor no-underline link-primary",attrs:{"to":{ name: 'my-playlists' },"replace":""}},[_vm._v("\n        "+_vm._s(_vm.$t("users.userMenu.myPlaylists"))+"\n      ")]),_vm._v(" "),_c('router-link',{staticClass:"w4 ttu pa2 pointer flex justify-center items-center textColor no-underline link-primary",attrs:{"to":{ name: 'my-favorites' },"replace":""}},[_vm._v("\n        "+_vm._s(_vm.$t("users.userMenu.myFavorites"))+"\n      ")]),_vm._v(" "),_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(!_vm.bitelFreeMusic),expression:"!bitelFreeMusic"}],staticClass:"w4 ttu pa2 pointer flex justify-center items-center textColor no-underline link-primary",attrs:{"to":{ name: 'my-shopping' },"replace":""}},[_vm._v("\n        "+_vm._s(_vm.$t("users.userMenu.myShopping"))+"\n      ")])],1),_vm._v(" "),_c('div',{staticClass:"mh6-l mh5-m mh3"},[_c('router-view')],1)])])}
var staticRenderFns = []


/***/ }),
/* 1111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyTracks_vue__ = __webpack_require__(541);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70962606_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyTracks_vue__ = __webpack_require__(1113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1112)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-70962606"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyTracks_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70962606_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyTracks_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70962606_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyTracks_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1112 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"flex justify-center"},[(_vm.showReorderButton && _vm.tracks.length > 10)?_c('button',{staticClass:"w-30-l w-50-m w-100 block mv2 pointer btn dim b f5 fw4 textColor",on:{"click":_vm.confirmTracksOrderChange}},[_vm._v("\n      "+_vm._s(_vm.$t("tracks.editTrack.saveChanges"))+"\n    ")]):_vm._e()]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"flex justify-center mt3 textColor"},[_c('clip-loader',{attrs:{"loading":_vm.loading,"color":_vm.color,"size":_vm.size}})],1),_vm._v(" "),_c('div',{staticClass:"track-list-header h2 w-95 mb1 textColor displayNone"},[_c('p',{staticClass:"fl w-10 h-100 ma0 textColor"}),_vm._v(" "),_c('p',{staticClass:"fl w-30 h-100 pa1 pl8 ma0 text-ellipsis center-content b textColor"},[_vm._v("\n      "+_vm._s(_vm.$t("tracks.headers.title"))+"\n    ")]),_vm._v(" "),_c('p',{staticClass:"fl w-20 h-100 pa1 pl3 ma0 text-ellipsis center-content b textColor"}),_vm._v(" "),_c('p',{staticClass:"fl w-20 h-100 pa1 ma0 text-ellipsis center-content b textColor dw-163"},[_vm._v("\n      "+_vm._s(_vm.$t("tracks.headers.genre"))+"\n    ")]),_vm._v(" "),_c('p',{staticClass:"released fl w-15 h-100 pa1 ma0 center-content b textColor"},[_vm._v("\n      "+_vm._s(_vm.$t("tracks.headers.duration"))+"\n    ")]),_vm._v(" "),_c('p',{staticClass:"fl w-5 h-100 ma0"})]),_vm._v(" "),_c('div',{staticClass:"ph5-l"},[_c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"flex flex-column self-end pr1 pl1 textColor"},[_c('draggable',{attrs:{"options":_vm.options},model:{value:(_vm.tracks),callback:function ($$v) {_vm.tracks=$$v},expression:"tracks"}},_vm._l((_vm.tracks),function(track,index){return _c('div',{key:index,staticClass:"bb b--black-05 pa1 nowrap textColor relative mb2",class:{'track-playing' : track === _vm.currentTrack}},[_c('div',{staticClass:"drag-icon dib v-mid ma0 pointer textColor"},[_c('font-awesome-icon',{attrs:{"icon":"bars","size":"lg"}})],1),_vm._v(" "),_c('track-item-list',{staticClass:"item-container dib v-mid vw66",attrs:{"track":track,"profileTracks":true},on:{"play":function($event){return _vm.setPlaylist(_vm.tracks)}}})],1)}),0)],1)])],1),_vm._v(" "),_c('div',{staticClass:"flex justify-center"},[(_vm.showReorderButton)?_c('button',{staticClass:"w-30-l w-50-m w-100 block mv2 pointer btn dim b f5 fw4 textColor",on:{"click":_vm.confirmTracksOrderChange}},[_vm._v("\n      "+_vm._s(_vm.$t("tracks.editTrack.saveChanges"))+"\n    ")]):_vm._e()])])}
var staticRenderFns = []


/***/ }),
/* 1114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyPlaylists_vue__ = __webpack_require__(542);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ce83181_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyPlaylists_vue__ = __webpack_require__(1123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1115)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyPlaylists_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ce83181_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyPlaylists_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ce83181_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyPlaylists_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1115 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyPlaylistsCarousel_vue__ = __webpack_require__(543);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40aa50e4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyPlaylistsCarousel_vue__ = __webpack_require__(1122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1117)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-40aa50e4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyPlaylistsCarousel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40aa50e4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyPlaylistsCarousel_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40aa50e4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyPlaylistsCarousel_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1117 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1118 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.track)?_c('div',[_c('div',{staticClass:"h-100 w-100 flex"},[_c('div',{staticClass:"pointer h-100 w-79 flex flex-column bg-primary resize"},[_c('div',{staticClass:"fl ma0 items-center justify-between"},[_c('div',{staticClass:"image-container"},[_c('img',{staticClass:"image-container h-100 w-70",attrs:{"src":_vm.trackPicture}})])]),_vm._v(" "),_c('p',{staticClass:"track-container title fl h-100 pa1 pr3 ma0 text-ellipsis center-content textColor trackTitle"},[_vm._v(_vm._s(_vm.track.title))]),_vm._v(" "),_c('router-link',{staticClass:"textColor no-underline",attrs:{"to":{ name:'artist-info', params:{ id:_vm.track.id_artist }},"append":""},nativeOn:{"click":function($event){$event.stopPropagation();}}},[(_vm.track.artist)?_c('p',{staticClass:"track-container artist fl h-100 pa1 ma0 text-ellipsis center-content textColor artistName"},[_vm._v(_vm._s(_vm.track.artist.name))]):_vm._e(),_vm._v(" "),(_vm.track.name)?_c('p',{staticClass:"track-container artist fl h-100 pa1 ma0 text-ellipsis center-content textColor artistName"},[_vm._v(_vm._s(_vm.track.name))]):_vm._e()]),_vm._v(" "),(_vm.track.genre)?_c('p',{staticClass:"track-container genre fl h-100 pa1 ma0 text-ellipsis center-content textColor genreNameAndTime"},[_vm._v(_vm._s(_vm.track.genre.name))]):_vm._e(),_vm._v(" "),(_vm.track.music_type)?_c('p',{staticClass:"track-container genre fl h-100 pa1 ma0 text-ellipsis center-content textColor genreNameAndTime"},[_vm._v(_vm._s(_vm.track.music_type))]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"track-container released fl h-100 pa1 ma0 center-content textColor genreNameAndTime"},[_vm._v(_vm._s(this.trackTime))]),_vm._v(" "),_c('track-options-button',{staticClass:"ma0 textColor",attrs:{"track":_vm.track,"inMyLikes":true}})],1)])]):_vm._e(),_vm._v(" "),(_vm.playlist)?_c('div',[_c('div',{staticClass:"h-100 w-100 flex"},[_c('div',{staticClass:"pointer h-100 w-79 flex flex-column bg-primary minH-220"},[_c('div',{staticClass:"fl ma0 items-center justify-between"},[_c('div',{staticClass:"image-container"},[_c('img',{staticClass:"image-container h-100 w-100",attrs:{"src":_vm.playlistPicture}})])]),_vm._v(" "),_c('p',{staticClass:"track-container title fl h-100 pa1 pr3 ma0 text-ellipsis center-content textColor"},[_vm._v(_vm._s(_vm.playlist.title))]),_vm._v(" "),_c('p',{staticClass:"track-container genre fl h-100 pa1 ma0 text-ellipsis center-content textColor"},[_vm._v(_vm._s(_vm.playlist.user.user_name))]),_vm._v(" "),(!_vm.isMyPlaylists)?_c('button',{staticClass:"like-button pa2 iconColor",attrs:{"title":_vm.$t('playlists.like.button')},on:{"click":function($event){return _vm.likePlaylist()}}},[_c('font-awesome-icon',{class:_vm.liking ? 'liked' : 'iconColor',attrs:{"icon":"heart"}})],1):_vm._e()])])]):_vm._e()])}
var staticRenderFns = []


/***/ }),
/* 1120 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"artist-card relative flex pointer pa3 cover bg-center resize",class:{'artist-card-profile': _vm.isProfile}},[_c('div',{staticClass:"flex-column w-100"},[_c('router-link',{staticClass:"artist-info",attrs:{"to":{ name:'playlist', params:{ id: _vm.playlist.id }}}},[_c('div',{staticClass:"h-100 w-100 flex"},[_c('div',{staticClass:"pointer h-100 flex flex-column bg-primary minH-220"},[_c('div',{staticClass:"fl ma0 items-center justify-between"},[_c('div',{staticClass:"image-playlist-container"},[_c('img',{staticClass:"image-playlist-container",attrs:{"src":_vm.playlistPicture,"alt":((_vm.playlist.title) + " Picture")}})])]),_vm._v(" "),_c('p',{staticClass:"playlist-card-container title fl h-100 pa1 pr3 ma0 text-ellipsis center-content textColor"},[_vm._v(_vm._s(_vm.playlist.title))]),_vm._v(" "),_c('p',{staticClass:"playlist-card-container genre fl h-100 pa1 ma0 text-ellipsis center-content textColor"},[_vm._v(_vm._s(_vm.playlist.user.user_name))]),_vm._v(" "),(!_vm.isMyPlaylists)?_c('button',{staticClass:"like-button pa2 iconColor",attrs:{"title":_vm.$t('playlists.like.button')},on:{"click":function($event){return _vm.likePlaylist()}}},[_c('font-awesome-icon',{class:_vm.liking ? 'liked' : 'iconColor',attrs:{"icon":"heart"}})],1):_vm._e()])])])],1)])}
var staticRenderFns = []


/***/ }),
/* 1122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('div',{staticClass:"w-100 justify-around items-center ttu",staticStyle:{"background-color":"#393839","position":"relative","display":"flex"}},[_c('div',[_c('a',{staticStyle:{"margin-left":"10px","fill":"white","cursor":"pointer"},on:{"click":function($event){return _vm.carouselTranslate('playlistsCarousel', 'left')}}},[_c('svg',{staticClass:"bi bi-caret-left",attrs:{"width":"25","height":"25","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M10 12.796V3.204L4.519 8 10 12.796zm-.659.753-5.48-4.796a1 1 0 0 1 0-1.506l5.48-4.796A1 1 0 0 1 11 3.204v9.592a1 1 0 0 1-1.659.753z"}})])])]),_vm._v(" "),_c('div'),_vm._v(" "),(_vm.playlists)?_c('div',{staticClass:"container-scroll w-100"},[_c('div',{staticClass:"container-genbar",attrs:{"id":"playlistsCarousel"}},_vm._l((_vm.playlists),function(playlist){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.playlists.length > 0),expression:"playlists.length > 0"}],key:playlist.id,staticClass:"genre-filter f6 link dim ph2 pv2 dib white",attrs:{"track-by":playlist.id,"tabindex":playlist.title}},[_c('modal-playlist-card',{staticStyle:{"width":"190px"},attrs:{"playlist":playlist,"isMyPlaylists":true}})],1)}),0)]):_vm._e(),_vm._v(" "),_c('div',[_c('a',{staticStyle:{"margin-right":"10px","fill":"white","cursor":"pointer"},on:{"click":function($event){return _vm.carouselTranslate('playlistsCarousel', 'right')}}},[_c('svg',{staticClass:"bi bi-caret-right",attrs:{"width":"25","height":"25","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M6 12.796V3.204L11.481 8 6 12.796zm.659.753 5.48-4.796a1 1 0 0 0 0-1.506L6.66 2.451C6.011 1.885 5 2.345 5 3.204v9.592a1 1 0 0 0 1.659.753z"}})])])])])])])}
var staticRenderFns = []


/***/ }),
/* 1123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"flex justify-center mt3 iconColor"},[_c('clip-loader',{attrs:{"loading":_vm.loading,"color":_vm.color,"size":_vm.size}})],1),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading && !_vm.myPlaylists.length),expression:"!loading && !myPlaylists.length"}],staticClass:"pa2 center tc iconColor"},[_vm._v(_vm._s(_vm.$t("artists.hasNotPlaylists")))]),_vm._v(" "),_c('my-playlists-carousel',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],attrs:{"playlists":_vm.myPlaylists}})],1)}
var staticRenderFns = []


/***/ }),
/* 1124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyFavorites_vue__ = __webpack_require__(547);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e3955114_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyFavorites_vue__ = __webpack_require__(1130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1125)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e3955114"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyFavorites_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e3955114_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyFavorites_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e3955114_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyFavorites_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1125 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1126 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"artist-card relative flex pointer dim pa3 cover bg-center resize",class:{'artist-card-profile': _vm.isProfile}},[_c('div',{staticClass:"flex-column w-100"},[_c('router-link',{staticClass:"artist-info",attrs:{"to":{ name:'artist-info', params:{ id: _vm.artist.id }}}},[_c('div',{staticClass:"body relative hide-child"},[(_vm.hasTracks)?_c('span',{staticClass:"white absolute top-0 v-mid w-100 h-100 child bg-black-40 flex items-center justify-center pointer"},[_c('div',{staticClass:"grow ba bw2 br-100 h3 w3 flex items-center justify-center",on:{"click":function($event){$event.preventDefault();return _vm.playArtistTracks()}}},[_c('font-awesome-icon',{attrs:{"icon":"play","size":"2x"}})],1)]):_vm._e(),_vm._v(" "),(_vm.artist.recommended)?_c('img',{staticClass:"artist-picture db beathey-loud",class:{'isArtistList': _vm.isArtistList, 'isProfile': _vm.isProfile},style:({'display': 'block' , 'margin-left': 'auto' , 'margin-right': 'auto'}),attrs:{"src":"https://beathey.com/uploads/LOUD/BTH+LOUD%C2%AE-02.svg"}}):_vm._e(),_vm._v(" "),_c('img',{staticClass:"artist-picture db",class:{'isArtistList': _vm.isArtistList, 'isProfile': _vm.isProfile},style:({'display': 'block' , 'margin-left': 'auto' , 'margin-right': 'auto'}),attrs:{"src":_vm.listPicture,"alt":((_vm.artist.name) + " Picture")}})]),_vm._v(" "),_c('div',{staticClass:"flex items-center bg-primary mw-90 justify-around"},[_c('p',{staticClass:"z-1 white-90 word-wrap flex f5 artist-name ma3"},[_vm._v(_vm._s(_vm.artist.name))])])])],1)])}
var staticRenderFns = []


/***/ }),
/* 1128 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"flex justify-end"},[(_vm.allTracks.length > 0 && !_vm.isMyFavorites)?_c('router-link',{staticClass:"mr3 no-underline",attrs:{"title":_vm.$t('tracks.seeAll'),"to":{name:'tracksList'}}},[_c('span',{staticClass:"mr3"},[_vm._v(_vm._s(_vm.$t('tracks.seeAll')))])]):_vm._e(),_vm._v(" "),(_vm.artists.length > 0 && !_vm.isMyFavorites)?_c('router-link',{staticClass:"mr3 no-underline",attrs:{"title":_vm.$t('artists.seeAll'),"to":{name:'new-artists-list'}}},[_c('span',{staticClass:"mr3"},[_vm._v(_vm._s(_vm.$t('artists.seeAll')))])]):_vm._e(),_vm._v(" "),(_vm.playlists.length > 0 && !_vm.isMyFavorites)?_c('router-link',{staticClass:"mr3 no-underline",attrs:{"title":_vm.$t('playlists.seeAll'),"to":{name:'new-playlists-list'}}},[_c('span',{staticClass:"mr3"},[_vm._v(_vm._s(_vm.$t('playlists.seeAll')))])]):_vm._e()],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.withFilters && _vm.genresMain.length > 0),expression:"withFilters && genresMain.length > 0"}]},[_c('div',{staticClass:"w-100 justify-around items-center ttu",staticStyle:{"background-color":"#393839","position":"relative","display":"flex"}},[_c('div',[_c('a',{staticStyle:{"margin-left":"10px","fill":"white","cursor":"pointer"},on:{"click":function($event){return _vm.genTranslate('genMain', 'left')}}},[_c('svg',{staticClass:"bi bi-caret-left",attrs:{"width":"25","height":"25","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M10 12.796V3.204L4.519 8 10 12.796zm-.659.753-5.48-4.796a1 1 0 0 1 0-1.506l5.48-4.796A1 1 0 0 1 11 3.204v9.592a1 1 0 0 1-1.659.753z"}})])])]),_vm._v(" "),_c('div'),_vm._v(" "),(_vm.allTracks.length > 0)?_c('div',{staticClass:"track-container-scroll container-scroll w-100"},[_c('div',{staticClass:"container-genbar",attrs:{"id":"genMain"}},_vm._l((_vm.allTracks),function(genre){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.allTracks.length > 0),expression:"allTracks.length > 0"}],key:genre.id,staticClass:"genre-filter f6 link ph2 pv2 dim dib white",class:{
              'genre-filter-selected': _vm.genreFilter == genre.id,
              pointer: _vm.genreFilter != genre.id,
            },attrs:{"track-by":genre.id,"tabindex":genre.title},on:{"click":function($event){return _vm.setPlayer(genre, _vm.allTracks)}}},[_c('carousel-item',{staticStyle:{"width":"190px"},attrs:{"isMyFavorites":_vm.isMyFavorites,"track":genre}})],1)}),0)]):_vm._e(),_vm._v(" "),(_vm.playlists)?_c('div',{staticClass:"container-scroll w-100"},[_c('div',{staticClass:"container-genbar",attrs:{"id":"genMain"}},_vm._l((_vm.playlists),function(genre){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.playlists.length > 0),expression:"playlists.length > 0"}],key:genre.id,staticClass:"genre-filter f6 link dim ph2 pv2 dim dib white",class:{
              'genre-filter-selected': _vm.genreFilter == genre.id,
              pointer: _vm.genreFilter != genre.id,
            },attrs:{"track-by":genre.id,"tabindex":genre.title}},[_c('modal-playlist-card',{staticStyle:{"width":"190px"},attrs:{"playlist":genre}})],1)}),0)]):_vm._e(),_vm._v(" "),(_vm.recommendedPlaylists)?_c('div',{staticClass:"container-scroll w-100"},[_c('div',{staticClass:"container-genbar",attrs:{"id":"genMain"}},_vm._l((_vm.recommendedPlaylists),function(genre){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.recommendedPlaylists.length > 0),expression:"recommendedPlaylists.length > 0"}],key:genre.id,staticClass:"genre-filter f6 link dim ph2 pv2 dim dib white",class:{
              'genre-filter-selected': _vm.genreFilter == genre.id,
              pointer: _vm.genreFilter != genre.id,
            },attrs:{"track-by":genre.id,"tabindex":genre.title}},[_c('modal-playlist-card',{staticStyle:{"width":"190px"},attrs:{"playlist":genre}})],1)}),0)]):_vm._e(),_vm._v(" "),(_vm.artists)?_c('div',{staticClass:"container-scroll w-100"},[_c('div',{staticClass:"container-genbar",attrs:{"id":"genMain"}},_vm._l((_vm.artists),function(artist){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.artists.length > 0),expression:"artists.length > 0"}],key:artist.id,staticClass:"genre-filter f6 link ph2 pv2 dim dib white",class:{
              'genre-filter-selected': _vm.genreFilter == artist.id,
              pointer: _vm.genreFilter != artist.id,
            }},[_c('artist-card',{staticStyle:{"width":"190px"},attrs:{"artist":artist,"isProfile":_vm.isMyFavorites}})],1)}),0)]):_vm._e(),_vm._v(" "),_c('div',[_c('a',{staticStyle:{"margin-right":"10px","fill":"white","cursor":"pointer"},on:{"click":function($event){return _vm.genTranslate('genMain', 'right')}}},[_c('svg',{staticClass:"bi bi-caret-right",attrs:{"width":"25","height":"25","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M6 12.796V3.204L11.481 8 6 12.796zm.659.753 5.48-4.796a1 1 0 0 0 0-1.506L6.66 2.451C6.011 1.885 5 2.345 5 3.204v9.592a1 1 0 0 0 1.659.753z"}})])])])])])])}
var staticRenderFns = []


/***/ }),
/* 1130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"flex justify-center mt3 textColor"},[_c('clip-loader',{attrs:{"loading":_vm.loading,"color":_vm.color,"size":_vm.size}})],1),_vm._v(" "),_c('div',[_c('div',{staticClass:"discoverHeight"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.withFilters && _vm.genresMain.length > 0),expression:"withFilters && genresMain.length > 0"}]},[_c('div',{staticClass:"w-100 justify-around items-center ttu",staticStyle:{"background-color":"#393839","position":"relative","display":"flex"}},[_c('div',[_c('a',{staticStyle:{"margin-left":"10px","fill":"white","cursor":"pointer"},on:{"click":function($event){return _vm.genTranslate('genMain', 'left')}}},[_c('svg',{staticClass:"bi bi-caret-left",attrs:{"width":"25","height":"25","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M10 12.796V3.204L4.519 8 10 12.796zm-.659.753-5.48-4.796a1 1 0 0 1 0-1.506l5.48-4.796A1 1 0 0 1 11 3.204v9.592a1 1 0 0 1-1.659.753z"}})])])]),_vm._v(" "),_c('div'),_vm._v(" "),_c('div',{staticClass:"container-scroll w-100"},[_c('div',{staticClass:"container-genbar",attrs:{"id":"genMain"}},[_c('a',{staticClass:"genre-filter f6 link dim ph3 pv2 dib white mr2",class:{
                  'genre-filter-selected': _vm.genreFilter == '',
                  pointer: _vm.genreFilter != '',
                },on:{"click":function($event){return _vm.selectGenMain('')}}},[_vm._v("\n                "+_vm._s(_vm.$t("tracks.genres.all"))+"\n              ")]),_vm._v(" "),_vm._l((_vm.genresMain),function(genre){return _c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.genresMain.length > 0),expression:"genresMain.length > 0"}],key:genre.id,staticClass:"genre-filter f6 link dim ph3 pv2 dib white mr2",class:{
                  'genre-filter-selected': _vm.genreFilter == genre.id,
                  pointer: _vm.genreFilter != genre.id,
                },attrs:{"track-by":genre.id,"tabindex":genre.id},on:{"click":function($event){return _vm.selectGenMain(genre.id)},"blur":function($event){return _vm.selectGenMainBlur($event)},"focus":function($event){return _vm.selectGenMainFocus($event)}}},[_vm._v("\n                "+_vm._s(genre.name)+"\n              ")])})],2)]),_vm._v(" "),_c('div',[_c('a',{staticStyle:{"margin-right":"10px","fill":"white","cursor":"pointer"},on:{"click":function($event){return _vm.genTranslate('genMain', 'right')}}},[_c('svg',{staticClass:"bi bi-caret-right",attrs:{"width":"25","height":"25","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M6 12.796V3.204L11.481 8 6 12.796zm.659.753 5.48-4.796a1 1 0 0 0 0-1.506L6.66 2.451C6.011 1.885 5 2.345 5 3.204v9.592a1 1 0 0 0 1.659.753z"}})])])])]),_vm._v(" "),_c('div',{staticClass:"w-100 justify-between items-center ttu black",staticStyle:{"background-color":"black","position":"relative","display":"flex"}},[_c('div',[_c('a',{staticStyle:{"fill":"white","cursor":"pointer"},on:{"click":function($event){return _vm.genTranslate('genSecon', 'left')}}},[_c('svg',{staticClass:"bi bi-caret-left",attrs:{"width":"25","height":"25","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M10 12.796V3.204L4.519 8 10 12.796zm-.659.753-5.48-4.796a1 1 0 0 1 0-1.506l5.48-4.796A1 1 0 0 1 11 3.204v9.592a1 1 0 0 1-1.659.753z"}})])])]),_vm._v(" "),_c('div',{staticClass:"container-scroll w-100"},[_c('div',{staticClass:"container-genbar",attrs:{"id":"genSecon"}},_vm._l((_vm.genSeconByMain),function(genre){return _c('a',{key:genre.id,staticClass:"genre-filter f6 link dim ph3 pv2 dib white mr2",class:{
                  'genre-filter-selected': _vm.genreFilter == genre.id,
                  pointer: _vm.genreFilter != genre.id,
                },staticStyle:{"font-size":"0.775rem","min-width":"120px","text-align":"center"},attrs:{"track-by":genre.id},on:{"click":function($event){return _vm.selectGenSecon(genre.id)}}},[_vm._v("\n                "+_vm._s(genre.name)+"\n              ")])}),0)]),_vm._v(" "),_c('div',[_c('a',{staticStyle:{"fill":"white","cursor":"pointer"},on:{"click":function($event){return _vm.genTranslate('genSecon', 'right')}}},[_c('svg',{staticClass:"bi bi-caret-right",attrs:{"width":"25","height":"25","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M6 12.796V3.204L11.481 8 6 12.796zm.659.753 5.48-4.796a1 1 0 0 0 0-1.506L6.66 2.451C6.011 1.885 5 2.345 5 3.204v9.592a1 1 0 0 0 1.659.753z"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"w-100 mh3 w-mobile"},[_c('div',{staticClass:"search-wrapper w-third-l w-50-m w-100 block pointer z-1 relative bg-tertiary fr mt3"},[_c('button',{staticClass:"w-10-ns w-90 pointer btn1 dim b f5 fw4",attrs:{"type":"button","icon":"search"},on:{"click":_vm.update}},[_c('font-awesome-icon',{staticClass:"search-left-icon",attrs:{"icon":"search"}})],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.textToFilter),expression:"textToFilter"}],staticClass:"pa2 input_filter_my_favorites w-100 bg-transparent w-50-mobile",attrs:{"maxlength":"255","placeholder":_vm.$t('artists.search.placeholder')},domProps:{"value":(_vm.textToFilter)},on:{"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.clearFilters.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.update.apply(null, arguments)}],"input":function($event){if($event.target.composing){ return; }_vm.textToFilter=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"filtersLabelsDiv"},[(_vm.mainGenre.name)?_c('span',{staticClass:"filtersLabels",on:{"click":_vm.filterByMainGenreLabel}},[_vm._v(_vm._s(_vm.mainGenre.name))]):_vm._e(),_vm._v(" "),(_vm.mainGenre.name && _vm.seconGenre.name)?_c('span',[_vm._v(" / ")]):_vm._e(),_vm._v(" "),(_vm.seconGenre.name)?_c('span',{staticClass:"filtersLabels",on:{"click":_vm.removeSeconGenreLabel}},[_vm._v(_vm._s(_vm.seconGenre.name))]):_vm._e(),_vm._v(" "),((_vm.mainGenre.name || _vm.seconGenre.name) && _vm.filteredText)?_c('span',[_vm._v(" / ")]):_vm._e(),_vm._v(" "),(_vm.filteredText)?_c('span',{staticClass:"filtersLabels",on:{"click":_vm.removeFilteredTextLabel}},[_vm._v(_vm._s(_vm.filteredText))]):_vm._e()]),_vm._v(" "),_c('div',{attrs:{"id":"discoverMainContent"}},[_c('div',{attrs:{"id":"artistsCarousel"}},[_c('h2',{staticClass:"p-2 carouselTitle"},[_vm._v(_vm._s(_vm.$t("discover.carousels.artists")))]),_vm._v(" "),(_vm.artists)?_c('div',[_c('custom-carousel',{attrs:{"loading":_vm.loading,"artists":_vm.artists,"textToFilter":_vm.textToFilter,"isMyFavorites":true}})],1):_vm._e(),_vm._v(" "),(!_vm.artists)?_c('div',{staticClass:"flex justify-center"},[_c('p',[_vm._v(_vm._s(_vm.$t("app.info.noResults")))])]):_vm._e()]),_vm._v(" "),_c('div',{attrs:{"id":"tracksCarousel"}},[_c('h2',{staticClass:"p-2 carouselTitle"},[_vm._v("Tracks")]),_vm._v(" "),(_vm.myFavorites.length > 0)?_c('div',[_c('custom-carousel',{attrs:{"loading":_vm.loading,"allTracks":_vm.myFavorites,"textToFilter":_vm.textToFilter,"isMyFavorites":true}})],1):_vm._e(),_vm._v(" "),(!_vm.myFavorites || _vm.myFavorites.length === 0)?_c('div',{staticClass:"flex justify-center"},[_c('p',[_vm._v(_vm._s(_vm.$t("app.info.noResults")))])]):_vm._e()]),_vm._v(" "),_c('div',{attrs:{"id":"playlistsCarousel"}},[_c('h2',{staticClass:"p-2 carouselTitle"},[_vm._v("Playlists")]),_vm._v(" "),(_vm.myLikedPlaylists.length > 0)?_c('div',[_c('custom-carousel',{attrs:{"loading":_vm.loading,"playlists":_vm.myLikedPlaylists,"textToFilter":_vm.textToFilter}})],1):_vm._e(),_vm._v(" "),(!_vm.myLikedPlaylists || _vm.myLikedPlaylists.length === 0)?_c('div',{staticClass:"flex justify-center"},[_c('p',[_vm._v(_vm._s(_vm.$t("app.info.noResults")))])]):_vm._e()])])])])])}
var staticRenderFns = []


/***/ }),
/* 1131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyShopping_vue__ = __webpack_require__(551);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01ac9682_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyShopping_vue__ = __webpack_require__(1138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyShopping_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01ac9682_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyShopping_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01ac9682_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyShopping_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrackDownload_vue__ = __webpack_require__(552);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8e5093e4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrackDownload_vue__ = __webpack_require__(1137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1133)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8e5093e4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrackDownload_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8e5093e4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrackDownload_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8e5093e4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrackDownload_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1133 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrackDownloadItemList_vue__ = __webpack_require__(553);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_387c946a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrackDownloadItemList_vue__ = __webpack_require__(1136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1135)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-387c946a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrackDownloadItemList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_387c946a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrackDownloadItemList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_387c946a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrackDownloadItemList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1135 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"h-100 w-100 track-item flex"},[_c('div',{staticClass:"pointer h-100 w-95"},[_c('p',{staticClass:"title fl w-30 h-100 pa1 pl3 ma0 text-ellipsis center-content textColor lh item-mobile-track"},[_vm._v(_vm._s(_vm.purchase.track.title))]),_vm._v(" "),_c('router-link',{staticClass:"textColor no-underline",attrs:{"to":{ name:'artist-info', params:{ id:_vm.purchase.track.artist.id }},"append":""},nativeOn:{"click":function($event){$event.stopPropagation();}}},[_c('p',{staticClass:"artist fl w-20 h-100 pa1 pl3 ma0 text-ellipsis center-content textColor lh item-mobile-artist"},[_vm._v(_vm._s(_vm.purchase.track.artist.name))])]),_vm._v(" "),_c('p',{staticClass:"released fl w-15 h-100 pa1 pl3 ma0 center-content textColor lh item-not-mobile"},[_vm._v(_vm._s(this.trackTime))]),_vm._v(" "),_c('p',{staticClass:"title fl w-21 h-100 pa1 pl3 ma0 text-ellipsis center-content textColor lh item-not-mobile"},[_vm._v(_vm._s(this.payment_date))]),_vm._v(" "),_c('a',{staticClass:"db-mobile",attrs:{"id":"db","href":_vm.download_url},on:{"click":function($event){return _vm.download()}}},[_vm._v("\n          Descargar\n      ")])],1)])])}
var staticRenderFns = []


/***/ }),
/* 1137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.nextPage),expression:"nextPage"}],staticClass:"track-list pa1 pb3-ns pt3-ns ph5-l ph3-m",class:{'overflow-y-scroll' : _vm.withPagination},attrs:{"infinite-scroll-immediate-check":"false","infinite-scroll-distance":"50","infinite-scroll-disabled":"disablePagination"}},[_c('div',{staticClass:"track-list-header h2 w-95 mb1 textColor"},[_c('p',{staticClass:"fl w-30 h-100 pa1 pl4 ma0 text-ellipsis center-content b textColor"},[_vm._v(_vm._s(_vm.$t("tracks.headers.title")))]),_vm._v(" "),_c('p',{staticClass:"fl w-20 h-100 pa1 pl4 ma0 text-ellipsis center-content b textColor artist-mobile"},[_vm._v(_vm._s(_vm.$t("tracks.headers.artist")))]),_vm._v(" "),_c('p',{staticClass:"released fl w-15 h-100 pa1 ma0 center-content b textColor display-mobile"},[_vm._v(_vm._s(_vm.$t("tracks.headers.duration")))]),_vm._v(" "),_c('p',{staticClass:"fl w-20 h-100 pa1 pl3 ma0 text-ellipsis center-content b textColor display-mobile"},[_vm._v(_vm._s(_vm.$t("tracks.headers.date")))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"flex justify-center items-center w-100"},[_c('clip-loader',{attrs:{"loading":_vm.loading,"color":_vm.color,"size":_vm.size2}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading && _vm.purchasedTracks.length === 0),expression:"!loading && purchasedTracks.length === 0"}],staticClass:"flex justify-center items-center w-100 pt2 textColor"},[_vm._v("\n    "+_vm._s(_vm.$t("app.info.noResults"))+"\n  ")]),_vm._v(" "),_vm._l((_vm.purchasedTracks),function(purchase){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.purchasedTracks && !_vm.loading),expression:"purchasedTracks && !loading"}],key:purchase.id,staticClass:"track-container relative mb2",attrs:{"track-by":purchase.id}},[_c('track-download-item-list',{staticClass:"item-container",attrs:{"purchase":purchase}})],1)}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.withPagination && _vm.noMoreResults),expression:"withPagination && noMoreResults"}],staticClass:"flex justify-center items-center w-100 pt2 pb2 textColor"},[_vm._v("\n    "+_vm._s(_vm.$t("app.info.noMoreResults"))+"\n  ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.withPagination && _vm.loadingMore),expression:"withPagination && loadingMore"}],staticClass:"flex justify-center items-center w-100"},[_c('clip-loader',{attrs:{"loading":_vm.loadingMore,"color":_vm.color,"size":_vm.size2}})],1)],2)}
var staticRenderFns = []


/***/ }),
/* 1138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"flex justify-center mt3 textColor"},[_c('clip-loader',{attrs:{"loading":_vm.loading,"color":_vm.color,"size":_vm.size}})],1),_vm._v(" "),_c('track-download',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],attrs:{"purchasedTracks":_vm.myShopping,"withFilters":false,"withPagination":false,"loading":_vm.loading}})],1)}
var staticRenderFns = []


/***/ }),
/* 1139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyInfo_vue__ = __webpack_require__(554);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b3573e6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyInfo_vue__ = __webpack_require__(1148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1140)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7b3573e6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b3573e6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyInfo_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b3573e6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyInfo_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1140 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  countries: [{
    'name': 'Afghanistan',
    'topLevelDomain': ['.af'],
    'alpha2Code': 'AF',
    'alpha3Code': 'AFG',
    'callingCodes': ['93'],
    'capital': 'Kabul',
    'altSpellings': ['AF', 'Afġānistān'],
    'region': 'Asia',
    'subregion': 'Southern Asia',
    'population': 26023100,
    'latlng': [33.0, 65.0],
    'demonym': 'Afghan',
    'area': 652230.0,
    'gini': 27.8,
    'timezones': ['UTC+04:30'],
    'borders': ['IRN', 'PAK', 'TKM', 'UZB', 'TJK', 'CHN'],
    'nativeName': 'افغانستان',
    'numericCode': '004',
    'currencies': ['AFN'],
    'languages': ['ps', 'uz', 'tk'],
    'translations': { 'de': 'Afghanistan', 'es': 'Afganistán', 'fr': 'Afghanistan', 'ja': 'アフガニスタン', 'it': 'Afghanistan' },
    'relevance': '0'
  }, {
    'name': 'Åland Islands',
    'topLevelDomain': ['.ax'],
    'alpha2Code': 'AX',
    'alpha3Code': 'ALA',
    'callingCodes': ['358'],
    'capital': 'Mariehamn',
    'altSpellings': ['AX', 'Aaland', 'Aland', 'Ahvenanmaa'],
    'region': 'Europe',
    'subregion': 'Northern Europe',
    'population': 28875,
    'latlng': [60.116667, 19.9],
    'demonym': 'Ålandish',
    'area': 1580.0,
    'gini': null,
    'timezones': ['UTC+02:00'],
    'borders': [],
    'nativeName': 'Åland',
    'numericCode': '248',
    'currencies': ['EUR'],
    'languages': ['sv'],
    'translations': { 'de': 'Åland', 'es': 'Alandia', 'fr': 'Åland', 'ja': 'オーランド諸島', 'it': 'Isole Aland' },
    'relevance': '0'
  }, {
    'name': 'Albania',
    'topLevelDomain': ['.al'],
    'alpha2Code': 'AL',
    'alpha3Code': 'ALB',
    'callingCodes': ['355'],
    'capital': 'Tirana',
    'altSpellings': ['AL', 'Shqipëri', 'Shqipëria', 'Shqipnia'],
    'region': 'Europe',
    'subregion': 'Southern Europe',
    'population': 2893005,
    'latlng': [41.0, 20.0],
    'demonym': 'Albanian',
    'area': 28748.0,
    'gini': 34.5,
    'timezones': ['UTC+01:00'],
    'borders': ['MNE', 'GRC', 'MKD', 'KOS'],
    'nativeName': 'Shqipëria',
    'numericCode': '008',
    'currencies': ['ALL'],
    'languages': ['sq'],
    'translations': { 'de': 'Albanien', 'es': 'Albania', 'fr': 'Albanie', 'ja': 'アルバニア', 'it': 'Albania' },
    'relevance': '0'
  }, {
    'name': 'Algeria',
    'topLevelDomain': ['.dz'],
    'alpha2Code': 'DZ',
    'alpha3Code': 'DZA',
    'callingCodes': ['213'],
    'capital': 'Algiers',
    'altSpellings': ['DZ', 'Dzayer', 'Algérie'],
    'region': 'Africa',
    'subregion': 'Northern Africa',
    'population': 39500000,
    'latlng': [28.0, 3.0],
    'demonym': 'Algerian',
    'area': 2381741.0,
    'gini': 35.3,
    'timezones': ['UTC+01:00'],
    'borders': ['TUN', 'LBY', 'NER', 'ESH', 'MRT', 'MLI', 'MAR'],
    'nativeName': 'الجزائر',
    'numericCode': '012',
    'currencies': ['DZD'],
    'languages': ['ar'],
    'translations': { 'de': 'Algerien', 'es': 'Argelia', 'fr': 'Algérie', 'ja': 'アルジェリア', 'it': 'Algeria' },
    'relevance': '0'
  }, {
    'name': 'American Samoa',
    'topLevelDomain': ['.as'],
    'alpha2Code': 'AS',
    'alpha3Code': 'ASM',
    'callingCodes': ['1684'],
    'capital': 'Pago Pago',
    'altSpellings': ['AS', 'Amerika Sāmoa', 'Amelika Sāmoa', 'Sāmoa Amelika'],
    'region': 'Oceania',
    'subregion': 'Polynesia',
    'population': 55519,
    'latlng': [-14.33333333, -170.0],
    'demonym': 'American Samoan',
    'area': 199.0,
    'gini': null,
    'timezones': ['UTC-11:00'],
    'borders': [],
    'nativeName': 'American Samoa',
    'numericCode': '016',
    'currencies': ['USD'],
    'languages': ['en', 'sm'],
    'translations': {
      'de': 'Amerikanisch-Samoa',
      'es': 'Samoa Americana',
      'fr': 'Samoa américaines',
      'ja': 'アメリカ領サモア',
      'it': 'Samoa Americane'
    },
    'relevance': '0.5'
  }, {
    'name': 'Andorra',
    'topLevelDomain': ['.ad'],
    'alpha2Code': 'AD',
    'alpha3Code': 'AND',
    'callingCodes': ['376'],
    'capital': 'Andorra la Vella',
    'altSpellings': ['AD', 'Principality of Andorra', 'Principat d\'Andorra'],
    'region': 'Europe',
    'subregion': 'Southern Europe',
    'population': 76949,
    'latlng': [42.5, 1.5],
    'demonym': 'Andorran',
    'area': 468.0,
    'gini': null,
    'timezones': ['UTC+01:00'],
    'borders': ['FRA', 'ESP'],
    'nativeName': 'Andorra',
    'numericCode': '020',
    'currencies': ['EUR'],
    'languages': ['ca'],
    'translations': { 'de': 'Andorra', 'es': 'Andorra', 'fr': 'Andorre', 'ja': 'アンドラ', 'it': 'Andorra' },
    'relevance': '0.5'
  }, {
    'name': 'Angola',
    'topLevelDomain': ['.ao'],
    'alpha2Code': 'AO',
    'alpha3Code': 'AGO',
    'callingCodes': ['244'],
    'capital': 'Luanda',
    'altSpellings': ['AO', 'República de Angola', 'ʁɛpublika de an\'ɡɔla'],
    'region': 'Africa',
    'subregion': 'Middle Africa',
    'population': 24383301,
    'latlng': [-12.5, 18.5],
    'demonym': 'Angolan',
    'area': 1246700.0,
    'gini': 58.6,
    'timezones': ['UTC+01:00'],
    'borders': ['COG', 'COD', 'ZMB', 'NAM'],
    'nativeName': 'Angola',
    'numericCode': '024',
    'currencies': ['AOA'],
    'languages': ['pt'],
    'translations': { 'de': 'Angola', 'es': 'Angola', 'fr': 'Angola', 'ja': 'アンゴラ', 'it': 'Angola' },
    'relevance': '0'
  }, {
    'name': 'Anguilla',
    'topLevelDomain': ['.ai'],
    'alpha2Code': 'AI',
    'alpha3Code': 'AIA',
    'callingCodes': ['1264'],
    'capital': 'The Valley',
    'altSpellings': ['AI'],
    'region': 'Americas',
    'subregion': 'Caribbean',
    'population': 13452,
    'latlng': [18.25, -63.16666666],
    'demonym': 'Anguillian',
    'area': 91.0,
    'gini': null,
    'timezones': ['UTC-04:00'],
    'borders': [],
    'nativeName': 'Anguilla',
    'numericCode': '660',
    'currencies': ['XCD'],
    'languages': ['en'],
    'translations': { 'de': 'Anguilla', 'es': 'Anguilla', 'fr': 'Anguilla', 'ja': 'アンギラ', 'it': 'Anguilla' },
    'relevance': '0.5'
  }, {
    'name': 'Antarctica',
    'topLevelDomain': ['.aq'],
    'alpha2Code': 'AQ',
    'alpha3Code': 'ATA',
    'callingCodes': [],
    'capital': '',
    'altSpellings': [],
    'region': 'Polar',
    'subregion': '',
    'population': 1000,
    'latlng': [-74.65, 4.48],
    'demonym': '',
    'area': 1.4E7,
    'gini': null,
    'timezones': ['UTC-03:00', 'UTC+03:00', 'UTC+05:00', 'UTC+06:00', 'UTC+07:00', 'UTC+08:00', 'UTC+10:00', 'UTC+12:00'],
    'borders': [],
    'nativeName': 'Antarctica',
    'numericCode': '010',
    'currencies': ['AUD', 'GBP'],
    'languages': ['en'],
    'translations': { 'de': 'Antarktika', 'es': 'Antártida', 'fr': 'Antarctique', 'ja': '南極大陸', 'it': 'Antartide' },
    'relevance': '0'
  }, {
    'name': 'Antigua and Barbuda',
    'topLevelDomain': ['.ag'],
    'alpha2Code': 'AG',
    'alpha3Code': 'ATG',
    'callingCodes': ['1268'],
    'capital': 'Saint John\'s',
    'altSpellings': ['AG'],
    'region': 'Americas',
    'subregion': 'Caribbean',
    'population': 86295,
    'latlng': [17.05, -61.8],
    'demonym': 'Antiguan, Barbudan',
    'area': 442.0,
    'gini': null,
    'timezones': ['UTC-04:00'],
    'borders': [],
    'nativeName': 'Antigua and Barbuda',
    'numericCode': '028',
    'currencies': ['XCD'],
    'languages': ['en'],
    'translations': {
      'de': 'Antigua und Barbuda',
      'es': 'Antigua y Barbuda',
      'fr': 'Antigua-et-Barbuda',
      'ja': 'アンティグア・バーブーダ',
      'it': 'Antigua e Barbuda'
    },
    'relevance': '0.5'
  }, {
    'name': 'Argentina',
    'topLevelDomain': ['.ar'],
    'alpha2Code': 'AR',
    'alpha3Code': 'ARG',
    'callingCodes': ['54'],
    'capital': 'Buenos Aires',
    'altSpellings': ['AR', 'Argentine Republic', 'República Argentina'],
    'region': 'Americas',
    'subregion': 'South America',
    'population': 43131966,
    'latlng': [-34.0, -64.0],
    'demonym': 'Argentinean',
    'area': 2780400.0,
    'gini': 44.5,
    'timezones': ['UTC-03:00'],
    'borders': ['BOL', 'BRA', 'CHL', 'PRY', 'URY'],
    'nativeName': 'Argentina',
    'numericCode': '032',
    'currencies': ['ARS'],
    'languages': ['es', 'gn'],
    'translations': { 'de': 'Argentinien', 'es': 'Argentina', 'fr': 'Argentine', 'ja': 'アルゼンチン', 'it': 'Argentina' },
    'relevance': '0'
  }, {
    'name': 'Armenia',
    'topLevelDomain': ['.am'],
    'alpha2Code': 'AM',
    'alpha3Code': 'ARM',
    'callingCodes': ['374'],
    'capital': 'Yerevan',
    'altSpellings': ['AM', 'Hayastan', 'Republic of Armenia', 'Հայաստանի Հանրապետություն'],
    'region': 'Asia',
    'subregion': 'Western Asia',
    'population': 3006800,
    'latlng': [40.0, 45.0],
    'demonym': 'Armenian',
    'area': 29743.0,
    'gini': 30.9,
    'timezones': ['UTC+04:00'],
    'borders': ['AZE', 'GEO', 'IRN', 'TUR'],
    'nativeName': 'Հայաստան',
    'numericCode': '051',
    'currencies': ['AMD'],
    'languages': ['hy', 'ru'],
    'translations': { 'de': 'Armenien', 'es': 'Armenia', 'fr': 'Arménie', 'ja': 'アルメニア', 'it': 'Armenia' },
    'relevance': '0'
  }, {
    'name': 'Aruba',
    'topLevelDomain': ['.aw'],
    'alpha2Code': 'AW',
    'alpha3Code': 'ABW',
    'callingCodes': ['297'],
    'capital': 'Oranjestad',
    'altSpellings': ['AW'],
    'region': 'Americas',
    'subregion': 'Caribbean',
    'population': 107394,
    'latlng': [12.5, -69.96666666],
    'demonym': 'Aruban',
    'area': 180.0,
    'gini': null,
    'timezones': ['UTC-04:00'],
    'borders': [],
    'nativeName': 'Aruba',
    'numericCode': '533',
    'currencies': ['AWG'],
    'languages': ['nl', 'pa'],
    'translations': { 'de': 'Aruba', 'es': 'Aruba', 'fr': 'Aruba', 'ja': 'アルバ', 'it': 'Aruba' },
    'relevance': '0.5'
  }, {
    'name': 'Australia',
    'topLevelDomain': ['.au'],
    'alpha2Code': 'AU',
    'alpha3Code': 'AUS',
    'callingCodes': ['61'],
    'capital': 'Canberra',
    'altSpellings': ['AU'],
    'region': 'Oceania',
    'subregion': 'Australia and New Zealand',
    'population': 23868800,
    'latlng': [-27.0, 133.0],
    'demonym': 'Australian',
    'area': 7692024.0,
    'gini': 30.5,
    'timezones': ['UTC+05:00', 'UTC+06:30', 'UTC+07:00', 'UTC+08:00', 'UTC+09:30', 'UTC+10:00', 'UTC+10:30', 'UTC+11:30'],
    'borders': [],
    'nativeName': 'Australia',
    'numericCode': '036',
    'currencies': ['AUD'],
    'languages': ['en'],
    'translations': { 'de': 'Australien', 'es': 'Australia', 'fr': 'Australie', 'ja': 'オーストラリア', 'it': 'Australia' },
    'relevance': '1.5'
  }, {
    'name': 'Austria',
    'topLevelDomain': ['.at'],
    'alpha2Code': 'AT',
    'alpha3Code': 'AUT',
    'callingCodes': ['43'],
    'capital': 'Vienna',
    'altSpellings': ['AT', 'Österreich', 'Osterreich', 'Oesterreich'],
    'region': 'Europe',
    'subregion': 'Western Europe',
    'population': 8602112,
    'latlng': [47.33333333, 13.33333333],
    'demonym': 'Austrian',
    'area': 83871.0,
    'gini': 26.0,
    'timezones': ['UTC+01:00'],
    'borders': ['CZE', 'DEU', 'HUN', 'ITA', 'LIE', 'SVK', 'SVN', 'CHE'],
    'nativeName': 'Österreich',
    'numericCode': '040',
    'currencies': ['EUR'],
    'languages': ['de'],
    'translations': { 'de': 'Österreich', 'es': 'Austria', 'fr': 'Autriche', 'ja': 'オーストリア', 'it': 'Austria' },
    'relevance': '0'
  }, {
    'name': 'Azerbaijan',
    'topLevelDomain': ['.az'],
    'alpha2Code': 'AZ',
    'alpha3Code': 'AZE',
    'callingCodes': ['994'],
    'capital': 'Baku',
    'altSpellings': ['AZ', 'Republic of Azerbaijan', 'Azərbaycan Respublikası'],
    'region': 'Asia',
    'subregion': 'Western Asia',
    'population': 9636300,
    'latlng': [40.5, 47.5],
    'demonym': 'Azerbaijani',
    'area': 86600.0,
    'gini': 33.7,
    'timezones': ['UTC+04:00'],
    'borders': ['ARM', 'GEO', 'IRN', 'RUS', 'TUR'],
    'nativeName': 'Azərbaycan',
    'numericCode': '031',
    'currencies': ['AZN'],
    'languages': ['az'],
    'translations': {
      'de': 'Aserbaidschan',
      'es': 'Azerbaiyán',
      'fr': 'Azerbaïdjan',
      'ja': 'アゼルバイジャン',
      'it': 'Azerbaijan'
    },
    'relevance': '0'
  }, {
    'name': 'The Bahamas',
    'topLevelDomain': ['.bs'],
    'alpha2Code': 'BS',
    'alpha3Code': 'BHS',
    'callingCodes': ['1242'],
    'capital': 'Nassau',
    'altSpellings': ['BS', 'Commonwealth of the Bahamas'],
    'region': 'Americas',
    'subregion': 'Caribbean',
    'population': 368390,
    'latlng': [24.25, -76.0],
    'demonym': 'Bahamian',
    'area': 13943.0,
    'gini': null,
    'timezones': ['UTC-05:00'],
    'borders': [],
    'nativeName': 'Bahamas',
    'numericCode': '044',
    'currencies': ['BSD'],
    'languages': ['en'],
    'translations': { 'de': 'Bahamas', 'es': 'Bahamas', 'fr': 'Bahamas', 'ja': 'バハマ', 'it': 'Bahamas' },
    'relevance': '0'
  }, {
    'name': 'Bahrain',
    'topLevelDomain': ['.bh'],
    'alpha2Code': 'BH',
    'alpha3Code': 'BHR',
    'callingCodes': ['973'],
    'capital': 'Manama',
    'altSpellings': ['BH', 'Kingdom of Bahrain', 'Mamlakat al-Baḥrayn'],
    'region': 'Asia',
    'subregion': 'Western Asia',
    'population': 1359800,
    'latlng': [26.0, 50.55],
    'demonym': 'Bahraini',
    'area': 765.0,
    'gini': null,
    'timezones': ['UTC+03:00'],
    'borders': [],
    'nativeName': '‏البحرين',
    'numericCode': '048',
    'currencies': ['BHD'],
    'languages': ['ar'],
    'translations': { 'de': 'Bahrain', 'es': 'Bahrein', 'fr': 'Bahreïn', 'ja': 'バーレーン', 'it': 'Bahrein' },
    'relevance': '0'
  }, {
    'name': 'Bangladesh',
    'topLevelDomain': ['.bd'],
    'alpha2Code': 'BD',
    'alpha3Code': 'BGD',
    'callingCodes': ['880'],
    'capital': 'Dhaka',
    'altSpellings': ['BD', 'People\'s Republic of Bangladesh', 'Gônôprôjatôntri Bangladesh'],
    'region': 'Asia',
    'subregion': 'Southern Asia',
    'population': 158875000,
    'latlng': [24.0, 90.0],
    'demonym': 'Bangladeshi',
    'area': 147570.0,
    'gini': 32.1,
    'timezones': ['UTC+06:00'],
    'borders': ['MMR', 'IND'],
    'nativeName': 'Bangladesh',
    'numericCode': '050',
    'currencies': ['BDT'],
    'languages': ['bn'],
    'translations': { 'de': 'Bangladesch', 'es': 'Bangladesh', 'fr': 'Bangladesh', 'ja': 'バングラデシュ', 'it': 'Bangladesh' },
    'relevance': '2'
  }, {
    'name': 'Barbados',
    'topLevelDomain': ['.bb'],
    'alpha2Code': 'BB',
    'alpha3Code': 'BRB',
    'callingCodes': ['1246'],
    'capital': 'Bridgetown',
    'altSpellings': ['BB'],
    'region': 'Americas',
    'subregion': 'Caribbean',
    'population': 285000,
    'latlng': [13.16666666, -59.53333333],
    'demonym': 'Barbadian',
    'area': 430.0,
    'gini': null,
    'timezones': ['UTC-04:00'],
    'borders': [],
    'nativeName': 'Barbados',
    'numericCode': '052',
    'currencies': ['BBD'],
    'languages': ['en'],
    'translations': { 'de': 'Barbados', 'es': 'Barbados', 'fr': 'Barbade', 'ja': 'バルバドス', 'it': 'Barbados' },
    'relevance': '0'
  }, {
    'name': 'Belarus',
    'topLevelDomain': ['.by'],
    'alpha2Code': 'BY',
    'alpha3Code': 'BLR',
    'callingCodes': ['375'],
    'capital': 'Minsk',
    'altSpellings': ['BY', 'Bielaruś', 'Republic of Belarus', 'Белоруссия', 'Республика Беларусь', 'Belorussiya', 'Respublika Belarus’'],
    'region': 'Europe',
    'subregion': 'Eastern Europe',
    'population': 9485300,
    'latlng': [53.0, 28.0],
    'demonym': 'Belarusian',
    'area': 207600.0,
    'gini': 26.5,
    'timezones': ['UTC+03:00'],
    'borders': ['LVA', 'LTU', 'POL', 'RUS', 'UKR'],
    'nativeName': 'Белару́сь',
    'numericCode': '112',
    'currencies': ['BYR'],
    'languages': ['be', 'ru'],
    'translations': { 'de': 'Weißrussland', 'es': 'Bielorrusia', 'fr': 'Biélorussie', 'ja': 'ベラルーシ', 'it': 'Bielorussia' },
    'relevance': '0'
  }, {
    'name': 'Belgium',
    'topLevelDomain': ['.be'],
    'alpha2Code': 'BE',
    'alpha3Code': 'BEL',
    'callingCodes': ['32'],
    'capital': 'Brussels',
    'altSpellings': ['BE', 'België', 'Belgie', 'Belgien', 'Belgique', 'Kingdom of Belgium', 'Koninkrijk België', 'Royaume de Belgique', 'Königreich Belgien'],
    'region': 'Europe',
    'subregion': 'Western Europe',
    'population': 11248330,
    'latlng': [50.83333333, 4.0],
    'demonym': 'Belgian',
    'area': 30528.0,
    'gini': 33.0,
    'timezones': ['UTC+01:00'],
    'borders': ['FRA', 'DEU', 'LUX', 'NLD'],
    'nativeName': 'België',
    'numericCode': '056',
    'currencies': ['EUR'],
    'languages': ['nl', 'fr', 'de'],
    'translations': { 'de': 'Belgien', 'es': 'Bélgica', 'fr': 'Belgique', 'ja': 'ベルギー', 'it': 'Belgio' },
    'relevance': '1.5'
  }, {
    'name': 'Belize',
    'topLevelDomain': ['.bz'],
    'alpha2Code': 'BZ',
    'alpha3Code': 'BLZ',
    'callingCodes': ['501'],
    'capital': 'Belmopan',
    'altSpellings': ['BZ'],
    'region': 'Americas',
    'subregion': 'Central America',
    'population': 368310,
    'latlng': [17.25, -88.75],
    'demonym': 'Belizean',
    'area': 22966.0,
    'gini': 53.1,
    'timezones': ['UTC-06:00'],
    'borders': ['GTM', 'MEX'],
    'nativeName': 'Belize',
    'numericCode': '084',
    'currencies': ['BZD'],
    'languages': ['en', 'es'],
    'translations': { 'de': 'Belize', 'es': 'Belice', 'fr': 'Belize', 'ja': 'ベリーズ', 'it': 'Belize' },
    'relevance': '0'
  }, {
    'name': 'Benin',
    'topLevelDomain': ['.bj'],
    'alpha2Code': 'BJ',
    'alpha3Code': 'BEN',
    'callingCodes': ['229'],
    'capital': 'Porto-Novo',
    'altSpellings': ['BJ', 'Republic of Benin', 'République du Bénin'],
    'region': 'Africa',
    'subregion': 'Western Africa',
    'population': 10315244,
    'latlng': [9.5, 2.25],
    'demonym': 'Beninese',
    'area': 112622.0,
    'gini': 38.6,
    'timezones': ['UTC+01:00'],
    'borders': ['BFA', 'NER', 'NGA', 'TGO'],
    'nativeName': 'Bénin',
    'numericCode': '204',
    'currencies': ['XOF'],
    'languages': ['fr'],
    'translations': { 'de': 'Benin', 'es': 'Benín', 'fr': 'Bénin', 'ja': 'ベナン', 'it': 'Benin' },
    'relevance': '0'
  }, {
    'name': 'Bermuda',
    'topLevelDomain': ['.bm'],
    'alpha2Code': 'BM',
    'alpha3Code': 'BMU',
    'callingCodes': ['1441'],
    'capital': 'Hamilton',
    'altSpellings': ['BM', 'The Islands of Bermuda', 'The Bermudas', 'Somers Isles'],
    'region': 'Americas',
    'subregion': 'Northern America',
    'population': 64237,
    'latlng': [32.33333333, -64.75],
    'demonym': 'Bermudian',
    'area': 54.0,
    'gini': null,
    'timezones': ['UTC-04:00'],
    'borders': [],
    'nativeName': 'Bermuda',
    'numericCode': '060',
    'currencies': ['BMD'],
    'languages': ['en'],
    'translations': { 'de': 'Bermuda', 'es': 'Bermudas', 'fr': 'Bermudes', 'ja': 'バミューダ', 'it': 'Bermuda' },
    'relevance': '0.5'
  }, {
    'name': 'Bhutan',
    'topLevelDomain': ['.bt'],
    'alpha2Code': 'BT',
    'alpha3Code': 'BTN',
    'callingCodes': ['975'],
    'capital': 'Thimphu',
    'altSpellings': ['BT', 'Kingdom of Bhutan'],
    'region': 'Asia',
    'subregion': 'Southern Asia',
    'population': 763920,
    'latlng': [27.5, 90.5],
    'demonym': 'Bhutanese',
    'area': 38394.0,
    'gini': 38.1,
    'timezones': ['UTC+06:00'],
    'borders': ['CHN', 'IND'],
    'nativeName': 'ʼbrug-yul',
    'numericCode': '064',
    'currencies': ['BTN', 'INR'],
    'languages': ['dz'],
    'translations': { 'de': 'Bhutan', 'es': 'Bután', 'fr': 'Bhoutan', 'ja': 'ブータン', 'it': 'Bhutan' },
    'relevance': '0'
  }, {
    'name': 'Bolivia',
    'topLevelDomain': ['.bo'],
    'alpha2Code': 'BO',
    'alpha3Code': 'BOL',
    'callingCodes': ['591'],
    'capital': 'Sucre',
    'altSpellings': ['BO', 'Buliwya', 'Wuliwya', 'Plurinational State of Bolivia', 'Estado Plurinacional de Bolivia', 'Buliwya Mamallaqta', 'Wuliwya Suyu', 'Tetã Volívia'],
    'region': 'Americas',
    'subregion': 'South America',
    'population': 11410651,
    'latlng': [-17.0, -65.0],
    'demonym': 'Bolivian',
    'area': 1098581.0,
    'gini': 56.3,
    'timezones': ['UTC-04:00'],
    'borders': ['ARG', 'BRA', 'CHL', 'PRY', 'PER'],
    'nativeName': 'Bolivia',
    'numericCode': '068',
    'currencies': ['BOB', 'BOV'],
    'languages': ['es', 'ay', 'qu'],
    'translations': { 'de': 'Bolivien', 'es': 'Bolivia', 'fr': 'Bolivie', 'ja': 'ボリビア多民族国', 'it': 'Bolivia' },
    'relevance': '0'
  }, {
    'name': 'Bonaire',
    'topLevelDomain': ['.an', '.nl'],
    'alpha2Code': 'BQ',
    'alpha3Code': 'BES',
    'callingCodes': ['5997'],
    'capital': 'Kralendijk',
    'altSpellings': ['BQ', 'Boneiru'],
    'region': 'Americas',
    'subregion': 'Caribbean',
    'population': 17408,
    'latlng': [12.15, -68.266667],
    'demonym': 'Dutch',
    'area': 294.0,
    'gini': null,
    'timezones': ['UTC-04:00'],
    'borders': [],
    'nativeName': 'Bonaire',
    'numericCode': '535',
    'currencies': ['USD'],
    'languages': ['nl'],
    'translations': { 'de': null, 'es': null, 'fr': null, 'ja': null, 'it': null },
    'relevance': '0'
  }, {
    'name': 'Bosnia and Herzegovina',
    'topLevelDomain': ['.ba'],
    'alpha2Code': 'BA',
    'alpha3Code': 'BIH',
    'callingCodes': ['387'],
    'capital': 'Sarajevo',
    'altSpellings': ['BA', 'Bosnia-Herzegovina', 'Босна и Херцеговина'],
    'region': 'Europe',
    'subregion': 'Southern Europe',
    'population': 3791622,
    'latlng': [44.0, 18.0],
    'demonym': 'Bosnian, Herzegovinian',
    'area': 51209.0,
    'gini': 36.2,
    'timezones': ['UTC+01:00'],
    'borders': ['HRV', 'MNE', 'SRB'],
    'nativeName': 'Bosna i Hercegovina',
    'numericCode': '070',
    'currencies': ['BAM'],
    'languages': ['bs', 'hr', 'sr'],
    'translations': {
      'de': 'Bosnien und Herzegowina',
      'es': 'Bosnia y Herzegovina',
      'fr': 'Bosnie-Herzégovine',
      'ja': 'ボスニア・ヘルツェゴビナ',
      'it': 'Bosnia ed Erzegovina'
    },
    'relevance': '0'
  }, {
    'name': 'Botswana',
    'topLevelDomain': ['.bw'],
    'alpha2Code': 'BW',
    'alpha3Code': 'BWA',
    'callingCodes': ['267'],
    'capital': 'Gaborone',
    'altSpellings': ['BW', 'Republic of Botswana', 'Lefatshe la Botswana'],
    'region': 'Africa',
    'subregion': 'Southern Africa',
    'population': 2070984,
    'latlng': [-22.0, 24.0],
    'demonym': 'Motswana',
    'area': 582000.0,
    'gini': 61.0,
    'timezones': ['UTC+02:00'],
    'borders': ['NAM', 'ZAF', 'ZMB', 'ZWE'],
    'nativeName': 'Botswana',
    'numericCode': '072',
    'currencies': ['BWP'],
    'languages': ['en', 'tn'],
    'translations': { 'de': 'Botswana', 'es': 'Botswana', 'fr': 'Botswana', 'ja': 'ボツワナ', 'it': 'Botswana' },
    'relevance': '0'
  }, {
    'name': 'Bouvet Island',
    'topLevelDomain': ['.bv'],
    'alpha2Code': 'BV',
    'alpha3Code': 'BVT',
    'callingCodes': [''],
    'capital': '',
    'altSpellings': ['BV', 'Bouvetøya', 'Bouvet-øya'],
    'region': '',
    'subregion': '',
    'population': 0,
    'latlng': [-54.43333333, 3.4],
    'demonym': '',
    'area': 49.0,
    'gini': null,
    'timezones': ['UTC+01:00'],
    'borders': [],
    'nativeName': 'Bouvetøya',
    'numericCode': '074',
    'currencies': ['NOK'],
    'languages': [],
    'translations': { 'de': 'Bouvetinsel', 'es': 'Isla Bouvet', 'fr': 'Île Bouvet', 'ja': 'ブーベ島', 'it': 'Isola Bouvet' },
    'relevance': '0'
  }, {
    'name': 'Brazil',
    'topLevelDomain': ['.br'],
    'alpha2Code': 'BR',
    'alpha3Code': 'BRA',
    'callingCodes': ['55'],
    'capital': 'Brasília',
    'altSpellings': ['BR', 'Brasil', 'Federative Republic of Brazil', 'República Federativa do Brasil'],
    'region': 'Americas',
    'subregion': 'South America',
    'population': 204772000,
    'latlng': [-10.0, -55.0],
    'demonym': 'Brazilian',
    'area': 8515767.0,
    'gini': 54.7,
    'timezones': ['UTC-05:00', 'UTC-04:00', 'UTC-03:00', 'UTC-02:00'],
    'borders': ['ARG', 'BOL', 'COL', 'GUF', 'GUY', 'PRY', 'PER', 'SUR', 'URY', 'VEN'],
    'nativeName': 'Brasil',
    'numericCode': '076',
    'currencies': ['BRL'],
    'languages': ['pt'],
    'translations': { 'de': 'Brasilien', 'es': 'Brasil', 'fr': 'Brésil', 'ja': 'ブラジル', 'it': 'Brasile' },
    'relevance': '2'
  }, {
    'name': 'British Indian Ocean Territory',
    'topLevelDomain': ['.io'],
    'alpha2Code': 'IO',
    'alpha3Code': 'IOT',
    'callingCodes': ['246'],
    'capital': 'Diego Garcia',
    'altSpellings': ['IO'],
    'region': 'Africa',
    'subregion': 'Eastern Africa',
    'population': 3000,
    'latlng': [-6.0, 71.5],
    'demonym': 'Indian',
    'area': 60.0,
    'gini': null,
    'timezones': ['UTC+06:00'],
    'borders': [],
    'nativeName': 'British Indian Ocean Territory',
    'numericCode': '086',
    'currencies': ['USD'],
    'languages': ['en'],
    'translations': {
      'de': 'Britisches Territorium im Indischen Ozean',
      'es': 'Territorio Británico del Océano Índico',
      'fr': 'Territoire britannique de l\'océan Indien',
      'ja': 'イギリス領インド洋地域',
      'it': 'Territorio britannico dell\'oceano indiano'
    },
    'relevance': '0'
  }, {
    'name': 'United States Minor Outlying Islands',
    'topLevelDomain': ['.us'],
    'alpha2Code': 'UM',
    'alpha3Code': 'UMI',
    'callingCodes': [''],
    'capital': '',
    'altSpellings': ['UM'],
    'region': 'Americas',
    'subregion': 'Northern America',
    'population': 300,
    'latlng': [],
    'demonym': 'American',
    'area': null,
    'gini': null,
    'timezones': ['UTC-11:00', 'UTC-10:00', 'UTC+12:00'],
    'borders': [],
    'nativeName': 'United States Minor Outlying Islands',
    'numericCode': '581',
    'currencies': ['USD'],
    'languages': ['en'],
    'translations': {
      'de': 'Kleinere Inselbesitzungen der Vereinigten Staaten',
      'es': 'Islas Ultramarinas Menores de Estados Unidos',
      'fr': 'Îles mineures éloignées des États-Unis',
      'ja': '合衆国領有小離島',
      'it': 'Isole minori esterne degli Stati Uniti d\'America'
    },
    'relevance': '0'
  }, {
    'name': 'Virgin Islands (British)',
    'topLevelDomain': ['.vg'],
    'alpha2Code': 'VG',
    'alpha3Code': 'VGB',
    'callingCodes': ['1284'],
    'capital': 'Road Town',
    'altSpellings': ['VG'],
    'region': 'Americas',
    'subregion': 'Caribbean',
    'population': 28054,
    'latlng': [18.431383, -64.62305],
    'demonym': 'Virgin Islander',
    'area': 151.0,
    'gini': null,
    'timezones': ['UTC-04:00'],
    'borders': [],
    'nativeName': 'British Virgin Islands',
    'numericCode': '092',
    'currencies': ['USD'],
    'languages': ['en'],
    'translations': {
      'de': 'Britische Jungferninseln',
      'es': 'Islas Vírgenes del Reino Unido',
      'fr': 'Îles Vierges britanniques',
      'ja': 'イギリス領ヴァージン諸島',
      'it': 'Isole Vergini Britanniche'
    },
    'relevance': '0.5'
  }, {
    'name': 'Virgin Islands (U.S.)',
    'topLevelDomain': ['.vi'],
    'alpha2Code': 'VI',
    'alpha3Code': 'VIR',
    'callingCodes': ['1 340'],
    'capital': 'Charlotte Amalie',
    'altSpellings': ['VI', 'USVI', 'American Virgin Islands', 'U.S. Virgin Islands'],
    'region': 'Americas',
    'subregion': 'Caribbean',
    'population': 114743,
    'latlng': [18.34, -64.93],
    'demonym': 'Virgin Islander',
    'area': 346.36,
    'gini': null,
    'timezones': ['UTC-04:00'],
    'borders': [],
    'nativeName': 'Virgin Islands of the United States',
    'numericCode': '850',
    'currencies': ['USD'],
    'languages': ['en'],
    'translations': {
      'de': 'Amerikanische Jungferninseln',
      'es': 'Islas Vírgenes de los Estados Unidos',
      'fr': 'Îles Vierges des États-Unis',
      'ja': 'アメリカ領ヴァージン諸島',
      'it': 'Isole Vergini americane'
    },
    'relevance': '0.5'
  }, {
    'name': 'Brunei',
    'topLevelDomain': ['.bn'],
    'alpha2Code': 'BN',
    'alpha3Code': 'BRN',
    'callingCodes': ['673'],
    'capital': 'Bandar Seri Begawan',
    'altSpellings': ['BN', 'Nation of Brunei', ' the Abode of Peace'],
    'region': 'Asia',
    'subregion': 'South-Eastern Asia',
    'population': 393372,
    'latlng': [4.5, 114.66666666],
    'demonym': 'Bruneian',
    'area': 5765.0,
    'gini': null,
    'timezones': ['UTC+08:00'],
    'borders': ['MYS'],
    'nativeName': 'Negara Brunei Darussalam',
    'numericCode': '096',
    'currencies': ['BND'],
    'languages': ['ms'],
    'translations': { 'de': 'Brunei', 'es': 'Brunei', 'fr': 'Brunei', 'ja': 'ブルネイ・ダルサラーム', 'it': 'Brunei' },
    'relevance': '0'
  }, {
    'name': 'Bulgaria',
    'topLevelDomain': ['.bg'],
    'alpha2Code': 'BG',
    'alpha3Code': 'BGR',
    'callingCodes': ['359'],
    'capital': 'Sofia',
    'altSpellings': ['BG', 'Republic of Bulgaria', 'Република България'],
    'region': 'Europe',
    'subregion': 'Eastern Europe',
    'population': 7202198,
    'latlng': [43.0, 25.0],
    'demonym': 'Bulgarian',
    'area': 110879.0,
    'gini': 28.2,
    'timezones': ['UTC+02:00'],
    'borders': ['GRC', 'MKD', 'ROU', 'SRB', 'TUR'],
    'nativeName': 'България',
    'numericCode': '100',
    'currencies': ['BGN'],
    'languages': ['bg'],
    'translations': { 'de': 'Bulgarien', 'es': 'Bulgaria', 'fr': 'Bulgarie', 'ja': 'ブルガリア', 'it': 'Bulgaria' },
    'relevance': '0'
  }, {
    'name': 'Burkina Faso',
    'topLevelDomain': ['.bf'],
    'alpha2Code': 'BF',
    'alpha3Code': 'BFA',
    'callingCodes': ['226'],
    'capital': 'Ouagadougou',
    'altSpellings': ['BF'],
    'region': 'Africa',
    'subregion': 'Western Africa',
    'population': 18450494,
    'latlng': [13.0, -2.0],
    'demonym': 'Burkinabe',
    'area': 272967.0,
    'gini': 39.8,
    'timezones': ['UTC'],
    'borders': ['BEN', 'CIV', 'GHA', 'MLI', 'NER', 'TGO'],
    'nativeName': 'Burkina Faso',
    'numericCode': '854',
    'currencies': ['XOF'],
    'languages': ['fr', 'ff'],
    'translations': {
      'de': 'Burkina Faso',
      'es': 'Burkina Faso',
      'fr': 'Burkina Faso',
      'ja': 'ブルキナファソ',
      'it': 'Burkina Faso'
    },
    'relevance': '0'
  }, {
    'name': 'Burundi',
    'topLevelDomain': ['.bi'],
    'alpha2Code': 'BI',
    'alpha3Code': 'BDI',
    'callingCodes': ['257'],
    'capital': 'Bujumbura',
    'altSpellings': ['BI', 'Republic of Burundi', 'Republika y\'Uburundi', 'République du Burundi'],
    'region': 'Africa',
    'subregion': 'Eastern Africa',
    'population': 9823827,
    'latlng': [-3.5, 30.0],
    'demonym': 'Burundian',
    'area': 27834.0,
    'gini': 33.3,
    'timezones': ['UTC+02:00'],
    'borders': ['COD', 'RWA', 'TZA'],
    'nativeName': 'Burundi',
    'numericCode': '108',
    'currencies': ['BIF'],
    'languages': ['fr', 'rn'],
    'translations': { 'de': 'Burundi', 'es': 'Burundi', 'fr': 'Burundi', 'ja': 'ブルンジ', 'it': 'Burundi' },
    'relevance': '0'
  }, {
    'name': 'Cambodia',
    'topLevelDomain': ['.kh'],
    'alpha2Code': 'KH',
    'alpha3Code': 'KHM',
    'callingCodes': ['855'],
    'capital': 'Phnom Penh',
    'altSpellings': ['KH', 'Kingdom of Cambodia'],
    'region': 'Asia',
    'subregion': 'South-Eastern Asia',
    'population': 15405157,
    'latlng': [13.0, 105.0],
    'demonym': 'Cambodian',
    'area': 181035.0,
    'gini': 37.9,
    'timezones': ['UTC+07:00'],
    'borders': ['LAO', 'THA', 'VNM'],
    'nativeName': 'Kâmpŭchéa',
    'numericCode': '116',
    'currencies': ['KHR'],
    'languages': ['km'],
    'translations': { 'de': 'Kambodscha', 'es': 'Camboya', 'fr': 'Cambodge', 'ja': 'カンボジア', 'it': 'Cambogia' },
    'relevance': '0'
  }, {
    'name': 'Cameroon',
    'topLevelDomain': ['.cm'],
    'alpha2Code': 'CM',
    'alpha3Code': 'CMR',
    'callingCodes': ['237'],
    'capital': 'Yaoundé',
    'altSpellings': ['CM', 'Republic of Cameroon', 'République du Cameroun'],
    'region': 'Africa',
    'subregion': 'Middle Africa',
    'population': 23344000,
    'latlng': [6.0, 12.0],
    'demonym': 'Cameroonian',
    'area': 475442.0,
    'gini': 38.9,
    'timezones': ['UTC+01:00'],
    'borders': ['CAF', 'TCD', 'COG', 'GNQ', 'GAB', 'NGA'],
    'nativeName': 'Cameroon',
    'numericCode': '120',
    'currencies': ['XAF'],
    'languages': ['en', 'fr'],
    'translations': { 'de': 'Kamerun', 'es': 'Camerún', 'fr': 'Cameroun', 'ja': 'カメルーン', 'it': 'Camerun' },
    'relevance': '0'
  }, {
    'name': 'Canada',
    'topLevelDomain': ['.ca'],
    'alpha2Code': 'CA',
    'alpha3Code': 'CAN',
    'callingCodes': ['1'],
    'capital': 'Ottawa',
    'altSpellings': ['CA'],
    'region': 'Americas',
    'subregion': 'Northern America',
    'population': 35749600,
    'latlng': [60.0, -95.0],
    'demonym': 'Canadian',
    'area': 9984670.0,
    'gini': 32.6,
    'timezones': ['UTC-08:00', 'UTC-07:00', 'UTC-06:00', 'UTC-05:00', 'UTC-04:00', 'UTC-03:30'],
    'borders': ['USA'],
    'nativeName': 'Canada',
    'numericCode': '124',
    'currencies': ['CAD'],
    'languages': ['en', 'fr'],
    'translations': { 'de': 'Kanada', 'es': 'Canadá', 'fr': 'Canada', 'ja': 'カナダ', 'it': 'Canada' },
    'relevance': '2'
  }, {
    'name': 'Cape Verde',
    'topLevelDomain': ['.cv'],
    'alpha2Code': 'CV',
    'alpha3Code': 'CPV',
    'callingCodes': ['238'],
    'capital': 'Praia',
    'altSpellings': ['CV', 'Republic of Cabo Verde', 'República de Cabo Verde'],
    'region': 'Africa',
    'subregion': 'Western Africa',
    'population': 524833,
    'latlng': [16.0, -24.0],
    'demonym': 'Cape Verdian',
    'area': 4033.0,
    'gini': 50.5,
    'timezones': ['UTC-01:00'],
    'borders': [],
    'nativeName': 'Cabo Verde',
    'numericCode': '132',
    'currencies': ['CVE'],
    'languages': ['pt'],
    'translations': { 'de': 'Kap Verde', 'es': 'Cabo Verde', 'fr': 'Cap Vert', 'ja': 'カーボベルデ', 'it': 'Capo Verde' },
    'relevance': '0'
  }, {
    'name': 'Cayman Islands',
    'topLevelDomain': ['.ky'],
    'alpha2Code': 'KY',
    'alpha3Code': 'CYM',
    'callingCodes': ['1345'],
    'capital': 'George Town',
    'altSpellings': ['KY'],
    'region': 'Americas',
    'subregion': 'Caribbean',
    'population': 58238,
    'latlng': [19.5, -80.5],
    'demonym': 'Caymanian',
    'area': 264.0,
    'gini': null,
    'timezones': ['UTC-05:00'],
    'borders': [],
    'nativeName': 'Cayman Islands',
    'numericCode': '136',
    'currencies': ['KYD'],
    'languages': ['en'],
    'translations': {
      'de': 'Kaimaninseln',
      'es': 'Islas Caimán',
      'fr': 'Îles Caïmans',
      'ja': 'ケイマン諸島',
      'it': 'Isole Cayman'
    },
    'relevance': '0.5'
  }, {
    'name': 'Central African Republic',
    'topLevelDomain': ['.cf'],
    'alpha2Code': 'CF',
    'alpha3Code': 'CAF',
    'callingCodes': ['236'],
    'capital': 'Bangui',
    'altSpellings': ['CF', 'Central African Republic', 'République centrafricaine'],
    'region': 'Africa',
    'subregion': 'Middle Africa',
    'population': 4900000,
    'latlng': [7.0, 21.0],
    'demonym': 'Central African',
    'area': 622984.0,
    'gini': 56.3,
    'timezones': ['UTC+01:00'],
    'borders': ['CMR', 'TCD', 'COD', 'COG', 'SSD', 'SDN'],
    'nativeName': 'Ködörösêse tî Bêafrîka',
    'numericCode': '140',
    'currencies': ['XAF'],
    'languages': ['fr', 'sg'],
    'translations': {
      'de': 'Zentralafrikanische Republik',
      'es': 'República Centroafricana',
      'fr': 'République centrafricaine',
      'ja': '中央アフリカ共和国',
      'it': 'Repubblica Centrafricana'
    },
    'relevance': '0'
  }, {
    'name': 'Chad',
    'topLevelDomain': ['.td'],
    'alpha2Code': 'TD',
    'alpha3Code': 'TCD',
    'callingCodes': ['235'],
    'capital': 'N\'Djamena',
    'altSpellings': ['TD', 'Tchad', 'Republic of Chad', 'République du Tchad'],
    'region': 'Africa',
    'subregion': 'Middle Africa',
    'population': 14037000,
    'latlng': [15.0, 19.0],
    'demonym': 'Chadian',
    'area': 1284000.0,
    'gini': 39.8,
    'timezones': ['UTC+01:00'],
    'borders': ['CMR', 'CAF', 'LBY', 'NER', 'NGA', 'SSD'],
    'nativeName': 'Tchad',
    'numericCode': '148',
    'currencies': ['XAF'],
    'languages': ['fr', 'ar'],
    'translations': { 'de': 'Tschad', 'es': 'Chad', 'fr': 'Tchad', 'ja': 'チャド', 'it': 'Ciad' },
    'relevance': '0'
  }, {
    'name': 'Chile',
    'topLevelDomain': ['.cl'],
    'alpha2Code': 'CL',
    'alpha3Code': 'CHL',
    'callingCodes': ['56'],
    'capital': 'Santiago',
    'altSpellings': ['CL', 'Republic of Chile', 'República de Chile'],
    'region': 'Americas',
    'subregion': 'South America',
    'population': 18006407,
    'latlng': [-30.0, -71.0],
    'demonym': 'Chilean',
    'area': 756102.0,
    'gini': 52.1,
    'timezones': ['UTC-06:00', 'UTC-04:00'],
    'borders': ['ARG', 'BOL', 'PER'],
    'nativeName': 'Chile',
    'numericCode': '152',
    'currencies': ['CLF', 'CLP'],
    'languages': ['es'],
    'translations': { 'de': 'Chile', 'es': 'Chile', 'fr': 'Chili', 'ja': 'チリ', 'it': 'Cile' },
    'relevance': '0'
  }, {
    'name': 'China',
    'topLevelDomain': ['.cn'],
    'alpha2Code': 'CN',
    'alpha3Code': 'CHN',
    'callingCodes': ['86'],
    'capital': 'Beijing',
    'altSpellings': ['CN', 'Zhōngguó', 'Zhongguo', 'Zhonghua', 'People\'s Republic of China', '中华人民共和国', 'Zhōnghuá Rénmín Gònghéguó'],
    'region': 'Asia',
    'subregion': 'Eastern Asia',
    'population': 1371590000,
    'latlng': [35.0, 105.0],
    'demonym': 'Chinese',
    'area': 9640011.0,
    'gini': 47.0,
    'timezones': ['UTC+08:00'],
    'borders': ['AFG', 'BTN', 'MMR', 'HKG', 'IND', 'KAZ', 'PRK', 'KGZ', 'LAO', 'MAC', 'MNG', 'PAK', 'RUS', 'TJK', 'VNM'],
    'nativeName': '中国',
    'numericCode': '156',
    'currencies': ['CNY'],
    'languages': ['zh'],
    'translations': { 'de': 'China', 'es': 'China', 'fr': 'Chine', 'ja': '中国', 'it': 'Cina' },
    'relevance': '0'
  }, {
    'name': 'Christmas Island',
    'topLevelDomain': ['.cx'],
    'alpha2Code': 'CX',
    'alpha3Code': 'CXR',
    'callingCodes': ['61'],
    'capital': 'Flying Fish Cove',
    'altSpellings': ['CX', 'Territory of Christmas Island'],
    'region': 'Oceania',
    'subregion': 'Australia and New Zealand',
    'population': 2072,
    'latlng': [-10.5, 105.66666666],
    'demonym': 'Christmas Island',
    'area': 135.0,
    'gini': null,
    'timezones': ['UTC+07:00'],
    'borders': [],
    'nativeName': 'Christmas Island',
    'numericCode': '162',
    'currencies': ['AUD'],
    'languages': ['en'],
    'translations': {
      'de': 'Weihnachtsinsel',
      'es': 'Isla de Navidad',
      'fr': 'Île Christmas',
      'ja': 'クリスマス島',
      'it': 'Isola di Natale'
    },
    'relevance': '0.5'
  }, {
    'name': 'Cocos (Keeling) Islands',
    'topLevelDomain': ['.cc'],
    'alpha2Code': 'CC',
    'alpha3Code': 'CCK',
    'callingCodes': ['61'],
    'capital': 'West Island',
    'altSpellings': ['CC', 'Territory of the Cocos (Keeling) Islands', 'Keeling Islands'],
    'region': 'Oceania',
    'subregion': 'Australia and New Zealand',
    'population': 550,
    'latlng': [-12.5, 96.83333333],
    'demonym': 'Cocos Islander',
    'area': 14.0,
    'gini': null,
    'timezones': ['UTC+06:30'],
    'borders': [],
    'nativeName': 'Cocos (Keeling) Islands',
    'numericCode': '166',
    'currencies': ['AUD'],
    'languages': ['en'],
    'translations': {
      'de': 'Kokosinseln',
      'es': 'Islas Cocos o Islas Keeling',
      'fr': 'Îles Cocos',
      'ja': 'ココス（キーリング）諸島',
      'it': 'Isole Cocos e Keeling'
    },
    'relevance': '0'
  }, {
    'name': 'Colombia',
    'topLevelDomain': ['.co'],
    'alpha2Code': 'CO',
    'alpha3Code': 'COL',
    'callingCodes': ['57'],
    'capital': 'Bogotá',
    'altSpellings': ['CO', 'Republic of Colombia', 'República de Colombia'],
    'region': 'Americas',
    'subregion': 'South America',
    'population': 48266600,
    'latlng': [4.0, -72.0],
    'demonym': 'Colombian',
    'area': 1141748.0,
    'gini': 55.9,
    'timezones': ['UTC-05:00'],
    'borders': ['BRA', 'ECU', 'PAN', 'PER', 'VEN'],
    'nativeName': 'Colombia',
    'numericCode': '170',
    'currencies': ['COP'],
    'languages': ['es'],
    'translations': { 'de': 'Kolumbien', 'es': 'Colombia', 'fr': 'Colombie', 'ja': 'コロンビア', 'it': 'Colombia' },
    'relevance': '0'
  }, {
    'name': 'Comoros',
    'topLevelDomain': ['.km'],
    'alpha2Code': 'KM',
    'alpha3Code': 'COM',
    'callingCodes': ['269'],
    'capital': 'Moroni',
    'altSpellings': ['KM', 'Union of the Comoros', 'Union des Comores', 'Udzima wa Komori', 'al-Ittiḥād al-Qumurī'],
    'region': 'Africa',
    'subregion': 'Eastern Africa',
    'population': 784745,
    'latlng': [-12.16666666, 44.25],
    'demonym': 'Comoran',
    'area': 1862.0,
    'gini': 64.3,
    'timezones': ['UTC+03:00'],
    'borders': [],
    'nativeName': 'Komori',
    'numericCode': '174',
    'currencies': ['KMF'],
    'languages': ['ar', 'fr'],
    'translations': { 'de': 'Union der Komoren', 'es': 'Comoras', 'fr': 'Comores', 'ja': 'コモロ', 'it': 'Comore' },
    'relevance': '0'
  }, {
    'name': 'Republic of the Congo',
    'topLevelDomain': ['.cg'],
    'alpha2Code': 'CG',
    'alpha3Code': 'COG',
    'callingCodes': ['242'],
    'capital': 'Brazzaville',
    'altSpellings': ['CG', 'Congo-Brazzaville'],
    'region': 'Africa',
    'subregion': 'Middle Africa',
    'population': 4620000,
    'latlng': [-1.0, 15.0],
    'demonym': 'Congolese',
    'area': 342000.0,
    'gini': 47.3,
    'timezones': ['UTC+01:00'],
    'borders': ['AGO', 'CMR', 'CAF', 'COD', 'GAB'],
    'nativeName': 'République du Congo',
    'numericCode': '178',
    'currencies': ['XAF'],
    'languages': ['fr', 'ln'],
    'translations': { 'de': 'Kongo', 'es': 'Congo', 'fr': 'Congo', 'ja': 'コンゴ共和国', 'it': 'Congo' },
    'relevance': '0'
  }, {
    'name': 'Democratic Republic of the Congo',
    'topLevelDomain': ['.cd'],
    'alpha2Code': 'CD',
    'alpha3Code': 'COD',
    'callingCodes': ['243'],
    'capital': 'Kinshasa',
    'altSpellings': ['CD', 'DR Congo', 'Congo-Kinshasa', 'DRC'],
    'region': 'Africa',
    'subregion': 'Middle Africa',
    'population': 77267000,
    'latlng': [0.0, 25.0],
    'demonym': 'Congolese',
    'area': 2344858.0,
    'gini': null,
    'timezones': ['UTC+01:00', 'UTC+02:00'],
    'borders': ['AGO', 'BDI', 'CAF', 'COG', 'RWA', 'SSD', 'TZA', 'UGA', 'ZMB'],
    'nativeName': 'République démocratique du Congo',
    'numericCode': '180',
    'currencies': ['CDF'],
    'languages': ['fr', 'ln', 'kg', 'sw', 'lu'],
    'translations': {
      'de': 'Kongo (Dem. Rep.)',
      'es': 'Congo (Rep. Dem.)',
      'fr': 'Congo (Rép. dém.)',
      'ja': 'コンゴ民主共和国',
      'it': 'Congo (Rep. Dem.)'
    },
    'relevance': '0'
  }, {
    'name': 'Cook Islands',
    'topLevelDomain': ['.ck'],
    'alpha2Code': 'CK',
    'alpha3Code': 'COK',
    'callingCodes': ['682'],
    'capital': 'Avarua',
    'altSpellings': ['CK', 'Kūki \'Āirani'],
    'region': 'Oceania',
    'subregion': 'Polynesia',
    'population': 14974,
    'latlng': [-21.23333333, -159.76666666],
    'demonym': 'Cook Islander',
    'area': 236.0,
    'gini': null,
    'timezones': ['UTC-10:00'],
    'borders': [],
    'nativeName': 'Cook Islands',
    'numericCode': '184',
    'currencies': ['NZD'],
    'languages': ['en'],
    'translations': { 'de': 'Cookinseln', 'es': 'Islas Cook', 'fr': 'Îles Cook', 'ja': 'クック諸島', 'it': 'Isole Cook' },
    'relevance': '0.5'
  }, {
    'name': 'Costa Rica',
    'topLevelDomain': ['.cr'],
    'alpha2Code': 'CR',
    'alpha3Code': 'CRI',
    'callingCodes': ['506'],
    'capital': 'San José',
    'altSpellings': ['CR', 'Republic of Costa Rica', 'República de Costa Rica'],
    'region': 'Americas',
    'subregion': 'Central America',
    'population': 4773130,
    'latlng': [10.0, -84.0],
    'demonym': 'Costa Rican',
    'area': 51100.0,
    'gini': 50.7,
    'timezones': ['UTC-06:00'],
    'borders': ['NIC', 'PAN'],
    'nativeName': 'Costa Rica',
    'numericCode': '188',
    'currencies': ['CRC'],
    'languages': ['es'],
    'translations': { 'de': 'Costa Rica', 'es': 'Costa Rica', 'fr': 'Costa Rica', 'ja': 'コスタリカ', 'it': 'Costa Rica' },
    'relevance': '0'
  }, {
    'name': 'Croatia',
    'topLevelDomain': ['.hr'],
    'alpha2Code': 'HR',
    'alpha3Code': 'HRV',
    'callingCodes': ['385'],
    'capital': 'Zagreb',
    'altSpellings': ['HR', 'Hrvatska', 'Republic of Croatia', 'Republika Hrvatska'],
    'region': 'Europe',
    'subregion': 'Southern Europe',
    'population': 4246800,
    'latlng': [45.16666666, 15.5],
    'demonym': 'Croatian',
    'area': 56594.0,
    'gini': 33.7,
    'timezones': ['UTC+01:00'],
    'borders': ['BIH', 'HUN', 'MNE', 'SRB', 'SVN'],
    'nativeName': 'Hrvatska',
    'numericCode': '191',
    'currencies': ['HRK'],
    'languages': ['hr'],
    'translations': { 'de': 'Kroatien', 'es': 'Croacia', 'fr': 'Croatie', 'ja': 'クロアチア', 'it': 'Croazia' },
    'relevance': '0'
  }, {
    'name': 'Cuba',
    'topLevelDomain': ['.cu'],
    'alpha2Code': 'CU',
    'alpha3Code': 'CUB',
    'callingCodes': ['53'],
    'capital': 'Havana',
    'altSpellings': ['CU', 'Republic of Cuba', 'República de Cuba'],
    'region': 'Americas',
    'subregion': 'Caribbean',
    'population': 11238317,
    'latlng': [21.5, -80.0],
    'demonym': 'Cuban',
    'area': 109884.0,
    'gini': null,
    'timezones': ['UTC-05:00'],
    'borders': [],
    'nativeName': 'Cuba',
    'numericCode': '192',
    'currencies': ['CUC', 'CUP'],
    'languages': ['es'],
    'translations': { 'de': 'Kuba', 'es': 'Cuba', 'fr': 'Cuba', 'ja': 'キューバ', 'it': 'Cuba' },
    'relevance': '0'
  }, {
    'name': 'Curaçao',
    'topLevelDomain': ['.cw'],
    'alpha2Code': 'CW',
    'alpha3Code': 'CUW',
    'callingCodes': ['599'],
    'capital': 'Willemstad',
    'altSpellings': ['CW', 'Curacao', 'Kòrsou', 'Country of Curaçao', 'Land Curaçao', 'Pais Kòrsou'],
    'region': 'Americas',
    'subregion': 'Caribbean',
    'population': 154843,
    'latlng': [12.116667, -68.933333],
    'demonym': 'Dutch',
    'area': 444.0,
    'gini': null,
    'timezones': ['UTC-04:00'],
    'borders': [],
    'nativeName': 'Curaçao',
    'numericCode': '531',
    'currencies': ['ANG'],
    'languages': ['nl', 'pa', 'en'],
    'translations': { 'de': null, 'es': null, 'fr': null, 'ja': null, 'it': null },
    'relevance': '0'
  }, {
    'name': 'Cyprus',
    'topLevelDomain': ['.cy'],
    'alpha2Code': 'CY',
    'alpha3Code': 'CYP',
    'callingCodes': ['357'],
    'capital': 'Nicosia',
    'altSpellings': ['CY', 'Kýpros', 'Kıbrıs', 'Republic of Cyprus', 'Κυπριακή Δημοκρατία', 'Kıbrıs Cumhuriyeti'],
    'region': 'Europe',
    'subregion': 'Southern Europe',
    'population': 858000,
    'latlng': [35.0, 33.0],
    'demonym': 'Cypriot',
    'area': 9251.0,
    'gini': null,
    'timezones': ['UTC+02:00'],
    'borders': ['GBR'],
    'nativeName': 'Κύπρος',
    'numericCode': '196',
    'currencies': ['EUR'],
    'languages': ['el', 'tr', 'hy'],
    'translations': { 'de': 'Zypern', 'es': 'Chipre', 'fr': 'Chypre', 'ja': 'キプロス', 'it': 'Cipro' },
    'relevance': '0'
  }, {
    'name': 'Czech Republic',
    'topLevelDomain': ['.cz'],
    'alpha2Code': 'CZ',
    'alpha3Code': 'CZE',
    'callingCodes': ['420'],
    'capital': 'Prague',
    'altSpellings': ['CZ', 'Česká republika', 'Česko'],
    'region': 'Europe',
    'subregion': 'Eastern Europe',
    'population': 10537818,
    'latlng': [49.75, 15.5],
    'demonym': 'Czech',
    'area': 78865.0,
    'gini': 26.0,
    'timezones': ['UTC+01:00'],
    'borders': ['AUT', 'DEU', 'POL', 'SVK'],
    'nativeName': 'Česká republika',
    'numericCode': '203',
    'currencies': ['CZK'],
    'languages': ['cs', 'sk'],
    'translations': {
      'de': 'Tschechische Republik',
      'es': 'República Checa',
      'fr': 'République tchèque',
      'ja': 'チェコ',
      'it': 'Repubblica Ceca'
    },
    'relevance': '0'
  }, {
    'name': 'Denmark',
    'topLevelDomain': ['.dk'],
    'alpha2Code': 'DK',
    'alpha3Code': 'DNK',
    'callingCodes': ['45'],
    'capital': 'Copenhagen',
    'altSpellings': ['DK', 'Danmark', 'Kingdom of Denmark', 'Kongeriget Danmark'],
    'region': 'Europe',
    'subregion': 'Northern Europe',
    'population': 5678348,
    'latlng': [56.0, 10.0],
    'demonym': 'Danish',
    'area': 43094.0,
    'gini': 24.0,
    'timezones': ['UTC-04:00', 'UTC-03:00', 'UTC-01:00', 'UTC', 'UTC+01:00'],
    'borders': ['DEU'],
    'nativeName': 'Danmark',
    'numericCode': '208',
    'currencies': ['DKK'],
    'languages': ['da'],
    'translations': { 'de': 'Dänemark', 'es': 'Dinamarca', 'fr': 'Danemark', 'ja': 'デンマーク', 'it': 'Danimarca' },
    'relevance': '1.5'
  }, {
    'name': 'Djibouti',
    'topLevelDomain': ['.dj'],
    'alpha2Code': 'DJ',
    'alpha3Code': 'DJI',
    'callingCodes': ['253'],
    'capital': 'Djibouti',
    'altSpellings': ['DJ', 'Jabuuti', 'Gabuuti', 'Republic of Djibouti', 'République de Djibouti', 'Gabuutih Ummuuno', 'Jamhuuriyadda Jabuuti'],
    'region': 'Africa',
    'subregion': 'Eastern Africa',
    'population': 888000,
    'latlng': [11.5, 43.0],
    'demonym': 'Djibouti',
    'area': 23200.0,
    'gini': 40.0,
    'timezones': ['UTC+03:00'],
    'borders': ['ERI', 'ETH', 'SOM'],
    'nativeName': 'Djibouti',
    'numericCode': '262',
    'currencies': ['DJF'],
    'languages': ['fr', 'ar'],
    'translations': { 'de': 'Dschibuti', 'es': 'Yibuti', 'fr': 'Djibouti', 'ja': 'ジブチ', 'it': 'Gibuti' },
    'relevance': '0'
  }, {
    'name': 'Dominica',
    'topLevelDomain': ['.dm'],
    'alpha2Code': 'DM',
    'alpha3Code': 'DMA',
    'callingCodes': ['1767'],
    'capital': 'Roseau',
    'altSpellings': ['DM', 'Dominique', 'Wai‘tu kubuli', 'Commonwealth of Dominica'],
    'region': 'Americas',
    'subregion': 'Caribbean',
    'population': 71293,
    'latlng': [15.41666666, -61.33333333],
    'demonym': 'Dominican',
    'area': 751.0,
    'gini': null,
    'timezones': ['UTC-04:00'],
    'borders': [],
    'nativeName': 'Dominica',
    'numericCode': '212',
    'currencies': ['XCD'],
    'languages': ['en'],
    'translations': { 'de': 'Dominica', 'es': 'Dominica', 'fr': 'Dominique', 'ja': 'ドミニカ国', 'it': 'Dominica' },
    'relevance': '0.5'
  }, {
    'name': 'Dominican Republic',
    'topLevelDomain': ['.do'],
    'alpha2Code': 'DO',
    'alpha3Code': 'DOM',
    'callingCodes': ['1809', '1829', '1849'],
    'capital': 'Santo Domingo',
    'altSpellings': ['DO'],
    'region': 'Americas',
    'subregion': 'Caribbean',
    'population': 10528000,
    'latlng': [19.0, -70.66666666],
    'demonym': 'Dominican',
    'area': 48671.0,
    'gini': 47.2,
    'timezones': ['UTC-04:00'],
    'borders': ['HTI'],
    'nativeName': 'República Dominicana',
    'numericCode': '214',
    'currencies': ['DOP'],
    'languages': ['es'],
    'translations': {
      'de': 'Dominikanische Republik',
      'es': 'República Dominicana',
      'fr': 'République dominicaine',
      'ja': 'ドミニカ共和国',
      'it': 'Repubblica Dominicana'
    },
    'relevance': '0'
  }, {
    'name': 'Ecuador',
    'topLevelDomain': ['.ec'],
    'alpha2Code': 'EC',
    'alpha3Code': 'ECU',
    'callingCodes': ['593'],
    'capital': 'Quito',
    'altSpellings': ['EC', 'Republic of Ecuador', 'República del Ecuador'],
    'region': 'Americas',
    'subregion': 'South America',
    'population': 16027500,
    'latlng': [-2.0, -77.5],
    'demonym': 'Ecuadorean',
    'area': 276841.0,
    'gini': 49.3,
    'timezones': ['UTC-06:00', 'UTC-05:00'],
    'borders': ['COL', 'PER'],
    'nativeName': 'Ecuador',
    'numericCode': '218',
    'currencies': ['USD'],
    'languages': ['es'],
    'translations': { 'de': 'Ecuador', 'es': 'Ecuador', 'fr': 'Équateur', 'ja': 'エクアドル', 'it': 'Ecuador' },
    'relevance': '0'
  }, {
    'name': 'Egypt',
    'topLevelDomain': ['.eg'],
    'alpha2Code': 'EG',
    'alpha3Code': 'EGY',
    'callingCodes': ['20'],
    'capital': 'Cairo',
    'altSpellings': ['EG', 'Arab Republic of Egypt'],
    'region': 'Africa',
    'subregion': 'Northern Africa',
    'population': 89335600,
    'latlng': [27.0, 30.0],
    'demonym': 'Egyptian',
    'area': 1002450.0,
    'gini': 30.8,
    'timezones': ['UTC+02:00'],
    'borders': ['ISR', 'LBY', 'SDN'],
    'nativeName': 'مصر‎',
    'numericCode': '818',
    'currencies': ['EGP'],
    'languages': ['ar'],
    'translations': { 'de': 'Ägypten', 'es': 'Egipto', 'fr': 'Égypte', 'ja': 'エジプト', 'it': 'Egitto' },
    'relevance': '1.5'
  }, {
    'name': 'El Salvador',
    'topLevelDomain': ['.sv'],
    'alpha2Code': 'SV',
    'alpha3Code': 'SLV',
    'callingCodes': ['503'],
    'capital': 'San Salvador',
    'altSpellings': ['SV', 'Republic of El Salvador', 'República de El Salvador'],
    'region': 'Americas',
    'subregion': 'Central America',
    'population': 6401240,
    'latlng': [13.83333333, -88.91666666],
    'demonym': 'Salvadoran',
    'area': 21041.0,
    'gini': 48.3,
    'timezones': ['UTC-06:00'],
    'borders': ['GTM', 'HND'],
    'nativeName': 'El Salvador',
    'numericCode': '222',
    'currencies': ['SVC', 'USD'],
    'languages': ['es'],
    'translations': { 'de': 'El Salvador', 'es': 'El Salvador', 'fr': 'Salvador', 'ja': 'エルサルバドル', 'it': 'El Salvador' },
    'relevance': '0'
  }, {
    'name': 'Equatorial Guinea',
    'topLevelDomain': ['.gq'],
    'alpha2Code': 'GQ',
    'alpha3Code': 'GNQ',
    'callingCodes': ['240'],
    'capital': 'Malabo',
    'altSpellings': ['GQ', 'Republic of Equatorial Guinea', 'República de Guinea Ecuatorial', 'République de Guinée équatoriale', 'República da Guiné Equatorial'],
    'region': 'Africa',
    'subregion': 'Middle Africa',
    'population': 1430000,
    'latlng': [2.0, 10.0],
    'demonym': 'Equatorial Guinean',
    'area': 28051.0,
    'gini': null,
    'timezones': ['UTC+01:00'],
    'borders': ['CMR', 'GAB'],
    'nativeName': 'Guinea Ecuatorial',
    'numericCode': '226',
    'currencies': ['XAF'],
    'languages': ['es', 'fr'],
    'translations': {
      'de': 'Äquatorial-Guinea',
      'es': 'Guinea Ecuatorial',
      'fr': 'Guinée-Équatoriale',
      'ja': '赤道ギニア',
      'it': 'Guinea Equatoriale'
    },
    'relevance': '0'
  }, {
    'name': 'Eritrea',
    'topLevelDomain': ['.er'],
    'alpha2Code': 'ER',
    'alpha3Code': 'ERI',
    'callingCodes': ['291'],
    'capital': 'Asmara',
    'altSpellings': ['ER', 'State of Eritrea', 'ሃገረ ኤርትራ', 'Dawlat Iritriyá', 'ʾErtrā', 'Iritriyā', ''],
    'region': 'Africa',
    'subregion': 'Eastern Africa',
    'population': 5228000,
    'latlng': [15.0, 39.0],
    'demonym': 'Eritrean',
    'area': 117600.0,
    'gini': null,
    'timezones': ['UTC+03:00'],
    'borders': ['DJI', 'ETH', 'SDN'],
    'nativeName': 'ኤርትራ',
    'numericCode': '232',
    'currencies': ['ERN'],
    'languages': ['ti', 'ar', 'en'],
    'translations': { 'de': 'Eritrea', 'es': 'Eritrea', 'fr': 'Érythrée', 'ja': 'エリトリア', 'it': 'Eritrea' },
    'relevance': '0'
  }, {
    'name': 'Estonia',
    'topLevelDomain': ['.ee'],
    'alpha2Code': 'EE',
    'alpha3Code': 'EST',
    'callingCodes': ['372'],
    'capital': 'Tallinn',
    'altSpellings': ['EE', 'Eesti', 'Republic of Estonia', 'Eesti Vabariik'],
    'region': 'Europe',
    'subregion': 'Northern Europe',
    'population': 1313271,
    'latlng': [59.0, 26.0],
    'demonym': 'Estonian',
    'area': 45227.0,
    'gini': 36.0,
    'timezones': ['UTC+02:00'],
    'borders': ['LVA', 'RUS'],
    'nativeName': 'Eesti',
    'numericCode': '233',
    'currencies': ['EUR'],
    'languages': ['et'],
    'translations': { 'de': 'Estland', 'es': 'Estonia', 'fr': 'Estonie', 'ja': 'エストニア', 'it': 'Estonia' },
    'relevance': '0'
  }, {
    'name': 'Ethiopia',
    'topLevelDomain': ['.et'],
    'alpha2Code': 'ET',
    'alpha3Code': 'ETH',
    'callingCodes': ['251'],
    'capital': 'Addis Ababa',
    'altSpellings': ['ET', 'ʾĪtyōṗṗyā', 'Federal Democratic Republic of Ethiopia', 'የኢትዮጵያ ፌዴራላዊ ዲሞክራሲያዊ ሪፐብሊክ'],
    'region': 'Africa',
    'subregion': 'Eastern Africa',
    'population': 90076012,
    'latlng': [8.0, 38.0],
    'demonym': 'Ethiopian',
    'area': 1104300.0,
    'gini': 29.8,
    'timezones': ['UTC+03:00'],
    'borders': ['DJI', 'ERI', 'KEN', 'SOM', 'SSD', 'SDN'],
    'nativeName': 'ኢትዮጵያ',
    'numericCode': '231',
    'currencies': ['ETB'],
    'languages': ['am'],
    'translations': { 'de': 'Äthiopien', 'es': 'Etiopía', 'fr': 'Éthiopie', 'ja': 'エチオピア', 'it': 'Etiopia' },
    'relevance': '0'
  }, {
    'name': 'Falkland Islands',
    'topLevelDomain': ['.fk'],
    'alpha2Code': 'FK',
    'alpha3Code': 'FLK',
    'callingCodes': ['500'],
    'capital': 'Stanley',
    'altSpellings': ['FK', 'Islas Malvinas'],
    'region': 'Americas',
    'subregion': 'South America',
    'population': 3000,
    'latlng': [-51.75, -59.0],
    'demonym': 'Falkland Islander',
    'area': 12173.0,
    'gini': null,
    'timezones': ['UTC-04:00'],
    'borders': [],
    'nativeName': 'Falkland Islands',
    'numericCode': '238',
    'currencies': ['FKP'],
    'languages': ['en'],
    'translations': {
      'de': 'Falklandinseln',
      'es': 'Islas Malvinas',
      'fr': 'Îles Malouines',
      'ja': 'フォークランド（マルビナス）諸島',
      'it': 'Isole Falkland o Isole Malvine'
    },
    'relevance': '0.5'
  }, {
    'name': 'Faroe Islands',
    'topLevelDomain': ['.fo'],
    'alpha2Code': 'FO',
    'alpha3Code': 'FRO',
    'callingCodes': ['298'],
    'capital': 'Tórshavn',
    'altSpellings': ['FO', 'Føroyar', 'Færøerne'],
    'region': 'Europe',
    'subregion': 'Northern Europe',
    'population': 48846,
    'latlng': [62.0, -7.0],
    'demonym': 'Faroese',
    'area': 1393.0,
    'gini': null,
    'timezones': ['UTC+00:00'],
    'borders': [],
    'nativeName': 'Føroyar',
    'numericCode': '234',
    'currencies': ['DKK'],
    'languages': ['fo'],
    'translations': {
      'de': 'Färöer-Inseln',
      'es': 'Islas Faroe',
      'fr': 'Îles Féroé',
      'ja': 'フェロー諸島',
      'it': 'Isole Far Oer'
    },
    'relevance': '0.5'
  }, {
    'name': 'Fiji',
    'topLevelDomain': ['.fj'],
    'alpha2Code': 'FJ',
    'alpha3Code': 'FJI',
    'callingCodes': ['679'],
    'capital': 'Suva',
    'altSpellings': ['FJ', 'Viti', 'Republic of Fiji', 'Matanitu ko Viti', 'Fijī Gaṇarājya'],
    'region': 'Oceania',
    'subregion': 'Melanesia',
    'population': 859178,
    'latlng': [-18.0, 175.0],
    'demonym': 'Fijian',
    'area': 18272.0,
    'gini': 42.8,
    'timezones': ['UTC+12:00'],
    'borders': [],
    'nativeName': 'Fiji',
    'numericCode': '242',
    'currencies': ['FJD'],
    'languages': ['en', 'fj', 'hi', 'ur'],
    'translations': { 'de': 'Fidschi', 'es': 'Fiyi', 'fr': 'Fidji', 'ja': 'フィジー', 'it': 'Figi' },
    'relevance': '0'
  }, {
    'name': 'Finland',
    'topLevelDomain': ['.fi'],
    'alpha2Code': 'FI',
    'alpha3Code': 'FIN',
    'callingCodes': ['358'],
    'capital': 'Helsinki',
    'altSpellings': ['FI', 'Suomi', 'Republic of Finland', 'Suomen tasavalta', 'Republiken Finland'],
    'region': 'Europe',
    'subregion': 'Northern Europe',
    'population': 5485215,
    'latlng': [64.0, 26.0],
    'demonym': 'Finnish',
    'area': 338424.0,
    'gini': 26.9,
    'timezones': ['UTC+02:00'],
    'borders': ['NOR', 'SWE', 'RUS'],
    'nativeName': 'Suomi',
    'numericCode': '246',
    'currencies': ['EUR'],
    'languages': ['fi', 'sv'],
    'translations': { 'de': 'Finnland', 'es': 'Finlandia', 'fr': 'Finlande', 'ja': 'フィンランド', 'it': 'Finlandia' },
    'relevance': '0.5'
  }, {
    'name': 'France',
    'topLevelDomain': ['.fr'],
    'alpha2Code': 'FR',
    'alpha3Code': 'FRA',
    'callingCodes': ['33'],
    'capital': 'Paris',
    'altSpellings': ['FR', 'French Republic', 'République française'],
    'region': 'Europe',
    'subregion': 'Western Europe',
    'population': 66186000,
    'latlng': [46.0, 2.0],
    'demonym': 'French',
    'area': 640679.0,
    'gini': 32.7,
    'timezones': ['UTC-10:00', 'UTC-09:30', 'UTC-09:00', 'UTC-08:00', 'UTC-04:00', 'UTC-03:00', 'UTC+01:00', 'UTC+03:00', 'UTC+04:00', 'UTC+05:00', 'UTC+11:00', 'UTC+12:00'],
    'borders': ['AND', 'BEL', 'DEU', 'ITA', 'LUX', 'MCO', 'ESP', 'CHE'],
    'nativeName': 'France',
    'numericCode': '250',
    'currencies': ['EUR'],
    'languages': ['fr'],
    'translations': { 'de': 'Frankreich', 'es': 'Francia', 'fr': 'France', 'ja': 'フランス', 'it': 'Francia' },
    'relevance': '2.5'
  }, {
    'name': 'French Guiana',
    'topLevelDomain': ['.gf'],
    'alpha2Code': 'GF',
    'alpha3Code': 'GUF',
    'callingCodes': ['594'],
    'capital': 'Cayenne',
    'altSpellings': ['GF', 'Guiana', 'Guyane'],
    'region': 'Americas',
    'subregion': 'South America',
    'population': 239648,
    'latlng': [4.0, -53.0],
    'demonym': '',
    'area': null,
    'gini': null,
    'timezones': ['UTC-03:00'],
    'borders': ['BRA', 'SUR'],
    'nativeName': 'Guyane française',
    'numericCode': '254',
    'currencies': ['EUR'],
    'languages': ['fr'],
    'translations': {
      'de': 'Französisch Guyana',
      'es': 'Guayana Francesa',
      'fr': 'Guayane',
      'ja': 'フランス領ギアナ',
      'it': 'Guyana francese'
    },
    'relevance': '0'
  }, {
    'name': 'French Polynesia',
    'topLevelDomain': ['.pf'],
    'alpha2Code': 'PF',
    'alpha3Code': 'PYF',
    'callingCodes': ['689'],
    'capital': 'Papeetē',
    'altSpellings': ['PF', 'Polynésie française', 'French Polynesia', 'Pōrīnetia Farāni'],
    'region': 'Oceania',
    'subregion': 'Polynesia',
    'population': 268270,
    'latlng': [-15.0, -140.0],
    'demonym': 'French Polynesian',
    'area': 4167.0,
    'gini': null,
    'timezones': ['UTC-10:00', 'UTC-09:30', 'UTC-09:00'],
    'borders': [],
    'nativeName': 'Polynésie française',
    'numericCode': '258',
    'currencies': ['XPF'],
    'languages': ['fr'],
    'translations': {
      'de': 'Französisch-Polynesien',
      'es': 'Polinesia Francesa',
      'fr': 'Polynésie française',
      'ja': 'フランス領ポリネシア',
      'it': 'Polinesia Francese'
    },
    'relevance': '0'
  }, {
    'name': 'French Southern and Antarctic Lands',
    'topLevelDomain': ['.tf'],
    'alpha2Code': 'TF',
    'alpha3Code': 'ATF',
    'callingCodes': [''],
    'capital': 'Port-aux-Français',
    'altSpellings': ['TF'],
    'region': 'Africa',
    'subregion': 'Southern Africa',
    'population': 140,
    'latlng': [-49.25, 69.167],
    'demonym': 'French',
    'area': 7747.0,
    'gini': null,
    'timezones': ['UTC+05:00'],
    'borders': [],
    'nativeName': 'Territoire des Terres australes et antarctiques françaises',
    'numericCode': '260',
    'currencies': ['EUR'],
    'languages': ['fr'],
    'translations': {
      'de': 'Französische Süd- und Antarktisgebiete',
      'es': 'Tierras Australes y Antárticas Francesas',
      'fr': 'Terres australes et antarctiques françaises',
      'ja': 'フランス領南方・南極地域',
      'it': 'Territori Francesi del Sud'
    },
    'relevance': '0'
  }, {
    'name': 'Gabon',
    'topLevelDomain': ['.ga'],
    'alpha2Code': 'GA',
    'alpha3Code': 'GAB',
    'callingCodes': ['241'],
    'capital': 'Libreville',
    'altSpellings': ['GA', 'Gabonese Republic', 'République Gabonaise'],
    'region': 'Africa',
    'subregion': 'Middle Africa',
    'population': 1725000,
    'latlng': [-1.0, 11.75],
    'demonym': 'Gabonese',
    'area': 267668.0,
    'gini': 41.5,
    'timezones': ['UTC+01:00'],
    'borders': ['CMR', 'COG', 'GNQ'],
    'nativeName': 'Gabon',
    'numericCode': '266',
    'currencies': ['XAF'],
    'languages': ['fr'],
    'translations': { 'de': 'Gabun', 'es': 'Gabón', 'fr': 'Gabon', 'ja': 'ガボン', 'it': 'Gabon' },
    'relevance': '0'
  }, {
    'name': 'The Gambia',
    'topLevelDomain': ['.gm'],
    'alpha2Code': 'GM',
    'alpha3Code': 'GMB',
    'callingCodes': ['220'],
    'capital': 'Banjul',
    'altSpellings': ['GM', 'Republic of the Gambia'],
    'region': 'Africa',
    'subregion': 'Western Africa',
    'population': 1882450,
    'latlng': [13.46666666, -16.56666666],
    'demonym': 'Gambian',
    'area': 11295.0,
    'gini': null,
    'timezones': ['UTC+00:00'],
    'borders': ['SEN'],
    'nativeName': 'Gambia',
    'numericCode': '270',
    'currencies': ['GMD'],
    'languages': ['en'],
    'translations': { 'de': 'Gambia', 'es': 'Gambia', 'fr': 'Gambie', 'ja': 'ガンビア', 'it': 'Gambia' },
    'relevance': '0'
  }, {
    'name': 'Georgia',
    'topLevelDomain': ['.ge'],
    'alpha2Code': 'GE',
    'alpha3Code': 'GEO',
    'callingCodes': ['995'],
    'capital': 'Tbilisi',
    'altSpellings': ['GE', 'Sakartvelo'],
    'region': 'Asia',
    'subregion': 'Western Asia',
    'population': 3729500,
    'latlng': [42.0, 43.5],
    'demonym': 'Georgian',
    'area': 69700.0,
    'gini': 41.3,
    'timezones': ['UTC-05:00'],
    'borders': ['ARM', 'AZE', 'RUS', 'TUR'],
    'nativeName': 'საქართველო',
    'numericCode': '268',
    'currencies': ['GEL'],
    'languages': ['ka'],
    'translations': { 'de': 'Georgien', 'es': 'Georgia', 'fr': 'Géorgie', 'ja': 'グルジア', 'it': 'Georgia' },
    'relevance': '0'
  }, {
    'name': 'Germany',
    'topLevelDomain': ['.de'],
    'alpha2Code': 'DE',
    'alpha3Code': 'DEU',
    'callingCodes': ['49'],
    'capital': 'Berlin',
    'altSpellings': ['DE', 'Federal Republic of Germany', 'Bundesrepublik Deutschland'],
    'region': 'Europe',
    'subregion': 'Western Europe',
    'population': 81083600,
    'latlng': [51.0, 9.0],
    'demonym': 'German',
    'area': 357114.0,
    'gini': 28.3,
    'timezones': ['UTC+01:00'],
    'borders': ['AUT', 'BEL', 'CZE', 'DNK', 'FRA', 'LUX', 'NLD', 'POL', 'CHE'],
    'nativeName': 'Deutschland',
    'numericCode': '276',
    'currencies': ['EUR'],
    'languages': ['de'],
    'translations': { 'de': 'Deutschland', 'es': 'Alemania', 'fr': 'Allemagne', 'ja': 'ドイツ', 'it': 'Germania' },
    'relevance': '3'
  }, {
    'name': 'Ghana',
    'topLevelDomain': ['.gh'],
    'alpha2Code': 'GH',
    'alpha3Code': 'GHA',
    'callingCodes': ['233'],
    'capital': 'Accra',
    'altSpellings': ['GH'],
    'region': 'Africa',
    'subregion': 'Western Africa',
    'population': 27043093,
    'latlng': [8.0, -2.0],
    'demonym': 'Ghanaian',
    'area': 238533.0,
    'gini': 42.8,
    'timezones': ['UTC'],
    'borders': ['BFA', 'CIV', 'TGO'],
    'nativeName': 'Ghana',
    'numericCode': '288',
    'currencies': ['GHS'],
    'languages': ['en'],
    'translations': { 'de': 'Ghana', 'es': 'Ghana', 'fr': 'Ghana', 'ja': 'ガーナ', 'it': 'Ghana' },
    'relevance': '0'
  }, {
    'name': 'Gibraltar',
    'topLevelDomain': ['.gi'],
    'alpha2Code': 'GI',
    'alpha3Code': 'GIB',
    'callingCodes': ['350'],
    'capital': 'Gibraltar',
    'altSpellings': ['GI'],
    'region': 'Europe',
    'subregion': 'Southern Europe',
    'population': 32734,
    'latlng': [36.13333333, -5.35],
    'demonym': 'Gibraltar',
    'area': 6.0,
    'gini': null,
    'timezones': ['UTC+01:00'],
    'borders': ['ESP'],
    'nativeName': 'Gibraltar',
    'numericCode': '292',
    'currencies': ['GIP'],
    'languages': ['en'],
    'translations': { 'de': 'Gibraltar', 'es': 'Gibraltar', 'fr': 'Gibraltar', 'ja': 'ジブラルタル', 'it': 'Gibilterra' },
    'relevance': '0.5'
  }, {
    'name': 'Greece',
    'topLevelDomain': ['.gr'],
    'alpha2Code': 'GR',
    'alpha3Code': 'GRC',
    'callingCodes': ['30'],
    'capital': 'Athens',
    'altSpellings': ['GR', 'Elláda', 'Hellenic Republic', 'Ελληνική Δημοκρατία'],
    'region': 'Europe',
    'subregion': 'Southern Europe',
    'population': 10846979,
    'latlng': [39.0, 22.0],
    'demonym': 'Greek',
    'area': 131990.0,
    'gini': 34.3,
    'timezones': ['UTC+02:00'],
    'borders': ['ALB', 'BGR', 'TUR', 'MKD'],
    'nativeName': 'Ελλάδα',
    'numericCode': '300',
    'currencies': ['EUR'],
    'languages': ['el'],
    'translations': { 'de': 'Griechenland', 'es': 'Grecia', 'fr': 'Grèce', 'ja': 'ギリシャ', 'it': 'Grecia' },
    'relevance': '1.5'
  }, {
    'name': 'Greenland',
    'topLevelDomain': ['.gl'],
    'alpha2Code': 'GL',
    'alpha3Code': 'GRL',
    'callingCodes': ['299'],
    'capital': 'Nuuk',
    'altSpellings': ['GL', 'Grønland'],
    'region': 'Americas',
    'subregion': 'Northern America',
    'population': 56114,
    'latlng': [72.0, -40.0],
    'demonym': 'Greenlandic',
    'area': 2166086.0,
    'gini': null,
    'timezones': ['UTC-04:00', 'UTC-03:00', 'UTC-01:00', 'UTC+00:00'],
    'borders': [],
    'nativeName': 'Kalaallit Nunaat',
    'numericCode': '304',
    'currencies': ['DKK'],
    'languages': ['kl'],
    'translations': { 'de': 'Grönland', 'es': 'Groenlandia', 'fr': 'Groenland', 'ja': 'グリーンランド', 'it': 'Groenlandia' },
    'relevance': '0.5'
  }, {
    'name': 'Grenada',
    'topLevelDomain': ['.gd'],
    'alpha2Code': 'GD',
    'alpha3Code': 'GRD',
    'callingCodes': ['1473'],
    'capital': 'St. George\'s',
    'altSpellings': ['GD'],
    'region': 'Americas',
    'subregion': 'Caribbean',
    'population': 103328,
    'latlng': [12.11666666, -61.66666666],
    'demonym': 'Grenadian',
    'area': 344.0,
    'gini': null,
    'timezones': ['UTC-04:00'],
    'borders': [],
    'nativeName': 'Grenada',
    'numericCode': '308',
    'currencies': ['XCD'],
    'languages': ['en'],
    'translations': { 'de': 'Grenada', 'es': 'Grenada', 'fr': 'Grenade', 'ja': 'グレナダ', 'it': 'Grenada' },
    'relevance': '0'
  }, {
    'name': 'Guadeloupe',
    'topLevelDomain': ['.gp'],
    'alpha2Code': 'GP',
    'alpha3Code': 'GLP',
    'callingCodes': ['590'],
    'capital': 'Basse-Terre',
    'altSpellings': ['GP', 'Gwadloup'],
    'region': 'Americas',
    'subregion': 'Caribbean',
    'population': 403750,
    'latlng': [16.25, -61.583333],
    'demonym': 'Guadeloupian',
    'area': null,
    'gini': null,
    'timezones': ['UTC-04:00'],
    'borders': [],
    'nativeName': 'Guadeloupe',
    'numericCode': '312',
    'currencies': ['EUR'],
    'languages': ['fr'],
    'translations': { 'de': 'Guadeloupe', 'es': 'Guadalupe', 'fr': 'Guadeloupe', 'ja': 'グアドループ', 'it': 'Guadeloupa' },
    'relevance': '0'
  }, {
    'name': 'Guam',
    'topLevelDomain': ['.gu'],
    'alpha2Code': 'GU',
    'alpha3Code': 'GUM',
    'callingCodes': ['1671'],
    'capital': 'Hagåtña',
    'altSpellings': ['GU', 'Guåhån'],
    'region': 'Oceania',
    'subregion': 'Micronesia',
    'population': 159358,
    'latlng': [13.46666666, 144.78333333],
    'demonym': 'Guamanian',
    'area': 549.0,
    'gini': null,
    'timezones': ['UTC+10:00'],
    'borders': [],
    'nativeName': 'Guam',
    'numericCode': '316',
    'currencies': ['USD'],
    'languages': ['en', 'ch', 'es'],
    'translations': { 'de': 'Guam', 'es': 'Guam', 'fr': 'Guam', 'ja': 'グアム', 'it': 'Guam' },
    'relevance': '0'
  }, {
    'name': 'Guatemala',
    'topLevelDomain': ['.gt'],
    'alpha2Code': 'GT',
    'alpha3Code': 'GTM',
    'callingCodes': ['502'],
    'capital': 'Guatemala City',
    'altSpellings': ['GT'],
    'region': 'Americas',
    'subregion': 'Central America',
    'population': 16176133,
    'latlng': [15.5, -90.25],
    'demonym': 'Guatemalan',
    'area': 108889.0,
    'gini': 55.9,
    'timezones': ['UTC-06:00'],
    'borders': ['BLZ', 'SLV', 'HND', 'MEX'],
    'nativeName': 'Guatemala',
    'numericCode': '320',
    'currencies': ['GTQ'],
    'languages': ['es'],
    'translations': { 'de': 'Guatemala', 'es': 'Guatemala', 'fr': 'Guatemala', 'ja': 'グアテマラ', 'it': 'Guatemala' },
    'relevance': '0'
  }, {
    'name': 'Guernsey',
    'topLevelDomain': ['.gg'],
    'alpha2Code': 'GG',
    'alpha3Code': 'GGY',
    'callingCodes': ['44'],
    'capital': 'St. Peter Port',
    'altSpellings': ['GG', 'Bailiwick of Guernsey', 'Bailliage de Guernesey'],
    'region': 'Europe',
    'subregion': 'Northern Europe',
    'population': 65150,
    'latlng': [49.46666666, -2.58333333],
    'demonym': 'Channel Islander',
    'area': 78.0,
    'gini': null,
    'timezones': ['UTC+00:00'],
    'borders': [],
    'nativeName': 'Guernsey',
    'numericCode': '831',
    'currencies': ['GBP'],
    'languages': ['en', 'fr'],
    'translations': { 'de': 'Guernsey', 'es': 'Guernsey', 'fr': 'Guernesey', 'ja': 'ガーンジー', 'it': 'Guernsey' },
    'relevance': '0.5'
  }, {
    'name': 'Guinea',
    'topLevelDomain': ['.gn'],
    'alpha2Code': 'GN',
    'alpha3Code': 'GIN',
    'callingCodes': ['224'],
    'capital': 'Conakry',
    'altSpellings': ['GN', 'Republic of Guinea', 'République de Guinée'],
    'region': 'Africa',
    'subregion': 'Western Africa',
    'population': 10628972,
    'latlng': [11.0, -10.0],
    'demonym': 'Guinean',
    'area': 245857.0,
    'gini': 39.4,
    'timezones': ['UTC'],
    'borders': ['CIV', 'GNB', 'LBR', 'MLI', 'SEN', 'SLE'],
    'nativeName': 'Guinée',
    'numericCode': '324',
    'currencies': ['GNF'],
    'languages': ['fr', 'ff'],
    'translations': { 'de': 'Guinea', 'es': 'Guinea', 'fr': 'Guinée', 'ja': 'ギニア', 'it': 'Guinea' },
    'relevance': '0'
  }, {
    'name': 'Guinea-Bissau',
    'topLevelDomain': ['.gw'],
    'alpha2Code': 'GW',
    'alpha3Code': 'GNB',
    'callingCodes': ['245'],
    'capital': 'Bissau',
    'altSpellings': ['GW', 'Republic of Guinea-Bissau', 'República da Guiné-Bissau'],
    'region': 'Africa',
    'subregion': 'Western Africa',
    'population': 1844000,
    'latlng': [12.0, -15.0],
    'demonym': 'Guinea-Bissauan',
    'area': 36125.0,
    'gini': 35.5,
    'timezones': ['UTC'],
    'borders': ['GIN', 'SEN'],
    'nativeName': 'Guiné-Bissau',
    'numericCode': '624',
    'currencies': ['XOF'],
    'languages': ['pt'],
    'translations': {
      'de': 'Guinea-Bissau',
      'es': 'Guinea-Bisáu',
      'fr': 'Guinée-Bissau',
      'ja': 'ギニアビサウ',
      'it': 'Guinea-Bissau'
    },
    'relevance': '0'
  }, {
    'name': 'Guyana',
    'topLevelDomain': ['.gy'],
    'alpha2Code': 'GY',
    'alpha3Code': 'GUY',
    'callingCodes': ['592'],
    'capital': 'Georgetown',
    'altSpellings': ['GY', 'Co-operative Republic of Guyana'],
    'region': 'Americas',
    'subregion': 'South America',
    'population': 746900,
    'latlng': [5.0, -59.0],
    'demonym': 'Guyanese',
    'area': 214969.0,
    'gini': 44.5,
    'timezones': ['UTC-04:00'],
    'borders': ['BRA', 'SUR', 'VEN'],
    'nativeName': 'Guyana',
    'numericCode': '328',
    'currencies': ['GYD'],
    'languages': ['en'],
    'translations': { 'de': 'Guyana', 'es': 'Guyana', 'fr': 'Guyane', 'ja': 'ガイアナ', 'it': 'Guyana' },
    'relevance': '0'
  }, {
    'name': 'Haiti',
    'topLevelDomain': ['.ht'],
    'alpha2Code': 'HT',
    'alpha3Code': 'HTI',
    'callingCodes': ['509'],
    'capital': 'Port-au-Prince',
    'altSpellings': ['HT', 'Republic of Haiti', 'République d\'Haïti', 'Repiblik Ayiti'],
    'region': 'Americas',
    'subregion': 'Caribbean',
    'population': 10911819,
    'latlng': [19.0, -72.41666666],
    'demonym': 'Haitian',
    'area': 27750.0,
    'gini': 59.2,
    'timezones': ['UTC-05:00'],
    'borders': ['DOM'],
    'nativeName': 'Haïti',
    'numericCode': '332',
    'currencies': ['HTG', 'USD'],
    'languages': ['fr', 'ht'],
    'translations': { 'de': 'Haiti', 'es': 'Haiti', 'fr': 'Haïti', 'ja': 'ハイチ', 'it': 'Haiti' },
    'relevance': '0'
  }, {
    'name': 'Heard Island and McDonald Islands',
    'topLevelDomain': ['.hm', '.aq'],
    'alpha2Code': 'HM',
    'alpha3Code': 'HMD',
    'callingCodes': [''],
    'capital': '',
    'altSpellings': ['HM'],
    'region': '',
    'subregion': '',
    'population': 0,
    'latlng': [-53.1, 72.51666666],
    'demonym': 'Heard and McDonald Islander',
    'area': 412.0,
    'gini': null,
    'timezones': ['UTC+05:00'],
    'borders': [],
    'nativeName': 'Heard Island and McDonald Islands',
    'numericCode': '334',
    'currencies': ['AUD'],
    'languages': ['en'],
    'translations': {
      'de': 'Heard und die McDonaldinseln',
      'es': 'Islas Heard y McDonald',
      'fr': 'Îles Heard-et-MacDonald',
      'ja': 'ハード島とマクドナルド諸島',
      'it': 'Isole Heard e McDonald'
    },
    'relevance': '0'
  }, {
    'name': 'Holy See',
    'topLevelDomain': ['.va'],
    'alpha2Code': 'VA',
    'alpha3Code': 'VAT',
    'callingCodes': ['379'],
    'capital': 'Rome',
    'altSpellings': ['Sancta Sedes', 'Vatican', 'The Vatican'],
    'region': 'Europe',
    'subregion': 'Southern Europe',
    'population': 451,
    'latlng': [41.9, 12.45],
    'demonym': '',
    'area': 0.44,
    'gini': null,
    'timezones': ['UTC+01:00'],
    'borders': ['ITA'],
    'nativeName': 'Sancta Sedes',
    'numericCode': null,
    'currencies': ['EUR'],
    'languages': ['la', 'it', 'fr', 'de'],
    'translations': { 'de': 'Heiliger Stuhl', 'es': 'Santa Sede', 'fr': 'voir Saint', 'ja': '聖座', 'it': 'Santa Sede' },
    'relevance': null
  }, {
    'name': 'Honduras',
    'topLevelDomain': ['.hn'],
    'alpha2Code': 'HN',
    'alpha3Code': 'HND',
    'callingCodes': ['504'],
    'capital': 'Tegucigalpa',
    'altSpellings': ['HN', 'Republic of Honduras', 'República de Honduras'],
    'region': 'Americas',
    'subregion': 'Central America',
    'population': 8725111,
    'latlng': [15.0, -86.5],
    'demonym': 'Honduran',
    'area': 112492.0,
    'gini': 57.0,
    'timezones': ['UTC-06:00'],
    'borders': ['GTM', 'SLV', 'NIC'],
    'nativeName': 'Honduras',
    'numericCode': '340',
    'currencies': ['HNL'],
    'languages': ['es'],
    'translations': { 'de': 'Honduras', 'es': 'Honduras', 'fr': 'Honduras', 'ja': 'ホンジュラス', 'it': 'Honduras' },
    'relevance': '0'
  }, {
    'name': 'Hong Kong',
    'topLevelDomain': ['.hk'],
    'alpha2Code': 'HK',
    'alpha3Code': 'HKG',
    'callingCodes': ['852'],
    'capital': 'City of Victoria',
    'altSpellings': ['HK', '香港'],
    'region': 'Asia',
    'subregion': 'Eastern Asia',
    'population': 7298600,
    'latlng': [22.25, 114.16666666],
    'demonym': 'Chinese',
    'area': 1104.0,
    'gini': 53.3,
    'timezones': ['UTC+08:00'],
    'borders': ['CHN'],
    'nativeName': '香港',
    'numericCode': '344',
    'currencies': ['HKD'],
    'languages': ['en', 'zh'],
    'translations': { 'de': 'Hong Kong', 'es': 'Hong Kong', 'fr': 'Hong Kong', 'ja': '香港', 'it': 'Hong Kong' },
    'relevance': '0'
  }, {
    'name': 'Hungary',
    'topLevelDomain': ['.hu'],
    'alpha2Code': 'HU',
    'alpha3Code': 'HUN',
    'callingCodes': ['36'],
    'capital': 'Budapest',
    'altSpellings': ['HU'],
    'region': 'Europe',
    'subregion': 'Eastern Europe',
    'population': 9849000,
    'latlng': [47.0, 20.0],
    'demonym': 'Hungarian',
    'area': 93028.0,
    'gini': 31.2,
    'timezones': ['UTC+01:00'],
    'borders': ['AUT', 'HRV', 'ROU', 'SRB', 'SVK', 'SVN', 'UKR'],
    'nativeName': 'Magyarország',
    'numericCode': '348',
    'currencies': ['HUF'],
    'languages': ['hu'],
    'translations': { 'de': 'Ungarn', 'es': 'Hungría', 'fr': 'Hongrie', 'ja': 'ハンガリー', 'it': 'Ungheria' },
    'relevance': '0'
  }, {
    'name': 'Iceland',
    'topLevelDomain': ['.is'],
    'alpha2Code': 'IS',
    'alpha3Code': 'ISL',
    'callingCodes': ['354'],
    'capital': 'Reykjavík',
    'altSpellings': ['IS', 'Island', 'Republic of Iceland', 'Lýðveldið Ísland'],
    'region': 'Europe',
    'subregion': 'Northern Europe',
    'population': 330610,
    'latlng': [65.0, -18.0],
    'demonym': 'Icelander',
    'area': 103000.0,
    'gini': null,
    'timezones': ['UTC'],
    'borders': [],
    'nativeName': 'Ísland',
    'numericCode': '352',
    'currencies': ['ISK'],
    'languages': ['is'],
    'translations': { 'de': 'Island', 'es': 'Islandia', 'fr': 'Islande', 'ja': 'アイスランド', 'it': 'Islanda' },
    'relevance': '0'
  }, {
    'name': 'India',
    'topLevelDomain': ['.in'],
    'alpha2Code': 'IN',
    'alpha3Code': 'IND',
    'callingCodes': ['91'],
    'capital': 'New Delhi',
    'altSpellings': ['IN', 'Bhārat', 'Republic of India', 'Bharat Ganrajya'],
    'region': 'Asia',
    'subregion': 'Southern Asia',
    'population': 1275840000,
    'latlng': [20.0, 77.0],
    'demonym': 'Indian',
    'area': 3287590.0,
    'gini': 33.4,
    'timezones': ['UTC+05:30'],
    'borders': ['AFG', 'BGD', 'BTN', 'MMR', 'CHN', 'NPL', 'PAK', 'LKA'],
    'nativeName': 'भारत',
    'numericCode': '356',
    'currencies': ['INR'],
    'languages': ['hi', 'en'],
    'translations': { 'de': 'Indien', 'es': 'India', 'fr': 'Inde', 'ja': 'インド', 'it': 'India' },
    'relevance': '3'
  }, {
    'name': 'Indonesia',
    'topLevelDomain': ['.id'],
    'alpha2Code': 'ID',
    'alpha3Code': 'IDN',
    'callingCodes': ['62'],
    'capital': 'Jakarta',
    'altSpellings': ['ID', 'Republic of Indonesia', 'Republik Indonesia'],
    'region': 'Asia',
    'subregion': 'South-Eastern Asia',
    'population': 255461700,
    'latlng': [-5.0, 120.0],
    'demonym': 'Indonesian',
    'area': 1904569.0,
    'gini': 34.0,
    'timezones': ['UTC+07:00', 'UTC+08:00', 'UTC+09:00'],
    'borders': ['TLS', 'MYS', 'PNG'],
    'nativeName': 'Indonesia',
    'numericCode': '360',
    'currencies': ['IDR'],
    'languages': ['id'],
    'translations': { 'de': 'Indonesien', 'es': 'Indonesia', 'fr': 'Indonésie', 'ja': 'インドネシア', 'it': 'Indonesia' },
    'relevance': '2'
  }, {
    'name': 'Ivory Coast',
    'topLevelDomain': ['.ci'],
    'alpha2Code': 'CI',
    'alpha3Code': 'CIV',
    'callingCodes': ['225'],
    'capital': 'Yamoussoukro',
    'altSpellings': ['CI', 'Ivory Coast', 'Republic of Côte d\'Ivoire', 'République de Côte d\'Ivoire'],
    'region': 'Africa',
    'subregion': 'Western Africa',
    'population': 22671331,
    'latlng': [8.0, -5.0],
    'demonym': 'Ivorian',
    'area': 322463.0,
    'gini': 41.5,
    'timezones': ['UTC'],
    'borders': ['BFA', 'GHA', 'GIN', 'LBR', 'MLI'],
    'nativeName': 'Côte d\'Ivoire',
    'numericCode': '384',
    'currencies': ['XOF'],
    'languages': ['fr'],
    'translations': {
      'de': 'Elfenbeinküste',
      'es': 'Costa de Marfil',
      'fr': 'Côte d\'Ivoire',
      'ja': 'コートジボワール',
      'it': 'Costa D\'Avorio'
    },
    'relevance': '0'
  }, {
    'name': 'Iran',
    'topLevelDomain': ['.ir'],
    'alpha2Code': 'IR',
    'alpha3Code': 'IRN',
    'callingCodes': ['98'],
    'capital': 'Tehran',
    'altSpellings': ['IR', 'Islamic Republic of Iran', 'Jomhuri-ye Eslāmi-ye Irān'],
    'region': 'Asia',
    'subregion': 'Southern Asia',
    'population': 78572500,
    'latlng': [32.0, 53.0],
    'demonym': 'Iranian',
    'area': 1648195.0,
    'gini': 38.3,
    'timezones': ['UTC+03:30'],
    'borders': ['AFG', 'ARM', 'AZE', 'IRQ', 'PAK', 'TUR', 'TKM'],
    'nativeName': 'ایران',
    'numericCode': '364',
    'currencies': ['IRR'],
    'languages': ['fa'],
    'translations': { 'de': 'Iran', 'es': 'Iran', 'fr': 'Iran', 'ja': 'イラン・イスラム共和国', 'it': null },
    'relevance': '0'
  }, {
    'name': 'Iraq',
    'topLevelDomain': ['.iq'],
    'alpha2Code': 'IQ',
    'alpha3Code': 'IRQ',
    'callingCodes': ['964'],
    'capital': 'Baghdad',
    'altSpellings': ['IQ', 'Republic of Iraq', 'Jumhūriyyat al-‘Irāq'],
    'region': 'Asia',
    'subregion': 'Western Asia',
    'population': 36004552,
    'latlng': [33.0, 44.0],
    'demonym': 'Iraqi',
    'area': 438317.0,
    'gini': 30.9,
    'timezones': ['UTC+03:00'],
    'borders': ['IRN', 'JOR', 'KWT', 'SAU', 'SYR', 'TUR'],
    'nativeName': 'العراق',
    'numericCode': '368',
    'currencies': ['IQD'],
    'languages': ['ar', 'ku'],
    'translations': { 'de': 'Irak', 'es': 'Irak', 'fr': 'Irak', 'ja': 'イラク', 'it': 'Iraq' },
    'relevance': '0'
  }, {
    'name': 'Republic of Ireland',
    'topLevelDomain': ['.ie'],
    'alpha2Code': 'IE',
    'alpha3Code': 'IRL',
    'callingCodes': ['353'],
    'capital': 'Dublin',
    'altSpellings': ['IE', 'Éire', 'Republic of Ireland', 'Poblacht na hÉireann'],
    'region': 'Europe',
    'subregion': 'Northern Europe',
    'population': 6378000,
    'latlng': [53.0, -8.0],
    'demonym': 'Irish',
    'area': 70273.0,
    'gini': 34.3,
    'timezones': ['UTC'],
    'borders': ['GBR'],
    'nativeName': 'Éire',
    'numericCode': '372',
    'currencies': ['EUR'],
    'languages': ['ga', 'en'],
    'translations': { 'de': 'Irland', 'es': 'Irlanda', 'fr': 'Irlande', 'ja': 'アイルランド', 'it': 'Irlanda' },
    'relevance': '1.2'
  }, {
    'name': 'Isle of Man',
    'topLevelDomain': ['.im'],
    'alpha2Code': 'IM',
    'alpha3Code': 'IMN',
    'callingCodes': ['44'],
    'capital': 'Douglas',
    'altSpellings': ['IM', 'Ellan Vannin', 'Mann', 'Mannin'],
    'region': 'Europe',
    'subregion': 'Northern Europe',
    'population': 84497,
    'latlng': [54.25, -4.5],
    'demonym': 'Manx',
    'area': 572.0,
    'gini': null,
    'timezones': ['UTC+00:00'],
    'borders': [],
    'nativeName': 'Isle of Man',
    'numericCode': '833',
    'currencies': ['GBP'],
    'languages': ['en', 'gv'],
    'translations': { 'de': 'Insel Man', 'es': 'Isla de Man', 'fr': 'Île de Man', 'ja': 'マン島', 'it': 'Isola di Man' },
    'relevance': '0.5'
  }, {
    'name': 'Israel',
    'topLevelDomain': ['.il'],
    'alpha2Code': 'IL',
    'alpha3Code': 'ISR',
    'callingCodes': ['972'],
    'capital': 'Jerusalem',
    'altSpellings': ['IL', 'State of Israel', 'Medīnat Yisrā\'el'],
    'region': 'Asia',
    'subregion': 'Western Asia',
    'population': 8371600,
    'latlng': [31.5, 34.75],
    'demonym': 'Israeli',
    'area': 20770.0,
    'gini': 39.2,
    'timezones': ['UTC+02:00'],
    'borders': ['EGY', 'JOR', 'LBN', 'SYR'],
    'nativeName': 'יִשְׂרָאֵל',
    'numericCode': '376',
    'currencies': ['ILS'],
    'languages': ['he', 'ar'],
    'translations': { 'de': 'Israel', 'es': 'Israel', 'fr': 'Israël', 'ja': 'イスラエル', 'it': 'Israele' },
    'relevance': '0'
  }, {
    'name': 'Italy',
    'topLevelDomain': ['.it'],
    'alpha2Code': 'IT',
    'alpha3Code': 'ITA',
    'callingCodes': ['39'],
    'capital': 'Rome',
    'altSpellings': ['IT', 'Italian Republic', 'Repubblica italiana'],
    'region': 'Europe',
    'subregion': 'Southern Europe',
    'population': 60753794,
    'latlng': [42.83333333, 12.83333333],
    'demonym': 'Italian',
    'area': 301336.0,
    'gini': 36.0,
    'timezones': ['UTC+01:00'],
    'borders': ['AUT', 'FRA', 'SMR', 'SVN', 'CHE', 'VAT'],
    'nativeName': 'Italia',
    'numericCode': '380',
    'currencies': ['EUR'],
    'languages': ['it'],
    'translations': { 'de': 'Italien', 'es': 'Italia', 'fr': 'Italie', 'ja': 'イタリア', 'it': 'Italia' },
    'relevance': '2'
  }, {
    'name': 'Jamaica',
    'topLevelDomain': ['.jm'],
    'alpha2Code': 'JM',
    'alpha3Code': 'JAM',
    'callingCodes': ['1876'],
    'capital': 'Kingston',
    'altSpellings': ['JM'],
    'region': 'Americas',
    'subregion': 'Caribbean',
    'population': 2717991,
    'latlng': [18.25, -77.5],
    'demonym': 'Jamaican',
    'area': 10991.0,
    'gini': 45.5,
    'timezones': ['UTC-05:00'],
    'borders': [],
    'nativeName': 'Jamaica',
    'numericCode': '388',
    'currencies': ['JMD'],
    'languages': ['en'],
    'translations': { 'de': 'Jamaika', 'es': 'Jamaica', 'fr': 'Jamaïque', 'ja': 'ジャマイカ', 'it': 'Giamaica' },
    'relevance': '0'
  }, {
    'name': 'Japan',
    'topLevelDomain': ['.jp'],
    'alpha2Code': 'JP',
    'alpha3Code': 'JPN',
    'callingCodes': ['81'],
    'capital': 'Tokyo',
    'altSpellings': ['JP', 'Nippon', 'Nihon'],
    'region': 'Asia',
    'subregion': 'Eastern Asia',
    'population': 126865000,
    'latlng': [36.0, 138.0],
    'demonym': 'Japanese',
    'area': 377930.0,
    'gini': 38.1,
    'timezones': ['UTC+09:00'],
    'borders': [],
    'nativeName': '日本',
    'numericCode': '392',
    'currencies': ['JPY'],
    'languages': ['ja'],
    'translations': { 'de': 'Japan', 'es': 'Japón', 'fr': 'Japon', 'ja': '日本', 'it': 'Giappone' },
    'relevance': '2.5'
  }, {
    'name': 'Jersey',
    'topLevelDomain': ['.je'],
    'alpha2Code': 'JE',
    'alpha3Code': 'JEY',
    'callingCodes': ['44'],
    'capital': 'Saint Helier',
    'altSpellings': ['JE', 'Bailiwick of Jersey', 'Bailliage de Jersey', 'Bailliage dé Jèrri'],
    'region': 'Europe',
    'subregion': 'Northern Europe',
    'population': 99000,
    'latlng': [49.25, -2.16666666],
    'demonym': 'Channel Islander',
    'area': 116.0,
    'gini': null,
    'timezones': ['UTC+01:00'],
    'borders': [],
    'nativeName': 'Jersey',
    'numericCode': '832',
    'currencies': ['GBP'],
    'languages': ['en', 'fr'],
    'translations': { 'de': 'Jersey', 'es': 'Jersey', 'fr': 'Jersey', 'ja': 'ジャージー', 'it': 'Isola di Jersey' },
    'relevance': '0.5'
  }, {
    'name': 'Jordan',
    'topLevelDomain': ['.jo'],
    'alpha2Code': 'JO',
    'alpha3Code': 'JOR',
    'callingCodes': ['962'],
    'capital': 'Amman',
    'altSpellings': ['JO', 'Hashemite Kingdom of Jordan', 'al-Mamlakah al-Urdunīyah al-Hāshimīyah'],
    'region': 'Asia',
    'subregion': 'Western Asia',
    'population': 6767600,
    'latlng': [31.0, 36.0],
    'demonym': 'Jordanian',
    'area': 89342.0,
    'gini': 35.4,
    'timezones': ['UTC+03:00'],
    'borders': ['IRQ', 'ISR', 'SAU', 'SYR'],
    'nativeName': 'الأردن',
    'numericCode': '400',
    'currencies': ['JOD'],
    'languages': ['ar'],
    'translations': { 'de': 'Jordanien', 'es': 'Jordania', 'fr': 'Jordanie', 'ja': 'ヨルダン', 'it': 'Giordania' },
    'relevance': '0'
  }, {
    'name': 'Kazakhstan',
    'topLevelDomain': ['.kz', '.қаз'],
    'alpha2Code': 'KZ',
    'alpha3Code': 'KAZ',
    'callingCodes': ['76', '77'],
    'capital': 'Astana',
    'altSpellings': ['KZ', 'Qazaqstan', 'Казахстан', 'Republic of Kazakhstan', 'Қазақстан Республикасы', 'Qazaqstan Respublïkası', 'Республика Казахстан', 'Respublika Kazakhstan'],
    'region': 'Asia',
    'subregion': 'Central Asia',
    'population': 17541200,
    'latlng': [48.0, 68.0],
    'demonym': 'Kazakhstani',
    'area': 2724900.0,
    'gini': 29.0,
    'timezones': ['UTC+05:00', 'UTC+06:00'],
    'borders': ['CHN', 'KGZ', 'RUS', 'TKM', 'UZB'],
    'nativeName': 'Қазақстан',
    'numericCode': '398',
    'currencies': ['KZT'],
    'languages': ['kk', 'ru'],
    'translations': { 'de': 'Kasachstan', 'es': 'Kazajistán', 'fr': 'Kazakhstan', 'ja': 'カザフスタン', 'it': 'Kazakistan' },
    'relevance': '0'
  }, {
    'name': 'Kenya',
    'topLevelDomain': ['.ke'],
    'alpha2Code': 'KE',
    'alpha3Code': 'KEN',
    'callingCodes': ['254'],
    'capital': 'Nairobi',
    'altSpellings': ['KE', 'Republic of Kenya', 'Jamhuri ya Kenya'],
    'region': 'Africa',
    'subregion': 'Eastern Africa',
    'population': 46050000,
    'latlng': [1.0, 38.0],
    'demonym': 'Kenyan',
    'area': 580367.0,
    'gini': 47.7,
    'timezones': ['UTC+03:00'],
    'borders': ['ETH', 'SOM', 'SSD', 'TZA', 'UGA'],
    'nativeName': 'Kenya',
    'numericCode': '404',
    'currencies': ['KES'],
    'languages': ['en', 'sw'],
    'translations': { 'de': 'Kenia', 'es': 'Kenia', 'fr': 'Kenya', 'ja': 'ケニア', 'it': 'Kenya' },
    'relevance': '0'
  }, {
    'name': 'Kiribati',
    'topLevelDomain': ['.ki'],
    'alpha2Code': 'KI',
    'alpha3Code': 'KIR',
    'callingCodes': ['686'],
    'capital': 'South Tarawa',
    'altSpellings': ['KI', 'Republic of Kiribati', 'Ribaberiki Kiribati'],
    'region': 'Oceania',
    'subregion': 'Micronesia',
    'population': 106461,
    'latlng': [1.41666666, 173.0],
    'demonym': 'I-Kiribati',
    'area': 811.0,
    'gini': null,
    'timezones': ['UTC+12:00', 'UTC+13:00', 'UTC+14:00'],
    'borders': [],
    'nativeName': 'Kiribati',
    'numericCode': '296',
    'currencies': ['AUD'],
    'languages': ['en'],
    'translations': { 'de': 'Kiribati', 'es': 'Kiribati', 'fr': 'Kiribati', 'ja': 'キリバス', 'it': 'Kiribati' },
    'relevance': '0'
  }, {
    'name': 'Kuwait',
    'topLevelDomain': ['.kw'],
    'alpha2Code': 'KW',
    'alpha3Code': 'KWT',
    'callingCodes': ['965'],
    'capital': 'Kuwait City',
    'altSpellings': ['KW', 'State of Kuwait', 'Dawlat al-Kuwait'],
    'region': 'Asia',
    'subregion': 'Western Asia',
    'population': 3268431,
    'latlng': [29.5, 45.75],
    'demonym': 'Kuwaiti',
    'area': 17818.0,
    'gini': null,
    'timezones': ['UTC+03:00'],
    'borders': ['IRN', 'SAU'],
    'nativeName': 'الكويت',
    'numericCode': '414',
    'currencies': ['KWD'],
    'languages': ['ar'],
    'translations': { 'de': 'Kuwait', 'es': 'Kuwait', 'fr': 'Koweït', 'ja': 'クウェート', 'it': 'Kuwait' },
    'relevance': '0'
  }, {
    'name': 'Kyrgyzstan',
    'topLevelDomain': ['.kg'],
    'alpha2Code': 'KG',
    'alpha3Code': 'KGZ',
    'callingCodes': ['996'],
    'capital': 'Bishkek',
    'altSpellings': ['KG', 'Киргизия', 'Kyrgyz Republic', 'Кыргыз Республикасы', 'Kyrgyz Respublikasy'],
    'region': 'Asia',
    'subregion': 'Central Asia',
    'population': 5944400,
    'latlng': [41.0, 75.0],
    'demonym': 'Kirghiz',
    'area': 199951.0,
    'gini': 36.2,
    'timezones': ['UTC+06:00'],
    'borders': ['CHN', 'KAZ', 'TJK', 'UZB'],
    'nativeName': 'Кыргызстан',
    'numericCode': '417',
    'currencies': ['KGS'],
    'languages': ['ky', 'ru'],
    'translations': { 'de': 'Kirgisistan', 'es': 'Kirguizistán', 'fr': 'Kirghizistan', 'ja': 'キルギス', 'it': 'Kirghizistan' },
    'relevance': '0'
  }, {
    'name': 'Laos',
    'topLevelDomain': ['.la'],
    'alpha2Code': 'LA',
    'alpha3Code': 'LAO',
    'callingCodes': ['856'],
    'capital': 'Vientiane',
    'altSpellings': ['LA', 'Lao', 'Lao People\'s Democratic Republic', 'Sathalanalat Paxathipatai Paxaxon Lao'],
    'region': 'Asia',
    'subregion': 'South-Eastern Asia',
    'population': 6802000,
    'latlng': [18.0, 105.0],
    'demonym': 'Laotian',
    'area': 236800.0,
    'gini': 36.7,
    'timezones': ['UTC+07:00'],
    'borders': ['MMR', 'KHM', 'CHN', 'THA', 'VNM'],
    'nativeName': 'ສປປລາວ',
    'numericCode': '418',
    'currencies': ['LAK'],
    'languages': ['lo'],
    'translations': { 'de': 'Laos', 'es': 'Laos', 'fr': 'Laos', 'ja': 'ラオス人民民主共和国', 'it': 'Laos' },
    'relevance': '0'
  }, {
    'name': 'Latvia',
    'topLevelDomain': ['.lv'],
    'alpha2Code': 'LV',
    'alpha3Code': 'LVA',
    'callingCodes': ['371'],
    'capital': 'Riga',
    'altSpellings': ['LV', 'Republic of Latvia', 'Latvijas Republika'],
    'region': 'Europe',
    'subregion': 'Northern Europe',
    'population': 1980700,
    'latlng': [57.0, 25.0],
    'demonym': 'Latvian',
    'area': 64559.0,
    'gini': 36.6,
    'timezones': ['UTC+02:00'],
    'borders': ['BLR', 'EST', 'LTU', 'RUS'],
    'nativeName': 'Latvija',
    'numericCode': '428',
    'currencies': ['EUR'],
    'languages': ['lv'],
    'translations': { 'de': 'Lettland', 'es': 'Letonia', 'fr': 'Lettonie', 'ja': 'ラトビア', 'it': 'Lettonia' },
    'relevance': '0'
  }, {
    'name': 'Lebanon',
    'topLevelDomain': ['.lb'],
    'alpha2Code': 'LB',
    'alpha3Code': 'LBN',
    'callingCodes': ['961'],
    'capital': 'Beirut',
    'altSpellings': ['LB', 'Lebanese Republic', 'Al-Jumhūrīyah Al-Libnānīyah'],
    'region': 'Asia',
    'subregion': 'Western Asia',
    'population': 4104000,
    'latlng': [33.83333333, 35.83333333],
    'demonym': 'Lebanese',
    'area': 10452.0,
    'gini': null,
    'timezones': ['UTC+02:00'],
    'borders': ['ISR', 'SYR'],
    'nativeName': 'لبنان',
    'numericCode': '422',
    'currencies': ['LBP'],
    'languages': ['ar', 'fr'],
    'translations': { 'de': 'Libanon', 'es': 'Líbano', 'fr': 'Liban', 'ja': 'レバノン', 'it': 'Libano' },
    'relevance': '0'
  }, {
    'name': 'Lesotho',
    'topLevelDomain': ['.ls'],
    'alpha2Code': 'LS',
    'alpha3Code': 'LSO',
    'callingCodes': ['266'],
    'capital': 'Maseru',
    'altSpellings': ['LS', 'Kingdom of Lesotho', 'Muso oa Lesotho'],
    'region': 'Africa',
    'subregion': 'Southern Africa',
    'population': 2135000,
    'latlng': [-29.5, 28.5],
    'demonym': 'Mosotho',
    'area': 30355.0,
    'gini': 52.5,
    'timezones': ['UTC+02:00'],
    'borders': ['ZAF'],
    'nativeName': 'Lesotho',
    'numericCode': '426',
    'currencies': ['LSL', 'ZAR'],
    'languages': ['en', 'st'],
    'translations': { 'de': 'Lesotho', 'es': 'Lesotho', 'fr': 'Lesotho', 'ja': 'レソト', 'it': 'Lesotho' },
    'relevance': '0'
  }, {
    'name': 'Liberia',
    'topLevelDomain': ['.lr'],
    'alpha2Code': 'LR',
    'alpha3Code': 'LBR',
    'callingCodes': ['231'],
    'capital': 'Monrovia',
    'altSpellings': ['LR', 'Republic of Liberia'],
    'region': 'Africa',
    'subregion': 'Western Africa',
    'population': 4503000,
    'latlng': [6.5, -9.5],
    'demonym': 'Liberian',
    'area': 111369.0,
    'gini': 38.2,
    'timezones': ['UTC'],
    'borders': ['GIN', 'CIV', 'SLE'],
    'nativeName': 'Liberia',
    'numericCode': '430',
    'currencies': ['LRD'],
    'languages': ['en'],
    'translations': { 'de': 'Liberia', 'es': 'Liberia', 'fr': 'Liberia', 'ja': 'リベリア', 'it': 'Liberia' },
    'relevance': '0'
  }, {
    'name': 'Libya',
    'topLevelDomain': ['.ly'],
    'alpha2Code': 'LY',
    'alpha3Code': 'LBY',
    'callingCodes': ['218'],
    'capital': 'Tripoli',
    'altSpellings': ['LY', 'State of Libya', 'Dawlat Libya'],
    'region': 'Africa',
    'subregion': 'Northern Africa',
    'population': 6278000,
    'latlng': [25.0, 17.0],
    'demonym': 'Libyan',
    'area': 1759540.0,
    'gini': null,
    'timezones': ['UTC+01:00'],
    'borders': ['DZA', 'TCD', 'EGY', 'NER', 'SDN', 'TUN'],
    'nativeName': '‏ليبيا',
    'numericCode': '434',
    'currencies': ['LYD'],
    'languages': ['ar'],
    'translations': { 'de': 'Libyen', 'es': 'Libia', 'fr': 'Libye', 'ja': 'リビア', 'it': 'Libia' },
    'relevance': '0'
  }, {
    'name': 'Liechtenstein',
    'topLevelDomain': ['.li'],
    'alpha2Code': 'LI',
    'alpha3Code': 'LIE',
    'callingCodes': ['423'],
    'capital': 'Vaduz',
    'altSpellings': ['LI', 'Principality of Liechtenstein', 'Fürstentum Liechtenstein'],
    'region': 'Europe',
    'subregion': 'Western Europe',
    'population': 37370,
    'latlng': [47.26666666, 9.53333333],
    'demonym': 'Liechtensteiner',
    'area': 160.0,
    'gini': null,
    'timezones': ['UTC+01:00'],
    'borders': ['AUT', 'CHE'],
    'nativeName': 'Liechtenstein',
    'numericCode': '438',
    'currencies': ['CHF'],
    'languages': ['de'],
    'translations': {
      'de': 'Liechtenstein',
      'es': 'Liechtenstein',
      'fr': 'Liechtenstein',
      'ja': 'リヒテンシュタイン',
      'it': 'Liechtenstein'
    },
    'relevance': '0'
  }, {
    'name': 'Lithuania',
    'topLevelDomain': ['.lt'],
    'alpha2Code': 'LT',
    'alpha3Code': 'LTU',
    'callingCodes': ['370'],
    'capital': 'Vilnius',
    'altSpellings': ['LT', 'Republic of Lithuania', 'Lietuvos Respublika'],
    'region': 'Europe',
    'subregion': 'Northern Europe',
    'population': 2900787,
    'latlng': [56.0, 24.0],
    'demonym': 'Lithuanian',
    'area': 65300.0,
    'gini': 37.6,
    'timezones': ['UTC+02:00'],
    'borders': ['BLR', 'LVA', 'POL', 'RUS'],
    'nativeName': 'Lietuva',
    'numericCode': '440',
    'currencies': ['EUR'],
    'languages': ['lt'],
    'translations': { 'de': 'Litauen', 'es': 'Lituania', 'fr': 'Lituanie', 'ja': 'リトアニア', 'it': 'Lituania' },
    'relevance': '0'
  }, {
    'name': 'Luxembourg',
    'topLevelDomain': ['.lu'],
    'alpha2Code': 'LU',
    'alpha3Code': 'LUX',
    'callingCodes': ['352'],
    'capital': 'Luxembourg',
    'altSpellings': ['LU', 'Grand Duchy of Luxembourg', 'Grand-Duché de Luxembourg', 'Großherzogtum Luxemburg', 'Groussherzogtum Lëtzebuerg'],
    'region': 'Europe',
    'subregion': 'Western Europe',
    'population': 562958,
    'latlng': [49.75, 6.16666666],
    'demonym': 'Luxembourger',
    'area': 2586.0,
    'gini': 30.8,
    'timezones': ['UTC+01:00'],
    'borders': ['BEL', 'FRA', 'DEU'],
    'nativeName': 'Luxembourg',
    'numericCode': '442',
    'currencies': ['EUR'],
    'languages': ['fr', 'de', 'lb'],
    'translations': { 'de': 'Luxemburg', 'es': 'Luxemburgo', 'fr': 'Luxembourg', 'ja': 'ルクセンブルク', 'it': 'Lussemburgo' },
    'relevance': '0'
  }, {
    'name': 'Macau',
    'topLevelDomain': ['.mo'],
    'alpha2Code': 'MO',
    'alpha3Code': 'MAC',
    'callingCodes': ['853'],
    'capital': '',
    'altSpellings': ['MO', '澳门', 'Macao Special Administrative Region of the People\'s Republic of China', '中華人民共和國澳門特別行政區', 'Região Administrativa Especial de Macau da República Popular da China'],
    'region': 'Asia',
    'subregion': 'Eastern Asia',
    'population': 642900,
    'latlng': [22.16666666, 113.55],
    'demonym': 'Chinese',
    'area': 30.0,
    'gini': null,
    'timezones': ['UTC+08:00'],
    'borders': ['CHN'],
    'nativeName': '澳門',
    'numericCode': '446',
    'currencies': ['MOP'],
    'languages': ['zh', 'pt'],
    'translations': { 'de': 'Macao', 'es': 'Macao', 'fr': 'Macao', 'ja': 'マカオ', 'it': 'Macao' },
    'relevance': '0'
  }, {
    'name': 'Republic of Macedonia',
    'topLevelDomain': ['.mk'],
    'alpha2Code': 'MK',
    'alpha3Code': 'MKD',
    'callingCodes': ['389'],
    'capital': 'Skopje',
    'altSpellings': ['MK', 'Republic of Macedonia', 'Република Македонија'],
    'region': 'Europe',
    'subregion': 'Southern Europe',
    'population': 2058539,
    'latlng': [41.83333333, 22.0],
    'demonym': 'Macedonian',
    'area': 25713.0,
    'gini': 43.2,
    'timezones': ['UTC+01:00'],
    'borders': ['ALB', 'BGR', 'GRC', 'KOS', 'SRB'],
    'nativeName': 'Македонија',
    'numericCode': '807',
    'currencies': ['MKD'],
    'languages': ['mk'],
    'translations': {
      'de': 'Mazedonien',
      'es': 'Macedonia',
      'fr': 'Macédoine',
      'ja': 'マケドニア旧ユーゴスラビア共和国',
      'it': 'Macedonia'
    },
    'relevance': '0'
  }, {
    'name': 'Madagascar',
    'topLevelDomain': ['.mg'],
    'alpha2Code': 'MG',
    'alpha3Code': 'MDG',
    'callingCodes': ['261'],
    'capital': 'Antananarivo',
    'altSpellings': ['MG', 'Republic of Madagascar', 'Repoblikan\'i Madagasikara', 'République de Madagascar'],
    'region': 'Africa',
    'subregion': 'Eastern Africa',
    'population': 22434363,
    'latlng': [-20.0, 47.0],
    'demonym': 'Malagasy',
    'area': 587041.0,
    'gini': 44.1,
    'timezones': ['UTC+03:00'],
    'borders': [],
    'nativeName': 'Madagasikara',
    'numericCode': '450',
    'currencies': ['MGA'],
    'languages': ['fr', 'mg'],
    'translations': { 'de': 'Madagaskar', 'es': 'Madagascar', 'fr': 'Madagascar', 'ja': 'マダガスカル', 'it': 'Madagascar' },
    'relevance': '0'
  }, {
    'name': 'Malawi',
    'topLevelDomain': ['.mw'],
    'alpha2Code': 'MW',
    'alpha3Code': 'MWI',
    'callingCodes': ['265'],
    'capital': 'Lilongwe',
    'altSpellings': ['MW', 'Republic of Malawi'],
    'region': 'Africa',
    'subregion': 'Eastern Africa',
    'population': 16310431,
    'latlng': [-13.5, 34.0],
    'demonym': 'Malawian',
    'area': 118484.0,
    'gini': 39.0,
    'timezones': ['UTC+02:00'],
    'borders': ['MOZ', 'TZA', 'ZMB'],
    'nativeName': 'Malawi',
    'numericCode': '454',
    'currencies': ['MWK'],
    'languages': ['en', 'ny'],
    'translations': { 'de': 'Malawi', 'es': 'Malawi', 'fr': 'Malawi', 'ja': 'マラウイ', 'it': 'Malawi' },
    'relevance': '0'
  }, {
    'name': 'Malaysia',
    'topLevelDomain': ['.my'],
    'alpha2Code': 'MY',
    'alpha3Code': 'MYS',
    'callingCodes': ['60'],
    'capital': 'Kuala Lumpur',
    'altSpellings': ['MY'],
    'region': 'Asia',
    'subregion': 'South-Eastern Asia',
    'population': 30678800,
    'latlng': [2.5, 112.5],
    'demonym': 'Malaysian',
    'area': 330803.0,
    'gini': 46.2,
    'timezones': ['UTC+08:00'],
    'borders': ['BRN', 'IDN', 'THA'],
    'nativeName': 'Malaysia',
    'numericCode': '458',
    'currencies': ['MYR'],
    'languages': ['ms'],
    'translations': { 'de': 'Malaysia', 'es': 'Malasia', 'fr': 'Malaisie', 'ja': 'マレーシア', 'it': 'Malesia' },
    'relevance': '0'
  }, {
    'name': 'Maldives',
    'topLevelDomain': ['.mv'],
    'alpha2Code': 'MV',
    'alpha3Code': 'MDV',
    'callingCodes': ['960'],
    'capital': 'Malé',
    'altSpellings': ['MV', 'Maldive Islands', 'Republic of the Maldives', 'Dhivehi Raajjeyge Jumhooriyya'],
    'region': 'Asia',
    'subregion': 'Southern Asia',
    'population': 341256,
    'latlng': [3.25, 73.0],
    'demonym': 'Maldivan',
    'area': 300.0,
    'gini': 37.4,
    'timezones': ['UTC+05:00'],
    'borders': [],
    'nativeName': 'Maldives',
    'numericCode': '462',
    'currencies': ['MVR'],
    'languages': ['dv'],
    'translations': { 'de': 'Malediven', 'es': 'Maldivas', 'fr': 'Maldives', 'ja': 'モルディブ', 'it': 'Maldive' },
    'relevance': '0'
  }, {
    'name': 'Mali',
    'topLevelDomain': ['.ml'],
    'alpha2Code': 'ML',
    'alpha3Code': 'MLI',
    'callingCodes': ['223'],
    'capital': 'Bamako',
    'altSpellings': ['ML', 'Republic of Mali', 'République du Mali'],
    'region': 'Africa',
    'subregion': 'Western Africa',
    'population': 17600000,
    'latlng': [17.0, -4.0],
    'demonym': 'Malian',
    'area': 1240192.0,
    'gini': 33.0,
    'timezones': ['UTC'],
    'borders': ['DZA', 'BFA', 'GIN', 'CIV', 'MRT', 'NER', 'SEN'],
    'nativeName': 'Mali',
    'numericCode': '466',
    'currencies': ['XOF'],
    'languages': ['fr'],
    'translations': { 'de': 'Mali', 'es': 'Mali', 'fr': 'Mali', 'ja': 'マリ', 'it': 'Mali' },
    'relevance': '0'
  }, {
    'name': 'Malta',
    'topLevelDomain': ['.mt'],
    'alpha2Code': 'MT',
    'alpha3Code': 'MLT',
    'callingCodes': ['356'],
    'capital': 'Valletta',
    'altSpellings': ['MT', 'Republic of Malta', 'Repubblika ta\' Malta'],
    'region': 'Europe',
    'subregion': 'Southern Europe',
    'population': 445426,
    'latlng': [35.83333333, 14.58333333],
    'demonym': 'Maltese',
    'area': 316.0,
    'gini': null,
    'timezones': ['UTC+01:00'],
    'borders': [],
    'nativeName': 'Malta',
    'numericCode': '470',
    'currencies': ['EUR'],
    'languages': ['mt', 'en'],
    'translations': { 'de': 'Malta', 'es': 'Malta', 'fr': 'Malte', 'ja': 'マルタ', 'it': 'Malta' },
    'relevance': '0'
  }, {
    'name': 'Marshall Islands',
    'topLevelDomain': ['.mh'],
    'alpha2Code': 'MH',
    'alpha3Code': 'MHL',
    'callingCodes': ['692'],
    'capital': 'Majuro',
    'altSpellings': ['MH', 'Republic of the Marshall Islands', 'Aolepān Aorōkin M̧ajeļ'],
    'region': 'Oceania',
    'subregion': 'Micronesia',
    'population': 56086,
    'latlng': [9.0, 168.0],
    'demonym': 'Marshallese',
    'area': 181.0,
    'gini': null,
    'timezones': ['UTC+12:00'],
    'borders': [],
    'nativeName': 'M̧ajeļ',
    'numericCode': '584',
    'currencies': ['USD'],
    'languages': ['en', 'mh'],
    'translations': {
      'de': 'Marshallinseln',
      'es': 'Islas Marshall',
      'fr': 'Îles Marshall',
      'ja': 'マーシャル諸島',
      'it': 'Isole Marshall'
    },
    'relevance': '0.5'
  }, {
    'name': 'Martinique',
    'topLevelDomain': ['.mq'],
    'alpha2Code': 'MQ',
    'alpha3Code': 'MTQ',
    'callingCodes': ['596'],
    'capital': 'Fort-de-France',
    'altSpellings': ['MQ'],
    'region': 'Americas',
    'subregion': 'Caribbean',
    'population': 381326,
    'latlng': [14.666667, -61.0],
    'demonym': 'French',
    'area': null,
    'gini': null,
    'timezones': ['UTC-04:00'],
    'borders': [],
    'nativeName': 'Martinique',
    'numericCode': '474',
    'currencies': ['EUR'],
    'languages': ['fr'],
    'translations': { 'de': 'Martinique', 'es': 'Martinica', 'fr': 'Martinique', 'ja': 'マルティニーク', 'it': 'Martinica' },
    'relevance': '0'
  }, {
    'name': 'Mauritania',
    'topLevelDomain': ['.mr'],
    'alpha2Code': 'MR',
    'alpha3Code': 'MRT',
    'callingCodes': ['222'],
    'capital': 'Nouakchott',
    'altSpellings': ['MR', 'Islamic Republic of Mauritania', 'al-Jumhūriyyah al-ʾIslāmiyyah al-Mūrītāniyyah'],
    'region': 'Africa',
    'subregion': 'Western Africa',
    'population': 3631775,
    'latlng': [20.0, -12.0],
    'demonym': 'Mauritanian',
    'area': 1030700.0,
    'gini': 40.5,
    'timezones': ['UTC'],
    'borders': ['DZA', 'MLI', 'SEN', 'ESH'],
    'nativeName': 'موريتانيا',
    'numericCode': '478',
    'currencies': ['MRO'],
    'languages': ['ar'],
    'translations': { 'de': 'Mauretanien', 'es': 'Mauritania', 'fr': 'Mauritanie', 'ja': 'モーリタニア', 'it': 'Mauritania' },
    'relevance': '0'
  }, {
    'name': 'Mauritius',
    'topLevelDomain': ['.mu'],
    'alpha2Code': 'MU',
    'alpha3Code': 'MUS',
    'callingCodes': ['230'],
    'capital': 'Port Louis',
    'altSpellings': ['MU', 'Republic of Mauritius', 'République de Maurice'],
    'region': 'Africa',
    'subregion': 'Eastern Africa',
    'population': 1261208,
    'latlng': [-20.28333333, 57.55],
    'demonym': 'Mauritian',
    'area': 2040.0,
    'gini': null,
    'timezones': ['UTC+04:00'],
    'borders': [],
    'nativeName': 'Maurice',
    'numericCode': '480',
    'currencies': ['MUR'],
    'languages': ['en'],
    'translations': { 'de': 'Mauritius', 'es': 'Mauricio', 'fr': 'Île Maurice', 'ja': 'モーリシャス', 'it': 'Mauritius' },
    'relevance': '0'
  }, {
    'name': 'Mayotte',
    'topLevelDomain': ['.yt'],
    'alpha2Code': 'YT',
    'alpha3Code': 'MYT',
    'callingCodes': ['262'],
    'capital': 'Mamoudzou',
    'altSpellings': ['YT', 'Department of Mayotte', 'Département de Mayotte'],
    'region': 'Africa',
    'subregion': 'Eastern Africa',
    'population': 212645,
    'latlng': [-12.83333333, 45.16666666],
    'demonym': 'French',
    'area': null,
    'gini': null,
    'timezones': ['UTC+03:00'],
    'borders': [],
    'nativeName': 'Mayotte',
    'numericCode': '175',
    'currencies': ['EUR'],
    'languages': ['fr'],
    'translations': { 'de': 'Mayotte', 'es': 'Mayotte', 'fr': 'Mayotte', 'ja': 'マヨット', 'it': 'Mayotte' },
    'relevance': '0'
  }, {
    'name': 'Mexico',
    'topLevelDomain': ['.mx'],
    'alpha2Code': 'MX',
    'alpha3Code': 'MEX',
    'callingCodes': ['52'],
    'capital': 'Mexico City',
    'altSpellings': ['MX', 'Mexicanos', 'United Mexican States', 'Estados Unidos Mexicanos'],
    'region': 'Americas',
    'subregion': 'Central America',
    'population': 121740000,
    'latlng': [23.0, -102.0],
    'demonym': 'Mexican',
    'area': 1964375.0,
    'gini': 47.0,
    'timezones': ['UTC-08:00', 'UTC-07:00', 'UTC-06:00'],
    'borders': ['BLZ', 'GTM', 'USA'],
    'nativeName': 'México',
    'numericCode': '484',
    'currencies': ['MXN'],
    'languages': ['es'],
    'translations': { 'de': 'Mexiko', 'es': 'México', 'fr': 'Mexique', 'ja': 'メキシコ', 'it': 'Messico' },
    'relevance': '1.5'
  }, {
    'name': 'Federated States of Micronesia',
    'topLevelDomain': ['.fm'],
    'alpha2Code': 'FM',
    'alpha3Code': 'FSM',
    'callingCodes': ['691'],
    'capital': 'Palikir',
    'altSpellings': ['FM', 'Federated States of Micronesia'],
    'region': 'Oceania',
    'subregion': 'Micronesia',
    'population': 101351,
    'latlng': [6.91666666, 158.25],
    'demonym': 'Micronesian',
    'area': 702.0,
    'gini': null,
    'timezones': ['UTC+10:00', 'UTC+11'],
    'borders': [],
    'nativeName': 'Micronesia',
    'numericCode': '583',
    'currencies': ['USD'],
    'languages': ['en'],
    'translations': { 'de': 'Mikronesien', 'es': 'Micronesia', 'fr': 'Micronésie', 'ja': 'ミクロネシア連邦', 'it': 'Micronesia' },
    'relevance': '0'
  }, {
    'name': 'Moldova',
    'topLevelDomain': ['.md'],
    'alpha2Code': 'MD',
    'alpha3Code': 'MDA',
    'callingCodes': ['373'],
    'capital': 'Chișinău',
    'altSpellings': ['MD', 'Republic of Moldova', 'Republica Moldova'],
    'region': 'Europe',
    'subregion': 'Eastern Europe',
    'population': 3555200,
    'latlng': [47.0, 29.0],
    'demonym': 'Moldovan',
    'area': 33846.0,
    'gini': 33.0,
    'timezones': ['UTC+02:00'],
    'borders': ['ROU', 'UKR'],
    'nativeName': 'Moldova',
    'numericCode': '498',
    'currencies': ['MDL'],
    'languages': ['ro'],
    'translations': { 'de': 'Moldawie', 'es': 'Moldavia', 'fr': 'Moldavie', 'ja': 'モルドバ共和国', 'it': 'Moldavia' },
    'relevance': '0'
  }, {
    'name': 'Monaco',
    'topLevelDomain': ['.mc'],
    'alpha2Code': 'MC',
    'alpha3Code': 'MCO',
    'callingCodes': ['377'],
    'capital': 'Monaco',
    'altSpellings': ['MC', 'Principality of Monaco', 'Principauté de Monaco'],
    'region': 'Europe',
    'subregion': 'Western Europe',
    'population': 37800,
    'latlng': [43.73333333, 7.4],
    'demonym': 'Monegasque',
    'area': 2.02,
    'gini': null,
    'timezones': ['UTC+01:00'],
    'borders': ['FRA'],
    'nativeName': 'Monaco',
    'numericCode': '492',
    'currencies': ['EUR'],
    'languages': ['fr'],
    'translations': { 'de': 'Monaco', 'es': 'Mónaco', 'fr': 'Monaco', 'ja': 'モナコ', 'it': 'Principato di Monaco' },
    'relevance': '0'
  }, {
    'name': 'Mongolia',
    'topLevelDomain': ['.mn'],
    'alpha2Code': 'MN',
    'alpha3Code': 'MNG',
    'callingCodes': ['976'],
    'capital': 'Ulan Bator',
    'altSpellings': ['MN'],
    'region': 'Asia',
    'subregion': 'Eastern Asia',
    'population': 3031099,
    'latlng': [46.0, 105.0],
    'demonym': 'Mongolian',
    'area': 1564110.0,
    'gini': 36.5,
    'timezones': ['UTC+07:00', 'UTC+08:00'],
    'borders': ['CHN', 'RUS'],
    'nativeName': 'Монгол улс',
    'numericCode': '496',
    'currencies': ['MNT'],
    'languages': ['mn'],
    'translations': { 'de': 'Mongolei', 'es': 'Mongolia', 'fr': 'Mongolie', 'ja': 'モンゴル', 'it': 'Mongolia' },
    'relevance': '0'
  }, {
    'name': 'Montenegro',
    'topLevelDomain': ['.me'],
    'alpha2Code': 'ME',
    'alpha3Code': 'MNE',
    'callingCodes': ['382'],
    'capital': 'Podgorica',
    'altSpellings': ['ME', 'Crna Gora'],
    'region': 'Europe',
    'subregion': 'Southern Europe',
    'population': 621207,
    'latlng': [42.5, 19.3],
    'demonym': 'Montenegrin',
    'area': 13812.0,
    'gini': 30.0,
    'timezones': ['UTC+01:00'],
    'borders': ['ALB', 'BIH', 'HRV', 'KOS', 'SRB'],
    'nativeName': 'Црна Гора',
    'numericCode': '499',
    'currencies': ['EUR'],
    'languages': ['sr', 'bs', 'sq', 'hr'],
    'translations': { 'de': 'Montenegro', 'es': 'Montenegro', 'fr': 'Monténégro', 'ja': 'モンテネグロ', 'it': 'Montenegro' },
    'relevance': '0'
  }, {
    'name': 'Montserrat',
    'topLevelDomain': ['.ms'],
    'alpha2Code': 'MS',
    'alpha3Code': 'MSR',
    'callingCodes': ['1664'],
    'capital': 'Plymouth',
    'altSpellings': ['MS'],
    'region': 'Americas',
    'subregion': 'Caribbean',
    'population': 4922,
    'latlng': [16.75, -62.2],
    'demonym': 'Montserratian',
    'area': 102.0,
    'gini': null,
    'timezones': ['UTC-04:00'],
    'borders': [],
    'nativeName': 'Montserrat',
    'numericCode': '500',
    'currencies': ['XCD'],
    'languages': ['en'],
    'translations': { 'de': 'Montserrat', 'es': 'Montserrat', 'fr': 'Montserrat', 'ja': 'モントセラト', 'it': 'Montserrat' },
    'relevance': '0.5'
  }, {
    'name': 'Morocco',
    'topLevelDomain': ['.ma'],
    'alpha2Code': 'MA',
    'alpha3Code': 'MAR',
    'callingCodes': ['212'],
    'capital': 'Rabat',
    'altSpellings': ['MA', 'Kingdom of Morocco', 'Al-Mamlakah al-Maġribiyah'],
    'region': 'Africa',
    'subregion': 'Northern Africa',
    'population': 33337529,
    'latlng': [32.0, -5.0],
    'demonym': 'Moroccan',
    'area': 446550.0,
    'gini': 40.9,
    'timezones': ['UTC'],
    'borders': ['DZA', 'ESH', 'ESP'],
    'nativeName': 'المغرب',
    'numericCode': '504',
    'currencies': ['MAD'],
    'languages': ['ar'],
    'translations': { 'de': 'Marokko', 'es': 'Marruecos', 'fr': 'Maroc', 'ja': 'モロッコ', 'it': 'Marocco' },
    'relevance': '0'
  }, {
    'name': 'Mozambique',
    'topLevelDomain': ['.mz'],
    'alpha2Code': 'MZ',
    'alpha3Code': 'MOZ',
    'callingCodes': ['258'],
    'capital': 'Maputo',
    'altSpellings': ['MZ', 'Republic of Mozambique', 'República de Moçambique'],
    'region': 'Africa',
    'subregion': 'Eastern Africa',
    'population': 25727911,
    'latlng': [-18.25, 35.0],
    'demonym': 'Mozambican',
    'area': 801590.0,
    'gini': 45.7,
    'timezones': ['UTC+02:00'],
    'borders': ['MWI', 'ZAF', 'SWZ', 'TZA', 'ZMB', 'ZWE'],
    'nativeName': 'Moçambique',
    'numericCode': '508',
    'currencies': ['MZN'],
    'languages': ['pt'],
    'translations': { 'de': 'Mosambik', 'es': 'Mozambique', 'fr': 'Mozambique', 'ja': 'モザンビーク', 'it': 'Mozambico' },
    'relevance': '0'
  }, {
    'name': 'Myanmar',
    'topLevelDomain': ['.mm'],
    'alpha2Code': 'MM',
    'alpha3Code': 'MMR',
    'callingCodes': ['95'],
    'capital': 'Naypyidaw',
    'altSpellings': ['MM', 'Burma', 'Republic of the Union of Myanmar', 'Pyidaunzu Thanmăda Myăma Nainngandaw'],
    'region': 'Asia',
    'subregion': 'South-Eastern Asia',
    'population': 53897000,
    'latlng': [22.0, 98.0],
    'demonym': 'Burmese',
    'area': 676578.0,
    'gini': null,
    'timezones': ['UTC+06:30'],
    'borders': ['BGD', 'CHN', 'IND', 'LAO', 'THA'],
    'nativeName': 'Myanma',
    'numericCode': '104',
    'currencies': ['MMK'],
    'languages': ['my'],
    'translations': { 'de': 'Myanmar', 'es': 'Myanmar', 'fr': 'Myanmar', 'ja': 'ミャンマー', 'it': 'Birmania' },
    'relevance': '0'
  }, {
    'name': 'Namibia',
    'topLevelDomain': ['.na'],
    'alpha2Code': 'NA',
    'alpha3Code': 'NAM',
    'callingCodes': ['264'],
    'capital': 'Windhoek',
    'altSpellings': ['NA', 'Namibië', 'Republic of Namibia'],
    'region': 'Africa',
    'subregion': 'Southern Africa',
    'population': 2280700,
    'latlng': [-22.0, 17.0],
    'demonym': 'Namibian',
    'area': 825615.0,
    'gini': 63.9,
    'timezones': ['UTC+01:00'],
    'borders': ['AGO', 'BWA', 'ZAF', 'ZMB'],
    'nativeName': 'Namibia',
    'numericCode': '516',
    'currencies': ['NAD', 'ZAR'],
    'languages': ['en', 'af'],
    'translations': { 'de': 'Namibia', 'es': 'Namibia', 'fr': 'Namibie', 'ja': 'ナミビア', 'it': 'Namibia' },
    'relevance': '0'
  }, {
    'name': 'Nauru',
    'topLevelDomain': ['.nr'],
    'alpha2Code': 'NR',
    'alpha3Code': 'NRU',
    'callingCodes': ['674'],
    'capital': 'Yaren',
    'altSpellings': ['NR', 'Naoero', 'Pleasant Island', 'Republic of Nauru', 'Ripublik Naoero'],
    'region': 'Oceania',
    'subregion': 'Micronesia',
    'population': 10084,
    'latlng': [-0.53333333, 166.91666666],
    'demonym': 'Nauruan',
    'area': 21.0,
    'gini': null,
    'timezones': ['UTC+12:00'],
    'borders': [],
    'nativeName': 'Nauru',
    'numericCode': '520',
    'currencies': ['AUD'],
    'languages': ['en', 'na'],
    'translations': { 'de': 'Nauru', 'es': 'Nauru', 'fr': 'Nauru', 'ja': 'ナウル', 'it': 'Nauru' },
    'relevance': '0.5'
  }, {
    'name': 'Nepal',
    'topLevelDomain': ['.np'],
    'alpha2Code': 'NP',
    'alpha3Code': 'NPL',
    'callingCodes': ['977'],
    'capital': 'Kathmandu',
    'altSpellings': ['NP', 'Federal Democratic Republic of Nepal', 'Loktāntrik Ganatantra Nepāl'],
    'region': 'Asia',
    'subregion': 'Southern Asia',
    'population': 28037904,
    'latlng': [28.0, 84.0],
    'demonym': 'Nepalese',
    'area': 147181.0,
    'gini': 32.8,
    'timezones': ['UTC+05:45'],
    'borders': ['CHN', 'IND'],
    'nativeName': 'नेपाल',
    'numericCode': '524',
    'currencies': ['NPR'],
    'languages': ['ne'],
    'translations': { 'de': 'Népal', 'es': 'Nepal', 'fr': 'Népal', 'ja': 'ネパール', 'it': 'Nepal' },
    'relevance': '0'
  }, {
    'name': 'Netherlands',
    'topLevelDomain': ['.nl'],
    'alpha2Code': 'NL',
    'alpha3Code': 'NLD',
    'callingCodes': ['31'],
    'capital': 'Amsterdam',
    'altSpellings': ['NL', 'Holland', 'Nederland'],
    'region': 'Europe',
    'subregion': 'Western Europe',
    'population': 16916000,
    'latlng': [52.5, 5.75],
    'demonym': 'Dutch',
    'area': 41850.0,
    'gini': 30.9,
    'timezones': ['UTC-04:00', 'UTC+01:00'],
    'borders': ['BEL', 'DEU'],
    'nativeName': 'Nederland',
    'numericCode': '528',
    'currencies': ['EUR'],
    'languages': ['nl'],
    'translations': { 'de': 'Niederlande', 'es': 'Países Bajos', 'fr': 'Pays-Bas', 'ja': 'オランダ', 'it': 'Paesi Bassi' },
    'relevance': '1.5'
  }, {
    'name': 'New Caledonia',
    'topLevelDomain': ['.nc'],
    'alpha2Code': 'NC',
    'alpha3Code': 'NCL',
    'callingCodes': ['687'],
    'capital': 'Nouméa',
    'altSpellings': ['NC'],
    'region': 'Oceania',
    'subregion': 'Melanesia',
    'population': 268767,
    'latlng': [-21.5, 165.5],
    'demonym': 'New Caledonian',
    'area': 18575.0,
    'gini': null,
    'timezones': ['UTC+11:00'],
    'borders': [],
    'nativeName': 'Nouvelle-Calédonie',
    'numericCode': '540',
    'currencies': ['XPF'],
    'languages': ['fr'],
    'translations': {
      'de': 'Neukaledonien',
      'es': 'Nueva Caledonia',
      'fr': 'Nouvelle-Calédonie',
      'ja': 'ニューカレドニア',
      'it': 'Nuova Caledonia'
    },
    'relevance': '0.5'
  }, {
    'name': 'New Zealand',
    'topLevelDomain': ['.nz'],
    'alpha2Code': 'NZ',
    'alpha3Code': 'NZL',
    'callingCodes': ['64'],
    'capital': 'Wellington',
    'altSpellings': ['NZ', 'Aotearoa'],
    'region': 'Oceania',
    'subregion': 'Australia and New Zealand',
    'population': 4609440,
    'latlng': [-41.0, 174.0],
    'demonym': 'New Zealander',
    'area': 270467.0,
    'gini': 36.2,
    'timezones': ['UTC-11:00', 'UTC-10:00', 'UTC+12:00', 'UTC+12:45', 'UTC+13:00'],
    'borders': [],
    'nativeName': 'New Zealand',
    'numericCode': '554',
    'currencies': ['NZD'],
    'languages': ['en', 'mi'],
    'translations': {
      'de': 'Neuseeland',
      'es': 'Nueva Zelanda',
      'fr': 'Nouvelle-Zélande',
      'ja': 'ニュージーランド',
      'it': 'Nuova Zelanda'
    },
    'relevance': '1.0'
  }, {
    'name': 'Nicaragua',
    'topLevelDomain': ['.ni'],
    'alpha2Code': 'NI',
    'alpha3Code': 'NIC',
    'callingCodes': ['505'],
    'capital': 'Managua',
    'altSpellings': ['NI', 'Republic of Nicaragua', 'República de Nicaragua'],
    'region': 'Americas',
    'subregion': 'Central America',
    'population': 6198154,
    'latlng': [13.0, -85.0],
    'demonym': 'Nicaraguan',
    'area': 130373.0,
    'gini': 40.5,
    'timezones': ['UTC-06:00'],
    'borders': ['CRI', 'HND'],
    'nativeName': 'Nicaragua',
    'numericCode': '558',
    'currencies': ['NIO'],
    'languages': ['es'],
    'translations': { 'de': 'Nicaragua', 'es': 'Nicaragua', 'fr': 'Nicaragua', 'ja': 'ニカラグア', 'it': 'Nicaragua' },
    'relevance': '0'
  }, {
    'name': 'Niger',
    'topLevelDomain': ['.ne'],
    'alpha2Code': 'NE',
    'alpha3Code': 'NER',
    'callingCodes': ['227'],
    'capital': 'Niamey',
    'altSpellings': ['NE', 'Nijar', 'Republic of Niger', 'République du Niger'],
    'region': 'Africa',
    'subregion': 'Western Africa',
    'population': 19899000,
    'latlng': [16.0, 8.0],
    'demonym': 'Nigerien',
    'area': 1267000.0,
    'gini': 34.6,
    'timezones': ['UTC+01:00'],
    'borders': ['DZA', 'BEN', 'BFA', 'TCD', 'LBY', 'MLI', 'NGA'],
    'nativeName': 'Niger',
    'numericCode': '562',
    'currencies': ['XOF'],
    'languages': ['fr'],
    'translations': { 'de': 'Niger', 'es': 'Níger', 'fr': 'Niger', 'ja': 'ニジェール', 'it': 'Niger' },
    'relevance': '0'
  }, {
    'name': 'Nigeria',
    'topLevelDomain': ['.ng'],
    'alpha2Code': 'NG',
    'alpha3Code': 'NGA',
    'callingCodes': ['234'],
    'capital': 'Abuja',
    'altSpellings': ['NG', 'Nijeriya', 'Naíjíríà', 'Federal Republic of Nigeria'],
    'region': 'Africa',
    'subregion': 'Western Africa',
    'population': 182202000,
    'latlng': [10.0, 8.0],
    'demonym': 'Nigerian',
    'area': 923768.0,
    'gini': 48.8,
    'timezones': ['UTC+01:00'],
    'borders': ['BEN', 'CMR', 'TCD', 'NER'],
    'nativeName': 'Nigeria',
    'numericCode': '566',
    'currencies': ['NGN'],
    'languages': ['en'],
    'translations': { 'de': 'Nigeria', 'es': 'Nigeria', 'fr': 'Nigéria', 'ja': 'ナイジェリア', 'it': 'Nigeria' },
    'relevance': '1.5'
  }, {
    'name': 'Niue',
    'topLevelDomain': ['.nu'],
    'alpha2Code': 'NU',
    'alpha3Code': 'NIU',
    'callingCodes': ['683'],
    'capital': 'Alofi',
    'altSpellings': ['NU'],
    'region': 'Oceania',
    'subregion': 'Polynesia',
    'population': 1613,
    'latlng': [-19.03333333, -169.86666666],
    'demonym': 'Niuean',
    'area': 260.0,
    'gini': null,
    'timezones': ['UTC-11:00'],
    'borders': [],
    'nativeName': 'Niuē',
    'numericCode': '570',
    'currencies': ['NZD'],
    'languages': ['en'],
    'translations': { 'de': 'Niue', 'es': 'Niue', 'fr': 'Niue', 'ja': 'ニウエ', 'it': 'Niue' },
    'relevance': '0.5'
  }, {
    'name': 'Norfolk Island',
    'topLevelDomain': ['.nf'],
    'alpha2Code': 'NF',
    'alpha3Code': 'NFK',
    'callingCodes': ['672'],
    'capital': 'Kingston',
    'altSpellings': ['NF', 'Territory of Norfolk Island', 'Teratri of Norf\'k Ailen'],
    'region': 'Oceania',
    'subregion': 'Australia and New Zealand',
    'population': 2302,
    'latlng': [-29.03333333, 167.95],
    'demonym': 'Norfolk Islander',
    'area': 36.0,
    'gini': null,
    'timezones': ['UTC+11:30'],
    'borders': [],
    'nativeName': 'Norfolk Island',
    'numericCode': '574',
    'currencies': ['AUD'],
    'languages': ['en'],
    'translations': {
      'de': 'Norfolkinsel',
      'es': 'Isla de Norfolk',
      'fr': 'Île de Norfolk',
      'ja': 'ノーフォーク島',
      'it': 'Isola Norfolk'
    },
    'relevance': '0.5'
  }, {
    'name': 'North Korea',
    'topLevelDomain': ['.kp'],
    'alpha2Code': 'KP',
    'alpha3Code': 'PRK',
    'callingCodes': ['850'],
    'capital': 'Pyongyang',
    'altSpellings': ['KP', 'Democratic People\'s Republic of Korea', '조선민주주의인민공화국', 'Chosŏn Minjujuŭi Inmin Konghwaguk'],
    'region': 'Asia',
    'subregion': 'Eastern Asia',
    'population': 25155000,
    'latlng': [40.0, 127.0],
    'demonym': 'North Korean',
    'area': 120538.0,
    'gini': null,
    'timezones': ['UTC+09:00'],
    'borders': ['CHN', 'KOR', 'RUS'],
    'nativeName': '북한',
    'numericCode': '408',
    'currencies': ['KPW'],
    'languages': ['ko'],
    'translations': {
      'de': 'Nordkorea',
      'es': 'Corea del Norte',
      'fr': 'Corée du Nord',
      'ja': '朝鮮民主主義人民共和国',
      'it': 'Corea del Nord'
    },
    'relevance': '0'
  }, {
    'name': 'Northern Mariana Islands',
    'topLevelDomain': ['.mp'],
    'alpha2Code': 'MP',
    'alpha3Code': 'MNP',
    'callingCodes': ['1670'],
    'capital': 'Saipan',
    'altSpellings': ['MP', 'Commonwealth of the Northern Mariana Islands', 'Sankattan Siha Na Islas Mariånas'],
    'region': 'Oceania',
    'subregion': 'Micronesia',
    'population': 53883,
    'latlng': [15.2, 145.75],
    'demonym': 'American',
    'area': 464.0,
    'gini': null,
    'timezones': ['UTC+10:00'],
    'borders': [],
    'nativeName': 'Northern Mariana Islands',
    'numericCode': '580',
    'currencies': ['USD'],
    'languages': ['en', 'ch'],
    'translations': {
      'de': 'Nördliche Marianen',
      'es': 'Islas Marianas del Norte',
      'fr': 'Îles Mariannes du Nord',
      'ja': '北マリアナ諸島',
      'it': 'Isole Marianne Settentrionali'
    },
    'relevance': '0.5'
  }, {
    'name': 'Norway',
    'topLevelDomain': ['.no'],
    'alpha2Code': 'NO',
    'alpha3Code': 'NOR',
    'callingCodes': ['47'],
    'capital': 'Oslo',
    'altSpellings': ['NO', 'Norge', 'Noreg', 'Kingdom of Norway', 'Kongeriket Norge', 'Kongeriket Noreg'],
    'region': 'Europe',
    'subregion': 'Northern Europe',
    'population': 5176998,
    'latlng': [62.0, 10.0],
    'demonym': 'Norwegian',
    'area': 323802.0,
    'gini': 25.8,
    'timezones': ['UTC+01:00'],
    'borders': ['FIN', 'SWE', 'RUS'],
    'nativeName': 'Norge',
    'numericCode': '578',
    'currencies': ['NOK'],
    'languages': ['no', 'nb', 'nn'],
    'translations': { 'de': 'Norwegen', 'es': 'Noruega', 'fr': 'Norvège', 'ja': 'ノルウェー', 'it': 'Norvegia' },
    'relevance': '1.5'
  }, {
    'name': 'Oman',
    'topLevelDomain': ['.om'],
    'alpha2Code': 'OM',
    'alpha3Code': 'OMN',
    'callingCodes': ['968'],
    'capital': 'Muscat',
    'altSpellings': ['OM', 'Sultanate of Oman', 'Salṭanat ʻUmān'],
    'region': 'Asia',
    'subregion': 'Western Asia',
    'population': 4185440,
    'latlng': [21.0, 57.0],
    'demonym': 'Omani',
    'area': 309500.0,
    'gini': null,
    'timezones': ['UTC+04:00'],
    'borders': ['SAU', 'ARE', 'YEM'],
    'nativeName': 'عمان',
    'numericCode': '512',
    'currencies': ['OMR'],
    'languages': ['ar'],
    'translations': { 'de': 'Oman', 'es': 'Omán', 'fr': 'Oman', 'ja': 'オマーン', 'it': 'oman' },
    'relevance': '0'
  }, {
    'name': 'Pakistan',
    'topLevelDomain': ['.pk'],
    'alpha2Code': 'PK',
    'alpha3Code': 'PAK',
    'callingCodes': ['92'],
    'capital': 'Islamabad',
    'altSpellings': ['PK', 'Pākistān', 'Islamic Republic of Pakistan', 'Islāmī Jumhūriya\'eh Pākistān'],
    'region': 'Asia',
    'subregion': 'Southern Asia',
    'population': 190668000,
    'latlng': [30.0, 70.0],
    'demonym': 'Pakistani',
    'area': 881912.0,
    'gini': 30.0,
    'timezones': ['UTC+05:00'],
    'borders': ['AFG', 'CHN', 'IND', 'IRN'],
    'nativeName': 'Pakistan',
    'numericCode': '586',
    'currencies': ['PKR'],
    'languages': ['en', 'ur'],
    'translations': { 'de': 'Pakistan', 'es': 'Pakistán', 'fr': 'Pakistan', 'ja': 'パキスタン', 'it': 'Pakistan' },
    'relevance': '2'
  }, {
    'name': 'Palau',
    'topLevelDomain': ['.pw'],
    'alpha2Code': 'PW',
    'alpha3Code': 'PLW',
    'callingCodes': ['680'],
    'capital': 'Ngerulmud',
    'altSpellings': ['PW', 'Republic of Palau', 'Beluu er a Belau'],
    'region': 'Oceania',
    'subregion': 'Micronesia',
    'population': 20901,
    'latlng': [7.5, 134.5],
    'demonym': 'Palauan',
    'area': 459.0,
    'gini': null,
    'timezones': ['UTC+09:00'],
    'borders': [],
    'nativeName': 'Palau',
    'numericCode': '585',
    'currencies': ['USD'],
    'languages': ['en'],
    'translations': { 'de': 'Palau', 'es': 'Palau', 'fr': 'Palaos', 'ja': 'パラオ', 'it': 'Palau' },
    'relevance': '0.5'
  }, {
    'name': 'Palestine',
    'topLevelDomain': ['.ps'],
    'alpha2Code': 'PS',
    'alpha3Code': 'PSE',
    'callingCodes': ['970'],
    'capital': 'Ramallah',
    'altSpellings': ['PS', 'State of Palestine', 'Dawlat Filasṭin'],
    'region': 'Asia',
    'subregion': 'Western Asia',
    'population': 4682467,
    'latlng': [31.9, 35.2],
    'demonym': 'Palestinian',
    'area': null,
    'gini': 35.5,
    'timezones': ['UTC+02:00'],
    'borders': ['ISR', 'EGY', 'JOR'],
    'nativeName': 'فلسطين',
    'numericCode': '275',
    'currencies': ['ILS'],
    'languages': ['ar'],
    'translations': { 'de': 'Palästina', 'es': 'Palestina', 'fr': 'Palestine', 'ja': 'パレスチナ', 'it': 'Palestina' },
    'relevance': '0'
  }, {
    'name': 'Panama',
    'topLevelDomain': ['.pa'],
    'alpha2Code': 'PA',
    'alpha3Code': 'PAN',
    'callingCodes': ['507'],
    'capital': 'Panama City',
    'altSpellings': ['PA', 'Republic of Panama', 'República de Panamá'],
    'region': 'Americas',
    'subregion': 'Central America',
    'population': 3764166,
    'latlng': [9.0, -80.0],
    'demonym': 'Panamanian',
    'area': 75417.0,
    'gini': 51.9,
    'timezones': ['UTC-05:00'],
    'borders': ['COL', 'CRI'],
    'nativeName': 'Panamá',
    'numericCode': '591',
    'currencies': ['PAB', 'USD'],
    'languages': ['es'],
    'translations': { 'de': 'Panama', 'es': 'Panamá', 'fr': 'Panama', 'ja': 'パナマ', 'it': 'Panama' },
    'relevance': '0'
  }, {
    'name': 'Papua New Guinea',
    'topLevelDomain': ['.pg'],
    'alpha2Code': 'PG',
    'alpha3Code': 'PNG',
    'callingCodes': ['675'],
    'capital': 'Port Moresby',
    'altSpellings': ['PG', 'Independent State of Papua New Guinea', 'Independen Stet bilong Papua Niugini'],
    'region': 'Oceania',
    'subregion': 'Melanesia',
    'population': 7398500,
    'latlng': [-6.0, 147.0],
    'demonym': 'Papua New Guinean',
    'area': 462840.0,
    'gini': 50.9,
    'timezones': ['UTC+10:00'],
    'borders': ['IDN'],
    'nativeName': 'Papua Niugini',
    'numericCode': '598',
    'currencies': ['PGK'],
    'languages': ['en'],
    'translations': {
      'de': 'Papua-Neuguinea',
      'es': 'Papúa Nueva Guinea',
      'fr': 'Papouasie-Nouvelle-Guinée',
      'ja': 'パプアニューギニア',
      'it': 'Papua Nuova Guinea'
    },
    'relevance': '0'
  }, {
    'name': 'Paraguay',
    'topLevelDomain': ['.py'],
    'alpha2Code': 'PY',
    'alpha3Code': 'PRY',
    'callingCodes': ['595'],
    'capital': 'Asunción',
    'altSpellings': ['PY', 'Republic of Paraguay', 'República del Paraguay', 'Tetã Paraguái'],
    'region': 'Americas',
    'subregion': 'South America',
    'population': 7003406,
    'latlng': [-23.0, -58.0],
    'demonym': 'Paraguayan',
    'area': 406752.0,
    'gini': 52.4,
    'timezones': ['UTC-04:00'],
    'borders': ['ARG', 'BOL', 'BRA'],
    'nativeName': 'Paraguay',
    'numericCode': '600',
    'currencies': ['PYG'],
    'languages': ['es', 'gn'],
    'translations': { 'de': 'Paraguay', 'es': 'Paraguay', 'fr': 'Paraguay', 'ja': 'パラグアイ', 'it': 'Paraguay' },
    'relevance': '0'
  }, {
    'name': 'Peru',
    'topLevelDomain': ['.pe'],
    'alpha2Code': 'PE',
    'alpha3Code': 'PER',
    'callingCodes': ['51'],
    'capital': 'Lima',
    'altSpellings': ['PE', 'Republic of Peru', ' República del Perú'],
    'region': 'Americas',
    'subregion': 'South America',
    'population': 31151643,
    'latlng': [-10.0, -76.0],
    'demonym': 'Peruvian',
    'area': 1285216.0,
    'gini': 48.1,
    'timezones': ['UTC-05:00'],
    'borders': ['BOL', 'BRA', 'CHL', 'COL', 'ECU'],
    'nativeName': 'Perú',
    'numericCode': '604',
    'currencies': ['PEN'],
    'languages': ['es'],
    'translations': { 'de': 'Peru', 'es': 'Perú', 'fr': 'Pérou', 'ja': 'ペルー', 'it': 'Perù' },
    'relevance': '0'
  }, {
    'name': 'Philippines',
    'topLevelDomain': ['.ph'],
    'alpha2Code': 'PH',
    'alpha3Code': 'PHL',
    'callingCodes': ['63'],
    'capital': 'Manila',
    'altSpellings': ['PH', 'Republic of the Philippines', 'Repúblika ng Pilipinas'],
    'region': 'Asia',
    'subregion': 'South-Eastern Asia',
    'population': 101920000,
    'latlng': [13.0, 122.0],
    'demonym': 'Filipino',
    'area': 342353.0,
    'gini': 43.0,
    'timezones': ['UTC+08:00'],
    'borders': [],
    'nativeName': 'Pilipinas',
    'numericCode': '608',
    'currencies': ['PHP'],
    'languages': ['en'],
    'translations': { 'de': 'Philippinen', 'es': 'Filipinas', 'fr': 'Philippines', 'ja': 'フィリピン', 'it': 'Filippine' },
    'relevance': '1.5'
  }, {
    'name': 'Pitcairn Islands',
    'topLevelDomain': ['.pn'],
    'alpha2Code': 'PN',
    'alpha3Code': 'PCN',
    'callingCodes': ['64'],
    'capital': 'Adamstown',
    'altSpellings': ['PN', 'Pitcairn Henderson Ducie and Oeno Islands'],
    'region': 'Oceania',
    'subregion': 'Polynesia',
    'population': 56,
    'latlng': [-25.06666666, -130.1],
    'demonym': 'Pitcairn Islander',
    'area': 47.0,
    'gini': null,
    'timezones': ['UTC-08:00'],
    'borders': [],
    'nativeName': 'Pitcairn Islands',
    'numericCode': '612',
    'currencies': ['NZD'],
    'languages': ['en'],
    'translations': {
      'de': 'Pitcairn',
      'es': 'Islas Pitcairn',
      'fr': 'Îles Pitcairn',
      'ja': 'ピトケアン',
      'it': 'Isole Pitcairn'
    },
    'relevance': '0.5'
  }, {
    'name': 'Poland',
    'topLevelDomain': ['.pl'],
    'alpha2Code': 'PL',
    'alpha3Code': 'POL',
    'callingCodes': ['48'],
    'capital': 'Warsaw',
    'altSpellings': ['PL', 'Republic of Poland', 'Rzeczpospolita Polska'],
    'region': 'Europe',
    'subregion': 'Eastern Europe',
    'population': 38484000,
    'latlng': [52.0, 20.0],
    'demonym': 'Polish',
    'area': 312679.0,
    'gini': 34.1,
    'timezones': ['UTC+01:00'],
    'borders': ['BLR', 'CZE', 'DEU', 'LTU', 'RUS', 'SVK', 'UKR'],
    'nativeName': 'Polska',
    'numericCode': '616',
    'currencies': ['PLN'],
    'languages': ['pl'],
    'translations': { 'de': 'Polen', 'es': 'Polonia', 'fr': 'Pologne', 'ja': 'ポーランド', 'it': 'Polonia' },
    'relevance': '1.25'
  }, {
    'name': 'Portugal',
    'topLevelDomain': ['.pt'],
    'alpha2Code': 'PT',
    'alpha3Code': 'PRT',
    'callingCodes': ['351'],
    'capital': 'Lisbon',
    'altSpellings': ['PT', 'Portuguesa', 'Portuguese Republic', 'República Portuguesa'],
    'region': 'Europe',
    'subregion': 'Southern Europe',
    'population': 10374822,
    'latlng': [39.5, -8.0],
    'demonym': 'Portuguese',
    'area': 92090.0,
    'gini': 38.5,
    'timezones': ['UTC-01:00', 'UTC'],
    'borders': ['ESP'],
    'nativeName': 'Portugal',
    'numericCode': '620',
    'currencies': ['EUR'],
    'languages': ['pt'],
    'translations': { 'de': 'Portugal', 'es': 'Portugal', 'fr': 'Portugal', 'ja': 'ポルトガル', 'it': 'Portogallo' },
    'relevance': '1.5'
  }, {
    'name': 'Puerto Rico',
    'topLevelDomain': ['.pr'],
    'alpha2Code': 'PR',
    'alpha3Code': 'PRI',
    'callingCodes': ['1787', '1939'],
    'capital': 'San Juan',
    'altSpellings': ['PR', 'Commonwealth of Puerto Rico', 'Estado Libre Asociado de Puerto Rico'],
    'region': 'Americas',
    'subregion': 'Caribbean',
    'population': 3548397,
    'latlng': [18.25, -66.5],
    'demonym': 'Puerto Rican',
    'area': 8870.0,
    'gini': null,
    'timezones': ['UTC-04:00'],
    'borders': [],
    'nativeName': 'Puerto Rico',
    'numericCode': '630',
    'currencies': ['USD'],
    'languages': ['es', 'en'],
    'translations': { 'de': 'Puerto Rico', 'es': 'Puerto Rico', 'fr': 'Porto Rico', 'ja': 'プエルトリコ', 'it': 'Porto Rico' },
    'relevance': '0'
  }, {
    'name': 'Qatar',
    'topLevelDomain': ['.qa'],
    'alpha2Code': 'QA',
    'alpha3Code': 'QAT',
    'callingCodes': ['974'],
    'capital': 'Doha',
    'altSpellings': ['QA', 'State of Qatar', 'Dawlat Qaṭar'],
    'region': 'Asia',
    'subregion': 'Western Asia',
    'population': 2120129,
    'latlng': [25.5, 51.25],
    'demonym': 'Qatari',
    'area': 11586.0,
    'gini': 41.1,
    'timezones': ['UTC+03:00'],
    'borders': ['SAU'],
    'nativeName': 'قطر',
    'numericCode': '634',
    'currencies': ['QAR'],
    'languages': ['ar'],
    'translations': { 'de': 'Katar', 'es': 'Catar', 'fr': 'Qatar', 'ja': 'カタール', 'it': 'Qatar' },
    'relevance': '0'
  }, {
    'name': 'Republic of Kosovo',
    'topLevelDomain': [''],
    'alpha2Code': 'XK',
    'alpha3Code': 'KOS',
    'callingCodes': ['383'],
    'capital': 'Pristina',
    'altSpellings': ['XK', 'Република Косово'],
    'region': 'Europe',
    'subregion': 'Eastern Europe',
    'population': 1733842,
    'latlng': [42.666667, 21.166667],
    'demonym': 'Kosovar',
    'area': 10908.0,
    'gini': null,
    'timezones': ['UTC+01:00'],
    'borders': ['ALB', 'MKD', 'MNE', 'SRB'],
    'nativeName': 'Republika e Kosovës',
    'numericCode': '780',
    'currencies': ['EUR'],
    'languages': ['sq', 'sr'],
    'translations': { 'de': null, 'es': 'Kosovo', 'fr': null, 'ja': null, 'it': null },
    'relevance': '0'
  }, {
    'name': 'Réunion',
    'topLevelDomain': ['.re'],
    'alpha2Code': 'RE',
    'alpha3Code': 'REU',
    'callingCodes': ['262'],
    'capital': 'Saint-Denis',
    'altSpellings': ['RE', 'Reunion'],
    'region': 'Africa',
    'subregion': 'Eastern Africa',
    'population': 840974,
    'latlng': [-21.15, 55.5],
    'demonym': 'French',
    'area': null,
    'gini': null,
    'timezones': ['UTC+04:00'],
    'borders': [],
    'nativeName': 'La Réunion',
    'numericCode': '638',
    'currencies': ['EUR'],
    'languages': ['fr'],
    'translations': { 'de': 'Réunion', 'es': 'Reunión', 'fr': 'Réunion', 'ja': 'レユニオン', 'it': 'Riunione' },
    'relevance': '0'
  }, {
    'name': 'Romania',
    'topLevelDomain': ['.ro'],
    'alpha2Code': 'RO',
    'alpha3Code': 'ROU',
    'callingCodes': ['40'],
    'capital': 'Bucharest',
    'altSpellings': ['RO', 'Rumania', 'Roumania', 'România'],
    'region': 'Europe',
    'subregion': 'Eastern Europe',
    'population': 19942642,
    'latlng': [46.0, 25.0],
    'demonym': 'Romanian',
    'area': 238391.0,
    'gini': 30.0,
    'timezones': ['UTC+02:00'],
    'borders': ['BGR', 'HUN', 'MDA', 'SRB', 'UKR'],
    'nativeName': 'România',
    'numericCode': '642',
    'currencies': ['RON'],
    'languages': ['ro'],
    'translations': { 'de': 'Rumänien', 'es': 'Rumania', 'fr': 'Roumanie', 'ja': 'ルーマニア', 'it': 'Romania' },
    'relevance': '0'
  }, {
    'name': 'Russia',
    'topLevelDomain': ['.ru'],
    'alpha2Code': 'RU',
    'alpha3Code': 'RUS',
    'callingCodes': ['7'],
    'capital': 'Moscow',
    'altSpellings': ['RU', 'Rossiya', 'Russian Federation', 'Российская Федерация', 'Rossiyskaya Federatsiya'],
    'region': 'Europe',
    'subregion': 'Eastern Europe',
    'population': 146556330,
    'latlng': [60.0, 100.0],
    'demonym': 'Russian',
    'area': 1.7124442E7,
    'gini': 40.1,
    'timezones': ['UTC+03:00', 'UTC+04:00', 'UTC+06:00', 'UTC+07:00', 'UTC+08:00', 'UTC+09:00', 'UTC+10:00', 'UTC+11:00', 'UTC+12:00'],
    'borders': ['AZE', 'BLR', 'CHN', 'EST', 'FIN', 'GEO', 'KAZ', 'PRK', 'LVA', 'LTU', 'MNG', 'NOR', 'POL', 'UKR'],
    'nativeName': 'Россия',
    'numericCode': '643',
    'currencies': ['RUB'],
    'languages': ['ru'],
    'translations': { 'de': 'Russland', 'es': 'Rusia', 'fr': 'Russie', 'ja': 'ロシア連邦', 'it': 'Russia' },
    'relevance': '2.5'
  }, {
    'name': 'Rwanda',
    'topLevelDomain': ['.rw'],
    'alpha2Code': 'RW',
    'alpha3Code': 'RWA',
    'callingCodes': ['250'],
    'capital': 'Kigali',
    'altSpellings': ['RW', 'Republic of Rwanda', 'Repubulika y\'u Rwanda', 'République du Rwanda'],
    'region': 'Africa',
    'subregion': 'Eastern Africa',
    'population': 11262564,
    'latlng': [-2.0, 30.0],
    'demonym': 'Rwandan',
    'area': 26338.0,
    'gini': 50.8,
    'timezones': ['UTC+02:00'],
    'borders': ['BDI', 'COD', 'TZA', 'UGA'],
    'nativeName': 'Rwanda',
    'numericCode': '646',
    'currencies': ['RWF'],
    'languages': ['rw', 'en', 'fr'],
    'translations': { 'de': 'Ruanda', 'es': 'Ruanda', 'fr': 'Rwanda', 'ja': 'ルワンダ', 'it': 'Ruanda' },
    'relevance': '0'
  }, {
    'name': 'Saint Barthélemy',
    'topLevelDomain': ['.bl'],
    'alpha2Code': 'BL',
    'alpha3Code': 'BLM',
    'callingCodes': ['590'],
    'capital': 'Gustavia',
    'altSpellings': ['BL', 'St. Barthelemy', 'Collectivity of Saint Barthélemy', 'Collectivité de Saint-Barthélemy'],
    'region': 'Americas',
    'subregion': 'Caribbean',
    'population': 9269,
    'latlng': [18.5, -63.41666666],
    'demonym': 'Saint Barthélemy Islander',
    'area': 21.0,
    'gini': null,
    'timezones': ['UTC-04:00'],
    'borders': [],
    'nativeName': 'Saint-Barthélemy',
    'numericCode': '652',
    'currencies': ['EUR'],
    'languages': ['fr'],
    'translations': {
      'de': 'Saint-Barthélemy',
      'es': 'San Bartolomé',
      'fr': 'Saint-Barthélemy',
      'ja': 'サン・バルテルミー',
      'it': 'Antille Francesi'
    },
    'relevance': '0'
  }, {
    'name': 'Saint Helena',
    'topLevelDomain': ['.sh'],
    'alpha2Code': 'SH',
    'alpha3Code': 'SHN',
    'callingCodes': ['290'],
    'capital': 'Jamestown',
    'altSpellings': ['SH'],
    'region': 'Africa',
    'subregion': 'Western Africa',
    'population': 4255,
    'latlng': [-15.95, -5.7],
    'demonym': 'Saint Helenian',
    'area': null,
    'gini': null,
    'timezones': ['UTC+00:00'],
    'borders': [],
    'nativeName': 'Saint Helena',
    'numericCode': '654',
    'currencies': ['SHP'],
    'languages': ['en'],
    'translations': {
      'de': 'Sankt Helena',
      'es': 'Santa Helena',
      'fr': 'Sainte-Hélène',
      'ja': 'セントヘレナ・アセンションおよびトリスタンダクーニャ',
      'it': 'Sant\'Elena'
    },
    'relevance': '0'
  }, {
    'name': 'Saint Kitts and Nevis',
    'topLevelDomain': ['.kn'],
    'alpha2Code': 'KN',
    'alpha3Code': 'KNA',
    'callingCodes': ['1869'],
    'capital': 'Basseterre',
    'altSpellings': ['KN', 'Federation of Saint Christopher and Nevis'],
    'region': 'Americas',
    'subregion': 'Caribbean',
    'population': 56000,
    'latlng': [17.33333333, -62.75],
    'demonym': 'Kittian and Nevisian',
    'area': 261.0,
    'gini': null,
    'timezones': ['UTC-04:00'],
    'borders': [],
    'nativeName': 'Saint Kitts and Nevis',
    'numericCode': '659',
    'currencies': ['XCD'],
    'languages': ['en'],
    'translations': {
      'de': 'St. Kitts und Nevis',
      'es': 'San Cristóbal y Nieves',
      'fr': 'Saint-Christophe-et-Niévès',
      'ja': 'セントクリストファー・ネイビス',
      'it': 'Saint Kitts e Nevis'
    },
    'relevance': '0'
  }, {
    'name': 'Saint Lucia',
    'topLevelDomain': ['.lc'],
    'alpha2Code': 'LC',
    'alpha3Code': 'LCA',
    'callingCodes': ['1758'],
    'capital': 'Castries',
    'altSpellings': ['LC'],
    'region': 'Americas',
    'subregion': 'Caribbean',
    'population': 185000,
    'latlng': [13.88333333, -60.96666666],
    'demonym': 'Saint Lucian',
    'area': 616.0,
    'gini': 42.6,
    'timezones': ['UTC-04:00'],
    'borders': [],
    'nativeName': 'Saint Lucia',
    'numericCode': '662',
    'currencies': ['XCD'],
    'languages': ['en'],
    'translations': { 'de': 'Saint Lucia', 'es': 'Santa Lucía', 'fr': 'Saint-Lucie', 'ja': 'セントルシア', 'it': 'Santa Lucia' },
    'relevance': '0'
  }, {
    'name': 'Saint Martin',
    'topLevelDomain': ['.mf', '.fr', '.gp'],
    'alpha2Code': 'MF',
    'alpha3Code': 'MAF',
    'callingCodes': ['590'],
    'capital': 'Marigot',
    'altSpellings': ['MF', 'Collectivity of Saint Martin', 'Collectivité de Saint-Martin'],
    'region': 'Americas',
    'subregion': 'Caribbean',
    'population': 36979,
    'latlng': [18.08333333, -63.95],
    'demonym': 'Saint Martin Islander',
    'area': 53.0,
    'gini': null,
    'timezones': ['UTC-04:00'],
    'borders': ['SXM', 'NLD'],
    'nativeName': 'Saint-Martin',
    'numericCode': '663',
    'currencies': ['EUR'],
    'languages': ['en', 'fr', 'nl'],
    'translations': {
      'de': 'Saint Martin',
      'es': 'Saint Martin',
      'fr': 'Saint-Martin',
      'ja': 'サン・マルタン（フランス領）',
      'it': 'Saint Martin'
    },
    'relevance': '0'
  }, {
    'name': 'Saint Pierre and Miquelon',
    'topLevelDomain': ['.pm'],
    'alpha2Code': 'PM',
    'alpha3Code': 'SPM',
    'callingCodes': ['508'],
    'capital': 'Saint-Pierre',
    'altSpellings': ['PM', 'Collectivité territoriale de Saint-Pierre-et-Miquelon'],
    'region': 'Americas',
    'subregion': 'Northern America',
    'population': 6069,
    'latlng': [46.83333333, -56.33333333],
    'demonym': 'French',
    'area': 242.0,
    'gini': null,
    'timezones': ['UTC-03:00'],
    'borders': [],
    'nativeName': 'Saint-Pierre-et-Miquelon',
    'numericCode': '666',
    'currencies': ['EUR'],
    'languages': ['fr'],
    'translations': {
      'de': 'Saint-Pierre und Miquelon',
      'es': 'San Pedro y Miquelón',
      'fr': 'Saint-Pierre-et-Miquelon',
      'ja': 'サンピエール島・ミクロン島',
      'it': 'Saint-Pierre e Miquelon'
    },
    'relevance': '0'
  }, {
    'name': 'Saint Vincent and the Grenadines',
    'topLevelDomain': ['.vc'],
    'alpha2Code': 'VC',
    'alpha3Code': 'VCT',
    'callingCodes': ['1784'],
    'capital': 'Kingstown',
    'altSpellings': ['VC'],
    'region': 'Americas',
    'subregion': 'Caribbean',
    'population': 109991,
    'latlng': [13.25, -61.2],
    'demonym': 'Saint Vincentian',
    'area': 389.0,
    'gini': null,
    'timezones': ['UTC-04:00'],
    'borders': [],
    'nativeName': 'Saint Vincent and the Grenadines',
    'numericCode': '670',
    'currencies': ['XCD'],
    'languages': ['en'],
    'translations': {
      'de': 'Saint Vincent und die Grenadinen',
      'es': 'San Vicente y Granadinas',
      'fr': 'Saint-Vincent-et-les-Grenadines',
      'ja': 'セントビンセントおよびグレナディーン諸島',
      'it': 'Saint Vincent e Grenadine'
    },
    'relevance': '0'
  }, {
    'name': 'Samoa',
    'topLevelDomain': ['.ws'],
    'alpha2Code': 'WS',
    'alpha3Code': 'WSM',
    'callingCodes': ['685'],
    'capital': 'Apia',
    'altSpellings': ['WS', 'Independent State of Samoa', 'Malo Saʻoloto Tutoʻatasi o Sāmoa'],
    'region': 'Oceania',
    'subregion': 'Polynesia',
    'population': 187820,
    'latlng': [-13.58333333, -172.33333333],
    'demonym': 'Samoan',
    'area': 2842.0,
    'gini': null,
    'timezones': ['UTC+13:00'],
    'borders': [],
    'nativeName': 'Samoa',
    'numericCode': '882',
    'currencies': ['WST'],
    'languages': ['sm', 'en'],
    'translations': { 'de': 'Samoa', 'es': 'Samoa', 'fr': 'Samoa', 'ja': 'サモア', 'it': 'Samoa' },
    'relevance': '0'
  }, {
    'name': 'San Marino',
    'topLevelDomain': ['.sm'],
    'alpha2Code': 'SM',
    'alpha3Code': 'SMR',
    'callingCodes': ['378'],
    'capital': 'City of San Marino',
    'altSpellings': ['SM', 'Republic of San Marino', 'Repubblica di San Marino'],
    'region': 'Europe',
    'subregion': 'Southern Europe',
    'population': 32831,
    'latlng': [43.76666666, 12.41666666],
    'demonym': 'Sammarinese',
    'area': 61.0,
    'gini': null,
    'timezones': ['UTC+01:00'],
    'borders': ['ITA'],
    'nativeName': 'San Marino',
    'numericCode': '674',
    'currencies': ['EUR'],
    'languages': ['it'],
    'translations': { 'de': 'San Marino', 'es': 'San Marino', 'fr': 'Saint-Marin', 'ja': 'サンマリノ', 'it': 'San Marino' },
    'relevance': '0'
  }, {
    'name': 'São Tomé and Príncipe',
    'topLevelDomain': ['.st'],
    'alpha2Code': 'ST',
    'alpha3Code': 'STP',
    'callingCodes': ['239'],
    'capital': 'São Tomé',
    'altSpellings': ['ST', 'Democratic Republic of São Tomé and Príncipe', 'República Democrática de São Tomé e Príncipe'],
    'region': 'Africa',
    'subregion': 'Middle Africa',
    'population': 187356,
    'latlng': [1.0, 7.0],
    'demonym': 'Sao Tomean',
    'area': 964.0,
    'gini': 50.8,
    'timezones': ['UTC'],
    'borders': [],
    'nativeName': 'São Tomé e Príncipe',
    'numericCode': '678',
    'currencies': ['STD'],
    'languages': ['pt'],
    'translations': {
      'de': 'São Tomé und Príncipe',
      'es': 'Santo Tomé y Príncipe',
      'fr': 'Sao Tomé-et-Principe',
      'ja': 'サントメ・プリンシペ',
      'it': 'São Tomé e Príncipe'
    },
    'relevance': '0'
  }, {
    'name': 'Saudi Arabia',
    'topLevelDomain': ['.sa'],
    'alpha2Code': 'SA',
    'alpha3Code': 'SAU',
    'callingCodes': ['966'],
    'capital': 'Riyadh',
    'altSpellings': ['SA', 'Kingdom of Saudi Arabia', 'Al-Mamlakah al-‘Arabiyyah as-Su‘ūdiyyah'],
    'region': 'Asia',
    'subregion': 'Western Asia',
    'population': 31521418,
    'latlng': [25.0, 45.0],
    'demonym': 'Saudi Arabian',
    'area': 2149690.0,
    'gini': null,
    'timezones': ['UTC+03:00'],
    'borders': ['IRQ', 'JOR', 'KWT', 'OMN', 'QAT', 'ARE', 'YEM'],
    'nativeName': 'العربية السعودية',
    'numericCode': '682',
    'currencies': ['SAR'],
    'languages': ['ar'],
    'translations': {
      'de': 'Saudi-Arabien',
      'es': 'Arabia Saudí',
      'fr': 'Arabie Saoudite',
      'ja': 'サウジアラビア',
      'it': 'Arabia Saudita'
    },
    'relevance': '0'
  }, {
    'name': 'Senegal',
    'topLevelDomain': ['.sn'],
    'alpha2Code': 'SN',
    'alpha3Code': 'SEN',
    'callingCodes': ['221'],
    'capital': 'Dakar',
    'altSpellings': ['SN', 'Republic of Senegal', 'République du Sénégal'],
    'region': 'Africa',
    'subregion': 'Western Africa',
    'population': 13508715,
    'latlng': [14.0, -14.0],
    'demonym': 'Senegalese',
    'area': 196722.0,
    'gini': 39.2,
    'timezones': ['UTC'],
    'borders': ['GMB', 'GIN', 'GNB', 'MLI', 'MRT'],
    'nativeName': 'Sénégal',
    'numericCode': '686',
    'currencies': ['XOF'],
    'languages': ['fr'],
    'translations': { 'de': 'Senegal', 'es': 'Senegal', 'fr': 'Sénégal', 'ja': 'セネガル', 'it': 'Senegal' },
    'relevance': '0'
  }, {
    'name': 'Serbia',
    'topLevelDomain': ['.rs'],
    'alpha2Code': 'RS',
    'alpha3Code': 'SRB',
    'callingCodes': ['381'],
    'capital': 'Belgrade',
    'altSpellings': ['RS', 'Srbija', 'Republic of Serbia', 'Република Србија', 'Republika Srbija'],
    'region': 'Europe',
    'subregion': 'Southern Europe',
    'population': 7114393,
    'latlng': [44.0, 21.0],
    'demonym': 'Serbian',
    'area': 88361.0,
    'gini': 27.8,
    'timezones': ['UTC+01:00'],
    'borders': ['BIH', 'BGR', 'HRV', 'HUN', 'KOS', 'MKD', 'MNE', 'ROU'],
    'nativeName': 'Србија',
    'numericCode': '688',
    'currencies': ['RSD'],
    'languages': ['sr'],
    'translations': { 'de': 'Serbien', 'es': 'Serbia', 'fr': 'Serbie', 'ja': 'セルビア', 'it': 'Serbia' },
    'relevance': '0'
  }, {
    'name': 'Seychelles',
    'topLevelDomain': ['.sc'],
    'alpha2Code': 'SC',
    'alpha3Code': 'SYC',
    'callingCodes': ['248'],
    'capital': 'Victoria',
    'altSpellings': ['SC', 'Republic of Seychelles', 'Repiblik Sesel', 'République des Seychelles'],
    'region': 'Africa',
    'subregion': 'Eastern Africa',
    'population': 89949,
    'latlng': [-4.58333333, 55.66666666],
    'demonym': 'Seychellois',
    'area': 452.0,
    'gini': 65.8,
    'timezones': ['UTC+04:00'],
    'borders': [],
    'nativeName': 'Seychelles',
    'numericCode': '690',
    'currencies': ['SCR'],
    'languages': ['fr', 'en'],
    'translations': { 'de': 'Seychellen', 'es': 'Seychelles', 'fr': 'Seychelles', 'ja': 'セーシェル', 'it': 'Seychelles' },
    'relevance': '0.5'
  }, {
    'name': 'Sierra Leone',
    'topLevelDomain': ['.sl'],
    'alpha2Code': 'SL',
    'alpha3Code': 'SLE',
    'callingCodes': ['232'],
    'capital': 'Freetown',
    'altSpellings': ['SL', 'Republic of Sierra Leone'],
    'region': 'Africa',
    'subregion': 'Western Africa',
    'population': 6453000,
    'latlng': [8.5, -11.5],
    'demonym': 'Sierra Leonean',
    'area': 71740.0,
    'gini': 42.5,
    'timezones': ['UTC'],
    'borders': ['GIN', 'LBR'],
    'nativeName': 'Sierra Leone',
    'numericCode': '694',
    'currencies': ['SLL'],
    'languages': ['en'],
    'translations': {
      'de': 'Sierra Leone',
      'es': 'Sierra Leone',
      'fr': 'Sierra Leone',
      'ja': 'シエラレオネ',
      'it': 'Sierra Leone'
    },
    'relevance': '0'
  }, {
    'name': 'Singapore',
    'topLevelDomain': ['.sg'],
    'alpha2Code': 'SG',
    'alpha3Code': 'SGP',
    'callingCodes': ['65'],
    'capital': 'Singapore',
    'altSpellings': ['SG', 'Singapura', 'Republik Singapura', '新加坡共和国'],
    'region': 'Asia',
    'subregion': 'South-Eastern Asia',
    'population': 5469700,
    'latlng': [1.36666666, 103.8],
    'demonym': 'Singaporean',
    'area': 710.0,
    'gini': 48.1,
    'timezones': ['UTC+08:00'],
    'borders': [],
    'nativeName': 'Singapore',
    'numericCode': '702',
    'currencies': ['SGD'],
    'languages': ['en', 'ms', 'ta', 'zh'],
    'translations': { 'de': 'Singapur', 'es': 'Singapur', 'fr': 'Singapour', 'ja': 'シンガポール', 'it': 'Singapore' },
    'relevance': '0'
  }, {
    'name': 'Sint Maarten',
    'topLevelDomain': ['.sx'],
    'alpha2Code': 'SX',
    'alpha3Code': 'SXM',
    'callingCodes': ['1721'],
    'capital': 'Philipsburg',
    'altSpellings': ['SX'],
    'region': 'Americas',
    'subregion': 'Caribbean',
    'population': 37429,
    'latlng': [18.033333, -63.05],
    'demonym': 'Dutch',
    'area': 34.0,
    'gini': null,
    'timezones': ['UTC-04:00'],
    'borders': ['MAF'],
    'nativeName': 'Sint Maarten',
    'numericCode': '534',
    'currencies': ['ANG'],
    'languages': ['nl', 'en'],
    'translations': { 'de': null, 'es': null, 'fr': null, 'ja': null, 'it': null },
    'relevance': '0'
  }, {
    'name': 'Slovakia',
    'topLevelDomain': ['.sk'],
    'alpha2Code': 'SK',
    'alpha3Code': 'SVK',
    'callingCodes': ['421'],
    'capital': 'Bratislava',
    'altSpellings': ['SK', 'Slovak Republic', 'Slovenská republika'],
    'region': 'Europe',
    'subregion': 'Eastern Europe',
    'population': 5421349,
    'latlng': [48.66666666, 19.5],
    'demonym': 'Slovak',
    'area': 49037.0,
    'gini': 26.0,
    'timezones': ['UTC+01:00'],
    'borders': ['AUT', 'CZE', 'HUN', 'POL', 'UKR'],
    'nativeName': 'Slovensko',
    'numericCode': '703',
    'currencies': ['EUR'],
    'languages': ['sk'],
    'translations': { 'de': 'Slowakei', 'es': 'República Eslovaca', 'fr': 'Slovaquie', 'ja': 'スロバキア', 'it': 'Slovacchia' },
    'relevance': '0'
  }, {
    'name': 'Slovenia',
    'topLevelDomain': ['.si'],
    'alpha2Code': 'SI',
    'alpha3Code': 'SVN',
    'callingCodes': ['386'],
    'capital': 'Ljubljana',
    'altSpellings': ['SI', 'Republic of Slovenia', 'Republika Slovenija'],
    'region': 'Europe',
    'subregion': 'Southern Europe',
    'population': 2067683,
    'latlng': [46.11666666, 14.81666666],
    'demonym': 'Slovene',
    'area': 20273.0,
    'gini': 31.2,
    'timezones': ['UTC+01:00'],
    'borders': ['AUT', 'HRV', 'ITA', 'HUN'],
    'nativeName': 'Slovenija',
    'numericCode': '705',
    'currencies': ['EUR'],
    'languages': ['sl'],
    'translations': { 'de': 'Slowenien', 'es': 'Eslovenia', 'fr': 'Slovénie', 'ja': 'スロベニア', 'it': 'Slovenia' },
    'relevance': '0'
  }, {
    'name': 'Solomon Islands',
    'topLevelDomain': ['.sb'],
    'alpha2Code': 'SB',
    'alpha3Code': 'SLB',
    'callingCodes': ['677'],
    'capital': 'Honiara',
    'altSpellings': ['SB'],
    'region': 'Oceania',
    'subregion': 'Melanesia',
    'population': 581344,
    'latlng': [-8.0, 159.0],
    'demonym': 'Solomon Islander',
    'area': 28896.0,
    'gini': null,
    'timezones': ['UTC+11:00'],
    'borders': [],
    'nativeName': 'Solomon Islands',
    'numericCode': '090',
    'currencies': ['SBD'],
    'languages': ['en'],
    'translations': {
      'de': 'Salomonen',
      'es': 'Islas Salomón',
      'fr': 'Îles Salomon',
      'ja': 'ソロモン諸島',
      'it': 'Isole Salomone'
    },
    'relevance': '0'
  }, {
    'name': 'Somalia',
    'topLevelDomain': ['.so'],
    'alpha2Code': 'SO',
    'alpha3Code': 'SOM',
    'callingCodes': ['252'],
    'capital': 'Mogadishu',
    'altSpellings': ['SO', 'aṣ-Ṣūmāl', 'Federal Republic of Somalia', 'Jamhuuriyadda Federaalka Soomaaliya', 'Jumhūriyyat aṣ-Ṣūmāl al-Fiderāliyya'],
    'region': 'Africa',
    'subregion': 'Eastern Africa',
    'population': 10787000,
    'latlng': [10.0, 49.0],
    'demonym': 'Somali',
    'area': 637657.0,
    'gini': null,
    'timezones': ['UTC+03:00'],
    'borders': ['DJI', 'ETH', 'KEN'],
    'nativeName': 'Soomaaliya',
    'numericCode': '706',
    'currencies': ['SOS'],
    'languages': ['so', 'ar'],
    'translations': { 'de': 'Somalia', 'es': 'Somalia', 'fr': 'Somalie', 'ja': 'ソマリア', 'it': 'Somalia' },
    'relevance': '0'
  }, {
    'name': 'South Africa',
    'topLevelDomain': ['.za'],
    'alpha2Code': 'ZA',
    'alpha3Code': 'ZAF',
    'callingCodes': ['27'],
    'capital': 'Pretoria',
    'altSpellings': ['ZA', 'RSA', 'Suid-Afrika', 'Republic of South Africa'],
    'region': 'Africa',
    'subregion': 'Southern Africa',
    'population': 54956900,
    'latlng': [-29.0, 24.0],
    'demonym': 'South African',
    'area': 1221037.0,
    'gini': 63.1,
    'timezones': ['UTC+02:00'],
    'borders': ['BWA', 'LSO', 'MOZ', 'NAM', 'SWZ', 'ZWE'],
    'nativeName': 'South Africa',
    'numericCode': '710',
    'currencies': ['ZAR'],
    'languages': ['af', 'en', 'nr', 'st', 'ss', 'tn', 'ts', 've', 'xh', 'zu'],
    'translations': {
      'de': 'Republik Südafrika',
      'es': 'República de Sudáfrica',
      'fr': 'Afrique du Sud',
      'ja': '南アフリカ',
      'it': 'Sud Africa'
    },
    'relevance': '0'
  }, {
    'name': 'South Georgia',
    'topLevelDomain': ['.gs'],
    'alpha2Code': 'GS',
    'alpha3Code': 'SGS',
    'callingCodes': ['500'],
    'capital': 'King Edward Point',
    'altSpellings': ['GS', 'South Georgia and the South Sandwich Islands'],
    'region': 'Americas',
    'subregion': 'South America',
    'population': 30,
    'latlng': [-54.5, -37.0],
    'demonym': 'South Georgia and the South Sandwich Islander',
    'area': null,
    'gini': null,
    'timezones': ['UTC-02:00'],
    'borders': [],
    'nativeName': 'South Georgia',
    'numericCode': '239',
    'currencies': ['GBP'],
    'languages': ['en'],
    'translations': {
      'de': 'Südgeorgien und die Südlichen Sandwichinseln',
      'es': 'Islas Georgias del Sur y Sandwich del Sur',
      'fr': 'Géorgie du Sud-et-les Îles Sandwich du Sud',
      'ja': 'サウスジョージア・サウスサンドウィッチ諸島',
      'it': 'Georgia del Sud e Isole Sandwich Meridionali'
    },
    'relevance': '0'
  }, {
    'name': 'South Korea',
    'topLevelDomain': ['.kr'],
    'alpha2Code': 'KR',
    'alpha3Code': 'KOR',
    'callingCodes': ['82'],
    'capital': 'Seoul',
    'altSpellings': ['KR', 'Republic of Korea'],
    'region': 'Asia',
    'subregion': 'Eastern Asia',
    'population': 51448183,
    'latlng': [37.0, 127.5],
    'demonym': 'South Korean',
    'area': 100210.0,
    'gini': 31.3,
    'timezones': ['UTC+09:00'],
    'borders': ['PRK'],
    'nativeName': '대한민국',
    'numericCode': '410',
    'currencies': ['KRW'],
    'languages': ['ko'],
    'translations': { 'de': 'Südkorea', 'es': 'Corea del Sur', 'fr': 'Corée du Sud', 'ja': '大韓民国', 'it': 'Corea del Sud' },
    'relevance': '1.5'
  }, {
    'name': 'South Sudan',
    'topLevelDomain': ['.ss'],
    'alpha2Code': 'SS',
    'alpha3Code': 'SSD',
    'callingCodes': ['211'],
    'capital': 'Juba',
    'altSpellings': ['SS'],
    'region': 'Africa',
    'subregion': 'Middle Africa',
    'population': 11892934,
    'latlng': [7.0, 30.0],
    'demonym': 'South Sudanese',
    'area': 619745.0,
    'gini': 45.5,
    'timezones': ['UTC+03:00'],
    'borders': ['CAF', 'COD', 'ETH', 'KEN', 'SDN', 'UGA'],
    'nativeName': 'South Sudan',
    'numericCode': '728',
    'currencies': ['SSP'],
    'languages': ['en'],
    'translations': {
      'de': 'Südsudan',
      'es': 'Sudán del Sur',
      'fr': 'Soudan du Sud',
      'ja': '南スーダン',
      'it': 'Sudan del sud'
    },
    'relevance': '0'
  }, {
    'name': 'Spain',
    'topLevelDomain': ['.es'],
    'alpha2Code': 'ES',
    'alpha3Code': 'ESP',
    'callingCodes': ['34'],
    'capital': 'Madrid',
    'altSpellings': ['ES', 'Kingdom of Spain', 'Reino de España'],
    'region': 'Europe',
    'subregion': 'Southern Europe',
    'population': 46439864,
    'latlng': [40.0, -4.0],
    'demonym': 'Spanish',
    'area': 505992.0,
    'gini': 34.7,
    'timezones': ['UTC', 'UTC+01:00'],
    'borders': ['AND', 'FRA', 'GIB', 'PRT', 'MAR'],
    'nativeName': 'España',
    'numericCode': '724',
    'currencies': ['EUR'],
    'languages': ['es'],
    'translations': { 'de': 'Spanien', 'es': 'España', 'fr': 'Espagne', 'ja': 'スペイン', 'it': 'Spagna' },
    'relevance': '2'
  }, {
    'name': 'Sri Lanka',
    'topLevelDomain': ['.lk'],
    'alpha2Code': 'LK',
    'alpha3Code': 'LKA',
    'callingCodes': ['94'],
    'capital': 'Colombo',
    'altSpellings': ['LK', 'ilaṅkai', 'Democratic Socialist Republic of Sri Lanka'],
    'region': 'Asia',
    'subregion': 'Southern Asia',
    'population': 20675000,
    'latlng': [7.0, 81.0],
    'demonym': 'Sri Lankan',
    'area': 65610.0,
    'gini': 40.3,
    'timezones': ['UTC+05:30'],
    'borders': ['IND'],
    'nativeName': 'śrī laṃkāva',
    'numericCode': '144',
    'currencies': ['LKR'],
    'languages': ['si', 'ta'],
    'translations': { 'de': 'Sri Lanka', 'es': 'Sri Lanka', 'fr': 'Sri Lanka', 'ja': 'スリランカ', 'it': 'Sri Lanka' },
    'relevance': '0'
  }, {
    'name': 'Sudan',
    'topLevelDomain': ['.sd'],
    'alpha2Code': 'SD',
    'alpha3Code': 'SDN',
    'callingCodes': ['249'],
    'capital': 'Khartoum',
    'altSpellings': ['SD', 'Republic of the Sudan', 'Jumhūrīyat as-Sūdān'],
    'region': 'Africa',
    'subregion': 'Northern Africa',
    'population': 38435252,
    'latlng': [15.0, 30.0],
    'demonym': 'Sudanese',
    'area': 1886068.0,
    'gini': 35.3,
    'timezones': ['UTC+03:00'],
    'borders': ['CAF', 'TCD', 'EGY', 'ERI', 'ETH', 'LBY', 'SSD'],
    'nativeName': 'السودان',
    'numericCode': '729',
    'currencies': ['SDG'],
    'languages': ['ar', 'en'],
    'translations': { 'de': 'Sudan', 'es': 'Sudán', 'fr': 'Soudan', 'ja': 'スーダン', 'it': 'Sudan' },
    'relevance': '0'
  }, {
    'name': 'Suriname',
    'topLevelDomain': ['.sr'],
    'alpha2Code': 'SR',
    'alpha3Code': 'SUR',
    'callingCodes': ['597'],
    'capital': 'Paramaribo',
    'altSpellings': ['SR', 'Sarnam', 'Sranangron', 'Republic of Suriname', 'Republiek Suriname'],
    'region': 'Americas',
    'subregion': 'South America',
    'population': 534189,
    'latlng': [4.0, -56.0],
    'demonym': 'Surinamer',
    'area': 163820.0,
    'gini': 52.9,
    'timezones': ['UTC-03:00'],
    'borders': ['BRA', 'GUF', 'FRA', 'GUY'],
    'nativeName': 'Suriname',
    'numericCode': '740',
    'currencies': ['SRD'],
    'languages': ['nl'],
    'translations': { 'de': 'Suriname', 'es': 'Surinam', 'fr': 'Surinam', 'ja': 'スリナム', 'it': 'Suriname' },
    'relevance': '0'
  }, {
    'name': 'Svalbard and Jan Mayen',
    'topLevelDomain': ['.sj'],
    'alpha2Code': 'SJ',
    'alpha3Code': 'SJM',
    'callingCodes': ['4779'],
    'capital': 'Longyearbyen',
    'altSpellings': ['SJ', 'Svalbard and Jan Mayen Islands'],
    'region': 'Europe',
    'subregion': 'Northern Europe',
    'population': 2562,
    'latlng': [78.0, 20.0],
    'demonym': 'Norwegian',
    'area': null,
    'gini': null,
    'timezones': ['UTC+01:00'],
    'borders': [],
    'nativeName': 'Svalbard og Jan Mayen',
    'numericCode': '744',
    'currencies': ['NOK'],
    'languages': ['no'],
    'translations': {
      'de': 'Svalbard und Jan Mayen',
      'es': 'Islas Svalbard y Jan Mayen',
      'fr': 'Svalbard et Jan Mayen',
      'ja': 'スヴァールバル諸島およびヤンマイエン島',
      'it': 'Svalbard e Jan Mayen'
    },
    'relevance': '0.5'
  }, {
    'name': 'Swaziland',
    'topLevelDomain': ['.sz'],
    'alpha2Code': 'SZ',
    'alpha3Code': 'SWZ',
    'callingCodes': ['268'],
    'capital': 'Lobamba',
    'altSpellings': ['SZ', 'weSwatini', 'Swatini', 'Ngwane', 'Kingdom of Swaziland', 'Umbuso waseSwatini'],
    'region': 'Africa',
    'subregion': 'Southern Africa',
    'population': 1119375,
    'latlng': [-26.5, 31.5],
    'demonym': 'Swazi',
    'area': 17364.0,
    'gini': 51.5,
    'timezones': ['UTC+02:00'],
    'borders': ['MOZ', 'ZAF'],
    'nativeName': 'Swaziland',
    'numericCode': '748',
    'currencies': ['SZL'],
    'languages': ['en', 'ss'],
    'translations': { 'de': 'Swasiland', 'es': 'Suazilandia', 'fr': 'Swaziland', 'ja': 'スワジランド', 'it': 'Swaziland' },
    'relevance': '0'
  }, {
    'name': 'Sweden',
    'topLevelDomain': ['.se'],
    'alpha2Code': 'SE',
    'alpha3Code': 'SWE',
    'callingCodes': ['46'],
    'capital': 'Stockholm',
    'altSpellings': ['SE', 'Kingdom of Sweden', 'Konungariket Sverige'],
    'region': 'Europe',
    'subregion': 'Northern Europe',
    'population': 9793172,
    'latlng': [62.0, 15.0],
    'demonym': 'Swedish',
    'area': 450295.0,
    'gini': 25.0,
    'timezones': ['UTC+01:00'],
    'borders': ['FIN', 'NOR'],
    'nativeName': 'Sverige',
    'numericCode': '752',
    'currencies': ['SEK'],
    'languages': ['sv'],
    'translations': { 'de': 'Schweden', 'es': 'Suecia', 'fr': 'Suède', 'ja': 'スウェーデン', 'it': 'Svezia' },
    'relevance': '1.5'
  }, {
    'name': 'Switzerland',
    'topLevelDomain': ['.ch'],
    'alpha2Code': 'CH',
    'alpha3Code': 'CHE',
    'callingCodes': ['41'],
    'capital': 'Bern',
    'altSpellings': ['CH', 'Swiss Confederation', 'Schweiz', 'Suisse', 'Svizzera', 'Svizra'],
    'region': 'Europe',
    'subregion': 'Western Europe',
    'population': 8256000,
    'latlng': [47.0, 8.0],
    'demonym': 'Swiss',
    'area': 41284.0,
    'gini': 33.7,
    'timezones': ['UTC+01:00'],
    'borders': ['AUT', 'FRA', 'ITA', 'LIE', 'DEU'],
    'nativeName': 'Schweiz',
    'numericCode': '756',
    'currencies': ['CHE', 'CHF', 'CHW'],
    'languages': ['de', 'fr', 'it'],
    'translations': { 'de': 'Schweiz', 'es': 'Suiza', 'fr': 'Suisse', 'ja': 'スイス', 'it': 'Svizzera' },
    'relevance': '1.5'
  }, {
    'name': 'Syria',
    'topLevelDomain': ['.sy'],
    'alpha2Code': 'SY',
    'alpha3Code': 'SYR',
    'callingCodes': ['963'],
    'capital': 'Damascus',
    'altSpellings': ['SY', 'Syrian Arab Republic', 'Al-Jumhūrīyah Al-ʻArabīyah As-Sūrīyah'],
    'region': 'Asia',
    'subregion': 'Western Asia',
    'population': 23339517,
    'latlng': [35.0, 38.0],
    'demonym': 'Syrian',
    'area': 185180.0,
    'gini': 35.8,
    'timezones': ['UTC+02:00'],
    'borders': ['IRQ', 'ISR', 'JOR', 'LBN', 'TUR'],
    'nativeName': 'سوريا',
    'numericCode': '760',
    'currencies': ['SYP'],
    'languages': ['ar'],
    'translations': { 'de': 'Syrien', 'es': 'Siria', 'fr': 'Syrie', 'ja': 'シリア・アラブ共和国', 'it': 'Siria' },
    'relevance': '0'
  }, {
    'name': 'Taiwan',
    'topLevelDomain': ['.tw'],
    'alpha2Code': 'TW',
    'alpha3Code': 'TWN',
    'callingCodes': ['886'],
    'capital': 'Taipei',
    'altSpellings': ['TW', 'Táiwān', 'Republic of China', '中華民國', 'Zhōnghuá Mínguó'],
    'region': 'Asia',
    'subregion': 'Eastern Asia',
    'population': 23461708,
    'latlng': [23.5, 121.0],
    'demonym': 'Taiwanese',
    'area': 36193.0,
    'gini': null,
    'timezones': ['UTC+08:00'],
    'borders': [],
    'nativeName': '臺灣',
    'numericCode': '158',
    'currencies': ['TWD'],
    'languages': ['zh'],
    'translations': { 'de': 'Taiwan', 'es': 'Taiwán', 'fr': 'Taïwan', 'ja': '台湾（台湾省/中華民国）', 'it': 'Taiwan' },
    'relevance': '0'
  }, {
    'name': 'Tajikistan',
    'topLevelDomain': ['.tj'],
    'alpha2Code': 'TJ',
    'alpha3Code': 'TJK',
    'callingCodes': ['992'],
    'capital': 'Dushanbe',
    'altSpellings': ['TJ', 'Toçikiston', 'Republic of Tajikistan', 'Ҷумҳурии Тоҷикистон', 'Çumhuriyi Toçikiston'],
    'region': 'Asia',
    'subregion': 'Central Asia',
    'population': 8354000,
    'latlng': [39.0, 71.0],
    'demonym': 'Tadzhik',
    'area': 143100.0,
    'gini': 30.8,
    'timezones': ['UTC+05:00'],
    'borders': ['AFG', 'CHN', 'KGZ', 'UZB'],
    'nativeName': 'Тоҷикистон',
    'numericCode': '762',
    'currencies': ['TJS'],
    'languages': ['tg', 'ru'],
    'translations': { 'de': 'Tadschikistan', 'es': 'Tayikistán', 'fr': 'Tadjikistan', 'ja': 'タジキスタン', 'it': 'Tagikistan' },
    'relevance': '0'
  }, {
    'name': 'Tanzania',
    'topLevelDomain': ['.tz'],
    'alpha2Code': 'TZ',
    'alpha3Code': 'TZA',
    'callingCodes': ['255'],
    'capital': 'Dodoma',
    'altSpellings': ['TZ', 'United Republic of Tanzania', 'Jamhuri ya Muungano wa Tanzania'],
    'region': 'Africa',
    'subregion': 'Eastern Africa',
    'population': 53470000,
    'latlng': [-6.0, 35.0],
    'demonym': 'Tanzanian',
    'area': 945087.0,
    'gini': 37.6,
    'timezones': ['UTC+03:00'],
    'borders': ['BDI', 'COD', 'KEN', 'MWI', 'MOZ', 'RWA', 'UGA', 'ZMB'],
    'nativeName': 'Tanzania',
    'numericCode': '834',
    'currencies': ['TZS'],
    'languages': ['sw', 'en'],
    'translations': { 'de': 'Tansania', 'es': 'Tanzania', 'fr': 'Tanzanie', 'ja': 'タンザニア', 'it': 'Tanzania' },
    'relevance': '0'
  }, {
    'name': 'Thailand',
    'topLevelDomain': ['.th'],
    'alpha2Code': 'TH',
    'alpha3Code': 'THA',
    'callingCodes': ['66'],
    'capital': 'Bangkok',
    'altSpellings': ['TH', 'Prathet', 'Thai', 'Kingdom of Thailand', 'ราชอาณาจักรไทย', 'Ratcha Anachak Thai'],
    'region': 'Asia',
    'subregion': 'South-Eastern Asia',
    'population': 65104000,
    'latlng': [15.0, 100.0],
    'demonym': 'Thai',
    'area': 513120.0,
    'gini': 40.0,
    'timezones': ['UTC+07:00'],
    'borders': ['MMR', 'KHM', 'LAO', 'MYS'],
    'nativeName': 'ประเทศไทย',
    'numericCode': '764',
    'currencies': ['THB'],
    'languages': ['th'],
    'translations': { 'de': 'Thailand', 'es': 'Tailandia', 'fr': 'Thaïlande', 'ja': 'タイ', 'it': 'Tailandia' },
    'relevance': '0'
  }, {
    'name': 'East Timor',
    'topLevelDomain': ['.tl'],
    'alpha2Code': 'TL',
    'alpha3Code': 'TLS',
    'callingCodes': ['670'],
    'capital': 'Dili',
    'altSpellings': ['TL', 'East Timor', 'Democratic Republic of Timor-Leste', 'República Democrática de Timor-Leste', 'Repúblika Demokrátika Timór-Leste'],
    'region': 'Asia',
    'subregion': 'South-Eastern Asia',
    'population': 1212107,
    'latlng': [-8.83333333, 125.91666666],
    'demonym': 'East Timorese',
    'area': 14874.0,
    'gini': 31.9,
    'timezones': ['UTC+09:00'],
    'borders': ['IDN'],
    'nativeName': 'Timor-Leste',
    'numericCode': '626',
    'currencies': ['USD'],
    'languages': ['pt'],
    'translations': {
      'de': 'Timor-Leste',
      'es': 'Timor Oriental',
      'fr': 'Timor oriental',
      'ja': '東ティモール',
      'it': 'Timor Est'
    },
    'relevance': '0'
  }, {
    'name': 'Togo',
    'topLevelDomain': ['.tg'],
    'alpha2Code': 'TG',
    'alpha3Code': 'TGO',
    'callingCodes': ['228'],
    'capital': 'Lomé',
    'altSpellings': ['TG', 'Togolese', 'Togolese Republic', 'République Togolaise'],
    'region': 'Africa',
    'subregion': 'Western Africa',
    'population': 7305000,
    'latlng': [8.0, 1.16666666],
    'demonym': 'Togolese',
    'area': 56785.0,
    'gini': 34.4,
    'timezones': ['UTC'],
    'borders': ['BEN', 'BFA', 'GHA'],
    'nativeName': 'Togo',
    'numericCode': '768',
    'currencies': ['XOF'],
    'languages': ['fr'],
    'translations': { 'de': 'Togo', 'es': 'Togo', 'fr': 'Togo', 'ja': 'トーゴ', 'it': 'Togo' },
    'relevance': '0'
  }, {
    'name': 'Tokelau',
    'topLevelDomain': ['.tk'],
    'alpha2Code': 'TK',
    'alpha3Code': 'TKL',
    'callingCodes': ['690'],
    'capital': 'Fakaofo',
    'altSpellings': ['TK'],
    'region': 'Oceania',
    'subregion': 'Polynesia',
    'population': 1411,
    'latlng': [-9.0, -172.0],
    'demonym': 'Tokelauan',
    'area': 12.0,
    'gini': null,
    'timezones': ['UTC+13:00'],
    'borders': [],
    'nativeName': 'Tokelau',
    'numericCode': '772',
    'currencies': ['NZD'],
    'languages': ['en'],
    'translations': { 'de': 'Tokelau', 'es': 'Islas Tokelau', 'fr': 'Tokelau', 'ja': 'トケラウ', 'it': 'Isole Tokelau' },
    'relevance': '0.5'
  }, {
    'name': 'Tonga',
    'topLevelDomain': ['.to'],
    'alpha2Code': 'TO',
    'alpha3Code': 'TON',
    'callingCodes': ['676'],
    'capital': 'Nuku\'alofa',
    'altSpellings': ['TO'],
    'region': 'Oceania',
    'subregion': 'Polynesia',
    'population': 103252,
    'latlng': [-20.0, -175.0],
    'demonym': 'Tongan',
    'area': 747.0,
    'gini': null,
    'timezones': ['UTC+13:00'],
    'borders': [],
    'nativeName': 'Tonga',
    'numericCode': '776',
    'currencies': ['TOP'],
    'languages': ['en', 'to'],
    'translations': { 'de': 'Tonga', 'es': 'Tonga', 'fr': 'Tonga', 'ja': 'トンガ', 'it': 'Tonga' },
    'relevance': '0'
  }, {
    'name': 'Trinidad and Tobago',
    'topLevelDomain': ['.tt'],
    'alpha2Code': 'TT',
    'alpha3Code': 'TTO',
    'callingCodes': ['1868'],
    'capital': 'Port of Spain',
    'altSpellings': ['TT', 'Republic of Trinidad and Tobago'],
    'region': 'Americas',
    'subregion': 'Caribbean',
    'population': 1340557,
    'latlng': [11.0, -61.0],
    'demonym': 'Trinidadian',
    'area': 5130.0,
    'gini': 40.3,
    'timezones': ['UTC-04:00'],
    'borders': [],
    'nativeName': 'Trinidad and Tobago',
    'numericCode': '780',
    'currencies': ['TTD'],
    'languages': ['en'],
    'translations': {
      'de': 'Trinidad und Tobago',
      'es': 'Trinidad y Tobago',
      'fr': 'Trinité et Tobago',
      'ja': 'トリニダード・トバゴ',
      'it': 'Trinidad e Tobago'
    },
    'relevance': '0'
  }, {
    'name': 'Tunisia',
    'topLevelDomain': ['.tn'],
    'alpha2Code': 'TN',
    'alpha3Code': 'TUN',
    'callingCodes': ['216'],
    'capital': 'Tunis',
    'altSpellings': ['TN', 'Republic of Tunisia', 'al-Jumhūriyyah at-Tūnisiyyah'],
    'region': 'Africa',
    'subregion': 'Northern Africa',
    'population': 10982754,
    'latlng': [34.0, 9.0],
    'demonym': 'Tunisian',
    'area': 163610.0,
    'gini': 41.4,
    'timezones': ['UTC+01:00'],
    'borders': ['DZA', 'LBY'],
    'nativeName': 'تونس',
    'numericCode': '788',
    'currencies': ['TND'],
    'languages': ['ar'],
    'translations': { 'de': 'Tunesien', 'es': 'Túnez', 'fr': 'Tunisie', 'ja': 'チュニジア', 'it': 'Tunisia' },
    'relevance': '0'
  }, {
    'name': 'Turkey',
    'topLevelDomain': ['.tr'],
    'alpha2Code': 'TR',
    'alpha3Code': 'TUR',
    'callingCodes': ['90'],
    'capital': 'Ankara',
    'altSpellings': ['TR', 'Turkiye', 'Republic of Turkey', 'Türkiye Cumhuriyeti'],
    'region': 'Asia',
    'subregion': 'Western Asia',
    'population': 77695904,
    'latlng': [39.0, 35.0],
    'demonym': 'Turkish',
    'area': 783562.0,
    'gini': 39.0,
    'timezones': ['UTC+02:00'],
    'borders': ['ARM', 'AZE', 'BGR', 'GEO', 'GRC', 'IRN', 'IRQ', 'SYR'],
    'nativeName': 'Türkiye',
    'numericCode': '792',
    'currencies': ['TRY'],
    'languages': ['tr'],
    'translations': { 'de': 'Türkei', 'es': 'Turquía', 'fr': 'Turquie', 'ja': 'トルコ', 'it': 'Turchia' },
    'relevance': '0'
  }, {
    'name': 'Turkmenistan',
    'topLevelDomain': ['.tm'],
    'alpha2Code': 'TM',
    'alpha3Code': 'TKM',
    'callingCodes': ['993'],
    'capital': 'Ashgabat',
    'altSpellings': ['TM'],
    'region': 'Asia',
    'subregion': 'Central Asia',
    'population': 4751120,
    'latlng': [40.0, 60.0],
    'demonym': 'Turkmen',
    'area': 488100.0,
    'gini': 40.8,
    'timezones': ['UTC+05:00'],
    'borders': ['AFG', 'IRN', 'KAZ', 'UZB'],
    'nativeName': 'Türkmenistan',
    'numericCode': '795',
    'currencies': ['TMT'],
    'languages': ['tk', 'ru'],
    'translations': {
      'de': 'Turkmenistan',
      'es': 'Turkmenistán',
      'fr': 'Turkménistan',
      'ja': 'トルクメニスタン',
      'it': 'Turkmenistan'
    },
    'relevance': '0'
  }, {
    'name': 'Turks and Caicos Islands',
    'topLevelDomain': ['.tc'],
    'alpha2Code': 'TC',
    'alpha3Code': 'TCA',
    'callingCodes': ['1649'],
    'capital': 'Cockburn Town',
    'altSpellings': ['TC'],
    'region': 'Americas',
    'subregion': 'Caribbean',
    'population': 31458,
    'latlng': [21.75, -71.58333333],
    'demonym': 'Turks and Caicos Islander',
    'area': 948.0,
    'gini': null,
    'timezones': ['UTC-04:00'],
    'borders': [],
    'nativeName': 'Turks and Caicos Islands',
    'numericCode': '796',
    'currencies': ['USD'],
    'languages': ['en'],
    'translations': {
      'de': 'Turks- und Caicosinseln',
      'es': 'Islas Turks y Caicos',
      'fr': 'Îles Turques-et-Caïques',
      'ja': 'タークス・カイコス諸島',
      'it': 'Isole Turks e Caicos'
    },
    'relevance': '0.5'
  }, {
    'name': 'Tuvalu',
    'topLevelDomain': ['.tv'],
    'alpha2Code': 'TV',
    'alpha3Code': 'TUV',
    'callingCodes': ['688'],
    'capital': 'Funafuti',
    'altSpellings': ['TV'],
    'region': 'Oceania',
    'subregion': 'Polynesia',
    'population': 10640,
    'latlng': [-8.0, 178.0],
    'demonym': 'Tuvaluan',
    'area': 26.0,
    'gini': null,
    'timezones': ['UTC+12:00'],
    'borders': [],
    'nativeName': 'Tuvalu',
    'numericCode': '798',
    'currencies': ['AUD'],
    'languages': ['en'],
    'translations': { 'de': 'Tuvalu', 'es': 'Tuvalu', 'fr': 'Tuvalu', 'ja': 'ツバル', 'it': 'Tuvalu' },
    'relevance': '0.5'
  }, {
    'name': 'Uganda',
    'topLevelDomain': ['.ug'],
    'alpha2Code': 'UG',
    'alpha3Code': 'UGA',
    'callingCodes': ['256'],
    'capital': 'Kampala',
    'altSpellings': ['UG', 'Republic of Uganda', 'Jamhuri ya Uganda'],
    'region': 'Africa',
    'subregion': 'Eastern Africa',
    'population': 34856813,
    'latlng': [1.0, 32.0],
    'demonym': 'Ugandan',
    'area': 241550.0,
    'gini': 44.3,
    'timezones': ['UTC+03:00'],
    'borders': ['COD', 'KEN', 'RWA', 'SSD', 'TZA'],
    'nativeName': 'Uganda',
    'numericCode': '800',
    'currencies': ['UGX'],
    'languages': ['en', 'sw'],
    'translations': { 'de': 'Uganda', 'es': 'Uganda', 'fr': 'Uganda', 'ja': 'ウガンダ', 'it': 'Uganda' },
    'relevance': '0'
  }, {
    'name': 'Ukraine',
    'topLevelDomain': ['.ua'],
    'alpha2Code': 'UA',
    'alpha3Code': 'UKR',
    'callingCodes': ['380'],
    'capital': 'Kiev',
    'altSpellings': ['UA', 'Ukrayina'],
    'region': 'Europe',
    'subregion': 'Eastern Europe',
    'population': 42836922,
    'latlng': [49.0, 32.0],
    'demonym': 'Ukrainian',
    'area': 603700.0,
    'gini': 26.4,
    'timezones': ['UTC+02:00'],
    'borders': ['BLR', 'HUN', 'MDA', 'POL', 'ROU', 'RUS', 'SVK'],
    'nativeName': 'Україна',
    'numericCode': '804',
    'currencies': ['UAH'],
    'languages': ['uk'],
    'translations': { 'de': 'Ukraine', 'es': 'Ucrania', 'fr': 'Ukraine', 'ja': 'ウクライナ', 'it': 'Ucraina' },
    'relevance': '0'
  }, {
    'name': 'United Arab Emirates',
    'topLevelDomain': ['.ae'],
    'alpha2Code': 'AE',
    'alpha3Code': 'ARE',
    'callingCodes': ['971'],
    'capital': 'Abu Dhabi',
    'altSpellings': ['AE', 'UAE'],
    'region': 'Asia',
    'subregion': 'Western Asia',
    'population': 9157000,
    'latlng': [24.0, 54.0],
    'demonym': 'Emirati',
    'area': 83600.0,
    'gini': null,
    'timezones': ['UTC+04'],
    'borders': ['OMN', 'SAU'],
    'nativeName': 'دولة الإمارات العربية المتحدة',
    'numericCode': '784',
    'currencies': ['AED'],
    'languages': ['ar'],
    'translations': {
      'de': 'Vereinigte Arabische Emirate',
      'es': 'Emiratos Árabes Unidos',
      'fr': 'Émirats arabes unis',
      'ja': 'アラブ首長国連邦',
      'it': 'Emirati Arabi Uniti'
    },
    'relevance': '0'
  }, {
    'name': 'United Kingdom',
    'topLevelDomain': ['.uk'],
    'alpha2Code': 'GB',
    'alpha3Code': 'GBR',
    'callingCodes': ['44'],
    'capital': 'London',
    'altSpellings': ['GB', 'UK', 'Great Britain'],
    'region': 'Europe',
    'subregion': 'Northern Europe',
    'population': 64800000,
    'latlng': [54.0, -2.0],
    'demonym': 'British',
    'area': 242900.0,
    'gini': 34.0,
    'timezones': ['UTC-08:00', 'UTC-05:00', 'UTC-04:00', 'UTC-03:00', 'UTC-02:00', 'UTC', 'UTC+01:00', 'UTC+02:00', 'UTC+06:00'],
    'borders': ['IRL'],
    'nativeName': 'United Kingdom',
    'numericCode': '826',
    'currencies': ['GBP'],
    'languages': ['en'],
    'translations': {
      'de': 'Vereinigtes Königreich',
      'es': 'Reino Unido',
      'fr': 'Royaume-Uni',
      'ja': 'イギリス',
      'it': 'Regno Unito'
    },
    'relevance': '2.5'
  }, {
    'name': 'United States',
    'topLevelDomain': ['.us'],
    'alpha2Code': 'US',
    'alpha3Code': 'USA',
    'callingCodes': ['1'],
    'capital': 'Washington, D.C.',
    'altSpellings': ['US', 'USA', 'United States of America'],
    'region': 'Americas',
    'subregion': 'Northern America',
    'population': 321645000,
    'latlng': [38.0, -97.0],
    'demonym': 'American',
    'area': 9629091.0,
    'gini': 48.0,
    'timezones': ['UTC-12:00', 'UTC-11:00', 'UTC-10:00', 'UTC-09:00', 'UTC-08:00', 'UTC-07:00', 'UTC-06:00', 'UTC-05:00', 'UTC-04:00', 'UTC+10:00', 'UTC+12:00'],
    'borders': ['CAN', 'MEX'],
    'nativeName': 'United States',
    'numericCode': '840',
    'currencies': ['USD', 'USN', 'USS'],
    'languages': ['en'],
    'translations': {
      'de': 'Vereinigte Staaten von Amerika',
      'es': 'Estados Unidos',
      'fr': 'États-Unis',
      'ja': 'アメリカ合衆国',
      'it': 'Stati Uniti D\'America'
    },
    'relevance': '3.5'
  }, {
    'name': 'Uruguay',
    'topLevelDomain': ['.uy'],
    'alpha2Code': 'UY',
    'alpha3Code': 'URY',
    'callingCodes': ['598'],
    'capital': 'Montevideo',
    'altSpellings': ['UY', 'Oriental Republic of Uruguay', 'República Oriental del Uruguay'],
    'region': 'Americas',
    'subregion': 'South America',
    'population': 3415866,
    'latlng': [-33.0, -56.0],
    'demonym': 'Uruguayan',
    'area': 181034.0,
    'gini': 39.7,
    'timezones': ['UTC-03:00'],
    'borders': ['ARG', 'BRA'],
    'nativeName': 'Uruguay',
    'numericCode': '858',
    'currencies': ['UYI', 'UYU'],
    'languages': ['es'],
    'translations': { 'de': 'Uruguay', 'es': 'Uruguay', 'fr': 'Uruguay', 'ja': 'ウルグアイ', 'it': 'Uruguay' },
    'relevance': '0'
  }, {
    'name': 'Uzbekistan',
    'topLevelDomain': ['.uz'],
    'alpha2Code': 'UZ',
    'alpha3Code': 'UZB',
    'callingCodes': ['998'],
    'capital': 'Tashkent',
    'altSpellings': ['UZ', 'Republic of Uzbekistan', 'O‘zbekiston Respublikasi', 'Ўзбекистон Республикаси'],
    'region': 'Asia',
    'subregion': 'Central Asia',
    'population': 31022500,
    'latlng': [41.0, 64.0],
    'demonym': 'Uzbekistani',
    'area': 447400.0,
    'gini': 36.7,
    'timezones': ['UTC+05:00'],
    'borders': ['AFG', 'KAZ', 'KGZ', 'TJK', 'TKM'],
    'nativeName': 'O‘zbekiston',
    'numericCode': '860',
    'currencies': ['UZS'],
    'languages': ['uz', 'ru'],
    'translations': { 'de': 'Usbekistan', 'es': 'Uzbekistán', 'fr': 'Ouzbékistan', 'ja': 'ウズベキスタン', 'it': 'Uzbekistan' },
    'relevance': '0'
  }, {
    'name': 'Vanuatu',
    'topLevelDomain': ['.vu'],
    'alpha2Code': 'VU',
    'alpha3Code': 'VUT',
    'callingCodes': ['678'],
    'capital': 'Port Vila',
    'altSpellings': ['VU', 'Republic of Vanuatu', 'Ripablik blong Vanuatu', 'République de Vanuatu'],
    'region': 'Oceania',
    'subregion': 'Melanesia',
    'population': 264652,
    'latlng': [-16.0, 167.0],
    'demonym': 'Ni-Vanuatu',
    'area': 12189.0,
    'gini': null,
    'timezones': ['UTC+11:00'],
    'borders': [],
    'nativeName': 'Vanuatu',
    'numericCode': '548',
    'currencies': ['VUV'],
    'languages': ['bi', 'en', 'fr'],
    'translations': { 'de': 'Vanuatu', 'es': 'Vanuatu', 'fr': 'Vanuatu', 'ja': 'バヌアツ', 'it': 'Vanuatu' },
    'relevance': '0'
  }, {
    'name': 'Venezuela',
    'topLevelDomain': ['.ve'],
    'alpha2Code': 'VE',
    'alpha3Code': 'VEN',
    'callingCodes': ['58'],
    'capital': 'Caracas',
    'altSpellings': ['VE', 'Bolivarian Republic of Venezuela', 'República Bolivariana de Venezuela'],
    'region': 'Americas',
    'subregion': 'South America',
    'population': 30620404,
    'latlng': [8.0, -66.0],
    'demonym': 'Venezuelan',
    'area': 916445.0,
    'gini': 44.8,
    'timezones': ['UTC-04:30'],
    'borders': ['BRA', 'COL', 'GUY'],
    'nativeName': 'Venezuela',
    'numericCode': '862',
    'currencies': ['VEF'],
    'languages': ['es'],
    'translations': { 'de': 'Venezuela', 'es': 'Venezuela', 'fr': 'Venezuela', 'ja': 'ベネズエラ・ボリバル共和国', 'it': 'Venezuela' },
    'relevance': '0'
  }, {
    'name': 'Vietnam',
    'topLevelDomain': ['.vn'],
    'alpha2Code': 'VN',
    'alpha3Code': 'VNM',
    'callingCodes': ['84'],
    'capital': 'Hanoi',
    'altSpellings': ['VN', 'Socialist Republic of Vietnam', 'Cộng hòa Xã hội chủ nghĩa Việt Nam'],
    'region': 'Asia',
    'subregion': 'South-Eastern Asia',
    'population': 91812000,
    'latlng': [16.16666666, 107.83333333],
    'demonym': 'Vietnamese',
    'area': 331212.0,
    'gini': 35.6,
    'timezones': ['UTC+07:00'],
    'borders': ['KHM', 'CHN', 'LAO'],
    'nativeName': 'Việt Nam',
    'numericCode': '704',
    'currencies': ['VND'],
    'languages': ['vi'],
    'translations': { 'de': 'Vietnam', 'es': 'Vietnam', 'fr': 'Viêt Nam', 'ja': 'ベトナム', 'it': 'Vietnam' },
    'relevance': '1.5'
  }, {
    'name': 'Wallis and Futuna',
    'topLevelDomain': ['.wf'],
    'alpha2Code': 'WF',
    'alpha3Code': 'WLF',
    'callingCodes': ['681'],
    'capital': 'Mata-Utu',
    'altSpellings': ['WF', 'Territory of the Wallis and Futuna Islands', 'Territoire des îles Wallis et Futuna'],
    'region': 'Oceania',
    'subregion': 'Polynesia',
    'population': 13135,
    'latlng': [-13.3, -176.2],
    'demonym': 'Wallis and Futuna Islander',
    'area': 142.0,
    'gini': null,
    'timezones': ['UTC+12:00'],
    'borders': [],
    'nativeName': 'Wallis et Futuna',
    'numericCode': '876',
    'currencies': ['XPF'],
    'languages': ['fr'],
    'translations': {
      'de': 'Wallis und Futuna',
      'es': 'Wallis y Futuna',
      'fr': 'Wallis-et-Futuna',
      'ja': 'ウォリス・フツナ',
      'it': 'Wallis e Futuna'
    },
    'relevance': '0.5'
  }, {
    'name': 'Western Sahara',
    'topLevelDomain': ['.eh'],
    'alpha2Code': 'EH',
    'alpha3Code': 'ESH',
    'callingCodes': ['212'],
    'capital': 'El Aaiún',
    'altSpellings': ['EH', 'Taneẓroft Tutrimt'],
    'region': 'Africa',
    'subregion': 'Northern Africa',
    'population': 510713,
    'latlng': [24.5, -13.0],
    'demonym': 'Sahrawi',
    'area': 266000.0,
    'gini': null,
    'timezones': ['UTC+00:00'],
    'borders': ['DZA', 'MRT', 'MAR'],
    'nativeName': 'الصحراء الغربية',
    'numericCode': '732',
    'currencies': ['MAD', 'DZD', 'MRO'],
    'languages': ['es'],
    'translations': {
      'de': 'Westsahara',
      'es': 'Sahara Occidental',
      'fr': 'Sahara Occidental',
      'ja': '西サハラ',
      'it': 'Sahara Occidentale'
    },
    'relevance': '0'
  }, {
    'name': 'Yemen',
    'topLevelDomain': ['.ye'],
    'alpha2Code': 'YE',
    'alpha3Code': 'YEM',
    'callingCodes': ['967'],
    'capital': 'Sana\'a',
    'altSpellings': ['YE', 'Yemeni Republic', 'al-Jumhūriyyah al-Yamaniyyah'],
    'region': 'Asia',
    'subregion': 'Western Asia',
    'population': 25956000,
    'latlng': [15.0, 48.0],
    'demonym': 'Yemeni',
    'area': 527968.0,
    'gini': 37.7,
    'timezones': ['UTC+03:00'],
    'borders': ['OMN', 'SAU'],
    'nativeName': 'اليَمَن',
    'numericCode': '887',
    'currencies': ['YER'],
    'languages': ['ar'],
    'translations': { 'de': 'Jemen', 'es': 'Yemen', 'fr': 'Yémen', 'ja': 'イエメン', 'it': 'Yemen' },
    'relevance': '0'
  }, {
    'name': 'Zambia',
    'topLevelDomain': ['.zm'],
    'alpha2Code': 'ZM',
    'alpha3Code': 'ZMB',
    'callingCodes': ['260'],
    'capital': 'Lusaka',
    'altSpellings': ['ZM', 'Republic of Zambia'],
    'region': 'Africa',
    'subregion': 'Eastern Africa',
    'population': 15473905,
    'latlng': [-15.0, 30.0],
    'demonym': 'Zambian',
    'area': 752612.0,
    'gini': 54.6,
    'timezones': ['UTC+02:00'],
    'borders': ['AGO', 'BWA', 'COD', 'MWI', 'MOZ', 'NAM', 'TZA', 'ZWE'],
    'nativeName': 'Zambia',
    'numericCode': '894',
    'currencies': ['ZMW'],
    'languages': ['en'],
    'translations': { 'de': 'Sambia', 'es': 'Zambia', 'fr': 'Zambie', 'ja': 'ザンビア', 'it': 'Zambia' },
    'relevance': '0'
  }, {
    'name': 'Zimbabwe',
    'topLevelDomain': ['.zw'],
    'alpha2Code': 'ZW',
    'alpha3Code': 'ZWE',
    'callingCodes': ['263'],
    'capital': 'Harare',
    'altSpellings': ['ZW', 'Republic of Zimbabwe'],
    'region': 'Africa',
    'subregion': 'Eastern Africa',
    'population': 13061239,
    'latlng': [-20.0, 30.0],
    'demonym': 'Zimbabwean',
    'area': 390757.0,
    'gini': null,
    'timezones': ['UTC+02:00'],
    'borders': ['BWA', 'MOZ', 'ZAF', 'ZMB'],
    'nativeName': 'Zimbabwe',
    'numericCode': '716',
    'currencies': ['USD'],
    'languages': ['en', 'sn', 'nd'],
    'translations': { 'de': 'Simbabwe', 'es': 'Zimbabue', 'fr': 'Zimbabwe', 'ja': 'ジンバブエ', 'it': 'Zimbabwe' },
    'relevance': '0'
  }]
});

/***/ }),
/* 1142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyArtistInfo_vue__ = __webpack_require__(555);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21a5baf4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyArtistInfo_vue__ = __webpack_require__(1147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1143)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-21a5baf4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyArtistInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21a5baf4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyArtistInfo_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21a5baf4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyArtistInfo_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1143 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentInfo_vue__ = __webpack_require__(556);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_046716b6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentInfo_vue__ = __webpack_require__(1146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1145)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-046716b6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_046716b6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentInfo_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_046716b6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentInfo_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1145 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex w-50-l w-100 h-100 flex-column textColor",staticStyle:{"display":"none"}},[_c('h3',{staticClass:"textColor"},[_vm._v(_vm._s(_vm.$t("payment.mpConnect.title")))]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.error),expression:"error"}],staticClass:"dark-red f7"},[_vm._v(_vm._s(_vm.error))]),_vm._v(" "),(_vm.user.mpConnected)?_c('div',[_c('p',{staticClass:"f6"},[_vm._v(_vm._s(_vm.$t("payment.mpConnect.connectedAs"))+":")]),_vm._v(" "),_c('div',{staticClass:"flex items-center justify-start textColor"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.info.profile_picture),expression:"info.profile_picture"}],staticClass:"picture flex item-center justify-center"},[_c('img',{staticClass:"w-100 h-100 iconColor",attrs:{"src":_vm.info.profile_picture}})]),_vm._v(" "),_c('div',{staticClass:"mw-100"},[_c('h1',{staticClass:"user-info f6 f5-ns fw6 lh-title mv0 mw-100 ph2 textColor"},[_vm._v(_vm._s(_vm.info.nickname)+" "),_c('small',{attrs:{"title":_vm.$t('payment.mpConnect.nickname_title_help')}},[_c('font-awesome-icon',{attrs:{"icon":"question-circle"}})],1)])])]),_vm._v(" "),_c('p',{staticClass:"f6 textColor"},[_vm._v(_vm._s(_vm.$t("payment.mpConnect.disconnectInfo"))+"\n      "),_c('a',{attrs:{"href":"https://appstore.mercadolibre.com.ar/apps/permissions","target":"_blank"}},[_vm._v("Mercado Pago")])])]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.user.mpConnected),expression:"!user.mpConnected"}],staticClass:"flex flex-column items-start-l items-center"},[_c('p',{staticClass:"w-100 tl textColor"},[_vm._v(_vm._s(_vm.$t("payment.mpConnect.info")))]),_vm._v(" "),_c('button',{staticClass:"w-50-ns w-100 block mv2 pointer btn dim b f5 fw4",on:{"click":_vm.connect}},[_vm._v(_vm._s(_vm.$t("payment.connect")))])])])}
var staticRenderFns = []


/***/ }),
/* 1147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loadingMyArtistInfo || _vm.loadingEdit),expression:"loadingMyArtistInfo || loadingEdit"}],staticClass:"mv2 flex justify-center w-100"},[_c('clip-loader',{attrs:{"loading":_vm.loadingMyArtistInfo || _vm.loadingEdit,"color":_vm.color,"size":_vm.size}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!(_vm.loadingMyArtistInfo || _vm.loadingEdit)),expression:"!(loadingMyArtistInfo || loadingEdit)"}]},[_c('h3',{staticClass:"textColor"},[_vm._v(_vm._s(_vm.$t("artists.info")))]),_vm._v(" "),_c('div',{staticClass:"flex flex-wrap"},[_c('div',{staticClass:"flex w-50-l w-100 h-100 ba"},[_c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
              content: _vm.msg,
              placement: 'bottom-center',
              classes: 'my_tooltip',
              offset: 5,
              delay: {
                show: 10,
                hide: 10,
              },
            }),expression:"{\n              content: msg,\n              placement: 'bottom-center',\n              classes: 'my_tooltip',\n              offset: 5,\n              delay: {\n                show: 10,\n                hide: 10,\n              },\n            }"}],staticClass:"db w-100 cover center relative image-container flex items-start",style:({ 'background-image': 'url(' + _vm.picture + ')'})},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.files.length && _vm.files[0].progress < 100),expression:"files.length && files[0].progress < 100"}],staticClass:"flex justify-center items-center h-100 w-100"},[_c('clip-loader',{attrs:{"loading":true,"color":_vm.color,"size":_vm.size}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.files.length),expression:"!files.length"}],staticClass:"flex justify-center"},[_c('file-upload',{ref:"imageUpload",staticClass:"ph2 pointer",attrs:{"post-action":_vm.url,"headers":_vm.postFileHeaders,"extensions":"jpg,jpeg,png,webp"},on:{"input-file":_vm.imageInputFile,"input-filter":_vm.imageInputFilter},model:{value:(_vm.files),callback:function ($$v) {_vm.files=$$v},expression:"files"}},[_c('div',{staticClass:"edit-button bg-primary ma2 br-100 flex items-center justify-center pointer"},[_c('font-awesome-icon',{staticClass:"white",attrs:{"icon":"camera"}})],1)])],1)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.myArtistInfo !== Object),expression:"myArtistInfo !== Object"}],staticClass:"w-50-l w-100 ph2"},[(_vm.error)?_c('p',{staticClass:"dark-red mh3 tc f7"},[_vm._v(_vm._s(_vm.error.message))]):_vm._e(),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.updateArtist.apply(null, arguments)}}},[_c('div',{staticClass:"mv2 w-100 flex flex-column"},[_c('label',{staticClass:"f7 textColor"},[_vm._v(_vm._s(_vm.$t("artists.name")))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.myArtistInfo.name),expression:"myArtistInfo.name"}],staticClass:"input f6 ph2",attrs:{"disabled":!_vm.edit},domProps:{"value":(_vm.myArtistInfo.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.myArtistInfo, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"mv2 w-100 flex flex-column"},[_c('label',{staticClass:"f7 textColor"},[_vm._v(_vm._s(_vm.$t("artists.phrase")))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.myArtistInfo.phrase),expression:"myArtistInfo.phrase"}],staticClass:"input f6 ph2",attrs:{"disabled":!_vm.edit},domProps:{"value":(_vm.myArtistInfo.phrase)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.myArtistInfo, "phrase", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"mv2 w-100 flex flex-column"},[_c('label',{staticClass:"f7 textColor"},[_vm._v(_vm._s(_vm.$t("artists.text")))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.myArtistInfo.text),expression:"myArtistInfo.text"}],staticClass:"input f6 ph2",attrs:{"disabled":!_vm.edit},domProps:{"value":(_vm.myArtistInfo.text)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.myArtistInfo, "text", $event.target.value)}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],staticClass:"flex justify-center"},[_c('input',{staticClass:"w-50-ns w-100 block mv2 pointer btn dim b f5 fw4",attrs:{"type":"submit"},domProps:{"value":_vm.$t('app.save')}})])])])])]),_vm._v(" "),_c('payment-info')],1)}
var staticRenderFns = []


/***/ }),
/* 1148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"flex w-100"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading || !_vm.user),expression:"loading || !user"}],staticClass:"flex justify-center mt3 w-100"},[_c('clip-loader',{attrs:{"loading":true,"color":_vm.color,"size":_vm.size}})],1),_vm._v(" "),_c('form',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading && _vm.user),expression:"!loading && user"}],staticClass:"w-100",on:{"submit":function($event){$event.preventDefault();return _vm.updateUser.apply(null, arguments)}}},[_c('div',{staticClass:"flex flex-column justify-center f6"},[(_vm.error && _vm.input === '')?_c('p',{staticClass:"dark-red mh3 tc f7"},[_vm._v(_vm._s(_vm.error))]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.user),expression:"user"}],staticClass:"flex-ns justify-center"},[_c('div',{staticClass:"w-50-ns w-100 pa2-ns pa1 flex flex-column"},[(_vm.$v.username.$error && !_vm.$v.username.required)?_c('span',{staticClass:"dark-red f7"},[_vm._v(_vm._s(_vm.$t("error.usernameRequired")))]):_vm._e(),_vm._v(" "),(_vm.error && _vm.input === 'username')?_c('span',{staticClass:"dark-red f7"},[_vm._v(_vm._s(_vm.error))]):_vm._e(),_vm._v(" "),_c('label',{staticClass:"f7 textColor",attrs:{"for":"username"}},[_vm._v(_vm._s(_vm.$t("users.username")))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.username),expression:"username"}],staticClass:"w-100 input ph2",class:{error: _vm.$v.username.$error || (_vm.error && _vm.input === 'username')},attrs:{"name":"username","id":"username","placeholder":_vm.$t('users.username'),"disabled":!_vm.edit},domProps:{"value":(_vm.username)},on:{"blur":_vm.$v.username.$touch,"input":function($event){if($event.target.composing){ return; }_vm.username=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"w-50-ns w-100 flex",class:{'input-margin': _vm.$v.username.$error}},[_c('div',{staticClass:"flex flex-column pa2-ns pa1 w-50"},[_c('label',{staticClass:"f7 textColor",attrs:{"for":"name"}},[_vm._v(_vm._s(_vm.$tc('users.name',2)))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],staticClass:"w-100 input ph2",attrs:{"name":"name","id":"name","placeholder":_vm.$tc('users.name',2),"disabled":!_vm.edit},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"flex flex-column pa2-ns pa1 w-50"},[_c('label',{staticClass:"f7 textColor",attrs:{"for":"surname"}},[_vm._v(_vm._s(_vm.$t("users.surnames")))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.surname),expression:"surname"}],staticClass:"w-100 input ph2",attrs:{"name":"surname","id":"surname","placeholder":_vm.$t('users.surnames'),"disabled":!_vm.edit},domProps:{"value":(_vm.surname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.surname=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"flex-ns justify-center"},[_c('div',{staticClass:"w-50-ns w-100 pa2-ns pa1 flex flex-column",class:{'input-margin': _vm.$v.phone.$error && !_vm.$v.dni.$error}},[(_vm.$v.dni.$error && !_vm.$v.dni.required)?_c('span',{staticClass:"dark-red f7"},[_vm._v(_vm._s(_vm.$t("error.idRequired")))]):_vm._e(),_vm._v(" "),_c('label',{staticClass:"f7 textColor",attrs:{"for":"dni"}},[_vm._v(_vm._s(_vm.$t("users.id")))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dni),expression:"dni"}],staticClass:"w-100 input ph2",class:{error: _vm.$v.dni.$error},attrs:{"name":"dni","id":"dni","placeholder":_vm.$t('users.id'),"disabled":!_vm.edit},domProps:{"value":(_vm.dni)},on:{"blur":_vm.$v.dni.$touch,"input":function($event){if($event.target.composing){ return; }_vm.dni=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"w-50-ns w-100 pa2-ns pa1 flex flex-column",class:{'input-margin': _vm.$v.dni.$error && !_vm.$v.phone.$error}},[(_vm.$v.phone.$error && !_vm.$v.phone.numeric)?_c('span',{staticClass:"dark-red f7"},[_vm._v(_vm._s(_vm.$t("error.phoneInvalid")))]):_vm._e(),_vm._v(" "),_c('label',{staticClass:"f7 textColor",attrs:{"for":"phone"}},[_vm._v(_vm._s(_vm.$t("users.phone")))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone),expression:"phone"}],staticClass:"w-100 input ph2",class:{error: _vm.$v.phone.$error},attrs:{"disabled":!_vm.edit,"name":"phone","id":"phone","placeholder":_vm.$t('users.phone')},domProps:{"value":(_vm.phone)},on:{"blur":_vm.$v.phone.$touch,"input":function($event){if($event.target.composing){ return; }_vm.phone=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"flex-ns db justify-left"},[_c('div',{staticClass:"w-50-ns w-100 pa2-ns pa1 flex flex-column",class:{'input-margin': _vm.$v.email2.$error && !_vm.$v.email.$error}},[(_vm.error && _vm.input === 'email')?_c('span',{staticClass:"dark-red f7"},[_vm._v(_vm._s(_vm.error))]):_vm._e(),_vm._v(" "),(_vm.$v.email.$error && !_vm.$v.email.required)?_c('span',{staticClass:"dark-red f7"},[_vm._v(_vm._s(_vm.$t("error.emailRequired")))]):_vm._e(),_vm._v(" "),(_vm.$v.email.$error && !_vm.$v.email.email)?_c('span',{staticClass:"dark-red f7"},[_vm._v(_vm._s(_vm.$t("error.emailInvalid")))]):_vm._e(),_vm._v(" "),_c('label',{staticClass:"f7 textColor",attrs:{"for":"email"}},[_vm._v(_vm._s(_vm.$t("users.email")))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"w-100 input ph2",class:{'error': _vm.$v.email.$error || (_vm.error && _vm.input === 'email')},attrs:{"name":"email","id":"email","placeholder":_vm.$t('users.email'),"disabled":true},domProps:{"value":(_vm.email)},on:{"blur":_vm.$v.email.$touch,"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"flex flex-column pa2-ns pa1 w-100"},[(_vm.$v.address.$error && !_vm.$v.address.required)?_c('span',{staticClass:"dark-red f7"},[_vm._v(_vm._s(_vm.$t("error.addressRequired")))]):_vm._e(),_vm._v(" "),_c('label',{staticClass:"f7 textColor",attrs:{"for":"address"}},[_vm._v(_vm._s(_vm.$t("users.address")))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.address),expression:"address"}],staticClass:"input ph2",class:{error: _vm.$v.address.$error},attrs:{"name":"address","id":"address","placeholder":_vm.$t('users.address'),"disabled":!_vm.edit},domProps:{"value":(_vm.address)},on:{"blur":_vm.$v.address.$touch,"input":function($event){if($event.target.composing){ return; }_vm.address=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"flex-ns justify-center"},[_c('div',{staticClass:"w-50-ns w-100 pa2-ns pa1 flex flex-column"},[_c('label',{staticClass:"f7 textColor",attrs:{"for":"country"}},[_vm._v(_vm._s(_vm.$t("users.country")))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.country),expression:"country"}],staticClass:"w-100 block ph1 pv2 input",attrs:{"id":"country","disabled":!_vm.edit},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.country=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.countries),function(country){return _c('option',{key:country.alpha2Code,attrs:{"track-by":country.alpha2Code},domProps:{"value":country.alpha2Code}},[_vm._v(_vm._s(country.name)+"\n              ")])}),0)]),_vm._v(" "),_c('div',{staticClass:"w-50-ns w-100 pa2-ns pa1"},[_c('label',{staticClass:"f7 textColor",attrs:{"for":"city"}},[_vm._v(_vm._s(_vm.$t("users.city")))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.city),expression:"city"}],staticClass:"w-100 input ph2",attrs:{"name":"city","id":"city","placeholder":_vm.$t('users.city'),"disabled":!_vm.edit},domProps:{"value":(_vm.city)},on:{"input":function($event){if($event.target.composing){ return; }_vm.city=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"flex"},[((_vm.$v.day.$error && !_vm.$v.day.required) || (_vm.$v.month.$error && !_vm.$v.month.required) ||
        (_vm.$v.year.$error && !_vm.$v.year.required))?_c('span',{staticClass:"dark-red f7 mh2-ns"},[_vm._v(_vm._s(_vm.$t("error.bithdateRequired")))]):_vm._e()]),_vm._v(" "),_c('label',{staticClass:"mh2-ns f7 textColor"},[_vm._v(_vm._s(_vm.$t("users.birthdate")))]),_vm._v(" "),_c('div',{staticClass:"flex-ns justify-between items-center"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.day),expression:"day"}],staticClass:"w-third-ns w-100 mh2-ns block ph1 pv2 input",class:{error: _vm.$v.day.$error},attrs:{"id":"birth-day","disabled":!_vm.edit},on:{"blur":_vm.$v.day.$touch,"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.day=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"disabled":"","value":"","selected":""}},[_vm._v("Día")]),_vm._v(" "),_vm._l((31),function(n){return _c('option',{key:n,attrs:{"track-by":n},domProps:{"value":n}},[_vm._v(_vm._s(n))])})],2),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.month),expression:"month"}],staticClass:"w-third-ns w-100 mh2-ns block ph1 pv2 input",class:{error: _vm.$v.month.$error},attrs:{"id":"birth-month","disabled":!_vm.edit},on:{"blur":_vm.$v.month.$touch,"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.month=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"disabled":"","value":"","selected":""}},[_vm._v("Mes")]),_vm._v(" "),_vm._l((_vm.months),function(item,index){return _c('option',{key:index,attrs:{"track-by":index},domProps:{"value":index}},[_vm._v(_vm._s(item))])})],2),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.year),expression:"year"}],staticClass:"w-third-ns w-100 mh2-ns block ph1 pv2 input textColor",class:{error: _vm.$v.year.$error},attrs:{"id":"birth-year","disabled":!_vm.edit},on:{"blur":_vm.$v.year.$touch,"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.year=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"disabled":"","value":"","selected":""}},[_vm._v("Año")]),_vm._v(" "),_vm._l((80),function(n){return _c('option',{key:n,attrs:{"track-by":n},domProps:{"value":_vm.currentYear - n}},[_vm._v(_vm._s(_vm.currentYear - n))])})],2)]),_vm._v(" "),_c('div',{staticClass:"mv2 flex-ns justify-center items-center"},[_c('label',{staticClass:"ma2 ttu textColor"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userType),expression:"userType"}],attrs:{"name":"user_type","type":"radio","value":"0","disabled":!_vm.edit},domProps:{"checked":_vm._q(_vm.userType,"0")},on:{"change":function($event){_vm.userType="0"}}}),_vm._v(_vm._s(_vm.$t("users.userType.musicFan"))+"\n          ")]),_vm._v(" "),_c('label',{staticClass:"ma2 ttu textColor"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userType),expression:"userType"}],attrs:{"name":"user_type","type":"radio","value":"1","disabled":!_vm.edit},domProps:{"checked":_vm._q(_vm.userType,"1")},on:{"change":function($event){_vm.userType="1"}}}),_vm._v("\n            "+_vm._s(_vm.$t("users.userType.producer"))+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"flex flex-column w-100 pa2-ns pa1"},[_c('label',{staticClass:"f7 textColor",attrs:{"for":"bio"}},[_vm._v(_vm._s(_vm.$t("users.bio")))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.bio),expression:"bio"}],staticClass:"ph2 input",attrs:{"name":"bio","id":"bio","placeholder":_vm.$t('users.bioDescription'),"disabled":!_vm.edit},domProps:{"value":(_vm.bio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.bio=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"mv2 display-c justify-center items-center"},[_c('label',{staticClass:"ma2 ttu textColor"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.acceptNewsLetter),expression:"acceptNewsLetter"}],attrs:{"name":"accept_news_letter","type":"checkbox","value":"1","disabled":!_vm.edit},domProps:{"checked":Array.isArray(_vm.acceptNewsLetter)?_vm._i(_vm.acceptNewsLetter,"1")>-1:(_vm.acceptNewsLetter)},on:{"change":function($event){var $$a=_vm.acceptNewsLetter,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.acceptNewsLetter=$$a.concat([$$v]))}else{$$i>-1&&(_vm.acceptNewsLetter=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.acceptNewsLetter=$$c}}}}),_vm._v(_vm._s(_vm.$t("users.accept.newsLetter"))+"\n          ")]),_vm._v(" "),_c('label',{staticClass:"ma2 ttu textColor"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.acceptShareInfo),expression:"acceptShareInfo"}],attrs:{"name":"accept_share_info","type":"checkbox","value":"1","disabled":!_vm.edit},domProps:{"checked":Array.isArray(_vm.acceptShareInfo)?_vm._i(_vm.acceptShareInfo,"1")>-1:(_vm.acceptShareInfo)},on:{"change":function($event){var $$a=_vm.acceptShareInfo,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.acceptShareInfo=$$a.concat([$$v]))}else{$$i>-1&&(_vm.acceptShareInfo=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.acceptShareInfo=$$c}}}}),_vm._v("\n            "+_vm._s(_vm.$t("users.accept.shareInfo"))+"\n          ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],staticClass:"flex justify-center"},[_c('input',{staticClass:"w-30-l w-50-m w-100 block mv2 pointer btn dim b f5 fw4 textColor",attrs:{"type":"submit"},domProps:{"value":_vm.$t('app.save')}})])])])]),_vm._v(" "),(_vm.canRefer)?_c('div',{staticClass:"mtb-30"},[_c('div',{staticClass:"flex list-group-horizontal items-center mh2 w-100"},[_c('button',{staticClass:"genCode",attrs:{"disabled":_vm.disableButton},on:{"click":_vm.genToken}},[_vm._v(_vm._s(_vm.$t('users.generateReferralCode')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.link),expression:"link"}],staticClass:"w-38 block ma2 ph1 pv2 input h2 textColor brad-100",attrs:{"contenteditable":"true","readonly":""},domProps:{"value":(_vm.link)},on:{"input":function($event){if($event.target.composing){ return; }_vm.link=$event.target.value}}}),_vm._v(" "),_c('button',{directives:[{name:"clipboard",rawName:"v-clipboard",value:(_vm.link),expression:"link"}],staticClass:"btn w-4 pd-4 pointer",on:{"success":_vm.clipboardLinkSuccess,"error":_vm.clipboardError}},[_c('font-awesome-icon',{staticClass:"white",attrs:{"icon":"copy"}})],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rcode),expression:"rcode"}],staticClass:"w-19 block ma2 ph1 pv2 input textColor h2 brad-100",attrs:{"contenteditable":"true","readonly":""},domProps:{"value":(_vm.rcode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.rcode=$event.target.value}}}),_vm._v(" "),_c('button',{directives:[{name:"clipboard",rawName:"v-clipboard",value:(_vm.rcode),expression:"rcode"}],staticClass:"btn w-4 pd-4 pointer",on:{"success":_vm.clipboardCodeSuccess,"error":_vm.clipboardError}},[_c('font-awesome-icon',{staticClass:"white",attrs:{"icon":"copy"}})],1)])]):_vm._e(),_vm._v(" "),(_vm.isProducer)?_c('my-artist-info',{attrs:{"edit":_vm.edit}}):_vm._e(),_vm._v(" "),(_vm.user)?_c('div',[(_vm.user.subscription)?_c('div',{staticClass:"flex flex-column items-start-l items-center"},[(_vm.user.subscription.active)?_c('div',[(_vm.subscriptionGateway)?_c('div',[_c('h3',{staticClass:"textColor"},[_vm._v(_vm._s(_vm.$t('users.subscription.cancelSubscription')))]),_vm._v(" "),_c('div',[_c('button',{staticClass:"w-50-ns w-100 block mv2 pointer btn dim b f5 fw4",on:{"click":_vm.mpCancelSubscription}},[_vm._v(_vm._s(_vm.$t('users.subscription.disaffiliate')))])])]):_vm._e()]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"flex flex-column items-start-l items-center"},[_c('div',[_c('div',[_c('p',{staticClass:"textColor pointer underline",on:{"click":_vm.deleteAccount}},[_vm._v(_vm._s(_vm.$t('users.subscription.cancelAccount')))])])])])]):_vm._e()],1)}
var staticRenderFns = []


/***/ }),
/* 1149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewArtistsList_vue__ = __webpack_require__(557);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e30e083a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewArtistsList_vue__ = __webpack_require__(1151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1150)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e30e083a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewArtistsList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e30e083a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewArtistsList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e30e083a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewArtistsList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1150 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"artistHeight"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.withFilters && _vm.genresMain.length > 0),expression:"withFilters && genresMain.length > 0"}]},[_c('div',{staticClass:"w-100 justify-around items-center ttu",staticStyle:{"background-color":"#393839","position":"relative","display":"flex"}},[_c('div',[_c('a',{staticStyle:{"margin-left":"10px","fill":"white","cursor":"pointer"},on:{"click":function($event){return _vm.genTranslate('genMain', 'left')}}},[_c('svg',{staticClass:"bi bi-caret-left",attrs:{"width":"25","height":"25","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M10 12.796V3.204L4.519 8 10 12.796zm-.659.753-5.48-4.796a1 1 0 0 1 0-1.506l5.48-4.796A1 1 0 0 1 11 3.204v9.592a1 1 0 0 1-1.659.753z"}})])])]),_vm._v(" "),_c('div'),_vm._v(" "),_c('div',{staticClass:"container-scroll w-100"},[_c('div',{staticClass:"container-genbar",attrs:{"id":"genMain"}},[_c('a',{staticClass:"genre-filter f6 link dim ph3 pv2 dib white mr2",class:{
              'genre-filter-selected': _vm.genreFilter == '',
              pointer: _vm.genreFilter != '',
            },on:{"click":function($event){return _vm.selectGenMain('')}}},[_vm._v("\n            "+_vm._s(_vm.$t("tracks.genres.all"))+"\n          ")]),_vm._v(" "),_vm._l((_vm.genresMain),function(genre){return _c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.genresMain.length > 0),expression:"genresMain.length > 0"}],key:genre.id,staticClass:"genre-filter f6 link dim ph3 pv2 dib white mr2",class:{
              'genre-filter-selected': _vm.genreFilter == genre.id,
              pointer: _vm.genreFilter != genre.id,
            },attrs:{"track-by":genre.id,"tabindex":genre.id},on:{"click":function($event){return _vm.selectGenMain(genre.id)},"blur":function($event){return _vm.selectGenMainBlur($event)},"focus":function($event){return _vm.selectGenMainFocus($event)}}},[_vm._v("\n            "+_vm._s(genre.name)+"\n          ")])})],2)]),_vm._v(" "),_c('div',[_c('a',{staticStyle:{"margin-right":"10px","fill":"white","cursor":"pointer"},on:{"click":function($event){return _vm.genTranslate('genMain', 'right')}}},[_c('svg',{staticClass:"bi bi-caret-right",attrs:{"width":"25","height":"25","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M6 12.796V3.204L11.481 8 6 12.796zm.659.753 5.48-4.796a1 1 0 0 0 0-1.506L6.66 2.451C6.011 1.885 5 2.345 5 3.204v9.592a1 1 0 0 0 1.659.753z"}})])])])]),_vm._v(" "),_c('div',{staticClass:"w-100 justify-between items-center ttu black",staticStyle:{"background-color":"black","position":"relative","display":"flex"}},[_c('div',[_c('a',{staticStyle:{"fill":"white","cursor":"pointer"},on:{"click":function($event){return _vm.genTranslate('genSecon', 'left')}}},[_c('svg',{staticClass:"bi bi-caret-left",attrs:{"width":"25","height":"25","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M10 12.796V3.204L4.519 8 10 12.796zm-.659.753-5.48-4.796a1 1 0 0 1 0-1.506l5.48-4.796A1 1 0 0 1 11 3.204v9.592a1 1 0 0 1-1.659.753z"}})])])]),_vm._v(" "),_c('div',{staticClass:"container-scroll w-100"},[_c('div',{staticClass:"container-genbar",attrs:{"id":"genSecon"}},_vm._l((_vm.genSeconByMain),function(genre){return _c('a',{key:genre.id,staticClass:"genre-filter f6 link dim ph3 pv2 dib white mr2",class:{
              'genre-filter-selected': _vm.genreFilter == genre.id,
              pointer: _vm.genreFilter != genre.id,
            },staticStyle:{"font-size":"0.775rem","min-width":"120px","text-align":"center"},attrs:{"track-by":genre.id},on:{"click":function($event){return _vm.selectGenSecon(genre.id)}}},[_vm._v("\n            "+_vm._s(genre.name)+"\n          ")])}),0)]),_vm._v(" "),_c('div',[_c('a',{staticStyle:{"fill":"white","cursor":"pointer"},on:{"click":function($event){return _vm.genTranslate('genSecon', 'right')}}},[_c('svg',{staticClass:"bi bi-caret-right",attrs:{"width":"25","height":"25","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M6 12.796V3.204L11.481 8 6 12.796zm.659.753 5.48-4.796a1 1 0 0 0 0-1.506L6.66 2.451C6.011 1.885 5 2.345 5 3.204v9.592a1 1 0 0 0 1.659.753z"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"w-100 mh3 w-mobile"},[_c('div',{staticClass:"search-wrapper w-third-l w-50-m w-100 block pointer z-1 relative bg-tertiary fr mt3"},[_c('button',{staticClass:"w-10-ns w-90 pointer btn1 dim b f5 fw4",attrs:{"type":"button","icon":"search"},on:{"click":_vm.update}},[_c('font-awesome-icon',{staticClass:"search-left-icon",attrs:{"icon":"search"}})],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.textToFilter),expression:"textToFilter"}],staticClass:"pa2 input w-100 bg-transparent w-50-mobile",attrs:{"maxlength":"255","placeholder":_vm.$t('artists.search.placeholder')},domProps:{"value":(_vm.textToFilter)},on:{"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.clearFilters.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.update.apply(null, arguments)}],"input":function($event){if($event.target.composing){ return; }_vm.textToFilter=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"artistsFiltersLabelsDiv"},[_c('router-link',{staticClass:"filtersLinks",attrs:{"title":_vm.$t('app.discover'),"to":{name:'discover'}}},[_c('span',{staticClass:"filtersLabels"},[_vm._v(_vm._s(_vm.$t('artists.artists')))])]),_vm._v(" "),(_vm.mainGenre.name || _vm.seconGenre.name || _vm.filteredText)?_c('span',{on:{"click":_vm.filterByMainGenreLabel}},[_vm._v(" - ")]):_vm._e(),_vm._v(" "),(_vm.mainGenre.name)?_c('span',{staticClass:"filtersLabels",on:{"click":_vm.filterByMainGenreLabel}},[_vm._v(_vm._s(_vm.mainGenre.name))]):_vm._e(),_vm._v(" "),(_vm.mainGenre.name && _vm.seconGenre.name)?_c('span',[_vm._v(" / ")]):_vm._e(),_vm._v(" "),(_vm.seconGenre.name)?_c('span',{staticClass:"filtersLabels",on:{"click":_vm.removeSeconGenreLabel}},[_vm._v(_vm._s(_vm.seconGenre.name))]):_vm._e(),_vm._v(" "),((_vm.mainGenre.name || _vm.seconGenre.name) && _vm.filteredText)?_c('span',[_vm._v(" / ")]):_vm._e(),_vm._v(" "),(_vm.filteredText)?_c('span',{staticClass:"filtersLabels mobileLabelsPosition",on:{"click":_vm.removeFilteredTextLabel}},[_vm._v(_vm._s(_vm.filteredText))]):_vm._e()],1),_vm._v(" "),(_vm.artists)?_c('div',{attrs:{"id":"artistsListMainContent"}},[_c('div',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadMorePaginated),expression:"loadMorePaginated"}],staticClass:"artist-list flex flex-wrap justify-center items-start pb5 w-100",attrs:{"infinite-scroll-distance":"250","infinite-scroll-disabled":"preventLoadMore"}},_vm._l((_vm.artists),function(artist,index){return _c('artist-card',{key:index,attrs:{"artist":artist,"isArtistList":true}})}),1)]):_vm._e(),_vm._v(" "),(!_vm.artists)?_c('div',{staticClass:"flex justify-center items-center w-100 textColor noResults"},[_vm._v("\n    "+_vm._s(_vm.$t("app.info.noResults"))+"\n  ")]):_vm._e()])}
var staticRenderFns = []


/***/ }),
/* 1152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewPlaylistsList_vue__ = __webpack_require__(558);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f53f813_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewPlaylistsList_vue__ = __webpack_require__(1154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1153)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5f53f813"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewPlaylistsList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f53f813_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewPlaylistsList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f53f813_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewPlaylistsList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1153 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"playlistsHeight"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.withFilters && _vm.genresMain.length > 0),expression:"withFilters && genresMain.length > 0"}]},[_c('div',{staticClass:"w-100 justify-around items-center ttu",staticStyle:{"background-color":"#393839","position":"relative","display":"flex"}},[_c('div',[_c('a',{staticStyle:{"margin-left":"10px","fill":"white","cursor":"pointer"},on:{"click":function($event){return _vm.genTranslate('genMain', 'left')}}},[_c('svg',{staticClass:"bi bi-caret-left",attrs:{"width":"25","height":"25","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M10 12.796V3.204L4.519 8 10 12.796zm-.659.753-5.48-4.796a1 1 0 0 1 0-1.506l5.48-4.796A1 1 0 0 1 11 3.204v9.592a1 1 0 0 1-1.659.753z"}})])])]),_vm._v(" "),_c('div'),_vm._v(" "),_c('div',{staticClass:"container-scroll w-100"},[_c('div',{staticClass:"container-genbar",attrs:{"id":"genMain"}},[_c('a',{staticClass:"genre-filter f6 link dim ph3 pv2 dib white mr2",class:{
              'genre-filter-selected': _vm.genreFilter == '',
              pointer: _vm.genreFilter != '',
            },on:{"click":function($event){return _vm.selectGenMain('')}}},[_vm._v("\n            "+_vm._s(_vm.$t("tracks.genres.all"))+"\n          ")]),_vm._v(" "),_vm._l((_vm.genresMain),function(genre){return _c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.genresMain.length > 0),expression:"genresMain.length > 0"}],key:genre.id,staticClass:"genre-filter f6 link dim ph3 pv2 dib white mr2",class:{
              'genre-filter-selected': _vm.genreFilter == genre.id,
              pointer: _vm.genreFilter != genre.id,
            },attrs:{"track-by":genre.id,"tabindex":genre.id},on:{"click":function($event){return _vm.selectGenMain(genre.id)},"blur":function($event){return _vm.selectGenMainBlur($event)},"focus":function($event){return _vm.selectGenMainFocus($event)}}},[_vm._v("\n            "+_vm._s(genre.name)+"\n          ")])})],2)]),_vm._v(" "),_c('div',[_c('a',{staticStyle:{"margin-right":"10px","fill":"white","cursor":"pointer"},on:{"click":function($event){return _vm.genTranslate('genMain', 'right')}}},[_c('svg',{staticClass:"bi bi-caret-right",attrs:{"width":"25","height":"25","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M6 12.796V3.204L11.481 8 6 12.796zm.659.753 5.48-4.796a1 1 0 0 0 0-1.506L6.66 2.451C6.011 1.885 5 2.345 5 3.204v9.592a1 1 0 0 0 1.659.753z"}})])])])]),_vm._v(" "),_c('div',{staticClass:"w-100 justify-between items-center ttu black",staticStyle:{"background-color":"black","position":"relative","display":"flex"}},[_c('div',[_c('a',{staticStyle:{"fill":"white","cursor":"pointer"},on:{"click":function($event){return _vm.genTranslate('genSecon', 'left')}}},[_c('svg',{staticClass:"bi bi-caret-left",attrs:{"width":"25","height":"25","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M10 12.796V3.204L4.519 8 10 12.796zm-.659.753-5.48-4.796a1 1 0 0 1 0-1.506l5.48-4.796A1 1 0 0 1 11 3.204v9.592a1 1 0 0 1-1.659.753z"}})])])]),_vm._v(" "),_c('div',{staticClass:"container-scroll w-100"},[_c('div',{staticClass:"container-genbar",attrs:{"id":"genSecon"}},_vm._l((_vm.genSeconByMain),function(genre){return _c('a',{key:genre.id,staticClass:"genre-filter f6 link dim ph3 pv2 dib white mr2",class:{
              'genre-filter-selected': _vm.genreFilter == genre.id,
              pointer: _vm.genreFilter != genre.id,
            },staticStyle:{"font-size":"0.775rem","min-width":"120px","text-align":"center"},attrs:{"track-by":genre.id},on:{"click":function($event){return _vm.selectGenSecon(genre.id)}}},[_vm._v("\n            "+_vm._s(genre.name)+"\n          ")])}),0)]),_vm._v(" "),_c('div',[_c('a',{staticStyle:{"fill":"white","cursor":"pointer"},on:{"click":function($event){return _vm.genTranslate('genSecon', 'right')}}},[_c('svg',{staticClass:"bi bi-caret-right",attrs:{"width":"25","height":"25","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M6 12.796V3.204L11.481 8 6 12.796zm.659.753 5.48-4.796a1 1 0 0 0 0-1.506L6.66 2.451C6.011 1.885 5 2.345 5 3.204v9.592a1 1 0 0 0 1.659.753z"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"w-100 mh3 w-mobile"},[_c('div',{staticClass:"search-wrapper w-third-l w-50-m w-100 block pointer z-1 relative bg-tertiary fr mt3"},[_c('button',{staticClass:"w-10-ns w-90 pointer btn1 dim b f5 fw4",attrs:{"type":"button","icon":"search"},on:{"click":_vm.update}},[_c('font-awesome-icon',{staticClass:"search-left-icon",attrs:{"icon":"search"}})],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.textToFilter),expression:"textToFilter"}],staticClass:"pa2 input w-100 bg-transparent w-50-mobile",attrs:{"maxlength":"255","placeholder":_vm.$t('artists.search.placeholder')},domProps:{"value":(_vm.textToFilter)},on:{"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.clearFilters.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.update.apply(null, arguments)}],"input":function($event){if($event.target.composing){ return; }_vm.textToFilter=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"playlistsFiltersLabelsDiv"},[_c('router-link',{staticClass:"filtersLinks",attrs:{"title":_vm.$t('app.discover'),"to":{name:'discover'}}},[_c('span',{staticClass:"filtersLabels"},[_vm._v(_vm._s(_vm.$t('playlists.playlist')))])]),_vm._v(" "),(_vm.mainGenre.name || _vm.seconGenre.name || _vm.filteredText)?_c('span',{on:{"click":_vm.filterByMainGenreLabel}},[_vm._v(" - ")]):_vm._e(),_vm._v(" "),(_vm.mainGenre.name)?_c('span',{staticClass:"filtersLabels",on:{"click":_vm.filterByMainGenreLabel}},[_vm._v(_vm._s(_vm.mainGenre.name))]):_vm._e(),_vm._v(" "),(_vm.mainGenre.name && _vm.seconGenre.name)?_c('span',[_vm._v(" / ")]):_vm._e(),_vm._v(" "),(_vm.seconGenre.name)?_c('span',{staticClass:"filtersLabels",on:{"click":_vm.removeSeconGenreLabel}},[_vm._v(_vm._s(_vm.seconGenre.name))]):_vm._e(),_vm._v(" "),((_vm.mainGenre.name || _vm.seconGenre.name) && _vm.filteredText)?_c('span',[_vm._v(" / ")]):_vm._e(),_vm._v(" "),(_vm.filteredText)?_c('span',{staticClass:"filtersLabels mobileLabelsPosition",on:{"click":_vm.removeFilteredTextLabel}},[_vm._v(_vm._s(_vm.filteredText))]):_vm._e()],1),_vm._v(" "),(_vm.playlists)?_c('div',{attrs:{"id":"playlistsListMainContent"}},[_c('div',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadMorePaginated),expression:"loadMorePaginated"}],staticClass:"playlist-list flex flex-wrap justify-center items-start pb5 w-100",attrs:{"infinite-scroll-distance":"250","infinite-scroll-disabled":"preventLoadMore"}},_vm._l((_vm.playlists),function(genre){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.playlists.length > 0),expression:"playlists.length > 0"}],key:genre.id,staticClass:"genre-filter f6 link dim ph2 pv2 dib white",class:{
                'genre-filter-selected': _vm.genreFilter == genre.id,
                pointer: _vm.genreFilter != genre.id,
              },attrs:{"track-by":genre.id,"tabindex":genre.title},on:{"click":function($event){return _vm.setPlayer(genre.tracks[0], genre.tracks)}}},[_c('router-link',{staticClass:"playlist-info",attrs:{"to":{ name:'playlist-info', params:{ id: genre.id }}}},[_c('modal-playlist-card',{staticStyle:{"width":"190px"},attrs:{"playlist":genre}})],1)],1)}),0)]):_vm._e(),_vm._v(" "),(!_vm.playlists)?_c('div',{staticClass:"flex justify-center items-center w-100 textColor noResults"},[_vm._v("\n    "+_vm._s(_vm.$t("app.info.noResults"))+"\n  ")]):_vm._e()])}
var staticRenderFns = []


/***/ }),
/* 1155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Vrtify_vue__ = __webpack_require__(559);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d81f901_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Vrtify_vue__ = __webpack_require__(1157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1156)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Vrtify_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d81f901_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Vrtify_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d81f901_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Vrtify_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1156 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticStyle:{"width":"100%","min-height":"400px","height":"100%","border":"none"},attrs:{"type":"text/html","src":"https://www.vrtify.com/#/channel/p/3272?iframe=true","allowfullscreen":""}})}
var staticRenderFns = []


/***/ }),
/* 1158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewAlbum_vue__ = __webpack_require__(560);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37eb3f9c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewAlbum_vue__ = __webpack_require__(1160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1159)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-37eb3f9c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewAlbum_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37eb3f9c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewAlbum_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37eb3f9c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewAlbum_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1159 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"example-drag flex justify-center h-100 w-100"},[_c('div',{staticClass:"w-100 h-100"},[_c('div',{staticClass:"w-100 h-100"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"mv2 flex justify-center items-center h-100 w-100"},[_c('clip-loader',{attrs:{"loading":true,"color":_vm.color,"size":_vm.size}})],1),_vm._v(" "),_c('div',{staticClass:"ph5-l flex flex-column justify-center items-center pt4"},[_c('div',{staticClass:"warningMessage"},[_c('span',[_vm._v(_vm._s(_vm.$t('albums.newAlbum.warningMessage')))])]),_vm._v(" "),_c('div',{staticClass:"flex flex-wrap w-100 justify-evenly"},[(!_vm.album.picture)?_c('div',[_c('upload-image',{staticClass:"ma3",attrs:{"path":"/tracks/upload/picture","picturePath":_vm.picture,"trackEdit":true},on:{"uploadFinished":_vm.handleUploadFinished,"uploadStart":function($event){_vm.loadingPicture = true}}}),_vm._v(" "),(_vm.files[0] || _vm.album.id)?_c('div',{staticClass:"justify-center"},[(_vm.$v.album.picture.$error && !_vm.$v.album.picture.required)?_c('span',{staticClass:"errorText f7 ph3 ptr"},[_vm._v(_vm._s(_vm.$t("error.pictureRequired")))]):_vm._e()]):_vm._e()],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"w-25-l w-100 w-50-m f6"},[_c('div',{staticClass:"w-100 ph2-ns"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.album.title),expression:"album.title"}],staticClass:"w-100 mv2 block ph1 pv2 input",class:{error: _vm.$v.album.title.$error},attrs:{"name":"title","placeholder":_vm.$t('albums.newAlbum.namePlaceholder')},domProps:{"value":(_vm.album.title)},on:{"blur":_vm.$v.album.title.$touch,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.album, "title", $event.target.value)}}}),_vm._v(" "),(_vm.$v.album.title.$error && !_vm.$v.album.title.required)?_c('span',{staticClass:"errorText f7"},[_vm._v(_vm._s(_vm.$t("error.albumNameRequired")))]):_vm._e()]),_vm._v(" "),_c('div',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.mainGenreSelected),expression:"mainGenreSelected"}],staticClass:"w-100 mv2 mh2-ns block ph1 pv2 input",class:{error: _vm.$v.album.id_music_type.$error},attrs:{"id":"id_music_type"},on:{"blur":_vm.$v.album.id_music_type.$touch,"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.mainGenreSelected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.filterChildrensGenres()}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Género")]),_vm._v(" "),_vm._l((_vm.genresMain),function(genre){return _c('option',{key:genre.id,attrs:{"album-by":genre.id},domProps:{"value":genre.id}},[_vm._v(_vm._s(genre.name)+"\n                ")])})],2),_vm._v(" "),(_vm.mainGenreSelected && _vm.isOthers === false)?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.album.id_music_type),expression:"album.id_music_type"}],staticClass:"w-100 mv2 mh2-ns block ph1 pv2 input",class:{error: _vm.$v.album.id_music_type.$error},attrs:{"id":"id_music_type"},on:{"blur":_vm.$v.album.id_music_type.$touch,"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.album, "id_music_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.otherSelected()}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Subgénero")]),_vm._v(" "),_vm._l((_vm.childrensGenres),function(genre){return _c('option',{key:genre.id,attrs:{"album-by":genre.id},domProps:{"value":genre.id}},[_vm._v(_vm._s(genre.name)+"\n                ")])})],2):_vm._e(),_vm._v(" "),(_vm.$v.album.id_music_type.$error && !_vm.$v.album.id_music_type.required)?_c('span',{staticClass:"errorText f7"},[_vm._v(_vm._s(_vm.$t("error.genreRequired"))+"\n              ")]):_vm._e()]),_vm._v(" "),(_vm.isOthersChildren === true || _vm.isOthers === true)?_c('div',{staticClass:"w-100 ph2-ns"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.album.recommendedGenre),expression:"album.recommendedGenre"}],staticClass:"w-100 mv2 block ph1 pv2",attrs:{"rows":"4","type":"text","name":"tags","placeholder":_vm.$t('tracks.editTrack.recommendedPlaceHolder')},domProps:{"value":(_vm.album.recommendedGenre)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.album, "recommendedGenre", $event.target.value)}}})]):_vm._e(),_vm._v(" "),_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.album.min_price),expression:"album.min_price"}],staticClass:"w-100 mv2 block ph1 pv2 input",class:{error: _vm.$v.album.min_price.$error},attrs:{"name":"min_price","placeholder":_vm.$t('tracks.minPrice')},domProps:{"value":(_vm.album.min_price)},on:{"blur":_vm.$v.album.min_price.$touch,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.album, "min_price", $event.target.value)}}}),_vm._v(" "),(_vm.$v.album.min_price.$error && !_vm.$v.album.min_price.required)?_c('span',{staticClass:"errorText f7"},[_vm._v(_vm._s(_vm.$t("error.minPriceRequired")))]):_vm._e(),_vm._v(" "),(_vm.$v.album.min_price.$error && !_vm.$v.album.min_price.minValue)?_c('span',{staticClass:"errorText f7"},[_vm._v(_vm._s(_vm.$t("error.minPriceValue")))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"w-100 ph2-ns"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.album.tags),expression:"album.tags"}],staticClass:"w-100 mv2 block ph1 pv2",attrs:{"rows":"4","type":"text","name":"tags","placeholder":_vm.$t('albums.newAlbum.tagsPlaceholder')},domProps:{"value":(_vm.album.tags)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.album, "tags", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"w-100 ph2-ns"},[_c('EditorCK',{attrs:{"placeholder":_vm.$t('tracks.editTrack.creditsPlaceholder'),"credits":_vm.album.credits},on:{"content-change":_vm.handleContentChange}})],1)]),_vm._v(" "),_c('div',{staticClass:"flex flex-wrap mv3 mh3 ba br2 b--light-silver w-50"},[_c('div',{staticClass:"f6 ph3 w-50-ns"},[_c('p',{staticClass:"b textColor"},[_vm._v(_vm._s(_vm.$t("tracks.licenses.features")))]),_vm._v(" "),_c('p',{staticClass:"mt0 b textColor"},[_vm._v(_vm._s(_vm.$t("tracks.licenses.questions.1.title")))]),_vm._v(" "),_c('div',{staticClass:"flex-ns justify-start items-center"},[_c('label',{staticClass:"ma2 textColor"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.adaptationCondition),expression:"adaptationCondition"}],attrs:{"name":"adaptationCondition","type":"radio","checked":""},domProps:{"value":0,"checked":_vm._q(_vm.adaptationCondition,0)},on:{"change":function($event){_vm.adaptationCondition=0}}}),_vm._v("\n                  "+_vm._s(_vm.$t("tracks.licenses.questions.1.options.1")))]),_vm._v(" "),_c('label',{staticClass:"ma2 textColor"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.adaptationCondition),expression:"adaptationCondition"}],attrs:{"name":"adaptationCondition","type":"radio"},domProps:{"value":1,"checked":_vm._q(_vm.adaptationCondition,1)},on:{"change":function($event){_vm.adaptationCondition=1}}}),_vm._v("\n                  "+_vm._s(_vm.$t("tracks.licenses.questions.1.options.2")))]),_vm._v(" "),_c('label',{staticClass:"ma2 textColor"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.adaptationCondition),expression:"adaptationCondition"}],attrs:{"name":"adaptationCondition","type":"radio"},domProps:{"value":2,"checked":_vm._q(_vm.adaptationCondition,2)},on:{"change":function($event){_vm.adaptationCondition=2}}}),_vm._v("\n                  "+_vm._s(_vm.$t("tracks.licenses.questions.1.options.3")))])]),_vm._v(" "),_c('p',{staticClass:"mt0 b textColor"},[_vm._v(_vm._s(_vm.$t("tracks.licenses.questions.2.title")))]),_vm._v(" "),_c('div',{staticClass:"flex-ns justify-start items-center"},[_c('label',{staticClass:"ma2 textColor"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.commercialCondition),expression:"commercialCondition"}],attrs:{"name":"commercialCondition","type":"radio","checked":""},domProps:{"value":0,"checked":_vm._q(_vm.commercialCondition,0)},on:{"change":function($event){_vm.commercialCondition=0}}}),_vm._v("\n                  "+_vm._s(_vm.$t("tracks.licenses.questions.2.options.1")))]),_vm._v(" "),_c('label',{staticClass:"ma2 textColor"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.commercialCondition),expression:"commercialCondition"}],attrs:{"name":"commercialCondition","type":"radio"},domProps:{"value":1,"checked":_vm._q(_vm.commercialCondition,1)},on:{"change":function($event){_vm.commercialCondition=1}}}),_vm._v("\n                  "+_vm._s(_vm.$t("tracks.licenses.questions.2.options.2")))])])]),_vm._v(" "),_c('div',{staticClass:"f6 ph3 w-100 w-50-ns textColor"},[_c('p',{staticClass:"b textColor"},[_vm._v(_vm._s(_vm.$t("tracks.licenses.selected")))]),_vm._v(" "),(_vm.actualLicense)?_c('p',{staticClass:"textColor"},[_vm._v(_vm._s(_vm.actualLicense.titulo))]):_vm._e(),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.licenseIcon),expression:"licenseIcon"}],attrs:{"src":_vm.licenseIcon,"alt":_vm.actualLicense.titulo}}),_vm._v(" "),_c('p',{staticClass:"textColor"},[_vm._v(_vm._s(_vm.actualLicense.descripcion))])])])])]),_vm._v(" "),_c('div',{staticClass:"flex flex-wrap justify-center"},[(_vm.album.id_music_type !== '' && _vm.album.picture !== '' && _vm.album.title !== '')?_c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.files.length),expression:"!files.length"}],staticClass:"pt4 ph4 pb2 justify-center"},[_c('div',{staticClass:"flex justify-center pv3"},[_c('file-upload',{ref:"upload",staticClass:"btn w5 pointer textColor",attrs:{"post-action":_vm.url,"headers":_vm.postFileHeaders,"extensions":"mp3","multiple":true,"drop":!_vm.files.length},on:{"input-file":_vm.inputFile,"input-filter":_vm.inputFilter},model:{value:(_vm.files),callback:function ($$v) {_vm.files=$$v},expression:"files"}},[_vm._v("\n                "+_vm._s(_vm.$t("albums.newAlbum.selectFiles"))+"\n              ")])],1),_vm._v(" "),(!_vm.fileValidator)?_c('span',{staticClass:"errorText f7 ph3 ptr"},[_vm._v(_vm._s(_vm.$t("error.trackFileRequired")))]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.files[0] !== undefined)?_c('div',{staticClass:"flex flex-column justify-center items-center w4 ma3"},[_c('circle-progress',{ref:"circleProgress",attrs:{"percent":parseFloat(_vm.files[0].progress),"fill":_vm.circleFill,"emptyFill":"#f4f3f4"}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.files[0].progress < 100),expression:"files[0].progress < 100"}],staticClass:"textColor"},[_vm._v(_vm._s(_vm.$t("app.loading")))]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.files[0].progress == 100),expression:"files[0].progress == 100"}],staticClass:"textColor"},[_vm._v(_vm._s(_vm.$t("tracks.editTrack.completed")))])],1):_vm._e()]),_vm._v(" "),(_vm.tracks.length)?_c('div',_vm._l((_vm.tracks),function(track,index){return _c('div',{key:index,staticClass:"pdt30"},[_c('div',{staticClass:"example-drag flex justify-center h-100 w-100"},[_c('div',{staticClass:"w-100 h-100"},[_c('div',{staticClass:"w-100 h-100"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"mv2 flex justify-center items-center h-100 w-100"},[_c('clip-loader',{attrs:{"loading":true,"color":_vm.color,"size":_vm.size}})],1),_vm._v(" "),_c('div',{staticClass:"ph5-l flex flex-column justify-center items-center"},[_c('div',{staticClass:"flex flex-wrap w-100 justify-center"},[_c('div',{staticClass:"displayFlex w-50-m f6"},[_c('div',{staticClass:"w-100 ph2-ns"},[_c('span',[_vm._v(_vm._s(_vm.tracks[index].correctedName))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tracks[index].title),expression:"tracks[index].title"}],staticClass:"w-100 mv2 block ph1 pv2 input",class:{error: _vm.$v.album.title.$error},attrs:{"name":"title","placeholder":_vm.$t('tracks.editTrack.namePlaceholder')},domProps:{"value":(_vm.tracks[index].title)},on:{"blur":_vm.$v.album.title.$touch,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tracks[index], "title", $event.target.value)}}}),_vm._v(" "),(_vm.tracks[index].title === '')?_c('span',{staticClass:"errorText f7"},[_vm._v(_vm._s(_vm.$t("error.trackNameRequired")))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"w-100 ph2-ns mr30"},[(_vm.mainGenreSelected && _vm.isOthers === false)?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.tracks[index].id_music_type),expression:"tracks[index].id_music_type"}],staticClass:"w-100 mv2 mh2-ns block ph1 pv2 input m15",class:{error: _vm.$v.album.id_music_type.$error},attrs:{"id":"id_music_type"},on:{"blur":_vm.$v.album.id_music_type.$touch,"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.tracks[index], "id_music_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.otherSelected()}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Subgénero")]),_vm._v(" "),_vm._l((_vm.childrensGenres),function(genre){return _c('option',{key:genre.id,attrs:{"album-by":genre.id},domProps:{"value":genre.id}},[_vm._v(_vm._s(genre.name)+"\n                          ")])})],2):_vm._e(),_vm._v(" "),(_vm.tracks[index].id_music_type === '' || _vm.tracks[index].id_music_type === null || _vm.tracks[index].id_music_type === undefined)?_c('span',{staticClass:"errorText f7"},[_vm._v(_vm._s(_vm.$t("error.genreRequired"))+"\n                        ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"w-100 ph2-ns"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tracks[index].min_price),expression:"tracks[index].min_price"}],staticClass:"w-100 mv2 block ph1 pv2 input",class:{error: _vm.$v.album.min_price.$error},attrs:{"name":"min_price","placeholder":_vm.$t('tracks.minPrice')},domProps:{"value":(_vm.tracks[index].min_price)},on:{"blur":_vm.$v.album.min_price.$touch,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tracks[index], "min_price", $event.target.value)}}}),_vm._v(" "),(_vm.tracks[index].min_price === '')?_c('span',{staticClass:"errorText f7"},[_vm._v(_vm._s(_vm.$t("error.minPriceRequired")))]):_vm._e(),_vm._v(" "),(_vm.tracks[index].min_price < 1)?_c('span',{staticClass:"errorText f7"},[_vm._v(_vm._s(_vm.$t("error.minPriceValue")))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"w-100 ph2-ns"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tracks[index].iswc),expression:"tracks[index].iswc"}],staticClass:"w-100 mv2 block ph1 pv2 input",class:{error: !_vm.$v.album.iswc.minLength || !_vm.$v.album.iswc.maxLength},attrs:{"name":"iswc","placeholder":_vm.$t('tracks.editTrack.iswcCode')},domProps:{"value":(_vm.tracks[index].iswc)},on:{"blur":_vm.$v.album.iswc.$touch,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tracks[index], "iswc", $event.target.value)}}}),_vm._v(" "),(_vm.tracks[index] && _vm.tracks[index].iswc)?_c('div',[(_vm.tracks[index].iswc !== '' && _vm.tracks[index].iswc.length !== 13)?_c('span',{staticClass:"errorText f7"},[_vm._v(_vm._s(_vm.$t("error.iswcErrorCode")))]):_vm._e()]):_vm._e()])])])])])])])])}),0):_vm._e(),_vm._v(" "),_c('div',{staticClass:"pt4 ph4 pb2 w-100"},[_c('p',{staticClass:"f7 tc textColor"},[_c('span',{staticClass:"b"},[_vm._v(_vm._s(_vm.$t("tracks.newTrack.important")))]),_vm._v(_vm._s(_vm.$t("tracks.newTrack.info"))+" ")]),_vm._v(" "),_c('p',{staticClass:"f7 b tc textColor"},[_vm._v(_vm._s(_vm.$t("tracks.newTrack.question1")))]),_vm._v(" "),_c('p',{staticClass:"f7 mt0 tc textColor"},[_vm._v(_vm._s(_vm.$t("tracks.newTrack.answer1")))]),_vm._v(" "),_c('p',{staticClass:"f7 b tc textColor"},[_vm._v(_vm._s(_vm.$t("tracks.newTrack.question2")))]),_vm._v(" "),_c('p',{staticClass:"f7 mt0 tc textColor"},[_vm._v(_vm._s(_vm.$t("tracks.newTrack.answer2")))])]),_vm._v(" "),_c('div',{staticClass:"flex justify-center textColor"},[_c('button',{staticClass:"w4 block mv2 pointer btn dim b f5 fw4 textColor",class:{disabled: _vm.buttonDisabled},attrs:{"disabled":_vm.buttonDisabled},on:{"click":function($event){$event.preventDefault();return _vm.save()}}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loadingEdition),expression:"!loadingEdition"}]},[_vm._v(_vm._s(_vm.$t("albums.newAlbum.uploadButton")))]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loadingEdition),expression:"loadingEdition"}],staticClass:"flex justify-center"},[_c('clip-loader',{attrs:{"loading":true,"color":_vm.color,"size":_vm.smallSize}})],1)])])])])])}
var staticRenderFns = []


/***/ }),
/* 1161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewDiscover_vue__ = __webpack_require__(561);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3225a374_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewDiscover_vue__ = __webpack_require__(1163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1162)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3225a374"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewDiscover_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3225a374_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewDiscover_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3225a374_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewDiscover_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1162 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"discoverHeight"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.withFilters && _vm.genresMain.length > 0),expression:"withFilters && genresMain.length > 0"}]},[_c('div',{staticClass:"w-100 justify-around items-center ttu",staticStyle:{"background-color":"#393839","position":"relative","display":"flex"}},[_c('div',[_c('a',{staticStyle:{"margin-left":"10px","fill":"white","cursor":"pointer"},on:{"click":function($event){return _vm.genTranslate('genMain', 'left')}}},[_c('svg',{staticClass:"bi bi-caret-left",attrs:{"width":"25","height":"25","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M10 12.796V3.204L4.519 8 10 12.796zm-.659.753-5.48-4.796a1 1 0 0 1 0-1.506l5.48-4.796A1 1 0 0 1 11 3.204v9.592a1 1 0 0 1-1.659.753z"}})])])]),_vm._v(" "),_c('div'),_vm._v(" "),_c('div',{staticClass:"container-scroll w-100"},[_c('div',{staticClass:"container-genbar",attrs:{"id":"genMain"}},[_c('a',{staticClass:"genre-filter f6 link dim ph3 pv2 dib white mr2",class:{
              'genre-filter-selected': _vm.genreFilter == '',
              pointer: _vm.genreFilter != '',
            },on:{"click":function($event){return _vm.selectGenMain('')}}},[_vm._v("\n            "+_vm._s(_vm.$t("tracks.genres.all"))+"\n          ")]),_vm._v(" "),_vm._l((_vm.genresMain),function(genre){return _c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.genresMain.length > 0),expression:"genresMain.length > 0"}],key:genre.id,staticClass:"genre-filter f6 link dim ph3 pv2 dib white mr2",class:{
              'genre-filter-selected': _vm.genreFilter == genre.id,
              pointer: _vm.genreFilter != genre.id,
            },attrs:{"track-by":genre.id,"tabindex":genre.id},on:{"click":function($event){return _vm.selectGenMain(genre.id)},"blur":function($event){return _vm.selectGenMainBlur($event)},"focus":function($event){return _vm.selectGenMainFocus($event)}}},[_vm._v("\n            "+_vm._s(genre.name)+"\n          ")])})],2)]),_vm._v(" "),_c('div',[_c('a',{staticStyle:{"margin-right":"10px","fill":"white","cursor":"pointer"},on:{"click":function($event){return _vm.genTranslate('genMain', 'right')}}},[_c('svg',{staticClass:"bi bi-caret-right",attrs:{"width":"25","height":"25","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M6 12.796V3.204L11.481 8 6 12.796zm.659.753 5.48-4.796a1 1 0 0 0 0-1.506L6.66 2.451C6.011 1.885 5 2.345 5 3.204v9.592a1 1 0 0 0 1.659.753z"}})])])])]),_vm._v(" "),_c('div',{staticClass:"w-100 justify-between items-center ttu black",staticStyle:{"background-color":"black","position":"relative","display":"flex"}},[_c('div',[_c('a',{staticStyle:{"fill":"white","cursor":"pointer"},on:{"click":function($event){return _vm.genTranslate('genSecon', 'left')}}},[_c('svg',{staticClass:"bi bi-caret-left",attrs:{"width":"25","height":"25","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M10 12.796V3.204L4.519 8 10 12.796zm-.659.753-5.48-4.796a1 1 0 0 1 0-1.506l5.48-4.796A1 1 0 0 1 11 3.204v9.592a1 1 0 0 1-1.659.753z"}})])])]),_vm._v(" "),_c('div',{staticClass:"container-scroll w-100"},[_c('div',{staticClass:"container-genbar",attrs:{"id":"genSecon"}},_vm._l((_vm.genSeconByMain),function(genre){return _c('a',{key:genre.id,staticClass:"genre-filter f6 link dim ph3 pv2 dib white mr2",class:{
              'genre-filter-selected': _vm.genreFilter == genre.id,
              pointer: _vm.genreFilter != genre.id,
            },staticStyle:{"font-size":"0.775rem","min-width":"120px","text-align":"center"},attrs:{"track-by":genre.id},on:{"click":function($event){return _vm.selectGenSecon(genre.id)}}},[_vm._v("\n            "+_vm._s(genre.name)+"\n          ")])}),0)]),_vm._v(" "),_c('div',[_c('a',{staticStyle:{"fill":"white","cursor":"pointer"},on:{"click":function($event){return _vm.genTranslate('genSecon', 'right')}}},[_c('svg',{staticClass:"bi bi-caret-right",attrs:{"width":"25","height":"25","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M6 12.796V3.204L11.481 8 6 12.796zm.659.753 5.48-4.796a1 1 0 0 0 0-1.506L6.66 2.451C6.011 1.885 5 2.345 5 3.204v9.592a1 1 0 0 0 1.659.753z"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"w-100 mh3 w-mobile"},[_c('div',{staticClass:"search-wrapper w-third-l w-50-m w-100 block pointer z-1 relative bg-tertiary fr mt3"},[_c('button',{staticClass:"w-10-ns w-90 pointer btn1 dim b f5 fw4",attrs:{"type":"button","icon":"search"},on:{"click":_vm.update}},[_c('font-awesome-icon',{staticClass:"search-left-icon",attrs:{"icon":"search"}})],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.textToFilter),expression:"textToFilter"}],staticClass:"pa2 input w-100 bg-transparent w-50-mobile",attrs:{"maxlength":"255","placeholder":_vm.$t('artists.search.placeholder')},domProps:{"value":(_vm.textToFilter)},on:{"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.clearFilters.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.update.apply(null, arguments)}],"input":function($event){if($event.target.composing){ return; }_vm.textToFilter=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"filtersLabelsDiv"},[(_vm.mainGenre.name)?_c('span',{staticClass:"filtersLabels",on:{"click":_vm.filterByMainGenreLabel}},[_vm._v(_vm._s(_vm.mainGenre.name))]):_vm._e(),_vm._v(" "),(_vm.mainGenre.name && _vm.seconGenre.name)?_c('span',[_vm._v(" / ")]):_vm._e(),_vm._v(" "),(_vm.seconGenre.name)?_c('span',{staticClass:"filtersLabels",on:{"click":_vm.removeSeconGenreLabel}},[_vm._v(_vm._s(_vm.seconGenre.name))]):_vm._e(),_vm._v(" "),((_vm.mainGenre.name || _vm.seconGenre.name) && _vm.filteredText)?_c('span',[_vm._v(" / ")]):_vm._e(),_vm._v(" "),(_vm.filteredText)?_c('span',{staticClass:"filtersLabels",on:{"click":_vm.removeFilteredTextLabel}},[_vm._v(_vm._s(_vm.filteredText))]):_vm._e()]),_vm._v(" "),_c('div',{attrs:{"id":"discoverMainContent"}},[_c('div',{attrs:{"id":"artistsCarousel"}},[_c('h2',{staticClass:"p-2 carouselTitle"},[_vm._v(_vm._s(_vm.$t("discover.carousels.artists")))]),_vm._v(" "),(_vm.artists)?_c('div',[_c('custom-carousel',{attrs:{"loading":_vm.loading,"artists":_vm.artists,"textToFilter":_vm.textToFilter}})],1):_vm._e(),_vm._v(" "),(!_vm.artists)?_c('div',{staticClass:"flex justify-center"},[_c('p',[_vm._v(_vm._s(_vm.$t("app.info.noResults")))])]):_vm._e()]),_vm._v(" "),_c('div',{attrs:{"id":"tracksCarousel"}},[_c('h2',{staticClass:"p-2 carouselTitle"},[_vm._v(_vm._s(_vm.$t("discover.carousels.tracks")))]),_vm._v(" "),(_vm.allTracks)?_c('div',[_c('custom-carousel',{attrs:{"loading":_vm.loading,"allTracks":_vm.allTracks,"textToFilter":_vm.textToFilter}})],1):_vm._e(),_vm._v(" "),(!_vm.allTracks)?_c('div',{staticClass:"flex justify-center"},[_c('p',[_vm._v(_vm._s(_vm.$t("app.info.noResults")))])]):_vm._e()]),_vm._v(" "),_c('div',{attrs:{"id":"playlistsCarousel"}},[_c('h2',{staticClass:"p-2 carouselTitle"},[_vm._v(_vm._s(_vm.$t("discover.carousels.playlists")))]),_vm._v(" "),(_vm.playlists)?_c('div',[_c('custom-carousel',{attrs:{"loading":_vm.loading,"playlists":_vm.playlists,"textToFilter":_vm.textToFilter}})],1):_vm._e(),_vm._v(" "),(!_vm.playlists)?_c('div',[_c('p',[_vm._v("No se encontraron Playlists con ése género")])]):_vm._e()]),_vm._v(" "),_c('div',{attrs:{"id":"recommendedPlaylistsCarousel"}},[_c('h2',{staticClass:"p-2 carouselTitle"},[_vm._v(_vm._s(_vm.$t("discover.carousels.recommendedPlaylists")))]),_vm._v(" "),(_vm.recommendedPlaylists)?_c('div',[_c('custom-carousel',{attrs:{"loading":_vm.loading,"recommendedPlaylists":_vm.recommendedPlaylists,"textToFilter":_vm.textToFilter}})],1):_vm._e(),_vm._v(" "),(!_vm.recommendedPlaylists)?_c('div',[_c('p',[_vm._v("No se encontraron Playlists recomendadas con ése género")])]):_vm._e()])])])}
var staticRenderFns = []


/***/ }),
/* 1164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RadiosList_vue__ = __webpack_require__(562);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea43833a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RadiosList_vue__ = __webpack_require__(1169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1165)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ea43833a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RadiosList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea43833a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RadiosList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea43833a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RadiosList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1165 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RadioCard_vue__ = __webpack_require__(563);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f296ec8_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RadioCard_vue__ = __webpack_require__(1168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1167)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5f296ec8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RadioCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f296ec8_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RadioCard_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f296ec8_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RadioCard_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1167 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"radio-card relative flex pointer pa3 cover bg-center"},[_c('div',{staticClass:"flex-column w-100"},[_c('div',{staticClass:"radio-info",on:{"click":_vm.listenToRadio}},[_c('div',{staticClass:"body relative hide-child"},[_c('img',{staticClass:"radio-picture db",attrs:{"src":_vm.listPicture,"alt":((_vm.radio.name) + " Picture")}})]),_vm._v(" "),_c('div',{staticClass:"flex items-center justify-center bg-primary mw-90"},[_c('p',{staticClass:"z-1 white-90 word-wrap flex f5 radio-name ma3 rname"},[_vm._v(_vm._s(_vm.radio.name))])]),_vm._v(" "),_c('div',{staticClass:"flex items-center justify-center bg-primary mw-90"},[_c('p',{staticClass:"z-1 white-90 word-wrap flex f5 radio-name ma3 rcategory"},[_vm._v(_vm._s(_vm.radio.category))])])])])])}
var staticRenderFns = []


/***/ }),
/* 1169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"radio-list flex flex-wrap justify-center items-start pb5 w-100"},_vm._l((_vm.radios),function(radio,index){return _c('radio-card',{key:index,attrs:{"radio":radio}})}),1)])}
var staticRenderFns = []


/***/ }),
/* 1170 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1171 */,
/* 1172 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1173 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1174 */,
/* 1175 */,
/* 1176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export modules */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_player__ = __webpack_require__(1177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_user__ = __webpack_require__(1187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_track__ = __webpack_require__(1191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_artist__ = __webpack_require__(1196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_playlist__ = __webpack_require__(1197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_home__ = __webpack_require__(1198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_license__ = __webpack_require__(1199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_translator__ = __webpack_require__(1200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_news__ = __webpack_require__(1203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_pricing__ = __webpack_require__(1204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_dashboard__ = __webpack_require__(1205);













__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var modules = {
  player: __WEBPACK_IMPORTED_MODULE_2__modules_player__["a" /* default */],
  user: __WEBPACK_IMPORTED_MODULE_3__modules_user__["a" /* default */],
  track: __WEBPACK_IMPORTED_MODULE_4__modules_track__["a" /* default */],
  artist: __WEBPACK_IMPORTED_MODULE_5__modules_artist__["a" /* default */],
  playlist: __WEBPACK_IMPORTED_MODULE_6__modules_playlist__["a" /* default */],
  home: __WEBPACK_IMPORTED_MODULE_7__modules_home__["a" /* default */],
  license: __WEBPACK_IMPORTED_MODULE_8__modules_license__["a" /* default */],
  translator: __WEBPACK_IMPORTED_MODULE_9__modules_translator__["a" /* default */],
  news: __WEBPACK_IMPORTED_MODULE_10__modules_news__["a" /* default */],
  pricing: __WEBPACK_IMPORTED_MODULE_11__modules_pricing__["a" /* default */],
  dashboard: __WEBPACK_IMPORTED_MODULE_12__modules_dashboard__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: modules
}));

/***/ }),
/* 1177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__(1178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__consts__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_loading__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuex_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__translator__ = __webpack_require__(69);







var _createActionHelpers = Object(__WEBPACK_IMPORTED_MODULE_4_vuex_loading__["createActionHelpers"])({
  moduleName: 'loading'
}),
    startLoading = _createActionHelpers.startLoading,
    endLoading = _createActionHelpers.endLoading;

var initialStates = function initialStates() {
  return {
    isPlaying: false,
    currentTrack: Object,
    index: 0,
    playlist: [],
    isPlayingPrevious: false,
    isUnauthorized: false,
    isShareTrack: false,
    minTrackDuration: 0
  };
};

var mutations = {
  setCurrentTrackLike: function setCurrentTrackLike(state, value) {
    state.currentTrack.is_liked = value;
  },
  setPlaying: function setPlaying(state, value) {
    state.isPlaying = value;
  },
  setPlaylist: function setPlaylist(state, value) {
    // Keep clone of playlist, preventing dual modifications.
    console.log('setPlaylist (state, value) { ', value);
    console.log('value.slice() ', value.slice());
    state.playlist = value.slice();
  },
  playFirstTrack: function playFirstTrack(state) {
    if (state.playlist.length > 0) {
      state.currentTrack = state.playlist[0];
      console.log('state.currentTrack', state.currentTrack);
      state.isPlaying = true;
      state.index = 0;
    }
  },
  playNext: function playNext(state) {
    if (state.index !== -1 && state.index < state.playlist.length - 1) {
      state.index++;
      state.currentTrack = state.playlist[state.index];
      state.isPlaying = !state.isUnauthorized;
    }
  },
  playPrevious: function playPrevious(state) {
    if (state.index !== -1 && state.index > 0) {
      state.index--;
      state.currentTrack = state.playlist[state.index];
      if (state.currentTrack.isAd) {
        state.isPlayingPrevious = true;
      } else {
        state.isPlayingPrevious = false;
      }
      state.isPlaying = !state.isUnauthorized;
    }
  },
  playByIndex: function playByIndex(state, value) {
    if (value <= 0 && value < state.playlist.length - 1) {
      state.index = value;
      state.currentTrack = state.playlist[value];
      state.isPlaying = !state.isUnauthorized;
    }
  },
  playByTrack: function playByTrack(state, value) {
    state.index = state.playlist.indexOf(value);
    if (state.index !== -1) {
      state.currentTrack = state.playlist[state.index];
      state.isPlaying = !state.isUnauthorized;
    }
  },
  addToQueue: function addToQueue(state, value) {
    var index = state.playlist.indexOf(value[0]);
    if (index === -1) {
      for (var i = 0; i < value.length; i++) {
        state.playlist.push(value[i]);
      }
    }
  },
  removeAds: function removeAds(state) {
    for (var i = 0; i < state.playlist.length; i++) {
      if (state.playlist[i].isAd) {
        state.playlist.splice(i, 1);
      }
    }
    state.index = state.playlist.indexOf(state.currentTrack);
  },
  addAds: function addAds(state, ads) {
    var aux = [];
    for (var i = 0; i < state.playlist.length; i++) {
      aux.push(state.playlist[i]);
      aux.push(ads[i % ads.length]);
    }
    state.playlist = aux.slice();
    state.index = state.playlist.indexOf(state.currentTrack);
  },
  setIsShareTrack: function setIsShareTrack(state, value) {
    console.log('state.isPlaying ', state.isPlaying);
    console.log('state.currentTrack ', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(state.currentTrack));
    state.isShareTrack = value;
  },
  setIsUnauthorized: function setIsUnauthorized(state, value) {
    state.isUnauthorized = value;
  },
  setMinTrackDuration: function setMinTrackDuration(state, value) {
    state.minTrackDuration = value;
  }
};
var actions = {
  setCurrentTrackLike: function setCurrentTrackLike(_ref, value) {
    var commit = _ref.commit;

    commit('setCurrentTrackLike', value);
  },
  setPlaying: function setPlaying(_ref2, value) {
    var commit = _ref2.commit;

    commit('setPlaying', value);
  },
  setPlaylist: function setPlaylist(_ref3, value) {
    var commit = _ref3.commit,
        state = _ref3.state,
        rootGetters = _ref3.rootGetters;

    if (!rootGetters['user/isSubscribed']) {
      if (!state.currentTrack.isAd) {
        commit('setPlaylist', value);
        commit('addAds', rootGetters['track/ads']);
      }
    } else {
      commit('setPlaylist', value);
    }
  },
  playNext: function playNext(_ref4) {
    var commit = _ref4.commit,
        rootGetters = _ref4.rootGetters,
        state = _ref4.state;

    commit('playNext');
  },
  playPrevious: function playPrevious(_ref5) {
    var commit = _ref5.commit,
        rootGetters = _ref5.rootGetters,
        state = _ref5.state;

    commit('playPrevious');
  },
  playByIndex: function playByIndex(_ref6, value) {
    var commit = _ref6.commit,
        rootGetters = _ref6.rootGetters,
        state = _ref6.state;

    if (!state.currentTrack.isAd) {
      commit('playByIndex', value);
    }
  },
  changeTrack: function changeTrack(_ref7, value) {
    var commit = _ref7.commit,
        rootGetters = _ref7.rootGetters,
        state = _ref7.state;

    if (rootGetters['user/isSubscribed'] || !state.currentTrack.isAd) {
      commit('playByTrack', value);
    }
  },
  playFirstTrack: function playFirstTrack(_ref8) {
    var commit = _ref8.commit,
        rootGetters = _ref8.rootGetters,
        state = _ref8.state;

    if (rootGetters['user/isSubscribed'] || !state.currentTrack.isAd) {
      commit('playFirstTrack');
    }
  },
  addToQueue: function addToQueue(_ref9, value) {
    var commit = _ref9.commit,
        rootGetters = _ref9.rootGetters;

    var aux = [];
    aux.push(value);
    if (!rootGetters['user/isSubscribed']) {
      aux.push(rootGetters['track/ads'][Math.floor(Math.random() * rootGetters['track/ads'].length)]);
    }
    commit('addToQueue', aux);
  },
  removeAdsFromCurrentPlaylist: function removeAdsFromCurrentPlaylist(_ref10) {
    var commit = _ref10.commit,
        state = _ref10.state;

    if (state.currentTrack.isAd) {
      if (state.isPlayingPrevious) {
        commit('playPrevious');
      } else {
        commit('playNext');
      }
    }
    commit('removeAds');
  },
  addAdsToCurrentPlaylist: function addAdsToCurrentPlaylist(_ref11) {
    var commit = _ref11.commit,
        rootGetters = _ref11.rootGetters;

    commit('addAds', rootGetters['track/ads']);
  },
  setIsShareTrack: function setIsShareTrack(_ref12, value) {
    var commit = _ref12.commit;

    commit('setIsShareTrack', value);
  },
  setIsUnauthorized: function setIsUnauthorized(_ref13, value) {
    var commit = _ref13.commit;

    commit('setIsUnauthorized', value);
  },
  getMinTrackDuration: function getMinTrackDuration(_ref14) {
    var commit = _ref14.commit,
        dispatch = _ref14.dispatch;

    startLoading(dispatch, 'player getMinTrackDuration');
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/config/getValueByParameter?parameter=minTrackDuration').then(function (response) {
        commit('setMinTrackDuration', parseInt(response.body.data));
        if (response.body.status === true) {
          resolve(parseInt(response.body.data));
        } else {
          reject(new Error(response.body.error));
        }
        endLoading(dispatch, 'player getMinTrackDuration');
      }, function () {
        endLoading(dispatch, 'player getMinTrackDuration');
        reject(new Error(__WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network')));
      });
    });
  }
};

var getters = {
  isPlaying: function isPlaying(state) {
    return state.isPlaying;
  },
  isCurrentTrack: function isCurrentTrack(state) {
    return function (track) {
      return state.currentTrack === track;
    };
  },
  currentTrack: function currentTrack(state) {
    return state.currentTrack;
  },
  playlist: function playlist(state) {
    return state.playlist;
  },
  canPrevious: function canPrevious(state) {
    var index = state.playlist.indexOf(state.currentTrack);
    return index !== -1 && index > 0 && !state.currentTrack.isAd;
  },
  canNext: function canNext(state) {
    var index = state.playlist.indexOf(state.currentTrack);
    return index !== -1 && index < state.playlist.length - 1 && !state.currentTrack.isAd;
  },
  currentIndex: function currentIndex(state) {
    return state.index;
  },
  isPlayingPrevious: function isPlayingPrevious(state) {
    return state.isPlayingPrevious;
  },
  isShareTrack: function isShareTrack(state) {
    return state.isShareTrack;
  },
  isUnauthorized: function isUnauthorized(state) {
    return state.isUnauthorized;
  },
  minTrackDuration: function minTrackDuration(state) {
    return state.minTrackDuration;
  }
};

var player = {
  namespaced: true,
  initialStates: initialStates,
  state: initialStates(),
  mutations: mutations,
  actions: actions,
  getters: getters
};

/* harmony default export */ __webpack_exports__["a"] = (player);

/***/ }),
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  currency: {
    style: 'currency', currency: '$'
  },
  app: {
    signin: 'Ingresa',
    signup: 'Registrate',
    or: 'o',
    save: 'Guardar',
    yes: 'Sí',
    no: 'No',
    clickHere: 'Click aquí',
    back: 'Volver',
    info: {
      noResults: 'No hay resultados',
      noMoreResults: 'No hay más resultados'
    },
    delete: 'Eliminar',
    loading: 'Cargando',
    discover: 'Descubrir',
    shop: 'Shop',
    '360': '360',
    latestNews: 'Latest News',
    featuredPlaylist: {
      title: 'Featured Playlist',
      createdBy: 'Creada por'
    },
    recommended: 'Recomendados de BeatHey',
    leaveConfirmation: '¿Está seguro que desea abandonar la página? Se perderá la información ingresada',
    notAllowed: 'Tu usuario no se encuentra autorizado para realizar esta acción.',
    notShowAgain: 'Aceptar'
  },

  form: {
    message: 'Mensaje',
    send: 'Enviar'
  },

  provider: {
    directLink: 'Crear acceso a pantalla de inicio'
  },

  discover: {
    carousels: {
      artists: 'ARTISTAS',
      tracks: 'LO ÚLTIMO',
      playlists: 'PLAYLISTS',
      recommendedPlaylists: 'PLAYLISTS RECOMENDADAS'
    }
  },

  error: {
    emailRequired: 'Debe ingresar un email',
    emailInvalid: 'El email ingresado no es válido',
    emailRepeated: 'El email ingresado ya existe',
    confirmEmailRequired: 'Debe repetir el email ingresado',
    confirmEmailInvalid: 'El email ingresado no coincide',
    valueRequired: 'Debe ingresar un importe',
    valueInvalid: 'El importe debe ser un número',
    valueMinPrice: 'El importe debe ser mayor o igual al mínimo: ',
    voucherInvalid: 'Beneficio inexistente, intentar con otro',
    voucherInactive: 'Beneficio ya no está activo',
    voucherFulled: 'Beneficio agotado',
    shortVoucher: 'El voucher debe tener mas de 10 caracteres',
    longVoucher: 'El voucher debe tener menos de 15 caracteres',
    trackNameRequired: 'Debe ingresar un nombre para el track',
    albumNameRequired: 'Debe ingresar un nombre para el album',
    trackFileRequired: 'Debe Subir un Track',
    iswcErrorCode: 'El codigo ISWC debe respetar el formato T-xxxxxxxxx-x',
    genreRequired: 'Debe ingresar un género para el track',
    usernameRequired: 'Debe ingresar un nombre de usuario',
    usernameRepeated: 'El nombre de usuario ya existe',
    idRequired: 'Debe ingresar un número de identificación personal',
    shortId: 'El número de identificación personal ingresado es demasiado corto',
    phoneInvalid: 'El teléfono ingresado no es válido',
    addressRequired: 'Debe ingresar su dirección',
    birthdateRequired: 'Debe ingresar su fecha de nacimiento completa',
    confirmPasswordInvalid: 'Las contraseñas deben coincidir',
    passwordRequired: 'Debe ingresar una contraseña',
    nameRequired: 'Debe ingresar un nombre',
    messageRequired: 'Debe ingresar una consulta',
    messageMaxLength: 'El mensaje es muy largo. Cantidad másxima de caracteres es 2048',
    playlistRequired: 'Debe seleccionar una playlist',
    playlistNameRequired: 'Debe ingresar el nombre de la playlist',
    trackUpload: 'Error al guardar el track',
    albumUpload: 'Error al guardar el album',
    minPriceRequired: 'Este campo es requerido',
    minPriceValue: 'El valor no puede ser menor a 1 dólar',
    pictureRequired: 'Debe Subir una Imagen',
    store: {
      network: 'Error de red',
      userValidation: 'Error al validar el usuario',
      paymentLink: 'Error al obtener el link de pago',
      myFavorites: 'Error al cargar mis favoritos',
      myTracks: 'Error al cargar mis tracks',
      myPlaylists: 'Error al cargar mis playlists',
      voteValidation: 'Error al verificar los votos',
      data: 'Error al cargar los datos',
      artists: 'Error al cargar los artistas',
      playlists: 'Error al cargar las playlists',
      tracks: 'Error al cargar los tracks',
      voteQuote: 'Ya votaste a 3 artistas! En el próximo mes contarás con 3 votos nuevos para seguir votando',
      SameArtistAndUser: 'No podés votarte a vos mismo!',
      vote: 'Error al votar',
      vinylContest: 'Error al cargar el vinyl contest',
      contact: 'Error al enviar el mensaje',
      addToPlaylist: 'Error al agregar a playlist',
      newPlaylist: 'Error al crear la playlist',
      deletePlaylist: 'Error al eliminar playlist',
      updatePlaylist: 'Error al editar playlist',
      deleteFromPlaylist: 'Error al eliminar track de la playlist',
      deleteTrack: 'Error al eliminar el track',
      noDataPosted: 'Error: Faltan datos',
      authenticationFailed: 'El email y/o la contraseña son incorrectos',
      login: 'Error al iniciar sesión',
      playlist: 'Error al cargar la playlist',
      playlistPrivate: 'Error: la playlist es privada',
      playlistNotFound: 'Error: no se encontró ninguna playlist',
      featuredPlaylist: 'Error al cargar featured playlist',
      artistNotFound: 'Error: no se encontró el artista de featured playlist',
      notSaved: 'Error: no se guardaron los cambios',
      editArtist: 'Error al actualizar los datos del artista',
      notValidToken: 'Error de autenticación',
      track: 'Error al cargar el track',
      likePlaylist: 'Error al hacer me gusta al playlist'
    }
  },

  users: {
    login: 'Iniciar sesión',
    username: 'Nombre de usuario',
    name: 'Nombre | Nombres',
    surnames: 'Apellidos',
    id: 'Número de identificación personal',
    email: 'Email',
    emailConfirmation: 'Confirmar email',
    address: 'Dirección',
    password: 'Contraseña',
    phone: 'Teléfono',
    birthdate: 'Fecha de Nacimiento',
    day: 'Día',
    month: 'Mes',
    year: 'Año',
    months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
    code: 'Código',
    voucher: 'Ingresá el código de descuento',
    generateReferralCode: 'Generar Link de Referido',
    choseUserType: 'Selecciona tu perfil',
    textUserType: 'Esta selección puede ser modificada en "Mi Perfil"',
    userType: {
      musicFan: 'Fan',
      producer: 'Artista',
      free: 'Oyente',
      flowArtist: {
        artisticName: 'Nombre artístico',
        text: 'Puedes modificar toda la información personal y artística en "Mi Perfil"'

      }
    },
    registration: {
      shareData: 'Compartir mis datos de registro con los proveedores de contenido de BeatHey para fines de marketing.',
      accept: 'Al hacer click en REGISTRARSE, aceptas los',
      comma: ', la',
      andThe: 'y la',
      register: 'Registrarse',
      alreadyHaveAnAccount: '¿Ya tenés una cuenta?'
    },
    accept: {
      newsLetter: 'Acepto recibir NewsLetter',
      shareInfo: 'Acepto compartir información de contacto con Artistas'
    },
    bio: 'Bio',
    bioDescription: 'Escribe algo sobre tí que te represente',
    country: 'País',
    city: 'Ciudad',
    forgetPassword: {
      question: '¿Olvidaste tu contraseña?',
      success: 'Se envió una nueva contraseña al email ingresado',
      button: 'Recuperar contraseña'
    },
    rememberPassword: '¿Recordaste tu contraseña?',
    changePassword: 'Cambiar contraseña',
    passwordConfirmation: 'Repetir contraseña',
    hasNotFavorites: 'No agregaste ningún track a favoritos',
    editSuccess: 'Se actualizó la información correctamente',
    loginToUnauthorizedUser: 'Para seguir escuchando música, te invitamos a registrarte',
    cancelLoginToUnauthorizedUser: 'Cancelar',
    subscription: {
      title: 'Suscribite!',
      info1: 'Lanzamiento digital de regalo con los mejores 4 artistas del Contest',
      info2: 'Recibir de regalo BeatHey Mag (Sólo para Argentina)',
      info3: 'Si sos artista, tenés la posibilidad de publicar tu música y ser votado en el Contest',
      info4: 'Si sos artista, el 100% de lo recaudado por la venta de música es tuyo',
      info5: 'Si sos artista, podés ser seleccionado para tocar en los eventos BeatHey',
      info6: 'Formas de pago',
      infoEmailNeeded1: 'Por controles internos a MercadoPago, necesitamos la dirección de mail asociada a la billetera (MercadoPago) con la cual realizaremos la operación',
      infoEmailNeeded2: 'Esta información no será almacenada por BeatHey y es de uso exclusivo para esta operación',
      valueTitle: 'Se parte de la comunidad por',
      currency: 'AR$',
      value: '250',
      free: '¡¡Gratuito!!',
      button: 'Suscribirse',
      cancel: 'Cancelar',
      disaffiliate: 'Desafiliarme',
      confirm: 'Confirmar',
      reject: 'Rechazar',
      cancelTitle: '¡Gracias por habernos elegido!',
      cancelMessage: '¿Está seguro de cancelar su suscripción a BeatHey?',
      cancelAccountMessage: '¿Está seguro de cancelar su cuenta BeatHey?',
      cancelAccount: 'Cancela tu cuenta BeatHey.',
      cancelAccountSuccess: 'Tu cuenta BeatHey fue eliminada correctamente.',
      cancelAccountError: 'Hubo un problema eliminando tu cuenta.',
      cancelSubscription: 'Desafiliar tu suscripción recurrente a BeatHey.',
      canceledMPsubSuccess: 'Su suscripción recurrente por Mercado Pago ah sido Cancelada correctamente',
      canceledMPsubError: 'Su suscripción recurrente por Mercado Pago ya ah sido Cancelada',
      voucherCodeMsg: 'Ingresá tu código de Beneficios',
      referredCodeMsg: 'Ingresá tu código de Referido',
      sendEmailNeeded: 'Procesar'
    },
    payment: {
      message: 'Elige una de las opciones de pago'
    },
    userMenu: {
      myProfile: 'Mi Perfil',
      myTracks: 'Mis Tracks',
      myPlaylists: 'Mis Playlist',
      myFavorites: 'Mis Favoritos',
      myShopping: 'Mis Compras',
      myAccount: 'Mi Cuenta',
      help: 'Ayuda',
      terms: 'Términos y Condiciones',
      logout: 'Cerrar Sesión'
    },
    followArtist: 'Ahora sigues a',
    unfollowArtist: 'Dejas de seguir a',
    follow: 'Seguir',
    following: 'Siguiendo',
    copyCodeSucces: 'Se copió el código correctamente',
    copyLinkSucces: 'Se copió el link correctamente',
    copyError: 'Error al copiar'
  },

  artists: {
    seeAll: 'Ver Todos',
    artists: 'Artistas',
    artist: 'Artista | Artistas',
    search: {
      placeholder: 'Buscar por nombre...',
      noMoreResults: 'No hay más resultados'
    },
    info: 'Información del artista',
    name: 'Nombre',
    phrase: 'Bajada',
    text: 'Información',
    hasNotTracks: 'El artista no tiene tracks',
    hasNotPlaylists: 'El artista no tiene playlists',
    hasNotInfo: 'El artista no tiene información',
    section: {
      info: 'Info',
      contact: 'Contacto'
    },
    contact: {
      messagePlaceholder: 'Escribe aquí tu mensaje',
      success: 'Se envió el mensaje correctamente'
    }
  },

  albums: {
    uploadAlbum: 'Subir Album',
    newAlbum: {
      warningMessage: 'Complete los datos del Album para acceder a la carga de Tracks',
      namePlaceholder: 'Nombre del Album',
      uploaded: 'El album se creó correctamente',
      selectFiles: 'Seleccionar archivos',
      uploadButton: 'Subir Album',
      tagsPlaceholder: 'Describe los integrantes que participaron de la elaboración de la obra. Ej: PRODUCTOR, MEZCLA Y MASTERING,ARTE DE TAPA, etc.'
    }
  },

  tracks: {
    seeAll: 'Ver Todos',
    uploadTrack: 'Subir Track',
    track: 'No hay tracks | track | tracks',
    title: 'Título',
    artist: 'Artista',
    genre: 'Género',
    genres: {
      all: 'Todos'
    },
    minPrice: 'Precio Mínimo en U$D',
    release: 'Fecha',
    actions: {
      like: 'Me gusta',
      addToQueue: 'Agregar a la cola',
      buy: 'Comprar',
      share: 'Compartir',
      addToPlaylist: 'Agregar a playlist',
      deleteFromPlaylist: 'Eliminar de playlist',
      edit: 'Editar',
      credits: 'Creditos'
    },
    buyTrack: {
      title: 'Ayudá a ',
      line1: 'Al descargar el track ayudas al artista para que siga trabajando en su música.',
      line2: 'Vos decidís cuánto valorás su música',
      downloadMessage: 'Encontrarás el enlace de descarga del track en la sección "Mis compras" del perfil.',
      values: ['10', '20', '30', '50', '75', '100'],
      valueLabel: 'Importe',
      button: 'Comprar'
    },
    newTrack: {
      button: 'Subir Contenido',
      newRelease: 'Agregar a la lista de NEW RELEASE',
      dropSelectTrack: 'Arrastra o selecciona el archivo del track',
      selectFile: 'Seleccionar archivo',
      dropMessage: 'Soltar archivo para cargarlo',
      important: 'Importante: ',
      info: 'Al compartir, usted confirma que sus sonidos cumplen con nuestras condiciones de uso y que no infrinjan los derechos de cualquier otra persona. En caso de duda, consultar nuestras páginas y preguntas frecuentes información de copyright antes de subir.',
      question1: '¿Problemas para subir archivos?',
      answer1: 'Por favor, consulte nuestras sugerencias para solucionar problemas.',
      question2: '¿Qué tipos de archivos puedo subir?',
      answer2: 'Puede cargar MP3. El tamaño máximo de archivo es de 50MB.',
      extensionMessage: 'El archivo debe ser mp3',
      leaveConfirmation: 'Esta seguro que desea abandonar la página? El Track no está guardado',
      notProducer: 'Para subir tracks debes suscribirte como DJ/Productor!',
      uploaded: 'El track se agregó correctamente',
      imageError: 'La imagen seleccionada supera las dimensiones esperadas, esta debe ser menor a 4024 x 3768 pixeles',
      imageType: 'El archivo debe ser una imagen (jpg,jpeg,png)'
    },
    editTrack: {
      title: 'Sube tu música',
      selectPicture: 'Seleccionar imagen del track',
      completed: 'Carga completa',
      namePlaceholder: 'Nombre del track',
      tagsPlaceholder: 'Describe con palabras el estilo de tu track',
      creditsPlaceholder: 'Agrega los créditos',
      recommendedPlaceHolder: 'Comentanos cuál es tu género musical! Ayudanos a ampliar la familia BeatHey.',
      uploaded: 'El track se actualizó correctamente',
      iswcCode: 'Codigo ISWC Ej: T-xxxxxxxxx-x (opcional)',
      saveChanges: 'Guardar Cambios',
      listUploaded: 'La lista se actualizó correctamente'
    },
    deleteTrack: {
      title: 'Eliminar track',
      success: 'El track ha sido eliminado',
      confirm: '¿Está seguro que desea eliminar el track?'
    },
    shareTrack: {
      title: 'Compartir track',
      copy: 'Copiar',
      success: 'Se copió el link correctamente',
      error: 'Error al copiar el link'
    },
    licenses: {
      features: 'Características de las licencias',
      selected: 'Licencia elegida',
      questions: {
        1: {
          title: '¿Quiere permitir que se compartan adaptaciones de su obra?',
          options: {
            1: 'Sí',
            2: 'No',
            3: 'Sí, siempre que se comparta de la misma manera'
          }
        },
        2: {
          title: '¿Quiere permitir usos comerciales de su obra?',
          options: {
            1: 'Sí',
            2: 'No'
          }
        }
      }
    },
    headers: {
      title: 'Título',
      artist: 'Artista',
      genre: 'Género',
      released: 'Lanzado',
      duration: 'Duración',
      date: 'Comprado'
    }
  },

  playlists: {
    seeAll: 'Ver Todos',
    playlist: 'Playlist | Playlists',
    type: {
      public: 'Pública',
      private: 'Privada'
    },
    isPrivate: 'Esta playlist es privada',
    addToPlaylist: {
      title: 'Agregar a playlist',
      select: 'Selecciona una playlist',
      add: 'Agregar',
      success: 'El track se agregó a la playlist correctamente',
      trackAlreadyExist: 'El track ya existe en esta playlist'
    },
    newPlaylist: {
      button: 'Nueva playlist',
      title: 'Crear nueva playlist',
      imageError: 'Error al cargar la imagen de la playlist',
      playlistName: 'Título playlist',
      saveAndAdd: 'Guardar y agregar',
      success: 'Se creó la playlist correctamente'
    },
    delete: {
      confirm: '¿Está seguro que desea eliminar la playlist?',
      success: 'Se eliminó la playlist correctamente',
      title: 'Eliminar Playlist'
    },
    edit: {
      title: 'Editar playlist',
      button: 'Editar',
      success: 'Se modficó la playlist correctamente'
    },
    deleteTrackFromPlaylist: {
      title: 'Eliminar track de la playlist',
      success: 'El track ha sido eliminado de la playlist',
      confirm: '¿Está seguro que desea eliminar el track de la playlist?'
    },
    sharePlaylist: 'Compartir playlist',
    like: {
      button: 'me gusta'
    }
  },

  vinylContest: {
    noArtist: 'No se han votado artistas aún',
    vote: 'Votar',
    success: 'Tu voto fue registrado!',
    link: 'Ir al Contest',
    title: 'Contest',
    closeIn: 'Cierra en:',
    day: 'día | días',
    hour: 'hora | horas',
    minute: 'minutos | minuto | minutos'
  },

  payment: {
    mpConnect: {
      info: 'Conectate a Mercado Pago para recibir el 100% de las ventas de tus tracks, sin intermediarios, directamente en tu cuenta personal.',
      title: 'Cobra mediante Mercado Pago la venta de tus tracks!',
      connectedAs: 'Conectado como',
      disconnectInfo: 'Para eliminar la conexión debe ingresar a ',
      nickname_title_help: 'Esta información la verá el comprador al momento de pagar. Te recomendamos que se relacione con el artista.'
    },
    connect: 'Conectar',
    paypal: {
      subscriptionSuccess: 'Su subscripción se generó exitosamente'
    }
  },

  help: {
    title: '¿Cómo te podemos ayudar?',
    contactInformation: 'Información de contacto',
    whatsapp: '+54 911 5574 0051',
    email: 'contacto@BeatHey.com',
    contactForm: {
      title: 'Envianos tu consulta',
      success: 'Se envió la consulta correctamente'
    },
    unsubscribe: 'Recuerda, para darte de baja con ',
    send: 'envía ',
    to: 'al ',
    faqs: 'Preguntas frecuentes'
  },

  uploadPicture: {
    selectPicture: 'Seleccionar imagen'
  },

  footer: {
    termsOfUse: 'Términos y condiciones de uso',
    intellectuallyProp: 'Política de propiedad intelectual',
    privacyPolicy: 'Política de privacidad y cookies',
    help: 'Ayuda',
    contact: 'Contacto',
    company: 'Empresa',
    language: {
      title: 'Idioma',
      spanish: 'Español',
      english: 'English',
      portuguese: 'Português'
    }
  },
  ads: {
    advertisingSpace: 'Espacio publicitario'
  },
  landing: {
    plans: 'Planes',
    music: 'Música',
    title: ' sin intermediarios',
    subtitle: 'Los ingresos son 100% para el artista',
    leyend: 'Comienza a cambiar vidas',
    button1: 'Oyendo',
    button2: 'Creando',
    join: 'Sumate!',
    joinText: 'Conocé nuestros',
    description: {
      t1: 'Los ingresos',
      t2: 'son 100%',
      t3: 'para el artista'
    },
    oyendo: {
      title: 'No Solo Oyendo',
      carousel: {
        text1: 'Apoyas, ayudas y construyes comunidad, Escuchando, Compartiendo, Comprando y Votando',
        text2: 'Somos una comunidad de artistas independientes, y tu ayuda va directamente a cada uno de nosotros, sin intermediarios',
        text3: 'Estamos creando un nuevo concepto en la industria de la música y queremos que seas parte.'
      },
      button: 'Planes'
    },
    creando: {
      title: 'Incubando talentos',
      carousel: {
        text1: 'Tu esfuerzo se monetiza, cuanto más te escuhan, más te votan, más se vende tu música, más exposición vas a tener.',
        text2: 'Eres el dueño de tus derechos, vende tu música sin intermediarios, obtén votos de la comunidad en el contest trimestral y sé parte de nuestra revista.',
        text3: 'Somos una comunidad de artistas independientes, creando un nuevo concepto en la industria de la música en el que somos los protagonistas. ¡Vívelo con nosotros!'
      },
      button: 'Planes'
    },
    planes: {
      title: 'Tu suscripción genera el cambio.',
      leyend: 'Lo recaudado con las suscripciones se distribuye a los artistas bajo el concepto de “pago por streaming”. De esta forma, tu suscripción está impactando directamente en ellos, generándoles más oportunidades.',
      free: {
        text1: 'Escuchar Música',
        text2: 'Publicidad inherente a BeatHey',
        text3: 'Comprar Música'
      },
      fan: {
        text1: 'Marcar Favoritos',
        text2: 'Votar en Contest',
        text3: 'Escuchar sin Publicidad',
        text4: 'Lanzamientos Digitales de ganadores de contest de forma gratuita',
        text5: 'Revista BeatHey Mag, física y/o digital de forma gratuita',
        text6: 'Descuentos de hasta el 60% en tickets de festivales BeatHey'
      },
      artist: {
        header: 'Todos los Beneficios del Fan y más...',
        text1: 'Subir música y monetizarla',
        text2: 'Recibir el doble de ingresos por reproducción (pago por streaming)',
        text3: 'Posibilidad de presentaciones en festivales BeatHey bajo aval del equipo de curaduría'
      }
    }
  },
  dashboard: {
    title: 'Dashboard',
    apply: 'Aplicar',
    upload: 'Canciones Subidas',
    daysWithoutUpload: 'Dias sin subir Canciones',
    avg: 'Promedio Subidas Mensuales',
    likes: 'Me Gusta',
    followers: 'Seguidores',
    reproductionsRanking: 'Ranking de Reproducciones',
    songRanking: 'Detalle de reproducciones',
    trackName: 'Nombre Canción',
    duration: 'Duración',
    atention: 'Atención...',
    warning: 'Esta herramienta te permite acceder a información de lo que sucede con tus obras y así poder tomar decisiones. Suscríbete a través del botón "Subir Contenido" para acceder al 100% de la información disponible.',
    tooltipAdmin: 'Sos un Administrador.',
    tooltipArtist: 'Sos un Artista.',
    tooltipSubscribed: 'Estas Subscripto.',
    tableName: 'Nombre',
    tableArtist: 'Artista',
    tableRepro: 'Reproducciones',
    tableLikes: 'Me Gusta'
  },
  localContent: {
    title: 'EN VIVO',
    category: 'Categoría'
  }
});

/***/ }),
/* 1184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  currency: {
    style: 'currency', currency: 'USD'
  },
  app: {
    signin: 'Log in',
    signup: 'Sign up',
    or: 'or',
    save: 'Save',
    yes: 'Yes',
    no: 'No',
    clickHere: 'Click here',
    back: 'Go back',
    info: {
      noResults: 'Your search did not return any results',
      noMoreResults: 'There are no more results'
    },
    delete: 'Delete',
    loading: 'Loading',
    discover: 'Discover',
    shop: 'Shop',
    '360': '360',
    latestNews: 'Latest News',
    featuredPlaylist: {
      title: 'Featured Playlist',
      createdBy: 'Created by'
    },
    recommended: 'Recommended by BeatHey',
    leaveConfirmation: 'Are you sure you want to leave the site? The information entered will be lost',
    notAllowed: 'Your account is not allowed to perform this action.',
    notShowAgain: 'Accept'
  },

  form: {
    message: 'Message',
    send: 'Submit'
  },

  provider: {
    directLink: 'Create home screen access'
  },

  discover: {
    carousels: {
      artists: 'ARTISTS',
      tracks: 'THE LAST',
      playlists: 'PLAYLISTS',
      recommendedPlaylists: 'RECOMMENDED PLAYLISTS'
    }
  },

  error: {
    emailRequired: 'Email is required',
    emailInvalid: 'Email is invalid',
    emailRepeated: 'Email already exists',
    confirmEmailRequired: 'Email confirmation is required',
    confirmEmailInvalid: 'The two emails do not match',
    valueRequired: 'Amount required',
    valueInvalid: 'Amount must be a number',
    valueMinPrice: 'Amount must be greater or equal than: ',
    voucherInvalid: 'Non-existent Voucher, try something else',
    voucherInactive: 'Voucher is no longer active',
    voucherFulled: 'Voucher exhausted',
    shortVoucher: 'Voucher must have more than 10 characters',
    longVoucher: 'Voucher must have less than 10 characters',
    trackNameRequired: 'Track name is required',
    iswcErrorCode: 'ISWC code must respect the format T-xxxxxxxxx-x',
    genreRequired: 'Track genre is required',
    usernameRequired: 'Username is required',
    usernameRepeated: 'Username already exists',
    idRequired: 'ID is required',
    shortId: 'ID too short',
    phoneInvalid: 'Phone is invalid',
    addressRequired: 'Address is required',
    birthdateRequired: 'Birthdate is required',
    confirmPasswordInvalid: 'Passwords do not match',
    passwordRequired: 'Password is required',
    nameRequired: 'Name is required',
    messageRequired: 'Message is required',
    messageMaxLength: 'The message is too long. Maximum number of characters is 2048',
    playlistRequired: 'You must select a playlist',
    playlistNameRequired: 'Playlist name is required',
    trackUpload: 'An error occurred while saving the track',
    pictureRequired: 'Picture is required',
    minPriceRequired: 'This field is required',
    minPriceValue: 'The amount cant be less than 1 USD',
    albumNameRequired: 'You must enter a name for the album',
    trackFileRequired: 'You must Upload a Track',
    albumUpload: 'Failed to save album',
    store: {
      network: 'Network error',
      userValidation: 'An error occurred while validating the user',
      paymentLink: 'There was an error getting the payment link',
      myFavorites: 'An error occurred while loading my favorites',
      myTracks: 'An error occurred while loading my tracks',
      myPlaylists: 'An error occurred while loading my playlists',
      voteValidation: 'An error occurred while verifying your votes',
      data: 'An error occurred while loading the data',
      artists: 'An error occurred while loading artists',
      playlists: 'An error occurred while loading playlists',
      tracks: 'An error occurred while loading tracks',
      voteQuote: 'You have already voted 3 artists! In the next month you will have 3 new votes to continue voting',
      SameArtistAndUser: 'You can\'t vote yourself',
      vote: 'An error occurred while voting an artist',
      vinylContest: 'An error occurred while loading vinyl contest',
      contact: 'An error occurred while sending the message',
      addToPlaylist: 'An error occurred while adding a track to the playlist',
      newPlaylist: 'There was an error creating the playlist',
      deletePlaylist: 'There was an error deleting the playlist',
      updatePlaylist: 'There was an error editing the playlist',
      deleteFromPlaylist: 'There was an error deleting track from the playlist',
      deleteTrack: 'There was an error deleting track',
      noDataPosted: 'Error: missing data',
      authenticationFailed: 'The email or password is incorrect',
      login: 'An error occurred while loging in',
      playlist: 'An error occurred while loading the playlist',
      playlistPrivate: 'Error: private playlist',
      playlistNotFound: 'Error: playlist not found',
      featuredPlaylist: 'An error occured while loading featured playlist',
      artistNotFound: 'Error: artist not found',
      notSaved: 'Error: changes not saved',
      editArtist: 'Error while updating artist data',
      notValidToken: 'Authentication error',
      track: 'An error occurred while loading track',
      likePlaylist: 'An error occurred while liking the playlist'
    }
  },

  users: {
    login: 'Log in',
    username: 'Username',
    name: 'Name | Names',
    surnames: 'Surnames',
    id: 'ID',
    email: 'Email',
    emailConfirmation: 'Confirm email',
    address: 'Address',
    password: 'Password',
    phone: 'Phone',
    birthdate: 'Birthdate',
    day: 'Day',
    month: 'Month',
    year: 'Year',
    months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    code: 'Code',
    voucher: 'Enter the discount code',
    generateReferralCode: 'Generate Referral Code',
    choseUserType: 'Choose your profile',
    textUserType: 'This option can be changed in "Mi Profile"',
    userType: {
      musicFan: 'Fan',
      producer: 'Artist',
      free: 'Listener',
      flowArtist: {
        artisticName: 'Artistic name',
        text: 'You can change all your personal and artistic information in "My Profile"'
      }
    },
    registration: {
      shareData: 'Share my registration data with BEATHEY content providers for marketing purposes.',
      accept: 'By clicking on REGISTER, you accept',
      comma: ', the',
      andThe: 'and the',
      register: 'Register',
      alreadyHaveAnAccount: 'Already have an account?'
    },
    accept: {
      newsLetter: 'I agree to receive Newsletter',
      shareInfo: 'I agree to share contact information with Artists'
    },
    bio: 'Bio',
    bioDescription: 'Write something about yourself that represents you',
    country: 'Country',
    city: 'City',
    forgetPassword: {
      question: 'Forget your password?',
      success: 'A new password was sent to the email',
      button: 'Submit'
    },
    rememberPassword: 'Did you remember your password?',
    changePassword: 'Change password',
    passwordConfirmation: 'Confirm password',
    hasNotFavorites: 'You haven\'t added a track to your favorites',
    editSuccess: 'The information was updated correctly',
    loginToUnauthorizedUser: 'To continue listening to music, we invite you to register',
    cancelLoginToUnauthorizedUser: 'Cancel',
    subscription: {
      title: 'Subscribe!',
      info1: 'Vinyl as a gift with the best 4 artists of each Vinyl Contest (Only for Argentina)',
      info2: 'Receive BeatHey Mag as a gift (Only for Argentina)',
      info3: 'If you are an artist, you have the possibility to publish your music and be voted on in the Vinyl Contest',
      info4: 'If you are an artist, 100% of the music sales collection is yours.',
      info5: 'If you are an artist, you can be selected to play at BeatHey events',
      info6: 'Payment methods',
      infoEmailNeeded1: 'For internal MercadoPago regulations, we need the e-mail address associated to the wallet (MercadoPago) with which we will perform the transaction',
      infoEmailNeeded2: 'This information will not be stored by BeatHey and is for the exclusive use of this operation.',
      valueTitle: 'Be part of the community by',
      currency: 'U$D',
      value: '3',
      free: 'Free!!',
      button: 'Subscribe',
      cancel: 'Cancel',
      disaffiliate: 'Disaffiliate',
      confirm: 'Confirm',
      reject: 'Reject',
      cancelTitle: 'Thank you for choosing us!',
      cancelMessage: 'Are you sure to cancel your BeatHey subscription?',
      cancelAccountMessage: 'Are you sure to cancel your BeatHey account?',
      cancelAccount: 'Cancel your BeatHey account.',
      cancelAccountSuccess: 'Your BeatHey account has been successfully deleted.',
      cancelAccountError: 'There was a problen deleting your account.',
      cancelSubscription: 'Disaffiliate your recurring subscription to BeatHey.',
      canceledMPsubSuccess: 'Your recurring subscription through Mercado Pago has been successfully Canceled',
      canceledMPsubError: 'Your recurring subscription through Mercado Pago has already been Canceled',
      voucherCodeMsg: 'Enter your Benefits code',
      referredCodeMsg: 'Enter your referral code',
      sendEmailNeeded: 'To Process'
    },
    payment: {
      message: 'Choose one payment method'
    },
    userMenu: {
      myProfile: 'Profile',
      myTracks: 'My Tracks',
      myPlaylists: 'My Playlists',
      myFavorites: 'My Favorites',
      myShopping: 'My Purchases',
      myAccount: 'Mi Account',
      help: 'Help',
      terms: 'Terms and Conditions',
      logout: 'Logout'
    },
    followArtist: 'Now you follow',
    unfollowArtist: 'You stopped following',
    follow: 'Follow',
    following: 'Following',
    copyCodeSucces: 'The code was copied correctly',
    copyLinkSucces: 'The link was copied correctly',
    copyError: 'An error occurred while copying'
  },

  artists: {
    seeAll: 'See all',
    artists: 'Artists',
    artist: 'Artist | Artists',
    search: {
      placeholder: 'Search by name...',
      noMoreResults: 'There are no more results'
    },
    info: 'Artist information',
    name: 'Name',
    phrase: 'Descent',
    text: 'Info',
    hasNotTracks: 'Artist does not have any track',
    hasNotPlaylists: 'Artists does not have any playlist',
    hasNotInfo: 'Artist does not have information',
    section: {
      info: 'Info',
      contact: 'Contact'
    },
    contact: {
      messagePlaceholder: 'Write your message here',
      success: 'The masseage was sent correctly'
    }
  },

  albums: {
    uploadAlbum: 'Upload Album',
    newAlbum: {
      warningMessage: 'Fill in the album details to access track loading',
      namePlaceholder: 'Album name',
      uploaded: 'The album was created successfully',
      selectFiles: 'Select files',
      uploadButton: 'Upload Album',
      tagsPlaceholder: 'Describe the members who participated in the development of the work. Ex: PRODUCER, MIXING AND MASTERING, COVER ART, etc.'
    }
  },

  tracks: {
    seeAll: 'See all',
    uploadTrack: 'Upload Track',
    track: 'No tracks | track | tracks',
    title: 'Title',
    artist: 'Artist',
    genre: 'Genre',
    genres: {
      all: 'All'
    },
    minPrice: 'Minimum price in U$D',
    release: 'Date',
    actions: {
      like: 'Like',
      addToQueue: 'Add to queue',
      buy: 'Buy',
      share: 'Share',
      addToPlaylist: 'Add to playlist',
      deleteFromPlaylist: 'Delete from playlist',
      edit: 'Edit',
      credits: 'Credits'
    },
    buyTrack: {
      title: 'Help to ',
      line1: 'By downloading the track you help the artist to keep working on their music.',
      line2: 'You decide how much you value their music.',
      downloadMessage: 'You will find the track\'s download link in the "My Purchases" Profile section.',
      valueLabel: 'Amount',
      button: 'Purchase'
    },
    newTrack: {
      button: 'Load Content',
      newRelease: 'Agregar a la lista de NEW RELEASE',
      dropSelectTrack: 'Drop or select the file',
      selectFile: 'Select file',
      dropMessage: 'Drop file to upload',
      important: 'Important: ',
      info: 'By sharing, you confirm that your sounds comply with our terms of use and do not infringe the rights of any other person. In case of doubt, please check our pages and FAQ copyright information before uploading.',
      question1: 'Problems uploading files?',
      answer1: 'Please see our troubleshooting tips.',
      question2: 'What types of files can I upload?',
      answer2: 'You can load MP3s. The maximum file size is 50MB.',
      extensionMessage: 'The file must be mp3',
      leaveConfirmation: 'Are you sure you want to leave the site? Track is not saved',
      notProducer: 'To upload tracks you must subscribe as a DJ/Producer!',
      uploaded: 'The track was uploaded correctly',
      imageError: 'The selected image exceeds the expected dimensions, it must be less than 4024 x 3768 pixels',
      imageType: 'The file must be an image (jpg,jpeg,png)'
    },
    editTrack: {
      title: 'Share your music',
      selectPicture: 'Select track image',
      completed: 'Full load',
      namePlaceholder: 'Track name',
      tagsPlaceholder: 'Describe in words the style of your track',
      creditsPlaceholder: 'Add credits',
      recommendedPlaceHolder: 'Tell us what your musical genre is! Help us expand the BeatHey family.',
      uploaded: 'The track was uploaded correctly',
      iswcCode: 'Code ISWC Ej: T-xxxxxxxxx-x (optional)',
      saveChanges: 'Save Changes',
      listUploaded: 'The list was updated successfully'
    },
    deleteTrack: {
      title: 'Delete track',
      success: 'The track was deleted',
      confirm: 'Are you sure you want to delete the track?'
    },
    shareTrack: {
      title: 'Share track',
      copy: 'Copy',
      success: 'The link was copied correctly',
      error: 'An error occurred while copying the link'
    },
    licenses: {
      features: 'Licenses features',
      selected: 'Chosen license',
      questions: {
        1: {
          title: 'Do you want to allow adaptations of your work to be shared?',
          options: {
            1: 'Yes',
            2: 'No',
            3: 'Yes, as long as it is shared in the same way'
          }
        },
        2: {
          title: 'Do you want to allow commercial uses of your work?',
          options: {
            1: 'Sí',
            2: 'No'
          }
        }
      }
    },
    headers: {
      title: 'Title',
      artist: 'Artist',
      genre: 'Genre',
      released: 'Released',
      duration: 'Duration',
      date: 'Bought'
    }
  },

  playlists: {
    seeAll: 'See all',
    playlist: 'Playlist | Playlists',
    type: {
      public: 'Public',
      private: 'Private'
    },
    isPrivate: 'This playlist is private',
    addToPlaylist: {
      title: 'Add to playlist',
      select: 'Select a playlist',
      add: 'Add',
      success: 'The track was added to playlist correctly',
      trackAlreadyExist: 'The track already exists in this playlist'
    },
    newPlaylist: {
      button: 'New playlist',
      title: 'New playlist',
      imageError: 'An error occurred while uploading the playlist image',
      playlistName: 'Playlist title',
      saveAndAdd: 'Save and add',
      success: 'The playlist was created correctly'
    },
    delete: {
      confirm: 'Are you sure you want to delete the playlist?',
      success: 'The playlist was deleted correctly',
      title: 'Delete Playlist'
    },
    edit: {
      title: 'Edit playlist',
      button: 'Edit',
      success: 'The playlist was updated correctly'
    },
    deleteTrackFromPlaylist: {
      title: 'Delete track from playlist',
      success: 'The track was deleted from playlist correctly',
      confirm: 'Are you sure you want to delete the track from the playlist?'
    },
    sharePlaylist: 'Share playlist',
    like: {
      button: 'like'
    }
  },

  vinylContest: {
    noArtist: 'No artists have been voted yet',
    vote: 'Vote',
    success: 'Your vote was registered!',
    link: 'Go to Contest',
    title: 'Contest',
    closeIn: 'Close in:',
    day: 'day | days',
    hour: 'hour | hours',
    minute: 'minutes | minute | minutes'
  },

  payment: {
    mpConnect: {
      info: 'Connect to Mercado Pago to receive 100% of the sales of your tracks, without intermediaries, directly to your personal account.',
      title: 'Collect the sale of your tracks through Mercado Pago!',
      connectedAs: 'Connected as',
      disconnectInfo: 'To disconnect your account enter to ',
      nickname_title_help: 'This information it\'s visible for te buyer in the checkout process. We recommend to choose a related name to the artist.'
    },
    connect: 'Connect',
    paypal: {
      subscriptionSuccess: 'Your subscription was generated successfully'
    }
  },

  help: {
    title: 'How can we help?',
    contactInformation: 'Contact information',
    whatsapp: '+54 911 5574 0051',
    email: 'contacto@beathey.com',
    contactForm: {
      title: 'Send us your question',
      success: 'The message was sent correctly'
    },
    unsubscribe: 'Remember, to unsubscribe with ',
    send: 'send ',
    to: 'to ',
    faqs: 'FAQs'
  },

  uploadPicture: {
    selectPicture: 'Select image'
  },

  footer: {
    terms: 'Terms and conditions',
    termsOfUse: 'Terms and conditions of use',
    intellectuallyProp: 'Intellectual property policy',
    privacyPolicy: 'Privacy and cookie policy',
    help: 'Help',
    contact: 'Contact',
    company: 'Company',
    language: {
      title: 'Language',
      spanish: 'Español',
      english: 'English',
      portuguese: 'Português'
    }
  },
  ads: {
    advertisingSpace: 'Advertising space'
  },
  landing: {
    plans: 'Plans',
    music: 'Music',
    title: 'without intermediaries',
    subtitle: 'Closer to your audience, closer to your artist',
    leyend: 'START CHANGING LIFES',
    button1: 'Listening',
    button2: 'Creating',
    join: 'Join!',
    joinText: 'Get to know our',
    description: {
      t1: 'Income',
      t2: 'is 100%',
      t3: 'for the artist'
    },
    oyendo: {
      title: 'Not Just Listening',
      carousel: {
        text1: 'You support, help and build community by Listening, Sharing, Buying and Voting.',
        text2: 'We are a community of independent artists, and your support goes directly to each of us, without intermediaries.',
        text3: 'We are developing a new concept in the music industry and we want you to be part of it.'
      },
      button: 'Plans'
    },
    creando: {
      title: 'Incubating talent',
      carousel: {
        text1: 'Your effort is monetized, the more they listen to you, the more they vote for you, the more your music sells, the more exposure you will get.',
        text2: 'You are the owner of your rights, sell your music without intermediaries, get votes from the community in the quarterly contest and be part of our magazine.',
        text3: 'We are a community of independent artists, creating a new concept in the music industry where we are the protagonists. Experience it with us!'
      },
      button: 'Plans'
    },
    planes: {
      title: 'Your subscription generates change.',
      leyend: 'The revenue from subscriptions is distributed to the artists under the concept of "pay-per-stream". In this way, your subscription is directly impacting the artists, generating more opportunities for them.',
      free: {
        text1: 'Listen to Music',
        text2: 'BeatHey Inherent Advertising',
        text3: 'Buy Music'
      },
      fan: {
        text1: 'Bookmark',
        text2: 'Vote in Contest',
        text3: 'Listen without Advertising',
        text4: 'Digital Releases of contest winners free of charge',
        text5: 'BeatHey Mag magazine, physical and/or digital, free of charge',
        text6: 'Discounts of up to 60% on BeatHey festival tickets'
      },
      artist: {
        header: 'All the benefits of the Fan and more...',
        text1: 'Upload music and monetize it',
        text2: 'Receive double income per playback (pay per stream)',
        text3: 'Possibility of presentations at BeatHey festivals under endorsement of the curatorial team.'
      }
    }
  },
  dashboard: {
    title: 'Dashboard',
    atention: 'Atention...',
    apply: 'Apply',
    upload: 'Songs Uploaded',
    daysWithoutUpload: 'Days without Uploading',
    avg: 'Average songs Uploaded',
    likes: 'Likes',
    followers: 'Followers',
    reproductionsRanking: 'Reporductions Ranking',
    songRanking: 'Reproductions Detail',
    trackName: 'Track Name',
    duration: 'Duration',
    warning: 'This module allows you to access information about what happens with your works and thus be able to make decisions. Subscribe through the "Upload Content" button to access 100% of the available information.',
    tooltipAdmin: 'You are an administrator.',
    tooltipArtist: 'You are an artist.',
    tooltipSubscribed: 'You are subscribed.',
    tableName: 'Name',
    tableArtist: 'Artist',
    tableRepro: 'Reproductions',
    tableLikes: 'Likes'
  },
  localContent: {
    title: 'LIVE',
    category: 'Category'
  }
});

/***/ }),
/* 1185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  currency: {
    style: 'currency',
    currency: 'USD'
  },
  app: {
    signin: 'Entrar',
    signup: 'Cadastrar-se',
    or: 'ou',
    save: 'Salvar',
    yes: 'Sim',
    no: 'Não',
    clickHere: 'Clique aqui',
    back: 'Voltar',
    info: {
      noResults: 'Sua busca não retornou nenhum resultado',
      noMoreResults: 'Não há mais resultados'
    },
    delete: 'Excluir',
    loading: 'Carregando',
    discover: 'Descobrir',
    shop: 'Loja',
    360: '360',
    latestNews: 'Últimas notícias',
    featuredPlaylist: {
      title: 'Playlist em destaque',
      createdBy: 'Criado por'
    },
    recommended: 'Recomendado por BeatHey',
    leaveConfirmation: 'Tem certeza de que deseja sair do site? As informações inseridas serão perdidas',
    notAllowed: 'Sua conta não tem permissão para realizar esta ação.',
    notShowAgain: 'Aceitar'
  },

  form: {
    message: 'Mensagem',
    send: 'Enviar'
  },

  provider: {
    directLink: 'Criar acesso à tela inicial'
  },

  discover: {
    carousels: {
      artists: 'ARTISTAS',
      tracks: 'AS ÚLTIMAS',
      playlists: 'PLAYLISTS',
      recommendedPlaylists: 'PLAYLISTS RECOMENDADAS'
    }
  },

  error: {
    emailRequired: 'E-mail é obrigatório',
    emailInvalid: 'E-mail é inválido',
    emailRepeated: 'E-mail já existe',
    confirmEmailRequired: 'Confirmação de e-mail é obrigatória',
    confirmEmailInvalid: 'Os dois e-mails não coincidem',
    valueRequired: 'Valor é obrigatório',
    valueInvalid: 'Valor deve ser um número',
    valueMinPrice: 'O valor deve ser maior ou igual a: ',
    voucherInvalid: 'Voucher inexistente, tente outro',
    voucherInactive: 'Voucher não está mais ativo',
    voucherFulled: 'Voucher esgotado',
    shortVoucher: 'O voucher deve ter mais de 10 caracteres',
    longVoucher: 'O voucher deve ter menos de 10 caracteres',
    trackNameRequired: 'Nome da faixa é obrigatório',
    iswcErrorCode: 'O código ISWC deve respeitar o formato T-xxxxxxxxx-x',
    genreRequired: 'Gênero da faixa é obrigatório',
    usernameRequired: 'Nome de usuário é obrigatório',
    usernameRepeated: 'Nome de usuário já existe',
    idRequired: 'ID é obrigatório',
    shortId: 'ID muito curto',
    phoneInvalid: 'Telefone é inválido',
    addressRequired: 'Endereço é obrigatório',
    birthdateRequired: 'Data de nascimento é obrigatória',
    confirmPasswordInvalid: 'As senhas não coincidem',
    passwordRequired: 'Senha é obrigatória',
    nameRequired: 'Nome é obrigatório',
    messageRequired: 'Mensagem é obrigatória',
    messageMaxLength: 'A mensagem é muito longa. O número máximo de caracteres é 2048',
    playlistRequired: 'Você deve selecionar uma playlist',
    playlistNameRequired: 'Nome da playlist é obrigatório',
    trackUpload: 'Ocorreu um erro ao salvar a faixa',
    pictureRequired: 'Imagem é obrigatória',
    minPriceRequired: 'Este campo é obrigatório',
    minPriceValue: 'O valor não pode ser inferior a 1 USD',
    albumNameRequired: 'Você deve inserir um nome para o álbum',
    trackFileRequired: 'Você deve carregar uma faixa',
    albumUpload: 'Falha ao salvar o álbum',
    store: {
      network: 'Erro de rede',
      userValidation: 'Ocorreu um erro ao validar o usuário',
      paymentLink: 'Houve um erro ao obter o link de pagamento',
      myFavorites: 'Ocorreu um erro ao carregar meus favoritos',
      myTracks: 'Ocorreu um erro ao carregar minhas faixas',
      myPlaylists: 'Ocorreu um erro ao carregar minhas playlists',
      voteValidation: 'Ocorreu um erro ao verificar seus votos',
      data: 'Ocorreu um erro ao carregar os dados',
      artists: 'Ocorreu um erro ao carregar artistas',
      playlists: 'Ocorreu um erro ao carregar playlists',
      tracks: 'Ocorreu um erro ao carregar faixas',
      voteQuote: 'Você já votou em 3 artistas! No próximo mês você terá 3 novos votos para continuar votando',
      SameArtistAndUser: 'Você não pode votar em si mesmo',
      vote: 'Ocorreu um erro ao votar em um artista',
      vinylContest: 'Ocorreu um erro ao carregar o concurso de vinil',
      contact: 'Ocorreu um erro ao enviar a mensagem',
      addToPlaylist: 'Ocorreu um erro ao adicionar uma faixa à playlist',
      newPlaylist: 'Houve um erro ao criar a playlist',
      deletePlaylist: 'Houve um erro ao deletar a playlist',
      updatePlaylist: 'Houve um erro ao editar a playlist',
      deleteFromPlaylist: 'Houve um erro ao excluir a faixa da playlist',
      deleteTrack: 'Houve um erro ao deletar a faixa',
      noDataPosted: 'Erro: dados faltando',
      authenticationFailed: 'O e-mail ou senha estão incorretos',
      login: 'Ocorreu um erro ao fazer login',
      playlist: 'Ocorreu um erro ao carregar a playlist',
      playlistPrivate: 'Erro: playlist privada',
      playlistNotFound: 'Erro: playlist não encontrada',
      featuredPlaylist: 'Ocorreu um erro ao carregar a playlist em destaque',
      artistNotFound: 'Erro: artista não encontrado',
      notSaved: 'Erro: alterações não salvas',
      editArtist: 'Erro ao atualizar dados do artista',
      notValidToken: 'Erro de autenticação',
      track: 'Ocorreu um erro ao carregar a faixa',
      likePlaylist: 'Ocorreu um erro ao curtir a playlist'
    }
  },

  users: {
    login: 'Entrar',
    username: 'Nome de usuário',
    name: 'Nome | Nomes',
    surnames: 'Sobrenomes',
    id: 'ID',
    email: 'E-mail',
    emailConfirmation: 'Confirmar e-mail',
    address: 'Endereço',
    password: 'Senha',
    phone: 'Telefone',
    birthdate: 'Data de nascimento',
    day: 'Dia',
    month: 'Mês',
    year: 'Ano',
    months: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
    code: 'Código',
    voucher: 'Insira o código de desconto',
    generateReferralCode: 'Gerar código de indicação',
    choseUserType: 'Escolha seu perfil',
    textUserType: 'Esta opção pode ser alterada em "Meu Perfil"',
    userType: {
      musicFan: 'Fã',
      producer: 'Artista',
      free: 'Ouvinte',
      flowArtist: {
        artisticName: 'Nome artístico',
        text: 'Você pode alterar todas as suas informações pessoais e artísticas em "Meu Perfil"'
      }
    },
    registration: {
      shareData: 'Compartilhar meus dados de registro com os provedores de conteúdo do BEATHEY para fins de marketing.',
      accept: 'Ao clicar em REGISTRAR, você aceita',
      comma: ', o',
      andThe: 'e o',
      register: 'Registrar',
      alreadyHaveAnAccount: 'Já tem uma conta?'
    },
    accept: {
      newsLetter: 'Aceito receber Newsletter',
      shareInfo: 'Aceito compartilhar informações de contato com Artistas'
    },
    bio: 'Bio',
    bioDescription: 'Escreva algo sobre você que te represente',
    country: 'País',
    city: 'Cidade',
    forgetPassword: {
      question: 'Esqueceu sua senha?',
      success: 'Uma nova senha foi enviada para o e-mail',
      button: 'Enviar'
    },
    rememberPassword: 'Lembrou sua senha?',
    changePassword: 'Alterar senha',
    passwordConfirmation: 'Confirmar senha',
    hasNotFavorites: 'Você não adicionou uma faixa aos seus favoritos',
    editSuccess: 'As informações foram atualizadas corretamente',
    loginToUnauthorizedUser: 'Para continuar ouvindo música, convidamos você a se registrar',
    cancelLoginToUnauthorizedUser: 'Cancelar',
    subscription: {
      title: 'Assine!',
      info1: 'Vinil como presente com os 4 melhores artistas de cada Concurso de Vinil (Somente para a Argentina)',
      info2: 'Receba a revista BeatHey como presente (Somente para a Argentina)',
      info3: 'Se você é um artista, tem a possibilidade de publicar sua música e ser votado no Concurso de Vinil',
      info4: 'Se você é um artista, 100% da arrecadação das vendas de músicas é sua.',
      info5: 'Se você é um artista, pode ser selecionado para tocar em eventos BeatHey',
      info6: 'Formas de pagamento',
      infoEmailNeeded1: 'Por regulamentações internas do MercadoPago, precisamos do endereço de e-mail associado à carteira (MercadoPago) com a qual realizaremos a transação',
      infoEmailNeeded2: 'Essas informações não serão armazenadas pela BeatHey e são de uso exclusivo para esta operação.',
      valueTitle: 'Seja parte da comunidade por',
      currency: 'USD',
      value: '3',
      free: 'Grátis!!',
      button: 'Assinar',
      cancel: 'Cancelar',
      disaffiliate: 'Desafiliar-se',
      confirm: 'Confirmar',
      reject: 'Rejeitar',
      cancelTitle: 'Obrigado por nos escolher!',
      cancelMessage: 'Você tem certeza de que deseja cancelar sua assinatura do BeatHey?',
      cancelAccountMessage: 'Você tem certeza de que deseja cancelar sua conta do BeatHey?',
      cancelAccount: 'Cancelar sua conta do BeatHey.',
      cancelAccountSuccess: 'Sua conta do BeatHey foi deletada com sucesso.',
      cancelAccountError: 'Houve um problema ao deletar sua conta.',
      cancelSubscription: 'Desafiliar sua assinatura recorrente do BeatHey.',
      canceledMPsubSuccess: 'Sua assinatura recorrente através do Mercado Pago foi cancelada com sucesso',
      canceledMPsubError: 'Sua assinatura recorrente através do Mercado Pago já foi cancelada',
      voucherCodeMsg: 'Insira o código de benefícios',
      referredCodeMsg: 'Insira o código de indicação',
      sendEmailNeeded: 'Para processar'
    },

    payment: {
      message: 'Escolha um método de pagamento'
    },
    userMenu: {
      myProfile: 'Perfil',
      myTracks: 'Minhas Faixas',
      myPlaylists: 'Minhas Playlists',
      myFavorites: 'Meus Favoritos',
      myShopping: 'Minhas Compras',
      myAccount: 'Minha Conta',
      help: 'Ajuda',
      terms: 'Termos e Condições',
      logout: 'Sair'
    },
    followArtist: 'Agora você segue',
    unfollowArtist: 'Você parou de seguir',
    follow: 'Seguir',
    following: 'Seguindo',
    copyCodeSucces: 'O código foi copiado corretamente',
    copyLinkSucces: 'O link foi copiado corretamente',
    copyError: 'Ocorreu um erro ao copiar'
  },

  artists: {
    seeAll: 'Ver tudo',
    artists: 'Artistas',
    artist: 'Artista | Artistas',
    search: {
      placeholder: 'Pesquisar por nome...',
      noMoreResults: 'Não há mais resultados'
    },
    info: 'Informações do artista',
    name: 'Nome',
    phrase: 'Descendência',
    text: 'Informações',
    hasNotTracks: 'O artista não tem nenhuma faixa',
    hasNotPlaylists: 'O artista não tem nenhuma playlist',
    hasNotInfo: 'O artista não tem informações',
    section: {
      info: 'Informações',
      contact: 'Contato'
    },
    contact: {
      'messagePlaceholder': 'Escreva sua mensagem aqui',
      'success': 'A mensagem foi enviada corretamente'
    }
  },

  albums: {
    uploadAlbum: 'Carregar Álbum',
    newAlbum: {
      warningMessage: 'Preencha os detalhes do álbum para acessar o carregamento de faixas',
      namePlaceholder: 'Nome do álbum',
      uploaded: 'O álbum foi criado com sucesso',
      selectFiles: 'Selecionar arquivos',
      uploadButton: 'Carregar Álbum',
      tagsPlaceholder: 'Descreva os membros que participaram do desenvolvimento da obra. Ex: PRODUTOR, MIXAGEM E MASTERIZAÇÃO, CAPA, etc.'
    }
  },

  tracks: {
    seeAll: 'Ver tudo',
    uploadTrack: 'Carregar Faixa',
    track: 'Sem faixas | faixa | faixas',
    title: 'Título',
    artist: 'Artista',
    genre: 'Gênero',
    genres: {
      all: 'Todos'
    },
    minPrice: 'Preço mínimo em U$D',
    release: 'Data',
    actions: {
      like: 'Curtir',
      addToQueue: 'Adicionar à fila',
      buy: 'Comprar',
      share: 'Compartilhar',
      addToPlaylist: 'Adicionar à playlist',
      deleteFromPlaylist: 'Excluir da playlist',
      edit: 'Editar'
    },
    buyTrack: {
      title: 'Ajude o ',
      line1: 'Ao baixar a faixa, você ajuda o artista a continuar trabalhando em sua música.',
      line2: 'Você decide quanto valoriza a música dele.',
      downloadMessage: 'Você encontrará o link de download da faixa na seção "Minhas Compras" do Perfil.',
      valueLabel: 'Valor',
      button: 'Comprar'
    },
    newTrack: {
      button: 'Carregar Conteúdo',
      newRelease: 'Adicionar à lista de NOVO LANÇAMENTO',
      dropSelectTrack: 'Solte ou selecione o arquivo',
      selectFile: 'Selecionar arquivo',
      dropMessage: 'Solte o arquivo para carregar',
      important: 'Importante: ',
      info: 'Ao compartilhar, você confirma que seus sons estão em conformidade com nossos termos de uso e não infringem os direitos de qualquer outra pessoa. Em caso de dúvida, consulte nossas páginas e FAQ sobre direitos autorais antes de carregar.',
      question1: 'Problemas ao carregar arquivos?',
      answer1: 'Veja nossas dicas de solução de problemas.',
      question2: 'Que tipos de arquivos posso carregar?',
      answer2: 'Você pode carregar MP3s. O tamanho máximo do arquivo é 50MB.',
      extensionMessage: 'O arquivo deve ser mp3',
      leaveConfirmation: 'Tem certeza de que deseja sair do site? A faixa não foi salva',
      notProducer: 'Para carregar faixas, você deve se inscrever como DJ/Produtor!',
      uploaded: 'A faixa foi carregada corretamente',
      imageError: 'A imagem selecionada excede as dimensões esperadas, deve ser inferior a 4024 x 3768 pixels',
      imageType: 'O arquivo deve ser uma imagem (jpg,jpeg,png)'
    },
    editTrack: {
      title: 'Compartilhe sua música',
      selectPicture: 'Selecionar imagem da faixa',
      completed: 'Carregamento completo',
      namePlaceholder: 'Nome da faixa',
      tagsPlaceholder: 'Descreva em palavras o estilo da sua faixa',
      recommendedPlaceHolder: 'Diga-nos qual é o seu gênero musical! Ajude-nos a expandir a família BeatHey.',
      uploaded: 'A faixa foi carregada corretamente',
      iswcCode: 'Código ISWC Ex: T-xxxxxxxxx-x (opcional)',
      saveChanges: 'Salvar Alterações',
      listUploaded: 'A lista foi atualizada com sucesso'
    },
    deleteTrack: {
      title: 'Excluir faixa',
      success: 'A faixa foi excluída',
      confirm: 'Tem certeza de que deseja excluir a faixa?'
    },
    shareTrack: {
      title: 'Compartilhar faixa',
      copy: 'Copiar',
      success: 'O link foi copiado corretamente',
      error: 'Ocorreu um erro ao copiar o link'
    },
    licenses: {
      features: 'Recursos das licenças',
      selected: 'Licença escolhida',
      questions: {
        1: {
          title: 'Você quer permitir que adaptações de seu trabalho sejam compartilhadas?',
          options: {
            1: 'Sim',
            2: 'Não',
            3: 'Sim, desde que seja compartilhado da mesma forma'
          }
        },
        2: {
          title: 'Você quer permitir o uso comercial de seu trabalho?',
          options: {
            1: 'Sim',
            2: 'Não'
          }
        }
      }
    },
    headers: {
      title: 'Título',
      artist: 'Artista',
      genre: 'Gênero',
      released: 'Lançado',
      duration: 'Duração',
      date: 'Comprado'
    }
  },

  playlists: {
    seeAll: 'Ver tudo',
    playlist: 'Playlist | Playlists',
    type: {
      public: 'Público',
      private: 'Privado'
    },
    isPrivate: 'Esta playlist é privada',
    addToPlaylist: {
      title: 'Adicionar à playlist',
      select: 'Selecione uma playlist',
      add: 'Adicionar',
      success: 'A faixa foi adicionada à playlist corretamente',
      trackAlreadyExist: 'A faixa já existe nesta playlist'
    },
    newPlaylist: {
      button: 'Nova playlist',
      title: 'Nova playlist',
      imageError: 'Ocorreu um erro ao carregar a imagem da playlist',
      playlistName: 'Título da playlist',
      saveAndAdd: 'Salvar e adicionar',
      success: 'A playlist foi criada corretamente'
    },
    delete: {
      confirm: 'Tem certeza de que deseja excluir a playlist?',
      success: 'A playlist foi excluída corretamente',
      title: 'Excluir Playlist'
    },
    edit: {
      title: 'Editar playlist',
      button: 'Editar',
      success: 'A playlist foi atualizada corretamente'
    },
    deleteTrackFromPlaylist: {
      'title': 'Excluir faixa da playlist',
      'success': 'A faixa foi excluída da playlist corretamente',
      'confirm': 'Tem certeza de que deseja excluir a faixa da playlist?'
    },
    sharePlaylist: 'Compartilhar playlist',
    like: {
      button: 'curtir'
    }
  },

  vinylContest: {
    noArtist: 'Nenhum artista foi votado ainda',
    vote: 'Votar',
    success: 'Seu voto foi registrado!',
    link: 'Ir para o Concurso',
    title: 'Concurso',
    closeIn: 'Fechar em:',
    day: 'dia | dias',
    hour: 'hora | horas',
    minute: 'minuto | minutos'
  },

  payment: {
    mpConnect: {
      info: 'Conecte-se ao Mercado Pago para receber 100% das vendas de suas faixas, sem intermediários, diretamente em sua conta pessoal.',
      title: 'Receba a venda de suas faixas através do Mercado Pago!',
      connectedAs: 'Conectado como',
      disconnectInfo: 'Para desconectar sua conta, entre em ',
      nickname_title_help: 'Estas informações estão visíveis para o comprador no processo de checkout. Recomendamos escolher um nome relacionado ao artista.'
    },
    connect: 'Conectar',
    paypal: {
      'subscriptionSuccess': 'Sua assinatura foi gerada com sucesso'
    }
  },

  help: {
    title: 'Como podemos ajudar?',
    contactInformation: 'Informações de contato',
    whatsapp: '+54 911 5574 0051',
    email: 'contato@beathey.com',
    contactForm: {
      title: 'Envie-nos sua pergunta',
      success: 'A mensagem foi enviada corretamente'
    },
    unsubscribe: 'Lembre-se, para cancelar a inscrição com ',
    send: 'enviar ',
    to: 'para ',
    faqs: 'Perguntas frequentes (FAQs)'
  },

  uploadPicture: {
    selectPicture: 'Selecionar imagem'
  },

  footer: {
    terms: 'Termos e condições',
    termsOfUse: 'Termos e condições de uso',
    intellectuallyProp: 'Política de propriedade intelectual',
    privacyPolicy: 'Política de privacidade e cookies',
    help: 'Ajuda',
    contact: 'Contato',
    company: 'Empresa',
    language: {
      title: 'Idioma',
      spanish: 'Espanhol',
      english: 'Inglês',
      portuguese: 'Português'
    }
  },

  ads: {
    advertisingSpace: 'Espaço publicitário'
  },

  landing: {
    plans: 'Planos',
    music: 'Música',
    title: 'sem intermediários',
    subtitle: 'Mais perto do seu público, mais perto do seu artista',
    leyend: 'COMECE A MUDAR VIDAS',
    button1: 'Ouvindo',
    button2: 'Criando',
    join: 'Junte-se!',
    joinText: 'Conheça nosso',
    description: {
      t1: 'Renda',
      t2: 'é 100%',
      t3: 'para o artista'
    },
    oyendo: {
      title: 'Não apenas ouvindo',
      carousel: {
        text1: 'Você apoia, ajuda e constrói comunidade ao ouvir, compartilhar, comprar e votar.',
        text2: 'Somos uma comunidade de artistas independentes, e seu apoio vai diretamente para cada um de nós, sem intermediários.',
        text3: 'Estamos desenvolvendo um novo conceito na indústria musical e queremos que você faça parte disso.'
      },
      button: 'Planos'
    },
    creando: {
      title: 'Incubando talentos',
      carousel: {
        text1: 'Seu esforço é monetizado, quanto mais ouvem você, mais votam em você, mais sua música vende, mais exposição você terá.',
        text2: 'Você é dono de seus direitos, venda sua música sem intermediários, obtenha votos da comunidade no concurso trimestral e faça parte de nossa revista.',
        text3: 'Somos uma comunidade de artistas independentes, criando um novo conceito na indústria musical onde somos os protagonistas. Viva essa experiência conosco!'
      },
      button: 'Planos'
    },
    planes: {
      title: 'Sua assinatura gera mudança.',
      leyend: 'A receita das assinaturas é distribuída para os artistas sob o conceito de "pago por reprodução". Assim, sua assinatura impacta diretamente os artistas, gerando mais oportunidades para eles.',
      free: {
        text1: 'Ouça Música',
        text2: 'Publicidade Inerente ao BeatHey',
        text3: 'Compre Música'
      },
      fan: {
        text1: 'Salvar Favoritos',
        text2: 'Votar no Concurso',
        text3: 'Ouça sem Anúncios',
        text4: 'Lançamentos Digitais gratuitos dos vencedores do concurso',
        text5: 'Revista BeatHey, física e/ou digital, gratuita',
        text6: 'Descontos de até 60% nos ingressos para festivais BeatHey'
      },
      artist: {
        header: 'Todos os benefícios do Fã e mais...',
        text1: 'Carregue música e monetize-a',
        text2: 'Receba o dobro de receita por reprodução (pago por stream)',
        text3: 'Possibilidade de apresentações em festivais BeatHey com a chancela da equipe curatorial.'
      }
    }
  },

  dashboard: {
    title: 'Painel de Controle',
    atention: 'Atenção...',
    apply: 'Aplicar',
    upload: 'Músicas Carregadas',
    daysWithoutUpload: 'Dias sem Carregar',
    avg: 'Média de músicas Carregadas',
    likes: 'Curtidas',
    followers: 'Seguidores',
    reproductionsRanking: 'Ranking de Reproduções',
    songRanking: 'Detalhe das Reproduções',
    trackName: 'Nome da Faixa',
    duration: 'Duração',
    warning: 'Este módulo permite que você acesse informações sobre o que acontece com suas obras e, assim, possa tomar decisões. Assine através do botão "Carregar Conteúdo" para acessar 100% das informações disponíveis.',
    tooltipAdmin: 'Você é um administrador.',
    tooltipArtist: 'Você é um artista.',
    tooltipSubscribed: 'Você está inscrito.',
    tableName: 'Nome',
    tableArtist: 'Artista',
    tableRepro: 'Reproduções',
    tableLikes: 'Curtidas'
  },

  localContent: {
    title: 'AO VIVO',
    category: 'Categoria'
  }
});

/***/ }),
/* 1186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__consts__ = __webpack_require__(21);


var locale = void 0;

var obtainLocale = function obtainLocale() {
  if (localStorage.getItem('language')) {
    locale = localStorage.getItem('language');
  } else {
    var lang = navigator.language.split('-')[0];
    if (lang && __WEBPACK_IMPORTED_MODULE_0__consts__["a" /* default */].ACCEPTED_LOCALES.indexOf(lang) >= 0) {
      locale = lang;
    } else {
      locale = __WEBPACK_IMPORTED_MODULE_0__consts__["a" /* default */].DEFAULT_LOCALE;
    }
    localStorage.setItem('language', locale);
  }
  return locale;
};

/* harmony default export */ __webpack_exports__["a"] = (obtainLocale);

/***/ }),
/* 1187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__consts__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__auth__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_loading__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuex_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__translator__ = __webpack_require__(69);








var _createActionHelpers = Object(__WEBPACK_IMPORTED_MODULE_5_vuex_loading__["createActionHelpers"])({
  moduleName: 'loading'
}),
    startLoading = _createActionHelpers.startLoading,
    endLoading = _createActionHelpers.endLoading;

var initialStates = function initialStates() {
  return {
    isEmailSent: false,
    user: null,
    loading: false,
    error: '',
    input: '',
    validVoucher: false,
    isProducer: false,
    isSubscribed: false,
    links: Object,
    myFavorites: [],
    myTracks: [],
    myPlaylists: [],
    myVotes: null,
    myShopping: [],
    preventLogout: false,
    userPromise: null,
    oauthLogin: false,
    followedArtists: [],
    myLikedPlaylists: [],
    referredCode: null,
    subsReferredCode: null
  };
};
var mutations = {
  loading: function loading(state, value) {
    state.loading = value;
  },
  error: function error(state, value) {
    state.error = value.message;
    state.input = value.input;
  },
  resetError: function resetError(state) {
    state.error = '';
  },
  logout: function logout(state) {
    var init = initialStates();
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(init).forEach(function (key) {
      state[key] = init[key];
    });
    __WEBPACK_IMPORTED_MODULE_4__auth__["b" /* default */].removeToken();
    __WEBPACK_IMPORTED_MODULE_4__auth__["b" /* default */].removeMsisdn();
    __WEBPACK_IMPORTED_MODULE_4__auth__["b" /* default */].removeProvider();
  },
  setOauthLogin: function setOauthLogin(state, value) {
    state.oauthLogin = value;
  },
  setUser: function setUser(state, user) {
    state.user = user;
  },
  setReferredCode: function setReferredCode(state, referredCode) {
    state.referredCode = referredCode;
  },
  setSubsReferredCode: function setSubsReferredCode(state, subsReferredCode) {
    state.subsReferredCode = subsReferredCode;
  },
  forgotPass: function forgotPass(state, value) {
    state.isEmailSent = value;
  },
  validVoucher: function validVoucher(state, value) {
    state.validVoucher = value;
  },
  isProducer: function isProducer(state, value) {
    state.isProducer = value;
  },
  links: function links(state, value) {
    state.links = value;
  },
  isSubscribed: function isSubscribed(state, value) {
    state.isSubscribed = value;
  },
  setMyFavorites: function setMyFavorites(state, value) {
    state.myFavorites = value;
  },
  setMyTracks: function setMyTracks(state, value) {
    state.myTracks = value;
  },
  setMyPlaylists: function setMyPlaylists(state, value) {
    state.myPlaylists = value;
  },
  setMyVotes: function setMyVotes(state, value) {
    state.myVotes = value;
  },
  setMyShopping: function setMyShopping(state, value) {
    state.myShopping = value;
  },
  decreaseMyVotes: function decreaseMyVotes(state) {
    state.myVotes--;
  },
  updateProfileImage: function updateProfileImage(state, value) {
    state.user.picture = value.path + value.filename;
  },
  setPreventLogout: function setPreventLogout(state, value) {
    state.preventLogout = value;
  },
  setUserPromise: function setUserPromise(state, value) {
    state.userPromise = value;
  },
  setFollowing: function setFollowing(state, value) {
    state.followedArtists = value;
  },
  setMyLikedPlaylists: function setMyLikedPlaylists(state, value) {
    state.myLikedPlaylists = value;
  }
};

var actions = {
  subscribeByPaypal: function subscribeByPaypal(_ref, subsData) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch,
        state = _ref.state;

    startLoading(dispatch, 'subscribeByPaypal');
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/payment/createSubscriptionByPayPal', {
        data: subsData
      }).then(function (response) {
        endLoading(dispatch, 'subscribeByPaypal');
        if (response.ok === true) {
          commit('isSubscribed', response.ok === true);
          this.$toasted.show('Paypal Payment Subscription Success', { type: 'success' });
          resolve();
        } else {
          commit('isSubscribed', false);
          commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.network') });
          reject(new Error(__WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.network')));
        }
      }, function () {
        endLoading(dispatch, 'subscribeByPaypal');
        commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.network') });
        reject(new Error(__WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.network')));
      });
    });
  },
  paypalCaptureOrder: function paypalCaptureOrder(_ref2, orderId) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch,
        state = _ref2.state;

    startLoading(dispatch, 'paypalCaptureOrder');
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/payment/paypalCaptureOrder', {
        order_id: orderId
      }).then(function (response) {
        endLoading(dispatch, 'paypalCaptureOrder');
        if (response.body.status === 'ok') {
          resolve(response.body.data);
        } else {
          commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.network') });
          reject(new Error(__WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.network')));
        }
      }, function () {
        endLoading(dispatch, 'paypalCaptureOrder');
        commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.network') });
        reject(new Error(__WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.network')));
      });
    });
  },
  setUser: function setUser(_ref3, user) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch,
        state = _ref3.state;

    commit('setUser', user);
    commit('isProducer', user.user_type === __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].PRODUCER_TYPE);
    endLoading(dispatch, 'user login');
    if (user.subscription) {
      commit('isSubscribed', user.subscription.active);
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
    } else {
      return dispatch('checkSubscription');
    }
  },
  loginAuth: function loginAuth(_ref4, oAuthUser) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch,
        state = _ref4.state;

    startLoading(dispatch, 'user login');
    var request = __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/oauth/login', {
      user: oAuthUser
    });
    request.then(function (response) {
      if (response.body.status) {
        __WEBPACK_IMPORTED_MODULE_4__auth__["b" /* default */].setToken(response.body.token);
        return dispatch('setUser', response.body.user);
      } else {
        commit('error', {
          message: response.body.error.message,
          input: ''
        });
        endLoading(dispatch, 'user login');
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error(response.body.error.message));
      }
    }).catch(function () {
      endLoading(dispatch, 'user login');
    });
    commit('setUserPromise', request);
    request.then(function () {
      dispatch('getMyVotes');
      endLoading(dispatch, 'user login');
    });
    return request;
  },
  login: function login(_ref5, user) {
    var commit = _ref5.commit,
        dispatch = _ref5.dispatch,
        state = _ref5.state;

    startLoading(dispatch, 'user login');
    var promise = __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/users/login', {
      email: user.email,
      password: user.pass
    }).then(function (response) {
      if (response.body.status) {
        __WEBPACK_IMPORTED_MODULE_4__auth__["b" /* default */].setToken(response.body.token);
        return dispatch('setUser', response.body.user);
      } else {
        commit('error', {
          message: response.body.error.message,
          input: ''
        });
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error(response.body.error.message));
      }
    }).catch(function (e) {
      endLoading(dispatch, 'user login');
      var message = e.message ? e.message : __WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.network');
      commit('error', {
        message: message,
        input: ''
      });
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error(message));
    });
    commit('setUserPromise', promise);
    promise.then(function () {
      if (state.isSubscribed) {
        dispatch('getMyVotes');
      }
      endLoading(dispatch, 'user login');
    });
    return promise;
  },
  loginByMsisdn: function loginByMsisdn(_ref6, _ref7) {
    var commit = _ref6.commit,
        dispatch = _ref6.dispatch,
        state = _ref6.state;
    var msisdn = _ref7.msisdn,
        _ref7$provider = _ref7.provider,
        provider = _ref7$provider === undefined ? null : _ref7$provider,
        _ref7$country = _ref7.country,
        country = _ref7$country === undefined ? null : _ref7$country,
        _ref7$enc = _ref7.enc,
        enc = _ref7$enc === undefined ? false : _ref7$enc,
        _ref7$isValidation = _ref7.isValidation,
        isValidation = _ref7$isValidation === undefined ? false : _ref7$isValidation;

    startLoading(dispatch, 'user login');
    msisdn = msisdn.replace(/\s/g, '+');
    var url = __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/subs/login';

    if (provider !== null) {
      url += '/' + provider;
    } else {
      url += '/bitel';
      country = 'per';
    }

    url += '/' + msisdn;

    var data = {
      'enc': enc,
      'country': country
    };

    var promise = __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.post(url, data).then(function (response) {
      if (response.body.status) {
        __WEBPACK_IMPORTED_MODULE_4__auth__["b" /* default */].setToken(response.body.token);
        if (response.body.msisdn) {
          __WEBPACK_IMPORTED_MODULE_4__auth__["b" /* default */].setMsisdn(response.body.msisdn);
          __WEBPACK_IMPORTED_MODULE_4__auth__["b" /* default */].setProvider(response.body.provider);
        }
        if (!isValidation) {
          window.location.href = '/home';
        }
        return dispatch('setUser', response.body.user);
      } else {
        commit('logout');
      }
      if (!isValidation) {
        window.location.href = '/home';
      }
    }).catch(function (e) {
      return {
        message: e
      };
    });
    commit('setUserPromise', promise);
    promise.then(function () {
      if (state.isSubscribed) {
        dispatch('getMyVotes');
      }
      endLoading(dispatch, 'user login');
    });
    return promise;
  },
  autologinRecurrent: function autologinRecurrent(_ref8, _ref9) {
    var commit = _ref8.commit,
        dispatch = _ref8.dispatch,
        state = _ref8.state;
    var iterations = _ref9.iterations,
        interval = _ref9.interval,
        msisdn = _ref9.msisdn,
        _ref9$provider = _ref9.provider,
        provider = _ref9$provider === undefined ? null : _ref9$provider,
        _ref9$country = _ref9.country,
        country = _ref9$country === undefined ? null : _ref9$country,
        _ref9$enc = _ref9.enc,
        enc = _ref9$enc === undefined ? false : _ref9$enc,
        _ref9$route = _ref9.route,
        route = _ref9$route === undefined ? '/' : _ref9$route;

    startLoading(dispatch, 'user login');
    msisdn = msisdn.replace(/\s/g, '+');
    var url = __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/subs/login';

    if (provider !== null) {
      url += '/' + provider;
    } else {
      url += '/bitel';
      country = 'per';
    }

    if (provider === 'entel') {
      country = 'per';
    }

    if (country !== null) {
      // url += '/' + country
    }

    url += '/' + msisdn;

    var data = enc ? { 'enc': true } : {};
    var count = 1;
    // localStorage.removeItem('token')
    setInterval(function () {
      if (count > iterations) {
        window.location.href = '/';
      } else {
        var promise = __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.post(url, data).then(function (response) {
          if (response.body.status) {
            __WEBPACK_IMPORTED_MODULE_4__auth__["b" /* default */].setToken(response.body.token);
            if (response.body.msisdn) {
              __WEBPACK_IMPORTED_MODULE_4__auth__["b" /* default */].setMsisdn(response.body.msisdn);
              __WEBPACK_IMPORTED_MODULE_4__auth__["b" /* default */].setProvider(response.body.provider);
            }
            window.location.href = route;
            return dispatch('setUser', response.body.user);
          } else {
            count++;
          }
        }).catch(function (e) {
          count++;
          return {
            message: e
          };
        });
        commit('setUserPromise', promise);
        promise.then(function () {
          if (state.isSubscribed) {
            dispatch('getMyVotes');
          }
          endLoading(dispatch, 'user login');
        });
        return promise;
      }
    }, interval * 1000);
  },
  autologinRecurrentEntel: function autologinRecurrentEntel(_ref10, _ref11) {
    var commit = _ref10.commit,
        dispatch = _ref10.dispatch,
        state = _ref10.state;
    var iterations = _ref11.iterations,
        interval = _ref11.interval,
        msisdn = _ref11.msisdn,
        _ref11$provider = _ref11.provider,
        provider = _ref11$provider === undefined ? null : _ref11$provider,
        _ref11$enc = _ref11.enc,
        enc = _ref11$enc === undefined ? false : _ref11$enc,
        _ref11$route = _ref11.route,
        route = _ref11$route === undefined ? '/' : _ref11$route;

    startLoading(dispatch, 'user login');
    msisdn = msisdn.replace(/\s/g, '+');
    var url = __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/subs/loginProvider';

    if (provider !== null) {
      url += '/' + provider;
    }

    url += '/' + msisdn;

    var data = enc ? { 'enc': true } : {};
    var count = 1;
    // localStorage.removeItem('token')
    setInterval(function () {
      if (count > iterations) {
        window.location.href = '/';
      } else {
        var promise = __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.post(url, data).then(function (response) {
          if (response.body.status) {
            __WEBPACK_IMPORTED_MODULE_4__auth__["b" /* default */].setToken(response.body.token);
            if (response.body.msisdn) {
              __WEBPACK_IMPORTED_MODULE_4__auth__["b" /* default */].setMsisdn(response.body.msisdn);
              __WEBPACK_IMPORTED_MODULE_4__auth__["b" /* default */].setProvider(response.body.provider);
            }
            window.location.href = route;
            return dispatch('setUser', response.body.user);
          } else {
            count++;
          }
        }).catch(function (e) {
          count++;
          return {
            message: e
          };
        });
        commit('setUserPromise', promise);
        promise.then(function () {
          if (state.isSubscribed) {
            dispatch('getMyVotes');
          }
          endLoading(dispatch, 'user login');
        });
        return promise;
      }
    }, interval * 1000);
  },
  checkUser: function checkUser(_ref12) {
    var commit = _ref12.commit,
        dispatch = _ref12.dispatch,
        state = _ref12.state;

    startLoading(dispatch, 'user checkUser');
    var promise = __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/users/getMyData').then(function (res) {
      if (res.body.status) {
        return dispatch('setUser', res.body.data);
      } else {
        commit('logout');
        commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.userValidation') });
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error(__WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.userValidation')));
      }
    }, function () {
      commit('logout');
      commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.network') });
      endLoading(dispatch, 'user checkUser');
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error(__WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.network')));
    });
    commit('setUserPromise', promise);
    promise.then(function () {
      dispatch('getMyVotes');
      endLoading(dispatch, 'user checkUser');
    });
    return promise;
  },
  checkSubscription: function checkSubscription(_ref13) {
    var commit = _ref13.commit;

    return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/users/check').then(function (res) {
      commit('isSubscribed', res.body.status === 'ok');
    }, function () {
      commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.network') });
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error(__WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.network')));
    });
  },
  cancelBeatheySuscription: function cancelBeatheySuscription(_ref14) {
    var dispatch = _ref14.dispatch;

    startLoading(dispatch, 'user cancelBeatheySuscription');
    return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/payment/cancelBeatheySuscription').then(function (response) {
      if (response.body.status) {
        endLoading(dispatch, 'user cancelBeatheySuscription');
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response.body.preapproval_suscription.response.status);
      } else {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error(response.body.error.message));
      }
    }).catch(function (e) {
      endLoading(dispatch, 'user cancelBeatheySuscription');
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(e.body.error.message);
      // return Promise.reject(new Error(e.body.error.message ? e.body.error.message : i18n.t('error.store.network')))
    });
  },
  deleteBeatheyAccount: function deleteBeatheyAccount(_ref15) {
    var dispatch = _ref15.dispatch;

    startLoading(dispatch, 'user deleteBeatheyAccount');
    return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.delete(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/users/delete').then(function (response) {
      if (response.body.status) {
        endLoading(dispatch, 'user deleteBeatheyAccount');
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response.body.status);
      } else {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response.body.status);
      }
    }).catch(function (e) {
      endLoading(dispatch, 'user deleteBeatheyAccount');
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(e.body.error.message);
    });
  },
  checkSubscriptionGateway: function checkSubscriptionGateway(_ref16) {
    var commit = _ref16.commit,
        dispatch = _ref16.dispatch;

    return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/users/getSubscriptionGateway').then(function (response) {
      if (response.body.status) {
        endLoading(dispatch, 'user checkSubscriptionGateway');
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response.body.data);
      } else {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error(response.body.error.message));
      }
    }).catch(function (e) {
      endLoading(dispatch, 'user checkSubscriptionGateway');
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error(e.message ? e.message : __WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.network')));
    });
  },
  logout: function logout(_ref17) {
    var commit = _ref17.commit;

    // Vue.http.post(consts.API_BASE_URL + '/users/logout')
    commit('logout');
  },
  forgotPass: function forgotPass(_ref18, email) {
    var commit = _ref18.commit;

    commit('loading', true);
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/users/forgot', {
        email: email
      }).then(function (response) {
        commit('loading', false);
        if (response.body.status === 'ok') {
          commit('forgotPass', true);
          resolve();
        } else {
          commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.emailInvalid') });
          reject(new Error(__WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.emailInvalid')));
        }
      }, function () {
        commit('loading', false);
        commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.network') });
        reject(new Error(__WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.network')));
      });
    });
  },
  register: function register(_ref19, user) {
    var commit = _ref19.commit,
        dispatch = _ref19.dispatch;

    commit('loading', true);
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/users/register', {
        user_name: user.username,
        password: user.pass,
        dni: user.dni,
        telefono: user.phone,
        email: user.email,
        direccion: user.address,
        birth: user.birthdate,
        user_type: user.userType,
        voucher: user.voucher
      }).then(function (response) {
        commit('loading', false);
        if (response.body.status === 'ok') {
          dispatch('login', { email: user.email, pass: user.pass });
          resolve();
        } else {
          if (response.body.status === 'error') {
            switch (response.body.error) {
              case 'user name exist':
                {
                  commit('error', {
                    message: __WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.usernameRepeated'),
                    input: 'username'
                  });
                  break;
                }
              case 'email exist':
                {
                  commit('error', {
                    message: __WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.emailRepeated'),
                    input: 'email'
                  });
                  break;
                }
              case 'the address is mandatory':
                {
                  commit('error', {
                    message: __WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.addressRequired'),
                    input: 'address'
                  });
                  break;
                }
              case 'the dni is mandatory':
                {
                  commit('error', {
                    message: __WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.idRequired'),
                    input: 'dni'
                  });
                  break;
                }
              default:
                {
                  commit('error', {
                    message: __WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.registration'),
                    input: ''
                  });
                }
            }
            reject(new Error(response.body.error));
          }
        }
      }, function () {
        commit('loading', false);
        commit('error', {
          error: true,
          message: __WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.network')
        });
        reject(new Error(__WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.network')));
      });
    });
  },
  resetError: function resetError(_ref20) {
    var commit = _ref20.commit;

    commit('resetError');
  },
  checkVoucher: function checkVoucher(_ref21, value) {
    var commit = _ref21.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      if (value !== '') {
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/users/checkVouchers' + '?code=' + value).then(function (response) {
          if (response.body.status === 'ok') {
            commit('validVoucher', true);
            resolve(response.body.data);
          } else {
            if (response.body.status === 'error') {
              commit('validVoucher', false);
              commit('error', {
                message: __WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.voucherInvalid'),
                input: 'voucher'
              });
              resolve(response.body.message);
            }
          }
        }, function () {
          commit('error', {
            error: true,
            message: __WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.network')
          });
          reject(new Error(__WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.network')));
        });
      } else {
        commit('validVoucher', true);
        resolve();
      }
    });
  },
  getSubscriptionLink: function getSubscriptionLink(_ref22, value) {
    var commit = _ref22.commit,
        dispatch = _ref22.dispatch;

    startLoading(dispatch, 'user getPaymentLink');
    var mk = localStorage.getItem('userFromLandingMK');
    var voucherCode = null;
    var referredCode = null;
    var emailNeeded = null;

    if (value.voucher) {
      voucherCode = value.voucher.code;
    }
    if (value.refCode) {
      referredCode = value.refCode;
    }
    if (value.emailNeeded) {
      emailNeeded = value.emailNeeded;
    }
    return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + value.paymentUrl + value.gateway + '?mk=' + mk + '&voucherCode=' + voucherCode + '&referredCode=' + referredCode + '&emailNeeded=' + emailNeeded).then(function (response) {
      endLoading(dispatch, 'user getSubscriptionLink');
      if (response.body.status) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response.body.next_url);
      } else {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response.body.error);
      }
    }).catch(function (e) {
      endLoading(dispatch, 'user getSubscriptionLink');
      var message = e.message ? e.message : __WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.network');
      commit('error', {
        message: message,
        input: ''
      });
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error(message));
    });
  },
  getMyFavorites: function getMyFavorites(_ref23, _ref24) {
    var commit = _ref23.commit;
    var _ref24$genreIdFilter = _ref24.genreIdFilter,
        genreIdFilter = _ref24$genreIdFilter === undefined ? 0 : _ref24$genreIdFilter,
        _ref24$textToFilter = _ref24.textToFilter,
        textToFilter = _ref24$textToFilter === undefined ? null : _ref24$textToFilter;

    commit('loading', true);
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/users/getMyLikes' + '?genreIdFilter=' + genreIdFilter + '&textToFilter=' + textToFilter).then(function (response) {
        commit('loading', false);
        if (response.body.status === 'ok') {
          commit('setMyFavorites', response.body.data);
          resolve(response.body.data);
        } else {
          commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.myFavorites') });
          reject(new Error(__WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.myFavorites')));
        }
      }, function () {
        commit('loading', false);
        commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.network') });
        reject(new Error(__WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.network')));
      });
    });
  },
  getMyTracks: function getMyTracks(_ref25) {
    var commit = _ref25.commit;

    commit('loading', true);
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/tracks/getMyTracks').then(function (response) {
        commit('loading', false);
        if (response.body.status === 'ok') {
          commit('setMyTracks', response.body.data[0]);
          resolve();
        } else {
          commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.myTracks') });
          reject(new Error(__WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.myTracks')));
        }
      }, function () {
        commit('loading', false);
        commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.network') });
        reject(new Error(__WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.network')));
      });
    });
  },
  getMyPlaylists: function getMyPlaylists(_ref26) {
    var commit = _ref26.commit,
        dispatch = _ref26.dispatch;

    startLoading(dispatch, 'user getMyPlaylists');
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/users/getMyPlaylists').then(function (response) {
        endLoading(dispatch, 'user getMyPlaylists');
        if (response.body.status) {
          commit('setMyPlaylists', response.body.data);
          resolve();
        } else {
          commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.myPlaylists') });
          reject(new Error(__WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.myPlaylists')));
        }
      }, function () {
        endLoading(dispatch, 'user getMyPlaylists');
        commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.network') });
        reject(new Error(__WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.network')));
      });
    });
  },
  getMyVotes: function getMyVotes(_ref27) {
    var commit = _ref27.commit,
        dispatch = _ref27.dispatch,
        state = _ref27.state;

    startLoading(dispatch, 'user getMyVotes');
    var routeString = state.isSubscribed ? '/users/getMyVotes' : '/users/getMyVotes?votes=1';
    return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + routeString).then(function (response) {
      endLoading(dispatch, 'user getMyVotes');
      if (response.body.status) {
        commit('setMyVotes', response.body.data);
      } else {
        commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.voteValidation') });
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error(__WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.voteValidation')));
      }
    }, function () {
      endLoading(dispatch, 'user getMyVotes');
      commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.network') });
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error(__WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.network')));
    });
  },
  getMyShopping: function getMyShopping(_ref28) {
    var commit = _ref28.commit,
        dispatch = _ref28.dispatch;

    startLoading(dispatch, 'user getMyShopping');
    return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/tracks/getMyShopping').then(function (response) {
      endLoading(dispatch, 'user getMyShopping');
      if (response.body.status) {
        commit('setMyShopping', response.body.data);
      } else {
        commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.voteValidation') });
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error(__WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.voteValidation')));
      }
    }, function () {
      endLoading(dispatch, 'user getMyShopping');
      commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.network') });
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error(__WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.network')));
    });
  },
  editUser: function editUser(_ref29, user) {
    var commit = _ref29.commit,
        state = _ref29.state,
        dispatch = _ref29.dispatch;

    commit('loading', true);
    var data;
    if (user.password === '') {
      data = {
        bio: user.bio,
        user_name: user.username,
        first_name: user.name,
        last_name: user.surname,
        dni: user.dni,
        telefono: user.phone,
        direccion: user.address,
        user_type: user.userType,
        country: user.country,
        city: user.city,
        birth: user.birthdate,
        email: user.email,
        accept_news_letter: user.acceptNewsLetter,
        accept_share_info: user.acceptShareInfo
      };
    } else {
      data = {
        bio: user.bio,
        password: user.password,
        user_name: user.username,
        first_name: user.name,
        last_name: user.surname,
        dni: user.dni,
        telefono: user.phone,
        direccion: user.address,
        user_type: user.userType,
        country: user.country,
        city: user.city,
        birth: user.birthdate,
        email: user.email,
        accept_news_letter: user.acceptNewsLetter,
        accept_share_info: user.acceptShareInfo
      };
    }
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/users/editData', data).then(function (response) {
        commit('loading', false);
        if (response.body.status === 'ok' && response.body.data === 'saved') {
          dispatch('checkUser');
          resolve();
        } else {
          if (response.body.status === 'error') {
            switch (response.body.error) {
              case 'user name exist':
                {
                  commit('error', {
                    message: __WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.usernameRepeated'),
                    input: 'username'
                  });
                  break;
                }
              case 'email exist':
                {
                  commit('error', {
                    message: __WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.emailRepeated'),
                    input: 'email'
                  });
                  break;
                }
              default:
                {
                  commit('error', {
                    message: response.body.error,
                    input: ''
                  });
                }
            }
            reject(new Error(response.body.error));
          }
        }
      }, function () {
        commit('loading', false);
        commit('error', {
          error: true,
          message: __WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.network')
        });
        reject(new Error(__WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.network')));
      });
    });
  },
  updateProfileImage: function updateProfileImage(_ref30, value) {
    var commit = _ref30.commit;

    commit('updateProfileImage', value);
  },
  contact: function contact(_ref31, value) {
    var commit = _ref31.commit,
        dispatch = _ref31.dispatch;

    startLoading(dispatch, 'user contact');
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/contact', {
        email: value.email,
        name: value.name,
        message: value.message,
        provider: value.provider
      }).then(function (response) {
        endLoading(dispatch, 'user contact');
        if (response.body.status === true) {
          resolve();
        } else {
          commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.contact') });
          reject(new Error(__WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.contact')));
        }
      }, function () {
        endLoading(dispatch, 'user contact');
        commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.network') });
        reject(new Error(__WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.network')));
      });
    });
  },
  setPreventLogout: function setPreventLogout(_ref32, value) {
    var commit = _ref32.commit;

    commit('setPreventLogout', value);
  },
  getMyFollowedArtists: function getMyFollowedArtists(_ref33, _ref34) {
    var commit = _ref33.commit,
        dispatch = _ref33.dispatch;
    var _ref34$getIds = _ref34.getIds,
        getIds = _ref34$getIds === undefined ? null : _ref34$getIds,
        _ref34$genreIdFilter = _ref34.genreIdFilter,
        genreIdFilter = _ref34$genreIdFilter === undefined ? 0 : _ref34$genreIdFilter,
        _ref34$textToFilter = _ref34.textToFilter,
        textToFilter = _ref34$textToFilter === undefined ? null : _ref34$textToFilter;

    startLoading(dispatch, 'user getMyFollowedArtists');
    return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/users/getMyFollowedArtists' + '?getIds=' + getIds + '&genreIdFilter=' + genreIdFilter + '&textToFilter=' + textToFilter).then(function (response) {
      endLoading(dispatch, 'user getMyFollowedArtists');
      if (response.body.status) {
        if (getIds) {
          localStorage.setItem('followedArtists', response.body.data);
        } else {
          // commit('setFollowing ', response.body.data, { root: true })
          return response.body.data;
        }
      } else {
        commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.network') });
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error(__WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.network')));
      }
    }, function () {
      endLoading(dispatch, 'user getMyFollowedArtists');
      commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.network') });
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error(__WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.network')));
    });
  },
  getMyLikedPlaylists: function getMyLikedPlaylists(_ref35, _ref36) {
    var commit = _ref35.commit,
        dispatch = _ref35.dispatch;
    var _ref36$genreIdFilter = _ref36.genreIdFilter,
        genreIdFilter = _ref36$genreIdFilter === undefined ? 0 : _ref36$genreIdFilter,
        _ref36$textToFilter = _ref36.textToFilter,
        textToFilter = _ref36$textToFilter === undefined ? 'null' : _ref36$textToFilter;

    startLoading(dispatch, 'user getMyLikedPlaylists');
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/playlists/searchLiked' + '?genreIdFilter=' + genreIdFilter + '&textToFilter=' + textToFilter).then(function (response) {
        endLoading(dispatch, 'user getMyLikedPlaylists');
        if (response.body.status === 'ok') {
          commit('setMyLikedPlaylists', response.body.data);
          resolve(response.body.data);
        } else {
          commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.myFavorites') });
          reject(new Error(__WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.myFavorites')));
        }
      }, function () {
        endLoading(dispatch, 'user getMyLikedPlaylists');
        commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.network') });
        reject(new Error(__WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.network')));
      });
    });
  },
  setFollowArtist: function setFollowArtist(_ref37, artistId) {
    var commit = _ref37.commit,
        dispatch = _ref37.dispatch;

    commit('loading', true);
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/users/followArtist', {
        artist_id: artistId
      }).then(function (response) {
        commit('loading', false);
        if (response.body.status === true) {
          resolve(response.body.status);
        } else {
          commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.network') });
          reject(new Error(__WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.network')));
        }
      }, function () {
        commit('loading', false);
        commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.network') });
        reject(new Error(__WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.network')));
      });
    });
  },
  setReferredCodeAction: function setReferredCodeAction(_ref38, value) {
    var commit = _ref38.commit;

    commit('setReferredCode', value);
  },
  setSubsReferredCodeAction: function setSubsReferredCodeAction(_ref39, value) {
    var commit = _ref39.commit;

    commit('setSubsReferredCode', value);
  },
  saveReferredCode: function saveReferredCode(_ref40, referredCode) {
    var commit = _ref40.commit,
        dispatch = _ref40.dispatch;

    commit('loading', true);
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/users/saveReferredCode', {
        referredCode: referredCode
      }).then(function (response) {
        commit('loading', false);
        if (response.body.status === true) {
          commit('setReferredCode', response.body.data);
          resolve(response.body.data);
        } else {
          commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.network') });
          reject(new Error(__WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.network')));
        }
      }, function () {
        commit('loading', false);
        commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.network') });
        reject(new Error(__WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.network')));
      });
    });
  },
  checkMyActiveUserReferredPlan: function checkMyActiveUserReferredPlan(_ref41) {
    var commit = _ref41.commit,
        dispatch = _ref41.dispatch;

    startLoading(dispatch, 'user checkMyActiveUserReferredPlan');
    return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/users/checkMyActiveUserReferredPlan').then(function (response) {
      endLoading(dispatch, 'user checkMyActiveUserReferredPlan');
      if (response.body.status) {
        commit('setReferredCode', response.body.data);
        return response.body.data;
      } else {
        commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.network') });
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error(__WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.network')));
      }
    }, function () {
      endLoading(dispatch, 'user checkMyActiveUserReferredPlan');
      commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.network') });
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error(__WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.network')));
    });
  },
  editUserType: function editUserType(_ref42, userType) {
    var dispatch = _ref42.dispatch;

    startLoading(dispatch, 'user editUserType');
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/users/setUserType', userType).then(function (response) {
        if (response.body.status === 'error') {
          reject(new Error(response.body.error));
        } else {
          resolve();
        }
        endLoading(dispatch, 'user editUserType');
      }).catch(function (e) {
        endLoading(dispatch, 'user editUserType');
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error(e.message ? e.message : 'error editUserType'));
      });
    });
  },
  checkUserLogged: function checkUserLogged(_ref43) {
    var commit = _ref43.commit;

    commit('loading', true);
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/users/getMyData').then(function (response) {
        commit('loading', false);
        if (response.body.status === true) {
          return resolve(response.body.data);
        } else {
          return reject(new Error(__WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.network')));
        }
      }, function () {
        commit('loading', false);
        commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.network') });
        return reject(new Error(__WEBPACK_IMPORTED_MODULE_6__translator__["a" /* default */].t('error.store.network')));
      });
    });
  }
};

var getters = {
  isLoggedIn: function isLoggedIn(state) {
    console.log(state.user);
    return state.user !== null;
  },
  error: function error(state) {
    return state.error;
  },
  loading: function loading(state) {
    return state.loading;
  },
  user: function user(state) {
    return state.user;
  },
  referredCode: function referredCode(state) {
    return state.referredCode;
  },
  subsReferredCode: function subsReferredCode(state) {
    return state.subsReferredCode;
  },
  isEmailSent: function isEmailSent(state) {
    return state.isEmailSent;
  },
  input: function input(state) {
    return state.input;
  },
  validVoucher: function validVoucher(state) {
    return state.validVoucher;
  },
  isProducer: function isProducer(state) {
    return state.isProducer;
  },
  isSubscribed: function isSubscribed(state) {
    return state.isSubscribed;
  },
  links: function links(state) {
    return state.links;
  },
  myFavorites: function myFavorites(state) {
    return state.myFavorites;
  },
  myTracks: function myTracks(state) {
    return state.myTracks;
  },
  myPlaylists: function myPlaylists(state) {
    return state.myPlaylists;
  },
  myVotes: function myVotes(state) {
    return state.myVotes;
  },
  myShopping: function myShopping(state) {
    return state.myShopping;
  },
  authToken: function authToken() {
    return __WEBPACK_IMPORTED_MODULE_4__auth__["b" /* default */].getToken();
  },
  preventLogout: function preventLogout(state) {
    return state.preventLogout;
  },
  userPromise: function userPromise(state) {
    return state.userPromise;
  },
  msisdn: function msisdn() {
    return __WEBPACK_IMPORTED_MODULE_4__auth__["b" /* default */].getMsisdn();
  },
  provider: function provider() {
    return __WEBPACK_IMPORTED_MODULE_4__auth__["b" /* default */].getProvider();
  },
  followedArtists: function followedArtists(state) {
    return state.followedArtists;
  },
  myLikedPlaylists: function myLikedPlaylists(state) {
    return state.myLikedPlaylists;
  }
};

var user = {
  namespaced: true,
  initialStates: initialStates,
  state: initialStates(),
  mutations: mutations,
  actions: actions,
  getters: getters
};

/* harmony default export */ __webpack_exports__["a"] = (user);

/***/ }),
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__consts__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_loading__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuex_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__translator__ = __webpack_require__(69);







var _createActionHelpers = Object(__WEBPACK_IMPORTED_MODULE_4_vuex_loading__["createActionHelpers"])({
  moduleName: 'loading'
}),
    startLoading = _createActionHelpers.startLoading,
    endLoading = _createActionHelpers.endLoading;

function getTracks(genreFilter, perPage, commit, textToFilter) {
  var url = __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + ('/tracks/byGenre/' + genreFilter + '/' + perPage + '/' + textToFilter));
  var promise = url;
  promise.then(function (response) {
    if (response.data.status === 'ok') {
      commit('incrementFrom', 1);
    }
  });
  return promise;
}

// emazzu, inicializamos array para genero principal
//
var initialStates = function initialStates() {
  return {
    error: '',
    genres: [],
    genresMain: [],
    // genresSecon: [],
    isTrackUploaded: false,
    allTracks: [],
    noMoreResults: false,
    results: [],
    // from: 0,
    perPage: 1,
    genreFilter: 0,
    discoverMainGenre: null,
    discoverSeconGenre: null,
    links: Object,
    promotion: [],
    ads: [],
    prices: []
  };
};

var mutations = {
  error: function error(state, value) {
    state.isLoggedIn = false;
    state.error = value['message'];
  },
  resetError: function resetError(state) {
    state.error = '';
  },

  // emazzu, asignamos array de json con genero principal
  //
  getGenresMain: function getGenresMain(state, value) {
    state.genresMain = value;
  },
  isTrackUploaded: function isTrackUploaded(state, value) {
    state.isTrackUploaded = value;
  },
  setAllTracks: function setAllTracks(state, value) {
    state.allTracks = value;
  },
  appendperPage: function appendperPage(state, value) {
    var _state$allTracks;

    (_state$allTracks = state.allTracks).push.apply(_state$allTracks, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(value));
  },
  incrementFrom: function incrementFrom(state, value) {
    state.perPage += value;
  },
  setGenreFilter: function setGenreFilter(state, value) {
    state.genreFilter = value;
  },
  setDiscoverMainGenre: function setDiscoverMainGenre(state, value) {
    state.discoverMainGenre = value;
  },
  setDiscoverSeconGenre: function setDiscoverSeconGenre(state, value) {
    state.discoverSeconGenre = value;
  },
  setFrom: function setFrom(state, value) {
    state.perPage = value;
  },
  noMoreResults: function noMoreResults(state, value) {
    state.noMoreResults = value;
  },
  setLinks: function setLinks(state, value) {
    state.links = value;
  },
  setPromotion: function setPromotion(state, value) {
    state.promotion = value;
  },
  setAds: function setAds(state, value) {
    for (var i = 0; i < value.audios.length; i++) {
      state.ads[i] = { path: value.path, file: value.audios[i], isAd: true };
    }
  },
  setPrices: function setPrices(state, value) {
    state.prices = value;
  }
};

var actions = {

  // emazzu, start, se ejecuta al hacer clic en la solapa DESCUBRIR
  getAll: function getAll(_ref) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch,
        state = _ref.state;
    var textToFilter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    startLoading(dispatch, 'track getAll');
    commit('noMoreResults', false);
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      getTracks(state.genreFilter, state.perPage, commit, textToFilter).then(function (response) {
        endLoading(dispatch, 'track getAll');
        if (response.body.status === true) {
          commit('setAllTracks', response.body.data);
          resolve(response.body.data);
        } else {
          commit('setAllTracks', null);
          commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.tracks') });
          reject(new Error(__WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network')));
        }
      }, function () {
        endLoading(dispatch, 'track getAll');
        commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network') });
        reject(new Error(__WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network')));
      });
    });
  },

  // emazzu, end, se ejecuta al hacer clic en la solapa DESCUBRIR

  // emazzu, start, se ejecuta al deslizarse hacia abajo para traer mas datos a demanda
  loadMore: function loadMore(_ref2) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch,
        state = _ref2.state;
    var textToFilter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    if (textToFilter === '') {
      textToFilter = null;
    }
    startLoading(dispatch, 'track loadMore');
    commit('noMoreResults', false);
    commit('incrementFrom', 1);
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      getTracks(state.genreFilter, state.perPage, commit, textToFilter).then(function (response) {
        endLoading(dispatch, 'track loadMore');
        if (response.body.status === true) {
          if (response.body.data.length > 0) {
            commit('appendperPage', response.body.data);
          } else {
            commit('noMoreResults', true);
          }
          resolve(response.body.data);
        } else if (response.body.status === false && response.body.error.message === 'Track no encontrado') {
          commit('noMoreResults', true);
          resolve(response.body.error.message);
        } else {
          commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.tracks') });
          reject(new Error(__WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.tracks')));
        }
      }, function () {
        endLoading(dispatch, 'track loadMore');
        commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network') });
        reject(new Error(__WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network')));
      });
    });
  },

  // emazzu, end, se ejecuta al deslizarse hacia abajo para traer mas datos a demanda

  setFrom: function setFrom(_ref3, value) {
    var commit = _ref3.commit;

    commit('setFrom', value);
  },
  setGenreFilter: function setGenreFilter(_ref4, value) {
    var commit = _ref4.commit;

    commit('setGenreFilter', value);
  },
  getConvertedValues: function getConvertedValues(_ref5, value) {
    var commit = _ref5.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var trackId = null;
      if (value.track) {
        trackId = value.track.id;
      }
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/getTrackValues', {
        track: trackId,
        currency: value.toCurrency
      }).then(function (response) {
        commit('setPrices', response.body.values);
        if (response.body.status === true) {
          resolve(response.body);
        } else {
          reject(new Error(response.body.error));
        }
      }, function () {
        reject(new Error(__WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network')));
      });
    });
  },
  getBuyLink: function getBuyLink(_ref6, value) {
    var commit = _ref6.commit,
        dispatch = _ref6.dispatch;

    startLoading(dispatch, 'track getBuyLink');
    return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/payment/getPayment', {
      track: value.track.id,
      amount: value.value || 0,
      currency: value.currency || null,
      gateway: value.gateway || null,
      description: value.description || null
    }).then(function (response) {
      endLoading(dispatch, 'track getBuyLink');
      if (response.body.status === true) {
        if (response.body.gateway !== 'paypal') {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response.body.next_url);
        } else {
          return response.body.status;
        }
      } else {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error(response.body.error));
      }
    }, function () {
      endLoading(dispatch, 'track getBuyLink');
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error(__WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network')));
    });
  },
  getPromotion: function getPromotion(_ref7) {
    var commit = _ref7.commit,
        dispatch = _ref7.dispatch;

    startLoading(dispatch, 'track getPromotion');
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/tracks/promotion').then(function (response) {
        if (response.body.status === 'ok') {
          endLoading(dispatch, 'track getPromotion');
          commit('setPromotion', response.body.data.tracks);
          commit('setAds', response.body.data.speechs);
          resolve();
        }
      }, function () {
        endLoading(dispatch, 'track getPromotion');
        reject(new Error(__WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network')));
      });
    });
  },
  setLike: function setLike(_ref8, value) {
    var commit = _ref8.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/tracks/setLike', {
        track_id: value
      }).then(function (response) {
        if (response.body.status === 'ok') {
          resolve();
        }
      }, function () {
        commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network') });
        reject(new Error(__WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network')));
      });
    });
  },
  resetError: function resetError(_ref9) {
    var commit = _ref9.commit;

    commit('resetError');
  },
  uploadAlbum: function uploadAlbum(_ref10, values) {
    var commit = _ref10.commit,
        dispatch = _ref10.dispatch;

    startLoading(dispatch, 'track editTrack');
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/tracks/uploadAlbum', {
        values: values
      }).then(function (response) {
        endLoading(dispatch, 'track editTrack');
        if (response.body.status === true) {
          commit('isTrackUploaded', true);
          resolve();
        } else {
          commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.trackUpload') });
          reject(new Error(__WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.albumUpload')));
        }
      }, function () {
        endLoading(dispatch, 'track editTrack');
        commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network') });
        reject(new Error(__WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network')));
      });
    });
  },
  editTrack: function editTrack(_ref11, value) {
    var commit = _ref11.commit,
        dispatch = _ref11.dispatch;

    var picture = value.picture.split(/\/uploads\/tracks\//gi).reverse()[0];
    startLoading(dispatch, 'track editTrack');
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/tracks/edit/' + value.id, {
        comments: value.coments,
        id_music_type: value.id_music_type,
        new_release: value.new_release,
        picture: picture,
        tags: value.tags,
        title: value.title,
        id_lisense: value.license,
        minPrice: value.min_price,
        recommendedGenre: value.recommendedGenre,
        iswc: value.iswc,
        credits: value.credits
      }).then(function (response) {
        endLoading(dispatch, 'track editTrack');
        if (response.body.data === 'saved') {
          commit('isTrackUploaded', true);
          resolve();
        } else {
          commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.trackUpload') });
          reject(new Error(__WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.trackUpload')));
        }
      }, function () {
        endLoading(dispatch, 'track editTrack');
        commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network') });
        reject(new Error(__WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network')));
      });
    });
  },

  // emazzu, devolvemos array de json con genero principal
  //
  getGenresMain: function getGenresMain(_ref12) {
    var commit = _ref12.commit,
        dispatch = _ref12.dispatch;
    var withTracksFilter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    startLoading(dispatch, 'track getGenresMain');
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var url = __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/genres/';
      if (withTracksFilter) {
        url = __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/genres/?withTrackFilter=1';
      }
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get(url).then(function (response) {
        endLoading(dispatch, 'track getGenresMain');
        if (response.body.status === true) {
          var mainGenre = response.body.data.sort(function (a, b) {
            if (a.name > b.name) {
              return 1;
            }
            if (a.name < b.name) {
              return -1;
            }
            // a must be equal to b
            return 0;
          });
          commit('getGenresMain', mainGenre);
          resolve();
        }
      }, function () {
        endLoading(dispatch, 'track getGenresMain');
        commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network') });
        reject(new Error(__WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network')));
      });
    });
  },
  setTrackUploaded: function setTrackUploaded(_ref13, value) {
    var commit = _ref13.commit;

    commit('isTrackUploaded', value);
  },
  delete: function _delete(_ref14, value) {
    var commit = _ref14.commit,
        dispatch = _ref14.dispatch;

    startLoading(dispatch, 'track delete');
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/tracks/del', {
        track_id: value
      }).then(function (response) {
        if (response.body.status === 'ok' && response.body.data === 'deleted') {
          dispatch('user/getMyTracks', null, { root: true });
          endLoading(dispatch, 'track delete');
          resolve();
        } else {
          commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.deleteTrack') });
          reject(new Error(__WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.deleteTrack')));
        }
      }, function () {
        endLoading(dispatch, 'track delete');
        commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network') });
        reject(new Error(__WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network')));
      });
    });
  },
  getTrack: function getTrack(_ref15, id) {
    var commit = _ref15.commit,
        dispatch = _ref15.dispatch;

    startLoading(dispatch, 'track getTrack');
    return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/tracks/' + id).then(function (response) {
      endLoading(dispatch, 'track getTrack');
      if (response.body.status) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve({ canEdit: response.body.can_edit, track: response.body.data });
      } else {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error(response.body.error.message));
      }
    }).catch(function (e) {
      var message = e.message ? e.message : __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network');
      endLoading(dispatch, 'track getTrack');
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error(message));
    });
  },
  storeReproduction: function storeReproduction(_ref16, value) {
    var commit = _ref16.commit,
        dispatch = _ref16.dispatch;

    return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/tracks/reproduction', {
      track_id: value.id
    }).then(function (response) {
      if (response.body.status) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
      } else {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error(response.body.error.message));
      }
    }).catch(function (e) {
      if (e.message) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error(e.message ? e.message : __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network')));
      }
    });
  },
  setMyTrackOrder: function setMyTrackOrder(_ref17, value) {
    var commit = _ref17.commit,
        dispatch = _ref17.dispatch;

    return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/tracks/reorderArtistTracks', {
      artist_id: value.artist_id,
      reorder: value.reorder
    }).then(function (response) {
      if (response.body.status) {
        return response.body.status;
      } else {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error(response.body.error.message));
      }
    }).catch(function (e) {
      if (e.message) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error(e.message ? e.message : __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network')));
      }
    });
  }
};

var getters = {
  error: function error(state) {
    return state.error;
  },
  genres: function genres(state) {
    return state.genres;
  },
  genresMain: function genresMain(state) {
    return state.genresMain;
  },
  isTrackUploaded: function isTrackUploaded(state) {
    return state.isTrackUploaded;
  },
  allTracks: function allTracks(state) {
    return state.allTracks;
  },
  genreFilter: function genreFilter(state) {
    return state.genreFilter;
  },
  discoverMainGenre: function discoverMainGenre(state) {
    return state.discoverMainGenre;
  },
  discoverSeconGenre: function discoverSeconGenre(state) {
    return state.discoverSeconGenre;
  },
  noMoreResults: function noMoreResults(state) {
    return state.noMoreResults;
  },
  links: function links(state) {
    return state.links;
  },
  promotion: function promotion(state) {
    return state.promotion;
  },
  ads: function ads(state) {
    return state.ads;
  },
  prices: function prices(state) {
    return state.prices;
  }
};

var track = {
  namespaced: true,
  initialStates: initialStates,
  state: initialStates(),
  mutations: mutations,
  actions: actions,
  getters: getters
};

/* harmony default export */ __webpack_exports__["a"] = (track);

/***/ }),
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__consts__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_loading__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuex_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__translator__ = __webpack_require__(69);







var _createActionHelpers = Object(__WEBPACK_IMPORTED_MODULE_4_vuex_loading__["createActionHelpers"])({
  moduleName: 'loading'
}),
    startLoading = _createActionHelpers.startLoading,
    endLoading = _createActionHelpers.endLoading;

function getArtists(genreFilter, page, commit, textToFilter) {
  var promise = __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + ('/artist/ByGenre/' + genreFilter + '/' + page + '/' + textToFilter));
  promise.then(function (response) {
    if (response.data.status === 'ok') {
      // commit('incrementFrom', 1)
    }
  });
  return promise;
}

var initialStates = function initialStates() {
  return {
    error: '',
    myArtistInfo: Object,
    myArtistInfoRefresh: 0,
    searchQuery: '',
    page: 0,
    artist: Object,
    artistsError: '',
    artists: [],
    noMoreResults: false,
    previousRequest: false,
    artistPlaylists: [],
    artistTracks: [],
    isProfileOpen: false,
    vinylContest: [],
    vinylContestInfo: [],
    genreFilter: 0
  };
};

var mutations = {
  setMyArtistInfo: function setMyArtistInfo(state, value) {
    state.myArtistInfo = value;

    // flag, lo uso, para cuando cargo artista, si existe o no el artista
    // fuerzo a que pase por aca, para que incremente el contador y poder
    // capturarlo con el watch
    state.myArtistInfoRefresh++;
  },
  setArtist: function setArtist(state, value) {
    state.artist = value;
  },
  setArtistGenreFilter: function setArtistGenreFilter(state, value) {
    state.genreFilter = value;
  },
  setPageFrom: function setPageFrom(state, value) {
    state.page = value;
  },
  previousRequest: function previousRequest(state, payload) {
    if (state.previousRequest && state.previousRequest !== payload.request) {
      state.previousRequest.abort();
    }
    state.previousRequest = payload.request;
  },
  setSearchQuery: function setSearchQuery(state, value) {
    state.page = 0;
    state.searchQuery = value;
    state.artists = [];
    state.noMoreResults = false;
  },
  setAll: function setAll(state, value) {
    state.artists = value;
  },
  error: function error(state, value) {
    state.error = value;
  },
  appendPage: function appendPage(state, value) {
    var _state$artists;

    (_state$artists = state.artists).push.apply(_state$artists, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(value));
    state.page++;
  },
  noMoreResults: function noMoreResults(state, value) {
    state.noMoreResults = value;
  },
  setArtistPlaylists: function setArtistPlaylists(state, value) {
    state.artistPlaylists = value;
  },
  updatePrimaryPicture: function updatePrimaryPicture(state, value) {
    state.myArtistInfo.path = value.path;
    state.myArtistInfo.primary_picture = value.filename;
  },
  setTracks: function setTracks(state, value) {
    state.artistTracks = value;
  },
  isProfileOpen: function isProfileOpen(state, value) {
    state.isProfileOpen = value;
  },
  setVinylContest: function setVinylContest(state, artists, info) {
    state.vinylContest = artists;
    state.vinylContestInfo = info;
  },
  resetError: function resetError(state) {
    state.error = '';
  }
};

var actions = {
  getMyArtistInfo: function getMyArtistInfo(_ref) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;

    startLoading(dispatch, 'artist getMyArtistInfo');
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/artists/getMyData').then(function (res) {
        endLoading(dispatch, 'artist getMyArtistInfo');
        if (res.body.status === 'ok') {
          commit('setMyArtistInfo', res.body.data);
          resolve();
        } else {
          // force, hago que si o si, pase por el state myArtistInfo
          commit('setMyArtistInfo', res.body.data);
          commit('error', __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.data'));
          reject(new Error(__WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.data')));
        }
      }, function () {
        endLoading(dispatch, 'artist getMyArtistInfo');
        commit('error', __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network'));
        reject(new Error(__WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network')));
      });
    });
  },
  editArtist: function editArtist(_ref2, artist) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch;

    startLoading(dispatch, 'artist editArtist');
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/artists/editGeneral', {
        name: artist.name,
        phrase: artist.phrase,
        text: artist.text
      }).then(function (response) {
        endLoading(dispatch, 'artist editArtist');
        if (response.body.status === 'ok' && response.body.data === 'saved') {
          resolve();
        } else {
          if (response.body.status === 'error') {
            switch (response.body.error) {
              case 'fail: no data posted':
                {
                  commit('error', {
                    message: __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.noDataPosted')
                  });
                  break;
                }
              case 'not valid token':
                {
                  commit('error', {
                    message: __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.notValidToken')
                  });
                  break;
                }
              case 'fail: not saved':
                {
                  commit('error', {
                    message: __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.notSaved')
                  });
                  break;
                }
              default:
                {
                  commit('error', {
                    message: __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.editArtist')
                  });
                  break;
                }
            }
          }
          reject(new Error(response.body.error));
        }
      }, function () {
        endLoading(dispatch, 'artist editArtist');
        commit('error', {
          error: true,
          message: __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network')
        });
        reject(new Error(__WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network')));
      });
    });
  },
  getArtist: function getArtist(_ref3, id) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch;

    startLoading(dispatch, 'artist getArtist');
    dispatch('resetArtist');
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/artists/get/' + id).then(function (res) {
        endLoading(dispatch, 'artist getArtist');
        if (res.body.status === 'ok') {
          commit('setArtist', res.body.data);
          resolve();
        } else {
          commit('error', __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.data'));
          reject(new Error(__WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.data')));
        }
      }, function () {
        endLoading(dispatch, 'artist getArtist');
        commit('error', __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network'));
        reject(new Error(__WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network')));
      });
    });
  },
  resetArtist: function resetArtist(_ref4) {
    var commit = _ref4.commit;

    commit('setArtist', {});
    commit('setArtistPlaylists', []);
    commit('setTracks', []);
  },
  resetError: function resetError(_ref5) {
    var commit = _ref5.commit;

    commit('resetError');
  },
  loadMoreArtists: function loadMoreArtists(_ref6) {
    var commit = _ref6.commit,
        state = _ref6.state,
        dispatch = _ref6.dispatch;
    var textToFilter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    startLoading(dispatch, 'artist loadMore');
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      getArtists(state.genreFilter, state.page, commit, textToFilter).then(function (response) {
        commit('previousRequest', false);
        if (response.status === 200) {
          if (response.body.data.length > 0) {
            commit('appendPage', response.body.data);
            commit('noMoreResults', false);
          } else {
            commit('noMoreResults', true);
          }
          endLoading(dispatch, 'artist loadMore');
          resolve(response.body.data);
        } else {
          commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.artists') });
          endLoading(dispatch, 'artist loadMore');
          reject(new Error(__WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.artists')));
        }
      }, function () {
        commit('previousRequest', false);
        endLoading(dispatch, 'artist loadMore');
        commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network') });
        reject(new Error(__WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network')));
      });
    });
  },
  getAllArtists: function getAllArtists(_ref7) {
    var commit = _ref7.commit,
        dispatch = _ref7.dispatch,
        state = _ref7.state;
    var textToFilter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    startLoading(dispatch, 'artist getAll');
    commit('noMoreResults', false);
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      getArtists(state.genreFilter, state.page, commit, textToFilter).then(function (response) {
        endLoading(dispatch, 'artist getAll');
        if (response.body.status === true) {
          commit('setAll', response.body.data);
          commit('setPageFrom', 1);
          resolve(response.body.data);
        } else {
          commit('setAll', null);
          commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.artists') });
          reject(new Error(__WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network')));
        }
      }, function () {
        endLoading(dispatch, 'artist getAll');
        commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network') });
        reject(new Error(__WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network')));
      });
    });
  },
  setArtistGenreFilter: function setArtistGenreFilter(_ref8, value) {
    var commit = _ref8.commit;

    commit('setArtistGenreFilter', value);
  },
  resetResults: function resetResults(_ref9) {
    var commit = _ref9.commit;

    commit('setFilterResults', []);
  },
  filter: function filter(_ref10, payload) {
    var commit = _ref10.commit,
        dispatch = _ref10.dispatch;

    startLoading(dispatch, 'artist setFilterResults');
    /**
     * Temporary hack to avoid going to network with a blank query and
     * assuring than normal list results are displayed immediately.
     */
    if (payload.query === '') {
      endLoading(dispatch, 'artist setFilterResults');
      commit('setFilterResults', []);
    }

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/artists/getAll').then(function (response) {
        endLoading(dispatch, 'artist setFilterResults');
        if (response.body.status === 'ok') {
          commit('setFilterResults', response.body.data.filter(function (artist) {
            return artist.name && artist.name.search(payload.query) !== -1;
          }));
          resolve(response.data.data);
        } else {
          commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.artists') });
          reject(new Error(__WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.artists')));
        }
      }, function () {
        endLoading(dispatch, 'artist setFilterResults');
        commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network') });
        reject(new Error(__WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network')));
      });
    });
  },
  setPageFrom: function setPageFrom(_ref11, value) {
    var commit = _ref11.commit;

    commit('setPageFrom', value);
  },
  getArtistPlaylists: function getArtistPlaylists(_ref12, id) {
    var commit = _ref12.commit,
        dispatch = _ref12.dispatch;

    startLoading(dispatch, 'artist getArtistPlaylists');
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/artist/' + id + '/playlists').then(function (response) {
        endLoading(dispatch, 'artist getArtistPlaylists');
        if (response.body.status) {
          commit('setArtistPlaylists', response.body.data);
          resolve();
        } else {
          commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.playlists') });
          reject(new Error(__WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.playlists')));
        }
      }, function () {
        endLoading(dispatch, 'artist getArtistPlaylists');
        commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network') });
        reject(new Error(__WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network')));
      });
    });
  },
  updatePrimaryPicture: function updatePrimaryPicture(_ref13, value) {
    var commit = _ref13.commit;

    commit('updatePrimaryPicture', value);
  },
  getArtistTracks: function getArtistTracks(_ref14, id) {
    var commit = _ref14.commit,
        dispatch = _ref14.dispatch;

    startLoading(dispatch, 'artist getArtistTracks');
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/tracks/getArtistTracks/' + id).then(function (response) {
        endLoading(dispatch, 'artist getArtistTracks');
        if (response.body.status === 'ok') {
          commit('setTracks', response.body.data[0].sort(function (a, b) {
            if (parseInt(a.order_position) > parseInt(b.order_position)) {
              return 1;
            }
            if (parseInt(a.order_position) < parseInt(b.order_position)) {
              return -1;
            }
            return 0;
          }));
          resolve();
        } else {
          commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.tracks') });
          reject(new Error(__WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.tracks')));
        }
      }, function () {
        endLoading(dispatch, 'artist getArtistTracks');
        commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network') });
        reject(new Error(__WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network')));
      });
    });
  },
  setVote: function setVote(_ref15, id) {
    var commit = _ref15.commit,
        state = _ref15.state,
        dispatch = _ref15.dispatch;

    startLoading(dispatch, 'artist setVote');
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      if (state.artistTracks.length > 0) {
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/tracks/setVote/', {
          track_id: state.artistTracks[0].id
        }).then(function (response) {
          endLoading(dispatch, 'artist setVote');
          if (response.body.status === 'ok') {
            if (response.body.data === 'voted') {
              commit('user/decreaseMyVotes', null, { root: true });
              resolve();
            }
          } else {
            if (response.body.error === 'Already use vote quote') {
              commit('error', {
                error: true,
                message: __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.voteQuote')
              });
              reject(new Error(__WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.voteQuote')));
            } else if (response.body.error === 'SameArtistAndUser') {
              commit('error', {
                error: true,
                message: __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.SameArtistAndUser')
              });
              reject(new Error(__WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.SameArtistAndUser')));
            } else {
              commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.vote') });
              reject(new Error(__WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.vote')));
            }
          }
        }, function () {
          endLoading(dispatch, 'artist setVote');
          commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network') });
          reject(new Error(__WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network')));
        });
      } else {
        endLoading(dispatch, 'artist setVote');
        commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('artists.hasNotTracks') });
        reject(new Error(__WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('artists.hasNotTracks')));
      }
    });
  },
  getVinylContest: function getVinylContest(_ref16) {
    var commit = _ref16.commit,
        dispatch = _ref16.dispatch;

    startLoading(dispatch, 'artist getVinylContest');
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/tracks/getContest').then(function (response) {
        endLoading(dispatch, 'artist getVinylContest');
        if (response.body.status === 'ok') {
          if (response.body.data['cant'] > 0) {
            commit('setVinylContest', response.body.data.data, response.body.data);
            resolve();
          }
        } else {
          commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.vinylContest') });
          reject(new Error(__WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.vinylContest')));
        }
      }, function () {
        endLoading(dispatch, 'artist getVinylContest');
        commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network') });
        reject(new Error(__WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network')));
      });
    });
  },
  openProfile: function openProfile(_ref17) {
    var commit = _ref17.commit;

    commit('isProfileOpen', true);
  },
  closeProfile: function closeProfile(_ref18) {
    var commit = _ref18.commit;

    commit('isProfileOpen', false);
  },
  contact: function contact(_ref19, value) {
    var commit = _ref19.commit,
        dispatch = _ref19.dispatch;

    startLoading(dispatch, 'artist contact');
    return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/artist/' + value.artist_id + '/contact', {
      message: value.message, userEmail: value.userEmail, userFirstName: value.userFirstName, userLastName: value.userLastName, username: value.username
    }).then(function (response) {
      endLoading(dispatch, 'artist setComment');
      if (response.body.status) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
      } else {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error(__WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.contact')));
      }
    }).catch(function (e) {
      endLoading(dispatch, 'artist setComment');
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error(__WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network')));
    });
  },
  getPaymentInfo: function getPaymentInfo(_ref20) {
    var dispatch = _ref20.dispatch;

    startLoading(dispatch, 'artist getPaymentInfo');
    return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/payment/mp/userInfo').then(function (response) {
      if (response.body.status) {
        endLoading(dispatch, 'artist getPaymentInfo');
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response.body.data);
      } else {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error(response.body.error.message));
      }
    }).catch(function (e) {
      endLoading(dispatch, 'artist getPaymentInfo');
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error(e.message ? e.message : __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network')));
    });
  },
  mpConnect: function mpConnect(_ref21) {
    var dispatch = _ref21.dispatch;

    startLoading(dispatch, 'artist mpConnect');
    return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/payment/mp/connect').then(function (response) {
      if (response.body.status) {
        endLoading(dispatch, 'artist mpConnect');
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response.body);
      } else {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error(response.body.error.message));
      }
    }).catch(function (e) {
      endLoading(dispatch, 'artist mpConnect');
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error(e.message ? e.message : __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network')));
    });
  },
  setArtisticName: function setArtisticName(_ref22, artisticName) {
    var dispatch = _ref22.dispatch;

    startLoading(dispatch, 'artist setArtisticName');
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/artist/editOrCreate', artisticName).then(function (response) {
        if (response.body.status !== true) {
          endLoading(dispatch, 'artist setArtisticName');
          reject(new Error(response.body.error));
        } else {
          endLoading(dispatch, 'artist setArtisticName');
          resolve();
        }
      }).catch(function (e) {
        endLoading(dispatch, 'artist setArtisticName');
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error(e.message ? e.message : 'error setArtisticName'));
      });
    });
  }
};

var getters = {
  error: function error(state) {
    return state.error;
  },
  loading: function loading(state) {
    return state.loading;
  },
  artist: function artist(state) {
    return state.artist;
  },
  myArtistInfo: function myArtistInfo(state) {
    return state.myArtistInfo;
  },
  myArtistInfoRefresh: function myArtistInfoRefresh(state) {
    return state.myArtistInfoRefresh;
  },
  noMoreResults: function noMoreResults(state) {
    return state.noMoreResults;
  },
  artists: function artists(state) {
    return state.artists;
  },
  results: function results(state) {
    return state.results;
  },
  loadingFilterResults: function loadingFilterResults(state) {
    return state.loadingFilterResults;
  },
  artistPlaylists: function artistPlaylists(state) {
    return state.artistPlaylists;
  },
  artistTracks: function artistTracks(state) {
    return state.artistTracks;
  },
  isProfileOpen: function isProfileOpen(state) {
    return state.isProfileOpen;
  },
  vinylContest: function vinylContest(state) {
    return state.vinylContest;
  },
  vinylContestInfo: function vinylContestInfo(state) {
    return state.vinylContestInfo;
  },
  genreFilter: function genreFilter(state) {
    return state.genreFilter;
  },
  page: function page(state) {
    return state.page;
  }
};

var artist = {
  namespaced: true,
  initialStates: initialStates,
  state: initialStates(),
  mutations: mutations,
  actions: actions,
  getters: getters
};

/* harmony default export */ __webpack_exports__["a"] = (artist);

/***/ }),
/* 1197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__consts__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_loading__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuex_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__translator__ = __webpack_require__(69);







var _createActionHelpers = Object(__WEBPACK_IMPORTED_MODULE_4_vuex_loading__["createActionHelpers"])({
  moduleName: 'loading'
}),
    startLoading = _createActionHelpers.startLoading,
    endLoading = _createActionHelpers.endLoading;

function getPlaylists(genreFilter, page, commit, textToFilter) {
  var promise = __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + ('/playlists/ByGenre/' + genreFilter + '/' + page + '/' + textToFilter));
  promise.then(function (response) {
    if (response.data.status === 'ok') {
      commit('incrementFrom', 1);
    }
  });
  return promise;
}
function getRecommendedPlaylists(genreFilter, page, commit, textToFilter, recommended) {
  var promise = __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + ('/playlists/ByGenre/' + genreFilter + '/' + page + '/' + textToFilter + '/' + recommended));
  promise.then(function (response) {
    if (response.data.status === 'ok') {
      commit('incrementFrom', 1);
    }
  });
  return promise;
}

var initialStates = function initialStates() {
  return {
    error: '',
    newPlaylistId: null,
    playlists: [],
    page: 0,
    recommendedPlaylists: [],
    pageRecommended: 0,
    genreFilter: 0,
    liked: false,
    isPlaylistOpen: false,
    playlist: {}
  };
};

var mutations = {
  isPlaylistOpen: function isPlaylistOpen(state, value) {
    state.isPlaylistOpen = value;
  },
  setPlaylist: function setPlaylist(state, value) {
    state.playlist = value;
  },
  error: function error(state, value) {
    state.error = value;
  },
  newPlaylistId: function newPlaylistId(state, value) {
    state.newPlaylistId = value;
  },
  setPlaylistFrom: function setPlaylistFrom(state, value) {
    state.page = value;
  },
  setPlaylistRecommendedFrom: function setPlaylistRecommendedFrom(state, value) {
    state.pageRecommended = value;
  },
  appendPage: function appendPage(state, value) {
    var _state$playlists;

    (_state$playlists = state.playlists).push.apply(_state$playlists, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(value));
    state.page++;
  },
  appendPageRecommended: function appendPageRecommended(state, value) {
    var _state$recommendedPla;

    (_state$recommendedPla = state.recommendedPlaylists).push.apply(_state$recommendedPla, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(value));
    state.pageRecommended++;
  },
  setAll: function setAll(state, value) {
    state.playlists = value;
  },
  setAllrecommended: function setAllrecommended(state, value) {
    state.recommendedPlaylists = value;
  },
  setPlaylistGenreFilter: function setPlaylistGenreFilter(state, value) {
    state.genreFilter = value;
  },
  togglePlaylistLike: function togglePlaylistLike(state, value) {
    state.liked = value;
    if (state.playlist.hasOwnProperty('liked')) {
      state.playlist.liked = value;
    }
  }
};

var actions = {
  openPlaylist: function openPlaylist(_ref) {
    var commit = _ref.commit;

    commit('isPlaylistOpen', true);
  },
  closePlaylist: function closePlaylist(_ref2) {
    var commit = _ref2.commit;

    commit('isPlaylistOpen', false);
  },
  addToPlaylist: function addToPlaylist(_ref3, value) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch;

    startLoading(dispatch, 'playlist addToPlaylist');
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/playlists/setTrackInPlaylist', {
        id_playlist: value.playlistId,
        id_track: value.trackId
      }).then(function (response) {
        endLoading(dispatch, 'playlist addToPlaylist');
        if (response.body.status === 'ok') {
          resolve();
        } else {
          if (response.body.error === 'track already added to playlist') {
            commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('playlists.trackAlreadyExist') });
            reject(new Error(__WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('playlists.trackAlreadyExist')));
          } else {
            commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.addToPlaylist') });
            reject(new Error(__WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.addToPlaylist')));
          }
        }
      }, function () {
        endLoading(dispatch, 'playlist addToPlaylist');
        commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network') });
        reject(new Error(__WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network')));
      });
    });
  },
  setPlaylist: function setPlaylist(_ref4, value) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;

    startLoading(dispatch, 'playlist setPlaylist');
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/playlists/setPlaylist', {
        picture: value.picture,
        title: value.title,
        type: value.type
      }).then(function (response) {
        endLoading(dispatch, 'playlist setPlaylist');
        if (response.body.status === 'ok' && response.body.data.msg === 'saved') {
          commit('newPlaylistId', response.body.data.id_playlist);
          resolve();
        } else {
          commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.newPlaylist') });
          reject(new Error(__WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.newPlaylist')));
        }
      }, function () {
        endLoading(dispatch, 'playlist setPlaylist');
        commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network') });
        reject(new Error(__WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network')));
      });
    });
  },
  setPlaylistAndTrack: function setPlaylistAndTrack(_ref5, value) {
    var commit = _ref5.commit,
        dispatch = _ref5.dispatch;

    startLoading(dispatch, 'playlist setPlaylistAndTrack');
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/playlists/setNewPlaylistAndTrack', {
        picture: value.picture,
        title: value.title,
        type: value.type,
        track_id: value.trackId
      }).then(function (response) {
        endLoading(dispatch, 'playlist setPlaylistAndTrack');
        if (response.body.status === 'ok' && response.body.data.msg === 'saved') {
          commit('newPlaylistId', response.body.data.id_playlist);
          resolve();
        } else {
          commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.newPlaylist') });
          reject(new Error(__WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.newPlaylist')));
        }
      }, function () {
        endLoading(dispatch, 'playlist setPlaylistAndTrack');
        commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network') });
        reject(new Error(__WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network')));
      });
    });
  },
  delete: function _delete(_ref6, value) {
    var commit = _ref6.commit,
        dispatch = _ref6.dispatch;

    startLoading(dispatch, 'playlist delete');
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/playlists/del', {
        playlist_id: value
      }).then(function (response) {
        if (response.body.status === 'ok' && response.body.data === 'deleted') {
          dispatch('user/getMyPlaylists', null, { root: true });
          endLoading(dispatch, 'playlist delete');
          resolve();
        } else {
          commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.deletePlaylist') });
          reject(new Error(__WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.deletePlaylist')));
        }
      }, function () {
        endLoading(dispatch, 'playlist delete');
        commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network') });
        reject(new Error(__WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network')));
      });
    });
  },
  edit: function edit(_ref7, value) {
    var commit = _ref7.commit,
        dispatch = _ref7.dispatch;

    var picture = value.picture.split(/\/uploads\/playlists\//gi).reverse()[0];
    startLoading(dispatch, 'playlist edit');
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/playlists/edit/' + value.playlistId, {
        title: value.title,
        picture: picture,
        type: value.type
      }).then(function (response) {
        if (response.body.status === 'ok' && response.body.data.msg === 'saved') {
          dispatch('user/getMyPlaylists', null, { root: true });
          endLoading(dispatch, 'playlist edit');
          resolve();
        } else {
          endLoading(dispatch, 'playlist edit');
          commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.updatePlaylist') });
          reject(new Error(__WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.updatePlaylist')));
        }
      }, function () {
        endLoading(dispatch, 'playlist edit');
        commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network') });
        reject(new Error(__WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network')));
      });
    });
  },
  getFeaturedPlaylist: function getFeaturedPlaylist(_ref8) {
    var dispatch = _ref8.dispatch,
        commit = _ref8.commit;

    startLoading(dispatch, 'playlist getFeaturedPlaylist');
    return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/featured_playlists/getLast').then(function (response) {
      endLoading(dispatch, 'playlist getFeaturedPlaylist');
      if (response.body.status) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response.body.data);
      } else {
        switch (response.body.error.message) {
          case 'no artist found':
            {
              commit('error', {
                message: __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.noArtistFound')
              });
              break;
            }
          default:
            {
              commit('error', {
                message: __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.featuredPlaylist')
              });
              break;
            }
        }
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error(response.body.error.message));
      }
    }).catch(function (e) {
      endLoading(dispatch, 'playlist getFeaturedPlaylist');
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error(__WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network')));
    });
  },
  deleteTrackFromPlaylist: function deleteTrackFromPlaylist(_ref9, value) {
    var commit = _ref9.commit,
        dispatch = _ref9.dispatch;

    startLoading(dispatch, 'playlist deleteTrack');
    return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/playlists/deleteTrackFromPlaylist', {
      id_track: value.trackId,
      id_playlist: value.playlistId
    }).then(function (response) {
      if (response.body.status === 'ok' && response.body.data === 'deleted') {
        dispatch('user/getMyPlaylists', null, { root: true });
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/playlists/getPlaylist/' + value.playlistId).then(function (response) {
          endLoading(dispatch, 'playlist getPlaylist');
          if (response.body.status) {
            commit('setPlaylist', response.body.data);
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response.body.data);
          } else {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error(response.body.error));
          }
        });
        endLoading(dispatch, 'playlist delete');
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
      } else {
        endLoading(dispatch, 'playlist delete');
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error(__WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.deleteFromPlaylist')));
      }
    }).catch(function () {
      endLoading(dispatch, 'playlist delete');
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error(__WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network')));
    });
  },
  getPlaylist: function getPlaylist(_ref10, id) {
    var commit = _ref10.commit,
        dispatch = _ref10.dispatch;

    startLoading(dispatch, 'playlist getPlaylist');
    commit('setPlaylist', {});
    return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/playlists/getPlaylist/' + id).then(function (response) {
      endLoading(dispatch, 'playlist getPlaylist');
      if (response.body.status) {
        commit('setPlaylist', response.body.data);
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response.body.data);
      } else {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error(response.body.error));
      }
    }).catch(function (e) {
      endLoading(dispatch, 'playlist getPlaylist');
      if (e.body.error) {
        switch (e.body.error.message) {
          case 'Playlist no encontrada':
            {
              commit('error', {
                message: __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.playlistNotFound')
              });
              break;
            }
          case 'Playlist privada':
            {
              commit('error', {
                message: __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.privatePlaylist')
              });
              break;
            }
          default:
            {
              commit('error', {
                message: __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.getPlaylist'),
                input: ''
              });
            }
        }
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error(e.body.error.message));
      }
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error(__WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network')));
    });
  },
  resetError: function resetError(_ref11) {
    var commit = _ref11.commit,
        state = _ref11.state;

    commit('error', '');
  },
  setPlaylistFrom: function setPlaylistFrom(_ref12, value) {
    var commit = _ref12.commit;

    commit('setPlaylistFrom', value);
  },
  setPlaylistRecommendedFrom: function setPlaylistRecommendedFrom(_ref13, value) {
    var commit = _ref13.commit;

    commit('setPlaylistRecommendedFrom', value);
  },
  setPlaylistGenreFilter: function setPlaylistGenreFilter(_ref14, value) {
    var commit = _ref14.commit;

    commit('setPlaylistGenreFilter', value);
  },
  loadMorePlaylist: function loadMorePlaylist(_ref15, textToFilter) {
    var commit = _ref15.commit,
        state = _ref15.state,
        dispatch = _ref15.dispatch;

    startLoading(dispatch, 'playlist loadMore');
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      getPlaylists(state.genreFilter, state.page, commit, textToFilter).then(function (response) {
        commit('previousRequest', false);
        if (response.status === 200) {
          if (response.body.data.length > 0) {
            commit('appendPage', response.body.data);
          } else {
            // commit('noMoreResults')
          }
          endLoading(dispatch, 'playlist loadMore');
          resolve(response.body.data);
        } else {
          commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.playlist') });
          endLoading(dispatch, 'playlist loadMore');
          reject(new Error(__WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.playlist')));
        }
      }, function () {
        commit('previousRequest', false);
        endLoading(dispatch, 'playlist loadMore');
        commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network') });
        reject(new Error(__WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network')));
      });
    });
  },
  loadMoreRecommendedPlaylist: function loadMoreRecommendedPlaylist(_ref16, textToFilter) {
    var commit = _ref16.commit,
        state = _ref16.state,
        dispatch = _ref16.dispatch;

    startLoading(dispatch, 'recommendedPlaylist loadMore');
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      getRecommendedPlaylists(state.genreFilter, state.page, commit, textToFilter, true).then(function (response) {
        commit('previousRequest', false);
        if (response.status === 200) {
          if (response.body.data.length > 0) {
            commit('appendPageRecommended', response.body.data);
          } else {
            // commit('noMoreResults')
          }
          endLoading(dispatch, 'recommendedPlaylist loadMore');
          resolve(response.body.data);
        } else {
          commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.playlist') });
          endLoading(dispatch, 'recommendedPlaylist loadMore');
          reject(new Error(__WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.playlist')));
        }
      }, function () {
        commit('previousRequest', false);
        endLoading(dispatch, 'recommendedPlaylist loadMore');
        commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network') });
        reject(new Error(__WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network')));
      });
    });
  },
  getAllPlaylist: function getAllPlaylist(_ref17) {
    var commit = _ref17.commit,
        dispatch = _ref17.dispatch,
        state = _ref17.state;
    var textToFilter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    startLoading(dispatch, 'playlist getAll');
    // commit('noMoreResults', false)
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      getPlaylists(state.genreFilter, state.page, commit, textToFilter).then(function (response) {
        endLoading(dispatch, 'playlist getAll');
        if (response.body.status === true) {
          commit('setAll', response.body.data);
          commit('setPlaylistFrom', 1);
          resolve(response.body.data);
        } else {
          commit('setAll', response.body.data);
          commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.playlist') });
          reject(new Error(__WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network')));
        }
      }, function () {
        endLoading(dispatch, 'playlist getAll');
        commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network') });
        reject(new Error(__WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network')));
      });
    });
  },
  getAllRecommendedPlaylist: function getAllRecommendedPlaylist(_ref18) {
    var commit = _ref18.commit,
        dispatch = _ref18.dispatch,
        state = _ref18.state;
    var textToFilter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    startLoading(dispatch, 'playlist getAllRecommendedPlaylist');
    // commit('noMoreResults', false)
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      getRecommendedPlaylists(state.genreFilter, state.page, commit, textToFilter, true).then(function (response) {
        endLoading(dispatch, 'playlist getAllRecommendedPlaylist');
        if (response.body.status === true) {
          commit('setAllrecommended', response.body.data);
          commit('setPlaylistRecommendedFrom', 1);
          resolve(response.body.data);
        } else {
          commit('setAllrecommended', response.body.data);
          commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.playlist') });
          reject(new Error(__WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network')));
        }
      }, function () {
        endLoading(dispatch, 'playlist getAllRecommendedPlaylist');
        commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network') });
        reject(new Error(__WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network')));
      });
    });
  },
  togglePlaylistLike: function togglePlaylistLike(_ref19, value) {
    var commit = _ref19.commit,
        dispatch = _ref19.dispatch;

    startLoading(dispatch, 'playlist like');
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/playlists/like', {
        id_playlist: value
      }).then(function (response) {
        endLoading(dispatch, 'playlist like');
        if (response.body.like === true || response.body.like === false) {
          commit('togglePlaylistLike', response.body.like);
          resolve();
        } else {
          commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.likePlaylist') });
          reject(new Error(__WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.likePlaylist')));
        }
      });
    });
  }
};

var getters = {
  error: function error(state) {
    return state.error;
  },
  newPlaylistId: function newPlaylistId(state) {
    return state.newPlaylistId;
  },
  genreFilter: function genreFilter(state) {
    return state.genreFilter;
  },
  playlists: function playlists(state) {
    return state.playlists;
  },
  playlist: function playlist(state) {
    return state.playlist;
  },
  recommendedPlaylists: function recommendedPlaylists(state) {
    return state.recommendedPlaylists;
  },
  playlistLiked: function playlistLiked(state) {
    return state.liked;
  },
  isPlaylistOpen: function isPlaylistOpen(state) {
    return state.isPlaylistOpen;
  }
};

var playlist = {
  namespaced: true,
  initialStates: initialStates,
  state: initialStates(),
  mutations: mutations,
  actions: actions,
  getters: getters
};

/* harmony default export */ __webpack_exports__["a"] = (playlist);

/***/ }),
/* 1198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__consts__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_loading__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuex_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__translator__ = __webpack_require__(69);







var _createActionHelpers = Object(__WEBPACK_IMPORTED_MODULE_4_vuex_loading__["createActionHelpers"])({
  moduleName: 'loading'
}),
    startLoading = _createActionHelpers.startLoading,
    endLoading = _createActionHelpers.endLoading;

var initialStates = function initialStates() {
  return {
    ppPlans: null
  };
};

var mutations = {
  logout: function logout(state) {
    var init = initialStates();
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(init).forEach(function (key) {
      state[key] = init[key];
    });
  },
  setPPplans: function setPPplans(state, value) {
    state.ppPlans = value;
  }
};

var actions = {
  getBanners: function getBanners(_ref, value) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;

    startLoading(dispatch, 'home getBanners');
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/getBanners').then(function (response) {
        endLoading(dispatch, 'home getBanners');
        if (response.body.status) {
          resolve(response.body.banners);
        } else {
          reject(new Error(response.body.error.message));
        }
      }, function () {
        endLoading(dispatch, 'home getBanners');
        reject(new Error('Error de red'));
      });
    });
  },
  getProviders: function getProviders(_ref2, data) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch;

    startLoading(dispatch, 'getProviders');
    return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/getProviderByCountry?provider=' + data.provider + '&country=' + data.providerCountry).then(function (response) {
      endLoading(dispatch, 'getProviders');
      if (response.body.status) {
        commit('setIlProviders', response.body.data);
        localStorage.setItem('provider_msj', response.body.data.unsuscribe_message);
        localStorage.setItem('provider_n', response.body.data.number);
        localStorage.setItem('provider_email', response.body.data.email);
      } else {
        commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network') });
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error(__WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network')));
      }
    }, function () {
      endLoading(dispatch, 'getProviders');
      commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network') });
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error(__WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network')));
    });
  },
  getPPplans: function getPPplans(_ref3) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch;

    startLoading(dispatch, 'getPPplans');
    return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/payment/pp/getPlans').then(function (response) {
      endLoading(dispatch, 'getPPplans');
      if (response.body.status) {
        commit('setPPplans', response.body.data.plans);
        return response.body.data.plans;
      } else {
        commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network') });
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error(__WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network')));
      }
    }, function () {
      endLoading(dispatch, 'getPPplans');
      commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network') });
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error(__WEBPACK_IMPORTED_MODULE_5__translator__["a" /* default */].t('error.store.network')));
    });
  },
  getLocalRadios: function getLocalRadios(_ref4, country) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;

    startLoading(dispatch, 'getLocalRadios');
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].API_BASE_URL + '/getLocalRadios?country=' + country).then(function (response) {
        endLoading(dispatch, 'getLocalRadios');
        if (response.body.status) {
          resolve(response.body.data);
        } else {
          reject(new Error(response.body.error.message));
        }
      }, function () {
        endLoading(dispatch, 'getLocalRadios');
        reject(new Error('Error de red'));
      });
    });
  }
};

var getters = {
  ppPlans: function ppPlans(state) {
    return state.ppPlans;
  }
};

var home = {
  namespaced: true,
  initialStates: initialStates,
  state: initialStates(),
  mutations: mutations,
  actions: actions,
  getters: getters
};

/* harmony default export */ __webpack_exports__["a"] = (home);

/***/ }),
/* 1199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__consts__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_loading__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuex_loading__);





var _createActionHelpers = Object(__WEBPACK_IMPORTED_MODULE_3_vuex_loading__["createActionHelpers"])({
  moduleName: 'loading'
}),
    startLoading = _createActionHelpers.startLoading,
    endLoading = _createActionHelpers.endLoading;

var ALLOW_ADAPTATION = 0;
var NOT_ALLOW_ADAPTATION = 1;
var ALLOW_WITHOUT_MODIFICATIONS = 2;
var ALLOW_COMMERCIAL_USES = 0;
var NOT_ALLOW_COMMERCIAL_USES = 1;

var initialStates = function initialStates() {
  return {
    licenses: [],
    actualLicense: Object,
    adaptationCondition: 1,
    commercialCondition: 1
  };
};

var mutations = {
  getLicenses: function getLicenses(state, value) {
    state.licenses = value;
  },
  setActualLicense: function setActualLicense(state) {
    // set actual license from adaptationCondition and commercialCondition values
    if (state.adaptationCondition === ALLOW_ADAPTATION && state.commercialCondition === ALLOW_COMMERCIAL_USES) {
      state.actualLicense = state.licenses[0];
    }
    if (state.adaptationCondition === ALLOW_ADAPTATION && state.commercialCondition === NOT_ALLOW_COMMERCIAL_USES) {
      state.actualLicense = state.licenses[3];
    }
    if (state.adaptationCondition === NOT_ALLOW_ADAPTATION && state.commercialCondition === ALLOW_COMMERCIAL_USES) {
      state.actualLicense = state.licenses[2];
    }
    if (state.adaptationCondition === NOT_ALLOW_ADAPTATION && state.commercialCondition === NOT_ALLOW_COMMERCIAL_USES) {
      state.actualLicense = state.licenses[5];
    }
    if (state.adaptationCondition === ALLOW_WITHOUT_MODIFICATIONS && state.commercialCondition === ALLOW_COMMERCIAL_USES) {
      state.actualLicense = state.licenses[1];
    }
    if (state.adaptationCondition === ALLOW_WITHOUT_MODIFICATIONS && state.commercialCondition === NOT_ALLOW_COMMERCIAL_USES) {
      state.actualLicense = state.licenses[4];
    }
  },
  setLicenseValues: function setLicenseValues(state, id) {
    // set adaptationCondition and license 2 from license id
    switch (id) {
      case state.licenses[0]:
        {
          state.adaptationCondition = ALLOW_ADAPTATION;
          state.commercialCondition = ALLOW_COMMERCIAL_USES;
          break;
        }
      case state.licenses[1]:
        {
          state.adaptationCondition = ALLOW_WITHOUT_MODIFICATIONS;
          state.commercialCondition = ALLOW_COMMERCIAL_USES;
          break;
        }
      case state.licenses[2]:
        {
          state.adaptationCondition = NOT_ALLOW_ADAPTATION;
          state.commercialCondition = ALLOW_COMMERCIAL_USES;
          break;
        }
      case state.licenses[3]:
        {
          state.adaptationCondition = ALLOW_ADAPTATION;
          state.commercialCondition = NOT_ALLOW_COMMERCIAL_USES;
          break;
        }
      case state.licenses[4]:
        {
          state.adaptationCondition = ALLOW_WITHOUT_MODIFICATIONS;
          state.commercialCondition = NOT_ALLOW_COMMERCIAL_USES;
          break;
        }
      case state.licenses[5]:
        {
          state.adaptationCondition = NOT_ALLOW_ADAPTATION;
          state.commercialCondition = NOT_ALLOW_COMMERCIAL_USES;
          break;
        }
    }
  },
  setAdaptationCondition: function setAdaptationCondition(state, value) {
    state.adaptationCondition = value;
  },
  setCommercialCondition: function setCommercialCondition(state, value) {
    state.commercialCondition = value;
  },
  resetLicense: function resetLicense(state) {
    state.adaptationCondition = ALLOW_ADAPTATION;
    state.commercialCondition = ALLOW_COMMERCIAL_USES;
    state.actualLicense = state.licenses[0];
  }
};

var actions = {
  getLicenses: function getLicenses(_ref) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;

    startLoading(dispatch, 'license getLicenses');
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].API_BASE_URL + '/tracks/getLisenses').then(function (response) {
        endLoading(dispatch, 'license getLicenses');
        if (response.body.status === 'ok') {
          commit('getLicenses', response.body.data);
          resolve();
        }
      }, function () {
        endLoading(dispatch, 'license getLicenses');
        reject(new Error('Error de red'));
      });
    });
  },
  setActualLicense: function setActualLicense(_ref2) {
    var commit = _ref2.commit;

    commit('setActualLicense');
  },
  setLicenseValues: function setLicenseValues(_ref3) {
    var commit = _ref3.commit;

    commit('setLicenseValues');
  },
  setAdaptationCondition: function setAdaptationCondition(_ref4, value) {
    var commit = _ref4.commit;

    commit('setAdaptationCondition', value);
  },
  setCommercialCondition: function setCommercialCondition(_ref5, value) {
    var commit = _ref5.commit;

    commit('setCommercialCondition', value);
  },
  resetLicense: function resetLicense(_ref6) {
    var commit = _ref6.commit;

    commit('resetLicense');
  }
};

var getters = {
  licenses: function licenses(state) {
    return state.licenses;
  },
  adaptationCondition: function adaptationCondition(state) {
    return state.adaptationCondition;
  },
  commercialCondition: function commercialCondition(state) {
    return state.commercialCondition;
  },
  actualLicense: function actualLicense(state) {
    return state.actualLicense;
  }
};

var license = {
  namespaced: true,
  initialStates: initialStates,
  state: initialStates(),
  mutations: mutations,
  actions: actions,
  getters: getters
};

/* harmony default export */ __webpack_exports__["a"] = (license);

/***/ }),
/* 1200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__translator__ = __webpack_require__(69);


var initialStates = function initialStates() {
  return {
    language: __WEBPACK_IMPORTED_MODULE_0__translator__["a" /* default */].locale,
    joinImage: __webpack_require__(565)
  };
};

var mutations = {
  setLanguage: function setLanguage(state, value) {
    state.language = value;
  },
  getLinkImage: function getLinkImage(state, value) {
    state.joinImage = __webpack_require__(1201)("./Join." + value + '.png');
  }
};

var actions = {
  setLanguage: function setLanguage(_ref, value) {
    var commit = _ref.commit;

    localStorage.setItem('language', value);
    __WEBPACK_IMPORTED_MODULE_0__translator__["a" /* default */].locale = value;
    commit('setLanguage', value);
    commit('getLinkImage', value);
  }
};

var getters = {
  language: function language(state) {
    return state.language;
  },
  joinImage: function joinImage(state) {
    return state.joinImage;
  },
  isCurrentLanguage: function isCurrentLanguage(state) {
    return function (lang) {
      return state.language === lang;
    };
  }
};

var translator = {
  namespaced: true,
  initialStates: initialStates,
  state: initialStates(),
  mutations: mutations,
  actions: actions,
  getters: getters
};

/* harmony default export */ __webpack_exports__["a"] = (translator);

/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./Join.en.png": 565,
	"./Join.es.png": 1202
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1201;

/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Join.es.9b0af52.png";

/***/ }),
/* 1203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__consts__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_loading__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuex_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__translator__ = __webpack_require__(69);






var _createActionHelpers = Object(__WEBPACK_IMPORTED_MODULE_3_vuex_loading__["createActionHelpers"])({
  moduleName: 'loading'
}),
    startLoading = _createActionHelpers.startLoading,
    endLoading = _createActionHelpers.endLoading;

var initialStates = function initialStates() {
  return {
    news: '',
    loading: false
  };
};

var mutations = {
  setNews: function setNews(state, value) {
    state.news = value;
  }
};

var actions = {
  setNews: function setNews(_ref, value) {
    var commit = _ref.commit;

    commit('setNews', value);
  },
  getNewsFeatures: function getNewsFeatures(_ref2, data) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch;

    startLoading(dispatch, 'news getNewsFeatures');
    return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].API_BASE_URL + '/new-feature/' + data.language + '/' + data.user).then(function (response) {
      endLoading(dispatch, 'news getNewsFeatures');
      if (response.body.status) {
        commit('setNews', response.body.data);
      } else {
        commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_4__translator__["a" /* default */].t('error.store.voteValidation') });
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error(__WEBPACK_IMPORTED_MODULE_4__translator__["a" /* default */].t('error.store.voteValidation')));
      }
    }, function () {
      endLoading(dispatch, 'news getNewsFeatures');
      commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_4__translator__["a" /* default */].t('error.store.network') });
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error(__WEBPACK_IMPORTED_MODULE_4__translator__["a" /* default */].t('error.store.network')));
    });
  },
  setNewFeatureSeen: function setNewFeatureSeen(_ref3, data) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch;

    startLoading(dispatch, 'news NewFeatureSeen');
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].API_BASE_URL + '/new-feature/setAccepted', data).then(function (response) {
        endLoading(dispatch, 'news NewFeatureSeen');
        if (response.body.status === true) {
          resolve();
        } else {
          commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_4__translator__["a" /* default */].t('error.store.contact') });
          reject(new Error(__WEBPACK_IMPORTED_MODULE_4__translator__["a" /* default */].t('error.store.contact')));
        }
      }, function () {
        endLoading(dispatch, 'news NewFeatureSeen');
        commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_4__translator__["a" /* default */].t('error.store.network') });
        reject(new Error(__WEBPACK_IMPORTED_MODULE_4__translator__["a" /* default */].t('error.store.network')));
      });
    });
  }
};

var getters = {
  news: function news(state) {
    return state.news;
  }
};

var news = {
  namespaced: true,
  initialStates: initialStates,
  state: initialStates(),
  mutations: mutations,
  actions: actions,
  getters: getters
};

/* harmony default export */ __webpack_exports__["a"] = (news);

/***/ }),
/* 1204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__consts__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_loading__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuex_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__translator__ = __webpack_require__(69);






var _createActionHelpers = Object(__WEBPACK_IMPORTED_MODULE_3_vuex_loading__["createActionHelpers"])({
  moduleName: 'loading'
}),
    startLoading = _createActionHelpers.startLoading,
    endLoading = _createActionHelpers.endLoading;

var initialStates = function initialStates() {
  return {
    error: '',
    pricing: null
  };
};

var actions = {
  getPricing: function getPricing(_ref, value) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;

    startLoading(dispatch, 'pricing getPricing');
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].API_BASE_URL + '/pricings/getPricings').then(function (response) {
        endLoading(dispatch, 'pricing getPricing');
        if (response.body.status) {
          commit('setPricing', response.body.data);
          resolve(response.body.data);
        } else {
          commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_4__translator__["a" /* default */].t('error.store.tracks') });
          reject(new Error(__WEBPACK_IMPORTED_MODULE_4__translator__["a" /* default */].t('error.store.network')));
        }
      }, function () {
        endLoading(dispatch, 'pricing getPricing');
        commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_4__translator__["a" /* default */].t('error.store.network') });
        reject(new Error(__WEBPACK_IMPORTED_MODULE_4__translator__["a" /* default */].t('error.store.network')));
      });
    });
  }
};

var mutations = {
  error: function error(state, value) {
    state.error = value['message'];
  },
  setPricing: function setPricing(state, value) {
    state.pricing = value;
  }
};

var getters = {
  error: function error(state) {
    return state.error;
  },
  pricing: function pricing(state) {
    return state.pricing;
  }
};

var pricing = {
  namespaced: true,
  initialStates: initialStates,
  state: initialStates(),
  mutations: mutations,
  actions: actions,
  getters: getters
};

/* harmony default export */ __webpack_exports__["a"] = (pricing);

/***/ }),
/* 1205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__consts__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_loading__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuex_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__translator__ = __webpack_require__(69);






var _createActionHelpers = Object(__WEBPACK_IMPORTED_MODULE_3_vuex_loading__["createActionHelpers"])({
  moduleName: 'loading'
}),
    startLoading = _createActionHelpers.startLoading,
    endLoading = _createActionHelpers.endLoading;

var initialStates = function initialStates() {
  return {
    error: '',
    metrics: Object,
    reproductions: [],
    songRanking: [],
    reproductionsRefresh: 0
  };
};

var mutations = {
  setMetrics: function setMetrics(state, value) {
    state.metrics = value;
  },
  setReproductions: function setReproductions(state, value) {
    state.reproductions = value;
    state.reproductionsRefresh++;
  },
  setSongRanking: function setSongRanking(state, value) {
    state.songRanking = value;
  }
};

var actions = {
  getMetrics: function getMetrics(_ref, param) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;

    startLoading(dispatch, 'dashboard setMetrics');
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var condition = '?from=' + param.from + '&to=' + param.to + (param.artistId !== null ? '&artistId=' + param.artistId.toString() : '');
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].API_BASE_URL + '/artist/singletonValues' + condition).then(function (res) {
        endLoading(dispatch, 'dashboard setMetrics');
        if (res.body.status === true) {
          commit('setMetrics', res.body.data);
          resolve();
        } else {
          commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_4__translator__["a" /* default */].t('error.store.tracks') });
          reject(new Error(__WEBPACK_IMPORTED_MODULE_4__translator__["a" /* default */].t('error.store.network')));
        }
      }, function () {
        endLoading(dispatch, 'dashboard setMetrics');
        commit('error', __WEBPACK_IMPORTED_MODULE_4__translator__["a" /* default */].t('error.store.network'));
        reject(new Error(__WEBPACK_IMPORTED_MODULE_4__translator__["a" /* default */].t('error.store.network')));
      });
    });
  },
  getReproductions: function getReproductions(_ref2, param) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch;

    startLoading(dispatch, 'dashboard setReproductions');
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var condition = '?from=' + param.from + '&to=' + param.to + (param.artistId !== null ? '&artistId=' + param.artistId.toString() : '');
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].API_BASE_URL + '/artist/reproductions' + condition).then(function (res) {
        endLoading(dispatch, 'dashboard setReproductions');
        if (res.body.status === true) {
          commit('setReproductions', res.body.data);
          resolve();
        } else {
          commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_4__translator__["a" /* default */].t('error.store.tracks') });
          reject(new Error(__WEBPACK_IMPORTED_MODULE_4__translator__["a" /* default */].t('error.store.network')));
        }
      }, function () {
        endLoading(dispatch, 'dashboard setReproductions');
        commit('error', __WEBPACK_IMPORTED_MODULE_4__translator__["a" /* default */].t('error.store.network'));
        reject(new Error(__WEBPACK_IMPORTED_MODULE_4__translator__["a" /* default */].t('error.store.network')));
      });
    });
  },
  getSongRanking: function getSongRanking(_ref3, param) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch;

    startLoading(dispatch, 'dashboard setSongRanking');
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var condition = '?from=' + param.from + '&to=' + param.to + (param.artistId !== null ? '&artistId=' + param.artistId.toString() : '');
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].API_BASE_URL + '/artist/reproductionsRankings' + condition).then(function (res) {
        endLoading(dispatch, 'dashboard setSongRanking');
        if (res.body.status === true) {
          commit('setSongRanking', res.body.data);
          resolve();
        } else {
          commit('error', { error: true, message: __WEBPACK_IMPORTED_MODULE_4__translator__["a" /* default */].t('error.store.tracks') });
          reject(new Error(__WEBPACK_IMPORTED_MODULE_4__translator__["a" /* default */].t('error.store.network')));
        }
      }, function () {
        endLoading(dispatch, 'dashboard setSongRanking');
        commit('error', __WEBPACK_IMPORTED_MODULE_4__translator__["a" /* default */].t('error.store.network'));
        reject(new Error(__WEBPACK_IMPORTED_MODULE_4__translator__["a" /* default */].t('error.store.network')));
      });
    });
  }
};

var getters = {
  error: function error(state) {
    return state.error;
  },

  metrics: function metrics(state) {
    return state.metrics;
  },
  reproductions: function reproductions(state) {
    return state.reproductions;
  },
  reproductionsRefresh: function reproductionsRefresh(state) {
    return state.reproductionsRefresh;
  },
  songRanking: function songRanking(state) {
    return state.songRanking;
  }

};

var dashboard = {
  namespaced: true,
  initialStates: initialStates,
  state: initialStates(),
  mutations: mutations,
  actions: actions,
  getters: getters
};

/* harmony default export */ __webpack_exports__["a"] = (dashboard);

/***/ }),
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (totalSeconds) {
  if (!totalSeconds) return '';

  var hours = Math.floor(totalSeconds / 3600);
  var minutes = Math.floor((totalSeconds - hours * 3600) / 60);
  var seconds = totalSeconds - hours * 3600 - minutes * 60;

  // round seconds
  seconds = Math.round(seconds * 100) / 100;

  var result = '';
  if (hours > 0) {
    result += (hours < 10 ? '0' + hours : hours) + ':';
  }
  result += minutes < 10 ? '0' + minutes : minutes;
  result += ':' + (seconds < 10 ? '0' + seconds : seconds);
  return result;
});

/***/ }),
/* 1211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (value, decimals) {
  var val = (value / 1).toFixed(decimals);
  return val.toString();
});

/***/ }),
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */,
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */,
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */,
/* 1301 */,
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */,
/* 1307 */,
/* 1308 */
/***/ (function(module, exports) {

module.exports = {"domain":"beathey.us.auth0.com","clientId":"jWl5vEKTpjMG3DVmEdElMvbmIHguQan9"}

/***/ }),
/* 1309 */,
/* 1310 */,
/* 1311 */,
/* 1312 */,
/* 1313 */,
/* 1314 */,
/* 1315 */,
/* 1316 */,
/* 1317 */,
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */,
/* 1323 */,
/* 1324 */,
/* 1325 */,
/* 1326 */,
/* 1327 */,
/* 1328 */,
/* 1329 */,
/* 1330 */,
/* 1331 */,
/* 1332 */,
/* 1333 */,
/* 1334 */,
/* 1335 */,
/* 1336 */,
/* 1337 */,
/* 1338 */,
/* 1339 */,
/* 1340 */,
/* 1341 */,
/* 1342 */,
/* 1343 */,
/* 1344 */,
/* 1345 */,
/* 1346 */,
/* 1347 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1348 */,
/* 1349 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
]),[731]);


// WEBPACK FOOTER //
// static/js/app.b6d67f094f851f7683bf.js